var cp = Object.defineProperty;
var hp = (p, e, n) =>
	e in p
		? cp(p, e, { enumerable: !0, configurable: !0, writable: !0, value: n })
		: (p[e] = n);
var tn = (p, e, n) => (hp(p, typeof e != "symbol" ? e + "" : e, n), n);
function hlKirbyUrl(p) {
	const e = p.startsWith("/") ? p : "/" + p;
	if (typeof document > "u") return e;
	const t = document.querySelector('meta[name="kirby-base-path"]')?.getAttribute("content"),
		n = ((t == null ? void 0 : t.trim().replace(/\/$/, "")) ?? "");
	return n !== "" ? n + e : e;
}
/*! js-cookie v3.0.5 | MIT */ function _u(p) {
	for (var e = 1; e < arguments.length; e++) {
		var n = arguments[e];
		for (var r in n) p[r] = n[r];
	}
	return p;
}
var fp = {
	read: function (p) {
		return (
			p[0] === '"' && (p = p.slice(1, -1)),
			p.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
		);
	},
	write: function (p) {
		return encodeURIComponent(p).replace(
			/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
			decodeURIComponent,
		);
	},
};
function ic(p, e) {
	function n(s, u, l) {
		if (!(typeof document > "u")) {
			((l = _u({}, e, l)),
				typeof l.expires == "number" &&
					(l.expires = new Date(Date.now() + l.expires * 864e5)),
				l.expires && (l.expires = l.expires.toUTCString()),
				(s = encodeURIComponent(s)
					.replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
					.replace(/[()]/g, escape)));
			var h = "";
			for (var f in l)
				l[f] &&
					((h += "; " + f), l[f] !== !0 && (h += "=" + l[f].split(";")[0]));
			return (document.cookie = s + "=" + p.write(u, s) + h);
		}
	}
	function r(s) {
		if (!(typeof document > "u" || (arguments.length && !s))) {
			for (
				var u = document.cookie ? document.cookie.split("; ") : [],
					l = {},
					h = 0;
				h < u.length;
				h++
			) {
				var f = u[h].split("="),
					v = f.slice(1).join("=");
				try {
					var w = decodeURIComponent(f[0]);
					if (((l[w] = p.read(v, w)), s === w)) break;
				} catch {}
			}
			return s ? l[s] : l;
		}
	}
	return Object.create(
		{
			set: n,
			get: r,
			remove: function (s, u) {
				n(s, "", _u({}, u, { expires: -1 }));
			},
			withAttributes: function (s) {
				return ic(this.converter, _u({}, this.attributes, s));
			},
			withConverter: function (s) {
				return ic(_u({}, this.converter, s), this.attributes);
			},
		},
		{
			attributes: { value: Object.freeze(e) },
			converter: { value: Object.freeze(p) },
		},
	);
}
var lo = ic(fp, { path: "/" });
class ua {
	constructor(e, n = {}) {
		const r = new CustomEvent(`cookieconsent:${e}`, { detail: n });
		window.dispatchEvent(r);
	}
}
class fh {
	constructor(e, n) {
		tn(this, "element", null);
		tn(this, "layer", document.querySelector(".js-cookieconsent-layer"));
		tn(this, "isOpen", !1);
		tn(this, "config", { name: null, modal: !0, position: "bottom" });
		if (
			((this.element = e),
			(this.config = { ...this.config, ...n }),
			!this.element)
		) {
			console.warn(`CookieconsentDialog "${this.config.name}" does not exist!`);
			return;
		}
		(this.init(), this.bindEvents());
	}
	init() {
		this.element.setAttribute("data-position", this.config.position);
	}
	bindEvents() {
		this.config.closeByKey &&
			document.addEventListener("keydown", (e) => {
				e.key === this.config.closeByKey && this.close();
			});
	}
	open() {
		this.element &&
			(this.config.modal ? this.element.showModal() : this.element.show(),
			(this.isOpen = !0),
			new ua("openDialog", { element: this.element }));
	}
	close() {
		this.isOpen &&
			(this.element.close(),
			(this.isOpen = !1),
			document.body.style.removeProperty("overflow"),
			new ua("closeDialog", { element: this.element }));
	}
}
class nc {
	constructor(e, n) {
		tn(this, "element", null);
		tn(this, "config", {
			allowed: [],
			enabled: !0,
			selectors: {
				banner: ".js-cookieconsent-embedbanner",
				provider: ".js-cookieconsent-embedprovider",
			},
		});
		((this.element = e), (this.config = { ...this.config, ...n }));
	}
	enable() {
		const e = this.element;
		if (e.hasAttribute("data-src")) {
			const n = e.getAttribute("data-src");
			(e.setAttribute("src", n),
				e.removeAttribute("data-src"),
				e.style.removeProperty("display"));
		}
		(this.removeBanner(e), new ua("enableEmbed", { embed: e }));
	}
	disable() {
		if (this.config.enabled === !1) return;
		const e = this.element;
		if (e.hasAttribute("src")) {
			const n = e.getAttribute("src");
			(e.setAttribute("data-src", n), e.removeAttribute("src"));
		}
		(this.setBanner(this.element), new ua("disableEmbed", { embed: e }));
	}
	setBanner(e) {
		var f;
		if (
			(f = e.previousElementSibling) != null &&
			f.id.startsWith("cookieconsent-embed-")
		)
			return;
		const n = this.getId(),
			r = e.cloneNode(!0);
		r.setAttribute("aria-hidden", !0);
		const s = document.querySelector("template" + this.config.selectors.banner),
			u = s == null ? void 0 : s.content.cloneNode(!0),
			l = u == null ? void 0 : u.firstElementChild;
		u && l && ((l.id = n), l.appendChild(r), e.before(u));
		const h = l.querySelector(this.config.selectors.provider);
		((h.textContent = e.getAttribute("data-src")),
			e.setAttribute("data-cookieconsent-embedbanner", n),
			(e.style.display = "none"));
	}
	removeBanner(e) {
		const n = document.getElementById(
			e.getAttribute("data-cookieconsent-embedbanner"),
		);
		(n == null || n.remove(),
			e.removeAttribute("data-cookieconsent-embedbanner"),
			e.removeAttribute("aria-hidden"));
	}
	getId() {
		return (
			"cookieconsent-embed-" +
			Date.now().toString(36) +
			Math.random().toString(36).substring(2)
		);
	}
}
class gf {
	constructor(e = {}) {
		tn(this, "config", { type: null, id: null, url: null });
		if (((this.config = { ...this.config, ...e }), !this.config.type)) {
			console.warn("Tagmanager Type does not exist!");
			return;
		}
		if (!this.config.id) {
			console.warn("Tagmanager ID does not exist!");
			return;
		}
		if (this.config.type === "matomo" && !this.config.url) {
			console.warn("Matomo URL does not exist!");
			return;
		}
	}
	enable() {
		(this.config.type === "google" && this.google(this.config.id),
			this.config.type === "matomo" &&
				this.matomo(this.config.id, this.config.url));
	}
	google(e) {
		(function (n, r, s, u, l) {
			((n[u] = n[u] || []),
				n[u].push({ "gtm.start": new Date().getTime(), event: "gtm.js" }));
			var h = r.getElementsByTagName(s)[0],
				f = r.createElement(s),
				v = u != "dataLayer" ? "&l=" + u : "";
			((f.async = !0),
				(f.src = "https://www.googletagmanager.com/gtm.js?id=" + l + v),
				h.parentNode.insertBefore(f, h));
		})(window, document, "script", "dataLayer", e);
	}
	matomo(e, n) {
		var r = (window._mtm = window._mtm || []);
		(r.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" }),
			(function () {
				var s = document,
					u = s.createElement("script"),
					l = s.getElementsByTagName("script")[0];
				((u.async = !0),
					(u.src = n + "/js/container_" + e + ".js"),
					l.parentNode.insertBefore(u, l));
			})());
	}
}
tn(gf, "instance", null);
class dp {
	async submit(e, n) {
		await fetch(hlKirbyUrl("/app/cookieconsent/submit"), {
			method: "POST",
			body: JSON.stringify({ type: e, preferences: n }),
		});
	}
}
class pp {
	constructor(e, n) {
		tn(this, "element", document.querySelector(".js-cookieconsent"));
		tn(this, "dialogs", { banner: null, preferences: null });
		tn(this, "elements", {
			bannerDialog: null,
			preferencesDialog: null,
			acceptButtons: null,
			acceptAllButtons: null,
			denyButtons: null,
			editButtons: null,
			embeds: null,
		});
		tn(this, "status");
		tn(this, "preferences");
		tn(this, "config", {
			cookiedomain: window.location.hostname.replace(/^www\./i, ""),
			selectors: {
				bannerDialog: ".js-cookieconsent-banner",
				preferencesDialog: ".js-cookieconsent-preferences",
				embedBanner: ".js-cookieconsent-embedbanner",
				embedBannerProvider: ".js-cookieconsent-embedprovider",
				acceptButton: ".js-cookieconsent-accept",
				acceptAllButton: ".js-cookieconsent-accept-all",
				denyButton: ".js-cookieconsent-deny",
				editButton: ".js-cookieconsent-edit",
				embed: "iframe, script[data-src]",
			},
			tagmanager: { type: null, id: null, url: null },
			bannerDialog: { modal: !1, position: "bottom" },
			preferencesDialog: { modal: !0, position: "center" },
			embedBanner: { allowed: [], enabled: !0 },
		});
		if (((this.element = e ?? this.element), !this.element)) {
			console.warn("Cookieconsent does not exist!");
			return;
		}
		((this.config = { ...this.config, ...n }), this.init(), this.bindEvents());
	}
	init() {
		((this.status = lo.get("lll-cookie-status")),
			this.initElements(),
			this.initDialogs(),
			this.initEmbeds(),
			this.updatePreferences(),
			this.initTagManager(),
			typeof this.status > "u" &&
				!this.isHidden() &&
				this.dialogs.banner.open());
	}
	initElements() {
		const e = this.element,
			n = this.elements,
			r = this.config.selectors;
		((n.bannerDialog = e.querySelector(r.bannerDialog)),
			(n.preferencesDialog = e.querySelector(r.preferencesDialog)),
			(n.acceptButtons = e.querySelectorAll(r.acceptButton)),
			(n.acceptAllButtons = e.querySelectorAll(r.acceptAllButton)),
			(n.denyButtons = e.querySelectorAll(r.denyButton)),
			(n.editButtons = document.querySelectorAll(r.editButton)),
			(n.embeds = document.querySelectorAll(r.embed)));
	}
	initDialogs() {
		((this.dialogs.banner = new fh(
			this.elements.bannerDialog,
			Object.assign(this.config.bannerDialog, { name: "bannerDialog" }),
		)),
			(this.dialogs.preferences = new fh(
				this.elements.preferencesDialog,
				this.config.preferencesDialog,
				Object.assign(this.config.preferencesDialog, {
					name: "preferencesDialog",
				}),
			)));
	}
	initTagManager() {
		if (
			typeof this.status > "u" ||
			typeof this.preferences > "u" ||
			this.preferences.length === 0 ||
			this.status !== "enabled" ||
			(this.preferences.length === 1 && this.preferences.includes("embeds"))
		)
			return;
		new gf(this.config.tagmanager).enable();
	}
	initEmbeds() {
		const e = lo.get("lll-cookie-preferences"),
			n = {
				...this.config.embedBanner,
				selectors: {
					banner: this.config.selectors.embedBanner,
					provider: this.config.selectors.embedBannerProvider,
				},
			},
			r = this.elements.embeds;
		if (n.enabled === !1 || (e != null && e.includes("embeds"))) {
			r.forEach((s) => {
				new nc(s, n).enable();
			});
			return;
		}
		r.forEach((s) => {
			new nc(s, n).disable();
		});
	}
	bindEvents() {
		(this.elements.acceptButtons.forEach((e) => {
			e.addEventListener("click", this.accept.bind(this, !1));
		}),
			this.elements.acceptAllButtons.forEach((e) => {
				e.addEventListener("click", this.accept.bind(this, !0));
			}),
			this.elements.denyButtons.forEach((e) => {
				e.addEventListener("click", this.deny.bind(this));
			}),
			this.elements.editButtons.forEach((e) => {
				e.addEventListener("click", this.edit.bind(this));
			}),
			document.body.addEventListener("click", (e) => {
				e.target.matches(this.config.selectors.editButton) && this.edit();
			}));
	}
	accept(e = !1) {
		const n = this.getPreferences();
		if (!e && n.checked.length === 0) {
			this.deny();
			return;
		}
		this.setStatus("enabled");
		const r = e ? n.available : n.checked;
		(this.setPreferences(r), this.submit("accept", r));
	}
	deny() {
		const e = this.getPreferences(),
			n = Object.keys(lo.get());
		for (let r = 0; r < n.length; r++)
			lo.remove(n[r], { path: "/", domain: this.config.cookiedomain });
		(this.setStatus("disabled"), this.submit("deny", e.checked));
	}
	edit() {
		(this.dialogs.banner.close(),
			this.dialogs.preferences.open(),
			new ua("edit"));
	}
	submit(e, n) {
		(this.dialogs.banner.close(),
			this.dialogs.preferences.close(),
			this.updatePreferences(),
			this.initTagManager(),
			this.initEmbeds(),
			new ua("submit", { type: e, preferences: n }),
			this.config.tracking && new dp().submit(e, n));
	}
	setStatus(e) {
		((this.status = e), lo.set("lll-cookie-status", e, { expires: 365 }));
	}
	setPreferences(e) {
		((this.preferences = e),
			lo.set("lll-cookie-preferences", JSON.stringify(e), { expires: 365 }));
	}
	getPreferences() {
		const e = [],
			n = [];
		return (
			this.element
				.querySelectorAll('input[name="cookieconsent[]"]:not([disabled])')
				.forEach((r) => {
					e.push(r.value);
				}),
			this.element
				.querySelectorAll(
					'input[name="cookieconsent[]"]:not([disabled]):checked',
				)
				.forEach((r) => {
					n.push(r.value);
				}),
			{ available: e, checked: n }
		);
	}
	updatePreferences() {
		const e = lo.get("lll-cookie-preferences");
		((this.preferences = e ? JSON.parse(e) : void 0),
			!(typeof this.preferences > "u") &&
				this.preferences.forEach((n) => {
					this.element
						.querySelectorAll(
							'input[name="cookieconsent[]"][value="' + n + '"]',
						)
						.forEach((r) => {
							r.checked = !0;
						});
				}));
	}
	isHidden() {
		const e = window.location.search,
			n = new URLSearchParams(e);
		return n.get("cookieconsent") ? n.get("cookieconsent") === "hidden" : !1;
	}
}
window.cookieconsent = pp;
var Rs =
	typeof globalThis < "u"
		? globalThis
		: typeof window < "u"
			? window
			: typeof global < "u"
				? global
				: typeof self < "u"
					? self
					: {};
function tl(p) {
	return p && p.__esModule && Object.prototype.hasOwnProperty.call(p, "default")
		? p.default
		: p;
}
var _f = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function (p) {
	(function (e, n) {
		p.exports = e.document
			? n(e, !0)
			: function (r) {
					if (!r.document)
						throw new Error("jQuery requires a window with a document");
					return n(r);
				};
	})(typeof window < "u" ? window : Rs, function (e, n) {
		var r = [],
			s = Object.getPrototypeOf,
			u = r.slice,
			l = r.flat
				? function (o) {
						return r.flat.call(o);
					}
				: function (o) {
						return r.concat.apply([], o);
					},
			h = r.push,
			f = r.indexOf,
			v = {},
			w = v.toString,
			A = v.hasOwnProperty,
			D = A.toString,
			C = D.call(Object),
			O = {},
			P = function (c) {
				return (
					typeof c == "function" &&
					typeof c.nodeType != "number" &&
					typeof c.item != "function"
				);
			},
			F = function (c) {
				return c != null && c === c.window;
			},
			G = e.document,
			B = { type: !0, src: !0, nonce: !0, noModule: !0 };
		function j(o, c, _) {
			_ = _ || G;
			var y,
				S,
				T = _.createElement("script");
			if (((T.text = o), c))
				for (y in B)
					((S = c[y] || (c.getAttribute && c.getAttribute(y))),
						S && T.setAttribute(y, S));
			_.head.appendChild(T).parentNode.removeChild(T);
		}
		function V(o) {
			return o == null
				? o + ""
				: typeof o == "object" || typeof o == "function"
					? v[w.call(o)] || "object"
					: typeof o;
		}
		var Q = "3.7.1",
			it = /HTML$/i,
			g = function (o, c) {
				return new g.fn.init(o, c);
			};
		((g.fn = g.prototype =
			{
				jquery: Q,
				constructor: g,
				length: 0,
				toArray: function () {
					return u.call(this);
				},
				get: function (o) {
					return o == null
						? u.call(this)
						: o < 0
							? this[o + this.length]
							: this[o];
				},
				pushStack: function (o) {
					var c = g.merge(this.constructor(), o);
					return ((c.prevObject = this), c);
				},
				each: function (o) {
					return g.each(this, o);
				},
				map: function (o) {
					return this.pushStack(
						g.map(this, function (c, _) {
							return o.call(c, _, c);
						}),
					);
				},
				slice: function () {
					return this.pushStack(u.apply(this, arguments));
				},
				first: function () {
					return this.eq(0);
				},
				last: function () {
					return this.eq(-1);
				},
				even: function () {
					return this.pushStack(
						g.grep(this, function (o, c) {
							return (c + 1) % 2;
						}),
					);
				},
				odd: function () {
					return this.pushStack(
						g.grep(this, function (o, c) {
							return c % 2;
						}),
					);
				},
				eq: function (o) {
					var c = this.length,
						_ = +o + (o < 0 ? c : 0);
					return this.pushStack(_ >= 0 && _ < c ? [this[_]] : []);
				},
				end: function () {
					return this.prevObject || this.constructor();
				},
				push: h,
				sort: r.sort,
				splice: r.splice,
			}),
			(g.extend = g.fn.extend =
				function () {
					var o,
						c,
						_,
						y,
						S,
						T,
						k = arguments[0] || {},
						H = 1,
						R = arguments.length,
						$ = !1;
					for (
						typeof k == "boolean" && (($ = k), (k = arguments[H] || {}), H++),
							typeof k != "object" && !P(k) && (k = {}),
							H === R && ((k = this), H--);
						H < R;
						H++
					)
						if ((o = arguments[H]) != null)
							for (c in o)
								((y = o[c]),
									!(c === "__proto__" || k === y) &&
										($ && y && (g.isPlainObject(y) || (S = Array.isArray(y)))
											? ((_ = k[c]),
												S && !Array.isArray(_)
													? (T = [])
													: !S && !g.isPlainObject(_)
														? (T = {})
														: (T = _),
												(S = !1),
												(k[c] = g.extend($, T, y)))
											: y !== void 0 && (k[c] = y)));
					return k;
				}),
			g.extend({
				expando: "jQuery" + (Q + Math.random()).replace(/\D/g, ""),
				isReady: !0,
				error: function (o) {
					throw new Error(o);
				},
				noop: function () {},
				isPlainObject: function (o) {
					var c, _;
					return !o || w.call(o) !== "[object Object]"
						? !1
						: ((c = s(o)),
							c
								? ((_ = A.call(c, "constructor") && c.constructor),
									typeof _ == "function" && D.call(_) === C)
								: !0);
				},
				isEmptyObject: function (o) {
					var c;
					for (c in o) return !1;
					return !0;
				},
				globalEval: function (o, c, _) {
					j(o, { nonce: c && c.nonce }, _);
				},
				each: function (o, c) {
					var _,
						y = 0;
					if (ct(o))
						for (_ = o.length; y < _ && c.call(o[y], y, o[y]) !== !1; y++);
					else for (y in o) if (c.call(o[y], y, o[y]) === !1) break;
					return o;
				},
				text: function (o) {
					var c,
						_ = "",
						y = 0,
						S = o.nodeType;
					if (!S) for (; (c = o[y++]); ) _ += g.text(c);
					return S === 1 || S === 11
						? o.textContent
						: S === 9
							? o.documentElement.textContent
							: S === 3 || S === 4
								? o.nodeValue
								: _;
				},
				makeArray: function (o, c) {
					var _ = c || [];
					return (
						o != null &&
							(ct(Object(o))
								? g.merge(_, typeof o == "string" ? [o] : o)
								: h.call(_, o)),
						_
					);
				},
				inArray: function (o, c, _) {
					return c == null ? -1 : f.call(c, o, _);
				},
				isXMLDoc: function (o) {
					var c = o && o.namespaceURI,
						_ = o && (o.ownerDocument || o).documentElement;
					return !it.test(c || (_ && _.nodeName) || "HTML");
				},
				merge: function (o, c) {
					for (var _ = +c.length, y = 0, S = o.length; y < _; y++)
						o[S++] = c[y];
					return ((o.length = S), o);
				},
				grep: function (o, c, _) {
					for (var y, S = [], T = 0, k = o.length, H = !_; T < k; T++)
						((y = !c(o[T], T)), y !== H && S.push(o[T]));
					return S;
				},
				map: function (o, c, _) {
					var y,
						S,
						T = 0,
						k = [];
					if (ct(o))
						for (y = o.length; T < y; T++)
							((S = c(o[T], T, _)), S != null && k.push(S));
					else for (T in o) ((S = c(o[T], T, _)), S != null && k.push(S));
					return l(k);
				},
				guid: 1,
				support: O,
			}),
			typeof Symbol == "function" &&
				(g.fn[Symbol.iterator] = r[Symbol.iterator]),
			g.each(
				"Boolean Number String Function Array Date RegExp Object Error Symbol".split(
					" ",
				),
				function (o, c) {
					v["[object " + c + "]"] = c.toLowerCase();
				},
			));
		function ct(o) {
			var c = !!o && "length" in o && o.length,
				_ = V(o);
			return P(o) || F(o)
				? !1
				: _ === "array" ||
						c === 0 ||
						(typeof c == "number" && c > 0 && c - 1 in o);
		}
		function ot(o, c) {
			return o.nodeName && o.nodeName.toLowerCase() === c.toLowerCase();
		}
		var ft = r.pop,
			Dt = r.sort,
			pt = r.splice,
			Et = "[\\x20\\t\\r\\n\\f]",
			K = new RegExp("^" + Et + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Et + "+$", "g");
		g.contains = function (o, c) {
			var _ = c && c.parentNode;
			return (
				o === _ ||
				!!(
					_ &&
					_.nodeType === 1 &&
					(o.contains
						? o.contains(_)
						: o.compareDocumentPosition && o.compareDocumentPosition(_) & 16)
				)
			);
		};
		var Nt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
		function St(o, c) {
			return c
				? o === "\0"
					? "�"
					: o.slice(0, -1) +
						"\\" +
						o.charCodeAt(o.length - 1).toString(16) +
						" "
				: "\\" + o;
		}
		g.escapeSelector = function (o) {
			return (o + "").replace(Nt, St);
		};
		var Ct = G,
			_t = h;
		(function () {
			var o,
				c,
				_,
				y,
				S,
				T = _t,
				k,
				H,
				R,
				$,
				rt,
				ut = g.expando,
				tt = 0,
				dt = 0,
				Xt = Ds(),
				ye = Ds(),
				le = Ds(),
				zi = Ds(),
				li = function (z, Z) {
					return (z === Z && (S = !0), 0);
				},
				Jn =
					"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
				On =
					"(?:\\\\[\\da-fA-F]{1,6}" +
					Et +
					"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
				me =
					"\\[" +
					Et +
					"*(" +
					On +
					")(?:" +
					Et +
					"*([*^$|!~]?=)" +
					Et +
					`*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` +
					On +
					"))|)" +
					Et +
					"*\\]",
				Qn =
					":(" +
					On +
					`)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` +
					me +
					")*)|.*)\\)|)",
				fe = new RegExp(Et + "+", "g"),
				ti = new RegExp("^" + Et + "*," + Et + "*"),
				pr = new RegExp("^" + Et + "*([>+~]|" + Et + ")" + Et + "*"),
				Si = new RegExp(Et + "|>"),
				si = new RegExp(Qn),
				tr = new RegExp("^" + On + "$"),
				er = {
					ID: new RegExp("^#(" + On + ")"),
					CLASS: new RegExp("^\\.(" + On + ")"),
					TAG: new RegExp("^(" + On + "|[*])"),
					ATTR: new RegExp("^" + me),
					PSEUDO: new RegExp("^" + Qn),
					CHILD: new RegExp(
						"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
							Et +
							"*(even|odd|(([+-]|)(\\d*)n|)" +
							Et +
							"*(?:([+-]|)" +
							Et +
							"*(\\d+)|))" +
							Et +
							"*\\)|)",
						"i",
					),
					bool: new RegExp("^(?:" + Jn + ")$", "i"),
					needsContext: new RegExp(
						"^" +
							Et +
							"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
							Et +
							"*((?:-\\d)?\\d*)" +
							Et +
							"*\\)|)(?=[^-]|$)",
						"i",
					),
				},
				ir = /^(?:input|select|textarea|button)$/i,
				un = /^h\d$/i,
				ci = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
				Xr = /[+~]/,
				Dn = new RegExp(
					"\\\\[\\da-fA-F]{1,6}" + Et + "?|\\\\([^\\r\\n\\f])",
					"g",
				),
				In = function (z, Z) {
					var X = "0x" + z.slice(1) - 65536;
					return (
						Z ||
						(X < 0
							? String.fromCharCode(X + 65536)
							: String.fromCharCode((X >> 10) | 55296, (X & 1023) | 56320))
					);
				},
				_n = function () {
					Vi();
				},
				Zr = Qi(
					function (z) {
						return z.disabled === !0 && ot(z, "fieldset");
					},
					{ dir: "parentNode", next: "legend" },
				);
			function Yr() {
				try {
					return k.activeElement;
				} catch {}
			}
			try {
				(T.apply((r = u.call(Ct.childNodes)), Ct.childNodes),
					r[Ct.childNodes.length].nodeType);
			} catch {
				T = {
					apply: function (Z, X) {
						_t.apply(Z, u.call(X));
					},
					call: function (Z) {
						_t.apply(Z, u.call(arguments, 1));
					},
				};
			}
			function ae(z, Z, X, et) {
				var at,
					mt,
					wt,
					It,
					kt,
					pe,
					Gt,
					$t = Z && Z.ownerDocument,
					ge = Z ? Z.nodeType : 9;
				if (
					((X = X || []),
					typeof z != "string" || !z || (ge !== 1 && ge !== 9 && ge !== 11))
				)
					return X;
				if (!et && (Vi(Z), (Z = Z || k), R)) {
					if (ge !== 11 && (kt = ci.exec(z)))
						if ((at = kt[1])) {
							if (ge === 9)
								if ((wt = Z.getElementById(at))) {
									if (wt.id === at) return (T.call(X, wt), X);
								} else return X;
							else if (
								$t &&
								(wt = $t.getElementById(at)) &&
								ae.contains(Z, wt) &&
								wt.id === at
							)
								return (T.call(X, wt), X);
						} else {
							if (kt[2]) return (T.apply(X, Z.getElementsByTagName(z)), X);
							if ((at = kt[3]) && Z.getElementsByClassName)
								return (T.apply(X, Z.getElementsByClassName(at)), X);
						}
					if (!zi[z + " "] && (!$ || !$.test(z))) {
						if (((Gt = z), ($t = Z), ge === 1 && (Si.test(z) || pr.test(z)))) {
							for (
								$t = (Xr.test(z) && be(Z.parentNode)) || Z,
									($t != Z || !O.scope) &&
										((It = Z.getAttribute("id"))
											? (It = g.escapeSelector(It))
											: Z.setAttribute("id", (It = ut))),
									pe = zn(z),
									mt = pe.length;
								mt--;
							)
								pe[mt] = (It ? "#" + It : ":scope") + " " + Kr(pe[mt]);
							Gt = pe.join(",");
						}
						try {
							return (T.apply(X, $t.querySelectorAll(Gt)), X);
						} catch {
							zi(z, !0);
						} finally {
							It === ut && Z.removeAttribute("id");
						}
					}
				}
				return ln(z.replace(K, "$1"), Z, X, et);
			}
			function Ds() {
				var z = [];
				function Z(X, et) {
					return (
						z.push(X + " ") > c.cacheLength && delete Z[z.shift()],
						(Z[X + " "] = et)
					);
				}
				return Z;
			}
			function qi(z) {
				return ((z[ut] = !0), z);
			}
			function mr(z) {
				var Z = k.createElement("fieldset");
				try {
					return !!z(Z);
				} catch {
					return !1;
				} finally {
					(Z.parentNode && Z.parentNode.removeChild(Z), (Z = null));
				}
			}
			function Lr(z) {
				return function (Z) {
					return ot(Z, "input") && Z.type === z;
				};
			}
			function Bn(z) {
				return function (Z) {
					return (ot(Z, "input") || ot(Z, "button")) && Z.type === z;
				};
			}
			function ys(z) {
				return function (Z) {
					return "form" in Z
						? Z.parentNode && Z.disabled === !1
							? "label" in Z
								? "label" in Z.parentNode
									? Z.parentNode.disabled === z
									: Z.disabled === z
								: Z.isDisabled === z || (Z.isDisabled !== !z && Zr(Z) === z)
							: Z.disabled === z
						: "label" in Z
							? Z.disabled === z
							: !1;
				};
			}
			function gr(z) {
				return qi(function (Z) {
					return (
						(Z = +Z),
						qi(function (X, et) {
							for (var at, mt = z([], X.length, Z), wt = mt.length; wt--; )
								X[(at = mt[wt])] && (X[at] = !(et[at] = X[at]));
						})
					);
				});
			}
			function be(z) {
				return z && typeof z.getElementsByTagName < "u" && z;
			}
			function Vi(z) {
				var Z,
					X = z ? z.ownerDocument || z : Ct;
				return (
					X == k ||
						X.nodeType !== 9 ||
						!X.documentElement ||
						((k = X),
						(H = k.documentElement),
						(R = !g.isXMLDoc(k)),
						(rt = H.matches || H.webkitMatchesSelector || H.msMatchesSelector),
						H.msMatchesSelector &&
							Ct != k &&
							(Z = k.defaultView) &&
							Z.top !== Z &&
							Z.addEventListener("unload", _n),
						(O.getById = mr(function (et) {
							return (
								(H.appendChild(et).id = g.expando),
								!k.getElementsByName || !k.getElementsByName(g.expando).length
							);
						})),
						(O.disconnectedMatch = mr(function (et) {
							return rt.call(et, "*");
						})),
						(O.scope = mr(function () {
							return k.querySelectorAll(":scope");
						})),
						(O.cssHas = mr(function () {
							try {
								return (k.querySelector(":has(*,:jqfake)"), !1);
							} catch {
								return !0;
							}
						})),
						O.getById
							? ((c.filter.ID = function (et) {
									var at = et.replace(Dn, In);
									return function (mt) {
										return mt.getAttribute("id") === at;
									};
								}),
								(c.find.ID = function (et, at) {
									if (typeof at.getElementById < "u" && R) {
										var mt = at.getElementById(et);
										return mt ? [mt] : [];
									}
								}))
							: ((c.filter.ID = function (et) {
									var at = et.replace(Dn, In);
									return function (mt) {
										var wt =
											typeof mt.getAttributeNode < "u" &&
											mt.getAttributeNode("id");
										return wt && wt.value === at;
									};
								}),
								(c.find.ID = function (et, at) {
									if (typeof at.getElementById < "u" && R) {
										var mt,
											wt,
											It,
											kt = at.getElementById(et);
										if (kt) {
											if (
												((mt = kt.getAttributeNode("id")),
												mt && mt.value === et)
											)
												return [kt];
											for (
												It = at.getElementsByName(et), wt = 0;
												(kt = It[wt++]);
											)
												if (
													((mt = kt.getAttributeNode("id")),
													mt && mt.value === et)
												)
													return [kt];
										}
										return [];
									}
								})),
						(c.find.TAG = function (et, at) {
							return typeof at.getElementsByTagName < "u"
								? at.getElementsByTagName(et)
								: at.querySelectorAll(et);
						}),
						(c.find.CLASS = function (et, at) {
							if (typeof at.getElementsByClassName < "u" && R)
								return at.getElementsByClassName(et);
						}),
						($ = []),
						mr(function (et) {
							var at;
							((H.appendChild(et).innerHTML =
								"<a id='" +
								ut +
								"' href='' disabled='disabled'></a><select id='" +
								ut +
								"-\r\\' disabled='disabled'><option selected=''></option></select>"),
								et.querySelectorAll("[selected]").length ||
									$.push("\\[" + Et + "*(?:value|" + Jn + ")"),
								et.querySelectorAll("[id~=" + ut + "-]").length || $.push("~="),
								et.querySelectorAll("a#" + ut + "+*").length ||
									$.push(".#.+[+~]"),
								et.querySelectorAll(":checked").length || $.push(":checked"),
								(at = k.createElement("input")),
								at.setAttribute("type", "hidden"),
								et.appendChild(at).setAttribute("name", "D"),
								(H.appendChild(et).disabled = !0),
								et.querySelectorAll(":disabled").length !== 2 &&
									$.push(":enabled", ":disabled"),
								(at = k.createElement("input")),
								at.setAttribute("name", ""),
								et.appendChild(at),
								et.querySelectorAll("[name='']").length ||
									$.push("\\[" + Et + "*name" + Et + "*=" + Et + `*(?:''|"")`));
						}),
						O.cssHas || $.push(":has"),
						($ = $.length && new RegExp($.join("|"))),
						(li = function (et, at) {
							if (et === at) return ((S = !0), 0);
							var mt =
								!et.compareDocumentPosition - !at.compareDocumentPosition;
							return (
								mt ||
								((mt =
									(et.ownerDocument || et) == (at.ownerDocument || at)
										? et.compareDocumentPosition(at)
										: 1),
								mt & 1 ||
								(!O.sortDetached && at.compareDocumentPosition(et) === mt)
									? et === k || (et.ownerDocument == Ct && ae.contains(Ct, et))
										? -1
										: at === k ||
											  (at.ownerDocument == Ct && ae.contains(Ct, at))
											? 1
											: y
												? f.call(y, et) - f.call(y, at)
												: 0
									: mt & 4
										? -1
										: 1)
							);
						})),
					k
				);
			}
			((ae.matches = function (z, Z) {
				return ae(z, null, null, Z);
			}),
				(ae.matchesSelector = function (z, Z) {
					if ((Vi(z), R && !zi[Z + " "] && (!$ || !$.test(Z))))
						try {
							var X = rt.call(z, Z);
							if (
								X ||
								O.disconnectedMatch ||
								(z.document && z.document.nodeType !== 11)
							)
								return X;
						} catch {
							zi(Z, !0);
						}
					return ae(Z, k, null, [z]).length > 0;
				}),
				(ae.contains = function (z, Z) {
					return ((z.ownerDocument || z) != k && Vi(z), g.contains(z, Z));
				}),
				(ae.attr = function (z, Z) {
					(z.ownerDocument || z) != k && Vi(z);
					var X = c.attrHandle[Z.toLowerCase()],
						et =
							X && A.call(c.attrHandle, Z.toLowerCase()) ? X(z, Z, !R) : void 0;
					return et !== void 0 ? et : z.getAttribute(Z);
				}),
				(ae.error = function (z) {
					throw new Error("Syntax error, unrecognized expression: " + z);
				}),
				(g.uniqueSort = function (z) {
					var Z,
						X = [],
						et = 0,
						at = 0;
					if (
						((S = !O.sortStable),
						(y = !O.sortStable && u.call(z, 0)),
						Dt.call(z, li),
						S)
					) {
						for (; (Z = z[at++]); ) Z === z[at] && (et = X.push(at));
						for (; et--; ) pt.call(z, X[et], 1);
					}
					return ((y = null), z);
				}),
				(g.fn.uniqueSort = function () {
					return this.pushStack(g.uniqueSort(u.apply(this)));
				}),
				(c = g.expr =
					{
						cacheLength: 50,
						createPseudo: qi,
						match: er,
						attrHandle: {},
						find: {},
						relative: {
							">": { dir: "parentNode", first: !0 },
							" ": { dir: "parentNode" },
							"+": { dir: "previousSibling", first: !0 },
							"~": { dir: "previousSibling" },
						},
						preFilter: {
							ATTR: function (z) {
								return (
									(z[1] = z[1].replace(Dn, In)),
									(z[3] = (z[3] || z[4] || z[5] || "").replace(Dn, In)),
									z[2] === "~=" && (z[3] = " " + z[3] + " "),
									z.slice(0, 4)
								);
							},
							CHILD: function (z) {
								return (
									(z[1] = z[1].toLowerCase()),
									z[1].slice(0, 3) === "nth"
										? (z[3] || ae.error(z[0]),
											(z[4] = +(z[4]
												? z[5] + (z[6] || 1)
												: 2 * (z[3] === "even" || z[3] === "odd"))),
											(z[5] = +(z[7] + z[8] || z[3] === "odd")))
										: z[3] && ae.error(z[0]),
									z
								);
							},
							PSEUDO: function (z) {
								var Z,
									X = !z[6] && z[2];
								return er.CHILD.test(z[0])
									? null
									: (z[3]
											? (z[2] = z[4] || z[5] || "")
											: X &&
												si.test(X) &&
												(Z = zn(X, !0)) &&
												(Z = X.indexOf(")", X.length - Z) - X.length) &&
												((z[0] = z[0].slice(0, Z)), (z[2] = X.slice(0, Z))),
										z.slice(0, 3));
							},
						},
						filter: {
							TAG: function (z) {
								var Z = z.replace(Dn, In).toLowerCase();
								return z === "*"
									? function () {
											return !0;
										}
									: function (X) {
											return ot(X, Z);
										};
							},
							CLASS: function (z) {
								var Z = Xt[z + " "];
								return (
									Z ||
									((Z = new RegExp("(^|" + Et + ")" + z + "(" + Et + "|$)")) &&
										Xt(z, function (X) {
											return Z.test(
												(typeof X.className == "string" && X.className) ||
													(typeof X.getAttribute < "u" &&
														X.getAttribute("class")) ||
													"",
											);
										}))
								);
							},
							ATTR: function (z, Z, X) {
								return function (et) {
									var at = ae.attr(et, z);
									return at == null
										? Z === "!="
										: Z
											? ((at += ""),
												Z === "="
													? at === X
													: Z === "!="
														? at !== X
														: Z === "^="
															? X && at.indexOf(X) === 0
															: Z === "*="
																? X && at.indexOf(X) > -1
																: Z === "$="
																	? X && at.slice(-X.length) === X
																	: Z === "~="
																		? (" " + at.replace(fe, " ") + " ").indexOf(
																				X,
																			) > -1
																		: Z === "|="
																			? at === X ||
																				at.slice(0, X.length + 1) === X + "-"
																			: !1)
											: !0;
								};
							},
							CHILD: function (z, Z, X, et, at) {
								var mt = z.slice(0, 3) !== "nth",
									wt = z.slice(-4) !== "last",
									It = Z === "of-type";
								return et === 1 && at === 0
									? function (kt) {
											return !!kt.parentNode;
										}
									: function (kt, pe, Gt) {
											var $t,
												ge,
												Ot,
												Ee,
												Gi,
												Qe = mt !== wt ? "nextSibling" : "previousSibling",
												cn = kt.parentNode,
												Rn = It && kt.nodeName.toLowerCase(),
												Qr = !Gt && !It,
												oi = !1;
											if (cn) {
												if (mt) {
													for (; Qe; ) {
														for (Ot = kt; (Ot = Ot[Qe]); )
															if (It ? ot(Ot, Rn) : Ot.nodeType === 1)
																return !1;
														Gi = Qe = z === "only" && !Gi && "nextSibling";
													}
													return !0;
												}
												if (
													((Gi = [wt ? cn.firstChild : cn.lastChild]), wt && Qr)
												) {
													for (
														ge = cn[ut] || (cn[ut] = {}),
															$t = ge[z] || [],
															Ee = $t[0] === tt && $t[1],
															oi = Ee && $t[2],
															Ot = Ee && cn.childNodes[Ee];
														(Ot =
															(++Ee && Ot && Ot[Qe]) ||
															(oi = Ee = 0) ||
															Gi.pop());
													)
														if (Ot.nodeType === 1 && ++oi && Ot === kt) {
															ge[z] = [tt, Ee, oi];
															break;
														}
												} else if (
													(Qr &&
														((ge = kt[ut] || (kt[ut] = {})),
														($t = ge[z] || []),
														(Ee = $t[0] === tt && $t[1]),
														(oi = Ee)),
													oi === !1)
												)
													for (
														;
														(Ot =
															(++Ee && Ot && Ot[Qe]) ||
															(oi = Ee = 0) ||
															Gi.pop()) &&
														!(
															(It ? ot(Ot, Rn) : Ot.nodeType === 1) &&
															++oi &&
															(Qr &&
																((ge = Ot[ut] || (Ot[ut] = {})),
																(ge[z] = [tt, oi])),
															Ot === kt)
														);
													);
												return (
													(oi -= at),
													oi === et || (oi % et === 0 && oi / et >= 0)
												);
											}
										};
							},
							PSEUDO: function (z, Z) {
								var X,
									et =
										c.pseudos[z] ||
										c.setFilters[z.toLowerCase()] ||
										ae.error("unsupported pseudo: " + z);
								return et[ut]
									? et(Z)
									: et.length > 1
										? ((X = [z, z, "", Z]),
											c.setFilters.hasOwnProperty(z.toLowerCase())
												? qi(function (at, mt) {
														for (var wt, It = et(at, Z), kt = It.length; kt--; )
															((wt = f.call(at, It[kt])),
																(at[wt] = !(mt[wt] = It[kt])));
													})
												: function (at) {
														return et(at, 0, X);
													})
										: et;
							},
						},
						pseudos: {
							not: qi(function (z) {
								var Z = [],
									X = [],
									et = Jr(z.replace(K, "$1"));
								return et[ut]
									? qi(function (at, mt, wt, It) {
											for (
												var kt, pe = et(at, null, It, []), Gt = at.length;
												Gt--;
											)
												(kt = pe[Gt]) && (at[Gt] = !(mt[Gt] = kt));
										})
									: function (at, mt, wt) {
											return (
												(Z[0] = at),
												et(Z, null, wt, X),
												(Z[0] = null),
												!X.pop()
											);
										};
							}),
							has: qi(function (z) {
								return function (Z) {
									return ae(z, Z).length > 0;
								};
							}),
							contains: qi(function (z) {
								return (
									(z = z.replace(Dn, In)),
									function (Z) {
										return (Z.textContent || g.text(Z)).indexOf(z) > -1;
									}
								);
							}),
							lang: qi(function (z) {
								return (
									tr.test(z || "") || ae.error("unsupported lang: " + z),
									(z = z.replace(Dn, In).toLowerCase()),
									function (Z) {
										var X;
										do
											if (
												(X = R
													? Z.lang
													: Z.getAttribute("xml:lang") ||
														Z.getAttribute("lang"))
											)
												return (
													(X = X.toLowerCase()),
													X === z || X.indexOf(z + "-") === 0
												);
										while ((Z = Z.parentNode) && Z.nodeType === 1);
										return !1;
									}
								);
							}),
							target: function (z) {
								var Z = e.location && e.location.hash;
								return Z && Z.slice(1) === z.id;
							},
							root: function (z) {
								return z === H;
							},
							focus: function (z) {
								return (
									z === Yr() &&
									k.hasFocus() &&
									!!(z.type || z.href || ~z.tabIndex)
								);
							},
							enabled: ys(!1),
							disabled: ys(!0),
							checked: function (z) {
								return (
									(ot(z, "input") && !!z.checked) ||
									(ot(z, "option") && !!z.selected)
								);
							},
							selected: function (z) {
								return (
									z.parentNode && z.parentNode.selectedIndex,
									z.selected === !0
								);
							},
							empty: function (z) {
								for (z = z.firstChild; z; z = z.nextSibling)
									if (z.nodeType < 6) return !1;
								return !0;
							},
							parent: function (z) {
								return !c.pseudos.empty(z);
							},
							header: function (z) {
								return un.test(z.nodeName);
							},
							input: function (z) {
								return ir.test(z.nodeName);
							},
							button: function (z) {
								return (
									(ot(z, "input") && z.type === "button") || ot(z, "button")
								);
							},
							text: function (z) {
								var Z;
								return (
									ot(z, "input") &&
									z.type === "text" &&
									((Z = z.getAttribute("type")) == null ||
										Z.toLowerCase() === "text")
								);
							},
							first: gr(function () {
								return [0];
							}),
							last: gr(function (z, Z) {
								return [Z - 1];
							}),
							eq: gr(function (z, Z, X) {
								return [X < 0 ? X + Z : X];
							}),
							even: gr(function (z, Z) {
								for (var X = 0; X < Z; X += 2) z.push(X);
								return z;
							}),
							odd: gr(function (z, Z) {
								for (var X = 1; X < Z; X += 2) z.push(X);
								return z;
							}),
							lt: gr(function (z, Z, X) {
								var et;
								for (
									X < 0 ? (et = X + Z) : X > Z ? (et = Z) : (et = X);
									--et >= 0;
								)
									z.push(et);
								return z;
							}),
							gt: gr(function (z, Z, X) {
								for (var et = X < 0 ? X + Z : X; ++et < Z; ) z.push(et);
								return z;
							}),
						},
					}),
				(c.pseudos.nth = c.pseudos.eq));
			for (o in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
				c.pseudos[o] = Lr(o);
			for (o in { submit: !0, reset: !0 }) c.pseudos[o] = Bn(o);
			function Ro() {}
			((Ro.prototype = c.filters = c.pseudos), (c.setFilters = new Ro()));
			function zn(z, Z) {
				var X,
					et,
					at,
					mt,
					wt,
					It,
					kt,
					pe = ye[z + " "];
				if (pe) return Z ? 0 : pe.slice(0);
				for (wt = z, It = [], kt = c.preFilter; wt; ) {
					((!X || (et = ti.exec(wt))) &&
						(et && (wt = wt.slice(et[0].length) || wt), It.push((at = []))),
						(X = !1),
						(et = pr.exec(wt)) &&
							((X = et.shift()),
							at.push({ value: X, type: et[0].replace(K, " ") }),
							(wt = wt.slice(X.length))));
					for (mt in c.filter)
						(et = er[mt].exec(wt)) &&
							(!kt[mt] || (et = kt[mt](et))) &&
							((X = et.shift()),
							at.push({ value: X, type: mt, matches: et }),
							(wt = wt.slice(X.length)));
					if (!X) break;
				}
				return Z ? wt.length : wt ? ae.error(z) : ye(z, It).slice(0);
			}
			function Kr(z) {
				for (var Z = 0, X = z.length, et = ""; Z < X; Z++) et += z[Z].value;
				return et;
			}
			function Qi(z, Z, X) {
				var et = Z.dir,
					at = Z.next,
					mt = at || et,
					wt = X && mt === "parentNode",
					It = dt++;
				return Z.first
					? function (kt, pe, Gt) {
							for (; (kt = kt[et]); )
								if (kt.nodeType === 1 || wt) return z(kt, pe, Gt);
							return !1;
						}
					: function (kt, pe, Gt) {
							var $t,
								ge,
								Ot = [tt, It];
							if (Gt) {
								for (; (kt = kt[et]); )
									if ((kt.nodeType === 1 || wt) && z(kt, pe, Gt)) return !0;
							} else
								for (; (kt = kt[et]); )
									if (kt.nodeType === 1 || wt)
										if (((ge = kt[ut] || (kt[ut] = {})), at && ot(kt, at)))
											kt = kt[et] || kt;
										else {
											if (($t = ge[mt]) && $t[0] === tt && $t[1] === It)
												return (Ot[2] = $t[2]);
											if (((ge[mt] = Ot), (Ot[2] = z(kt, pe, Gt)))) return !0;
										}
							return !1;
						};
			}
			function no(z) {
				return z.length > 1
					? function (Z, X, et) {
							for (var at = z.length; at--; ) if (!z[at](Z, X, et)) return !1;
							return !0;
						}
					: z[0];
			}
			function Nn(z, Z, X) {
				for (var et = 0, at = Z.length; et < at; et++) ae(z, Z[et], X);
				return X;
			}
			function nr(z, Z, X, et, at) {
				for (
					var mt, wt = [], It = 0, kt = z.length, pe = Z != null;
					It < kt;
					It++
				)
					(mt = z[It]) &&
						(!X || X(mt, et, at)) &&
						(wt.push(mt), pe && Z.push(It));
				return wt;
			}
			function vn(z, Z, X, et, at, mt) {
				return (
					et && !et[ut] && (et = vn(et)),
					at && !at[ut] && (at = vn(at, mt)),
					qi(function (wt, It, kt, pe) {
						var Gt,
							$t,
							ge,
							Ot,
							Ee = [],
							Gi = [],
							Qe = It.length,
							cn = wt || Nn(Z || "*", kt.nodeType ? [kt] : kt, []),
							Rn = z && (wt || !Z) ? nr(cn, Ee, z, kt, pe) : cn;
						if (
							(X
								? ((Ot = at || (wt ? z : Qe || et) ? [] : It),
									X(Rn, Ot, kt, pe))
								: (Ot = Rn),
							et)
						)
							for (Gt = nr(Ot, Gi), et(Gt, [], kt, pe), $t = Gt.length; $t--; )
								(ge = Gt[$t]) && (Ot[Gi[$t]] = !(Rn[Gi[$t]] = ge));
						if (wt) {
							if (at || z) {
								if (at) {
									for (Gt = [], $t = Ot.length; $t--; )
										(ge = Ot[$t]) && Gt.push((Rn[$t] = ge));
									at(null, (Ot = []), Gt, pe);
								}
								for ($t = Ot.length; $t--; )
									(ge = Ot[$t]) &&
										(Gt = at ? f.call(wt, ge) : Ee[$t]) > -1 &&
										(wt[Gt] = !(It[Gt] = ge));
							}
						} else
							((Ot = nr(Ot === It ? Ot.splice(Qe, Ot.length) : Ot)),
								at ? at(null, It, Ot, pe) : T.apply(It, Ot));
					})
				);
			}
			function kr(z) {
				for (
					var Z,
						X,
						et,
						at = z.length,
						mt = c.relative[z[0].type],
						wt = mt || c.relative[" "],
						It = mt ? 1 : 0,
						kt = Qi(
							function ($t) {
								return $t === Z;
							},
							wt,
							!0,
						),
						pe = Qi(
							function ($t) {
								return f.call(Z, $t) > -1;
							},
							wt,
							!0,
						),
						Gt = [
							function ($t, ge, Ot) {
								var Ee =
									(!mt && (Ot || ge != _)) ||
									((Z = ge).nodeType ? kt($t, ge, Ot) : pe($t, ge, Ot));
								return ((Z = null), Ee);
							},
						];
					It < at;
					It++
				)
					if ((X = c.relative[z[It].type])) Gt = [Qi(no(Gt), X)];
					else {
						if (
							((X = c.filter[z[It].type].apply(null, z[It].matches)), X[ut])
						) {
							for (et = ++It; et < at && !c.relative[z[et].type]; et++);
							return vn(
								It > 1 && no(Gt),
								It > 1 &&
									Kr(
										z
											.slice(0, It - 1)
											.concat({ value: z[It - 2].type === " " ? "*" : "" }),
									).replace(K, "$1"),
								X,
								It < et && kr(z.slice(It, et)),
								et < at && kr((z = z.slice(et))),
								et < at && Kr(z),
							);
						}
						Gt.push(X);
					}
				return no(Gt);
			}
			function ro(z, Z) {
				var X = Z.length > 0,
					et = z.length > 0,
					at = function (mt, wt, It, kt, pe) {
						var Gt,
							$t,
							ge,
							Ot = 0,
							Ee = "0",
							Gi = mt && [],
							Qe = [],
							cn = _,
							Rn = mt || (et && c.find.TAG("*", pe)),
							Qr = (tt += cn == null ? 1 : Math.random() || 0.1),
							oi = Rn.length;
						for (
							pe && (_ = wt == k || wt || pe);
							Ee !== oi && (Gt = Rn[Ee]) != null;
							Ee++
						) {
							if (et && Gt) {
								for (
									$t = 0, !wt && Gt.ownerDocument != k && (Vi(Gt), (It = !R));
									(ge = z[$t++]);
								)
									if (ge(Gt, wt || k, It)) {
										T.call(kt, Gt);
										break;
									}
								pe && (tt = Qr);
							}
							X && ((Gt = !ge && Gt) && Ot--, mt && Gi.push(Gt));
						}
						if (((Ot += Ee), X && Ee !== Ot)) {
							for ($t = 0; (ge = Z[$t++]); ) ge(Gi, Qe, wt, It);
							if (mt) {
								if (Ot > 0)
									for (; Ee--; ) Gi[Ee] || Qe[Ee] || (Qe[Ee] = ft.call(kt));
								Qe = nr(Qe);
							}
							(T.apply(kt, Qe),
								pe &&
									!mt &&
									Qe.length > 0 &&
									Ot + Z.length > 1 &&
									g.uniqueSort(kt));
						}
						return (pe && ((tt = Qr), (_ = cn)), Gi);
					};
				return X ? qi(at) : at;
			}
			function Jr(z, Z) {
				var X,
					et = [],
					at = [],
					mt = le[z + " "];
				if (!mt) {
					for (Z || (Z = zn(z)), X = Z.length; X--; )
						((mt = kr(Z[X])), mt[ut] ? et.push(mt) : at.push(mt));
					((mt = le(z, ro(at, et))), (mt.selector = z));
				}
				return mt;
			}
			function ln(z, Z, X, et) {
				var at,
					mt,
					wt,
					It,
					kt,
					pe = typeof z == "function" && z,
					Gt = !et && zn((z = pe.selector || z));
				if (((X = X || []), Gt.length === 1)) {
					if (
						((mt = Gt[0] = Gt[0].slice(0)),
						mt.length > 2 &&
							(wt = mt[0]).type === "ID" &&
							Z.nodeType === 9 &&
							R &&
							c.relative[mt[1].type])
					) {
						if (
							((Z = (c.find.ID(wt.matches[0].replace(Dn, In), Z) || [])[0]), Z)
						)
							pe && (Z = Z.parentNode);
						else return X;
						z = z.slice(mt.shift().value.length);
					}
					for (
						at = er.needsContext.test(z) ? 0 : mt.length;
						at-- && ((wt = mt[at]), !c.relative[(It = wt.type)]);
					)
						if (
							(kt = c.find[It]) &&
							(et = kt(
								wt.matches[0].replace(Dn, In),
								(Xr.test(mt[0].type) && be(Z.parentNode)) || Z,
							))
						) {
							if ((mt.splice(at, 1), (z = et.length && Kr(mt)), !z))
								return (T.apply(X, et), X);
							break;
						}
				}
				return (
					(pe || Jr(z, Gt))(
						et,
						Z,
						!R,
						X,
						!Z || (Xr.test(z) && be(Z.parentNode)) || Z,
					),
					X
				);
			}
			((O.sortStable = ut.split("").sort(li).join("") === ut),
				Vi(),
				(O.sortDetached = mr(function (z) {
					return z.compareDocumentPosition(k.createElement("fieldset")) & 1;
				})),
				(g.find = ae),
				(g.expr[":"] = g.expr.pseudos),
				(g.unique = g.uniqueSort),
				(ae.compile = Jr),
				(ae.select = ln),
				(ae.setDocument = Vi),
				(ae.tokenize = zn),
				(ae.escape = g.escapeSelector),
				(ae.getText = g.text),
				(ae.isXML = g.isXMLDoc),
				(ae.selectors = g.expr),
				(ae.support = g.support),
				(ae.uniqueSort = g.uniqueSort));
		})();
		var de = function (o, c, _) {
				for (var y = [], S = _ !== void 0; (o = o[c]) && o.nodeType !== 9; )
					if (o.nodeType === 1) {
						if (S && g(o).is(_)) break;
						y.push(o);
					}
				return y;
			},
			W = function (o, c) {
				for (var _ = []; o; o = o.nextSibling)
					o.nodeType === 1 && o !== c && _.push(o);
				return _;
			},
			Wt = g.expr.match.needsContext,
			Zt = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
		function oe(o, c, _) {
			return P(c)
				? g.grep(o, function (y, S) {
						return !!c.call(y, S, y) !== _;
					})
				: c.nodeType
					? g.grep(o, function (y) {
							return (y === c) !== _;
						})
					: typeof c != "string"
						? g.grep(o, function (y) {
								return f.call(c, y) > -1 !== _;
							})
						: g.filter(c, o, _);
		}
		((g.filter = function (o, c, _) {
			var y = c[0];
			return (
				_ && (o = ":not(" + o + ")"),
				c.length === 1 && y.nodeType === 1
					? g.find.matchesSelector(y, o)
						? [y]
						: []
					: g.find.matches(
							o,
							g.grep(c, function (S) {
								return S.nodeType === 1;
							}),
						)
			);
		}),
			g.fn.extend({
				find: function (o) {
					var c,
						_,
						y = this.length,
						S = this;
					if (typeof o != "string")
						return this.pushStack(
							g(o).filter(function () {
								for (c = 0; c < y; c++) if (g.contains(S[c], this)) return !0;
							}),
						);
					for (_ = this.pushStack([]), c = 0; c < y; c++) g.find(o, S[c], _);
					return y > 1 ? g.uniqueSort(_) : _;
				},
				filter: function (o) {
					return this.pushStack(oe(this, o || [], !1));
				},
				not: function (o) {
					return this.pushStack(oe(this, o || [], !0));
				},
				is: function (o) {
					return !!oe(
						this,
						typeof o == "string" && Wt.test(o) ? g(o) : o || [],
						!1,
					).length;
				},
			}));
		var jt,
			Vt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
			U = (g.fn.init = function (o, c, _) {
				var y, S;
				if (!o) return this;
				if (((_ = _ || jt), typeof o == "string"))
					if (
						(o[0] === "<" && o[o.length - 1] === ">" && o.length >= 3
							? (y = [null, o, null])
							: (y = Vt.exec(o)),
						y && (y[1] || !c))
					)
						if (y[1]) {
							if (
								((c = c instanceof g ? c[0] : c),
								g.merge(
									this,
									g.parseHTML(
										y[1],
										c && c.nodeType ? c.ownerDocument || c : G,
										!0,
									),
								),
								Zt.test(y[1]) && g.isPlainObject(c))
							)
								for (y in c) P(this[y]) ? this[y](c[y]) : this.attr(y, c[y]);
							return this;
						} else
							return (
								(S = G.getElementById(y[2])),
								S && ((this[0] = S), (this.length = 1)),
								this
							);
					else
						return !c || c.jquery
							? (c || _).find(o)
							: this.constructor(c).find(o);
				else {
					if (o.nodeType) return ((this[0] = o), (this.length = 1), this);
					if (P(o)) return _.ready !== void 0 ? _.ready(o) : o(g);
				}
				return g.makeArray(o, this);
			});
		((U.prototype = g.fn), (jt = g(G)));
		var xe = /^(?:parents|prev(?:Until|All))/,
			qe = { children: !0, contents: !0, next: !0, prev: !0 };
		g.fn.extend({
			has: function (o) {
				var c = g(o, this),
					_ = c.length;
				return this.filter(function () {
					for (var y = 0; y < _; y++) if (g.contains(this, c[y])) return !0;
				});
			},
			closest: function (o, c) {
				var _,
					y = 0,
					S = this.length,
					T = [],
					k = typeof o != "string" && g(o);
				if (!Wt.test(o)) {
					for (; y < S; y++)
						for (_ = this[y]; _ && _ !== c; _ = _.parentNode)
							if (
								_.nodeType < 11 &&
								(k
									? k.index(_) > -1
									: _.nodeType === 1 && g.find.matchesSelector(_, o))
							) {
								T.push(_);
								break;
							}
				}
				return this.pushStack(T.length > 1 ? g.uniqueSort(T) : T);
			},
			index: function (o) {
				return o
					? typeof o == "string"
						? f.call(g(o), this[0])
						: f.call(this, o.jquery ? o[0] : o)
					: this[0] && this[0].parentNode
						? this.first().prevAll().length
						: -1;
			},
			add: function (o, c) {
				return this.pushStack(g.uniqueSort(g.merge(this.get(), g(o, c))));
			},
			addBack: function (o) {
				return this.add(
					o == null ? this.prevObject : this.prevObject.filter(o),
				);
			},
		});
		function Ze(o, c) {
			for (; (o = o[c]) && o.nodeType !== 1; );
			return o;
		}
		g.each(
			{
				parent: function (o) {
					var c = o.parentNode;
					return c && c.nodeType !== 11 ? c : null;
				},
				parents: function (o) {
					return de(o, "parentNode");
				},
				parentsUntil: function (o, c, _) {
					return de(o, "parentNode", _);
				},
				next: function (o) {
					return Ze(o, "nextSibling");
				},
				prev: function (o) {
					return Ze(o, "previousSibling");
				},
				nextAll: function (o) {
					return de(o, "nextSibling");
				},
				prevAll: function (o) {
					return de(o, "previousSibling");
				},
				nextUntil: function (o, c, _) {
					return de(o, "nextSibling", _);
				},
				prevUntil: function (o, c, _) {
					return de(o, "previousSibling", _);
				},
				siblings: function (o) {
					return W((o.parentNode || {}).firstChild, o);
				},
				children: function (o) {
					return W(o.firstChild);
				},
				contents: function (o) {
					return o.contentDocument != null && s(o.contentDocument)
						? o.contentDocument
						: (ot(o, "template") && (o = o.content || o),
							g.merge([], o.childNodes));
				},
			},
			function (o, c) {
				g.fn[o] = function (_, y) {
					var S = g.map(this, c, _);
					return (
						o.slice(-5) !== "Until" && (y = _),
						y && typeof y == "string" && (S = g.filter(y, S)),
						this.length > 1 &&
							(qe[o] || g.uniqueSort(S), xe.test(o) && S.reverse()),
						this.pushStack(S)
					);
				};
			},
		);
		var je = /[^\x20\t\r\n\f]+/g;
		function Ge(o) {
			var c = {};
			return (
				g.each(o.match(je) || [], function (_, y) {
					c[y] = !0;
				}),
				c
			);
		}
		g.Callbacks = function (o) {
			o = typeof o == "string" ? Ge(o) : g.extend({}, o);
			var c,
				_,
				y,
				S,
				T = [],
				k = [],
				H = -1,
				R = function () {
					for (S = S || o.once, y = c = !0; k.length; H = -1)
						for (_ = k.shift(); ++H < T.length; )
							T[H].apply(_[0], _[1]) === !1 &&
								o.stopOnFalse &&
								((H = T.length), (_ = !1));
					(o.memory || (_ = !1), (c = !1), S && (_ ? (T = []) : (T = "")));
				},
				$ = {
					add: function () {
						return (
							T &&
								(_ && !c && ((H = T.length - 1), k.push(_)),
								(function rt(ut) {
									g.each(ut, function (tt, dt) {
										P(dt)
											? (!o.unique || !$.has(dt)) && T.push(dt)
											: dt && dt.length && V(dt) !== "string" && rt(dt);
									});
								})(arguments),
								_ && !c && R()),
							this
						);
					},
					remove: function () {
						return (
							g.each(arguments, function (rt, ut) {
								for (var tt; (tt = g.inArray(ut, T, tt)) > -1; )
									(T.splice(tt, 1), tt <= H && H--);
							}),
							this
						);
					},
					has: function (rt) {
						return rt ? g.inArray(rt, T) > -1 : T.length > 0;
					},
					empty: function () {
						return (T && (T = []), this);
					},
					disable: function () {
						return ((S = k = []), (T = _ = ""), this);
					},
					disabled: function () {
						return !T;
					},
					lock: function () {
						return ((S = k = []), !_ && !c && (T = _ = ""), this);
					},
					locked: function () {
						return !!S;
					},
					fireWith: function (rt, ut) {
						return (
							S ||
								((ut = ut || []),
								(ut = [rt, ut.slice ? ut.slice() : ut]),
								k.push(ut),
								c || R()),
							this
						);
					},
					fire: function () {
						return ($.fireWith(this, arguments), this);
					},
					fired: function () {
						return !!y;
					},
				};
			return $;
		};
		function Ue(o) {
			return o;
		}
		function ne(o) {
			throw o;
		}
		function We(o, c, _, y) {
			var S;
			try {
				o && P((S = o.promise))
					? S.call(o).done(c).fail(_)
					: o && P((S = o.then))
						? S.call(o, c, _)
						: c.apply(void 0, [o].slice(y));
			} catch (T) {
				_.apply(void 0, [T]);
			}
		}
		g.extend({
			Deferred: function (o) {
				var c = [
						[
							"notify",
							"progress",
							g.Callbacks("memory"),
							g.Callbacks("memory"),
							2,
						],
						[
							"resolve",
							"done",
							g.Callbacks("once memory"),
							g.Callbacks("once memory"),
							0,
							"resolved",
						],
						[
							"reject",
							"fail",
							g.Callbacks("once memory"),
							g.Callbacks("once memory"),
							1,
							"rejected",
						],
					],
					_ = "pending",
					y = {
						state: function () {
							return _;
						},
						always: function () {
							return (S.done(arguments).fail(arguments), this);
						},
						catch: function (T) {
							return y.then(null, T);
						},
						pipe: function () {
							var T = arguments;
							return g
								.Deferred(function (k) {
									(g.each(c, function (H, R) {
										var $ = P(T[R[4]]) && T[R[4]];
										S[R[1]](function () {
											var rt = $ && $.apply(this, arguments);
											rt && P(rt.promise)
												? rt
														.promise()
														.progress(k.notify)
														.done(k.resolve)
														.fail(k.reject)
												: k[R[0] + "With"](this, $ ? [rt] : arguments);
										});
									}),
										(T = null));
								})
								.promise();
						},
						then: function (T, k, H) {
							var R = 0;
							function $(rt, ut, tt, dt) {
								return function () {
									var Xt = this,
										ye = arguments,
										le = function () {
											var li, Jn;
											if (!(rt < R)) {
												if (((li = tt.apply(Xt, ye)), li === ut.promise()))
													throw new TypeError("Thenable self-resolution");
												((Jn =
													li &&
													(typeof li == "object" || typeof li == "function") &&
													li.then),
													P(Jn)
														? dt
															? Jn.call(li, $(R, ut, Ue, dt), $(R, ut, ne, dt))
															: (R++,
																Jn.call(
																	li,
																	$(R, ut, Ue, dt),
																	$(R, ut, ne, dt),
																	$(R, ut, Ue, ut.notifyWith),
																))
														: (tt !== Ue && ((Xt = void 0), (ye = [li])),
															(dt || ut.resolveWith)(Xt, ye)));
											}
										},
										zi = dt
											? le
											: function () {
													try {
														le();
													} catch (li) {
														(g.Deferred.exceptionHook &&
															g.Deferred.exceptionHook(li, zi.error),
															rt + 1 >= R &&
																(tt !== ne && ((Xt = void 0), (ye = [li])),
																ut.rejectWith(Xt, ye)));
													}
												};
									rt
										? zi()
										: (g.Deferred.getErrorHook
												? (zi.error = g.Deferred.getErrorHook())
												: g.Deferred.getStackHook &&
													(zi.error = g.Deferred.getStackHook()),
											e.setTimeout(zi));
								};
							}
							return g
								.Deferred(function (rt) {
									(c[0][3].add($(0, rt, P(H) ? H : Ue, rt.notifyWith)),
										c[1][3].add($(0, rt, P(T) ? T : Ue)),
										c[2][3].add($(0, rt, P(k) ? k : ne)));
								})
								.promise();
						},
						promise: function (T) {
							return T != null ? g.extend(T, y) : y;
						},
					},
					S = {};
				return (
					g.each(c, function (T, k) {
						var H = k[2],
							R = k[5];
						((y[k[1]] = H.add),
							R &&
								H.add(
									function () {
										_ = R;
									},
									c[3 - T][2].disable,
									c[3 - T][3].disable,
									c[0][2].lock,
									c[0][3].lock,
								),
							H.add(k[3].fire),
							(S[k[0]] = function () {
								return (
									S[k[0] + "With"](this === S ? void 0 : this, arguments),
									this
								);
							}),
							(S[k[0] + "With"] = H.fireWith));
					}),
					y.promise(S),
					o && o.call(S, S),
					S
				);
			},
			when: function (o) {
				var c = arguments.length,
					_ = c,
					y = Array(_),
					S = u.call(arguments),
					T = g.Deferred(),
					k = function (H) {
						return function (R) {
							((y[H] = this),
								(S[H] = arguments.length > 1 ? u.call(arguments) : R),
								--c || T.resolveWith(y, S));
						};
					};
				if (
					c <= 1 &&
					(We(o, T.done(k(_)).resolve, T.reject, !c),
					T.state() === "pending" || P(S[_] && S[_].then))
				)
					return T.then();
				for (; _--; ) We(S[_], k(_), T.reject);
				return T.promise();
			},
		});
		var He = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
		((g.Deferred.exceptionHook = function (o, c) {
			e.console &&
				e.console.warn &&
				o &&
				He.test(o.name) &&
				e.console.warn("jQuery.Deferred exception: " + o.message, o.stack, c);
		}),
			(g.readyException = function (o) {
				e.setTimeout(function () {
					throw o;
				});
			}));
		var di = g.Deferred();
		((g.fn.ready = function (o) {
			return (
				di.then(o).catch(function (c) {
					g.readyException(c);
				}),
				this
			);
		}),
			g.extend({
				isReady: !1,
				readyWait: 1,
				ready: function (o) {
					(o === !0 ? --g.readyWait : g.isReady) ||
						((g.isReady = !0),
						!(o !== !0 && --g.readyWait > 0) && di.resolveWith(G, [g]));
				},
			}),
			(g.ready.then = di.then));
		function st() {
			(G.removeEventListener("DOMContentLoaded", st),
				e.removeEventListener("load", st),
				g.ready());
		}
		G.readyState === "complete" ||
		(G.readyState !== "loading" && !G.documentElement.doScroll)
			? e.setTimeout(g.ready)
			: (G.addEventListener("DOMContentLoaded", st),
				e.addEventListener("load", st));
		var ze = function (o, c, _, y, S, T, k) {
				var H = 0,
					R = o.length,
					$ = _ == null;
				if (V(_) === "object") {
					S = !0;
					for (H in _) ze(o, c, H, _[H], !0, T, k);
				} else if (
					y !== void 0 &&
					((S = !0),
					P(y) || (k = !0),
					$ &&
						(k
							? (c.call(o, y), (c = null))
							: (($ = c),
								(c = function (rt, ut, tt) {
									return $.call(g(rt), tt);
								}))),
					c)
				)
					for (; H < R; H++) c(o[H], _, k ? y : y.call(o[H], H, c(o[H], _)));
				return S ? o : $ ? c.call(o) : R ? c(o[0], _) : T;
			},
			Ji = /^-ms-/,
			pi = /-([a-z])/g;
		function Ie(o, c) {
			return c.toUpperCase();
		}
		function $e(o) {
			return o.replace(Ji, "ms-").replace(pi, Ie);
		}
		var re = function (o) {
			return o.nodeType === 1 || o.nodeType === 9 || !+o.nodeType;
		};
		function Di() {
			this.expando = g.expando + Di.uid++;
		}
		((Di.uid = 1),
			(Di.prototype = {
				cache: function (o) {
					var c = o[this.expando];
					return (
						c ||
							((c = {}),
							re(o) &&
								(o.nodeType
									? (o[this.expando] = c)
									: Object.defineProperty(o, this.expando, {
											value: c,
											configurable: !0,
										}))),
						c
					);
				},
				set: function (o, c, _) {
					var y,
						S = this.cache(o);
					if (typeof c == "string") S[$e(c)] = _;
					else for (y in c) S[$e(y)] = c[y];
					return S;
				},
				get: function (o, c) {
					return c === void 0
						? this.cache(o)
						: o[this.expando] && o[this.expando][$e(c)];
				},
				access: function (o, c, _) {
					return c === void 0 || (c && typeof c == "string" && _ === void 0)
						? this.get(o, c)
						: (this.set(o, c, _), _ !== void 0 ? _ : c);
				},
				remove: function (o, c) {
					var _,
						y = o[this.expando];
					if (y !== void 0) {
						if (c !== void 0)
							for (
								Array.isArray(c)
									? (c = c.map($e))
									: ((c = $e(c)), (c = (c in y) ? [c] : c.match(je) || [])),
									_ = c.length;
								_--;
							)
								delete y[c[_]];
						(c === void 0 || g.isEmptyObject(y)) &&
							(o.nodeType
								? (o[this.expando] = void 0)
								: delete o[this.expando]);
					}
				},
				hasData: function (o) {
					var c = o[this.expando];
					return c !== void 0 && !g.isEmptyObject(c);
				},
			}));
		var gt = new Di(),
			Lt = new Di(),
			Ft = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
			vt = /[A-Z]/g;
		function Kt(o) {
			return o === "true"
				? !0
				: o === "false"
					? !1
					: o === "null"
						? null
						: o === +o + ""
							? +o
							: Ft.test(o)
								? JSON.parse(o)
								: o;
		}
		function Ne(o, c, _) {
			var y;
			if (_ === void 0 && o.nodeType === 1)
				if (
					((y = "data-" + c.replace(vt, "-$&").toLowerCase()),
					(_ = o.getAttribute(y)),
					typeof _ == "string")
				) {
					try {
						_ = Kt(_);
					} catch {}
					Lt.set(o, c, _);
				} else _ = void 0;
			return _;
		}
		(g.extend({
			hasData: function (o) {
				return Lt.hasData(o) || gt.hasData(o);
			},
			data: function (o, c, _) {
				return Lt.access(o, c, _);
			},
			removeData: function (o, c) {
				Lt.remove(o, c);
			},
			_data: function (o, c, _) {
				return gt.access(o, c, _);
			},
			_removeData: function (o, c) {
				gt.remove(o, c);
			},
		}),
			g.fn.extend({
				data: function (o, c) {
					var _,
						y,
						S,
						T = this[0],
						k = T && T.attributes;
					if (o === void 0) {
						if (
							this.length &&
							((S = Lt.get(T)), T.nodeType === 1 && !gt.get(T, "hasDataAttrs"))
						) {
							for (_ = k.length; _--; )
								k[_] &&
									((y = k[_].name),
									y.indexOf("data-") === 0 &&
										((y = $e(y.slice(5))), Ne(T, y, S[y])));
							gt.set(T, "hasDataAttrs", !0);
						}
						return S;
					}
					return typeof o == "object"
						? this.each(function () {
								Lt.set(this, o);
							})
						: ze(
								this,
								function (H) {
									var R;
									if (T && H === void 0)
										return (
											(R = Lt.get(T, o)),
											R !== void 0 || ((R = Ne(T, o)), R !== void 0)
												? R
												: void 0
										);
									this.each(function () {
										Lt.set(this, o, H);
									});
								},
								null,
								c,
								arguments.length > 1,
								null,
								!0,
							);
				},
				removeData: function (o) {
					return this.each(function () {
						Lt.remove(this, o);
					});
				},
			}),
			g.extend({
				queue: function (o, c, _) {
					var y;
					if (o)
						return (
							(c = (c || "fx") + "queue"),
							(y = gt.get(o, c)),
							_ &&
								(!y || Array.isArray(_)
									? (y = gt.access(o, c, g.makeArray(_)))
									: y.push(_)),
							y || []
						);
				},
				dequeue: function (o, c) {
					c = c || "fx";
					var _ = g.queue(o, c),
						y = _.length,
						S = _.shift(),
						T = g._queueHooks(o, c),
						k = function () {
							g.dequeue(o, c);
						};
					(S === "inprogress" && ((S = _.shift()), y--),
						S &&
							(c === "fx" && _.unshift("inprogress"),
							delete T.stop,
							S.call(o, k, T)),
						!y && T && T.empty.fire());
				},
				_queueHooks: function (o, c) {
					var _ = c + "queueHooks";
					return (
						gt.get(o, _) ||
						gt.access(o, _, {
							empty: g.Callbacks("once memory").add(function () {
								gt.remove(o, [c + "queue", _]);
							}),
						})
					);
				},
			}),
			g.fn.extend({
				queue: function (o, c) {
					var _ = 2;
					return (
						typeof o != "string" && ((c = o), (o = "fx"), _--),
						arguments.length < _
							? g.queue(this[0], o)
							: c === void 0
								? this
								: this.each(function () {
										var y = g.queue(this, o, c);
										(g._queueHooks(this, o),
											o === "fx" &&
												y[0] !== "inprogress" &&
												g.dequeue(this, o));
									})
					);
				},
				dequeue: function (o) {
					return this.each(function () {
						g.dequeue(this, o);
					});
				},
				clearQueue: function (o) {
					return this.queue(o || "fx", []);
				},
				promise: function (o, c) {
					var _,
						y = 1,
						S = g.Deferred(),
						T = this,
						k = this.length,
						H = function () {
							--y || S.resolveWith(T, [T]);
						};
					for (
						typeof o != "string" && ((c = o), (o = void 0)), o = o || "fx";
						k--;
					)
						((_ = gt.get(T[k], o + "queueHooks")),
							_ && _.empty && (y++, _.empty.add(H)));
					return (H(), S.promise(c));
				},
			}));
		var bt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
			se = new RegExp("^(?:([+-])=|)(" + bt + ")([a-z%]*)$", "i"),
			ke = ["Top", "Right", "Bottom", "Left"],
			ie = G.documentElement,
			Jt = function (o) {
				return g.contains(o.ownerDocument, o);
			},
			vi = { composed: !0 };
		ie.getRootNode &&
			(Jt = function (o) {
				return (
					g.contains(o.ownerDocument, o) ||
					o.getRootNode(vi) === o.ownerDocument
				);
			});
		var Ii = function (o, c) {
			return (
				(o = c || o),
				o.style.display === "none" ||
					(o.style.display === "" && Jt(o) && g.css(o, "display") === "none")
			);
		};
		function En(o, c, _, y) {
			var S,
				T,
				k = 20,
				H = y
					? function () {
							return y.cur();
						}
					: function () {
							return g.css(o, c, "");
						},
				R = H(),
				$ = (_ && _[3]) || (g.cssNumber[c] ? "" : "px"),
				rt =
					o.nodeType &&
					(g.cssNumber[c] || ($ !== "px" && +R)) &&
					se.exec(g.css(o, c));
			if (rt && rt[3] !== $) {
				for (R = R / 2, $ = $ || rt[3], rt = +R || 1; k--; )
					(g.style(o, c, rt + $),
						(1 - T) * (1 - (T = H() / R || 0.5)) <= 0 && (k = 0),
						(rt = rt / T));
				((rt = rt * 2), g.style(o, c, rt + $), (_ = _ || []));
			}
			return (
				_ &&
					((rt = +rt || +R || 0),
					(S = _[1] ? rt + (_[1] + 1) * _[2] : +_[2]),
					y && ((y.unit = $), (y.start = rt), (y.end = S))),
				S
			);
		}
		var Qt = {};
		function Vn(o) {
			var c,
				_ = o.ownerDocument,
				y = o.nodeName,
				S = Qt[y];
			return (
				S ||
				((c = _.body.appendChild(_.createElement(y))),
				(S = g.css(c, "display")),
				c.parentNode.removeChild(c),
				S === "none" && (S = "block"),
				(Qt[y] = S),
				S)
			);
		}
		function ii(o, c) {
			for (var _, y, S = [], T = 0, k = o.length; T < k; T++)
				((y = o[T]),
					y.style &&
						((_ = y.style.display),
						c
							? (_ === "none" &&
									((S[T] = gt.get(y, "display") || null),
									S[T] || (y.style.display = "")),
								y.style.display === "" && Ii(y) && (S[T] = Vn(y)))
							: _ !== "none" && ((S[T] = "none"), gt.set(y, "display", _))));
			for (T = 0; T < k; T++) S[T] != null && (o[T].style.display = S[T]);
			return o;
		}
		g.fn.extend({
			show: function () {
				return ii(this, !0);
			},
			hide: function () {
				return ii(this);
			},
			toggle: function (o) {
				return typeof o == "boolean"
					? o
						? this.show()
						: this.hide()
					: this.each(function () {
							Ii(this) ? g(this).show() : g(this).hide();
						});
			},
		});
		var Pi = /^(?:checkbox|radio)$/i,
			Ui = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
			Cn = /^$|^module$|\/(?:java|ecma)script/i;
		(function () {
			var o = G.createDocumentFragment(),
				c = o.appendChild(G.createElement("div")),
				_ = G.createElement("input");
			(_.setAttribute("type", "radio"),
				_.setAttribute("checked", "checked"),
				_.setAttribute("name", "t"),
				c.appendChild(_),
				(O.checkClone = c.cloneNode(!0).cloneNode(!0).lastChild.checked),
				(c.innerHTML = "<textarea>x</textarea>"),
				(O.noCloneChecked = !!c.cloneNode(!0).lastChild.defaultValue),
				(c.innerHTML = "<option></option>"),
				(O.option = !!c.lastChild));
		})();
		var yi = {
			thead: [1, "<table>", "</table>"],
			col: [2, "<table><colgroup>", "</colgroup></table>"],
			tr: [2, "<table><tbody>", "</tbody></table>"],
			td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
			_default: [0, "", ""],
		};
		((yi.tbody = yi.tfoot = yi.colgroup = yi.caption = yi.thead),
			(yi.th = yi.td),
			O.option ||
				(yi.optgroup = yi.option =
					[1, "<select multiple='multiple'>", "</select>"]));
		function Xe(o, c) {
			var _;
			return (
				typeof o.getElementsByTagName < "u"
					? (_ = o.getElementsByTagName(c || "*"))
					: typeof o.querySelectorAll < "u"
						? (_ = o.querySelectorAll(c || "*"))
						: (_ = []),
				c === void 0 || (c && ot(o, c)) ? g.merge([o], _) : _
			);
		}
		function Gn(o, c) {
			for (var _ = 0, y = o.length; _ < y; _++)
				gt.set(o[_], "globalEval", !c || gt.get(c[_], "globalEval"));
		}
		var te = /<|&#?\w+;/;
		function qt(o, c, _, y, S) {
			for (
				var T,
					k,
					H,
					R,
					$,
					rt,
					ut = c.createDocumentFragment(),
					tt = [],
					dt = 0,
					Xt = o.length;
				dt < Xt;
				dt++
			)
				if (((T = o[dt]), T || T === 0))
					if (V(T) === "object") g.merge(tt, T.nodeType ? [T] : T);
					else if (!te.test(T)) tt.push(c.createTextNode(T));
					else {
						for (
							k = k || ut.appendChild(c.createElement("div")),
								H = (Ui.exec(T) || ["", ""])[1].toLowerCase(),
								R = yi[H] || yi._default,
								k.innerHTML = R[1] + g.htmlPrefilter(T) + R[2],
								rt = R[0];
							rt--;
						)
							k = k.lastChild;
						(g.merge(tt, k.childNodes),
							(k = ut.firstChild),
							(k.textContent = ""));
					}
			for (ut.textContent = "", dt = 0; (T = tt[dt++]); ) {
				if (y && g.inArray(T, y) > -1) {
					S && S.push(T);
					continue;
				}
				if ((($ = Jt(T)), (k = Xe(ut.appendChild(T), "script")), $ && Gn(k), _))
					for (rt = 0; (T = k[rt++]); ) Cn.test(T.type || "") && _.push(T);
			}
			return ut;
		}
		var we = /^([^.]*)(?:\.(.+)|)/;
		function yt() {
			return !0;
		}
		function Ut() {
			return !1;
		}
		function Rt(o, c, _, y, S, T) {
			var k, H;
			if (typeof c == "object") {
				typeof _ != "string" && ((y = y || _), (_ = void 0));
				for (H in c) Rt(o, H, _, y, c[H], T);
				return o;
			}
			if (
				(y == null && S == null
					? ((S = _), (y = _ = void 0))
					: S == null &&
						(typeof _ == "string"
							? ((S = y), (y = void 0))
							: ((S = y), (y = _), (_ = void 0))),
				S === !1)
			)
				S = Ut;
			else if (!S) return o;
			return (
				T === 1 &&
					((k = S),
					(S = function (R) {
						return (g().off(R), k.apply(this, arguments));
					}),
					(S.guid = k.guid || (k.guid = g.guid++))),
				o.each(function () {
					g.event.add(this, c, S, y, _);
				})
			);
		}
		g.event = {
			global: {},
			add: function (o, c, _, y, S) {
				var T,
					k,
					H,
					R,
					$,
					rt,
					ut,
					tt,
					dt,
					Xt,
					ye,
					le = gt.get(o);
				if (re(o))
					for (
						_.handler && ((T = _), (_ = T.handler), (S = T.selector)),
							S && g.find.matchesSelector(ie, S),
							_.guid || (_.guid = g.guid++),
							(R = le.events) || (R = le.events = Object.create(null)),
							(k = le.handle) ||
								(k = le.handle =
									function (zi) {
										return typeof g < "u" && g.event.triggered !== zi.type
											? g.event.dispatch.apply(o, arguments)
											: void 0;
									}),
							c = (c || "").match(je) || [""],
							$ = c.length;
						$--;
					)
						((H = we.exec(c[$]) || []),
							(dt = ye = H[1]),
							(Xt = (H[2] || "").split(".").sort()),
							dt &&
								((ut = g.event.special[dt] || {}),
								(dt = (S ? ut.delegateType : ut.bindType) || dt),
								(ut = g.event.special[dt] || {}),
								(rt = g.extend(
									{
										type: dt,
										origType: ye,
										data: y,
										handler: _,
										guid: _.guid,
										selector: S,
										needsContext: S && g.expr.match.needsContext.test(S),
										namespace: Xt.join("."),
									},
									T,
								)),
								(tt = R[dt]) ||
									((tt = R[dt] = []),
									(tt.delegateCount = 0),
									(!ut.setup || ut.setup.call(o, y, Xt, k) === !1) &&
										o.addEventListener &&
										o.addEventListener(dt, k)),
								ut.add &&
									(ut.add.call(o, rt),
									rt.handler.guid || (rt.handler.guid = _.guid)),
								S ? tt.splice(tt.delegateCount++, 0, rt) : tt.push(rt),
								(g.event.global[dt] = !0)));
			},
			remove: function (o, c, _, y, S) {
				var T,
					k,
					H,
					R,
					$,
					rt,
					ut,
					tt,
					dt,
					Xt,
					ye,
					le = gt.hasData(o) && gt.get(o);
				if (!(!le || !(R = le.events))) {
					for (c = (c || "").match(je) || [""], $ = c.length; $--; ) {
						if (
							((H = we.exec(c[$]) || []),
							(dt = ye = H[1]),
							(Xt = (H[2] || "").split(".").sort()),
							!dt)
						) {
							for (dt in R) g.event.remove(o, dt + c[$], _, y, !0);
							continue;
						}
						for (
							ut = g.event.special[dt] || {},
								dt = (y ? ut.delegateType : ut.bindType) || dt,
								tt = R[dt] || [],
								H =
									H[2] &&
									new RegExp("(^|\\.)" + Xt.join("\\.(?:.*\\.|)") + "(\\.|$)"),
								k = T = tt.length;
							T--;
						)
							((rt = tt[T]),
								(S || ye === rt.origType) &&
									(!_ || _.guid === rt.guid) &&
									(!H || H.test(rt.namespace)) &&
									(!y || y === rt.selector || (y === "**" && rt.selector)) &&
									(tt.splice(T, 1),
									rt.selector && tt.delegateCount--,
									ut.remove && ut.remove.call(o, rt)));
						k &&
							!tt.length &&
							((!ut.teardown || ut.teardown.call(o, Xt, le.handle) === !1) &&
								g.removeEvent(o, dt, le.handle),
							delete R[dt]);
					}
					g.isEmptyObject(R) && gt.remove(o, "handle events");
				}
			},
			dispatch: function (o) {
				var c,
					_,
					y,
					S,
					T,
					k,
					H = new Array(arguments.length),
					R = g.event.fix(o),
					$ = (gt.get(this, "events") || Object.create(null))[R.type] || [],
					rt = g.event.special[R.type] || {};
				for (H[0] = R, c = 1; c < arguments.length; c++) H[c] = arguments[c];
				if (
					((R.delegateTarget = this),
					!(rt.preDispatch && rt.preDispatch.call(this, R) === !1))
				) {
					for (
						k = g.event.handlers.call(this, R, $), c = 0;
						(S = k[c++]) && !R.isPropagationStopped();
					)
						for (
							R.currentTarget = S.elem, _ = 0;
							(T = S.handlers[_++]) && !R.isImmediatePropagationStopped();
						)
							(!R.rnamespace ||
								T.namespace === !1 ||
								R.rnamespace.test(T.namespace)) &&
								((R.handleObj = T),
								(R.data = T.data),
								(y = (
									(g.event.special[T.origType] || {}).handle || T.handler
								).apply(S.elem, H)),
								y !== void 0 &&
									(R.result = y) === !1 &&
									(R.preventDefault(), R.stopPropagation()));
					return (rt.postDispatch && rt.postDispatch.call(this, R), R.result);
				}
			},
			handlers: function (o, c) {
				var _,
					y,
					S,
					T,
					k,
					H = [],
					R = c.delegateCount,
					$ = o.target;
				if (R && $.nodeType && !(o.type === "click" && o.button >= 1)) {
					for (; $ !== this; $ = $.parentNode || this)
						if (
							$.nodeType === 1 &&
							!(o.type === "click" && $.disabled === !0)
						) {
							for (T = [], k = {}, _ = 0; _ < R; _++)
								((y = c[_]),
									(S = y.selector + " "),
									k[S] === void 0 &&
										(k[S] = y.needsContext
											? g(S, this).index($) > -1
											: g.find(S, this, null, [$]).length),
									k[S] && T.push(y));
							T.length && H.push({ elem: $, handlers: T });
						}
				}
				return (
					($ = this),
					R < c.length && H.push({ elem: $, handlers: c.slice(R) }),
					H
				);
			},
			addProp: function (o, c) {
				Object.defineProperty(g.Event.prototype, o, {
					enumerable: !0,
					configurable: !0,
					get: P(c)
						? function () {
								if (this.originalEvent) return c(this.originalEvent);
							}
						: function () {
								if (this.originalEvent) return this.originalEvent[o];
							},
					set: function (_) {
						Object.defineProperty(this, o, {
							enumerable: !0,
							configurable: !0,
							writable: !0,
							value: _,
						});
					},
				});
			},
			fix: function (o) {
				return o[g.expando] ? o : new g.Event(o);
			},
			special: {
				load: { noBubble: !0 },
				click: {
					setup: function (o) {
						var c = this || o;
						return (
							Pi.test(c.type) &&
								c.click &&
								ot(c, "input") &&
								zt(c, "click", !0),
							!1
						);
					},
					trigger: function (o) {
						var c = this || o;
						return (
							Pi.test(c.type) && c.click && ot(c, "input") && zt(c, "click"),
							!0
						);
					},
					_default: function (o) {
						var c = o.target;
						return (
							(Pi.test(c.type) &&
								c.click &&
								ot(c, "input") &&
								gt.get(c, "click")) ||
							ot(c, "a")
						);
					},
				},
				beforeunload: {
					postDispatch: function (o) {
						o.result !== void 0 &&
							o.originalEvent &&
							(o.originalEvent.returnValue = o.result);
					},
				},
			},
		};
		function zt(o, c, _) {
			if (!_) {
				gt.get(o, c) === void 0 && g.event.add(o, c, yt);
				return;
			}
			(gt.set(o, c, !1),
				g.event.add(o, c, {
					namespace: !1,
					handler: function (y) {
						var S,
							T = gt.get(this, c);
						if (y.isTrigger & 1 && this[c]) {
							if (T)
								(g.event.special[c] || {}).delegateType && y.stopPropagation();
							else if (
								((T = u.call(arguments)),
								gt.set(this, c, T),
								this[c](),
								(S = gt.get(this, c)),
								gt.set(this, c, !1),
								T !== S)
							)
								return (y.stopImmediatePropagation(), y.preventDefault(), S);
						} else
							T &&
								(gt.set(this, c, g.event.trigger(T[0], T.slice(1), this)),
								y.stopPropagation(),
								(y.isImmediatePropagationStopped = yt));
					},
				}));
		}
		((g.removeEvent = function (o, c, _) {
			o.removeEventListener && o.removeEventListener(c, _);
		}),
			(g.Event = function (o, c) {
				if (!(this instanceof g.Event)) return new g.Event(o, c);
				(o && o.type
					? ((this.originalEvent = o),
						(this.type = o.type),
						(this.isDefaultPrevented =
							o.defaultPrevented ||
							(o.defaultPrevented === void 0 && o.returnValue === !1)
								? yt
								: Ut),
						(this.target =
							o.target && o.target.nodeType === 3
								? o.target.parentNode
								: o.target),
						(this.currentTarget = o.currentTarget),
						(this.relatedTarget = o.relatedTarget))
					: (this.type = o),
					c && g.extend(this, c),
					(this.timeStamp = (o && o.timeStamp) || Date.now()),
					(this[g.expando] = !0));
			}),
			(g.Event.prototype = {
				constructor: g.Event,
				isDefaultPrevented: Ut,
				isPropagationStopped: Ut,
				isImmediatePropagationStopped: Ut,
				isSimulated: !1,
				preventDefault: function () {
					var o = this.originalEvent;
					((this.isDefaultPrevented = yt),
						o && !this.isSimulated && o.preventDefault());
				},
				stopPropagation: function () {
					var o = this.originalEvent;
					((this.isPropagationStopped = yt),
						o && !this.isSimulated && o.stopPropagation());
				},
				stopImmediatePropagation: function () {
					var o = this.originalEvent;
					((this.isImmediatePropagationStopped = yt),
						o && !this.isSimulated && o.stopImmediatePropagation(),
						this.stopPropagation());
				},
			}),
			g.each(
				{
					altKey: !0,
					bubbles: !0,
					cancelable: !0,
					changedTouches: !0,
					ctrlKey: !0,
					detail: !0,
					eventPhase: !0,
					metaKey: !0,
					pageX: !0,
					pageY: !0,
					shiftKey: !0,
					view: !0,
					char: !0,
					code: !0,
					charCode: !0,
					key: !0,
					keyCode: !0,
					button: !0,
					buttons: !0,
					clientX: !0,
					clientY: !0,
					offsetX: !0,
					offsetY: !0,
					pointerId: !0,
					pointerType: !0,
					screenX: !0,
					screenY: !0,
					targetTouches: !0,
					toElement: !0,
					touches: !0,
					which: !0,
				},
				g.event.addProp,
			),
			g.each({ focus: "focusin", blur: "focusout" }, function (o, c) {
				function _(y) {
					if (G.documentMode) {
						var S = gt.get(this, "handle"),
							T = g.event.fix(y);
						((T.type = y.type === "focusin" ? "focus" : "blur"),
							(T.isSimulated = !0),
							S(y),
							T.target === T.currentTarget && S(T));
					} else g.event.simulate(c, y.target, g.event.fix(y));
				}
				((g.event.special[o] = {
					setup: function () {
						var y;
						if ((zt(this, o, !0), G.documentMode))
							((y = gt.get(this, c)),
								y || this.addEventListener(c, _),
								gt.set(this, c, (y || 0) + 1));
						else return !1;
					},
					trigger: function () {
						return (zt(this, o), !0);
					},
					teardown: function () {
						var y;
						if (G.documentMode)
							((y = gt.get(this, c) - 1),
								y
									? gt.set(this, c, y)
									: (this.removeEventListener(c, _), gt.remove(this, c)));
						else return !1;
					},
					_default: function (y) {
						return gt.get(y.target, o);
					},
					delegateType: c,
				}),
					(g.event.special[c] = {
						setup: function () {
							var y = this.ownerDocument || this.document || this,
								S = G.documentMode ? this : y,
								T = gt.get(S, c);
							(T ||
								(G.documentMode
									? this.addEventListener(c, _)
									: y.addEventListener(o, _, !0)),
								gt.set(S, c, (T || 0) + 1));
						},
						teardown: function () {
							var y = this.ownerDocument || this.document || this,
								S = G.documentMode ? this : y,
								T = gt.get(S, c) - 1;
							T
								? gt.set(S, c, T)
								: (G.documentMode
										? this.removeEventListener(c, _)
										: y.removeEventListener(o, _, !0),
									gt.remove(S, c));
						},
					}));
			}),
			g.each(
				{
					mouseenter: "mouseover",
					mouseleave: "mouseout",
					pointerenter: "pointerover",
					pointerleave: "pointerout",
				},
				function (o, c) {
					g.event.special[o] = {
						delegateType: c,
						bindType: c,
						handle: function (_) {
							var y,
								S = this,
								T = _.relatedTarget,
								k = _.handleObj;
							return (
								(!T || (T !== S && !g.contains(S, T))) &&
									((_.type = k.origType),
									(y = k.handler.apply(this, arguments)),
									(_.type = c)),
								y
							);
						},
					};
				},
			),
			g.fn.extend({
				on: function (o, c, _, y) {
					return Rt(this, o, c, _, y);
				},
				one: function (o, c, _, y) {
					return Rt(this, o, c, _, y, 1);
				},
				off: function (o, c, _) {
					var y, S;
					if (o && o.preventDefault && o.handleObj)
						return (
							(y = o.handleObj),
							g(o.delegateTarget).off(
								y.namespace ? y.origType + "." + y.namespace : y.origType,
								y.selector,
								y.handler,
							),
							this
						);
					if (typeof o == "object") {
						for (S in o) this.off(S, c, o[S]);
						return this;
					}
					return (
						(c === !1 || typeof c == "function") && ((_ = c), (c = void 0)),
						_ === !1 && (_ = Ut),
						this.each(function () {
							g.event.remove(this, o, _, c);
						})
					);
				},
			}));
		var xt = /<script|<style|<link/i,
			he = /checked\s*(?:[^=]|=\s*.checked.)/i,
			Ye = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
		function mi(o, c) {
			return (
				(ot(o, "table") &&
					ot(c.nodeType !== 11 ? c : c.firstChild, "tr") &&
					g(o).children("tbody")[0]) ||
				o
			);
		}
		function Ve(o) {
			return ((o.type = (o.getAttribute("type") !== null) + "/" + o.type), o);
		}
		function Re(o) {
			return (
				(o.type || "").slice(0, 5) === "true/"
					? (o.type = o.type.slice(5))
					: o.removeAttribute("type"),
				o
			);
		}
		function Ae(o, c) {
			var _, y, S, T, k, H, R;
			if (c.nodeType === 1) {
				if (gt.hasData(o) && ((T = gt.get(o)), (R = T.events), R)) {
					gt.remove(c, "handle events");
					for (S in R)
						for (_ = 0, y = R[S].length; _ < y; _++) g.event.add(c, S, R[S][_]);
				}
				Lt.hasData(o) &&
					((k = Lt.access(o)), (H = g.extend({}, k)), Lt.set(c, H));
			}
		}
		function Li(o, c) {
			var _ = c.nodeName.toLowerCase();
			_ === "input" && Pi.test(o.type)
				? (c.checked = o.checked)
				: (_ === "input" || _ === "textarea") &&
					(c.defaultValue = o.defaultValue);
		}
		function Le(o, c, _, y) {
			c = l(c);
			var S,
				T,
				k,
				H,
				R,
				$,
				rt = 0,
				ut = o.length,
				tt = ut - 1,
				dt = c[0],
				Xt = P(dt);
			if (
				Xt ||
				(ut > 1 && typeof dt == "string" && !O.checkClone && he.test(dt))
			)
				return o.each(function (ye) {
					var le = o.eq(ye);
					(Xt && (c[0] = dt.call(this, ye, le.html())), Le(le, c, _, y));
				});
			if (
				ut &&
				((S = qt(c, o[0].ownerDocument, !1, o, y)),
				(T = S.firstChild),
				S.childNodes.length === 1 && (S = T),
				T || y)
			) {
				for (k = g.map(Xe(S, "script"), Ve), H = k.length; rt < ut; rt++)
					((R = S),
						rt !== tt &&
							((R = g.clone(R, !0, !0)), H && g.merge(k, Xe(R, "script"))),
						_.call(o[rt], R, rt));
				if (H)
					for (
						$ = k[k.length - 1].ownerDocument, g.map(k, Re), rt = 0;
						rt < H;
						rt++
					)
						((R = k[rt]),
							Cn.test(R.type || "") &&
								!gt.access(R, "globalEval") &&
								g.contains($, R) &&
								(R.src && (R.type || "").toLowerCase() !== "module"
									? g._evalUrl &&
										!R.noModule &&
										g._evalUrl(
											R.src,
											{ nonce: R.nonce || R.getAttribute("nonce") },
											$,
										)
									: j(R.textContent.replace(Ye, ""), R, $)));
			}
			return o;
		}
		function ki(o, c, _) {
			for (var y, S = c ? g.filter(c, o) : o, T = 0; (y = S[T]) != null; T++)
				(!_ && y.nodeType === 1 && g.cleanData(Xe(y)),
					y.parentNode &&
						(_ && Jt(y) && Gn(Xe(y, "script")), y.parentNode.removeChild(y)));
			return o;
		}
		(g.extend({
			htmlPrefilter: function (o) {
				return o;
			},
			clone: function (o, c, _) {
				var y,
					S,
					T,
					k,
					H = o.cloneNode(!0),
					R = Jt(o);
				if (
					!O.noCloneChecked &&
					(o.nodeType === 1 || o.nodeType === 11) &&
					!g.isXMLDoc(o)
				)
					for (k = Xe(H), T = Xe(o), y = 0, S = T.length; y < S; y++)
						Li(T[y], k[y]);
				if (c)
					if (_)
						for (
							T = T || Xe(o), k = k || Xe(H), y = 0, S = T.length;
							y < S;
							y++
						)
							Ae(T[y], k[y]);
					else Ae(o, H);
				return (
					(k = Xe(H, "script")),
					k.length > 0 && Gn(k, !R && Xe(o, "script")),
					H
				);
			},
			cleanData: function (o) {
				for (
					var c, _, y, S = g.event.special, T = 0;
					(_ = o[T]) !== void 0;
					T++
				)
					if (re(_)) {
						if ((c = _[gt.expando])) {
							if (c.events)
								for (y in c.events)
									S[y] ? g.event.remove(_, y) : g.removeEvent(_, y, c.handle);
							_[gt.expando] = void 0;
						}
						_[Lt.expando] && (_[Lt.expando] = void 0);
					}
			},
		}),
			g.fn.extend({
				detach: function (o) {
					return ki(this, o, !0);
				},
				remove: function (o) {
					return ki(this, o);
				},
				text: function (o) {
					return ze(
						this,
						function (c) {
							return c === void 0
								? g.text(this)
								: this.empty().each(function () {
										(this.nodeType === 1 ||
											this.nodeType === 11 ||
											this.nodeType === 9) &&
											(this.textContent = c);
									});
						},
						null,
						o,
						arguments.length,
					);
				},
				append: function () {
					return Le(this, arguments, function (o) {
						if (
							this.nodeType === 1 ||
							this.nodeType === 11 ||
							this.nodeType === 9
						) {
							var c = mi(this, o);
							c.appendChild(o);
						}
					});
				},
				prepend: function () {
					return Le(this, arguments, function (o) {
						if (
							this.nodeType === 1 ||
							this.nodeType === 11 ||
							this.nodeType === 9
						) {
							var c = mi(this, o);
							c.insertBefore(o, c.firstChild);
						}
					});
				},
				before: function () {
					return Le(this, arguments, function (o) {
						this.parentNode && this.parentNode.insertBefore(o, this);
					});
				},
				after: function () {
					return Le(this, arguments, function (o) {
						this.parentNode &&
							this.parentNode.insertBefore(o, this.nextSibling);
					});
				},
				empty: function () {
					for (var o, c = 0; (o = this[c]) != null; c++)
						o.nodeType === 1 && (g.cleanData(Xe(o, !1)), (o.textContent = ""));
					return this;
				},
				clone: function (o, c) {
					return (
						(o = o ?? !1),
						(c = c ?? o),
						this.map(function () {
							return g.clone(this, o, c);
						})
					);
				},
				html: function (o) {
					return ze(
						this,
						function (c) {
							var _ = this[0] || {},
								y = 0,
								S = this.length;
							if (c === void 0 && _.nodeType === 1) return _.innerHTML;
							if (
								typeof c == "string" &&
								!xt.test(c) &&
								!yi[(Ui.exec(c) || ["", ""])[1].toLowerCase()]
							) {
								c = g.htmlPrefilter(c);
								try {
									for (; y < S; y++)
										((_ = this[y] || {}),
											_.nodeType === 1 &&
												(g.cleanData(Xe(_, !1)), (_.innerHTML = c)));
									_ = 0;
								} catch {}
							}
							_ && this.empty().append(c);
						},
						null,
						o,
						arguments.length,
					);
				},
				replaceWith: function () {
					var o = [];
					return Le(
						this,
						arguments,
						function (c) {
							var _ = this.parentNode;
							g.inArray(this, o) < 0 &&
								(g.cleanData(Xe(this)), _ && _.replaceChild(c, this));
						},
						o,
					);
				},
			}),
			g.each(
				{
					appendTo: "append",
					prependTo: "prepend",
					insertBefore: "before",
					insertAfter: "after",
					replaceAll: "replaceWith",
				},
				function (o, c) {
					g.fn[o] = function (_) {
						for (var y, S = [], T = g(_), k = T.length - 1, H = 0; H <= k; H++)
							((y = H === k ? this : this.clone(!0)),
								g(T[H])[c](y),
								h.apply(S, y.get()));
						return this.pushStack(S);
					};
				},
			));
		var $i = new RegExp("^(" + bt + ")(?!px)[a-z%]+$", "i"),
			Fe = /^--/,
			ni = function (o) {
				var c = o.ownerDocument.defaultView;
				return ((!c || !c.opener) && (c = e), c.getComputedStyle(o));
			},
			gi = function (o, c, _) {
				var y,
					S,
					T = {};
				for (S in c) ((T[S] = o.style[S]), (o.style[S] = c[S]));
				y = _.call(o);
				for (S in c) o.style[S] = T[S];
				return y;
			},
			hr = new RegExp(ke.join("|"), "i");
		(function () {
			function o() {
				if ($) {
					((R.style.cssText =
						"position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
						($.style.cssText =
							"position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
						ie.appendChild(R).appendChild($));
					var rt = e.getComputedStyle($);
					((_ = rt.top !== "1%"),
						(H = c(rt.marginLeft) === 12),
						($.style.right = "60%"),
						(T = c(rt.right) === 36),
						(y = c(rt.width) === 36),
						($.style.position = "absolute"),
						(S = c($.offsetWidth / 3) === 12),
						ie.removeChild(R),
						($ = null));
				}
			}
			function c(rt) {
				return Math.round(parseFloat(rt));
			}
			var _,
				y,
				S,
				T,
				k,
				H,
				R = G.createElement("div"),
				$ = G.createElement("div");
			$.style &&
				(($.style.backgroundClip = "content-box"),
				($.cloneNode(!0).style.backgroundClip = ""),
				(O.clearCloneStyle = $.style.backgroundClip === "content-box"),
				g.extend(O, {
					boxSizingReliable: function () {
						return (o(), y);
					},
					pixelBoxStyles: function () {
						return (o(), T);
					},
					pixelPosition: function () {
						return (o(), _);
					},
					reliableMarginLeft: function () {
						return (o(), H);
					},
					scrollboxSize: function () {
						return (o(), S);
					},
					reliableTrDimensions: function () {
						var rt, ut, tt, dt;
						return (
							k == null &&
								((rt = G.createElement("table")),
								(ut = G.createElement("tr")),
								(tt = G.createElement("div")),
								(rt.style.cssText =
									"position:absolute;left:-11111px;border-collapse:separate"),
								(ut.style.cssText = "box-sizing:content-box;border:1px solid"),
								(ut.style.height = "1px"),
								(tt.style.height = "9px"),
								(tt.style.display = "block"),
								ie.appendChild(rt).appendChild(ut).appendChild(tt),
								(dt = e.getComputedStyle(ut)),
								(k =
									parseInt(dt.height, 10) +
										parseInt(dt.borderTopWidth, 10) +
										parseInt(dt.borderBottomWidth, 10) ===
									ut.offsetHeight),
								ie.removeChild(rt)),
							k
						);
					},
				}));
		})();
		function on(o, c, _) {
			var y,
				S,
				T,
				k,
				H = Fe.test(c),
				R = o.style;
			return (
				(_ = _ || ni(o)),
				_ &&
					((k = _.getPropertyValue(c) || _[c]),
					H && k && (k = k.replace(K, "$1") || void 0),
					k === "" && !Jt(o) && (k = g.style(o, c)),
					!O.pixelBoxStyles() &&
						$i.test(k) &&
						hr.test(c) &&
						((y = R.width),
						(S = R.minWidth),
						(T = R.maxWidth),
						(R.minWidth = R.maxWidth = R.width = k),
						(k = _.width),
						(R.width = y),
						(R.minWidth = S),
						(R.maxWidth = T))),
				k !== void 0 ? k + "" : k
			);
		}
		function bi(o, c) {
			return {
				get: function () {
					if (o()) {
						delete this.get;
						return;
					}
					return (this.get = c).apply(this, arguments);
				},
			};
		}
		var ri = ["Webkit", "Moz", "ms"],
			Fi = G.createElement("div").style,
			Fr = {};
		function cs(o) {
			for (var c = o[0].toUpperCase() + o.slice(1), _ = ri.length; _--; )
				if (((o = ri[_] + c), o in Fi)) return o;
		}
		function pn(o) {
			var c = g.cssProps[o] || Fr[o];
			return c || (o in Fi ? o : (Fr[o] = cs(o) || o));
		}
		var Hi = /^(none|table(?!-c[ea]).+)/,
			Er = { position: "absolute", visibility: "hidden", display: "block" },
			Xn = { letterSpacing: "0", fontWeight: "400" };
		function mn(o, c, _) {
			var y = se.exec(c);
			return y ? Math.max(0, y[2] - (_ || 0)) + (y[3] || "px") : c;
		}
		function ve(o, c, _, y, S, T) {
			var k = c === "width" ? 1 : 0,
				H = 0,
				R = 0,
				$ = 0;
			if (_ === (y ? "border" : "content")) return 0;
			for (; k < 4; k += 2)
				(_ === "margin" && ($ += g.css(o, _ + ke[k], !0, S)),
					y
						? (_ === "content" && (R -= g.css(o, "padding" + ke[k], !0, S)),
							_ !== "margin" &&
								(R -= g.css(o, "border" + ke[k] + "Width", !0, S)))
						: ((R += g.css(o, "padding" + ke[k], !0, S)),
							_ !== "padding"
								? (R += g.css(o, "border" + ke[k] + "Width", !0, S))
								: (H += g.css(o, "border" + ke[k] + "Width", !0, S))));
			return (
				!y &&
					T >= 0 &&
					(R +=
						Math.max(
							0,
							Math.ceil(
								o["offset" + c[0].toUpperCase() + c.slice(1)] - T - R - H - 0.5,
							),
						) || 0),
				R + $
			);
		}
		function Ke(o, c, _) {
			var y = ni(o),
				S = !O.boxSizingReliable() || _,
				T = S && g.css(o, "boxSizing", !1, y) === "border-box",
				k = T,
				H = on(o, c, y),
				R = "offset" + c[0].toUpperCase() + c.slice(1);
			if ($i.test(H)) {
				if (!_) return H;
				H = "auto";
			}
			return (
				((!O.boxSizingReliable() && T) ||
					(!O.reliableTrDimensions() && ot(o, "tr")) ||
					H === "auto" ||
					(!parseFloat(H) && g.css(o, "display", !1, y) === "inline")) &&
					o.getClientRects().length &&
					((T = g.css(o, "boxSizing", !1, y) === "border-box"),
					(k = R in o),
					k && (H = o[R])),
				(H = parseFloat(H) || 0),
				H + ve(o, c, _ || (T ? "border" : "content"), k, y, H) + "px"
			);
		}
		(g.extend({
			cssHooks: {
				opacity: {
					get: function (o, c) {
						if (c) {
							var _ = on(o, "opacity");
							return _ === "" ? "1" : _;
						}
					},
				},
			},
			cssNumber: {
				animationIterationCount: !0,
				aspectRatio: !0,
				borderImageSlice: !0,
				columnCount: !0,
				flexGrow: !0,
				flexShrink: !0,
				fontWeight: !0,
				gridArea: !0,
				gridColumn: !0,
				gridColumnEnd: !0,
				gridColumnStart: !0,
				gridRow: !0,
				gridRowEnd: !0,
				gridRowStart: !0,
				lineHeight: !0,
				opacity: !0,
				order: !0,
				orphans: !0,
				scale: !0,
				widows: !0,
				zIndex: !0,
				zoom: !0,
				fillOpacity: !0,
				floodOpacity: !0,
				stopOpacity: !0,
				strokeMiterlimit: !0,
				strokeOpacity: !0,
			},
			cssProps: {},
			style: function (o, c, _, y) {
				if (!(!o || o.nodeType === 3 || o.nodeType === 8 || !o.style)) {
					var S,
						T,
						k,
						H = $e(c),
						R = Fe.test(c),
						$ = o.style;
					if (
						(R || (c = pn(H)),
						(k = g.cssHooks[c] || g.cssHooks[H]),
						_ !== void 0)
					) {
						if (
							((T = typeof _),
							T === "string" &&
								(S = se.exec(_)) &&
								S[1] &&
								((_ = En(o, c, S)), (T = "number")),
							_ == null || _ !== _)
						)
							return;
						(T === "number" &&
							!R &&
							(_ += (S && S[3]) || (g.cssNumber[H] ? "" : "px")),
							!O.clearCloneStyle &&
								_ === "" &&
								c.indexOf("background") === 0 &&
								($[c] = "inherit"),
							(!k || !("set" in k) || (_ = k.set(o, _, y)) !== void 0) &&
								(R ? $.setProperty(c, _) : ($[c] = _)));
					} else
						return k && "get" in k && (S = k.get(o, !1, y)) !== void 0
							? S
							: $[c];
				}
			},
			css: function (o, c, _, y) {
				var S,
					T,
					k,
					H = $e(c),
					R = Fe.test(c);
				return (
					R || (c = pn(H)),
					(k = g.cssHooks[c] || g.cssHooks[H]),
					k && "get" in k && (S = k.get(o, !0, _)),
					S === void 0 && (S = on(o, c, y)),
					S === "normal" && c in Xn && (S = Xn[c]),
					_ === "" || _
						? ((T = parseFloat(S)), _ === !0 || isFinite(T) ? T || 0 : S)
						: S
				);
			},
		}),
			g.each(["height", "width"], function (o, c) {
				g.cssHooks[c] = {
					get: function (_, y, S) {
						if (y)
							return Hi.test(g.css(_, "display")) &&
								(!_.getClientRects().length || !_.getBoundingClientRect().width)
								? gi(_, Er, function () {
										return Ke(_, c, S);
									})
								: Ke(_, c, S);
					},
					set: function (_, y, S) {
						var T,
							k = ni(_),
							H = !O.scrollboxSize() && k.position === "absolute",
							R = H || S,
							$ = R && g.css(_, "boxSizing", !1, k) === "border-box",
							rt = S ? ve(_, c, S, $, k) : 0;
						return (
							$ &&
								H &&
								(rt -= Math.ceil(
									_["offset" + c[0].toUpperCase() + c.slice(1)] -
										parseFloat(k[c]) -
										ve(_, c, "border", !1, k) -
										0.5,
								)),
							rt &&
								(T = se.exec(y)) &&
								(T[3] || "px") !== "px" &&
								((_.style[c] = y), (y = g.css(_, c))),
							mn(_, y, rt)
						);
					},
				};
			}),
			(g.cssHooks.marginLeft = bi(O.reliableMarginLeft, function (o, c) {
				if (c)
					return (
						(parseFloat(on(o, "marginLeft")) ||
							o.getBoundingClientRect().left -
								gi(o, { marginLeft: 0 }, function () {
									return o.getBoundingClientRect().left;
								})) + "px"
					);
			})),
			g.each({ margin: "", padding: "", border: "Width" }, function (o, c) {
				((g.cssHooks[o + c] = {
					expand: function (_) {
						for (
							var y = 0, S = {}, T = typeof _ == "string" ? _.split(" ") : [_];
							y < 4;
							y++
						)
							S[o + ke[y] + c] = T[y] || T[y - 2] || T[0];
						return S;
					},
				}),
					o !== "margin" && (g.cssHooks[o + c].set = mn));
			}),
			g.fn.extend({
				css: function (o, c) {
					return ze(
						this,
						function (_, y, S) {
							var T,
								k,
								H = {},
								R = 0;
							if (Array.isArray(y)) {
								for (T = ni(_), k = y.length; R < k; R++)
									H[y[R]] = g.css(_, y[R], !1, T);
								return H;
							}
							return S !== void 0 ? g.style(_, y, S) : g.css(_, y);
						},
						o,
						c,
						arguments.length > 1,
					);
				},
			}));
		function Bi(o, c, _, y, S) {
			return new Bi.prototype.init(o, c, _, y, S);
		}
		((g.Tween = Bi),
			(Bi.prototype = {
				constructor: Bi,
				init: function (o, c, _, y, S, T) {
					((this.elem = o),
						(this.prop = _),
						(this.easing = S || g.easing._default),
						(this.options = c),
						(this.start = this.now = this.cur()),
						(this.end = y),
						(this.unit = T || (g.cssNumber[_] ? "" : "px")));
				},
				cur: function () {
					var o = Bi.propHooks[this.prop];
					return o && o.get ? o.get(this) : Bi.propHooks._default.get(this);
				},
				run: function (o) {
					var c,
						_ = Bi.propHooks[this.prop];
					return (
						this.options.duration
							? (this.pos = c =
									g.easing[this.easing](
										o,
										this.options.duration * o,
										0,
										1,
										this.options.duration,
									))
							: (this.pos = c = o),
						(this.now = (this.end - this.start) * c + this.start),
						this.options.step &&
							this.options.step.call(this.elem, this.now, this),
						_ && _.set ? _.set(this) : Bi.propHooks._default.set(this),
						this
					);
				},
			}),
			(Bi.prototype.init.prototype = Bi.prototype),
			(Bi.propHooks = {
				_default: {
					get: function (o) {
						var c;
						return o.elem.nodeType !== 1 ||
							(o.elem[o.prop] != null && o.elem.style[o.prop] == null)
							? o.elem[o.prop]
							: ((c = g.css(o.elem, o.prop, "")), !c || c === "auto" ? 0 : c);
					},
					set: function (o) {
						g.fx.step[o.prop]
							? g.fx.step[o.prop](o)
							: o.elem.nodeType === 1 &&
								  (g.cssHooks[o.prop] || o.elem.style[pn(o.prop)] != null)
								? g.style(o.elem, o.prop, o.now + o.unit)
								: (o.elem[o.prop] = o.now);
					},
				},
			}),
			(Bi.propHooks.scrollTop = Bi.propHooks.scrollLeft =
				{
					set: function (o) {
						o.elem.nodeType && o.elem.parentNode && (o.elem[o.prop] = o.now);
					},
				}),
			(g.easing = {
				linear: function (o) {
					return o;
				},
				swing: function (o) {
					return 0.5 - Math.cos(o * Math.PI) / 2;
				},
				_default: "swing",
			}),
			(g.fx = Bi.prototype.init),
			(g.fx.step = {}));
		var Pn,
			an,
			ks = /^(?:toggle|show|hide)$/,
			ue = /queueHooks$/;
		function Je() {
			an &&
				(G.hidden === !1 && e.requestAnimationFrame
					? e.requestAnimationFrame(Je)
					: e.setTimeout(Je, g.fx.interval),
				g.fx.tick());
		}
		function xi() {
			return (
				e.setTimeout(function () {
					Pn = void 0;
				}),
				(Pn = Date.now())
			);
		}
		function Me(o, c) {
			var _,
				y = 0,
				S = { height: o };
			for (c = c ? 1 : 0; y < 4; y += 2 - c)
				((_ = ke[y]), (S["margin" + _] = S["padding" + _] = o));
			return (c && (S.opacity = S.width = o), S);
		}
		function Ai(o, c, _) {
			for (
				var y,
					S = (wi.tweeners[c] || []).concat(wi.tweeners["*"]),
					T = 0,
					k = S.length;
				T < k;
				T++
			)
				if ((y = S[T].call(_, c, o))) return y;
		}
		function Ln(o, c, _) {
			var y,
				S,
				T,
				k,
				H,
				R,
				$,
				rt,
				ut = "width" in c || "height" in c,
				tt = this,
				dt = {},
				Xt = o.style,
				ye = o.nodeType && Ii(o),
				le = gt.get(o, "fxshow");
			_.queue ||
				((k = g._queueHooks(o, "fx")),
				k.unqueued == null &&
					((k.unqueued = 0),
					(H = k.empty.fire),
					(k.empty.fire = function () {
						k.unqueued || H();
					})),
				k.unqueued++,
				tt.always(function () {
					tt.always(function () {
						(k.unqueued--, g.queue(o, "fx").length || k.empty.fire());
					});
				}));
			for (y in c)
				if (((S = c[y]), ks.test(S))) {
					if (
						(delete c[y],
						(T = T || S === "toggle"),
						S === (ye ? "hide" : "show"))
					)
						if (S === "show" && le && le[y] !== void 0) ye = !0;
						else continue;
					dt[y] = (le && le[y]) || g.style(o, y);
				}
			if (((R = !g.isEmptyObject(c)), !(!R && g.isEmptyObject(dt)))) {
				(ut &&
					o.nodeType === 1 &&
					((_.overflow = [Xt.overflow, Xt.overflowX, Xt.overflowY]),
					($ = le && le.display),
					$ == null && ($ = gt.get(o, "display")),
					(rt = g.css(o, "display")),
					rt === "none" &&
						($
							? (rt = $)
							: (ii([o], !0),
								($ = o.style.display || $),
								(rt = g.css(o, "display")),
								ii([o]))),
					(rt === "inline" || (rt === "inline-block" && $ != null)) &&
						g.css(o, "float") === "none" &&
						(R ||
							(tt.done(function () {
								Xt.display = $;
							}),
							$ == null && ((rt = Xt.display), ($ = rt === "none" ? "" : rt))),
						(Xt.display = "inline-block"))),
					_.overflow &&
						((Xt.overflow = "hidden"),
						tt.always(function () {
							((Xt.overflow = _.overflow[0]),
								(Xt.overflowX = _.overflow[1]),
								(Xt.overflowY = _.overflow[2]));
						})),
					(R = !1));
				for (y in dt)
					(R ||
						(le
							? "hidden" in le && (ye = le.hidden)
							: (le = gt.access(o, "fxshow", { display: $ })),
						T && (le.hidden = !ye),
						ye && ii([o], !0),
						tt.done(function () {
							(ye || ii([o]), gt.remove(o, "fxshow"));
							for (y in dt) g.style(o, y, dt[y]);
						})),
						(R = Ai(ye ? le[y] : 0, y, tt)),
						y in le ||
							((le[y] = R.start), ye && ((R.end = R.start), (R.start = 0))));
			}
		}
		function kn(o, c) {
			var _, y, S, T, k;
			for (_ in o)
				if (
					((y = $e(_)),
					(S = c[y]),
					(T = o[_]),
					Array.isArray(T) && ((S = T[1]), (T = o[_] = T[0])),
					_ !== y && ((o[y] = T), delete o[_]),
					(k = g.cssHooks[y]),
					k && "expand" in k)
				) {
					((T = k.expand(T)), delete o[y]);
					for (_ in T) _ in o || ((o[_] = T[_]), (c[_] = S));
				} else c[y] = S;
		}
		function wi(o, c, _) {
			var y,
				S,
				T = 0,
				k = wi.prefilters.length,
				H = g.Deferred().always(function () {
					delete R.elem;
				}),
				R = function () {
					if (S) return !1;
					for (
						var ut = Pn || xi(),
							tt = Math.max(0, $.startTime + $.duration - ut),
							dt = tt / $.duration || 0,
							Xt = 1 - dt,
							ye = 0,
							le = $.tweens.length;
						ye < le;
						ye++
					)
						$.tweens[ye].run(Xt);
					return (
						H.notifyWith(o, [$, Xt, tt]),
						Xt < 1 && le
							? tt
							: (le || H.notifyWith(o, [$, 1, 0]), H.resolveWith(o, [$]), !1)
					);
				},
				$ = H.promise({
					elem: o,
					props: g.extend({}, c),
					opts: g.extend(
						!0,
						{ specialEasing: {}, easing: g.easing._default },
						_,
					),
					originalProperties: c,
					originalOptions: _,
					startTime: Pn || xi(),
					duration: _.duration,
					tweens: [],
					createTween: function (ut, tt) {
						var dt = g.Tween(
							o,
							$.opts,
							ut,
							tt,
							$.opts.specialEasing[ut] || $.opts.easing,
						);
						return ($.tweens.push(dt), dt);
					},
					stop: function (ut) {
						var tt = 0,
							dt = ut ? $.tweens.length : 0;
						if (S) return this;
						for (S = !0; tt < dt; tt++) $.tweens[tt].run(1);
						return (
							ut
								? (H.notifyWith(o, [$, 1, 0]), H.resolveWith(o, [$, ut]))
								: H.rejectWith(o, [$, ut]),
							this
						);
					},
				}),
				rt = $.props;
			for (kn(rt, $.opts.specialEasing); T < k; T++)
				if (((y = wi.prefilters[T].call($, o, rt, $.opts)), y))
					return (
						P(y.stop) &&
							(g._queueHooks($.elem, $.opts.queue).stop = y.stop.bind(y)),
						y
					);
			return (
				g.map(rt, Ai, $),
				P($.opts.start) && $.opts.start.call(o, $),
				$.progress($.opts.progress)
					.done($.opts.done, $.opts.complete)
					.fail($.opts.fail)
					.always($.opts.always),
				g.fx.timer(g.extend(R, { elem: o, anim: $, queue: $.opts.queue })),
				$
			);
		}
		((g.Animation = g.extend(wi, {
			tweeners: {
				"*": [
					function (o, c) {
						var _ = this.createTween(o, c);
						return (En(_.elem, o, se.exec(c), _), _);
					},
				],
			},
			tweener: function (o, c) {
				P(o) ? ((c = o), (o = ["*"])) : (o = o.match(je));
				for (var _, y = 0, S = o.length; y < S; y++)
					((_ = o[y]),
						(wi.tweeners[_] = wi.tweeners[_] || []),
						wi.tweeners[_].unshift(c));
			},
			prefilters: [Ln],
			prefilter: function (o, c) {
				c ? wi.prefilters.unshift(o) : wi.prefilters.push(o);
			},
		})),
			(g.speed = function (o, c, _) {
				var y =
					o && typeof o == "object"
						? g.extend({}, o)
						: {
								complete: _ || (!_ && c) || (P(o) && o),
								duration: o,
								easing: (_ && c) || (c && !P(c) && c),
							};
				return (
					g.fx.off
						? (y.duration = 0)
						: typeof y.duration != "number" &&
							(y.duration in g.fx.speeds
								? (y.duration = g.fx.speeds[y.duration])
								: (y.duration = g.fx.speeds._default)),
					(y.queue == null || y.queue === !0) && (y.queue = "fx"),
					(y.old = y.complete),
					(y.complete = function () {
						(P(y.old) && y.old.call(this), y.queue && g.dequeue(this, y.queue));
					}),
					y
				);
			}),
			g.fn.extend({
				fadeTo: function (o, c, _, y) {
					return this.filter(Ii)
						.css("opacity", 0)
						.show()
						.end()
						.animate({ opacity: c }, o, _, y);
				},
				animate: function (o, c, _, y) {
					var S = g.isEmptyObject(o),
						T = g.speed(c, _, y),
						k = function () {
							var H = wi(this, g.extend({}, o), T);
							(S || gt.get(this, "finish")) && H.stop(!0);
						};
					return (
						(k.finish = k),
						S || T.queue === !1 ? this.each(k) : this.queue(T.queue, k)
					);
				},
				stop: function (o, c, _) {
					var y = function (S) {
						var T = S.stop;
						(delete S.stop, T(_));
					};
					return (
						typeof o != "string" && ((_ = c), (c = o), (o = void 0)),
						c && this.queue(o || "fx", []),
						this.each(function () {
							var S = !0,
								T = o != null && o + "queueHooks",
								k = g.timers,
								H = gt.get(this);
							if (T) H[T] && H[T].stop && y(H[T]);
							else for (T in H) H[T] && H[T].stop && ue.test(T) && y(H[T]);
							for (T = k.length; T--; )
								k[T].elem === this &&
									(o == null || k[T].queue === o) &&
									(k[T].anim.stop(_), (S = !1), k.splice(T, 1));
							(S || !_) && g.dequeue(this, o);
						})
					);
				},
				finish: function (o) {
					return (
						o !== !1 && (o = o || "fx"),
						this.each(function () {
							var c,
								_ = gt.get(this),
								y = _[o + "queue"],
								S = _[o + "queueHooks"],
								T = g.timers,
								k = y ? y.length : 0;
							for (
								_.finish = !0,
									g.queue(this, o, []),
									S && S.stop && S.stop.call(this, !0),
									c = T.length;
								c--;
							)
								T[c].elem === this &&
									T[c].queue === o &&
									(T[c].anim.stop(!0), T.splice(c, 1));
							for (c = 0; c < k; c++)
								y[c] && y[c].finish && y[c].finish.call(this);
							delete _.finish;
						})
					);
				},
			}),
			g.each(["toggle", "show", "hide"], function (o, c) {
				var _ = g.fn[c];
				g.fn[c] = function (y, S, T) {
					return y == null || typeof y == "boolean"
						? _.apply(this, arguments)
						: this.animate(Me(c, !0), y, S, T);
				};
			}),
			g.each(
				{
					slideDown: Me("show"),
					slideUp: Me("hide"),
					slideToggle: Me("toggle"),
					fadeIn: { opacity: "show" },
					fadeOut: { opacity: "hide" },
					fadeToggle: { opacity: "toggle" },
				},
				function (o, c) {
					g.fn[o] = function (_, y, S) {
						return this.animate(c, _, y, S);
					};
				},
			),
			(g.timers = []),
			(g.fx.tick = function () {
				var o,
					c = 0,
					_ = g.timers;
				for (Pn = Date.now(); c < _.length; c++)
					((o = _[c]), !o() && _[c] === o && _.splice(c--, 1));
				(_.length || g.fx.stop(), (Pn = void 0));
			}),
			(g.fx.timer = function (o) {
				(g.timers.push(o), g.fx.start());
			}),
			(g.fx.interval = 13),
			(g.fx.start = function () {
				an || ((an = !0), Je());
			}),
			(g.fx.stop = function () {
				an = null;
			}),
			(g.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
			(g.fn.delay = function (o, c) {
				return (
					(o = (g.fx && g.fx.speeds[o]) || o),
					(c = c || "fx"),
					this.queue(c, function (_, y) {
						var S = e.setTimeout(_, o);
						y.stop = function () {
							e.clearTimeout(S);
						};
					})
				);
			}),
			(function () {
				var o = G.createElement("input"),
					c = G.createElement("select"),
					_ = c.appendChild(G.createElement("option"));
				((o.type = "checkbox"),
					(O.checkOn = o.value !== ""),
					(O.optSelected = _.selected),
					(o = G.createElement("input")),
					(o.value = "t"),
					(o.type = "radio"),
					(O.radioValue = o.value === "t"));
			})());
		var ui,
			Tt = g.expr.attrHandle;
		(g.fn.extend({
			attr: function (o, c) {
				return ze(this, g.attr, o, c, arguments.length > 1);
			},
			removeAttr: function (o) {
				return this.each(function () {
					g.removeAttr(this, o);
				});
			},
		}),
			g.extend({
				attr: function (o, c, _) {
					var y,
						S,
						T = o.nodeType;
					if (!(T === 3 || T === 8 || T === 2)) {
						if (typeof o.getAttribute > "u") return g.prop(o, c, _);
						if (
							((T !== 1 || !g.isXMLDoc(o)) &&
								(S =
									g.attrHooks[c.toLowerCase()] ||
									(g.expr.match.bool.test(c) ? ui : void 0)),
							_ !== void 0)
						) {
							if (_ === null) {
								g.removeAttr(o, c);
								return;
							}
							return S && "set" in S && (y = S.set(o, _, c)) !== void 0
								? y
								: (o.setAttribute(c, _ + ""), _);
						}
						return S && "get" in S && (y = S.get(o, c)) !== null
							? y
							: ((y = g.find.attr(o, c)), y ?? void 0);
					}
				},
				attrHooks: {
					type: {
						set: function (o, c) {
							if (!O.radioValue && c === "radio" && ot(o, "input")) {
								var _ = o.value;
								return (o.setAttribute("type", c), _ && (o.value = _), c);
							}
						},
					},
				},
				removeAttr: function (o, c) {
					var _,
						y = 0,
						S = c && c.match(je);
					if (S && o.nodeType === 1)
						for (; (_ = S[y++]); ) o.removeAttribute(_);
				},
			}),
			(ui = {
				set: function (o, c, _) {
					return (c === !1 ? g.removeAttr(o, _) : o.setAttribute(_, _), _);
				},
			}),
			g.each(g.expr.match.bool.source.match(/\w+/g), function (o, c) {
				var _ = Tt[c] || g.find.attr;
				Tt[c] = function (y, S, T) {
					var k,
						H,
						R = S.toLowerCase();
					return (
						T ||
							((H = Tt[R]),
							(Tt[R] = k),
							(k = _(y, S, T) != null ? R : null),
							(Tt[R] = H)),
						k
					);
				};
			}));
		var Cr = /^(?:input|select|textarea|button)$/i,
			hs = /^(?:a|area)$/i;
		(g.fn.extend({
			prop: function (o, c) {
				return ze(this, g.prop, o, c, arguments.length > 1);
			},
			removeProp: function (o) {
				return this.each(function () {
					delete this[g.propFix[o] || o];
				});
			},
		}),
			g.extend({
				prop: function (o, c, _) {
					var y,
						S,
						T = o.nodeType;
					if (!(T === 3 || T === 8 || T === 2))
						return (
							(T !== 1 || !g.isXMLDoc(o)) &&
								((c = g.propFix[c] || c), (S = g.propHooks[c])),
							_ !== void 0
								? S && "set" in S && (y = S.set(o, _, c)) !== void 0
									? y
									: (o[c] = _)
								: S && "get" in S && (y = S.get(o, c)) !== null
									? y
									: o[c]
						);
				},
				propHooks: {
					tabIndex: {
						get: function (o) {
							var c = g.find.attr(o, "tabindex");
							return c
								? parseInt(c, 10)
								: Cr.test(o.nodeName) || (hs.test(o.nodeName) && o.href)
									? 0
									: -1;
						},
					},
				},
				propFix: { for: "htmlFor", class: "className" },
			}),
			O.optSelected ||
				(g.propHooks.selected = {
					get: function (o) {
						var c = o.parentNode;
						return (c && c.parentNode && c.parentNode.selectedIndex, null);
					},
					set: function (o) {
						var c = o.parentNode;
						c && (c.selectedIndex, c.parentNode && c.parentNode.selectedIndex);
					},
				}),
			g.each(
				[
					"tabIndex",
					"readOnly",
					"maxLength",
					"cellSpacing",
					"cellPadding",
					"rowSpan",
					"colSpan",
					"useMap",
					"frameBorder",
					"contentEditable",
				],
				function () {
					g.propFix[this.toLowerCase()] = this;
				},
			));
		function fr(o) {
			var c = o.match(je) || [];
			return c.join(" ");
		}
		function An(o) {
			return (o.getAttribute && o.getAttribute("class")) || "";
		}
		function fs(o) {
			return Array.isArray(o)
				? o
				: typeof o == "string"
					? o.match(je) || []
					: [];
		}
		g.fn.extend({
			addClass: function (o) {
				var c, _, y, S, T, k;
				return P(o)
					? this.each(function (H) {
							g(this).addClass(o.call(this, H, An(this)));
						})
					: ((c = fs(o)),
						c.length
							? this.each(function () {
									if (
										((y = An(this)),
										(_ = this.nodeType === 1 && " " + fr(y) + " "),
										_)
									) {
										for (T = 0; T < c.length; T++)
											((S = c[T]),
												_.indexOf(" " + S + " ") < 0 && (_ += S + " "));
										((k = fr(_)), y !== k && this.setAttribute("class", k));
									}
								})
							: this);
			},
			removeClass: function (o) {
				var c, _, y, S, T, k;
				return P(o)
					? this.each(function (H) {
							g(this).removeClass(o.call(this, H, An(this)));
						})
					: arguments.length
						? ((c = fs(o)),
							c.length
								? this.each(function () {
										if (
											((y = An(this)),
											(_ = this.nodeType === 1 && " " + fr(y) + " "),
											_)
										) {
											for (T = 0; T < c.length; T++)
												for (S = c[T]; _.indexOf(" " + S + " ") > -1; )
													_ = _.replace(" " + S + " ", " ");
											((k = fr(_)), y !== k && this.setAttribute("class", k));
										}
									})
								: this)
						: this.attr("class", "");
			},
			toggleClass: function (o, c) {
				var _,
					y,
					S,
					T,
					k = typeof o,
					H = k === "string" || Array.isArray(o);
				return P(o)
					? this.each(function (R) {
							g(this).toggleClass(o.call(this, R, An(this), c), c);
						})
					: typeof c == "boolean" && H
						? c
							? this.addClass(o)
							: this.removeClass(o)
						: ((_ = fs(o)),
							this.each(function () {
								if (H)
									for (T = g(this), S = 0; S < _.length; S++)
										((y = _[S]),
											T.hasClass(y) ? T.removeClass(y) : T.addClass(y));
								else
									(o === void 0 || k === "boolean") &&
										((y = An(this)),
										y && gt.set(this, "__className__", y),
										this.setAttribute &&
											this.setAttribute(
												"class",
												y || o === !1
													? ""
													: gt.get(this, "__className__") || "",
											));
							}));
			},
			hasClass: function (o) {
				var c,
					_,
					y = 0;
				for (c = " " + o + " "; (_ = this[y++]); )
					if (_.nodeType === 1 && (" " + fr(An(_)) + " ").indexOf(c) > -1)
						return !0;
				return !1;
			},
		});
		var Js = /\r/g;
		(g.fn.extend({
			val: function (o) {
				var c,
					_,
					y,
					S = this[0];
				return arguments.length
					? ((y = P(o)),
						this.each(function (T) {
							var k;
							this.nodeType === 1 &&
								(y ? (k = o.call(this, T, g(this).val())) : (k = o),
								k == null
									? (k = "")
									: typeof k == "number"
										? (k += "")
										: Array.isArray(k) &&
											(k = g.map(k, function (H) {
												return H == null ? "" : H + "";
											})),
								(c =
									g.valHooks[this.type] ||
									g.valHooks[this.nodeName.toLowerCase()]),
								(!c || !("set" in c) || c.set(this, k, "value") === void 0) &&
									(this.value = k));
						}))
					: S
						? ((c = g.valHooks[S.type] || g.valHooks[S.nodeName.toLowerCase()]),
							c && "get" in c && (_ = c.get(S, "value")) !== void 0
								? _
								: ((_ = S.value),
									typeof _ == "string" ? _.replace(Js, "") : (_ ?? "")))
						: void 0;
			},
		}),
			g.extend({
				valHooks: {
					option: {
						get: function (o) {
							var c = g.find.attr(o, "value");
							return c ?? fr(g.text(o));
						},
					},
					select: {
						get: function (o) {
							var c,
								_,
								y,
								S = o.options,
								T = o.selectedIndex,
								k = o.type === "select-one",
								H = k ? null : [],
								R = k ? T + 1 : S.length;
							for (T < 0 ? (y = R) : (y = k ? T : 0); y < R; y++)
								if (
									((_ = S[y]),
									(_.selected || y === T) &&
										!_.disabled &&
										(!_.parentNode.disabled || !ot(_.parentNode, "optgroup")))
								) {
									if (((c = g(_).val()), k)) return c;
									H.push(c);
								}
							return H;
						},
						set: function (o, c) {
							for (
								var _, y, S = o.options, T = g.makeArray(c), k = S.length;
								k--;
							)
								((y = S[k]),
									(y.selected = g.inArray(g.valHooks.option.get(y), T) > -1) &&
										(_ = !0));
							return (_ || (o.selectedIndex = -1), T);
						},
					},
				},
			}),
			g.each(["radio", "checkbox"], function () {
				((g.valHooks[this] = {
					set: function (o, c) {
						if (Array.isArray(c))
							return (o.checked = g.inArray(g(o).val(), c) > -1);
					},
				}),
					O.checkOn ||
						(g.valHooks[this].get = function (o) {
							return o.getAttribute("value") === null ? "on" : o.value;
						}));
			}));
		var Pr = e.location,
			Hr = { guid: Date.now() },
			ds = /\?/;
		g.parseXML = function (o) {
			var c, _;
			if (!o || typeof o != "string") return null;
			try {
				c = new e.DOMParser().parseFromString(o, "text/xml");
			} catch {}
			return (
				(_ = c && c.getElementsByTagName("parsererror")[0]),
				(!c || _) &&
					g.error(
						"Invalid XML: " +
							(_
								? g.map(_.childNodes, function (y) {
										return y.textContent;
									}).join(`
`)
								: o),
					),
				c
			);
		};
		var ps = /^(?:focusinfocus|focusoutblur)$/,
			Qs = function (o) {
				o.stopPropagation();
			};
		(g.extend(g.event, {
			trigger: function (o, c, _, y) {
				var S,
					T,
					k,
					H,
					R,
					$,
					rt,
					ut,
					tt = [_ || G],
					dt = A.call(o, "type") ? o.type : o,
					Xt = A.call(o, "namespace") ? o.namespace.split(".") : [];
				if (
					((T = ut = k = _ = _ || G),
					!(_.nodeType === 3 || _.nodeType === 8) &&
						!ps.test(dt + g.event.triggered) &&
						(dt.indexOf(".") > -1 &&
							((Xt = dt.split(".")), (dt = Xt.shift()), Xt.sort()),
						(R = dt.indexOf(":") < 0 && "on" + dt),
						(o = o[g.expando] ? o : new g.Event(dt, typeof o == "object" && o)),
						(o.isTrigger = y ? 2 : 3),
						(o.namespace = Xt.join(".")),
						(o.rnamespace = o.namespace
							? new RegExp("(^|\\.)" + Xt.join("\\.(?:.*\\.|)") + "(\\.|$)")
							: null),
						(o.result = void 0),
						o.target || (o.target = _),
						(c = c == null ? [o] : g.makeArray(c, [o])),
						(rt = g.event.special[dt] || {}),
						!(!y && rt.trigger && rt.trigger.apply(_, c) === !1)))
				) {
					if (!y && !rt.noBubble && !F(_)) {
						for (
							H = rt.delegateType || dt, ps.test(H + dt) || (T = T.parentNode);
							T;
							T = T.parentNode
						)
							(tt.push(T), (k = T));
						k === (_.ownerDocument || G) &&
							tt.push(k.defaultView || k.parentWindow || e);
					}
					for (S = 0; (T = tt[S++]) && !o.isPropagationStopped(); )
						((ut = T),
							(o.type = S > 1 ? H : rt.bindType || dt),
							($ =
								(gt.get(T, "events") || Object.create(null))[o.type] &&
								gt.get(T, "handle")),
							$ && $.apply(T, c),
							($ = R && T[R]),
							$ &&
								$.apply &&
								re(T) &&
								((o.result = $.apply(T, c)),
								o.result === !1 && o.preventDefault()));
					return (
						(o.type = dt),
						!y &&
							!o.isDefaultPrevented() &&
							(!rt._default || rt._default.apply(tt.pop(), c) === !1) &&
							re(_) &&
							R &&
							P(_[dt]) &&
							!F(_) &&
							((k = _[R]),
							k && (_[R] = null),
							(g.event.triggered = dt),
							o.isPropagationStopped() && ut.addEventListener(dt, Qs),
							_[dt](),
							o.isPropagationStopped() && ut.removeEventListener(dt, Qs),
							(g.event.triggered = void 0),
							k && (_[R] = k)),
						o.result
					);
				}
			},
			simulate: function (o, c, _) {
				var y = g.extend(new g.Event(), _, { type: o, isSimulated: !0 });
				g.event.trigger(y, null, c);
			},
		}),
			g.fn.extend({
				trigger: function (o, c) {
					return this.each(function () {
						g.event.trigger(o, c, this);
					});
				},
				triggerHandler: function (o, c) {
					var _ = this[0];
					if (_) return g.event.trigger(o, c, _, !0);
				},
			}));
		var Gr = /\[\]$/,
			Io = /\r?\n/g,
			ee = /^(?:submit|button|image|reset|file)$/i,
			Mn = /^(?:input|select|textarea|keygen)/i;
		function Be(o, c, _, y) {
			var S;
			if (Array.isArray(c))
				g.each(c, function (T, k) {
					_ || Gr.test(o)
						? y(o, k)
						: Be(
								o + "[" + (typeof k == "object" && k != null ? T : "") + "]",
								k,
								_,
								y,
							);
				});
			else if (!_ && V(c) === "object")
				for (S in c) Be(o + "[" + S + "]", c[S], _, y);
			else y(o, c);
		}
		((g.param = function (o, c) {
			var _,
				y = [],
				S = function (T, k) {
					var H = P(k) ? k() : k;
					y[y.length] =
						encodeURIComponent(T) + "=" + encodeURIComponent(H ?? "");
				};
			if (o == null) return "";
			if (Array.isArray(o) || (o.jquery && !g.isPlainObject(o)))
				g.each(o, function () {
					S(this.name, this.value);
				});
			else for (_ in o) Be(_, o[_], c, S);
			return y.join("&");
		}),
			g.fn.extend({
				serialize: function () {
					return g.param(this.serializeArray());
				},
				serializeArray: function () {
					return this.map(function () {
						var o = g.prop(this, "elements");
						return o ? g.makeArray(o) : this;
					})
						.filter(function () {
							var o = this.type;
							return (
								this.name &&
								!g(this).is(":disabled") &&
								Mn.test(this.nodeName) &&
								!ee.test(o) &&
								(this.checked || !Pi.test(o))
							);
						})
						.map(function (o, c) {
							var _ = g(this).val();
							return _ == null
								? null
								: Array.isArray(_)
									? g.map(_, function (y) {
											return {
												name: c.name,
												value: y.replace(
													Io,
													`\r
`,
												),
											};
										})
									: {
											name: c.name,
											value: _.replace(
												Io,
												`\r
`,
											),
										};
						})
						.get();
				},
			}));
		var Yn = /%20/g,
			ms = /#.*$/,
			As = /([?&])_=[^&]*/,
			Kn = /^(.*?):[ \t]*([^\r\n]*)$/gm,
			qr = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
			to = /^(?:GET|HEAD)$/,
			gs = /^\/\//,
			Mi = {},
			dr = {},
			eo = "*/".concat("*"),
			Ms = G.createElement("a");
		Ms.href = Pr.href;
		function Bo(o) {
			return function (c, _) {
				typeof c != "string" && ((_ = c), (c = "*"));
				var y,
					S = 0,
					T = c.toLowerCase().match(je) || [];
				if (P(_))
					for (; (y = T[S++]); )
						y[0] === "+"
							? ((y = y.slice(1) || "*"), (o[y] = o[y] || []).unshift(_))
							: (o[y] = o[y] || []).push(_);
			};
		}
		function io(o, c, _, y) {
			var S = {},
				T = o === dr;
			function k(H) {
				var R;
				return (
					(S[H] = !0),
					g.each(o[H] || [], function ($, rt) {
						var ut = rt(c, _, y);
						if (typeof ut == "string" && !T && !S[ut])
							return (c.dataTypes.unshift(ut), k(ut), !1);
						if (T) return !(R = ut);
					}),
					R
				);
			}
			return k(c.dataTypes[0]) || (!S["*"] && k("*"));
		}
		function _s(o, c) {
			var _,
				y,
				S = g.ajaxSettings.flatOptions || {};
			for (_ in c) c[_] !== void 0 && ((S[_] ? o : y || (y = {}))[_] = c[_]);
			return (y && g.extend(!0, o, y), o);
		}
		function ma(o, c, _) {
			for (var y, S, T, k, H = o.contents, R = o.dataTypes; R[0] === "*"; )
				(R.shift(),
					y === void 0 &&
						(y = o.mimeType || c.getResponseHeader("Content-Type")));
			if (y) {
				for (S in H)
					if (H[S] && H[S].test(y)) {
						R.unshift(S);
						break;
					}
			}
			if (R[0] in _) T = R[0];
			else {
				for (S in _) {
					if (!R[0] || o.converters[S + " " + R[0]]) {
						T = S;
						break;
					}
					k || (k = S);
				}
				T = T || k;
			}
			if (T) return (T !== R[0] && R.unshift(T), _[T]);
		}
		function zo(o, c, _, y) {
			var S,
				T,
				k,
				H,
				R,
				$ = {},
				rt = o.dataTypes.slice();
			if (rt[1]) for (k in o.converters) $[k.toLowerCase()] = o.converters[k];
			for (T = rt.shift(); T; )
				if (
					(o.responseFields[T] && (_[o.responseFields[T]] = c),
					!R && y && o.dataFilter && (c = o.dataFilter(c, o.dataType)),
					(R = T),
					(T = rt.shift()),
					T)
				) {
					if (T === "*") T = R;
					else if (R !== "*" && R !== T) {
						if (((k = $[R + " " + T] || $["* " + T]), !k)) {
							for (S in $)
								if (
									((H = S.split(" ")),
									H[1] === T && ((k = $[R + " " + H[0]] || $["* " + H[0]]), k))
								) {
									k === !0
										? (k = $[S])
										: $[S] !== !0 && ((T = H[0]), rt.unshift(H[1]));
									break;
								}
						}
						if (k !== !0)
							if (k && o.throws) c = k(c);
							else
								try {
									c = k(c);
								} catch (ut) {
									return {
										state: "parsererror",
										error: k ? ut : "No conversion from " + R + " to " + T,
									};
								}
					}
				}
			return { state: "success", data: c };
		}
		(g.extend({
			active: 0,
			lastModified: {},
			etag: {},
			ajaxSettings: {
				url: Pr.href,
				type: "GET",
				isLocal: qr.test(Pr.protocol),
				global: !0,
				processData: !0,
				async: !0,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",
				accepts: {
					"*": eo,
					text: "text/plain",
					html: "text/html",
					xml: "application/xml, text/xml",
					json: "application/json, text/javascript",
				},
				contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
				responseFields: {
					xml: "responseXML",
					text: "responseText",
					json: "responseJSON",
				},
				converters: {
					"* text": String,
					"text html": !0,
					"text json": JSON.parse,
					"text xml": g.parseXML,
				},
				flatOptions: { url: !0, context: !0 },
			},
			ajaxSetup: function (o, c) {
				return c ? _s(_s(o, g.ajaxSettings), c) : _s(g.ajaxSettings, o);
			},
			ajaxPrefilter: Bo(Mi),
			ajaxTransport: Bo(dr),
			ajax: function (o, c) {
				(typeof o == "object" && ((c = o), (o = void 0)), (c = c || {}));
				var _,
					y,
					S,
					T,
					k,
					H,
					R,
					$,
					rt,
					ut,
					tt = g.ajaxSetup({}, c),
					dt = tt.context || tt,
					Xt = tt.context && (dt.nodeType || dt.jquery) ? g(dt) : g.event,
					ye = g.Deferred(),
					le = g.Callbacks("once memory"),
					zi = tt.statusCode || {},
					li = {},
					Jn = {},
					On = "canceled",
					me = {
						readyState: 0,
						getResponseHeader: function (fe) {
							var ti;
							if (R) {
								if (!T)
									for (T = {}; (ti = Kn.exec(S)); )
										T[ti[1].toLowerCase() + " "] = (
											T[ti[1].toLowerCase() + " "] || []
										).concat(ti[2]);
								ti = T[fe.toLowerCase() + " "];
							}
							return ti == null ? null : ti.join(", ");
						},
						getAllResponseHeaders: function () {
							return R ? S : null;
						},
						setRequestHeader: function (fe, ti) {
							return (
								R == null &&
									((fe = Jn[fe.toLowerCase()] = Jn[fe.toLowerCase()] || fe),
									(li[fe] = ti)),
								this
							);
						},
						overrideMimeType: function (fe) {
							return (R == null && (tt.mimeType = fe), this);
						},
						statusCode: function (fe) {
							var ti;
							if (fe)
								if (R) me.always(fe[me.status]);
								else for (ti in fe) zi[ti] = [zi[ti], fe[ti]];
							return this;
						},
						abort: function (fe) {
							var ti = fe || On;
							return (_ && _.abort(ti), Qn(0, ti), this);
						},
					};
				if (
					(ye.promise(me),
					(tt.url = ((o || tt.url || Pr.href) + "").replace(
						gs,
						Pr.protocol + "//",
					)),
					(tt.type = c.method || c.type || tt.method || tt.type),
					(tt.dataTypes = (tt.dataType || "*").toLowerCase().match(je) || [""]),
					tt.crossDomain == null)
				) {
					H = G.createElement("a");
					try {
						((H.href = tt.url),
							(H.href = H.href),
							(tt.crossDomain =
								Ms.protocol + "//" + Ms.host != H.protocol + "//" + H.host));
					} catch {
						tt.crossDomain = !0;
					}
				}
				if (
					(tt.data &&
						tt.processData &&
						typeof tt.data != "string" &&
						(tt.data = g.param(tt.data, tt.traditional)),
					io(Mi, tt, c, me),
					R)
				)
					return me;
				(($ = g.event && tt.global),
					$ && g.active++ === 0 && g.event.trigger("ajaxStart"),
					(tt.type = tt.type.toUpperCase()),
					(tt.hasContent = !to.test(tt.type)),
					(y = tt.url.replace(ms, "")),
					tt.hasContent
						? tt.data &&
							tt.processData &&
							(tt.contentType || "").indexOf(
								"application/x-www-form-urlencoded",
							) === 0 &&
							(tt.data = tt.data.replace(Yn, "+"))
						: ((ut = tt.url.slice(y.length)),
							tt.data &&
								(tt.processData || typeof tt.data == "string") &&
								((y += (ds.test(y) ? "&" : "?") + tt.data), delete tt.data),
							tt.cache === !1 &&
								((y = y.replace(As, "$1")),
								(ut = (ds.test(y) ? "&" : "?") + "_=" + Hr.guid++ + ut)),
							(tt.url = y + ut)),
					tt.ifModified &&
						(g.lastModified[y] &&
							me.setRequestHeader("If-Modified-Since", g.lastModified[y]),
						g.etag[y] && me.setRequestHeader("If-None-Match", g.etag[y])),
					((tt.data && tt.hasContent && tt.contentType !== !1) ||
						c.contentType) &&
						me.setRequestHeader("Content-Type", tt.contentType),
					me.setRequestHeader(
						"Accept",
						tt.dataTypes[0] && tt.accepts[tt.dataTypes[0]]
							? tt.accepts[tt.dataTypes[0]] +
									(tt.dataTypes[0] !== "*" ? ", " + eo + "; q=0.01" : "")
							: tt.accepts["*"],
					));
				for (rt in tt.headers) me.setRequestHeader(rt, tt.headers[rt]);
				if (tt.beforeSend && (tt.beforeSend.call(dt, me, tt) === !1 || R))
					return me.abort();
				if (
					((On = "abort"),
					le.add(tt.complete),
					me.done(tt.success),
					me.fail(tt.error),
					(_ = io(dr, tt, c, me)),
					!_)
				)
					Qn(-1, "No Transport");
				else {
					if (((me.readyState = 1), $ && Xt.trigger("ajaxSend", [me, tt]), R))
						return me;
					tt.async &&
						tt.timeout > 0 &&
						(k = e.setTimeout(function () {
							me.abort("timeout");
						}, tt.timeout));
					try {
						((R = !1), _.send(li, Qn));
					} catch (fe) {
						if (R) throw fe;
						Qn(-1, fe);
					}
				}
				function Qn(fe, ti, pr, Si) {
					var si,
						tr,
						er,
						ir,
						un,
						ci = ti;
					R ||
						((R = !0),
						k && e.clearTimeout(k),
						(_ = void 0),
						(S = Si || ""),
						(me.readyState = fe > 0 ? 4 : 0),
						(si = (fe >= 200 && fe < 300) || fe === 304),
						pr && (ir = ma(tt, me, pr)),
						!si &&
							g.inArray("script", tt.dataTypes) > -1 &&
							g.inArray("json", tt.dataTypes) < 0 &&
							(tt.converters["text script"] = function () {}),
						(ir = zo(tt, ir, me, si)),
						si
							? (tt.ifModified &&
									((un = me.getResponseHeader("Last-Modified")),
									un && (g.lastModified[y] = un),
									(un = me.getResponseHeader("etag")),
									un && (g.etag[y] = un)),
								fe === 204 || tt.type === "HEAD"
									? (ci = "nocontent")
									: fe === 304
										? (ci = "notmodified")
										: ((ci = ir.state),
											(tr = ir.data),
											(er = ir.error),
											(si = !er)))
							: ((er = ci),
								(fe || !ci) && ((ci = "error"), fe < 0 && (fe = 0))),
						(me.status = fe),
						(me.statusText = (ti || ci) + ""),
						si
							? ye.resolveWith(dt, [tr, ci, me])
							: ye.rejectWith(dt, [me, ci, er]),
						me.statusCode(zi),
						(zi = void 0),
						$ &&
							Xt.trigger(si ? "ajaxSuccess" : "ajaxError", [
								me,
								tt,
								si ? tr : er,
							]),
						le.fireWith(dt, [me, ci]),
						$ &&
							(Xt.trigger("ajaxComplete", [me, tt]),
							--g.active || g.event.trigger("ajaxStop")));
				}
				return me;
			},
			getJSON: function (o, c, _) {
				return g.get(o, c, _, "json");
			},
			getScript: function (o, c) {
				return g.get(o, void 0, c, "script");
			},
		}),
			g.each(["get", "post"], function (o, c) {
				g[c] = function (_, y, S, T) {
					return (
						P(y) && ((T = T || S), (S = y), (y = void 0)),
						g.ajax(
							g.extend(
								{ url: _, type: c, dataType: T, data: y, success: S },
								g.isPlainObject(_) && _,
							),
						)
					);
				};
			}),
			g.ajaxPrefilter(function (o) {
				var c;
				for (c in o.headers)
					c.toLowerCase() === "content-type" &&
						(o.contentType = o.headers[c] || "");
			}),
			(g._evalUrl = function (o, c, _) {
				return g.ajax({
					url: o,
					type: "GET",
					dataType: "script",
					cache: !0,
					async: !1,
					global: !1,
					converters: { "text script": function () {} },
					dataFilter: function (y) {
						g.globalEval(y, c, _);
					},
				});
			}),
			g.fn.extend({
				wrapAll: function (o) {
					var c;
					return (
						this[0] &&
							(P(o) && (o = o.call(this[0])),
							(c = g(o, this[0].ownerDocument).eq(0).clone(!0)),
							this[0].parentNode && c.insertBefore(this[0]),
							c
								.map(function () {
									for (var _ = this; _.firstElementChild; )
										_ = _.firstElementChild;
									return _;
								})
								.append(this)),
						this
					);
				},
				wrapInner: function (o) {
					return P(o)
						? this.each(function (c) {
								g(this).wrapInner(o.call(this, c));
							})
						: this.each(function () {
								var c = g(this),
									_ = c.contents();
								_.length ? _.wrapAll(o) : c.append(o);
							});
				},
				wrap: function (o) {
					var c = P(o);
					return this.each(function (_) {
						g(this).wrapAll(c ? o.call(this, _) : o);
					});
				},
				unwrap: function (o) {
					return (
						this.parent(o)
							.not("body")
							.each(function () {
								g(this).replaceWith(this.childNodes);
							}),
						this
					);
				},
			}),
			(g.expr.pseudos.hidden = function (o) {
				return !g.expr.pseudos.visible(o);
			}),
			(g.expr.pseudos.visible = function (o) {
				return !!(o.offsetWidth || o.offsetHeight || o.getClientRects().length);
			}),
			(g.ajaxSettings.xhr = function () {
				try {
					return new e.XMLHttpRequest();
				} catch {}
			}));
		var Se = { 0: 200, 1223: 204 },
			vs = g.ajaxSettings.xhr();
		((O.cors = !!vs && "withCredentials" in vs),
			(O.ajax = vs = !!vs),
			g.ajaxTransport(function (o) {
				var c, _;
				if (O.cors || (vs && !o.crossDomain))
					return {
						send: function (y, S) {
							var T,
								k = o.xhr();
							if (
								(k.open(o.type, o.url, o.async, o.username, o.password),
								o.xhrFields)
							)
								for (T in o.xhrFields) k[T] = o.xhrFields[T];
							(o.mimeType &&
								k.overrideMimeType &&
								k.overrideMimeType(o.mimeType),
								!o.crossDomain &&
									!y["X-Requested-With"] &&
									(y["X-Requested-With"] = "XMLHttpRequest"));
							for (T in y) k.setRequestHeader(T, y[T]);
							((c = function (H) {
								return function () {
									c &&
										((c =
											_ =
											k.onload =
											k.onerror =
											k.onabort =
											k.ontimeout =
											k.onreadystatechange =
												null),
										H === "abort"
											? k.abort()
											: H === "error"
												? typeof k.status != "number"
													? S(0, "error")
													: S(k.status, k.statusText)
												: S(
														Se[k.status] || k.status,
														k.statusText,
														(k.responseType || "text") !== "text" ||
															typeof k.responseText != "string"
															? { binary: k.response }
															: { text: k.responseText },
														k.getAllResponseHeaders(),
													));
								};
							}),
								(k.onload = c()),
								(_ = k.onerror = k.ontimeout = c("error")),
								k.onabort !== void 0
									? (k.onabort = _)
									: (k.onreadystatechange = function () {
											k.readyState === 4 &&
												e.setTimeout(function () {
													c && _();
												});
										}),
								(c = c("abort")));
							try {
								k.send((o.hasContent && o.data) || null);
							} catch (H) {
								if (c) throw H;
							}
						},
						abort: function () {
							c && c();
						},
					};
			}),
			g.ajaxPrefilter(function (o) {
				o.crossDomain && (o.contents.script = !1);
			}),
			g.ajaxSetup({
				accepts: {
					script:
						"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
				},
				contents: { script: /\b(?:java|ecma)script\b/ },
				converters: {
					"text script": function (o) {
						return (g.globalEval(o), o);
					},
				},
			}),
			g.ajaxPrefilter("script", function (o) {
				(o.cache === void 0 && (o.cache = !1),
					o.crossDomain && (o.type = "GET"));
			}),
			g.ajaxTransport("script", function (o) {
				if (o.crossDomain || o.scriptAttrs) {
					var c, _;
					return {
						send: function (y, S) {
							((c = g("<script>")
								.attr(o.scriptAttrs || {})
								.prop({ charset: o.scriptCharset, src: o.url })
								.on(
									"load error",
									(_ = function (T) {
										(c.remove(),
											(_ = null),
											T && S(T.type === "error" ? 404 : 200, T.type));
									}),
								)),
								G.head.appendChild(c[0]));
						},
						abort: function () {
							_ && _();
						},
					};
				}
			}));
		var gn = [],
			Wr = /(=)\?(?=&|$)|\?\?/;
		(g.ajaxSetup({
			jsonp: "callback",
			jsonpCallback: function () {
				var o = gn.pop() || g.expando + "_" + Hr.guid++;
				return ((this[o] = !0), o);
			},
		}),
			g.ajaxPrefilter("json jsonp", function (o, c, _) {
				var y,
					S,
					T,
					k =
						o.jsonp !== !1 &&
						(Wr.test(o.url)
							? "url"
							: typeof o.data == "string" &&
								(o.contentType || "").indexOf(
									"application/x-www-form-urlencoded",
								) === 0 &&
								Wr.test(o.data) &&
								"data");
				if (k || o.dataTypes[0] === "jsonp")
					return (
						(y = o.jsonpCallback =
							P(o.jsonpCallback) ? o.jsonpCallback() : o.jsonpCallback),
						k
							? (o[k] = o[k].replace(Wr, "$1" + y))
							: o.jsonp !== !1 &&
								(o.url += (ds.test(o.url) ? "&" : "?") + o.jsonp + "=" + y),
						(o.converters["script json"] = function () {
							return (T || g.error(y + " was not called"), T[0]);
						}),
						(o.dataTypes[0] = "json"),
						(S = e[y]),
						(e[y] = function () {
							T = arguments;
						}),
						_.always(function () {
							(S === void 0 ? g(e).removeProp(y) : (e[y] = S),
								o[y] && ((o.jsonpCallback = c.jsonpCallback), gn.push(y)),
								T && P(S) && S(T[0]),
								(T = S = void 0));
						}),
						"script"
					);
			}),
			(O.createHTMLDocument = (function () {
				var o = G.implementation.createHTMLDocument("").body;
				return (
					(o.innerHTML = "<form></form><form></form>"),
					o.childNodes.length === 2
				);
			})()),
			(g.parseHTML = function (o, c, _) {
				if (typeof o != "string") return [];
				typeof c == "boolean" && ((_ = c), (c = !1));
				var y, S, T;
				return (
					c ||
						(O.createHTMLDocument
							? ((c = G.implementation.createHTMLDocument("")),
								(y = c.createElement("base")),
								(y.href = G.location.href),
								c.head.appendChild(y))
							: (c = G)),
					(S = Zt.exec(o)),
					(T = !_ && []),
					S
						? [c.createElement(S[1])]
						: ((S = qt([o], c, T)),
							T && T.length && g(T).remove(),
							g.merge([], S.childNodes))
				);
			}),
			(g.fn.load = function (o, c, _) {
				var y,
					S,
					T,
					k = this,
					H = o.indexOf(" ");
				return (
					H > -1 && ((y = fr(o.slice(H))), (o = o.slice(0, H))),
					P(c)
						? ((_ = c), (c = void 0))
						: c && typeof c == "object" && (S = "POST"),
					k.length > 0 &&
						g
							.ajax({ url: o, type: S || "GET", dataType: "html", data: c })
							.done(function (R) {
								((T = arguments),
									k.html(y ? g("<div>").append(g.parseHTML(R)).find(y) : R));
							})
							.always(
								_ &&
									function (R, $) {
										k.each(function () {
											_.apply(this, T || [R.responseText, $, R]);
										});
									},
							),
					this
				);
			}),
			(g.expr.pseudos.animated = function (o) {
				return g.grep(g.timers, function (c) {
					return o === c.elem;
				}).length;
			}),
			(g.offset = {
				setOffset: function (o, c, _) {
					var y,
						S,
						T,
						k,
						H,
						R,
						$,
						rt = g.css(o, "position"),
						ut = g(o),
						tt = {};
					(rt === "static" && (o.style.position = "relative"),
						(H = ut.offset()),
						(T = g.css(o, "top")),
						(R = g.css(o, "left")),
						($ =
							(rt === "absolute" || rt === "fixed") &&
							(T + R).indexOf("auto") > -1),
						$
							? ((y = ut.position()), (k = y.top), (S = y.left))
							: ((k = parseFloat(T) || 0), (S = parseFloat(R) || 0)),
						P(c) && (c = c.call(o, _, g.extend({}, H))),
						c.top != null && (tt.top = c.top - H.top + k),
						c.left != null && (tt.left = c.left - H.left + S),
						"using" in c ? c.using.call(o, tt) : ut.css(tt));
				},
			}),
			g.fn.extend({
				offset: function (o) {
					if (arguments.length)
						return o === void 0
							? this
							: this.each(function (S) {
									g.offset.setOffset(this, o, S);
								});
					var c,
						_,
						y = this[0];
					if (y)
						return y.getClientRects().length
							? ((c = y.getBoundingClientRect()),
								(_ = y.ownerDocument.defaultView),
								{ top: c.top + _.pageYOffset, left: c.left + _.pageXOffset })
							: { top: 0, left: 0 };
				},
				position: function () {
					if (this[0]) {
						var o,
							c,
							_,
							y = this[0],
							S = { top: 0, left: 0 };
						if (g.css(y, "position") === "fixed") c = y.getBoundingClientRect();
						else {
							for (
								c = this.offset(),
									_ = y.ownerDocument,
									o = y.offsetParent || _.documentElement;
								o &&
								(o === _.body || o === _.documentElement) &&
								g.css(o, "position") === "static";
							)
								o = o.parentNode;
							o &&
								o !== y &&
								o.nodeType === 1 &&
								((S = g(o).offset()),
								(S.top += g.css(o, "borderTopWidth", !0)),
								(S.left += g.css(o, "borderLeftWidth", !0)));
						}
						return {
							top: c.top - S.top - g.css(y, "marginTop", !0),
							left: c.left - S.left - g.css(y, "marginLeft", !0),
						};
					}
				},
				offsetParent: function () {
					return this.map(function () {
						for (
							var o = this.offsetParent;
							o && g.css(o, "position") === "static";
						)
							o = o.offsetParent;
						return o || ie;
					});
				},
			}),
			g.each(
				{ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
				function (o, c) {
					var _ = c === "pageYOffset";
					g.fn[o] = function (y) {
						return ze(
							this,
							function (S, T, k) {
								var H;
								if (
									(F(S) ? (H = S) : S.nodeType === 9 && (H = S.defaultView),
									k === void 0)
								)
									return H ? H[c] : S[T];
								H
									? H.scrollTo(_ ? H.pageXOffset : k, _ ? k : H.pageYOffset)
									: (S[T] = k);
							},
							o,
							y,
							arguments.length,
						);
					};
				},
			),
			g.each(["top", "left"], function (o, c) {
				g.cssHooks[c] = bi(O.pixelPosition, function (_, y) {
					if (y)
						return ((y = on(_, c)), $i.test(y) ? g(_).position()[c] + "px" : y);
				});
			}),
			g.each({ Height: "height", Width: "width" }, function (o, c) {
				g.each(
					{ padding: "inner" + o, content: c, "": "outer" + o },
					function (_, y) {
						g.fn[y] = function (S, T) {
							var k = arguments.length && (_ || typeof S != "boolean"),
								H = _ || (S === !0 || T === !0 ? "margin" : "border");
							return ze(
								this,
								function (R, $, rt) {
									var ut;
									return F(R)
										? y.indexOf("outer") === 0
											? R["inner" + o]
											: R.document.documentElement["client" + o]
										: R.nodeType === 9
											? ((ut = R.documentElement),
												Math.max(
													R.body["scroll" + o],
													ut["scroll" + o],
													R.body["offset" + o],
													ut["offset" + o],
													ut["client" + o],
												))
											: rt === void 0
												? g.css(R, $, H)
												: g.style(R, $, rt, H);
								},
								c,
								k ? S : void 0,
								k,
							);
						};
					},
				);
			}),
			g.each(
				[
					"ajaxStart",
					"ajaxStop",
					"ajaxComplete",
					"ajaxError",
					"ajaxSuccess",
					"ajaxSend",
				],
				function (o, c) {
					g.fn[c] = function (_) {
						return this.on(c, _);
					};
				},
			),
			g.fn.extend({
				bind: function (o, c, _) {
					return this.on(o, null, c, _);
				},
				unbind: function (o, c) {
					return this.off(o, null, c);
				},
				delegate: function (o, c, _, y) {
					return this.on(c, o, _, y);
				},
				undelegate: function (o, c, _) {
					return arguments.length === 1
						? this.off(o, "**")
						: this.off(c, o || "**", _);
				},
				hover: function (o, c) {
					return this.on("mouseenter", o).on("mouseleave", c || o);
				},
			}),
			g.each(
				"blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
					" ",
				),
				function (o, c) {
					g.fn[c] = function (_, y) {
						return arguments.length > 0
							? this.on(c, null, _, y)
							: this.trigger(c);
					};
				},
			));
		var No = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
		((g.proxy = function (o, c) {
			var _, y, S;
			if ((typeof c == "string" && ((_ = o[c]), (c = o), (o = _)), !!P(o)))
				return (
					(y = u.call(arguments, 2)),
					(S = function () {
						return o.apply(c || this, y.concat(u.call(arguments)));
					}),
					(S.guid = o.guid = o.guid || g.guid++),
					S
				);
		}),
			(g.holdReady = function (o) {
				o ? g.readyWait++ : g.ready(!0);
			}),
			(g.isArray = Array.isArray),
			(g.parseJSON = JSON.parse),
			(g.nodeName = ot),
			(g.isFunction = P),
			(g.isWindow = F),
			(g.camelCase = $e),
			(g.type = V),
			(g.now = Date.now),
			(g.isNumeric = function (o) {
				var c = g.type(o);
				return (c === "number" || c === "string") && !isNaN(o - parseFloat(o));
			}),
			(g.trim = function (o) {
				return o == null ? "" : (o + "").replace(No, "$1");
			}));
		var ga = e.jQuery,
			Os = e.$;
		return (
			(g.noConflict = function (o) {
				return (
					e.$ === g && (e.$ = Os),
					o && e.jQuery === g && (e.jQuery = ga),
					g
				);
			}),
			typeof n > "u" && (e.jQuery = e.$ = g),
			g
		);
	});
})(_f);
var mp = _f.exports;
const Ht = tl(mp);
function vu(p) {
	throw new Error(
		'Could not dynamically require "' +
			p +
			'". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.',
	);
}
var vf = { exports: {} };
/*! ally.js - v1.4.1 - https://allyjs.io/ - MIT License */ (function (p, e) {
	(function (n) {
		p.exports = n();
	})(function () {
		return (function n(r, s, u) {
			function l(v, w) {
				if (!s[v]) {
					if (!r[v]) {
						var A = typeof vu == "function" && vu;
						if (!w && A) return A(v, !0);
						if (h) return h(v, !0);
						var D = new Error("Cannot find module '" + v + "'");
						throw ((D.code = "MODULE_NOT_FOUND"), D);
					}
					var C = (s[v] = { exports: {} });
					r[v][0].call(
						C.exports,
						function (O) {
							var P = r[v][1][O];
							return l(P || O);
						},
						C,
						C.exports,
						n,
						r,
						s,
						u,
					);
				}
				return s[v].exports;
			}
			for (var h = typeof vu == "function" && vu, f = 0; f < u.length; f++)
				l(u[f]);
			return l;
		})(
			{
				1: [
					function (n, r) {
						function s(m, b) {
							if (!(m instanceof b))
								throw new TypeError("Cannot call a class as a function");
						}
						function u(m) {
							return m &&
								(typeof m > "u" ? "undefined" : ks(m)) === "object" &&
								"default" in m
								? m.default
								: m;
						}
						function l() {
							var m = {
									activeElement: document.activeElement,
									windowScrollTop: window.scrollTop,
									windowScrollLeft: window.scrollLeft,
									bodyScrollTop: document.body.scrollTop,
									bodyScrollLeft: document.body.scrollLeft,
								},
								b = document.createElement("iframe");
							(b.setAttribute(
								"style",
								"position:absolute; position:fixed; top:0; left:-2px; width:1px; height:1px; overflow:hidden;",
							),
								b.setAttribute("aria-live", "off"),
								b.setAttribute("aria-busy", "true"),
								b.setAttribute("aria-hidden", "true"),
								document.body.appendChild(b));
							var E = b.contentWindow,
								I = E.document;
							(I.open(), I.close());
							var N = I.createElement("div");
							return (
								I.body.appendChild(N),
								(m.iframe = b),
								(m.wrapper = N),
								(m.window = E),
								(m.document = I),
								m
							);
						}
						function h(m, b) {
							m.wrapper.innerHTML = "";
							var E =
									typeof b.element == "string"
										? m.document.createElement(b.element)
										: b.element(m.wrapper, m.document),
								I = b.mutate && b.mutate(E, m.wrapper, m.document);
							return (
								I || I === !1 || (I = E),
								!E.parentNode && m.wrapper.appendChild(E),
								I && I.focus && I.focus(),
								b.validate
									? b.validate(E, I, m.document)
									: m.document.activeElement === I
							);
						}
						function f(m) {
							(m.activeElement === document.body
								? (document.activeElement &&
										document.activeElement.blur &&
										document.activeElement.blur(),
									Tt.is.IE10 && document.body.focus())
								: m.activeElement &&
									m.activeElement.focus &&
									m.activeElement.focus(),
								document.body.removeChild(m.iframe),
								(window.scrollTop = m.windowScrollTop),
								(window.scrollLeft = m.windowScrollLeft),
								(document.body.scrollTop = m.bodyScrollTop),
								(document.body.scrollLeft = m.bodyScrollLeft));
						}
						function v(m) {
							var b = void 0;
							try {
								((b = window.localStorage && window.localStorage.getItem(m)),
									(b = b ? JSON.parse(b) : {}));
							} catch {
								b = {};
							}
							return b;
						}
						function w(m, b) {
							if (document.hasFocus())
								try {
									window.localStorage &&
										window.localStorage.setItem(m, JSON.stringify(b));
								} catch {}
							else
								try {
									window.localStorage && window.localStorage.removeItem(m);
								} catch {}
						}
						function A() {
							var m = document.createElement("div");
							return (
								(m.innerHTML = `<svg><foreignObject width="30" height="30">
      <input type="text"/>
  </foreignObject></svg>`),
								m.firstChild.firstChild
							);
						}
						function D(m) {
							return (
								'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
								m +
								"</svg>"
							);
						}
						function C(m) {
							if (!m.focus)
								try {
									HTMLElement.prototype.focus.call(m);
								} catch {
									rt(m);
								}
						}
						function O(m, b, E) {
							return (C(b), E.activeElement === b);
						}
						function P() {
							var m = Io(pr);
							return (
								Object.keys(ti).forEach(function (b) {
									m[b] = ti[b]();
								}),
								m
							);
						}
						function F() {
							qi.warn("trying to focus inert element", this);
						}
						function G(m, b) {
							if (b) {
								var E = ci(m);
								Yr({
									element: m,
									attribute: "tabindex",
									temporaryValue: "-1",
									saveValue: E !== null ? E : "",
								});
							} else Yr({ element: m, attribute: "tabindex" });
						}
						function B(m, b) {
							Zr({ element: m, attribute: "controls", remove: b });
						}
						function j(m, b) {
							Yr({
								element: m,
								attribute: "focusable",
								temporaryValue: b ? "false" : void 0,
							});
						}
						function V(m, b) {
							Zr({ element: m, attribute: "xlink:href", remove: b });
						}
						function Q(m, b) {
							Yr({
								element: m,
								attribute: "aria-disabled",
								temporaryValue: b ? "true" : void 0,
							});
						}
						function it(m, b) {
							b ? (m.focus = F) : delete m.focus;
						}
						function g(m, b) {
							if (b) {
								var E = m.style.pointerEvents || "";
								(m.setAttribute("data-inert-pointer-events", E),
									(m.style.pointerEvents = "none"));
							} else {
								var I = m.getAttribute("data-inert-pointer-events");
								(m.removeAttribute("data-inert-pointer-events"),
									(m.style.pointerEvents = I));
							}
						}
						function ct(m, b) {
							(Q(m, b), G(m, b), it(m, b), g(m, b));
							var E = m.nodeName.toLowerCase();
							((E === "video" || E === "audio") && B(m, b),
								(E === "svg" || m.ownerSVGElement) &&
									(mr.focusSvgFocusableAttribute
										? j(m, b)
										: mr.focusSvgTabindexAttribute || E !== "a" || V(m, b)),
								b
									? m.setAttribute("data-ally-disabled", "true")
									: m.removeAttribute("data-ally-disabled"));
						}
						function ot(m) {
							ys.some(function (b) {
								return m[b] ? ((gr = b), !0) : !1;
							});
						}
						function ft(m, b) {
							return (gr || ot(m), m[gr](b));
						}
						function Dt(m) {
							var b = m.webkitUserModify || "";
							return !!(b && b.indexOf("write") !== -1);
						}
						function pt(m) {
							return [
								m.getPropertyValue("overflow"),
								m.getPropertyValue("overflow-x"),
								m.getPropertyValue("overflow-y"),
							].some(function (b) {
								return b === "auto" || b === "scroll";
							});
						}
						function Et(m) {
							return m.display.indexOf("flex") > -1;
						}
						function K(m, b, E, I) {
							return (b !== "div" && b !== "span") ||
								(E && E !== "div" && E !== "span" && !pt(I))
								? !1
								: m.offsetHeight < m.scrollHeight ||
										m.offsetWidth < m.scrollWidth;
						}
						function Nt() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context,
								E = m.except,
								I =
									E === void 0
										? { flexbox: !1, scrollable: !1, shadow: !1 }
										: E;
							be || (be = si());
							var N = Me({
								label: "is/focus-relevant",
								resolveDocument: !0,
								context: b,
							});
							if (!I.shadow && N.shadowRoot) return !0;
							var Y = N.nodeName.toLowerCase();
							if (Y === "input" && N.type === "hidden") return !1;
							if (
								Y === "input" ||
								Y === "select" ||
								Y === "button" ||
								Y === "textarea" ||
								(Y === "legend" && be.focusRedirectLegend) ||
								Y === "label" ||
								Y === "area" ||
								(Y === "a" && N.hasAttribute("href"))
							)
								return !0;
							if (Y === "object" && N.hasAttribute("usemap")) return !1;
							if (Y === "object") {
								var lt = N.getAttribute("type");
								if (
									(!be.focusObjectSvg && lt === "image/svg+xml") ||
									(!be.focusObjectSwf && lt === "application/x-shockwave-flash")
								)
									return !1;
							}
							if (
								Y === "iframe" ||
								Y === "object" ||
								Y === "embed" ||
								Y === "keygen" ||
								N.hasAttribute("contenteditable") ||
								(Y === "audio" &&
									(be.focusAudioWithoutControls ||
										N.hasAttribute("controls"))) ||
								(Y === "video" &&
									(be.focusVideoWithoutControls ||
										N.hasAttribute("controls"))) ||
								(be.focusSummary && Y === "summary")
							)
								return !0;
							var Pt = un(N);
							if (Y === "img" && N.hasAttribute("usemap"))
								return (
									(Pt && be.focusImgUsemapTabindex) || be.focusRedirectImgUsemap
								);
							if (
								(be.focusTable && (Y === "table" || Y === "td")) ||
								(be.focusFieldset && Y === "fieldset")
							)
								return !0;
							var Mt = Y === "svg",
								ce = N.ownerSVGElement,
								Xi = N.getAttribute("focusable"),
								fn = ci(N);
							if (Y === "use" && fn !== null && !be.focusSvgUseTabindex)
								return !1;
							if (Y === "foreignobject")
								return fn !== null && be.focusSvgForeignobjectTabindex;
							if (ft(N, "svg a") && N.hasAttribute("xlink:href")) return !0;
							if (
								(Mt || ce) &&
								N.focus &&
								!be.focusSvgNegativeTabindexAttribute &&
								0 > fn
							)
								return !1;
							if (Mt)
								return (
									Pt ||
									be.focusSvg ||
									be.focusSvgInIframe ||
									!!(be.focusSvgFocusableAttribute && Xi && Xi === "true")
								);
							if (ce) {
								if (be.focusSvgTabindexAttribute && Pt) return !0;
								if (be.focusSvgFocusableAttribute) return Xi === "true";
							}
							if (Pt) return !0;
							var ts = window.getComputedStyle(N, null);
							if (Dt(ts)) return !0;
							if (be.focusImgIsmap && Y === "img" && N.hasAttribute("ismap")) {
								var uo = Bn({ context: N }).some(function (Ca) {
									return (
										Ca.nodeName.toLowerCase() === "a" && Ca.hasAttribute("href")
									);
								});
								if (uo) return !0;
							}
							if (!I.scrollable && be.focusScrollContainer) {
								if (be.focusScrollContainerWithoutOverflow) {
									if (K(N, Y)) return !0;
								} else if (pt(ts)) return !0;
							}
							if (!I.flexbox && be.focusFlexboxContainer && Et(ts)) return !0;
							var Vo = N.parentElement;
							if (!I.scrollable && Vo) {
								var xl = Vo.nodeName.toLowerCase(),
									Ea = window.getComputedStyle(Vo, null);
								if (
									(be.focusScrollBody && K(Vo, Y, xl, Ea)) ||
									(be.focusChildrenOfFocusableFlexbox && Et(Ea))
								)
									return !0;
							}
							return !1;
						}
						function St(m, b) {
							if (m.findIndex) return m.findIndex(b);
							var E = m.length;
							if (E === 0) return -1;
							for (var I = 0; E > I; I++) if (b(m[I], I, m)) return I;
							return -1;
						}
						function Ct(m) {
							if (
								(Qi || (Qi = Kr("object, iframe")), m._frameElement !== void 0)
							)
								return m._frameElement;
							m._frameElement = null;
							var b = m.parent.document.querySelectorAll(Qi);
							return (
								[].some.call(b, function (E) {
									var I = Ro(E);
									return I !== m.document ? !1 : ((m._frameElement = E), !0);
								}),
								m._frameElement
							);
						}
						function _t(m) {
							var b = wi(m);
							if (!b.parent || b.parent === b) return null;
							try {
								return b.frameElement || Ct(b);
							} catch {
								return null;
							}
						}
						function de(m, b) {
							return window.getComputedStyle(m, null).getPropertyValue(b);
						}
						function W(m) {
							return m.some(function (b) {
								return de(b, "display") === "none";
							});
						}
						function Wt(m) {
							var b = St(m, function (I) {
								var N = de(I, "visibility");
								return N === "hidden" || N === "collapse";
							});
							if (b === -1) return !1;
							var E = St(m, function (I) {
								return de(I, "visibility") === "visible";
							});
							return E === -1 ? !0 : E > b;
						}
						function Zt(m) {
							var b = 1;
							return (
								m[0].nodeName.toLowerCase() === "summary" && (b = 2),
								m.slice(b).some(function (E) {
									return (
										E.nodeName.toLowerCase() === "details" && E.open === !1
									);
								})
							);
						}
						function oe() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context,
								E = m.except,
								I =
									E === void 0
										? {
												notRendered: !1,
												cssDisplay: !1,
												cssVisibility: !1,
												detailsElement: !1,
												browsingContext: !1,
											}
										: E,
								N = Me({
									label: "is/visible",
									resolveDocument: !0,
									context: b,
								}),
								Y = N.nodeName.toLowerCase();
							if (!I.notRendered && no.test(Y)) return !0;
							var lt = Bn({ context: N }),
								Pt = Y === "audio" && !N.hasAttribute("controls");
							if (
								(!I.cssDisplay && W(Pt ? lt.slice(1) : lt)) ||
								(!I.cssVisibility && Wt(lt)) ||
								(!I.detailsElement && Zt(lt))
							)
								return !1;
							if (!I.browsingContext) {
								var Mt = _t(N),
									ce = oe.except(I);
								if (Mt && !ce(Mt)) return !1;
							}
							return !0;
						}
						function jt(m, b) {
							var E = b.querySelector('map[name="' + Je(m) + '"]');
							return E || null;
						}
						function Vt(m) {
							var b = m.getAttribute("usemap");
							if (!b) return null;
							var E = Ln(m);
							return jt(b.slice(1), E);
						}
						function U(m) {
							var b = m.parentElement;
							if (!b.name || b.nodeName.toLowerCase() !== "map") return null;
							var E = Ln(m);
							return (
								E.querySelector('img[usemap="#' + Je(b.name) + '"]') || null
							);
						}
						function xe(m) {
							var b = m.nodeName.toLowerCase();
							return b === "fieldset" && m.disabled;
						}
						function qe(m) {
							var b = m.nodeName.toLowerCase();
							return b === "form" && m.disabled;
						}
						function Ze() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context,
								E = m.except,
								I =
									E === void 0
										? { onlyFocusableBrowsingContext: !1, visible: !1 }
										: E,
								N = Me({
									label: "is/only-tabbable",
									resolveDocument: !0,
									context: b,
								});
							if (!I.visible && !Nn(N)) return !1;
							if (
								!I.onlyFocusableBrowsingContext &&
								(Tt.is.GECKO || Tt.is.TRIDENT || Tt.is.EDGE)
							) {
								var Y = _t(N);
								if (Y && ci(Y) < 0) return !1;
							}
							var lt = N.nodeName.toLowerCase(),
								Pt = ci(N);
							return lt === "label" && Tt.is.GECKO
								? Pt !== null && Pt >= 0
								: !!(
										Tt.is.GECKO &&
										N.ownerSVGElement &&
										!N.focus &&
										lt === "a" &&
										N.hasAttribute("xlink:href") &&
										Tt.is.GECKO
									);
						}
						function je(m) {
							var b = m.nodeName.toLowerCase();
							if (b === "embed" || b === "keygen") return !0;
							var E = ci(m);
							if (m.shadowRoot && E === null) return !0;
							if (b === "label") return !ln.focusLabelTabindex || E === null;
							if (b === "legend") return E === null;
							if (
								ln.focusSvgFocusableAttribute &&
								(m.ownerSVGElement || b === "svg")
							) {
								var I = m.getAttribute("focusable");
								return I && I === "false";
							}
							return b === "img" && m.hasAttribute("usemap")
								? E === null || !ln.focusImgUsemapTabindex
								: b === "area"
									? !vn(m)
									: !1;
						}
						function Ge() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context,
								E = m.except,
								I =
									E === void 0
										? { disabled: !1, visible: !1, onlyTabbable: !1 }
										: E;
							ln || (ln = si());
							var N = Jr.rules.except({
									onlyFocusableBrowsingContext: !0,
									visible: I.visible,
								}),
								Y = Me({
									label: "is/focusable",
									resolveDocument: !0,
									context: b,
								}),
								lt = Vi.rules({ context: Y, except: I });
							if (
								!lt ||
								je(Y) ||
								(!I.disabled && ro(Y)) ||
								(!I.onlyTabbable && N(Y))
							)
								return !1;
							if (!I.visible) {
								var Pt = { context: Y, except: {} };
								if (
									(ln.focusInHiddenIframe && (Pt.except.browsingContext = !0),
									ln.focusObjectSvgHidden)
								) {
									var Mt = Y.nodeName.toLowerCase();
									Mt === "object" && (Pt.except.cssVisibility = !0);
								}
								if (!Nn.rules(Pt)) return !1;
							}
							var ce = _t(Y);
							if (ce) {
								var Xi = ce.nodeName.toLowerCase();
								if (
									!(
										Xi !== "object" ||
										ln.focusInZeroDimensionObject ||
										(ce.offsetWidth && ce.offsetHeight)
									)
								)
									return !1;
							}
							var fn = Y.nodeName.toLowerCase();
							return !(
								fn === "svg" &&
								ln.focusSvgInIframe &&
								!ce &&
								Y.getAttribute("tabindex") === null
							);
						}
						function Ue(m) {
							var b = function (E) {
								return E.shadowRoot || m(E)
									? NodeFilter.FILTER_ACCEPT
									: NodeFilter.FILTER_SKIP;
							};
							return ((b.acceptNode = b), b);
						}
						function ne() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context,
								E = m.includeContext,
								I = m.includeOnlyTabbable,
								N = m.strategy;
							b || (b = document.documentElement);
							for (
								var Y = z.rules.except({ onlyTabbable: I }),
									lt = Ln(b),
									Pt = lt.createTreeWalker(
										b,
										NodeFilter.SHOW_ELEMENT,
										N === "all" ? Z : Ue(Y),
										!1,
									),
									Mt = [];
								Pt.nextNode();
							)
								Pt.currentNode.shadowRoot
									? (Y(Pt.currentNode) && Mt.push(Pt.currentNode),
										(Mt = Mt.concat(
											ne({
												context: Pt.currentNode.shadowRoot,
												includeOnlyTabbable: I,
												strategy: N,
											}),
										)))
									: Mt.push(Pt.currentNode);
							return (
								E &&
									(N === "all"
										? Vi(b) && Mt.unshift(b)
										: Y(b) && Mt.unshift(b)),
								Mt
							);
						}
						function We() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context,
								E = m.includeContext,
								I = m.includeOnlyTabbable,
								N = at(),
								Y = b.querySelectorAll(N),
								lt = z.rules.except({ onlyTabbable: I }),
								Pt = [].filter.call(Y, lt);
							return (E && lt(b) && Pt.unshift(b), Pt);
						}
						function He() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context,
								E = m.except,
								I =
									E === void 0
										? {
												flexbox: !1,
												scrollable: !1,
												shadow: !1,
												visible: !1,
												onlyTabbable: !1,
											}
										: E;
							wt || (wt = si());
							var N = Me({
								label: "is/tabbable",
								resolveDocument: !0,
								context: b,
							});
							if (Tt.is.BLINK && Tt.is.ANDROID && Tt.majorVersion > 42)
								return !1;
							var Y = _t(N);
							if (Y) {
								if (
									(Tt.is.WEBKIT && Tt.is.IOS) ||
									ci(Y) < 0 ||
									(!I.visible && (Tt.is.BLINK || Tt.is.WEBKIT) && !Nn(Y))
								)
									return !1;
								var lt = Y.nodeName.toLowerCase();
								if (lt === "object") {
									var Pt =
										(Tt.name === "Chrome" && Tt.majorVersion >= 54) ||
										(Tt.name === "Opera" && Tt.majorVersion >= 41);
									if (Tt.is.WEBKIT || (Tt.is.BLINK && !Pt)) return !1;
								}
							}
							var Mt = N.nodeName.toLowerCase(),
								ce = ci(N),
								Xi = ce === null ? null : ce >= 0;
							if (
								Tt.is.EDGE &&
								Tt.majorVersion >= 14 &&
								Y &&
								N.ownerSVGElement &&
								0 > ce
							)
								return !0;
							var fn = Xi !== !1,
								ts = ce !== null && ce >= 0;
							if (N.hasAttribute("contenteditable")) return fn;
							if (It.test(Mt) && Xi !== !0) return !1;
							if (Tt.is.WEBKIT && Tt.is.IOS) {
								var uo =
									(Mt === "input" && N.type === "text") ||
									N.type === "password" ||
									Mt === "select" ||
									Mt === "textarea" ||
									N.hasAttribute("contenteditable");
								if (!uo) {
									var Vo = window.getComputedStyle(N, null);
									uo = Dt(Vo);
								}
								if (!uo) return !1;
							}
							if (
								(Mt === "use" &&
									ce !== null &&
									(Tt.is.BLINK || (Tt.is.WEBKIT && Tt.majorVersion === 9))) ||
								(ft(N, "svg a") &&
									N.hasAttribute("xlink:href") &&
									(fn || (N.focus && !wt.focusSvgNegativeTabindexAttribute))) ||
								(Mt === "svg" && wt.focusSvgInIframe && fn)
							)
								return !0;
							if (Tt.is.TRIDENT || Tt.is.EDGE) {
								if (Mt === "svg")
									return wt.focusSvg ? !0 : N.hasAttribute("focusable") || ts;
								if (N.ownerSVGElement)
									return wt.focusSvgTabindexAttribute && ts
										? !0
										: N.hasAttribute("focusable");
							}
							if (N.tabIndex === void 0) return !!I.onlyTabbable;
							if (Mt === "audio") {
								if (!N.hasAttribute("controls")) return !1;
								if (Tt.is.BLINK) return !0;
							}
							if (Mt === "video") {
								if (N.hasAttribute("controls")) {
									if (Tt.is.BLINK || Tt.is.GECKO) return !0;
								} else if (Tt.is.TRIDENT || Tt.is.EDGE) return !1;
							}
							if (
								(Mt === "object" && (Tt.is.BLINK || Tt.is.WEBKIT)) ||
								Mt === "iframe"
							)
								return !1;
							if (!I.scrollable && Tt.is.GECKO) {
								var xl = window.getComputedStyle(N, null);
								if (pt(xl)) return fn;
							}
							if (Tt.is.TRIDENT || Tt.is.EDGE) {
								if (Mt === "area") {
									var Ea = U(N);
									if (Ea && ci(Ea) < 0) return !1;
								}
								var Ca = window.getComputedStyle(N, null);
								if (Dt(Ca)) return N.tabIndex >= 0;
								if (!I.flexbox && Et(Ca))
									return ce !== null ? ts : kt(N) && pe(N);
								if (K(N, Mt)) return !1;
								var gu = N.parentElement;
								if (gu) {
									var lp = gu.nodeName.toLowerCase(),
										hh = window.getComputedStyle(gu, null);
									if (K(gu, Mt, lp, hh)) return !1;
									if (Et(hh)) return ts;
								}
							}
							return N.tabIndex >= 0;
						}
						function di(m, b) {
							return m.compareDocumentPosition(b) &
								Node.DOCUMENT_POSITION_FOLLOWING
								? -1
								: 1;
						}
						function st(m, b) {
							return St(m, function (E) {
								return (
									b.compareDocumentPosition(E) &
									Node.DOCUMENT_POSITION_FOLLOWING
								);
							});
						}
						function ze(m, b, E) {
							var I = [];
							return (
								b.forEach(function (N) {
									var Y = !0,
										lt = m.indexOf(N);
									(lt === -1 && ((lt = st(m, N)), (Y = !1)),
										lt === -1 && (lt = m.length));
									var Pt = xi(E ? E(N) : N);
									Pt.length && I.push({ offset: lt, replace: Y, elements: Pt });
								}),
								I
							);
						}
						function Ji(m, b) {
							var E = 0;
							(b.sort(function (I, N) {
								return I.offset - N.offset;
							}),
								b.forEach(function (I) {
									var N = I.replace ? 1 : 0,
										Y = [I.offset + E, N].concat(I.elements);
									(m.splice.apply(m, Y), (E += I.elements.length - N));
								}));
						}
						function pi(m) {
							var b = m.nodeName.toLowerCase();
							return (
								b === "input" ||
								b === "textarea" ||
								b === "select" ||
								b === "button"
							);
						}
						function Ie(m, b) {
							var E = m.getAttribute("for");
							return E
								? b.getElementById(E)
								: m.querySelector("input, select, textarea");
						}
						function $e(m) {
							var b = m.parentNode,
								E = mt({ context: b, strategy: "strict" });
							return E.filter(pi)[0] || null;
						}
						function re(m, b) {
							var E = $t({ context: b.body, strategy: "strict" });
							if (!E.length) return null;
							var I = Ot({ list: E, elements: [m] }),
								N = I.indexOf(m);
							return N === I.length - 1 ? null : I[N + 1];
						}
						function Di(m, b) {
							if (!Ee.focusRedirectLegend) return null;
							var E = m.parentNode;
							return E.nodeName.toLowerCase() !== "fieldset"
								? null
								: Ee.focusRedirectLegend === "tabbable"
									? re(m, b)
									: $e(m);
						}
						function gt(m) {
							if (!Ee.focusRedirectImgUsemap) return null;
							var b = Vt(m);
							return (b && b.querySelector("area")) || null;
						}
						function Lt(m) {
							var b = Bn({ context: m }),
								E = b.slice(1).map(function (I) {
									return {
										element: I,
										scrollTop: I.scrollTop,
										scrollLeft: I.scrollLeft,
									};
								});
							return function () {
								E.forEach(function (I) {
									((I.element.scrollTop = I.scrollTop),
										(I.element.scrollLeft = I.scrollLeft));
								});
							};
						}
						function Ft(m) {
							if (m.focus) return (m.focus(), kn(m) ? m : null);
							var b = wi(m);
							try {
								return (
									b.HTMLElement.prototype.focus.call(m),
									kn(m) ? m : null
								);
							} catch {
								var E = rt(m);
								return E && kn(m) ? m : null;
							}
						}
						function vt() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.force;
							(b ? (this.instances = 0) : this.instances--,
								this.instances || (this.disengage(), (this._result = null)));
						}
						function Kt() {
							return this.instances
								? (this.instances++, this._result)
								: (this.instances++,
									(this._result = this.engage() || {}),
									(this._result.disengage = vt.bind(this)),
									this._result);
						}
						function Ne() {}
						function bt() {
							if (document.activeElement) {
								if (document.activeElement !== so) {
									var m = new ol("active-element", {
										bubbles: !1,
										cancelable: !1,
										detail: { focus: document.activeElement, blur: so },
									});
									(document.dispatchEvent(m), (so = document.activeElement));
								}
							} else document.body.focus();
							Is !== !1 && (Is = requestAnimationFrame(bt));
						}
						function se() {
							((Is = !0), (so = document.activeElement), bt());
						}
						function ke() {
							(cancelAnimationFrame(Is), (Is = !1));
						}
						function ie() {
							for (var m = [document.activeElement]; m[0] && m[0].shadowRoot; )
								m.unshift(m[0].shadowRoot.activeElement);
							return m;
						}
						function Jt() {
							var m = _a({ context: document.activeElement });
							return [document.activeElement].concat(m);
						}
						function vi() {
							this.context &&
								(this.context.forEach(this.disengage),
								(this.context = null),
								(this.engage = null),
								(this.disengage = null));
						}
						function Ii() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context;
							return (
								(this.context = xi(b || document)),
								this.context.forEach(this.engage),
								{ disengage: vi.bind(this) }
							);
						}
						function En() {}
						function Qt() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.parent,
								E = m.element,
								I = m.includeSelf;
							if (b)
								return function (N) {
									return !!(
										(I && N === b) ||
										b.compareDocumentPosition(N) &
											Node.DOCUMENT_POSITION_CONTAINED_BY
									);
								};
							if (E)
								return function (N) {
									return !!(
										(I && E === N) ||
										N.compareDocumentPosition(E) &
											Node.DOCUMENT_POSITION_CONTAINED_BY
									);
								};
							throw new TypeError(
								"util/compare-position#getParentComparator required either options.parent or options.element",
							);
						}
						function Vn(m) {
							var b = m.context,
								E = m.filter,
								I = function (Mt) {
									var ce = Qt({ parent: Mt });
									return E.some(ce);
								},
								N = [],
								Y = function (Mt) {
									return E.some(function (ce) {
										return Mt === ce;
									})
										? NodeFilter.FILTER_REJECT
										: I(Mt)
											? NodeFilter.FILTER_ACCEPT
											: (N.push(Mt), NodeFilter.FILTER_REJECT);
								};
							Y.acceptNode = Y;
							for (
								var lt = Ln(b),
									Pt = lt.createTreeWalker(b, NodeFilter.SHOW_ELEMENT, Y, !1);
								Pt.nextNode();
							);
							return N;
						}
						function ii() {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = m.context,
								E = Me({
									label: "query/shadow-hosts",
									resolveDocument: !0,
									defaultToDocument: !0,
									context: b,
								}),
								I = Ln(b),
								N = I.createTreeWalker(E, NodeFilter.SHOW_ELEMENT, q, !1),
								Y = [];
							for (
								E.shadowRoot &&
								(Y.push(E), (Y = Y.concat(ii({ context: E.shadowRoot }))));
								N.nextNode();
							)
								(Y.push(N.currentNode),
									(Y = Y.concat(ii({ context: N.currentNode.shadowRoot }))));
							return Y;
						}
						function Pi(m) {
							return Lr(m, !0);
						}
						function Ui(m) {
							return Lr(m, !1);
						}
						function Cn(m) {
							Yr({
								element: m,
								attribute: "aria-hidden",
								temporaryValue: "true",
							});
						}
						function yi(m) {
							Yr({ element: m, attribute: "aria-hidden" });
						}
						function Xe(m, b) {
							var E = m.indexOf(b);
							if (E > 0) {
								var I = m.splice(E, 1);
								return I.concat(m);
							}
							return m;
						}
						function Gn(m, b) {
							return (
								jo.tabsequenceAreaAtImgPosition && (m = zs(m, b)),
								(m = fl(m))
							);
						}
						function te(m) {
							var b = m ? null : !1;
							return { altKey: b, ctrlKey: b, metaKey: b, shiftKey: b };
						}
						function qt(m) {
							var b = m.indexOf("*") !== -1,
								E = te(b);
							return (
								m.forEach(function (I) {
									if (I !== "*") {
										var N = !0,
											Y = I.slice(0, 1);
										(Y === "?" ? (N = null) : Y === "!" && (N = !1),
											N !== !0 && (I = I.slice(1)));
										var lt = Sa[I];
										if (!lt)
											throw new TypeError('Unknown modifier "' + I + '"');
										E[lt] = N;
									}
								}),
								E
							);
						}
						function we(m) {
							var b = jr[m] || parseInt(m, 10);
							if (!b || typeof b != "number" || isNaN(b))
								throw new TypeError('Unknown key "' + m + '"');
							return [b].concat(jr._alias[b] || []);
						}
						function yt(m, b) {
							return !$d.some(function (E) {
								return typeof m[E] == "boolean" && !!b[E] !== m[E];
							});
						}
						function Ut() {
							((ao = 0), ($o = 0));
						}
						function Rt(m) {
							m.isPrimary !== !1 && ao++;
						}
						function zt(m) {
							return m.isPrimary !== !1
								? m.touches
									? void (ao = m.touches.length)
									: void (window.setImmediate || window.setTimeout)(
											function () {
												ao = Math.max(ao - 1, 0);
											},
										)
								: void 0;
						}
						function xt(m) {
							switch (m.keyCode || m.which) {
								case 16:
								case 17:
								case 18:
								case 91:
								case 93:
									return;
							}
							$o++;
						}
						function he(m) {
							switch (m.keyCode || m.which) {
								case 16:
								case 17:
								case 18:
								case 91:
								case 93:
									return;
							}
							(window.setImmediate || window.setTimeout)(function () {
								$o = Math.max($o - 1, 0);
							});
						}
						function Ye() {
							return { pointer: !!ao, key: !!$o };
						}
						function mi() {
							((ao = $o = 0),
								window.removeEventListener("blur", Ut, !1),
								document.documentElement.removeEventListener("keydown", xt, !0),
								document.documentElement.removeEventListener("keyup", he, !0),
								nh.forEach(function (m) {
									document.documentElement.removeEventListener(m, Rt, !0);
								}),
								rh.forEach(function (m) {
									document.documentElement.removeEventListener(m, zt, !0);
								}));
						}
						function Ve() {
							return (
								window.addEventListener("blur", Ut, !1),
								document.documentElement.addEventListener("keydown", xt, !0),
								document.documentElement.addEventListener("keyup", he, !0),
								nh.forEach(function (m) {
									document.documentElement.addEventListener(m, Rt, !0);
								}),
								rh.forEach(function (m) {
									document.documentElement.addEventListener(m, zt, !0);
								}),
								{ get: Ye }
							);
						}
						function Re(m) {
							return m.hasAttribute("autofocus");
						}
						function Ae(m) {
							return m.tabIndex <= 0;
						}
						function Li(m) {
							var b = (m.getAttribute && m.getAttribute("class")) || "";
							return b === "" ? [] : b.split(" ");
						}
						function Le(m, b, E) {
							var I = Li(m),
								N = I.indexOf(b),
								Y = N !== -1,
								lt = E !== void 0 ? E : !Y;
							lt !== Y &&
								(lt || I.splice(N, 1),
								lt && I.push(b),
								m.setAttribute("class", I.join(" ")));
						}
						function ki(m, b) {
							return Le(m, b, !1);
						}
						function $i(m, b) {
							return Le(m, b, !0);
						}
						function Fe(m) {
							var b = "";
							if (m.type === dl || m.type === "shadow-focus") {
								var E = pl.get();
								b =
									pu ||
									(E.pointer && "pointer") ||
									(E.key && "key") ||
									"script";
							} else m.type === "initial" && (b = "initial");
							(document.documentElement.setAttribute("data-focus-source", b),
								m.type !== du &&
									(Ta[b] || $i(document.documentElement, "focus-source-" + b),
									(Ta[b] = !0),
									(gl = b)));
						}
						function ni() {
							return gl;
						}
						function gi(m) {
							return Ta[m];
						}
						function hr(m) {
							pu = m;
						}
						function on() {
							pu = !1;
						}
						function bi() {
							(Fe({ type: du }),
								(gl = pu = null),
								Object.keys(Ta).forEach(function (m) {
									(ki(document.documentElement, "focus-source-" + m),
										(Ta[m] = !1));
								}),
								pl.disengage(),
								ml && ml.disengage(),
								document.removeEventListener("shadow-focus", Fe, !0),
								document.documentElement.removeEventListener(dl, Fe, !0),
								document.documentElement.removeEventListener(du, Fe, !0),
								document.documentElement.removeAttribute("data-focus-source"));
						}
						function ri() {
							return (
								(ml = Bs()),
								document.addEventListener("shadow-focus", Fe, !0),
								document.documentElement.addEventListener(dl, Fe, !0),
								document.documentElement.addEventListener(du, Fe, !0),
								(pl = sh()),
								Fe({ type: "initial" }),
								{ used: gi, current: ni, lock: hr, unlock: on }
							);
						}
						function Fi(m) {
							var b = m || Fo();
							_l.cssShadowPiercingDeepCombinator || (b = b.slice(-1));
							var E = [].slice.call(document.querySelectorAll(vl), 0),
								I = b
									.map(function (N) {
										return Bn({ context: N });
									})
									.reduce(function (N, Y) {
										return Y.concat(N);
									}, []);
							(E.forEach(function (N) {
								I.indexOf(N) === -1 && ki(N, mu);
							}),
								I.forEach(function (N) {
									E.indexOf(N) === -1 && $i(N, mu);
								}));
						}
						function Fr() {
							yl = (window.setImmediate || window.setTimeout)(function () {
								Fi();
							});
						}
						function cs() {
							((window.clearImmediate || window.clearTimeout)(yl), Fi());
						}
						function pn(m) {
							Fi(m.detail.elements);
						}
						function Hi() {
							(bl && bl.disengage(),
								(window.clearImmediate || window.clearTimeout)(yl),
								document.removeEventListener(lh, Fr, !0),
								document.removeEventListener(uh, cs, !0),
								document.removeEventListener("shadow-focus", pn, !0),
								[].forEach.call(document.querySelectorAll(vl), function (m) {
									ki(m, mu);
								}));
						}
						function Er() {
							(_l || ((_l = si()), (vl = Kr("." + mu))),
								(bl = Bs()),
								document.addEventListener(lh, Fr, !0),
								document.addEventListener(uh, cs, !0),
								document.addEventListener("shadow-focus", pn, !0),
								Fi());
						}
						function Xn(m, b) {
							var E = Math.max(m.top, b.top),
								I = Math.max(m.left, b.left),
								N = Math.max(Math.min(m.right, b.right), I),
								Y = Math.max(Math.min(m.bottom, b.bottom), E);
							return {
								top: E,
								right: N,
								bottom: Y,
								left: I,
								width: N - I,
								height: Y - E,
							};
						}
						function mn() {
							var m = window.innerWidth || document.documentElement.clientWidth,
								b = window.innerHeight || document.documentElement.clientHeight;
							return {
								top: 0,
								right: m,
								bottom: b,
								left: 0,
								width: m,
								height: b,
							};
						}
						function ve(m) {
							var b = m.getBoundingClientRect(),
								E = m.offsetWidth - m.clientWidth,
								I = m.offsetHeight - m.clientHeight,
								N = {
									top: b.top,
									left: b.left,
									right: b.right - E,
									bottom: b.bottom - I,
									width: b.width - E,
									height: b.height - I,
									area: 0,
								};
							return ((N.area = N.width * N.height), N);
						}
						function Ke(m) {
							var b = window.getComputedStyle(m, null),
								E = "visible";
							return (
								b.getPropertyValue("overflow-x") !== E &&
								b.getPropertyValue("overflow-y") !== E
							);
						}
						function Bi(m) {
							return Ke(m)
								? m.offsetHeight < m.scrollHeight ||
										m.offsetWidth < m.scrollWidth
								: !1;
						}
						function Pn(m) {
							var b = Bn({ context: m }).slice(1).filter(Bi);
							return b.length
								? b.reduce(function (E, I) {
										var N = ve(I),
											Y = Xn(N, E);
										return ((Y.area = Math.min(N.area, E.area)), Y);
									}, ve(b[0]))
								: null;
						}
						var an = (function () {
								function m(b, E) {
									for (var I = 0; I < E.length; I++) {
										var N = E[I];
										((N.enumerable = N.enumerable || !1),
											(N.configurable = !0),
											"value" in N && (N.writable = !0),
											Object.defineProperty(b, N.key, N));
									}
								}
								return function (b, E, I) {
									return (E && m(b.prototype, E), I && m(b, I), b);
								};
							})(),
							ks =
								typeof Symbol == "function" &&
								typeof Symbol.iterator == "symbol"
									? function (m) {
											return typeof m;
										}
									: function (m) {
											return m &&
												typeof Symbol == "function" &&
												m.constructor === Symbol &&
												m !== Symbol.prototype
												? "symbol"
												: typeof m;
										},
							ue = u(n("platform")),
							Je = u(n("css.escape")),
							xi = function (m) {
								if (!m) return [];
								if (Array.isArray(m)) return m;
								if (m.nodeType !== void 0) return [m];
								if (
									(typeof m == "string" && (m = document.querySelectorAll(m)),
									m.length !== void 0)
								)
									return [].slice.call(m, 0);
								throw new TypeError("unexpected input " + String(m));
							},
							Me = function (m) {
								var b = m.context,
									E = m.label,
									I = E === void 0 ? "context-to-element" : E,
									N = m.resolveDocument,
									Y = m.defaultToDocument,
									lt = xi(b)[0];
								if (
									(N &&
										lt &&
										lt.nodeType === Node.DOCUMENT_NODE &&
										(lt = lt.documentElement),
									!lt && Y)
								)
									return document.documentElement;
								if (!lt)
									throw new TypeError(I + " requires valid options.context");
								if (
									lt.nodeType !== Node.ELEMENT_NODE &&
									lt.nodeType !== Node.DOCUMENT_FRAGMENT_NODE
								)
									throw new TypeError(
										I + " requires options.context to be an Element",
									);
								return lt;
							},
							Ai = function () {
								for (
									var m =
											arguments.length > 0 && arguments[0] !== void 0
												? arguments[0]
												: {},
										b = m.context,
										E = Me({ label: "get/shadow-host", context: b }),
										I = null;
									E;
								)
									((I = E), (E = E.parentNode));
								return I.nodeType === I.DOCUMENT_FRAGMENT_NODE && I.host
									? I.host
									: null;
							},
							Ln = function (m) {
								return m
									? m.nodeType === Node.DOCUMENT_NODE
										? m
										: m.ownerDocument || document
									: document;
							},
							kn = function (m) {
								var b = Me({
										label: "is/active-element",
										resolveDocument: !0,
										context: m,
									}),
									E = Ln(b);
								if (E.activeElement === b) return !0;
								var I = Ai({ context: b });
								return !!(I && I.shadowRoot.activeElement === b);
							},
							wi = function (m) {
								var b = Ln(m);
								return b.defaultView || window;
							},
							ui = function (m) {
								var b = Me({ label: "element/blur", context: m });
								if (!kn(b)) return null;
								var E = b.nodeName.toLowerCase();
								if (E === "body") return null;
								if (b.blur) return (b.blur(), document.activeElement);
								var I = wi(b);
								try {
									I.HTMLElement.prototype.blur.call(b);
								} catch {
									var N = I.document && I.document.body;
									if (!N) return null;
									var Y = N.getAttribute("tabindex");
									(N.setAttribute("tabindex", "-1"),
										N.focus(),
										Y
											? N.setAttribute("tabindex", Y)
											: N.removeAttribute("tabindex"));
								}
								return I.document.activeElement;
							},
							Tt = JSON.parse(JSON.stringify(ue)),
							Cr = Tt.os.family || "",
							hs = Cr === "Android",
							fr = Cr.slice(0, 7) === "Windows",
							An = Cr === "OS X",
							fs = Cr === "iOS",
							Js = Tt.layout === "Blink",
							Pr = Tt.layout === "Gecko",
							Hr = Tt.layout === "Trident",
							ds = Tt.layout === "EdgeHTML",
							ps = Tt.layout === "WebKit",
							Qs = parseFloat(Tt.version),
							Gr = Math.floor(Qs);
						((Tt.majorVersion = Gr),
							(Tt.is = {
								ANDROID: hs,
								WINDOWS: fr,
								OSX: An,
								IOS: fs,
								BLINK: Js,
								GECKO: Pr,
								TRIDENT: Hr,
								EDGE: ds,
								WEBKIT: ps,
								IE9: Hr && Gr === 9,
								IE10: Hr && Gr === 10,
								IE11: Hr && Gr === 11,
							}));
						var Io = function (m) {
								var b = l(),
									E = {};
								return (
									Object.keys(m).map(function (I) {
										E[I] = h(b, m[I]);
									}),
									f(b),
									E
								);
							},
							ee = "1.4.1",
							Mn = (typeof window < "u" && window.navigator.userAgent) || "",
							Be = "ally-supports-cache",
							Yn = v(Be);
						((Yn.userAgent !== Mn || Yn.version !== ee) && (Yn = {}),
							(Yn.userAgent = Mn),
							(Yn.version = ee));
						var ms = {
								get: function () {
									return Yn;
								},
								set: function (m) {
									(Object.keys(m).forEach(function (b) {
										Yn[b] = m[b];
									}),
										(Yn.time = new Date().toISOString()),
										w(Be, Yn));
								},
							},
							As = function () {
								var m = void 0;
								try {
									(document.querySelector("html >>> :first-child"),
										(m = ">>>"));
								} catch {
									try {
										(document.querySelector("html /deep/ :first-child"),
											(m = "/deep/"));
									} catch {
										m = "";
									}
								}
								return m;
							},
							Kn =
								"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
							qr = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML =
											'<map name="image-map-tabindex-test"><area shape="rect" coords="63,19,144,45"></map><img usemap="#image-map-tabindex-test" tabindex="-1" alt="" src="' +
											Kn +
											'">'),
										m.querySelector("area")
									);
								},
							},
							to = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML =
											'<map name="image-map-tabindex-test"><area href="#void" tabindex="-1" shape="rect" coords="63,19,144,45"></map><img usemap="#image-map-tabindex-test" alt="" src="' +
											Kn +
											'">'),
										!1
									);
								},
								validate: function (m, b, E) {
									if (Tt.is.GECKO) return !0;
									var I = m.querySelector("area");
									return (I.focus(), E.activeElement === I);
								},
							},
							gs = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML =
											'<map name="image-map-area-href-test"><area shape="rect" coords="63,19,144,45"></map><img usemap="#image-map-area-href-test" alt="" src="' +
											Kn +
											'">'),
										m.querySelector("area")
									);
								},
								validate: function (m, b, E) {
									return Tt.is.GECKO ? !0 : E.activeElement === b;
								},
							},
							Mi = {
								name: "can-focus-audio-without-controls",
								element: "audio",
								mutate: function (m) {
									try {
										m.setAttribute("src", Kn);
									} catch {}
								},
							},
							dr =
								"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ",
							eo = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML =
											'<map name="broken-image-map-test"><area href="#void" shape="rect" coords="63,19,144,45"></map><img usemap="#broken-image-map-test" alt="" src="' +
											dr +
											'">'),
										m.querySelector("area")
									);
								},
							},
							Ms = {
								element: "div",
								mutate: function (m) {
									return (
										m.setAttribute("tabindex", "-1"),
										m.setAttribute(
											"style",
											"display: -webkit-flex; display: -ms-flexbox; display: flex;",
										),
										(m.innerHTML =
											'<span style="display: block;">hello</span>'),
										m.querySelector("span")
									);
								},
							},
							Bo = {
								element: "fieldset",
								mutate: function (m) {
									(m.setAttribute("tabindex", 0),
										m.setAttribute("disabled", "disabled"));
								},
							},
							io = {
								element: "fieldset",
								mutate: function (m) {
									m.innerHTML = "<legend>legend</legend><p>content</p>";
								},
							},
							_s = {
								element: "span",
								mutate: function (m) {
									(m.setAttribute(
										"style",
										"display: -webkit-flex; display: -ms-flexbox; display: flex;",
									),
										(m.innerHTML =
											'<span style="display: block;">hello</span>'));
								},
							},
							ma = {
								element: "form",
								mutate: function (m) {
									(m.setAttribute("tabindex", 0),
										m.setAttribute("disabled", "disabled"));
								},
							},
							zo = {
								element: "a",
								mutate: function (m) {
									return (
										(m.href = "#void"),
										(m.innerHTML = '<img ismap src="' + Kn + '" alt="">'),
										m.querySelector("img")
									);
								},
							},
							Se = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML =
											'<map name="image-map-tabindex-test"><area href="#void" shape="rect" coords="63,19,144,45"></map><img usemap="#image-map-tabindex-test" tabindex="-1" alt="" src="' +
											Kn +
											'">'),
										m.querySelector("img")
									);
								},
							},
							vs = {
								element: function (m, b) {
									var E = b.createElement("iframe");
									m.appendChild(E);
									var I = E.contentWindow.document;
									return (I.open(), I.close(), E);
								},
								mutate: function (m) {
									m.style.visibility = "hidden";
									var b = m.contentWindow.document,
										E = b.createElement("input");
									return (b.body.appendChild(E), E);
								},
								validate: function (m) {
									var b = m.contentWindow.document,
										E = b.querySelector("input");
									return b.activeElement === E;
								},
							},
							gn = !Tt.is.WEBKIT,
							Wr = function () {
								return gn;
							},
							No = {
								element: "div",
								mutate: function (m) {
									m.setAttribute("tabindex", "invalid-value");
								},
							},
							ga = {
								element: "label",
								mutate: function (m) {
									m.setAttribute("tabindex", "-1");
								},
								validate: function (m, b, E) {
									return (m.offsetHeight, m.focus(), E.activeElement === m);
								},
							},
							Os =
								"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBpZD0ic3ZnIj48dGV4dCB4PSIxMCIgeT0iMjAiIGlkPSJzdmctbGluay10ZXh0Ij50ZXh0PC90ZXh0Pjwvc3ZnPg==",
							o = {
								element: "object",
								mutate: function (m) {
									(m.setAttribute("type", "image/svg+xml"),
										m.setAttribute("data", Os),
										m.setAttribute("width", "200"),
										m.setAttribute("height", "50"),
										(m.style.visibility = "hidden"));
								},
							},
							c = {
								name: "can-focus-object-svg",
								element: "object",
								mutate: function (m) {
									(m.setAttribute("type", "image/svg+xml"),
										m.setAttribute("data", Os),
										m.setAttribute("width", "200"),
										m.setAttribute("height", "50"));
								},
								validate: function (m, b, E) {
									return Tt.is.GECKO ? !0 : E.activeElement === m;
								},
							},
							_ = !Tt.is.IE9,
							y = function () {
								return _;
							},
							S = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML =
											'<map name="focus-redirect-img-usemap"><area href="#void" shape="rect" coords="63,19,144,45"></map><img usemap="#focus-redirect-img-usemap" alt="" src="' +
											Kn +
											'">'),
										m.querySelector("img")
									);
								},
								validate: function (m, b, E) {
									var I = m.querySelector("area");
									return E.activeElement === I;
								},
							},
							T = {
								element: "fieldset",
								mutate: function (m) {
									return (
										(m.innerHTML =
											'<legend>legend</legend><input tabindex="-1"><input tabindex="0">'),
										!1
									);
								},
								validate: function (m, b, E) {
									var I = m.querySelector('input[tabindex="-1"]'),
										N = m.querySelector('input[tabindex="0"]');
									return (
										m.focus(),
										m.querySelector("legend").focus(),
										(E.activeElement === I && "focusable") ||
											(E.activeElement === N && "tabbable") ||
											""
									);
								},
							},
							k = {
								element: "div",
								mutate: function (m) {
									return (
										m.setAttribute(
											"style",
											"width: 100px; height: 50px; overflow: auto;",
										),
										(m.innerHTML =
											'<div style="width: 500px; height: 40px;">scrollable content</div>'),
										m.querySelector("div")
									);
								},
							},
							H = {
								element: "div",
								mutate: function (m) {
									(m.setAttribute("style", "width: 100px; height: 50px;"),
										(m.innerHTML =
											'<div style="width: 500px; height: 40px;">scrollable content</div>'));
								},
							},
							R = {
								element: "div",
								mutate: function (m) {
									(m.setAttribute(
										"style",
										"width: 100px; height: 50px; overflow: auto;",
									),
										(m.innerHTML =
											'<div style="width: 500px; height: 40px;">scrollable content</div>'));
								},
							},
							$ = {
								element: "details",
								mutate: function (m) {
									return (
										(m.innerHTML = "<summary>foo</summary><p>content</p>"),
										m.firstElementChild
									);
								},
							},
							rt = function (m) {
								var b = m.ownerSVGElement || m.nodeName.toLowerCase() === "svg";
								if (!b) return !1;
								var E = A();
								m.appendChild(E);
								var I = E.querySelector("input");
								return (I.focus(), (I.disabled = !0), m.removeChild(E), !0);
							},
							ut = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML = D('<text focusable="true">a</text>')),
										m.querySelector("text")
									);
								},
								validate: O,
							},
							tt = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML = D('<text tabindex="0">a</text>')),
										m.querySelector("text")
									);
								},
								validate: O,
							},
							dt = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML = D('<text tabindex="-1">a</text>')),
										m.querySelector("text")
									);
								},
								validate: O,
							},
							Xt = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML = D(
											[
												'<g id="ally-test-target"><a xlink:href="#void"><text>link</text></a></g>',
												'<use xlink:href="#ally-test-target" x="0" y="0" tabindex="-1" />',
											].join(""),
										)),
										m.querySelector("use")
									);
								},
								validate: O,
							},
							ye = {
								element: "div",
								mutate: function (m) {
									return (
										(m.innerHTML = D(
											'<foreignObject tabindex="-1"><input type="text" /></foreignObject>',
										)),
										m.querySelector("foreignObject") ||
											m.getElementsByTagName("foreignObject")[0]
									);
								},
								validate: O,
							},
							le = !!(
								Tt.is.GECKO &&
								typeof SVGElement < "u" &&
								SVGElement.prototype.focus
							),
							zi = function () {
								return le;
							},
							li = {
								element: "div",
								mutate: function (m) {
									return ((m.innerHTML = D("")), m.firstChild);
								},
								validate: O,
							},
							Jn = {
								element: "div",
								mutate: function (m) {
									m.setAttribute("tabindex", "3x");
								},
							},
							On = {
								element: "table",
								mutate: function (m, b, E) {
									var I = E.createDocumentFragment();
									((I.innerHTML = "<tr><td>cell</td></tr>"), m.appendChild(I));
								},
							},
							me = {
								element: "video",
								mutate: function (m) {
									try {
										m.setAttribute("src", Kn);
									} catch {}
								},
							},
							Qn = Tt.is.GECKO || Tt.is.TRIDENT || Tt.is.EDGE,
							fe = function () {
								return Qn;
							},
							ti = {
								cssShadowPiercingDeepCombinator: As,
								focusInZeroDimensionObject: Wr,
								focusObjectSwf: y,
								focusSvgInIframe: zi,
								tabsequenceAreaAtImgPosition: fe,
							},
							pr = {
								focusAreaImgTabindex: qr,
								focusAreaTabindex: to,
								focusAreaWithoutHref: gs,
								focusAudioWithoutControls: Mi,
								focusBrokenImageMap: eo,
								focusChildrenOfFocusableFlexbox: Ms,
								focusFieldsetDisabled: Bo,
								focusFieldset: io,
								focusFlexboxContainer: _s,
								focusFormDisabled: ma,
								focusImgIsmap: zo,
								focusImgUsemapTabindex: Se,
								focusInHiddenIframe: vs,
								focusInvalidTabindex: No,
								focusLabelTabindex: ga,
								focusObjectSvg: c,
								focusObjectSvgHidden: o,
								focusRedirectImgUsemap: S,
								focusRedirectLegend: T,
								focusScrollBody: k,
								focusScrollContainerWithoutOverflow: H,
								focusScrollContainer: R,
								focusSummary: $,
								focusSvgFocusableAttribute: ut,
								focusSvgTabindexAttribute: tt,
								focusSvgNegativeTabindexAttribute: dt,
								focusSvgUseTabindex: Xt,
								focusSvgForeignobjectTabindex: ye,
								focusSvg: li,
								focusTabindexTrailingCharacters: Jn,
								focusTable: On,
								focusVideoWithoutControls: me,
							},
							Si = null,
							si = function () {
								return (
									Si ||
									((Si = ms.get()),
									Si.time || (ms.set(P()), (Si = ms.get())),
									Si)
								);
							},
							tr = void 0,
							er = /^\s*(-|\+)?[0-9]+\s*$/,
							ir = /^\s*(-|\+)?[0-9]+.*$/,
							un = function (m) {
								tr || (tr = si());
								var b = tr.focusTabindexTrailingCharacters ? ir : er,
									E = Me({
										label: "is/valid-tabindex",
										resolveDocument: !0,
										context: m,
									}),
									I = E.hasAttribute("tabindex"),
									N = E.hasAttribute("tabIndex");
								if (!I && !N) return !1;
								var Y = E.ownerSVGElement || E.nodeName.toLowerCase() === "svg";
								if (Y && !tr.focusSvgTabindexAttribute) return !1;
								if (tr.focusInvalidTabindex) return !0;
								var lt = E.getAttribute(I ? "tabindex" : "tabIndex");
								return lt === "-32768" ? !1 : !!(lt && b.test(lt));
							},
							ci = function (m) {
								if (!un(m)) return null;
								var b = m.hasAttribute("tabindex"),
									E = b ? "tabindex" : "tabIndex",
									I = parseInt(m.getAttribute(E), 10);
								return isNaN(I) ? -1 : I;
							},
							Xr = void 0,
							Dn = void 0,
							In = {
								input: !0,
								select: !0,
								textarea: !0,
								button: !0,
								fieldset: !0,
								form: !0,
							},
							_n = function (m) {
								Xr ||
									((Xr = si()),
									Xr.focusFieldsetDisabled && delete In.fieldset,
									Xr.focusFormDisabled && delete In.form,
									(Dn = new RegExp("^(" + Object.keys(In).join("|") + ")$")));
								var b = Me({
										label: "is/native-disabled-supported",
										context: m,
									}),
									E = b.nodeName.toLowerCase();
								return !!Dn.test(E);
							},
							Zr = function (m) {
								var b = m.element,
									E = m.attribute,
									I = "data-cached-" + E,
									N = b.getAttribute(I);
								if (N === null) {
									var Y = b.getAttribute(E);
									if (Y === null) return;
									(b.setAttribute(I, Y || ""), b.removeAttribute(E));
								} else {
									var lt = b.getAttribute(I);
									(b.removeAttribute(I), b.setAttribute(E, lt));
								}
							},
							Yr = function (m) {
								var b = m.element,
									E = m.attribute,
									I = m.temporaryValue,
									N = m.saveValue,
									Y = "data-cached-" + E;
								if (I !== void 0) {
									var lt = N || b.getAttribute(E);
									(b.setAttribute(Y, lt || ""), b.setAttribute(E, I));
								} else {
									var Pt = b.getAttribute(Y);
									(b.removeAttribute(Y),
										Pt === "" ? b.removeAttribute(E) : b.setAttribute(E, Pt));
								}
							},
							ae = function () {},
							Ds = { log: ae, debug: ae, info: ae, warn: ae, error: ae },
							qi = typeof console < "u" ? console : Ds,
							mr = void 0,
							Lr = function (m, b) {
								mr || (mr = si());
								var E = Me({ label: "element/disabled", context: m });
								b = !!b;
								var I = E.hasAttribute("data-ally-disabled"),
									N = arguments.length === 1;
								return _n(E)
									? N
										? E.disabled
										: ((E.disabled = b), E)
									: N
										? I
										: (I === b || ct(E, b), E);
							},
							Bn = function () {
								for (
									var m =
											arguments.length > 0 && arguments[0] !== void 0
												? arguments[0]
												: {},
										b = m.context,
										E = [],
										I = Me({ label: "get/parents", context: b });
									I;
								)
									(E.push(I),
										(I = I.parentNode),
										I && I.nodeType !== Node.ELEMENT_NODE && (I = null));
								return E;
							},
							ys = [
								"matches",
								"webkitMatchesSelector",
								"mozMatchesSelector",
								"msMatchesSelector",
							],
							gr = null,
							be = void 0;
						Nt.except = function () {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = function (E) {
									return Nt({ context: E, except: m });
								};
							return ((b.rules = Nt), b);
						};
						var Vi = Nt.except({}),
							Ro = function (m) {
								try {
									return (
										m.contentDocument ||
										(m.contentWindow && m.contentWindow.document) ||
										(m.getSVGDocument && m.getSVGDocument()) ||
										null
									);
								} catch {
									return null;
								}
							},
							zn = void 0,
							Kr = function (m) {
								if (typeof zn != "string") {
									var b = As();
									b && (zn = ", html " + b + " ");
								}
								return zn
									? m +
											zn +
											m
												.replace(/\s*,\s*/g, ",")
												.split(",")
												.join(zn)
									: m;
							},
							Qi = void 0,
							no = /^(area)$/;
						oe.except = function () {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = function (E) {
									return oe({ context: E, except: m });
								};
							return ((b.rules = oe), b);
						};
						var Nn = oe.except({}),
							nr = void 0,
							vn = function (m) {
								nr || (nr = si());
								var b = Me({ label: "is/valid-area", context: m }),
									E = b.nodeName.toLowerCase();
								if (E !== "area") return !1;
								var I = b.hasAttribute("tabindex");
								if (!nr.focusAreaTabindex && I) return !1;
								var N = U(b);
								if (
									!N ||
									!Nn(N) ||
									(!nr.focusBrokenImageMap &&
										(!N.complete ||
											!N.naturalHeight ||
											N.offsetWidth <= 0 ||
											N.offsetHeight <= 0))
								)
									return !1;
								if (!nr.focusAreaWithoutHref && !b.href)
									return (
										(nr.focusAreaTabindex && I) ||
										(nr.focusAreaImgTabindex && N.hasAttribute("tabindex"))
									);
								var Y = Bn({ context: N })
									.slice(1)
									.some(function (lt) {
										var Pt = lt.nodeName.toLowerCase();
										return Pt === "button" || Pt === "a";
									});
								return !Y;
							},
							kr = void 0,
							ro = function (m) {
								kr || (kr = si());
								var b = Me({ label: "is/disabled", context: m });
								if (b.hasAttribute("data-ally-disabled")) return !0;
								if (!_n(b)) return !1;
								if (b.disabled) return !0;
								var E = Bn({ context: b });
								return E.some(xe)
									? !0
									: !!(!kr.focusFormDisabled && E.some(qe));
							};
						Ze.except = function () {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = function (E) {
									return Ze({ context: E, except: m });
								};
							return ((b.rules = Ze), b);
						};
						var Jr = Ze.except({}),
							ln = void 0;
						Ge.except = function () {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = function (E) {
									return Ge({ context: E, except: m });
								};
							return ((b.rules = Ge), b);
						};
						var z = Ge.except({}),
							Z = Ue(Vi),
							X = void 0,
							et = void 0,
							at = function () {
								return (
									X || (X = si()),
									typeof et == "string"
										? et
										: ((et =
												(X.focusTable ? "table, td," : "") +
												(X.focusFieldset ? "fieldset," : "") +
												"svg a,a[href],area[href],input, select, textarea, button,iframe, object, embed,keygen," +
												(X.focusAudioWithoutControls
													? "audio,"
													: "audio[controls],") +
												(X.focusVideoWithoutControls
													? "video,"
													: "video[controls],") +
												(X.focusSummary ? "summary," : "") +
												"[tabindex],[contenteditable]"),
											(et = Kr(et)))
								);
							},
							mt = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = m.includeContext,
									I = m.includeOnlyTabbable,
									N = m.strategy,
									Y = N === void 0 ? "quick" : N,
									lt = Me({
										label: "query/focusable",
										resolveDocument: !0,
										defaultToDocument: !0,
										context: b,
									}),
									Pt = {
										context: lt,
										includeContext: E,
										includeOnlyTabbable: I,
										strategy: Y,
									};
								if (Y === "quick") return We(Pt);
								if (Y === "strict" || Y === "all") return ne(Pt);
								throw new TypeError(
									'query/focusable requires option.strategy to be one of ["quick", "strict", "all"]',
								);
							},
							wt = void 0,
							It = /^(fieldset|table|td|body)$/;
						He.except = function () {
							var m =
									arguments.length > 0 && arguments[0] !== void 0
										? arguments[0]
										: {},
								b = function (E) {
									return He({ context: E, except: m });
								};
							return ((b.rules = He), b);
						};
						var kt = Vi.rules.except({ flexbox: !0 }),
							pe = He.except({ flexbox: !0 }),
							Gt = He.except({}),
							$t = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = m.includeContext,
									I = m.includeOnlyTabbable,
									N = m.strategy,
									Y = Gt.rules.except({ onlyTabbable: I });
								return mt({
									context: b,
									includeContext: E,
									includeOnlyTabbable: I,
									strategy: N,
								}).filter(Y);
							},
							ge = function (m) {
								return m.sort(di);
							},
							Ot = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.list,
									E = m.elements,
									I = m.resolveElement,
									N = b.slice(0),
									Y = xi(E).slice(0);
								ge(Y);
								var lt = ze(N, Y, I);
								return (Ji(N, lt), N);
							},
							Ee = void 0,
							Gi = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = m.skipFocusable;
								Ee || (Ee = si());
								var I = Me({ label: "get/focus-redirect-target", context: b });
								if (!E && z(I)) return null;
								var N = I.nodeName.toLowerCase(),
									Y = Ln(I);
								return N === "label"
									? Ie(I, Y)
									: N === "legend"
										? Di(I, Y)
										: N === "img"
											? gt(I)
											: null;
							},
							Qe = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = m.except,
									I = Me({ label: "get/focus-target", context: b }),
									N = null,
									Y = function (lt) {
										var Pt = z.rules({ context: lt, except: E });
										return Pt
											? ((N = lt), !0)
											: ((N = Gi({ context: lt, skipFocusable: !0 })), !!N);
									};
								return (Y(I) || Bn({ context: I }).slice(1).some(Y), N);
							},
							cn = { flexbox: !0, scrollable: !0, onlyTabbable: !0 },
							Rn = function (m) {
								var b =
										arguments.length > 1 && arguments[1] !== void 0
											? arguments[1]
											: {},
									E = b.defaultToAncestor,
									I = b.undoScrolling,
									N = Me({ label: "element/focus", context: m }),
									Y = z.rules({ context: N, except: cn });
								if (!E && !Y) return null;
								var lt = Qe({ context: N, except: cn });
								if (!lt) return null;
								if (kn(lt)) return lt;
								var Pt = void 0;
								I && (Pt = Lt(lt));
								var Mt = Ft(lt);
								return (Pt && Pt(), Mt);
							},
							Qr = { blur: ui, disabled: Lr, focus: Rn };
						typeof window < "u" &&
							(function () {
								for (
									var m = 0,
										b = ["ms", "moz", "webkit", "o"],
										E = "",
										I = "",
										N = 0,
										Y = b.length;
									Y > N;
									++N
								)
									((E = window[b[N] + "RequestAnimationFrame"]),
										(I =
											window[b[N] + "CancelAnimationFrame"] ||
											window[b[N] + "CancelRequestAnimationFrame"]));
								(typeof window.requestAnimationFrame != "function" &&
									(window.requestAnimationFrame =
										window[E] ||
										function (lt) {
											var Pt = new Date().getTime(),
												Mt = Math.max(0, 16 - (Pt - m)),
												ce = window.setTimeout(function () {
													lt(Pt + Mt);
												}, Mt);
											return ((m = Pt + Mt), ce);
										}),
									typeof window.cancelAnimationFrame != "function" &&
										(window.cancelAnimationFrame =
											window[I] ||
											function (lt) {
												clearTimeout(lt);
											}));
							})();
						var oi =
							(typeof window < "u" && window.CustomEvent) || function () {};
						typeof oi != "function" &&
							((oi = function (m, b) {
								var E = document.createEvent("CustomEvent");
								return (
									!b && (b = { bubbles: !1, cancelable: !1, detail: void 0 }),
									E.initCustomEvent(m, b.bubbles, b.cancelable, b.detail),
									E
								);
							}),
							(oi.prototype = window.Event.prototype));
						var ol = oi,
							Ar = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.engage,
									E = m.disengage,
									I = {
										engage: b || Ne,
										disengage: E || Ne,
										instances: 0,
										_result: null,
									};
								return Kt.bind(I);
							},
							so = void 0,
							Is = void 0,
							al = Ar({ engage: se, disengage: ke }),
							Mr = function (m) {
								var b = Me({
									label: "is/shadowed",
									resolveDocument: !0,
									context: m,
								});
								return !!Ai({ context: b });
							},
							_a = function () {
								for (
									var m =
											arguments.length > 0 && arguments[0] !== void 0
												? arguments[0]
												: {},
										b = m.context,
										E = [],
										I = Me({ label: "get/shadow-host-parents", context: b });
									I && (I = Ai({ context: I }));
								)
									E.push(I);
								return E;
							},
							Fo = function () {
								return (
									document.activeElement === null && document.body.focus(),
									Mr(document.activeElement) ? Jt() : ie()
								);
							},
							bs = void 0,
							va = void 0;
						typeof document < "u" && document.documentElement.createShadowRoot
							? (function () {
									var m = void 0,
										b = void 0,
										E = function () {
											(N(),
												(window.clearImmediate || window.clearTimeout)(m),
												(m = (window.setImmediate || window.setTimeout)(
													function () {
														Y();
													},
												)));
										},
										I = function (Pt) {
											(Pt.addEventListener("blur", E, !0), (b = Pt));
										},
										N = function () {
											(b && b.removeEventListener("blur", E, !0), (b = null));
										},
										Y = function () {
											var Pt = Fo();
											if (Pt.length === 1) return void N();
											I(Pt[0]);
											var Mt = new CustomEvent("shadow-focus", {
												bubbles: !1,
												cancelable: !1,
												detail: {
													elements: Pt,
													active: Pt[0],
													hosts: Pt.slice(1),
												},
											});
											document.dispatchEvent(Mt);
										},
										lt = function () {
											((window.clearImmediate || window.clearTimeout)(m), Y());
										};
									((bs = function () {
										document.addEventListener("focus", lt, !0);
									}),
										(va = function () {
											((window.clearImmediate || window.clearTimeout)(m),
												b && b.removeEventListener("blur", E, !0),
												document.removeEventListener("focus", lt, !0));
										}));
								})()
							: (bs = va = function () {});
						var Bs = Ar({ engage: bs, disengage: va }),
							oo = { activeElement: al, shadowFocus: Bs },
							Ho = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.engage,
									E = m.disengage,
									I = { engage: b || En, disengage: E || En, context: null };
								return Ii.bind(I);
							},
							qo = void 0,
							ou = void 0,
							au = Tt.is.TRIDENT && (Tt.is.IE10 || Tt.is.IE11);
						au
							? (function () {
									var m = function (b) {
										var E = Qe({
											context: b.target,
											except: { flexbox: !0, scrollable: !0 },
										});
										if (E && E !== b.target) {
											window.setImmediate(function () {
												E.focus();
											});
											var I = [].map.call(E.children, function (N) {
												var Y = N.style.visibility || "",
													lt = N.style.transition || "";
												return (
													(N.style.visibility = "hidden"),
													(N.style.transition = "none"),
													[N, Y, lt]
												);
											});
											window.setImmediate(function () {
												I.forEach(function (N) {
													((N[0].style.visibility = N[1]),
														(N[0].style.transition = N[2]));
												});
											});
										}
									};
									((qo = function (b) {
										b.addEventListener("mousedown", m, !0);
									}),
										(ou = function (b) {
											b.removeEventListener("mousedown", m, !0);
										}));
								})()
							: (qo = function () {});
						var uu = Ho({ engage: qo, disengage: ou }),
							Wo = void 0,
							ya = void 0,
							lu = Tt.is.OSX && (Tt.is.GECKO || Tt.is.WEBKIT);
						lu
							? (function () {
									var m = function (E) {
											if (
												!E.defaultPrevented &&
												ft(E.target, "input, button, button *")
											) {
												var I = Qe({ context: E.target });
												(window.setImmediate || window.setTimeout)(function () {
													I.focus();
												});
											}
										},
										b = function (E) {
											if (
												!E.defaultPrevented &&
												ft(E.target, "label, label *")
											) {
												var I = Qe({ context: E.target });
												I && I.focus();
											}
										};
									((Wo = function (E) {
										(E.addEventListener("mousedown", m, !1),
											E.addEventListener("mouseup", b, !1));
									}),
										(ya = function (E) {
											(E.removeEventListener("mousedown", m, !1),
												E.removeEventListener("mouseup", b, !1));
										}));
								})()
							: (Wo = function () {});
						var ul = Ho({ engage: Wo, disengage: ya }),
							Zo = void 0,
							ba = void 0,
							ll = Tt.is.WEBKIT;
						ll
							? (function () {
									var m = function (b) {
										var E = Qe({ context: b.target });
										!E ||
											(E.hasAttribute("tabindex") && un(E)) ||
											(E.setAttribute("tabindex", 0),
											(window.setImmediate || window.setTimeout)(function () {
												E.removeAttribute("tabindex");
											}, 0));
									};
									((Zo = function (b) {
										(b.addEventListener("mousedown", m, !0),
											b.addEventListener("touchstart", m, !0));
									}),
										(ba = function (b) {
											(b.removeEventListener("mousedown", m, !0),
												b.removeEventListener("touchstart", m, !0));
										}));
								})()
							: (Zo = function () {});
						var t = Ho({ engage: Zo, disengage: ba }),
							i = {
								pointerFocusChildren: uu,
								pointerFocusInput: ul,
								pointerFocusParent: t,
							},
							a = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = Ln(b),
									I = void 0;
								try {
									I = E.activeElement;
								} catch {}
								return (
									(I && I.nodeType) || (I = E.body || E.documentElement),
									I
								);
							},
							d = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = m.filter;
								if (
									((b = Me({
										label: "get/insignificant-branches",
										defaultToDocument: !0,
										context: b,
									})),
									(E = xi(E)),
									!E.length)
								)
									throw new TypeError(
										"get/insignificant-branches requires valid options.filter",
									);
								return Vn({ context: b, filter: E });
							},
							x = {
								activeElement: a,
								activeElements: Fo,
								focusRedirectTarget: Gi,
								focusTarget: Qe,
								insignificantBranches: d,
								parents: Bn,
								shadowHostParents: _a,
								shadowHost: Ai,
							},
							M = {
								activeElement: kn,
								disabled: ro,
								focusRelevant: Vi,
								focusable: z,
								onlyTabbable: Jr,
								shadowed: Mr,
								tabbable: Gt,
								validArea: vn,
								validTabindex: un,
								visible: Nn,
							},
							q = function (m) {
								return m.shadowRoot
									? NodeFilter.FILTER_ACCEPT
									: NodeFilter.FILTER_SKIP;
							};
						q.acceptNode = q;
						for (
							var J = { childList: !0, subtree: !0 },
								nt = (function () {
									function m() {
										var b = this,
											E =
												arguments.length > 0 && arguments[0] !== void 0
													? arguments[0]
													: {},
											I = E.context,
											N = E.callback,
											Y = E.config;
										(s(this, m),
											(this.config = Y),
											(this.disengage = this.disengage.bind(this)),
											(this.clientObserver = new MutationObserver(N)),
											(this.hostObserver = new MutationObserver(function (lt) {
												return lt.forEach(b.handleHostMutation, b);
											})),
											this.observeContext(I),
											this.observeShadowHosts(I));
									}
									return (
										an(m, [
											{
												key: "disengage",
												value: function () {
													(this.clientObserver &&
														this.clientObserver.disconnect(),
														(this.clientObserver = null),
														this.hostObserver && this.hostObserver.disconnect(),
														(this.hostObserver = null));
												},
											},
											{
												key: "observeShadowHosts",
												value: function (b) {
													var E = this,
														I = ii({ context: b });
													I.forEach(function (N) {
														return E.observeContext(N.shadowRoot);
													});
												},
											},
											{
												key: "observeContext",
												value: function (b) {
													(this.clientObserver.observe(b, this.config),
														this.hostObserver.observe(b, J));
												},
											},
											{
												key: "handleHostMutation",
												value: function (b) {
													if (b.type === "childList") {
														var E = xi(b.addedNodes).filter(function (I) {
															return I.nodeType === Node.ELEMENT_NODE;
														});
														E.forEach(this.observeShadowHosts, this);
													}
												},
											},
										]),
										m
									);
								})(),
								ht = function () {
									var m =
											arguments.length > 0 && arguments[0] !== void 0
												? arguments[0]
												: {},
										b = m.context,
										E = m.callback,
										I = m.config;
									if (typeof E != "function")
										throw new TypeError(
											"observe/shadow-mutations requires options.callback to be a function",
										);
									if ((typeof I > "u" ? "undefined" : ks(I)) !== "object")
										throw new TypeError(
											"observe/shadow-mutations requires options.config to be an object",
										);
									if (!window.MutationObserver)
										return { disengage: function () {} };
									var N = Me({
											label: "observe/shadow-mutations",
											resolveDocument: !0,
											defaultToDocument: !0,
											context: b,
										}),
										Y = new nt({ context: N, callback: E, config: I });
									return { disengage: Y.disengage };
								},
								At = {
									attributes: !0,
									childList: !0,
									subtree: !0,
									attributeFilter: [
										"tabindex",
										"disabled",
										"data-ally-disabled",
									],
								},
								Yt = (function () {
									function m() {
										var b = this,
											E =
												arguments.length > 0 && arguments[0] !== void 0
													? arguments[0]
													: {},
											I = E.context,
											N = E.filter;
										(s(this, m),
											(this._context = xi(I || document.documentElement)[0]),
											(this._filter = xi(N)),
											(this._inertElementCache = []),
											(this.disengage = this.disengage.bind(this)),
											(this.handleMutation = this.handleMutation.bind(this)),
											(this.renderInert = this.renderInert.bind(this)),
											(this.filterElements = this.filterElements.bind(this)),
											(this.filterParentElements =
												this.filterParentElements.bind(this)));
										var Y = mt({
											context: this._context,
											includeContext: !0,
											strategy: "all",
										});
										(this.renderInert(Y),
											(this.shadowObserver = ht({
												context: this._context,
												config: At,
												callback: function (lt) {
													return lt.forEach(b.handleMutation);
												},
											})));
									}
									return (
										an(m, [
											{
												key: "disengage",
												value: function () {
													this._context &&
														(Ui(this._context),
														this._inertElementCache.forEach(function (b) {
															return Ui(b);
														}),
														(this._inertElementCache = null),
														(this._filter = null),
														(this._context = null),
														this.shadowObserver &&
															this.shadowObserver.disengage(),
														(this.shadowObserver = null));
												},
											},
											{
												key: "listQueryFocusable",
												value: function (b) {
													return b
														.map(function (E) {
															return mt({
																context: E,
																includeContext: !0,
																strategy: "all",
															});
														})
														.reduce(function (E, I) {
															return E.concat(I);
														}, []);
												},
											},
											{
												key: "renderInert",
												value: function (b) {
													var E = this,
														I = function (N) {
															(E._inertElementCache.push(N), Pi(N));
														};
													b.filter(this.filterElements)
														.filter(this.filterParentElements)
														.filter(function (N) {
															return !Lr(N);
														})
														.forEach(I);
												},
											},
											{
												key: "filterElements",
												value: function (b) {
													var E = Qt({ element: b, includeSelf: !0 });
													return !this._filter.some(E);
												},
											},
											{
												key: "filterParentElements",
												value: function (b) {
													var E = Qt({ parent: b });
													return !this._filter.some(E);
												},
											},
											{
												key: "handleMutation",
												value: function (b) {
													if (b.type === "childList") {
														var E = xi(b.addedNodes).filter(function (N) {
															return N.nodeType === Node.ELEMENT_NODE;
														});
														if (!E.length) return;
														var I = this.listQueryFocusable(E);
														this.renderInert(I);
													} else
														b.type === "attributes" &&
															this.renderInert([b.target]);
												},
											},
										]),
										m
									);
								})(),
								_e = function () {
									var m =
											arguments.length > 0 && arguments[0] !== void 0
												? arguments[0]
												: {},
										b = m.context,
										E = m.filter,
										I = new Yt({ context: b, filter: E });
									return { disengage: I.disengage };
								},
								hn = { attributes: !1, childList: !0, subtree: !0 },
								Wi = (function () {
									function m() {
										var b =
												arguments.length > 0 && arguments[0] !== void 0
													? arguments[0]
													: {},
											E = b.context,
											I = b.filter;
										(s(this, m),
											(this._context = xi(E || document.documentElement)[0]),
											(this._filter = xi(I)),
											(this.disengage = this.disengage.bind(this)),
											(this.handleMutation = this.handleMutation.bind(this)),
											(this.isInsignificantBranch =
												this.isInsignificantBranch.bind(this)));
										var N = d({ context: this._context, filter: this._filter });
										(N.forEach(Cn), this.startObserver());
									}
									return (
										an(m, [
											{
												key: "disengage",
												value: function () {
													this._context &&
														([].forEach.call(
															this._context.querySelectorAll(
																"[data-cached-aria-hidden]",
															),
															yi,
														),
														(this._context = null),
														(this._filter = null),
														this._observer && this._observer.disconnect(),
														(this._observer = null));
												},
											},
											{
												key: "startObserver",
												value: function () {
													var b = this;
													window.MutationObserver &&
														((this._observer = new MutationObserver(function (
															E,
														) {
															return E.forEach(b.handleMutation);
														})),
														this._observer.observe(this._context, hn));
												},
											},
											{
												key: "handleMutation",
												value: function (b) {
													b.type === "childList" &&
														xi(b.addedNodes)
															.filter(function (E) {
																return E.nodeType === Node.ELEMENT_NODE;
															})
															.filter(this.isInsignificantBranch)
															.forEach(Cn);
												},
											},
											{
												key: "isInsignificantBranch",
												value: function (b) {
													var E = Bn({ context: b });
													if (
														E.some(function (N) {
															return N.getAttribute("aria-hidden") === "true";
														})
													)
														return !1;
													var I = Qt({ element: b });
													return !this._filter.some(I);
												},
											},
										]),
										m
									);
								})(),
								rr = function () {
									var m =
											arguments.length > 0 && arguments[0] !== void 0
												? arguments[0]
												: {},
										b = m.context,
										E = m.filter,
										I = new Wi({ context: b, filter: E });
									return { disengage: I.disengage };
								},
								yn = (function () {
									function m(b) {
										(s(this, m), (this._document = Ln(b)), (this.maps = {}));
									}
									return (
										an(m, [
											{
												key: "getAreasFor",
												value: function (b) {
													return (
														this.maps[b] || this.addMapByName(b),
														this.maps[b]
													);
												},
											},
											{
												key: "addMapByName",
												value: function (b) {
													var E = jt(b, this._document);
													E && (this.maps[E.name] = $t({ context: E }));
												},
											},
											{
												key: "extractAreasFromList",
												value: function (b) {
													return b.filter(function (E) {
														var I = E.nodeName.toLowerCase();
														if (I !== "area") return !0;
														var N = E.parentNode;
														return (
															this.maps[N.name] || (this.maps[N.name] = []),
															this.maps[N.name].push(E),
															!1
														);
													}, this);
												},
											},
										]),
										m
									);
								})(),
								zs = function (m, b) {
									var E = b.querySelectorAll("img[usemap]"),
										I = new yn(b),
										N = I.extractAreasFromList(m);
									return E.length
										? Ot({
												list: N,
												elements: E,
												resolveElement: function (Y) {
													var lt = Y.getAttribute("usemap").slice(1);
													return I.getAreasFor(lt);
												},
											})
										: N;
								},
								cl = (function () {
									function m(b, E) {
										(s(this, m),
											(this.context = b),
											(this.sortElements = E),
											(this.hostCounter = 1),
											(this.inHost = {}),
											(this.inDocument = []),
											(this.hosts = {}),
											(this.elements = {}));
									}
									return (
										an(m, [
											{
												key: "_registerHost",
												value: function (b) {
													if (!b._sortingId) {
														((b._sortingId = "shadow-" + this.hostCounter++),
															(this.hosts[b._sortingId] = b));
														var E = Ai({ context: b });
														E
															? (this._registerHost(E),
																this._registerHostParent(b, E))
															: this.inDocument.push(b);
													}
												},
											},
											{
												key: "_registerHostParent",
												value: function (b, E) {
													(this.inHost[E._sortingId] ||
														(this.inHost[E._sortingId] = []),
														this.inHost[E._sortingId].push(b));
												},
											},
											{
												key: "_registerElement",
												value: function (b, E) {
													(this.elements[E._sortingId] ||
														(this.elements[E._sortingId] = []),
														this.elements[E._sortingId].push(b));
												},
											},
											{
												key: "extractElements",
												value: function (b) {
													return b.filter(function (E) {
														var I = Ai({ context: E });
														return I
															? (this._registerHost(I),
																this._registerElement(E, I),
																!1)
															: !0;
													}, this);
												},
											},
											{
												key: "sort",
												value: function (b) {
													var E = this._injectHosts(b);
													return (
														(E = this._replaceHosts(E)),
														this._cleanup(),
														E
													);
												},
											},
											{
												key: "_injectHosts",
												value: function (b) {
													return (
														Object.keys(this.hosts).forEach(function (E) {
															var I = this.elements[E],
																N = this.inHost[E],
																Y = this.hosts[E].shadowRoot;
															this.elements[E] = this._merge(I, N, Y);
														}, this),
														this._merge(b, this.inDocument, this.context)
													);
												},
											},
											{
												key: "_merge",
												value: function (b, E, I) {
													var N = Ot({ list: b, elements: E });
													return this.sortElements(N, I);
												},
											},
											{
												key: "_replaceHosts",
												value: function (b) {
													return Ot({
														list: b,
														elements: this.inDocument,
														resolveElement: this._resolveHostElement.bind(this),
													});
												},
											},
											{
												key: "_resolveHostElement",
												value: function (b) {
													var E = Ot({
															list: this.elements[b._sortingId],
															elements: this.inHost[b._sortingId],
															resolveElement:
																this._resolveHostElement.bind(this),
														}),
														I = ci(b);
													return I !== null && I > -1 ? [b].concat(E) : E;
												},
											},
											{
												key: "_cleanup",
												value: function () {
													Object.keys(this.hosts).forEach(function (b) {
														delete this.hosts[b]._sortingId;
													}, this);
												},
											},
										]),
										m
									);
								})(),
								hl = function (m, b, E) {
									var I = new cl(b, E),
										N = I.extractElements(m);
									return N.length === m.length ? E(m) : I.sort(N);
								},
								fl = function (m) {
									var b = {},
										E = [],
										I = m.filter(function (Y) {
											var lt = Y.tabIndex;
											return (
												lt === void 0 && (lt = ci(Y)),
												0 >= lt || lt === null || lt === void 0
													? !0
													: (b[lt] || ((b[lt] = []), E.push(lt)),
														b[lt].push(Y),
														!1)
											);
										}),
										N = E.sort()
											.map(function (Y) {
												return b[Y];
											})
											.reduceRight(function (Y, lt) {
												return lt.concat(Y);
											}, I);
									return N;
								},
								jo = void 0,
								xa = function () {
									var m =
											arguments.length > 0 && arguments[0] !== void 0
												? arguments[0]
												: {},
										b = m.context,
										E = m.includeContext,
										I = m.includeOnlyTabbable,
										N = m.strategy;
									jo || (jo = si());
									var Y = xi(b)[0] || document.documentElement,
										lt = $t({
											context: Y,
											includeContext: E,
											includeOnlyTabbable: I,
											strategy: N,
										});
									return (
										(lt =
											document.body.createShadowRoot && Tt.is.BLINK
												? hl(lt, Y, Gn)
												: Gn(lt, Y)),
										E && (lt = Xe(lt, Y)),
										lt
									);
								},
								jr = {
									tab: 9,
									left: 37,
									up: 38,
									right: 39,
									down: 40,
									pageUp: 33,
									"page-up": 33,
									pageDown: 34,
									"page-down": 34,
									end: 35,
									home: 36,
									enter: 13,
									escape: 27,
									space: 32,
									shift: 16,
									capsLock: 20,
									"caps-lock": 20,
									ctrl: 17,
									alt: 18,
									meta: 91,
									pause: 19,
									insert: 45,
									delete: 46,
									backspace: 8,
									_alias: { 91: [92, 93, 224] },
								},
								hi = 1;
							26 > hi;
							hi++
						)
							jr["f" + hi] = hi + 111;
						for (var Ur = 0; 10 > Ur; Ur++) {
							var cu = Ur + 48,
								hu = Ur + 96;
							((jr[Ur] = cu), (jr["num-" + Ur] = hu), (jr._alias[cu] = [hu]));
						}
						for (var wa = 0; 26 > wa; wa++) {
							var Uo = wa + 65,
								fu = String.fromCharCode(Uo).toLowerCase();
							jr[fu] = Uo;
						}
						var Sa = {
								alt: "altKey",
								ctrl: "ctrlKey",
								meta: "metaKey",
								shift: "shiftKey",
							},
							$d = Object.keys(Sa).map(function (m) {
								return Sa[m];
							}),
							Vd = function (m) {
								return m.split(/\s+/).map(function (b) {
									var E = b.split("+"),
										I = qt(E.slice(0, -1)),
										N = we(E.slice(-1));
									return {
										keyCodes: N,
										modifiers: I,
										matchModifiers: yt.bind(null, I),
									};
								});
							},
							ih = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = {},
									E = xi(m.context)[0] || document.documentElement;
								delete m.context;
								var I = xi(m.filter);
								delete m.filter;
								var N = Object.keys(m);
								if (!N.length)
									throw new TypeError(
										"when/key requires at least one option key",
									);
								var Y = function (Mt) {
									Mt.keyCodes.forEach(function (ce) {
										(b[ce] || (b[ce] = []), b[ce].push(Mt));
									});
								};
								N.forEach(function (Mt) {
									if (typeof m[Mt] != "function")
										throw new TypeError(
											'when/key requires option["' + Mt + '"] to be a function',
										);
									var ce = function (Xi) {
										return ((Xi.callback = m[Mt]), Xi);
									};
									Vd(Mt).map(ce).forEach(Y);
								});
								var lt = function (Mt) {
									if (!Mt.defaultPrevented) {
										if (I.length) {
											var ce = Qt({ element: Mt.target, includeSelf: !0 });
											if (I.some(ce)) return;
										}
										var Xi = Mt.keyCode || Mt.which;
										b[Xi] &&
											b[Xi].forEach(function (fn) {
												fn.matchModifiers(Mt) && fn.callback.call(E, Mt, Pt);
											});
									}
								};
								E.addEventListener("keydown", lt, !1);
								var Pt = function () {
									E.removeEventListener("keydown", lt, !1);
								};
								return { disengage: Pt };
							},
							Gd = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context;
								return (
									b || (b = document.documentElement),
									xa(),
									ih({
										"?alt+?shift+tab": function (E) {
											E.preventDefault();
											var I = xa({ context: b }),
												N = E.shiftKey,
												Y = I[0],
												lt = I[I.length - 1],
												Pt = N ? Y : lt,
												Mt = N ? lt : Y;
											if (kn(Pt)) return void Mt.focus();
											var ce = void 0,
												Xi = I.some(function (ts, uo) {
													return kn(ts) ? ((ce = uo), !0) : !1;
												});
											if (!Xi) return void Y.focus();
											var fn = N ? -1 : 1;
											I[ce + fn].focus();
										},
									})
								);
							},
							Xd = { disabled: _e, hidden: rr, tabFocus: Gd },
							Yd = {
								"aria-busy": { default: "false", values: ["true", "false"] },
								"aria-checked": {
									default: void 0,
									values: ["true", "false", "mixed", void 0],
								},
								"aria-disabled": {
									default: "false",
									values: ["true", "false"],
								},
								"aria-expanded": {
									default: void 0,
									values: ["true", "false", void 0],
								},
								"aria-grabbed": {
									default: void 0,
									values: ["true", "false", void 0],
								},
								"aria-hidden": { default: "false", values: ["true", "false"] },
								"aria-invalid": {
									default: "false",
									values: ["true", "false", "grammar", "spelling"],
								},
								"aria-pressed": {
									default: void 0,
									values: ["true", "false", "mixed", void 0],
								},
								"aria-selected": {
									default: void 0,
									values: ["true", "false", void 0],
								},
								"aria-atomic": { default: "false", values: ["true", "false"] },
								"aria-autocomplete": {
									default: "none",
									values: ["inline", "list", "both", "none"],
								},
								"aria-dropeffect": {
									default: "none",
									multiple: !0,
									values: ["copy", "move", "link", "execute", "popup", "none"],
								},
								"aria-haspopup": {
									default: "false",
									values: ["true", "false"],
								},
								"aria-live": {
									default: "off",
									values: ["off", "polite", "assertive"],
								},
								"aria-multiline": {
									default: "false",
									values: ["true", "false"],
								},
								"aria-multiselectable": {
									default: "false",
									values: ["true", "false"],
								},
								"aria-orientation": {
									default: "horizontal",
									values: ["vertical", "horizontal"],
								},
								"aria-readonly": {
									default: "false",
									values: ["true", "false"],
								},
								"aria-relevant": {
									default: "additions text",
									multiple: !0,
									values: ["additions", "removals", "text", "all"],
								},
								"aria-required": {
									default: "false",
									values: ["true", "false"],
								},
								"aria-sort": {
									default: "none",
									other: !0,
									values: ["ascending", "descending", "none"],
								},
							},
							Kd = { attribute: Yd, keycode: jr },
							ao = 0,
							$o = 0,
							nh = ["touchstart", "pointerdown", "MSPointerDown", "mousedown"],
							rh = [
								"touchend",
								"touchcancel",
								"pointerup",
								"MSPointerUp",
								"pointercancel",
								"MSPointerCancel",
								"mouseup",
							],
							sh = Ar({ engage: Ve, disengage: mi }),
							Jd = { interactionType: sh, shadowMutations: ht },
							Qd = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = m.sequence,
									I = m.strategy,
									N = m.ignoreAutofocus,
									Y = m.defaultToContext,
									lt = m.includeOnlyTabbable,
									Pt = -1;
								(E ||
									((b = xi(b || document.body)[0]),
									(E = $t({
										context: b,
										includeOnlyTabbable: lt,
										strategy: I,
									}))),
									E.length && !N && (Pt = St(E, Re)),
									E.length && Pt === -1 && (Pt = St(E, Ae)));
								var Mt = z.rules.except({ onlyTabbable: lt });
								return Pt === -1 && Y && b && Mt(b) ? b : E[Pt] || null;
							},
							tp = {
								firstTabbable: Qd,
								focusable: mt,
								shadowHosts: ii,
								tabbable: $t,
								tabsequence: xa,
							},
							oh = typeof document < "u" && "onfocusin" in document,
							dl = oh ? "focusin" : "focus",
							du = oh ? "focusout" : "blur",
							pl = void 0,
							ml = void 0,
							gl = null,
							pu = null,
							Ta = { pointer: !1, key: !1, script: !1, initial: !1 },
							ep = Ar({ engage: ri, disengage: bi }),
							_l = void 0,
							ah = typeof document < "u" && "onfocusin" in document,
							uh = ah ? "focusin" : "focus",
							lh = ah ? "focusout" : "blur",
							mu = "ally-focus-within",
							vl = void 0,
							yl = void 0,
							bl = void 0,
							ip = Ar({ engage: Er, disengage: Hi }),
							np = { focusSource: ep, focusWithin: ip },
							rp = function (b) {
								var E = b.getBoundingClientRect(),
									I = mn();
								I.area = I.width * I.height;
								var N = I,
									Y = Pn(b);
								if (Y) {
									if (!Y.width || !Y.height) return 0;
									((N = Xn(Y, I)), (N.area = Y.area));
								}
								var lt = Xn(E, N);
								if (!lt.width || !lt.height) return 0;
								var Pt = E.width * E.height,
									Mt = Math.min(Pt, N.area),
									ce = (Math.round(lt.width) * Math.round(lt.height)) / Mt,
									Xi = 1e4,
									fn = Math.round(ce * Xi) / Xi;
								return Math.min(fn, 1);
							},
							ch = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = m.callback,
									I = m.area;
								if (typeof E != "function")
									throw new TypeError(
										"when/visible-area requires options.callback to be a function",
									);
								typeof I != "number" && (I = 1);
								var N = Me({ label: "when/visible-area", context: b }),
									Y = void 0,
									lt = null,
									Pt = function () {
										Y && cancelAnimationFrame(Y);
									},
									Mt = function () {
										return !Nn(N) || rp(N) < I || E(N) === !1;
									},
									ce = function () {
										return Mt() ? void lt() : void Pt();
									};
								return (
									(lt = function () {
										Y = requestAnimationFrame(ce);
									}),
									lt(),
									{ disengage: Pt }
								);
							},
							sp = function () {
								var m =
										arguments.length > 0 && arguments[0] !== void 0
											? arguments[0]
											: {},
									b = m.context,
									E = m.callback,
									I = m.area;
								if (typeof E != "function")
									throw new TypeError(
										"when/focusable requires options.callback to be a function",
									);
								var N = Me({ label: "when/focusable", context: b }),
									Y = function (ce) {
										return z(ce) ? E(ce) : !1;
									},
									lt = Ln(N),
									Pt = ch({ context: N, callback: Y, area: I }),
									Mt = function ce() {
										(lt.removeEventListener("focus", ce, !0),
											Pt && Pt.disengage());
									};
								return (
									lt.addEventListener("focus", Mt, !0),
									{ disengage: Mt }
								);
							},
							op = { focusable: sp, key: ih, visibleArea: ch },
							ap = typeof window < "u" && window.ally,
							up = {
								element: Qr,
								event: oo,
								fix: i,
								get: x,
								is: M,
								maintain: Xd,
								map: Kd,
								observe: Jd,
								query: tp,
								style: np,
								when: op,
								version: ee,
								noConflict: function () {
									return (
										typeof window < "u" &&
											window.ally === this &&
											(window.ally = ap),
										this
									);
								},
							};
						r.exports = up;
					},
					{ "css.escape": 2, platform: 3 },
				],
				2: [
					function (n, r, s) {
						(function (u) {
							(function (l, h) {
								typeof s == "object" ? (r.exports = h(l)) : h(l);
							})(typeof u < "u" ? u : this, function (l) {
								if (l.CSS && l.CSS.escape) return l.CSS.escape;
								var h = function (f) {
									if (arguments.length == 0)
										throw new TypeError("`CSS.escape` requires an argument.");
									for (
										var v,
											w = String(f),
											A = w.length,
											D = -1,
											C = "",
											O = w.charCodeAt(0);
										++D < A;
									)
										((v = w.charCodeAt(D)),
											(C +=
												v != 0
													? (v >= 1 && 31 >= v) ||
														v == 127 ||
														(D == 0 && v >= 48 && 57 >= v) ||
														(D == 1 && v >= 48 && 57 >= v && O == 45)
														? "\\" + v.toString(16) + " "
														: (D != 0 || A != 1 || v != 45) &&
															  (v >= 128 ||
																	v == 45 ||
																	v == 95 ||
																	(v >= 48 && 57 >= v) ||
																	(v >= 65 && 90 >= v) ||
																	(v >= 97 && 122 >= v))
															? w.charAt(D)
															: "\\" + w.charAt(D)
													: "�"));
									return C;
								};
								return (l.CSS || (l.CSS = {}), (l.CSS.escape = h), h);
							});
						}).call(
							this,
							typeof Rs < "u"
								? Rs
								: typeof self < "u"
									? self
									: typeof window < "u"
										? window
										: {},
						);
					},
					{},
				],
				3: [
					function (n, r, s) {
						(function (u) {
							(function () {
								function l(K) {
									return (
										(K = String(K)),
										K.charAt(0).toUpperCase() + K.slice(1)
									);
								}
								function h(K, Nt, St) {
									var Ct = {
										"10.0": "10",
										6.4: "10 Technical Preview",
										6.3: "8.1",
										6.2: "8",
										6.1: "Server 2008 R2 / 7",
										"6.0": "Server 2008 / Vista",
										5.2: "Server 2003 / XP 64-bit",
										5.1: "XP",
										5.01: "2000 SP1",
										"5.0": "2000",
										"4.0": "NT",
										"4.90": "ME",
									};
									return (
										Nt &&
											St &&
											/^Win/i.test(K) &&
											!/^Windows Phone /i.test(K) &&
											(Ct = Ct[/[\d.]+$/.exec(K)]) &&
											(K = "Windows " + Ct),
										(K = String(K)),
										Nt && St && (K = K.replace(RegExp(Nt, "i"), St)),
										(K = v(
											K.replace(/ ce$/i, " CE")
												.replace(/\bhpw/i, "web")
												.replace(/\bMacintosh\b/, "Mac OS")
												.replace(/_PowerPC\b/i, " OS")
												.replace(/\b(OS X) [^ \d]+/i, "$1")
												.replace(/\bMac (OS X)\b/, "$1")
												.replace(/\/(\d)/, " $1")
												.replace(/_/g, ".")
												.replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "")
												.replace(/\bx86\.64\b/gi, "x86_64")
												.replace(/\b(Windows Phone) OS\b/, "$1")
												.replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1")
												.split(" on ")[0],
										))
									);
								}
								function f(K, Nt) {
									var St = -1,
										Ct = K ? K.length : 0;
									if (typeof Ct == "number" && Ct > -1 && g >= Ct)
										for (; ++St < Ct; ) Nt(K[St], St, K);
									else w(K, Nt);
								}
								function v(K) {
									return (
										(K = P(K)),
										/^(?:webOS|i(?:OS|P))/.test(K) ? K : l(K)
									);
								}
								function w(K, Nt) {
									for (var St in K) Dt.call(K, St) && Nt(K[St], St, K);
								}
								function A(K) {
									return K == null ? l(K) : pt.call(K).slice(8, -1);
								}
								function D(K, Nt) {
									var St = K != null ? typeof K[Nt] : "number";
									return (
										!/^(?:boolean|number|string|undefined)$/.test(St) &&
										(St == "object" ? !!K[Nt] : !0)
									);
								}
								function C(K) {
									return String(K).replace(/([ -])(?!$)/g, "$1?");
								}
								function O(K, Nt) {
									var St = null;
									return (
										f(K, function (Ct, _t) {
											St = Nt(St, Ct, _t, K);
										}),
										St
									);
								}
								function P(K) {
									return String(K).replace(/^ +| +$/g, "");
								}
								function F(K) {
									function Nt(ke) {
										return O(ke, function (ie, Jt) {
											return (
												ie ||
												(RegExp(
													"\\b" + (Jt.pattern || C(Jt)) + "\\b",
													"i",
												).exec(K) &&
													(Jt.label || Jt))
											);
										});
									}
									function St(ke) {
										return O(ke, function (ie, Jt, vi) {
											return (
												ie ||
												((Jt[Kt] ||
													Jt[/^[a-z]+(?: +[a-z]+\b)*/i.exec(Kt)] ||
													RegExp("\\b" + C(vi) + "(?:\\b|\\w*\\d)", "i").exec(
														K,
													)) &&
													vi)
											);
										});
									}
									function Ct(ke) {
										return O(ke, function (ie, Jt) {
											return (
												ie ||
												(RegExp(
													"\\b" + (Jt.pattern || C(Jt)) + "\\b",
													"i",
												).exec(K) &&
													(Jt.label || Jt))
											);
										});
									}
									function _t(ke) {
										return O(ke, function (ie, Jt) {
											var vi = Jt.pattern || C(Jt);
											return (
												!ie &&
													(ie = RegExp(
														"\\b" + vi + "(?:/[\\d.]+|[ \\w.]*)",
														"i",
													).exec(K)) &&
													(ie = h(ie, vi, Jt.label || Jt)),
												ie
											);
										});
									}
									function de(ke) {
										return O(ke, function (ie, Jt) {
											var vi = Jt.pattern || C(Jt);
											return (
												!ie &&
													(ie =
														RegExp("\\b" + vi + " *\\d+[.\\w_]*", "i").exec(
															K,
														) ||
														RegExp(
															"\\b" +
																vi +
																"(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)",
															"i",
														).exec(K)) &&
													((ie = String(
														Jt.label && !RegExp(vi, "i").test(Jt.label)
															? Jt.label
															: ie,
													).split("/"))[1] &&
														!/[\d.]+/.test(ie[0]) &&
														(ie[0] += " " + ie[1]),
													(Jt = Jt.label || Jt),
													(ie = v(
														ie[0]
															.replace(RegExp(vi, "i"), Jt)
															.replace(
																RegExp("; *(?:" + Jt + "[_-])?", "i"),
																" ",
															)
															.replace(
																RegExp("(" + Jt + ")[-_.]?(\\w)", "i"),
																"$1 $2",
															),
													))),
												ie
											);
										});
									}
									function W(ke) {
										return O(ke, function (ie, Jt) {
											return (
												ie ||
												(RegExp(
													Jt +
														"(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)",
													"i",
												).exec(K) || 0)[1] ||
												null
											);
										});
									}
									function Wt() {
										return this.description || "";
									}
									var Zt = B,
										oe = K && typeof K == "object" && A(K) != "String";
									oe && ((Zt = K), (K = null));
									var jt = Zt.navigator || {},
										Vt = jt.userAgent || "";
									K || (K = Vt);
									var U,
										xe,
										qe = oe || ot == j,
										Ze = oe
											? !!jt.likeChrome
											: /\bChrome\b/.test(K) &&
												!/internal|\n/i.test(pt.toString()),
										je = "Object",
										Ge = oe ? je : "ScriptBridgingProxyObject",
										Ue = oe ? je : "Environment",
										ne = oe && Zt.java ? "JavaPackage" : A(Zt.java),
										We = oe ? je : "RuntimeObject",
										He = /\bJava/.test(ne) && Zt.java,
										di = He && A(Zt.environment) == Ue,
										st = He ? "a" : "α",
										ze = He ? "b" : "β",
										Ji = Zt.document || {},
										pi = Zt.operamini || Zt.opera,
										Ie = ct.test((Ie = oe && pi ? pi["[[Class]]"] : A(pi)))
											? Ie
											: (pi = null),
										$e = K,
										re = [],
										Di = null,
										gt = K == Vt,
										Lt =
											gt &&
											pi &&
											typeof pi.version == "function" &&
											pi.version(),
										Ft = Nt([
											{ label: "EdgeHTML", pattern: "Edge" },
											"Trident",
											{ label: "WebKit", pattern: "AppleWebKit" },
											"iCab",
											"Presto",
											"NetFront",
											"Tasman",
											"KHTML",
											"Gecko",
										]),
										vt = Ct([
											"Adobe AIR",
											"Arora",
											"Avant Browser",
											"Breach",
											"Camino",
											"Epiphany",
											"Fennec",
											"Flock",
											"Galeon",
											"GreenBrowser",
											"iCab",
											"Iceweasel",
											"K-Meleon",
											"Konqueror",
											"Lunascape",
											"Maxthon",
											{ label: "Microsoft Edge", pattern: "Edge" },
											"Midori",
											"Nook Browser",
											"PaleMoon",
											"PhantomJS",
											"Raven",
											"Rekonq",
											"RockMelt",
											"SeaMonkey",
											{ label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" },
											"Sleipnir",
											"SlimBrowser",
											{ label: "SRWare Iron", pattern: "Iron" },
											"Sunrise",
											"Swiftfox",
											"WebPositive",
											"Opera Mini",
											{ label: "Opera Mini", pattern: "OPiOS" },
											"Opera",
											{ label: "Opera", pattern: "OPR" },
											"Chrome",
											{ label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" },
											{ label: "Firefox", pattern: "(?:Firefox|Minefield)" },
											{ label: "Firefox for iOS", pattern: "FxiOS" },
											{ label: "IE", pattern: "IEMobile" },
											{ label: "IE", pattern: "MSIE" },
											"Safari",
										]),
										Kt = de([
											{ label: "BlackBerry", pattern: "BB10" },
											"BlackBerry",
											{ label: "Galaxy S", pattern: "GT-I9000" },
											{ label: "Galaxy S2", pattern: "GT-I9100" },
											{ label: "Galaxy S3", pattern: "GT-I9300" },
											{ label: "Galaxy S4", pattern: "GT-I9500" },
											"Google TV",
											"Lumia",
											"iPad",
											"iPod",
											"iPhone",
											"Kindle",
											{
												label: "Kindle Fire",
												pattern: "(?:Cloud9|Silk-Accelerated)",
											},
											"Nexus",
											"Nook",
											"PlayBook",
											"PlayStation 3",
											"PlayStation 4",
											"PlayStation Vita",
											"TouchPad",
											"Transformer",
											{ label: "Wii U", pattern: "WiiU" },
											"Wii",
											"Xbox One",
											{ label: "Xbox 360", pattern: "Xbox" },
											"Xoom",
										]),
										Ne = St({
											Apple: { iPad: 1, iPhone: 1, iPod: 1 },
											Archos: {},
											Amazon: { Kindle: 1, "Kindle Fire": 1 },
											Asus: { Transformer: 1 },
											"Barnes & Noble": { Nook: 1 },
											BlackBerry: { PlayBook: 1 },
											Google: { "Google TV": 1, Nexus: 1 },
											HP: { TouchPad: 1 },
											HTC: {},
											LG: {},
											Microsoft: { Xbox: 1, "Xbox One": 1 },
											Motorola: { Xoom: 1 },
											Nintendo: { "Wii U": 1, Wii: 1 },
											Nokia: { Lumia: 1 },
											Samsung: {
												"Galaxy S": 1,
												"Galaxy S2": 1,
												"Galaxy S3": 1,
												"Galaxy S4": 1,
											},
											Sony: {
												"PlayStation 4": 1,
												"PlayStation 3": 1,
												"PlayStation Vita": 1,
											},
										}),
										bt = _t([
											"Windows Phone",
											"Android",
											"CentOS",
											{ label: "Chrome OS", pattern: "CrOS" },
											"Debian",
											"Fedora",
											"FreeBSD",
											"Gentoo",
											"Haiku",
											"Kubuntu",
											"Linux Mint",
											"OpenBSD",
											"Red Hat",
											"SuSE",
											"Ubuntu",
											"Xubuntu",
											"Cygwin",
											"Symbian OS",
											"hpwOS",
											"webOS ",
											"webOS",
											"Tablet OS",
											"Linux",
											"Mac OS X",
											"Macintosh",
											"Mac",
											"Windows 98;",
											"Windows ",
										]);
									if (
										(Ft && (Ft = [Ft]),
										Ne && !Kt && (Kt = de([Ne])),
										(U = /\bGoogle TV\b/.exec(Kt)) && (Kt = U[0]),
										/\bSimulator\b/i.test(K) &&
											(Kt = (Kt ? Kt + " " : "") + "Simulator"),
										vt == "Opera Mini" &&
											/\bOPiOS\b/.test(K) &&
											re.push("running in Turbo/Uncompressed mode"),
										vt == "IE" && /\blike iPhone OS\b/.test(K)
											? ((U = F(K.replace(/like iPhone OS/, ""))),
												(Ne = U.manufacturer),
												(Kt = U.product))
											: /^iP/.test(Kt)
												? (vt || (vt = "Safari"),
													(bt =
														"iOS" +
														((U = / OS ([\d_]+)/i.exec(K))
															? " " + U[1].replace(/_/g, ".")
															: "")))
												: vt != "Konqueror" || /buntu/i.test(bt)
													? (Ne &&
															Ne != "Google" &&
															((/Chrome/.test(vt) &&
																!/\bMobile Safari\b/i.test(K)) ||
																/\bVita\b/.test(Kt))) ||
														(/\bAndroid\b/.test(bt) &&
															/^Chrome/.test(vt) &&
															/\bVersion\//i.test(K))
														? ((vt = "Android Browser"),
															(bt = /\bAndroid\b/.test(bt) ? bt : "Android"))
														: vt == "Silk"
															? (/\bMobi/i.test(K) ||
																	((bt = "Android"),
																	re.unshift("desktop mode")),
																/Accelerated *= *true/i.test(K) &&
																	re.unshift("accelerated"))
															: vt == "PaleMoon" &&
																  (U = /\bFirefox\/([\d.]+)\b/.exec(K))
																? re.push("identifying as Firefox " + U[1])
																: vt == "Firefox" &&
																	  (U = /\b(Mobile|Tablet|TV)\b/i.exec(K))
																	? (bt || (bt = "Firefox OS"),
																		Kt || (Kt = U[1]))
																	: (!vt ||
																			(U =
																				!/\bMinefield\b/i.test(K) &&
																				/\b(?:Firefox|Safari)\b/.exec(vt))) &&
																		(vt &&
																			!Kt &&
																			/[\/,]|^[^(]+?\)/.test(
																				K.slice(K.indexOf(U + "/") + 8),
																			) &&
																			(vt = null),
																		(U = Kt || Ne || bt) &&
																			(Kt ||
																				Ne ||
																				/\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(
																					bt,
																				)) &&
																			(vt =
																				/[a-z]+(?: Hat)?/i.exec(
																					/\bAndroid\b/.test(bt) ? bt : U,
																				) + " Browser"))
													: (bt = "Kubuntu"),
										Lt ||
											(Lt = W([
												"(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))",
												"Version",
												C(vt),
												"(?:Firefox|Minefield|NetFront)",
											])),
										(U =
											(Ft == "iCab" && parseFloat(Lt) > 3 && "WebKit") ||
											(/\bOpera\b/.test(vt) &&
												(/\bOPR\b/.test(K) ? "Blink" : "Presto")) ||
											(/\b(?:Midori|Nook|Safari)\b/i.test(K) &&
												!/^(?:Trident|EdgeHTML)$/.test(Ft) &&
												"WebKit") ||
											(!Ft &&
												/\bMSIE\b/i.test(K) &&
												(bt == "Mac OS" ? "Tasman" : "Trident")) ||
											(Ft == "WebKit" &&
												/\bPlayStation\b(?! Vita\b)/i.test(vt) &&
												"NetFront")) && (Ft = [U]),
										vt == "IE" &&
										(U = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(K) || 0)[1])
											? ((vt += " Mobile"),
												(bt =
													"Windows Phone " + (/\+$/.test(U) ? U : U + ".x")),
												re.unshift("desktop mode"))
											: /\bWPDesktop\b/i.test(K)
												? ((vt = "IE Mobile"),
													(bt = "Windows Phone 8.x"),
													re.unshift("desktop mode"),
													Lt || (Lt = (/\brv:([\d.]+)/.exec(K) || 0)[1]))
												: vt != "IE" &&
													Ft == "Trident" &&
													(U = /\brv:([\d.]+)/.exec(K)) &&
													(vt &&
														re.push(
															"identifying as " + vt + (Lt ? " " + Lt : ""),
														),
													(vt = "IE"),
													(Lt = U[1])),
										gt)
									) {
										if (D(Zt, "global"))
											if (
												(He &&
													((U = He.lang.System),
													($e = U.getProperty("os.arch")),
													(bt =
														bt ||
														U.getProperty("os.name") +
															" " +
															U.getProperty("os.version"))),
												qe && D(Zt, "system") && (U = [Zt.system])[0])
											) {
												bt || (bt = U[0].os || null);
												try {
													((U[1] = Zt.require("ringo/engine").version),
														(Lt = U[1].join(".")),
														(vt = "RingoJS"));
												} catch {
													U[0].global.system == Zt.system && (vt = "Narwhal");
												}
											} else
												typeof Zt.process == "object" &&
												!Zt.process.browser &&
												(U = Zt.process)
													? ((vt = "Node.js"),
														($e = U.arch),
														(bt = U.platform),
														(Lt = /[\d.]+/.exec(U.version)[0]))
													: di && (vt = "Rhino");
										else
											A((U = Zt.runtime)) == Ge
												? ((vt = "Adobe AIR"),
													(bt = U.flash.system.Capabilities.os))
												: A((U = Zt.phantom)) == We
													? ((vt = "PhantomJS"),
														(Lt =
															(U = U.version || null) &&
															U.major + "." + U.minor + "." + U.patch))
													: typeof Ji.documentMode == "number" &&
														(U = /\bTrident\/(\d+)/i.exec(K)) &&
														((Lt = [Lt, Ji.documentMode]),
														(U = +U[1] + 4) != Lt[1] &&
															(re.push("IE " + Lt[1] + " mode"),
															Ft && (Ft[1] = ""),
															(Lt[1] = U)),
														(Lt =
															vt == "IE" ? String(Lt[1].toFixed(1)) : Lt[0]));
										bt = bt && v(bt);
									}
									(Lt &&
										(U =
											/(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(Lt) ||
											/(?:alpha|beta)(?: ?\d)?/i.exec(
												K + ";" + (gt && jt.appMinorVersion),
											) ||
											(/\bMinefield\b/i.test(K) && "a")) &&
										((Di = /b/i.test(U) ? "beta" : "alpha"),
										(Lt =
											Lt.replace(RegExp(U + "\\+?$"), "") +
											(Di == "beta" ? ze : st) +
											(/\d+\+?/.exec(U) || ""))),
										vt == "Fennec" ||
										(vt == "Firefox" && /\b(?:Android|Firefox OS)\b/.test(bt))
											? (vt = "Firefox Mobile")
											: vt == "Maxthon" && Lt
												? (Lt = Lt.replace(/\.[\d.]+/, ".x"))
												: /\bXbox\b/i.test(Kt)
													? ((bt = null),
														Kt == "Xbox 360" &&
															/\bIEMobile\b/.test(K) &&
															re.unshift("mobile mode"))
													: (!/^(?:Chrome|IE|Opera)$/.test(vt) &&
																(!vt || Kt || /Browser|Mobi/.test(vt))) ||
														  (bt != "Windows CE" && !/Mobi/i.test(K))
														? vt == "IE" && gt && Zt.external === null
															? re.unshift("platform preview")
															: (/\bBlackBerry\b/.test(Kt) ||
																		/\bBB10\b/.test(K)) &&
																  (U =
																		(RegExp(
																			Kt.replace(/ +/g, " *") + "/([.\\d]+)",
																			"i",
																		).exec(K) || 0)[1] || Lt)
																? ((U = [U, /BB10/.test(K)]),
																	(bt =
																		(U[1]
																			? ((Kt = null), (Ne = "BlackBerry"))
																			: "Device Software") +
																		" " +
																		U[0]),
																	(Lt = null))
																: this != w &&
																	Kt != "Wii" &&
																	((gt && pi) ||
																		(/Opera/.test(vt) &&
																			/\b(?:MSIE|Firefox)\b/i.test(K)) ||
																		(vt == "Firefox" &&
																			/\bOS X (?:\d+\.){2,}/.test(bt)) ||
																		(vt == "IE" &&
																			((bt && !/^Win/.test(bt) && Lt > 5.5) ||
																				(/\bWindows XP\b/.test(bt) && Lt > 8) ||
																				(Lt == 8 &&
																					!/\bTrident\b/.test(K))))) &&
																	!ct.test(
																		(U = F.call(w, K.replace(ct, "") + ";")),
																	) &&
																	U.name &&
																	((U =
																		"ing as " +
																		U.name +
																		((U = U.version) ? " " + U : "")),
																	ct.test(vt)
																		? (/\bIE\b/.test(U) &&
																				bt == "Mac OS" &&
																				(bt = null),
																			(U = "identify" + U))
																		: ((U = "mask" + U),
																			(vt = Ie
																				? v(
																						Ie.replace(
																							/([a-z])([A-Z])/g,
																							"$1 $2",
																						),
																					)
																				: "Opera"),
																			/\bIE\b/.test(U) && (bt = null),
																			gt || (Lt = null)),
																	(Ft = ["Presto"]),
																	re.push(U))
														: (vt += " Mobile"),
										(U = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(K) || 0)[1]) &&
											((U = [parseFloat(U.replace(/\.(\d)$/, ".0$1")), U]),
											vt == "Safari" && U[1].slice(-1) == "+"
												? ((vt = "WebKit Nightly"),
													(Di = "alpha"),
													(Lt = U[1].slice(0, -1)))
												: (Lt == U[1] ||
														Lt ==
															(U[2] = (/\bSafari\/([\d.]+\+?)/i.exec(K) ||
																0)[1])) &&
													(Lt = null),
											(U[1] = (/\bChrome\/([\d.]+)/i.exec(K) || 0)[1]),
											U[0] == 537.36 &&
												U[2] == 537.36 &&
												parseFloat(U[1]) >= 28 &&
												Ft == "WebKit" &&
												(Ft = ["Blink"]),
											gt && (Ze || U[1])
												? (Ft && (Ft[1] = "like Chrome"),
													(U =
														U[1] ||
														((U = U[0]),
														530 > U
															? 1
															: 532 > U
																? 2
																: 532.05 > U
																	? 3
																	: 533 > U
																		? 4
																		: 534.03 > U
																			? 5
																			: 534.07 > U
																				? 6
																				: 534.1 > U
																					? 7
																					: 534.13 > U
																						? 8
																						: 534.16 > U
																							? 9
																							: 534.24 > U
																								? 10
																								: 534.3 > U
																									? 11
																									: 535.01 > U
																										? 12
																										: 535.02 > U
																											? "13+"
																											: 535.07 > U
																												? 15
																												: 535.11 > U
																													? 16
																													: 535.19 > U
																														? 17
																														: 536.05 > U
																															? 18
																															: 536.1 > U
																																? 19
																																: 537.01 > U
																																	? 20
																																	: 537.11 > U
																																		? "21+"
																																		: 537.13 > U
																																			? 23
																																			: 537.18 >
																																				  U
																																				? 24
																																				: 537.24 >
																																					  U
																																					? 25
																																					: 537.36 >
																																						  U
																																						? 26
																																						: Ft !=
																																							  "Blink"
																																							? "27"
																																							: "28")))
												: (Ft && (Ft[1] = "like Safari"),
													(U = U[0]),
													(U =
														400 > U
															? 1
															: 500 > U
																? 2
																: 526 > U
																	? 3
																	: 533 > U
																		? 4
																		: 534 > U
																			? "4+"
																			: 535 > U
																				? 5
																				: 537 > U
																					? 6
																					: 538 > U
																						? 7
																						: 601 > U
																							? 8
																							: "8")),
											Ft &&
												(Ft[1] +=
													" " +
													(U +=
														typeof U == "number"
															? ".x"
															: /[.+]/.test(U)
																? ""
																: "+")),
											vt == "Safari" && (!Lt || parseInt(Lt) > 45) && (Lt = U)),
										vt == "Opera" && (U = /\bzbov|zvav$/.exec(bt))
											? ((vt += " "),
												re.unshift("desktop mode"),
												U == "zvav"
													? ((vt += "Mini"), (Lt = null))
													: (vt += "Mobile"),
												(bt = bt.replace(RegExp(" *" + U + "$"), "")))
											: vt == "Safari" &&
												/\bChrome\b/.exec(Ft && Ft[1]) &&
												(re.unshift("desktop mode"),
												(vt = "Chrome Mobile"),
												(Lt = null),
												/\bOS X\b/.test(bt)
													? ((Ne = "Apple"), (bt = "iOS 4.3+"))
													: (bt = null)),
										Lt &&
											Lt.indexOf((U = /[\d.]+$/.exec(bt))) == 0 &&
											K.indexOf("/" + U + "-") > -1 &&
											(bt = P(bt.replace(U, ""))),
										Ft &&
											!/\b(?:Avant|Nook)\b/.test(vt) &&
											(/Browser|Lunascape|Maxthon/.test(vt) ||
												(vt != "Safari" &&
													/^iOS/.test(bt) &&
													/\bSafari\b/.test(Ft[1])) ||
												(/^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(
													vt,
												) &&
													Ft[1])) &&
											(U = Ft[Ft.length - 1]) &&
											re.push(U),
										re.length && (re = ["(" + re.join("; ") + ")"]),
										Ne && Kt && Kt.indexOf(Ne) < 0 && re.push("on " + Ne),
										Kt &&
											re.push(
												(/^on /.test(re[re.length - 1]) ? "" : "on ") + Kt,
											),
										bt &&
											((U = / ([\d.+]+)$/.exec(bt)),
											(xe = U && bt.charAt(bt.length - U[0].length - 1) == "/"),
											(bt = {
												architecture: 32,
												family: U && !xe ? bt.replace(U[0], "") : bt,
												version: U ? U[1] : null,
												toString: function () {
													var ke = this.version;
													return (
														this.family +
														(ke && !xe ? " " + ke : "") +
														(this.architecture == 64 ? " 64-bit" : "")
													);
												},
											})),
										(U = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec($e)) &&
										!/\bi686\b/i.test($e)
											? (bt &&
													((bt.architecture = 64),
													(bt.family = bt.family.replace(
														RegExp(" *" + U),
														"",
													))),
												vt &&
													(/\bWOW64\b/i.test(K) ||
														(gt &&
															/\w(?:86|32)$/.test(jt.cpuClass || jt.platform) &&
															!/\bWin64; x64\b/i.test(K))) &&
													re.unshift("32-bit"))
											: bt &&
												/^OS X/.test(bt.family) &&
												vt == "Chrome" &&
												parseFloat(Lt) >= 39 &&
												(bt.architecture = 64),
										K || (K = null));
									var se = {};
									return (
										(se.description = K),
										(se.layout = Ft && Ft[0]),
										(se.manufacturer = Ne),
										(se.name = vt),
										(se.prerelease = Di),
										(se.product = Kt),
										(se.ua = K),
										(se.version = vt && Lt),
										(se.os = bt || {
											architecture: null,
											family: null,
											version: null,
											toString: function () {
												return "null";
											},
										}),
										(se.parse = F),
										(se.toString = Wt),
										se.version && re.unshift(Lt),
										se.name && re.unshift(vt),
										bt &&
											vt &&
											(bt != String(bt).split(" ")[0] ||
												(bt != vt.split(" ")[0] && !Kt)) &&
											re.push(Kt ? "(" + bt + ")" : "on " + bt),
										re.length && (se.description = re.join(" ")),
										se
									);
								}
								var G = { function: !0, object: !0 },
									B = (G[typeof window] && window) || this,
									j = B,
									V = G[typeof s] && s,
									Q = G[typeof r] && r && !r.nodeType && r,
									it = V && Q && typeof u == "object" && u;
								!it ||
									(it.global !== it && it.window !== it && it.self !== it) ||
									(B = it);
								var g = Math.pow(2, 53) - 1,
									ct = /\bOpera/,
									ot = this,
									ft = Object.prototype,
									Dt = ft.hasOwnProperty,
									pt = ft.toString,
									Et = F();
								V && Q
									? w(Et, function (K, Nt) {
											V[Nt] = K;
										})
									: (B.platform = Et);
							}).call(this);
						}).call(
							this,
							typeof Rs < "u"
								? Rs
								: typeof self < "u"
									? self
									: typeof window < "u"
										? window
										: {},
						);
					},
					{},
				],
			},
			{},
			[1],
		)(1);
	});
})(vf);
var gp = vf.exports;
const po = tl(gp);
/*!
 *
 * jQuery Tabs plugin using GSAP
 *
 * Authors: Florian Wacker, Christian Dilger
 *
 * based on jQuery lightweight plugin boilerplate
 * Original author: @ajpiano
 * Further changes, comments: @addyosmani
 * Licensed under the MIT license
 *
 * Last updated: 06.09.2019
 * Dependencies: jQuery
 *
 */ (function (p, e, n) {
	var r = "hellltabs",
		s = { ease: "Power3.easeInOut", tabIndex: 0 };
	function u(l, h) {
		((this.element = l),
			(this.options = p.extend({}, s, h)),
			(this._defaults = s),
			(this._name = r),
			(this._settings = {
				$tabNav: null,
				$tabLinks: null,
				$tabSelect: null,
				$tabs: null,
				$tab: null,
				$currentTab: null,
				$currentTabLink: null,
				navType: null,
				$tabByHash: !1,
			}),
			this.init());
	}
	((u.prototype = {
		init: function () {
			var l = e.location.hash;
			((this._settings.$tabNav = p(this.element).find(".js-tab-nav")),
				(this._settings.$tabLinks = p(this.element).find(".js-tab-link")),
				(this._settings.$tabSelect = p(this.element).find(".js-tab-select")),
				(this._settings.$tabOptions = p(this.element).find(
					".js-tab-select option",
				)),
				(this._settings.$tabs = p(this.element).find(".js-tabs")),
				(this._settings.$tab = p(this.element).find(".js-tab-item")),
				(this._settings.navType = this.getNavType()),
				l.length > 0 &&
					(this._settings.$tabByHash = this._settings.$tabNav.find(
						'[href="' + l + '"]',
					)),
				this._settings.$tabByHash &&
					this._settings.$tabByHash.length > 0 &&
					(this.options.tabIndex = this._settings.$tabByHash.data("index")),
				this.initializeTabs(),
				this.bindEvents());
		},
		bindEvents: function () {
			var l = this;
			this._settings.navType === "links"
				? (this._settings.$tabLinks.on("click", { self: this }, this.select),
					this._settings.$tabLinks.on(
						"keydown",
						{ self: this },
						this.keyboardInputManagement,
					))
				: this._settings.$tabSelect.on("change", { self: this }, this.select);
			var h;
			p(e).on("resize", function (f) {
				(clearTimeout(h),
					(h = setTimeout(function () {
						l.setTabHeight();
					}, 100)));
			});
		},
		getNavType: function () {
			return this._settings.$tabLinks.length > 0 ? "links" : "select";
		},
		initializeTabs: function () {
			((this._settings.$currentTab = this._settings.$tab.eq(
				this.options.tabIndex,
			)),
				this._settings.navType === "links"
					? ((this._settings.$currentTabLink = this._settings.$tabNav
							.find("li")
							.eq(this.options.tabIndex)),
						this.setCurrentTabLink(this.options.tabIndex))
					: ((this._settings.$tabSelect[0].selectedIndex =
							this.options.tabIndex),
						this.setCurrentTabOption(this.options.tabIndex)),
				this._settings.$tab.attr("aria-hidden", !0),
				this._settings.$currentTab.addClass("is-active"),
				this._settings.$currentTab.attr("aria-hidden", !1),
				this.setTabHeight());
		},
		setTabHeight: function () {
			var l = this;
			setTimeout(function () {
				var h = p(l.element).find(".tab__item.is-active").height();
				l._settings.$tabs.css("height", h);
			}, 100);
		},
		select: function (l) {
			l.preventDefault();
			var h = l.data.self,
				f;
			(h._settings.navType === "select"
				? ((f = p(this).prop("selectedIndex")), h.setCurrentTabOption(f))
				: ((f = p(this).data("index")), h.setCurrentTabLink(f)),
				(h._settings.$currentTab = p(h.element).find(".js-tab-item").eq(f)),
				h.fadeOut(h),
				h.fadeIn(h),
				h.setTabContainerHeight(h));
		},
		fadeOut: function (l) {
			(l._settings.$tab.attr("aria-hidden", !0),
				l._settings.$tab.removeClass("is-active"));
		},
		fadeIn: function (l) {
			(l._settings.$currentTab.attr("aria-hidden", !1),
				l._settings.$currentTab.addClass("is-active"));
		},
		setTabContainerHeight: function (l) {
			l._settings.$tabs.css("height", l._settings.$currentTab.height());
		},
		setCurrentTabLink: function (l) {
			(this._settings.$currentTabLink.removeClass("is-active"),
				(this._settings.$currentTabLink = this._settings.$tabNav
					.find("li")
					.eq(l)),
				this._settings.$currentTabLink.addClass("is-active"),
				this._settings.$tabLinks.each(function (h, f) {
					(p(f).attr("aria-selected", !1), p(f).attr("tabindex", "-1"));
				}),
				this._settings.$currentTabLink.find("button").attr("tabindex", "0"),
				this._settings.$currentTabLink
					.find("button")
					.attr("aria-selected", !0));
		},
		setCurrentTabOption(l) {
			(this._settings.$tabOptions.each(function (h, f) {
				p(f).attr("aria-selected", !1);
			}),
				this._settings.$tabOptions.eq(l).attr("aria-selected", !0));
		},
		keyboardInputManagement: function (l) {
			var h = l.data.self;
			if (h._settings.navType === "links")
				if (l.key === "ArrowLeft") {
					let f = p(l.target).data("index");
					f <= 0
						? po.element.focus(h._settings.$tabLinks.last())
						: po.element.focus(h._settings.$tabNav.find("li button").eq(f - 1));
				} else if (l.key === "ArrowRight") {
					let f = p(l.target).data("index"),
						v = h._settings.$tabLinks.last().data("index");
					f >= v
						? po.element.focus(h._settings.$tabLinks.first())
						: po.element.focus(h._settings.$tabNav.find("li button").eq(f + 1));
				} else
					l.key === "Home"
						? (l.preventDefault(),
							po.element.focus(h._settings.$tabLinks.first()))
						: l.key === "End" &&
							(l.preventDefault(),
							po.element.focus(h._settings.$tabLinks.last()));
		},
		updateHash: function () {
			var l = this._settings.$currentTabLink.find("button").attr("href");
			l.length > 0 && e.location.hash.length > 0 && (e.location.hash = l);
		},
	}),
		(p.fn[r] = function (l) {
			return this.each(function () {
				p.data(this, "plugin_" + r) ||
					p.data(this, "plugin_" + r, new u(this, l));
			});
		}));
})(Ht, window);
/*!
 *
 * jQuery Plugin – accordion
 *
 * Author: IVIS MEDIA (based on original work by helllicht medien GmbH)
 *
 * Last updated: 25.05.2020
 *
 */ (function (p, e, n) {
	var r = "helllaccordion",
		s = { trigger: "[aria-controls]" };
	function u(l, h) {
		((this.element = l),
			(this.options = p.extend({}, s, h)),
			(this._defaults = s),
			(this._name = r),
			(this._settings = { $el: null, $buttons: null }),
			this.init());
	}
	(p.extend(u.prototype, {
		init: function () {
			((this._settings.$el = p(this.element)),
				(this._settings.$buttons = this._settings.$el.find(
					this.options.trigger,
				)),
				this.bindEvents());
		},
		bindEvents: function () {
			(this._settings.$buttons.on("click", { self: this }, this.toggle),
				this._settings.$buttons.on("keydown", { self: this }, this.onKeyDown));
		},
		toggle: function (l) {
			l.preventDefault();
			var h = l.data.self,
				f = p(this),
				v = f.attr("aria-controls");
			h.checkOthers(f[0], h);
			var w = p("#" + v).attr("aria-hidden");
			w === "true"
				? (p("#" + v).attr("aria-hidden", "false"),
					p("#" + v).slideDown({
						duration: 500,
						queue: !1,
						complete: function () {
							typeof ScrollTrigger < "u" && ScrollTrigger.refresh();
						},
					}))
				: (p("#" + v).attr("aria-hidden", "true"),
					p("#" + v).slideUp({
						duration: 500,
						complete: function () {
							typeof ScrollTrigger < "u" && ScrollTrigger.refresh();
						},
					}));
			var A = f.attr("aria-expanded"),
				D = A === "false" ? "true" : "false";
			f.attr("aria-expanded", D);
		},
		checkOthers: function (l, h) {
			for (var f = h._settings.$buttons, v = 0; v < f.length; v++)
				if (f[v] !== l && p(f[v]).attr("aria-expanded") === "true") {
					p(f[v]).attr("aria-expanded", "false");
					var w = p(f[v]).attr("aria-controls");
					((p(f[v]).checked = !1),
						p("#" + w).attr("aria-hidden", "true"),
						p("#" + w).slideUp({ duration: 500 }));
				}
		},
		getAccordionButtonIndex: function (l, h) {
			for (var f = h._settings.$buttons, v = 0; v < f.length; v++)
				if (l === f[v]) return v;
			return -1;
		},
		onKeyDown: function (l) {
			if (l.key !== "Tab") {
				l.preventDefault();
				var h = l.data.self,
					f = h._settings.$buttons,
					v = f.length,
					w;
				l.key === "ArrowUp"
					? ((w = h.getAccordionButtonIndex(l.target, h)),
						w !== -1 &&
							(w === 0 ? f[v - 1].focus() : w > 0 && w < v && f[w - 1].focus()))
					: l.key === "ArrowDown"
						? ((w = h.getAccordionButtonIndex(l.target, h)),
							w !== -1 &&
								(w === f.length - 1
									? f[0].focus()
									: w > -1 && w < f.length && f[w + 1].focus()))
						: l.key === "End"
							? f[f.length - 1].focus()
							: l.key === "Home"
								? f[0].focus()
								: (l.key === "Enter" || l.code === "Space") && l.target.click();
			}
		},
	}),
		(p.fn[r] = function (l) {
			return this.each(function () {
				p.data(this, "plugin_" + r) ||
					p.data(this, "plugin_" + r, new u(this, l));
			});
		}));
})(Ht);
Ht(function () {
	var p = {
		$open: Ht(".js-open-msg"),
		$close: Ht(".js-close-msg"),
		$closeSmall: Ht(".js-close-msg-small"),
		$layer: Ht(".js-msg-layer"),
		$msg: null,
		init: function () {
			this.bindEvents();
		},
		bindEvents: function () {
			(p.$open.on("click", p.open),
				p.$close.on("click", p.close),
				p.$closeSmall.on("click", p.closeSmall),
				p.$layer.on("click", p.close));
		},
		open: function (e) {
			e.preventDefault();
			var n = Ht(this).data("msg");
			((p.$msg = Ht(".js-msg-" + n)),
				p.$msg.addClass("is-open"),
				p.$layer.addClass("is-open"));
		},
		close: function (e) {
			(e.preventDefault(),
				(p.$msg = Ht(".js-msg")),
				p.$msg.removeClass("is-open"),
				p.$layer.removeClass("is-open"));
		},
		closeSmall: function (e) {
			(e.preventDefault(), (p.$msg = Ht(this).parent()), p.$msg.hide());
		},
	};
	p.init();
});
function _p() {
	let p = !1;
	return (
		/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
			navigator.userAgent || navigator.vendor || window.opera,
		) && (p = !0),
		p
	);
}
const wl = window.matchMedia("(prefers-reduced-motion)");
function vp() {
	let p = Ht("body");
	(p.hasClass("no-js") && p.removeClass("no-js"),
		_p() && !p.hasClass("is-touch") && Ht("body").addClass("is-touch"));
}
function Xa(p, e = 0, n = 800, r = !0) {
	Ht(p).length &&
		Ht("html, body")
			.stop()
			.animate({ scrollTop: Ht(p).offset().top - e }, n, function () {
				r && (window.location.hash = p);
			});
}
/*!
 *
 * jQuery AJAX Form Plugin
 *
 * Authors: Philipp Sterker
 *
 * based on jQuery lightweight plugin boilerplate
 * Original author: @ajpiano
 * Further changes, comments: @addyosmani
 * Licensed under the MIT license
 *
 * Last updated: 23.11.2023
 * Dependencies: jQuery
 */ (function (p, e, n) {
	const r = "ajaxForm",
		s = {
			validationUrl: "/form/",
			$form: p(".js-form"),
			csrfTokenUrl: "/app/form/getCsrfToken",
			invalidClass: "is-invalid",
			formErrorClass: "field__error",
			hasErrorsClass: "has-errors",
			formFieldClass: "field",
			formAlertClass: "form__alert",
			headerClass: "header",
			scrollOffset: 30,
		};
	function u(l, h) {
		((this.element = l),
			(this.options = p.extend({}, s, h)),
			(this._defaults = s),
			(this._name = r),
			(this._settings = {
				$form: null,
				$csrfToken: null,
				$turnstileField: null,
				validationUrl: null,
				formData: null,
				$formFields: null,
				$submitBtn: null,
				$header: null,
				$alert: null,
			}),
			this.init());
	}
	((u.prototype = {
		init: function () {
			((this._settings.$form = p(this.element)),
				(this._settings.validationUrl = this._settings.$form.attr("action")),
				(this._settings.$csrfToken = this._settings.$form.find(
					'input[name="csrf_token"',
				)),
				(this._settings.$turnstileField = this._settings.$form.find(
					'input[data-turnstile-response],input[name="cf-turnstile-response"]',
				)),
				(this._settings.$formFields = this._settings.$form.find(
					"." + this.options.formFieldClass,
				)),
				(this._settings.$submitBtn = this._settings.$form.find(
					'button[type="submit"]',
				)),
				(this._settings.$header = p("." + this.options.headerClass)),
				this._settings.$form.find('input[name="ajax"]').attr("value", !0),
				(this._settings.$alert = this._settings.$form.find(
					"." + this.options.formAlertClass,
				)),
				this.getCsrfToken(),
				this.bindEvents());
		},
		bindEvents: function () {
			this._settings.$form.on("submit", { self: this }, this.submitForm);
		},
		async submitForm(l) {
			l.preventDefault();
			const h = l.data.self,
				f = new FormData(p(this)[0]),
				v = h._settings.$formFields,
				w = v.find("input,select,textarea"),
				A = v.find("." + h.options.formErrorClass);
			(v.removeClass(h.options.hasErrorsClass),
				w
					.removeClass(h.options.invalidClass)
					.removeAttr("aria-invalid")
					.removeAttr("aria-describedBy"),
				A.html("").attr("aria-hidden", !0),
				h._settings.$submitBtn.attr("disabled", !0).attr("aria-busy", !0),
				h._settings.$alert
					.html("")
					.removeAttr("data-type")
					.attr("aria-hidden", !0));
			if (h.requiresTurnstile() && h.hasTurnstileResponse() === !1 && h.shouldFailOpen() === !1) {
				h.handleTurnstileError();
				h._settings.$submitBtn.attr("disabled", !1).attr("aria-busy", !1);
				return;
			}
			try {
				const D = await fetch(h._settings.validationUrl, {
						method: "POST",
						body: f,
					}),
					C = await D.json();
				D.ok ? h.handleSuccess(C) : h.handleError(D, C);
			} catch (D) {
				console.error("Error submitting form:", D);
			} finally {
				h.resetTurnstile();
				h._settings.$submitBtn.attr("disabled", !1).attr("aria-busy", !1);
			}
		},
		requiresTurnstile: function () {
			return this._settings.$form.data("turnstile-enabled") === !0;
		},
		shouldFailOpen: function () {
			return this._settings.$form.data("turnstile-fail-open") === !0;
		},
		hasTurnstileResponse: function () {
			return this._settings.$turnstileField.length === 0 || this._settings.$turnstileField.val() !== "";
		},
		handleTurnstileError: function () {
			const l = this._settings.$form.find("#field-cf-turnstile-response"),
				h = l.find("." + this.options.formErrorClass),
				f = this._settings.$turnstileField,
				v = f.data("turnstile-required-message") || "Please confirm that you are not a robot.";
			l.addClass(this.options.hasErrorsClass),
				f.addClass(this.options.invalidClass)
					.attr("aria-invalid", !0)
					.attr("aria-describedBy", "field-error-cf-turnstile-response"),
				h.html(v).attr("aria-hidden", !1),
				this.scrollToError();
		},
		resetTurnstile: function () {
			const l = this._settings.$form.attr("id"),
				h = document.getElementById(l),
				f = h == null ? void 0 : h.dataset.turnstileWidgetId;
			(this._settings.$turnstileField.val(""),
				window.turnstile && typeof f < "u" && window.turnstile.reset(f));
		},
		handleSuccess: function (l) {
			const h = this;
			(h._settings.$alert
				.html("<p><strong>" + l.headline + "</strong><br />" + l.text + "</p>")
				.attr("data-type", "success")
				.attr("aria-hidden", !1),
				h._settings.$form[0].reset(),
				h.scrollToSuccess());
		},
		handleError: function (l, h) {
			const f = this;
			if (l.status === 400) {
				const w = h.errors;
				(p.each(w, function (A, D) {
					const C = f._settings.$form.find("#field-" + A),
						O = C.find("input,select,textarea"),
						P = C.find("." + f.options.formErrorClass);
					(C.addClass(f.options.hasErrorsClass),
						O.addClass(f.options.invalidClass)
							.attr("aria-invalid", !0)
							.attr("aria-describedBy", "field-error-" + A),
						P.html(D).attr("aria-hidden", !1));
				}),
					f.scrollToError());
			}
			const v = h.message;
			f._settings.$alert
				.html("<p><strong>" + v.headline + "</strong><br />" + v.text + "</p>")
				.attr("data-type", "error")
				.attr("aria-hidden", !1);
		},
		getCsrfToken: function () {
			const l = this;
			p.ajax({
				type: "GET",
				dataType: "json",
				url: hlKirbyUrl(this.options.csrfTokenUrl),
				cache: !1,
				success: function (h) {
					l._settings.$csrfToken.val(h.token);
				},
			});
		},
		isFixedHeader: function () {
			return this._settings.$header.css("position") === "fixed";
		},
		scrollToError: function () {
			const l = p(
				"." + this.options.formFieldClass + "." + this.options.hasErrorsClass,
			).first();
			let h = this.options.scrollOffset;
			(this.isFixedHeader() && (h = h + this._settings.$header.outerHeight()),
				Xa(l, h, 800, !1));
		},
		scrollToSuccess: function () {
			const l = p("#" + this._settings.$form.attr("id"));
			let h = this.options.scrollOffset;
			(this.isFixedHeader() && (h = h + this._settings.$header.outerHeight()),
				Xa(l, h, 800, !1));
		},
	}),
		(p.fn[r] = function (l) {
			return this.each(function () {
				p.data(this, "plugin_" + r) ||
					p.data(this, "plugin_" + r, new u(this, l));
			});
		}));
})(Ht);
Ht(document).ready(function () {
	function p(e) {
		var n = Ht(window).scrollTop(),
			r = Ht(".js-sticky-wrapper"),
			s = e,
			u = s.outerHeight(),
			l = r.offset().top;
		n >= l
			? (s.addClass("is-sticky"), r.height(u))
			: (s.removeClass("is-sticky"), r.height(""));
	}
	Ht(window).on("scroll load", function () {
		Ht(".js-sticky-wrapper").length > 0 && p(Ht(".js-sticky"));
	});
});
Ht(".js-animate-download").click(function (p) {
	(p.preventDefault(),
		Ht(this).attr("href"),
		setTimeout(function () {
			console.log("Download!");
		}, 4e3),
		Ht(this).toggleClass("is-animated"));
});
Ht(".js-start-progress").on("click", function (p) {
	p.preventDefault();
	var e = Ht(this).next();
	e.toggleClass("is-animated");
});
Ht(".js-play-video").on("click", function () {
	var p = Ht(this).data("embed"),
		e = Ht(this).data("type"),
		n = "";
	(e === "vimeo"
		? (n =
				'<iframe width="853" height="480" src="https://player.vimeo.com/video/' +
				p +
				'?autoplay=1&?dnt=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>')
		: e === "youtube" &&
			(n =
				'<iframe width="853" height="480" src="https://www.youtube-nocookie.com/embed/' +
				p +
				'?rel=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'),
		Ht(this).parent().html(n));
});
class yp {
	constructor() {
		((this.openSearchBtn = document.querySelector(".js-open-search")),
			(this.closeSearchBtn = document.querySelector(".js-close-search")),
			(this.navigation = document.querySelector("#navigation")),
			(this.searchField = document.querySelector("#search-field")),
			(this.logo = document.querySelector(".logo")),
			this.init());
	}
	init() {
		this.openSearchBtn &&
			this.closeSearchBtn &&
			(this.openSearchBtn.addEventListener("click", () => this.openSearch()),
			this.closeSearchBtn.addEventListener("click", () => this.closeSearch()));
	}
	openSearch() {
		(this.searchField.classList.toggle("visible"),
			this.searchField.classList.toggle("hidden"),
			window.innerWidth <= 768 && this.toggleLogo(!1));
	}
	closeSearch() {
		(this.toggleSearchField(!1),
			window.innerWidth <= 768 && this.toggleLogo(!0));
	}
	toggleSearchField(e) {
		e
			? (this.searchField.classList.remove("hidden"),
				this.searchField.classList.add("visible"))
			: (this.searchField.classList.remove("visible"),
				this.searchField.classList.add("hidden"));
	}
	toggleLogo(e) {
		this.logo &&
			(e
				? this.logo.classList.remove("hidden")
				: this.logo.classList.add("hidden"));
	}
}
document.addEventListener("DOMContentLoaded", () => {
	new yp();
});
class bp {
	constructor() {
		((this.megaMenus = document.querySelectorAll(
			".header [data-mega-menu-id]",
		)),
			(this.megaMenusNavLinks = document.querySelectorAll(
				".header [data-mega-menu-nav-id]",
			)),
			(this.megaMenusNavLinksAnchors = document.querySelectorAll(
				".header [data-mega-menu-id] a",
			)),
			(this.megaMenusNavLinksAll = [
				...this.megaMenusNavLinks,
				...this.megaMenusNavLinksAnchors,
			]),
			(this.overlay = null),
			(this.currentNavLink = null),
			(this.currentMegaMenu = null),
			this.initializeEventListeners());
	}
	initializeEventListeners() {
		(this.megaMenusNavLinks.forEach((e) => {
			(e.addEventListener("mouseenter", () => {
				e.classList.contains("is-active") || this.openMegaMenu(e);
			}),
				e.addEventListener("mouseleave", (r) => {
					this.closeOnMouseLeave(r, e);
				}));
			const n = e.nextElementSibling;
			n &&
				n.addEventListener("mouseleave", (r) => {
					this.closeOnMouseLeave(r, e);
				});
		}),
			this.megaMenusNavLinksAll.forEach((e) => {
				e.addEventListener("focusout", (n) => {
					var s;
					(((s = this.currentMegaMenu) == null
						? void 0
						: s.contains(n.relatedTarget)) ??
						!1) ||
						this.close();
				});
			}));
	}
	closeOnMouseLeave(e, n) {
		var u;
		const r = e.relatedTarget;
		!n.contains(r) &&
			!((u = this.currentMegaMenu) != null && u.contains(r)) &&
			this.close();
	}
	close() {
		(this.closeAllMegaMenus(), this.removeOverlay());
	}
	openMegaMenu(e) {
		const n = this.getMatchingMegaMenu(e)[0] ?? null;
		((this.currentMegaMenu = n),
			(this.currentNavLink = e),
			this.closeAllMegaMenus(),
			this.currentMegaMenu &&
				(this.currentNavLink.classList.add("is-active"),
				this.currentMegaMenu.classList.add("is-active"),
				this.addOverlay()));
	}
	closeAllMegaMenus() {
		(this.megaMenusNavLinks.forEach((e) => {
			e.classList.remove("is-active");
		}),
			this.megaMenus.forEach((e) => {
				e.classList.remove("is-active");
			}));
	}
	getMatchingMegaMenu(e) {
		const n = this.megaMenus,
			r = e.getAttribute("data-mega-menu-nav-id") ?? null;
		return Array.from(n).filter(
			(s) => s.getAttribute("data-mega-menu-id") === r,
		);
	}
	createOverlay() {
		var n;
		const e = document.createElement("div");
		return (
			e.classList.add("overlay"),
			(e.style.zIndex = this.getZIndex(this.currentMegaMenu) - 1),
			this.currentMegaMenu.appendChild(e),
			(n = this.overlay) == null || n.remove(),
			(this.overlay = e),
			e
		);
	}
	addOverlay() {
		this.createOverlay().addEventListener("click", () => {
			this.close();
		});
	}
	removeOverlay() {
		var e;
		(e = this.overlay) == null || e.remove();
	}
	getZIndex(e) {
		const n = window.getComputedStyle(e);
		return parseInt(n.zIndex) ?? 0;
	}
}
window.addEventListener("DOMContentLoaded", () => {
	new bp();
});
class xp {
	constructor() {
		((this.slides = document.querySelectorAll(".hero-slider__slide")),
			(this.currentSlide = 0),
			(this.totalSlides = this.slides.length),
			(this.prevButtons = document.querySelectorAll(".prev-slide")),
			(this.nextButtons = document.querySelectorAll(".next-slide")),
			(this.sliderCounts = document.querySelectorAll(".slider-count")),
			this.prevButtons.forEach((e) =>
				e.addEventListener("click", () => this.showPrevSlide()),
			),
			this.nextButtons.forEach((e) =>
				e.addEventListener("click", () => this.showNextSlide()),
			),
			this.showSlide(this.currentSlide));
	}
	showSlide(e) {
		(this.slides.forEach((n) => n.classList.remove("is-active")),
			this.slides[e].classList.add("is-active"),
			this.updateSliderCount(e));
	}
	showPrevSlide() {
		((this.currentSlide =
			this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1),
			this.showSlide(this.currentSlide));
	}
	showNextSlide() {
		((this.currentSlide =
			this.currentSlide === this.totalSlides - 1 ? 0 : this.currentSlide + 1),
			this.showSlide(this.currentSlide));
	}
	updateSliderCount(e) {
		this.sliderCounts.forEach(
			(n) => (n.textContent = `${e + 1}/${this.totalSlides}`),
		);
	}
}
document.querySelectorAll(".js-hero-slider").forEach((p) => {
	new xp(p);
});
class wp {
	constructor(e) {
		((this.wrapper = e),
			(this.container = e.querySelector(".article-cards")),
			(this.cards = e.querySelectorAll(".slider__item")),
			(this.arrowRight = e.querySelector(".slider-arrow--right")),
			(this.arrowLeft = e.querySelector(".slider-arrow--left")),
			(this.cardWidth = this.calculateCardWidth()),
			(this.currentIndex = 0),
			this.init());
	}
	init() {
		(this.arrowRight.addEventListener("click", () => this.slideNext()),
			this.arrowLeft.addEventListener("click", () => this.slidePrev()),
			this.container.addEventListener("scroll", () =>
				this.updateArrowVisibility(),
			),
			window.addEventListener("resize", () => this.handleResize()),
			this.updateArrowVisibility());
	}
	handleResize() {
		this.updateArrowVisibility();
	}
	calculateCardWidth() {
		return this.cards[0].offsetWidth + 30;
	}
	slideNext() {
		this.cardWidth = this.calculateCardWidth();
		const e = this.container.scrollWidth - this.container.clientWidth;
		(this.container.scrollLeft + this.cardWidth < e
			? (this.container.scrollLeft += this.cardWidth)
			: (this.container.scrollLeft = e),
			this.updateArrowVisibility());
	}
	slidePrev() {
		((this.cardWidth = this.calculateCardWidth()),
			this.container.scrollLeft > 0
				? (this.container.scrollLeft -= this.cardWidth)
				: (this.container.scrollLeft = 0),
			this.updateArrowVisibility());
	}
	updateArrowVisibility() {
		const e = this.container.scrollWidth - this.container.clientWidth;
		this.cards.length > 2
			? (this.arrowRight.classList.add("is-active"),
				this.container.scrollLeft > 0
					? this.arrowLeft.classList.add("is-active")
					: this.arrowLeft.classList.remove("is-active"),
				this.container.scrollLeft > 0 && this.container.scrollLeft >= e - 1
					? this.arrowRight.classList.remove("is-active")
					: this.arrowRight.classList.add("is-active"))
			: this.cards.length === 2
				? window.innerWidth < 600
					? (this.arrowRight.classList.add("is-active"),
						this.arrowLeft.classList.remove("is-active"),
						this.container.scrollLeft > 0 &&
							this.arrowLeft.classList.add("is-active"),
						this.container.scrollLeft >= e - 1 &&
							this.arrowRight.classList.remove("is-active"))
					: (this.arrowLeft.classList.remove("is-active"),
						this.arrowRight.classList.remove("is-active"))
				: (this.arrowLeft.classList.remove("is-active"),
					this.arrowRight.classList.remove("is-active"));
	}
}
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".js-cards-slider").forEach((e) => new wp(e));
});
class Sp {
	constructor(e) {
		((this.cards = e.querySelectorAll(".grid-card")),
			(this.totalSlides = this.cards.length),
			(this.currentSlide = 1),
			(this.sliderCounts = e.querySelectorAll(".slider-count")),
			(this.isMobile = window.matchMedia("(max-width: 768px)").matches),
			this.isMobile && e !== null
				? (this.updateSliderCount(this.currentSlide), this.initScrollSpy())
				: this.setDefaultCounterText(),
			window.addEventListener("resize", this.handleResize.bind(this)));
	}
	handleResize() {
		const e = this.isMobile;
		((this.isMobile = window.matchMedia("(max-width: 768px)").matches),
			this.isMobile && !e
				? (this.updateSliderCount(this.currentSlide), this.initScrollSpy())
				: !this.isMobile && e && this.setDefaultCounterText());
	}
	initScrollSpy() {
		const e = { root: null, rootMargin: "0px", threshold: 0.5 },
			n = new IntersectionObserver((r) => {
				r.forEach((s) => {
					const u = Array.from(this.cards).indexOf(s.target);
					s.isIntersecting && this.updateSliderCount(u);
				});
			}, e);
		this.cards.forEach((r) => n.observe(r));
	}
	updateSliderCount(e) {
		e !== this.currentSlide &&
			((this.currentSlide = e),
			this.sliderCounts.forEach(
				(n) => (n.textContent = `${e + 1}/${this.totalSlides}`),
			));
	}
	setDefaultCounterText() {
		this.sliderCounts.forEach((e) => (e.textContent = `1/${this.totalSlides}`));
	}
}
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".js-grid-mobile-slider").forEach((e) => new Sp(e));
});
function dh(p) {
	var e = p.getDate(),
		n = p.getMonth() + 1,
		r = p.getFullYear();
	return (
		e < 10 && (e = "0" + e),
		n < 10 && (n = "0" + n),
		r + "-" + n + "-" + e
	);
}
const ph = document.getElementById("btn-tax-calc"),
	mh = document.getElementById("btn-reset-tax-calc");
ph &&
	ph.addEventListener("click", function () {
		let p = document.getElementById("dateFrom").value,
			e = document.getElementById("dateTo").value,
			n = parseInt(document.getElementById("reduced").value, 10) || 0,
			r = parseInt(document.getElementById("adults").value, 10) || 0,
			s = this.dataset.lang,
			u = parseFloat(document.getElementById("adults").dataset.priceA),
			l = parseFloat(document.getElementById("adults").dataset.priceB),
			h = parseFloat(document.getElementById("reduced").dataset.priceA),
			f = parseFloat(document.getElementById("reduced").dataset.priceB),
			v = new Date(p),
			w = new Date(e);
		if (w < v) {
			alert(
				s === "de"
					? "Abreisetag muss nach Anreisetag liegen."
					: "Departure day must be after the arrival day.",
			);
			return;
		}
		let A = 0,
			D = new Date(v);
		for (; D <= w; ) {
			let C = D.getMonth();
			(C >= 3 && C <= 9 ? (A += r * u + n * h) : (A += r * l + n * f),
				D.setDate(D.getDate() + 1));
		}
		document.getElementById("tax-result").textContent =
			A.toFixed(2).replace(".", ",") + " €";
	});
mh &&
	mh.addEventListener("click", function () {
		var p = new Date(),
			e = new Date();
		(e.setDate(p.getDate() + 7),
			(document.getElementById("dateFrom").value = dh(p)),
			(document.getElementById("dateTo").value = dh(e)),
			(document.getElementById("children").value = 0),
			(document.getElementById("reduced").value = 0),
			(document.getElementById("adults").value = 0),
			(document.getElementById("tax-result").textContent = "0.00 €"));
	});
class Tp {
	constructor(e) {
		((this.root = e || document),
			(this.categoryField = this.root.querySelector("#category-field")),
			(this.categorySelect = this.root.querySelector("#select-category")),
			(this.subcategoryField = this.root.querySelector("#subcategory-field")),
			(this.subcategorySelect = this.root.querySelector("#select-subcategory")),
			!(
				!this.categorySelect ||
				!this.subcategorySelect ||
				!this.subcategoryField ||
				!this.categoryField
			) && (this.initializeEventListeners(), this.updateSubcategories()));
	}
	initializeEventListeners() {
		this.categorySelect.addEventListener("change", () => {
			this.updateSubcategories();
		});
	}
	updateSubcategories() {
		const e = this.categorySelect.options[this.categorySelect.selectedIndex];
		if (!e || !e.value) {
			(this.closesubcategoryField(),
				this.filterSubcategoryOptions([]),
				this.setFieldWidths(!1));
			return;
		}
		const r = (e.getAttribute("data-subcategories") || "")
			.split(",")
			.map((s) => s.trim())
			.filter(Boolean);
		if (!r.length) {
			(this.closesubcategoryField(),
				this.filterSubcategoryOptions([]),
				this.setFieldWidths(!1));
			return;
		}
		(this.opensubcategoryField(),
			this.setFieldWidths(!0),
			this.filterSubcategoryOptions(r));
	}
	filterSubcategoryOptions(e) {
		const n = new Set(e);
		Array.from(this.subcategorySelect.options).forEach((s) => {
			const u = s.value;
			if (!u) {
				((s.disabled = !1), (s.hidden = !1));
				return;
			}
			const l = n.has(u);
			((s.disabled = !l),
				(s.hidden = !l),
				!l && s.selected && (s.selected = !1));
		});
	}
	opensubcategoryField() {
		this.subcategoryField.classList.add("is-active");
	}
	closesubcategoryField() {
		this.subcategoryField.classList.remove("is-active");
	}
	setFieldWidths(e) {
		this.categoryField &&
			(e
				? (this.categoryField.classList.remove("field--1-2"),
					this.categoryField.classList.add("field--1-4"))
				: (this.categoryField.classList.remove("field--1-4"),
					this.categoryField.classList.add("field--1-2")));
	}
}
window.addEventListener("DOMContentLoaded", () => {
	const p = document.querySelector("#js-events");
	p && new Tp(p);
});
function xs(p) {
	if (p === void 0)
		throw new ReferenceError(
			"this hasn't been initialised - super() hasn't been called",
		);
	return p;
}
function yf(p, e) {
	((p.prototype = Object.create(e.prototype)),
		(p.prototype.constructor = p),
		(p.__proto__ = e));
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */ var Sr = {
		autoSleep: 120,
		force3D: "auto",
		nullTargetWarn: 1,
		units: { lineHeight: "" },
	},
	la = { duration: 0.5, overwrite: !1, delay: 0 },
	Mc,
	Sn,
	_i,
	Br = 1e8,
	ai = 1 / Br,
	rc = Math.PI * 2,
	Ep = rc / 4,
	Cp = 0,
	bf = Math.sqrt,
	Pp = Math.cos,
	Lp = Math.sin,
	sn = function (e) {
		return typeof e == "string";
	},
	Oi = function (e) {
		return typeof e == "function";
	},
	Ps = function (e) {
		return typeof e == "number";
	},
	Oc = function (e) {
		return typeof e > "u";
	},
	ls = function (e) {
		return typeof e == "object";
	},
	or = function (e) {
		return e !== !1;
	},
	Dc = function () {
		return typeof window < "u";
	},
	yu = function (e) {
		return Oi(e) || sn(e);
	},
	xf =
		(typeof ArrayBuffer == "function" && ArrayBuffer.isView) || function () {},
	Tn = Array.isArray,
	sc = /(?:-?\.?\d|\.)+/gi,
	wf = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
	Qo = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
	Sl = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
	Sf = /[+-]=-?[.\d]+/,
	Tf = /[^,'"\[\]\s]+/gi,
	kp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
	Ei,
	is,
	oc,
	Ic,
	Tr = {},
	Wu = {},
	Ef,
	Cf = function (e) {
		return (Wu = Po(e, Tr)) && cr;
	},
	Bc = function (e, n) {
		return console.warn(
			"Invalid property",
			e,
			"set to",
			n,
			"Missing plugin? gsap.registerPlugin()",
		);
	},
	Ya = function (e, n) {
		return !n && console.warn(e);
	},
	Pf = function (e, n) {
		return (e && (Tr[e] = n) && Wu && (Wu[e] = n)) || Tr;
	},
	Ka = function () {
		return 0;
	},
	Ap = { suppressEvents: !0, isStart: !0, kill: !1 },
	Du = { suppressEvents: !0, kill: !1 },
	Mp = { suppressEvents: !0 },
	zc = {},
	js = [],
	ac = {},
	Lf,
	yr = {},
	Tl = {},
	gh = 30,
	Iu = [],
	Nc = "",
	Rc = function (e) {
		var n = e[0],
			r,
			s;
		if ((ls(n) || Oi(n) || (e = [e]), !(r = (n._gsap || {}).harness))) {
			for (s = Iu.length; s-- && !Iu[s].targetTest(n); );
			r = Iu[s];
		}
		for (s = e.length; s--; )
			(e[s] && (e[s]._gsap || (e[s]._gsap = new Jf(e[s], r)))) ||
				e.splice(s, 1);
		return e;
	},
	bo = function (e) {
		return e._gsap || Rc(zr(e))[0]._gsap;
	},
	kf = function (e, n, r) {
		return (r = e[n]) && Oi(r)
			? e[n]()
			: (Oc(r) && e.getAttribute && e.getAttribute(n)) || r;
	},
	ar = function (e, n) {
		return (e = e.split(",")).forEach(n) || e;
	},
	Ni = function (e) {
		return Math.round(e * 1e5) / 1e5 || 0;
	},
	rn = function (e) {
		return Math.round(e * 1e7) / 1e7 || 0;
	},
	ia = function (e, n) {
		var r = n.charAt(0),
			s = parseFloat(n.substr(2));
		return (
			(e = parseFloat(e)),
			r === "+" ? e + s : r === "-" ? e - s : r === "*" ? e * s : e / s
		);
	},
	Op = function (e, n) {
		for (var r = n.length, s = 0; e.indexOf(n[s]) < 0 && ++s < r; );
		return s < r;
	},
	Zu = function () {
		var e = js.length,
			n = js.slice(0),
			r,
			s;
		for (ac = {}, js.length = 0, r = 0; r < e; r++)
			((s = n[r]),
				s && s._lazy && (s.render(s._lazy[0], s._lazy[1], !0)._lazy = 0));
	},
	Af = function (e, n, r, s) {
		(js.length && !Sn && Zu(),
			e.render(n, r, s || (Sn && n < 0 && (e._initted || e._startAt))),
			js.length && !Sn && Zu());
	},
	Mf = function (e) {
		var n = parseFloat(e);
		return (n || n === 0) && (e + "").match(Tf).length < 2
			? n
			: sn(e)
				? e.trim()
				: e;
	},
	Of = function (e) {
		return e;
	},
	Rr = function (e, n) {
		for (var r in n) r in e || (e[r] = n[r]);
		return e;
	},
	Dp = function (e) {
		return function (n, r) {
			for (var s in r)
				s in n || (s === "duration" && e) || s === "ease" || (n[s] = r[s]);
		};
	},
	Po = function (e, n) {
		for (var r in n) e[r] = n[r];
		return e;
	},
	_h = function p(e, n) {
		for (var r in n)
			r !== "__proto__" &&
				r !== "constructor" &&
				r !== "prototype" &&
				(e[r] = ls(n[r]) ? p(e[r] || (e[r] = {}), n[r]) : n[r]);
		return e;
	},
	ju = function (e, n) {
		var r = {},
			s;
		for (s in e) s in n || (r[s] = e[s]);
		return r;
	},
	Na = function (e) {
		var n = e.parent || Ei,
			r = e.keyframes ? Dp(Tn(e.keyframes)) : Rr;
		if (or(e.inherit))
			for (; n; ) (r(e, n.vars.defaults), (n = n.parent || n._dp));
		return e;
	},
	Ip = function (e, n) {
		for (var r = e.length, s = r === n.length; s && r-- && e[r] === n[r]; );
		return r < 0;
	},
	Df = function (e, n, r, s, u) {
		(r === void 0 && (r = "_first"), s === void 0 && (s = "_last"));
		var l = e[s],
			h;
		if (u) for (h = n[u]; l && l[u] > h; ) l = l._prev;
		return (
			l ? ((n._next = l._next), (l._next = n)) : ((n._next = e[r]), (e[r] = n)),
			n._next ? (n._next._prev = n) : (e[s] = n),
			(n._prev = l),
			(n.parent = n._dp = e),
			n
		);
	},
	el = function (e, n, r, s) {
		(r === void 0 && (r = "_first"), s === void 0 && (s = "_last"));
		var u = n._prev,
			l = n._next;
		(u ? (u._next = l) : e[r] === n && (e[r] = l),
			l ? (l._prev = u) : e[s] === n && (e[s] = u),
			(n._next = n._prev = n.parent = null));
	},
	Vs = function (e, n) {
		(e.parent &&
			(!n || e.parent.autoRemoveChildren) &&
			e.parent.remove &&
			e.parent.remove(e),
			(e._act = 0));
	},
	xo = function (e, n) {
		if (e && (!n || n._end > e._dur || n._start < 0))
			for (var r = e; r; ) ((r._dirty = 1), (r = r.parent));
		return e;
	},
	Bp = function (e) {
		for (var n = e.parent; n && n.parent; )
			((n._dirty = 1), n.totalDuration(), (n = n.parent));
		return e;
	},
	uc = function (e, n, r, s) {
		return (
			e._startAt &&
			(Sn
				? e._startAt.revert(Du)
				: (e.vars.immediateRender && !e.vars.autoRevert) ||
					e._startAt.render(n, !0, s))
		);
	},
	zp = function p(e) {
		return !e || (e._ts && p(e.parent));
	},
	vh = function (e) {
		return e._repeat ? ca(e._tTime, (e = e.duration() + e._rDelay)) * e : 0;
	},
	ca = function (e, n) {
		var r = Math.floor((e /= n));
		return e && r === e ? r - 1 : r;
	},
	Uu = function (e, n) {
		return (
			(e - n._start) * n._ts +
			(n._ts >= 0 ? 0 : n._dirty ? n.totalDuration() : n._tDur)
		);
	},
	il = function (e) {
		return (e._end = rn(
			e._start + (e._tDur / Math.abs(e._ts || e._rts || ai) || 0),
		));
	},
	nl = function (e, n) {
		var r = e._dp;
		return (
			r &&
				r.smoothChildTiming &&
				e._ts &&
				((e._start = rn(
					r._time -
						(e._ts > 0
							? n / e._ts
							: ((e._dirty ? e.totalDuration() : e._tDur) - n) / -e._ts),
				)),
				il(e),
				r._dirty || xo(r, e)),
			e
		);
	},
	If = function (e, n) {
		var r;
		if (
			((n._time ||
				(!n._dur && n._initted) ||
				(n._start < e._time && (n._dur || !n.add))) &&
				((r = Uu(e.rawTime(), n)),
				(!n._dur || su(0, n.totalDuration(), r) - n._tTime > ai) &&
					n.render(r, !0)),
			xo(e, n)._dp && e._initted && e._time >= e._dur && e._ts)
		) {
			if (e._dur < e.duration())
				for (r = e; r._dp; )
					(r.rawTime() >= 0 && r.totalTime(r._tTime), (r = r._dp));
			e._zTime = -ai;
		}
	},
	rs = function (e, n, r, s) {
		return (
			n.parent && Vs(n),
			(n._start = rn(
				(Ps(r) ? r : r || e !== Ei ? Or(e, r, n) : e._time) + n._delay,
			)),
			(n._end = rn(
				n._start + (n.totalDuration() / Math.abs(n.timeScale()) || 0),
			)),
			Df(e, n, "_first", "_last", e._sort ? "_start" : 0),
			lc(n) || (e._recent = n),
			s || If(e, n),
			e._ts < 0 && nl(e, e._tTime),
			e
		);
	},
	Bf = function (e, n) {
		return (
			(Tr.ScrollTrigger || Bc("scrollTrigger", n)) &&
			Tr.ScrollTrigger.create(n, e)
		);
	},
	zf = function (e, n, r, s, u) {
		if ((Hc(e, n, u), !e._initted)) return 1;
		if (
			!r &&
			e._pt &&
			!Sn &&
			((e._dur && e.vars.lazy !== !1) || (!e._dur && e.vars.lazy)) &&
			Lf !== br.frame
		)
			return (js.push(e), (e._lazy = [u, s]), 1);
	},
	Np = function p(e) {
		var n = e.parent;
		return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || p(n));
	},
	lc = function (e) {
		var n = e.data;
		return n === "isFromStart" || n === "isStart";
	},
	Rp = function (e, n, r, s) {
		var u = e.ratio,
			l =
				n < 0 ||
				(!n &&
					((!e._start && Np(e) && !(!e._initted && lc(e))) ||
						((e._ts < 0 || e._dp._ts < 0) && !lc(e))))
					? 0
					: 1,
			h = e._rDelay,
			f = 0,
			v,
			w,
			A;
		if (
			(h &&
				e._repeat &&
				((f = su(0, e._tDur, n)),
				(w = ca(f, h)),
				e._yoyo && w & 1 && (l = 1 - l),
				w !== ca(e._tTime, h) &&
					((u = 1 - l), e.vars.repeatRefresh && e._initted && e.invalidate())),
			l !== u || Sn || s || e._zTime === ai || (!n && e._zTime))
		) {
			if (!e._initted && zf(e, n, s, r, f)) return;
			for (
				A = e._zTime,
					e._zTime = n || (r ? ai : 0),
					r || (r = n && !A),
					e.ratio = l,
					e._from && (l = 1 - l),
					e._time = 0,
					e._tTime = f,
					v = e._pt;
				v;
			)
				(v.r(l, v.d), (v = v._next));
			(n < 0 && uc(e, n, r, !0),
				e._onUpdate && !r && wr(e, "onUpdate"),
				f && e._repeat && !r && e.parent && wr(e, "onRepeat"),
				(n >= e._tDur || n < 0) &&
					e.ratio === l &&
					(l && Vs(e, 1),
					!r &&
						!Sn &&
						(wr(e, l ? "onComplete" : "onReverseComplete", !0),
						e._prom && e._prom())));
		} else e._zTime || (e._zTime = n);
	},
	Fp = function (e, n, r) {
		var s;
		if (r > n)
			for (s = e._first; s && s._start <= r; ) {
				if (s.data === "isPause" && s._start > n) return s;
				s = s._next;
			}
		else
			for (s = e._last; s && s._start >= r; ) {
				if (s.data === "isPause" && s._start < n) return s;
				s = s._prev;
			}
	},
	ha = function (e, n, r, s) {
		var u = e._repeat,
			l = rn(n) || 0,
			h = e._tTime / e._tDur;
		return (
			h && !s && (e._time *= l / e._dur),
			(e._dur = l),
			(e._tDur = u ? (u < 0 ? 1e10 : rn(l * (u + 1) + e._rDelay * u)) : l),
			h > 0 && !s && nl(e, (e._tTime = e._tDur * h)),
			e.parent && il(e),
			r || xo(e.parent, e),
			e
		);
	},
	yh = function (e) {
		return e instanceof jn ? xo(e) : ha(e, e._dur);
	},
	Hp = { _start: 0, endTime: Ka, totalDuration: Ka },
	Or = function p(e, n, r) {
		var s = e.labels,
			u = e._recent || Hp,
			l = e.duration() >= Br ? u.endTime(!1) : e._dur,
			h,
			f,
			v;
		return sn(n) && (isNaN(n) || n in s)
			? ((f = n.charAt(0)),
				(v = n.substr(-1) === "%"),
				(h = n.indexOf("=")),
				f === "<" || f === ">"
					? (h >= 0 && (n = n.replace(/=/, "")),
						(f === "<" ? u._start : u.endTime(u._repeat >= 0)) +
							(parseFloat(n.substr(1)) || 0) *
								(v ? (h < 0 ? u : r).totalDuration() / 100 : 1))
					: h < 0
						? (n in s || (s[n] = l), s[n])
						: ((f = parseFloat(n.charAt(h - 1) + n.substr(h + 1))),
							v && r && (f = (f / 100) * (Tn(r) ? r[0] : r).totalDuration()),
							h > 1 ? p(e, n.substr(0, h - 1), r) + f : l + f))
			: n == null
				? l
				: +n;
	},
	Ra = function (e, n, r) {
		var s = Ps(n[1]),
			u = (s ? 2 : 1) + (e < 2 ? 0 : 1),
			l = n[u],
			h,
			f;
		if ((s && (l.duration = n[1]), (l.parent = r), e)) {
			for (h = l, f = r; f && !("immediateRender" in h); )
				((h = f.vars.defaults || {}), (f = or(f.vars.inherit) && f.parent));
			((l.immediateRender = or(h.immediateRender)),
				e < 2 ? (l.runBackwards = 1) : (l.startAt = n[u - 1]));
		}
		return new ji(n[0], l, n[u + 1]);
	},
	Ys = function (e, n) {
		return e || e === 0 ? n(e) : n;
	},
	su = function (e, n, r) {
		return r < e ? e : r > n ? n : r;
	},
	wn = function (e, n) {
		return !sn(e) || !(n = kp.exec(e)) ? "" : n[1];
	},
	qp = function (e, n, r) {
		return Ys(r, function (s) {
			return su(e, n, s);
		});
	},
	cc = [].slice,
	Nf = function (e, n) {
		return (
			e &&
			ls(e) &&
			"length" in e &&
			((!n && !e.length) || (e.length - 1 in e && ls(e[0]))) &&
			!e.nodeType &&
			e !== is
		);
	},
	Wp = function (e, n, r) {
		return (
			r === void 0 && (r = []),
			e.forEach(function (s) {
				var u;
				return (sn(s) && !n) || Nf(s, 1)
					? (u = r).push.apply(u, zr(s))
					: r.push(s);
			}) || r
		);
	},
	zr = function (e, n, r) {
		return _i && !n && _i.selector
			? _i.selector(e)
			: sn(e) && !r && (oc || !fa())
				? cc.call((n || Ic).querySelectorAll(e), 0)
				: Tn(e)
					? Wp(e, r)
					: Nf(e)
						? cc.call(e, 0)
						: e
							? [e]
							: [];
	},
	hc = function (e) {
		return (
			(e = zr(e)[0] || Ya("Invalid scope") || {}),
			function (n) {
				var r = e.current || e.nativeElement || e;
				return zr(
					n,
					r.querySelectorAll
						? r
						: r === e
							? Ya("Invalid scope") || Ic.createElement("div")
							: e,
				);
			}
		);
	},
	Rf = function (e) {
		return e.sort(function () {
			return 0.5 - Math.random();
		});
	},
	Ff = function (e) {
		if (Oi(e)) return e;
		var n = ls(e) ? e : { each: e },
			r = wo(n.ease),
			s = n.from || 0,
			u = parseFloat(n.base) || 0,
			l = {},
			h = s > 0 && s < 1,
			f = isNaN(s) || h,
			v = n.axis,
			w = s,
			A = s;
		return (
			sn(s)
				? (w = A = { center: 0.5, edges: 0.5, end: 1 }[s] || 0)
				: !h && f && ((w = s[0]), (A = s[1])),
			function (D, C, O) {
				var P = (O || n).length,
					F = l[P],
					G,
					B,
					j,
					V,
					Q,
					it,
					g,
					ct,
					ot;
				if (!F) {
					if (((ot = n.grid === "auto" ? 0 : (n.grid || [1, Br])[1]), !ot)) {
						for (
							g = -Br;
							g < (g = O[ot++].getBoundingClientRect().left) && ot < P;
						);
						ot < P && ot--;
					}
					for (
						F = l[P] = [],
							G = f ? Math.min(ot, P) * w - 0.5 : s % ot,
							B = ot === Br ? 0 : f ? (P * A) / ot - 0.5 : (s / ot) | 0,
							g = 0,
							ct = Br,
							it = 0;
						it < P;
						it++
					)
						((j = (it % ot) - G),
							(V = B - ((it / ot) | 0)),
							(F[it] = Q = v ? Math.abs(v === "y" ? V : j) : bf(j * j + V * V)),
							Q > g && (g = Q),
							Q < ct && (ct = Q));
					(s === "random" && Rf(F),
						(F.max = g - ct),
						(F.min = ct),
						(F.v = P =
							(parseFloat(n.amount) ||
								parseFloat(n.each) *
									(ot > P
										? P - 1
										: v
											? v === "y"
												? P / ot
												: ot
											: Math.max(ot, P / ot)) ||
								0) * (s === "edges" ? -1 : 1)),
						(F.b = P < 0 ? u - P : u),
						(F.u = wn(n.amount || n.each) || 0),
						(r = r && P < 0 ? Xf(r) : r));
				}
				return (
					(P = (F[D] - F.min) / F.max || 0),
					rn(F.b + (r ? r(P) : P) * F.v) + F.u
				);
			}
		);
	},
	fc = function (e) {
		var n = Math.pow(10, ((e + "").split(".")[1] || "").length);
		return function (r) {
			var s = rn(Math.round(parseFloat(r) / e) * e * n);
			return (s - (s % 1)) / n + (Ps(r) ? 0 : wn(r));
		};
	},
	Hf = function (e, n) {
		var r = Tn(e),
			s,
			u;
		return (
			!r &&
				ls(e) &&
				((s = r = e.radius || Br),
				e.values
					? ((e = zr(e.values)), (u = !Ps(e[0])) && (s *= s))
					: (e = fc(e.increment))),
			Ys(
				n,
				r
					? Oi(e)
						? function (l) {
								return ((u = e(l)), Math.abs(u - l) <= s ? u : l);
							}
						: function (l) {
								for (
									var h = parseFloat(u ? l.x : l),
										f = parseFloat(u ? l.y : 0),
										v = Br,
										w = 0,
										A = e.length,
										D,
										C;
									A--;
								)
									(u
										? ((D = e[A].x - h), (C = e[A].y - f), (D = D * D + C * C))
										: (D = Math.abs(e[A] - h)),
										D < v && ((v = D), (w = A)));
								return (
									(w = !s || v <= s ? e[w] : l),
									u || w === l || Ps(l) ? w : w + wn(l)
								);
							}
					: fc(e),
			)
		);
	},
	qf = function (e, n, r, s) {
		return Ys(Tn(e) ? !n : r === !0 ? !!(r = 0) : !s, function () {
			return Tn(e)
				? e[~~(Math.random() * e.length)]
				: (r = r || 1e-5) &&
						(s = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) &&
						Math.floor(
							Math.round((e - r / 2 + Math.random() * (n - e + r * 0.99)) / r) *
								r *
								s,
						) / s;
		});
	},
	Zp = function () {
		for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
			n[r] = arguments[r];
		return function (s) {
			return n.reduce(function (u, l) {
				return l(u);
			}, s);
		};
	},
	jp = function (e, n) {
		return function (r) {
			return e(parseFloat(r)) + (n || wn(r));
		};
	},
	Up = function (e, n, r) {
		return Zf(e, n, 0, 1, r);
	},
	Wf = function (e, n, r) {
		return Ys(r, function (s) {
			return e[~~n(s)];
		});
	},
	$p = function p(e, n, r) {
		var s = n - e;
		return Tn(e)
			? Wf(e, p(0, e.length), n)
			: Ys(r, function (u) {
					return ((s + ((u - e) % s)) % s) + e;
				});
	},
	Vp = function p(e, n, r) {
		var s = n - e,
			u = s * 2;
		return Tn(e)
			? Wf(e, p(0, e.length - 1), n)
			: Ys(r, function (l) {
					return ((l = (u + ((l - e) % u)) % u || 0), e + (l > s ? u - l : l));
				});
	},
	Ja = function (e) {
		for (var n = 0, r = "", s, u, l, h; ~(s = e.indexOf("random(", n)); )
			((l = e.indexOf(")", s)),
				(h = e.charAt(s + 7) === "["),
				(u = e.substr(s + 7, l - s - 7).match(h ? Tf : sc)),
				(r +=
					e.substr(n, s - n) + qf(h ? u : +u[0], h ? 0 : +u[1], +u[2] || 1e-5)),
				(n = l + 1));
		return r + e.substr(n, e.length - n);
	},
	Zf = function (e, n, r, s, u) {
		var l = n - e,
			h = s - r;
		return Ys(u, function (f) {
			return r + (((f - e) / l) * h || 0);
		});
	},
	Gp = function p(e, n, r, s) {
		var u = isNaN(e + n)
			? 0
			: function (C) {
					return (1 - C) * e + C * n;
				};
		if (!u) {
			var l = sn(e),
				h = {},
				f,
				v,
				w,
				A,
				D;
			if ((r === !0 && (s = 1) && (r = null), l))
				((e = { p: e }), (n = { p: n }));
			else if (Tn(e) && !Tn(n)) {
				for (w = [], A = e.length, D = A - 2, v = 1; v < A; v++)
					w.push(p(e[v - 1], e[v]));
				(A--,
					(u = function (O) {
						O *= A;
						var P = Math.min(D, ~~O);
						return w[P](O - P);
					}),
					(r = n));
			} else s || (e = Po(Tn(e) ? [] : {}, e));
			if (!w) {
				for (f in n) Fc.call(h, e, f, "get", n[f]);
				u = function (O) {
					return Zc(O, h) || (l ? e.p : e);
				};
			}
		}
		return Ys(r, u);
	},
	bh = function (e, n, r) {
		var s = e.labels,
			u = Br,
			l,
			h,
			f;
		for (l in s)
			((h = s[l] - n),
				h < 0 == !!r && h && u > (h = Math.abs(h)) && ((f = l), (u = h)));
		return f;
	},
	wr = function (e, n, r) {
		var s = e.vars,
			u = s[n],
			l = _i,
			h = e._ctx,
			f,
			v,
			w;
		if (u)
			return (
				(f = s[n + "Params"]),
				(v = s.callbackScope || e),
				r && js.length && Zu(),
				h && (_i = h),
				(w = f ? u.apply(v, f) : u.call(v)),
				(_i = l),
				w
			);
	},
	Aa = function (e) {
		return (
			Vs(e),
			e.scrollTrigger && e.scrollTrigger.kill(!!Sn),
			e.progress() < 1 && wr(e, "onInterrupt"),
			e
		);
	},
	ta,
	jf = [],
	Uf = function (e) {
		if (e)
			if (((e = (!e.name && e.default) || e), Dc() || e.headless)) {
				var n = e.name,
					r = Oi(e),
					s =
						n && !r && e.init
							? function () {
									this._props = [];
								}
							: e,
					u = {
						init: Ka,
						render: Zc,
						add: Fc,
						kill: cm,
						modifier: lm,
						rawVars: 0,
					},
					l = {
						targetTest: 0,
						get: 0,
						getSetter: Wc,
						aliases: {},
						register: 0,
					};
				if ((fa(), e !== s)) {
					if (yr[n]) return;
					(Rr(s, Rr(ju(e, u), l)),
						Po(s.prototype, Po(u, ju(e, l))),
						(yr[(s.prop = n)] = s),
						e.targetTest && (Iu.push(s), (zc[n] = 1)),
						(n =
							(n === "css" ? "CSS" : n.charAt(0).toUpperCase() + n.substr(1)) +
							"Plugin"));
				}
				(Pf(n, s), e.register && e.register(cr, s, ur));
			} else jf.push(e);
	},
	ei = 255,
	Ma = {
		aqua: [0, ei, ei],
		lime: [0, ei, 0],
		silver: [192, 192, 192],
		black: [0, 0, 0],
		maroon: [128, 0, 0],
		teal: [0, 128, 128],
		blue: [0, 0, ei],
		navy: [0, 0, 128],
		white: [ei, ei, ei],
		olive: [128, 128, 0],
		yellow: [ei, ei, 0],
		orange: [ei, 165, 0],
		gray: [128, 128, 128],
		purple: [128, 0, 128],
		green: [0, 128, 0],
		red: [ei, 0, 0],
		pink: [ei, 192, 203],
		cyan: [0, ei, ei],
		transparent: [ei, ei, ei, 0],
	},
	El = function (e, n, r) {
		return (
			(e += e < 0 ? 1 : e > 1 ? -1 : 0),
			((e * 6 < 1
				? n + (r - n) * e * 6
				: e < 0.5
					? r
					: e * 3 < 2
						? n + (r - n) * (2 / 3 - e) * 6
						: n) *
				ei +
				0.5) |
				0
		);
	},
	$f = function (e, n, r) {
		var s = e ? (Ps(e) ? [e >> 16, (e >> 8) & ei, e & ei] : 0) : Ma.black,
			u,
			l,
			h,
			f,
			v,
			w,
			A,
			D,
			C,
			O;
		if (!s) {
			if ((e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), Ma[e]))
				s = Ma[e];
			else if (e.charAt(0) === "#") {
				if (
					(e.length < 6 &&
						((u = e.charAt(1)),
						(l = e.charAt(2)),
						(h = e.charAt(3)),
						(e =
							"#" +
							u +
							u +
							l +
							l +
							h +
							h +
							(e.length === 5 ? e.charAt(4) + e.charAt(4) : ""))),
					e.length === 9)
				)
					return (
						(s = parseInt(e.substr(1, 6), 16)),
						[s >> 16, (s >> 8) & ei, s & ei, parseInt(e.substr(7), 16) / 255]
					);
				((e = parseInt(e.substr(1), 16)),
					(s = [e >> 16, (e >> 8) & ei, e & ei]));
			} else if (e.substr(0, 3) === "hsl") {
				if (((s = O = e.match(sc)), !n))
					((f = (+s[0] % 360) / 360),
						(v = +s[1] / 100),
						(w = +s[2] / 100),
						(l = w <= 0.5 ? w * (v + 1) : w + v - w * v),
						(u = w * 2 - l),
						s.length > 3 && (s[3] *= 1),
						(s[0] = El(f + 1 / 3, u, l)),
						(s[1] = El(f, u, l)),
						(s[2] = El(f - 1 / 3, u, l)));
				else if (~e.indexOf("="))
					return ((s = e.match(wf)), r && s.length < 4 && (s[3] = 1), s);
			} else s = e.match(sc) || Ma.transparent;
			s = s.map(Number);
		}
		return (
			n &&
				!O &&
				((u = s[0] / ei),
				(l = s[1] / ei),
				(h = s[2] / ei),
				(A = Math.max(u, l, h)),
				(D = Math.min(u, l, h)),
				(w = (A + D) / 2),
				A === D
					? (f = v = 0)
					: ((C = A - D),
						(v = w > 0.5 ? C / (2 - A - D) : C / (A + D)),
						(f =
							A === u
								? (l - h) / C + (l < h ? 6 : 0)
								: A === l
									? (h - u) / C + 2
									: (u - l) / C + 4),
						(f *= 60)),
				(s[0] = ~~(f + 0.5)),
				(s[1] = ~~(v * 100 + 0.5)),
				(s[2] = ~~(w * 100 + 0.5))),
			r && s.length < 4 && (s[3] = 1),
			s
		);
	},
	Vf = function (e) {
		var n = [],
			r = [],
			s = -1;
		return (
			e.split(Us).forEach(function (u) {
				var l = u.match(Qo) || [];
				(n.push.apply(n, l), r.push((s += l.length + 1)));
			}),
			(n.c = r),
			n
		);
	},
	xh = function (e, n, r) {
		var s = "",
			u = (e + s).match(Us),
			l = n ? "hsla(" : "rgba(",
			h = 0,
			f,
			v,
			w,
			A;
		if (!u) return e;
		if (
			((u = u.map(function (D) {
				return (
					(D = $f(D, n, 1)) &&
					l +
						(n ? D[0] + "," + D[1] + "%," + D[2] + "%," + D[3] : D.join(",")) +
						")"
				);
			})),
			r && ((w = Vf(e)), (f = r.c), f.join(s) !== w.c.join(s)))
		)
			for (v = e.replace(Us, "1").split(Qo), A = v.length - 1; h < A; h++)
				s +=
					v[h] +
					(~f.indexOf(h)
						? u.shift() || l + "0,0,0,0)"
						: (w.length ? w : u.length ? u : r).shift());
		if (!v)
			for (v = e.split(Us), A = v.length - 1; h < A; h++) s += v[h] + u[h];
		return s + v[A];
	},
	Us = (function () {
		var p =
				"(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
			e;
		for (e in Ma) p += "|" + e + "\\b";
		return new RegExp(p + ")", "gi");
	})(),
	Xp = /hsl[a]?\(/,
	Gf = function (e) {
		var n = e.join(" "),
			r;
		if (((Us.lastIndex = 0), Us.test(n)))
			return (
				(r = Xp.test(n)),
				(e[1] = xh(e[1], r)),
				(e[0] = xh(e[0], r, Vf(e[1]))),
				!0
			);
	},
	Qa,
	br = (function () {
		var p = Date.now,
			e = 500,
			n = 33,
			r = p(),
			s = r,
			u = 1e3 / 240,
			l = u,
			h = [],
			f,
			v,
			w,
			A,
			D,
			C,
			O = function P(F) {
				var G = p() - s,
					B = F === !0,
					j,
					V,
					Q,
					it;
				if (
					((G > e || G < 0) && (r += G - n),
					(s += G),
					(Q = s - r),
					(j = Q - l),
					(j > 0 || B) &&
						((it = ++A.frame),
						(D = Q - A.time * 1e3),
						(A.time = Q = Q / 1e3),
						(l += j + (j >= u ? 4 : u - j)),
						(V = 1)),
					B || (f = v(P)),
					V)
				)
					for (C = 0; C < h.length; C++) h[C](Q, D, it, F);
			};
		return (
			(A = {
				time: 0,
				frame: 0,
				tick: function () {
					O(!0);
				},
				deltaRatio: function (F) {
					return D / (1e3 / (F || 60));
				},
				wake: function () {
					Ef &&
						(!oc &&
							Dc() &&
							((is = oc = window),
							(Ic = is.document || {}),
							(Tr.gsap = cr),
							(is.gsapVersions || (is.gsapVersions = [])).push(cr.version),
							Cf(Wu || is.GreenSockGlobals || (!is.gsap && is) || {}),
							jf.forEach(Uf)),
						(w = typeof requestAnimationFrame < "u" && requestAnimationFrame),
						f && A.sleep(),
						(v =
							w ||
							function (F) {
								return setTimeout(F, (l - A.time * 1e3 + 1) | 0);
							}),
						(Qa = 1),
						O(2));
				},
				sleep: function () {
					((w ? cancelAnimationFrame : clearTimeout)(f), (Qa = 0), (v = Ka));
				},
				lagSmoothing: function (F, G) {
					((e = F || 1 / 0), (n = Math.min(G || 33, e)));
				},
				fps: function (F) {
					((u = 1e3 / (F || 240)), (l = A.time * 1e3 + u));
				},
				add: function (F, G, B) {
					var j = G
						? function (V, Q, it, g) {
								(F(V, Q, it, g), A.remove(j));
							}
						: F;
					return (A.remove(F), h[B ? "unshift" : "push"](j), fa(), j);
				},
				remove: function (F, G) {
					~(G = h.indexOf(F)) && h.splice(G, 1) && C >= G && C--;
				},
				_listeners: h,
			}),
			A
		);
	})(),
	fa = function () {
		return !Qa && br.wake();
	},
	De = {},
	Yp = /^[\d.\-M][\d.\-,\s]/,
	Kp = /["']/g,
	Jp = function (e) {
		for (
			var n = {},
				r = e.substr(1, e.length - 3).split(":"),
				s = r[0],
				u = 1,
				l = r.length,
				h,
				f,
				v;
			u < l;
			u++
		)
			((f = r[u]),
				(h = u !== l - 1 ? f.lastIndexOf(",") : f.length),
				(v = f.substr(0, h)),
				(n[s] = isNaN(v) ? v.replace(Kp, "").trim() : +v),
				(s = f.substr(h + 1).trim()));
		return n;
	},
	Qp = function (e) {
		var n = e.indexOf("(") + 1,
			r = e.indexOf(")"),
			s = e.indexOf("(", n);
		return e.substring(n, ~s && s < r ? e.indexOf(")", r + 1) : r);
	},
	tm = function (e) {
		var n = (e + "").split("("),
			r = De[n[0]];
		return r && n.length > 1 && r.config
			? r.config.apply(
					null,
					~e.indexOf("{") ? [Jp(n[1])] : Qp(e).split(",").map(Mf),
				)
			: De._CE && Yp.test(e)
				? De._CE("", e)
				: r;
	},
	Xf = function (e) {
		return function (n) {
			return 1 - e(1 - n);
		};
	},
	Yf = function p(e, n) {
		for (var r = e._first, s; r; )
			(r instanceof jn
				? p(r, n)
				: r.vars.yoyoEase &&
					(!r._yoyo || !r._repeat) &&
					r._yoyo !== n &&
					(r.timeline
						? p(r.timeline, n)
						: ((s = r._ease),
							(r._ease = r._yEase),
							(r._yEase = s),
							(r._yoyo = n))),
				(r = r._next));
	},
	wo = function (e, n) {
		return (e && (Oi(e) ? e : De[e] || tm(e))) || n;
	},
	Oo = function (e, n, r, s) {
		(r === void 0 &&
			(r = function (f) {
				return 1 - n(1 - f);
			}),
			s === void 0 &&
				(s = function (f) {
					return f < 0.5 ? n(f * 2) / 2 : 1 - n((1 - f) * 2) / 2;
				}));
		var u = { easeIn: n, easeOut: r, easeInOut: s },
			l;
		return (
			ar(e, function (h) {
				((De[h] = Tr[h] = u), (De[(l = h.toLowerCase())] = r));
				for (var f in u)
					De[
						l + (f === "easeIn" ? ".in" : f === "easeOut" ? ".out" : ".inOut")
					] = De[h + "." + f] = u[f];
			}),
			u
		);
	},
	Kf = function (e) {
		return function (n) {
			return n < 0.5 ? (1 - e(1 - n * 2)) / 2 : 0.5 + e((n - 0.5) * 2) / 2;
		};
	},
	Cl = function p(e, n, r) {
		var s = n >= 1 ? n : 1,
			u = (r || (e ? 0.3 : 0.45)) / (n < 1 ? n : 1),
			l = (u / rc) * (Math.asin(1 / s) || 0),
			h = function (w) {
				return w === 1 ? 1 : s * Math.pow(2, -10 * w) * Lp((w - l) * u) + 1;
			},
			f =
				e === "out"
					? h
					: e === "in"
						? function (v) {
								return 1 - h(1 - v);
							}
						: Kf(h);
		return (
			(u = rc / u),
			(f.config = function (v, w) {
				return p(e, v, w);
			}),
			f
		);
	},
	Pl = function p(e, n) {
		n === void 0 && (n = 1.70158);
		var r = function (l) {
				return l ? --l * l * ((n + 1) * l + n) + 1 : 0;
			},
			s =
				e === "out"
					? r
					: e === "in"
						? function (u) {
								return 1 - r(1 - u);
							}
						: Kf(r);
		return (
			(s.config = function (u) {
				return p(e, u);
			}),
			s
		);
	};
ar("Linear,Quad,Cubic,Quart,Quint,Strong", function (p, e) {
	var n = e < 5 ? e + 1 : e;
	Oo(
		p + ",Power" + (n - 1),
		e
			? function (r) {
					return Math.pow(r, n);
				}
			: function (r) {
					return r;
				},
		function (r) {
			return 1 - Math.pow(1 - r, n);
		},
		function (r) {
			return r < 0.5
				? Math.pow(r * 2, n) / 2
				: 1 - Math.pow((1 - r) * 2, n) / 2;
		},
	);
});
De.Linear.easeNone = De.none = De.Linear.easeIn;
Oo("Elastic", Cl("in"), Cl("out"), Cl());
(function (p, e) {
	var n = 1 / e,
		r = 2 * n,
		s = 2.5 * n,
		u = function (h) {
			return h < n
				? p * h * h
				: h < r
					? p * Math.pow(h - 1.5 / e, 2) + 0.75
					: h < s
						? p * (h -= 2.25 / e) * h + 0.9375
						: p * Math.pow(h - 2.625 / e, 2) + 0.984375;
		};
	Oo(
		"Bounce",
		function (l) {
			return 1 - u(1 - l);
		},
		u,
	);
})(7.5625, 2.75);
Oo("Expo", function (p) {
	return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
Oo("Circ", function (p) {
	return -(bf(1 - p * p) - 1);
});
Oo("Sine", function (p) {
	return p === 1 ? 1 : -Pp(p * Ep) + 1;
});
Oo("Back", Pl("in"), Pl("out"), Pl());
De.SteppedEase =
	De.steps =
	Tr.SteppedEase =
		{
			config: function (e, n) {
				e === void 0 && (e = 1);
				var r = 1 / e,
					s = e + (n ? 0 : 1),
					u = n ? 1 : 0,
					l = 1 - ai;
				return function (h) {
					return (((s * su(0, l, h)) | 0) + u) * r;
				};
			},
		};
la.ease = De["quad.out"];
ar(
	"onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",
	function (p) {
		return (Nc += p + "," + p + "Params,");
	},
);
var Jf = function (e, n) {
		((this.id = Cp++),
			(e._gsap = this),
			(this.target = e),
			(this.harness = n),
			(this.get = n ? n.get : kf),
			(this.set = n ? n.getSetter : Wc));
	},
	tu = (function () {
		function p(n) {
			((this.vars = n),
				(this._delay = +n.delay || 0),
				(this._repeat = n.repeat === 1 / 0 ? -2 : n.repeat || 0) &&
					((this._rDelay = n.repeatDelay || 0),
					(this._yoyo = !!n.yoyo || !!n.yoyoEase)),
				(this._ts = 1),
				ha(this, +n.duration, 1, 1),
				(this.data = n.data),
				_i && ((this._ctx = _i), _i.data.push(this)),
				Qa || br.wake());
		}
		var e = p.prototype;
		return (
			(e.delay = function (r) {
				return r || r === 0
					? (this.parent &&
							this.parent.smoothChildTiming &&
							this.startTime(this._start + r - this._delay),
						(this._delay = r),
						this)
					: this._delay;
			}),
			(e.duration = function (r) {
				return arguments.length
					? this.totalDuration(
							this._repeat > 0 ? r + (r + this._rDelay) * this._repeat : r,
						)
					: this.totalDuration() && this._dur;
			}),
			(e.totalDuration = function (r) {
				return arguments.length
					? ((this._dirty = 0),
						ha(
							this,
							this._repeat < 0
								? r
								: (r - this._repeat * this._rDelay) / (this._repeat + 1),
						))
					: this._tDur;
			}),
			(e.totalTime = function (r, s) {
				if ((fa(), !arguments.length)) return this._tTime;
				var u = this._dp;
				if (u && u.smoothChildTiming && this._ts) {
					for (nl(this, r), !u._dp || u.parent || If(u, this); u && u.parent; )
						(u.parent._time !==
							u._start +
								(u._ts >= 0
									? u._tTime / u._ts
									: (u.totalDuration() - u._tTime) / -u._ts) &&
							u.totalTime(u._tTime, !0),
							(u = u.parent));
					!this.parent &&
						this._dp.autoRemoveChildren &&
						((this._ts > 0 && r < this._tDur) ||
							(this._ts < 0 && r > 0) ||
							(!this._tDur && !r)) &&
						rs(this._dp, this, this._start - this._delay);
				}
				return (
					(this._tTime !== r ||
						(!this._dur && !s) ||
						(this._initted && Math.abs(this._zTime) === ai) ||
						(!r && !this._initted && (this.add || this._ptLookup))) &&
						(this._ts || (this._pTime = r), Af(this, r, s)),
					this
				);
			}),
			(e.time = function (r, s) {
				return arguments.length
					? this.totalTime(
							Math.min(this.totalDuration(), r + vh(this)) %
								(this._dur + this._rDelay) || (r ? this._dur : 0),
							s,
						)
					: this._time;
			}),
			(e.totalProgress = function (r, s) {
				return arguments.length
					? this.totalTime(this.totalDuration() * r, s)
					: this.totalDuration()
						? Math.min(1, this._tTime / this._tDur)
						: this.rawTime() > 0
							? 1
							: 0;
			}),
			(e.progress = function (r, s) {
				return arguments.length
					? this.totalTime(
							this.duration() *
								(this._yoyo && !(this.iteration() & 1) ? 1 - r : r) +
								vh(this),
							s,
						)
					: this.duration()
						? Math.min(1, this._time / this._dur)
						: this.rawTime() > 0
							? 1
							: 0;
			}),
			(e.iteration = function (r, s) {
				var u = this.duration() + this._rDelay;
				return arguments.length
					? this.totalTime(this._time + (r - 1) * u, s)
					: this._repeat
						? ca(this._tTime, u) + 1
						: 1;
			}),
			(e.timeScale = function (r, s) {
				if (!arguments.length) return this._rts === -ai ? 0 : this._rts;
				if (this._rts === r) return this;
				var u =
					this.parent && this._ts ? Uu(this.parent._time, this) : this._tTime;
				return (
					(this._rts = +r || 0),
					(this._ts = this._ps || r === -ai ? 0 : this._rts),
					this.totalTime(su(-Math.abs(this._delay), this._tDur, u), s !== !1),
					il(this),
					Bp(this)
				);
			}),
			(e.paused = function (r) {
				return arguments.length
					? (this._ps !== r &&
							((this._ps = r),
							r
								? ((this._pTime =
										this._tTime || Math.max(-this._delay, this.rawTime())),
									(this._ts = this._act = 0))
								: (fa(),
									(this._ts = this._rts),
									this.totalTime(
										this.parent && !this.parent.smoothChildTiming
											? this.rawTime()
											: this._tTime || this._pTime,
										this.progress() === 1 &&
											Math.abs(this._zTime) !== ai &&
											(this._tTime -= ai),
									))),
						this)
					: this._ps;
			}),
			(e.startTime = function (r) {
				if (arguments.length) {
					this._start = r;
					var s = this.parent || this._dp;
					return (
						s && (s._sort || !this.parent) && rs(s, this, r - this._delay),
						this
					);
				}
				return this._start;
			}),
			(e.endTime = function (r) {
				return (
					this._start +
					(or(r) ? this.totalDuration() : this.duration()) /
						Math.abs(this._ts || 1)
				);
			}),
			(e.rawTime = function (r) {
				var s = this.parent || this._dp;
				return s
					? r &&
						(!this._ts ||
							(this._repeat && this._time && this.totalProgress() < 1))
						? this._tTime % (this._dur + this._rDelay)
						: this._ts
							? Uu(s.rawTime(r), this)
							: this._tTime
					: this._tTime;
			}),
			(e.revert = function (r) {
				r === void 0 && (r = Mp);
				var s = Sn;
				return (
					(Sn = r),
					(this._initted || this._startAt) &&
						(this.timeline && this.timeline.revert(r),
						this.totalTime(-0.01, r.suppressEvents)),
					this.data !== "nested" && r.kill !== !1 && this.kill(),
					(Sn = s),
					this
				);
			}),
			(e.globalTime = function (r) {
				for (var s = this, u = arguments.length ? r : s.rawTime(); s; )
					((u = s._start + u / (Math.abs(s._ts) || 1)), (s = s._dp));
				return !this.parent && this._sat ? this._sat.globalTime(r) : u;
			}),
			(e.repeat = function (r) {
				return arguments.length
					? ((this._repeat = r === 1 / 0 ? -2 : r), yh(this))
					: this._repeat === -2
						? 1 / 0
						: this._repeat;
			}),
			(e.repeatDelay = function (r) {
				if (arguments.length) {
					var s = this._time;
					return ((this._rDelay = r), yh(this), s ? this.time(s) : this);
				}
				return this._rDelay;
			}),
			(e.yoyo = function (r) {
				return arguments.length ? ((this._yoyo = r), this) : this._yoyo;
			}),
			(e.seek = function (r, s) {
				return this.totalTime(Or(this, r), or(s));
			}),
			(e.restart = function (r, s) {
				return this.play().totalTime(r ? -this._delay : 0, or(s));
			}),
			(e.play = function (r, s) {
				return (r != null && this.seek(r, s), this.reversed(!1).paused(!1));
			}),
			(e.reverse = function (r, s) {
				return (
					r != null && this.seek(r || this.totalDuration(), s),
					this.reversed(!0).paused(!1)
				);
			}),
			(e.pause = function (r, s) {
				return (r != null && this.seek(r, s), this.paused(!0));
			}),
			(e.resume = function () {
				return this.paused(!1);
			}),
			(e.reversed = function (r) {
				return arguments.length
					? (!!r !== this.reversed() &&
							this.timeScale(-this._rts || (r ? -ai : 0)),
						this)
					: this._rts < 0;
			}),
			(e.invalidate = function () {
				return ((this._initted = this._act = 0), (this._zTime = -ai), this);
			}),
			(e.isActive = function () {
				var r = this.parent || this._dp,
					s = this._start,
					u;
				return !!(
					!r ||
					(this._ts &&
						this._initted &&
						r.isActive() &&
						(u = r.rawTime(!0)) >= s &&
						u < this.endTime(!0) - ai)
				);
			}),
			(e.eventCallback = function (r, s, u) {
				var l = this.vars;
				return arguments.length > 1
					? (s
							? ((l[r] = s),
								u && (l[r + "Params"] = u),
								r === "onUpdate" && (this._onUpdate = s))
							: delete l[r],
						this)
					: l[r];
			}),
			(e.then = function (r) {
				var s = this;
				return new Promise(function (u) {
					var l = Oi(r) ? r : Of,
						h = function () {
							var v = s.then;
							((s.then = null),
								Oi(l) && (l = l(s)) && (l.then || l === s) && (s.then = v),
								u(l),
								(s.then = v));
						};
					(s._initted && s.totalProgress() === 1 && s._ts >= 0) ||
					(!s._tTime && s._ts < 0)
						? h()
						: (s._prom = h);
				});
			}),
			(e.kill = function () {
				Aa(this);
			}),
			p
		);
	})();
Rr(tu.prototype, {
	_time: 0,
	_start: 0,
	_end: 0,
	_tTime: 0,
	_tDur: 0,
	_dirty: 0,
	_repeat: 0,
	_yoyo: !1,
	parent: null,
	_initted: !1,
	_rDelay: 0,
	_ts: 1,
	_dp: 0,
	ratio: 0,
	_zTime: -ai,
	_prom: 0,
	_ps: !1,
	_rts: 1,
});
var jn = (function (p) {
	yf(e, p);
	function e(r, s) {
		var u;
		return (
			r === void 0 && (r = {}),
			(u = p.call(this, r) || this),
			(u.labels = {}),
			(u.smoothChildTiming = !!r.smoothChildTiming),
			(u.autoRemoveChildren = !!r.autoRemoveChildren),
			(u._sort = or(r.sortChildren)),
			Ei && rs(r.parent || Ei, xs(u), s),
			r.reversed && u.reverse(),
			r.paused && u.paused(!0),
			r.scrollTrigger && Bf(xs(u), r.scrollTrigger),
			u
		);
	}
	var n = e.prototype;
	return (
		(n.to = function (s, u, l) {
			return (Ra(0, arguments, this), this);
		}),
		(n.from = function (s, u, l) {
			return (Ra(1, arguments, this), this);
		}),
		(n.fromTo = function (s, u, l, h) {
			return (Ra(2, arguments, this), this);
		}),
		(n.set = function (s, u, l) {
			return (
				(u.duration = 0),
				(u.parent = this),
				Na(u).repeatDelay || (u.repeat = 0),
				(u.immediateRender = !!u.immediateRender),
				new ji(s, u, Or(this, l), 1),
				this
			);
		}),
		(n.call = function (s, u, l) {
			return rs(this, ji.delayedCall(0, s, u), l);
		}),
		(n.staggerTo = function (s, u, l, h, f, v, w) {
			return (
				(l.duration = u),
				(l.stagger = l.stagger || h),
				(l.onComplete = v),
				(l.onCompleteParams = w),
				(l.parent = this),
				new ji(s, l, Or(this, f)),
				this
			);
		}),
		(n.staggerFrom = function (s, u, l, h, f, v, w) {
			return (
				(l.runBackwards = 1),
				(Na(l).immediateRender = or(l.immediateRender)),
				this.staggerTo(s, u, l, h, f, v, w)
			);
		}),
		(n.staggerFromTo = function (s, u, l, h, f, v, w, A) {
			return (
				(h.startAt = l),
				(Na(h).immediateRender = or(h.immediateRender)),
				this.staggerTo(s, u, h, f, v, w, A)
			);
		}),
		(n.render = function (s, u, l) {
			var h = this._time,
				f = this._dirty ? this.totalDuration() : this._tDur,
				v = this._dur,
				w = s <= 0 ? 0 : rn(s),
				A = this._zTime < 0 != s < 0 && (this._initted || !v),
				D,
				C,
				O,
				P,
				F,
				G,
				B,
				j,
				V,
				Q,
				it,
				g;
			if (
				(this !== Ei && w > f && s >= 0 && (w = f), w !== this._tTime || l || A)
			) {
				if (
					(h !== this._time &&
						v &&
						((w += this._time - h), (s += this._time - h)),
					(D = w),
					(V = this._start),
					(j = this._ts),
					(G = !j),
					A && (v || (h = this._zTime), (s || !u) && (this._zTime = s)),
					this._repeat)
				) {
					if (
						((it = this._yoyo),
						(F = v + this._rDelay),
						this._repeat < -1 && s < 0)
					)
						return this.totalTime(F * 100 + s, u, l);
					if (
						((D = rn(w % F)),
						w === f
							? ((P = this._repeat), (D = v))
							: ((P = ~~(w / F)),
								P && P === w / F && ((D = v), P--),
								D > v && (D = v)),
						(Q = ca(this._tTime, F)),
						!h &&
							this._tTime &&
							Q !== P &&
							this._tTime - Q * F - this._dur <= 0 &&
							(Q = P),
						it && P & 1 && ((D = v - D), (g = 1)),
						P !== Q && !this._lock)
					) {
						var ct = it && Q & 1,
							ot = ct === (it && P & 1);
						if (
							(P < Q && (ct = !ct),
							(h = ct ? 0 : w % v ? v : w),
							(this._lock = 1),
							(this.render(h || (g ? 0 : rn(P * F)), u, !v)._lock = 0),
							(this._tTime = w),
							!u && this.parent && wr(this, "onRepeat"),
							this.vars.repeatRefresh && !g && (this.invalidate()._lock = 1),
							(h && h !== this._time) ||
								G !== !this._ts ||
								(this.vars.onRepeat && !this.parent && !this._act))
						)
							return this;
						if (
							((v = this._dur),
							(f = this._tDur),
							ot &&
								((this._lock = 2),
								(h = ct ? v : -1e-4),
								this.render(h, !0),
								this.vars.repeatRefresh && !g && this.invalidate()),
							(this._lock = 0),
							!this._ts && !G)
						)
							return this;
						Yf(this, g);
					}
				}
				if (
					(this._hasPause &&
						!this._forcing &&
						this._lock < 2 &&
						((B = Fp(this, rn(h), rn(D))), B && (w -= D - (D = B._start))),
					(this._tTime = w),
					(this._time = D),
					(this._act = !j),
					this._initted ||
						((this._onUpdate = this.vars.onUpdate),
						(this._initted = 1),
						(this._zTime = s),
						(h = 0)),
					!h && D && !u && !P && (wr(this, "onStart"), this._tTime !== w))
				)
					return this;
				if (D >= h && s >= 0)
					for (C = this._first; C; ) {
						if (
							((O = C._next), (C._act || D >= C._start) && C._ts && B !== C)
						) {
							if (C.parent !== this) return this.render(s, u, l);
							if (
								(C.render(
									C._ts > 0
										? (D - C._start) * C._ts
										: (C._dirty ? C.totalDuration() : C._tDur) +
												(D - C._start) * C._ts,
									u,
									l,
								),
								D !== this._time || (!this._ts && !G))
							) {
								((B = 0), O && (w += this._zTime = -ai));
								break;
							}
						}
						C = O;
					}
				else {
					C = this._last;
					for (var ft = s < 0 ? s : D; C; ) {
						if (((O = C._prev), (C._act || ft <= C._end) && C._ts && B !== C)) {
							if (C.parent !== this) return this.render(s, u, l);
							if (
								(C.render(
									C._ts > 0
										? (ft - C._start) * C._ts
										: (C._dirty ? C.totalDuration() : C._tDur) +
												(ft - C._start) * C._ts,
									u,
									l || (Sn && (C._initted || C._startAt)),
								),
								D !== this._time || (!this._ts && !G))
							) {
								((B = 0), O && (w += this._zTime = ft ? -ai : ai));
								break;
							}
						}
						C = O;
					}
				}
				if (
					B &&
					!u &&
					(this.pause(),
					(B.render(D >= h ? 0 : -ai)._zTime = D >= h ? 1 : -1),
					this._ts)
				)
					return ((this._start = V), il(this), this.render(s, u, l));
				(this._onUpdate && !u && wr(this, "onUpdate", !0),
					((w === f && this._tTime >= this.totalDuration()) || (!w && h)) &&
						(V === this._start || Math.abs(j) !== Math.abs(this._ts)) &&
						(this._lock ||
							((s || !v) &&
								((w === f && this._ts > 0) || (!w && this._ts < 0)) &&
								Vs(this, 1),
							!u &&
								!(s < 0 && !h) &&
								(w || h || !f) &&
								(wr(
									this,
									w === f && s >= 0 ? "onComplete" : "onReverseComplete",
									!0,
								),
								this._prom &&
									!(w < f && this.timeScale() > 0) &&
									this._prom()))));
			}
			return this;
		}),
		(n.add = function (s, u) {
			var l = this;
			if ((Ps(u) || (u = Or(this, u, s)), !(s instanceof tu))) {
				if (Tn(s))
					return (
						s.forEach(function (h) {
							return l.add(h, u);
						}),
						this
					);
				if (sn(s)) return this.addLabel(s, u);
				if (Oi(s)) s = ji.delayedCall(0, s);
				else return this;
			}
			return this !== s ? rs(this, s, u) : this;
		}),
		(n.getChildren = function (s, u, l, h) {
			(s === void 0 && (s = !0),
				u === void 0 && (u = !0),
				l === void 0 && (l = !0),
				h === void 0 && (h = -Br));
			for (var f = [], v = this._first; v; )
				(v._start >= h &&
					(v instanceof ji
						? u && f.push(v)
						: (l && f.push(v), s && f.push.apply(f, v.getChildren(!0, u, l)))),
					(v = v._next));
			return f;
		}),
		(n.getById = function (s) {
			for (var u = this.getChildren(1, 1, 1), l = u.length; l--; )
				if (u[l].vars.id === s) return u[l];
		}),
		(n.remove = function (s) {
			return sn(s)
				? this.removeLabel(s)
				: Oi(s)
					? this.killTweensOf(s)
					: (el(this, s),
						s === this._recent && (this._recent = this._last),
						xo(this));
		}),
		(n.totalTime = function (s, u) {
			return arguments.length
				? ((this._forcing = 1),
					!this._dp &&
						this._ts &&
						(this._start = rn(
							br.time -
								(this._ts > 0
									? s / this._ts
									: (this.totalDuration() - s) / -this._ts),
						)),
					p.prototype.totalTime.call(this, s, u),
					(this._forcing = 0),
					this)
				: this._tTime;
		}),
		(n.addLabel = function (s, u) {
			return ((this.labels[s] = Or(this, u)), this);
		}),
		(n.removeLabel = function (s) {
			return (delete this.labels[s], this);
		}),
		(n.addPause = function (s, u, l) {
			var h = ji.delayedCall(0, u || Ka, l);
			return (
				(h.data = "isPause"),
				(this._hasPause = 1),
				rs(this, h, Or(this, s))
			);
		}),
		(n.removePause = function (s) {
			var u = this._first;
			for (s = Or(this, s); u; )
				(u._start === s && u.data === "isPause" && Vs(u), (u = u._next));
		}),
		(n.killTweensOf = function (s, u, l) {
			for (var h = this.getTweensOf(s, l), f = h.length; f--; )
				Fs !== h[f] && h[f].kill(s, u);
			return this;
		}),
		(n.getTweensOf = function (s, u) {
			for (var l = [], h = zr(s), f = this._first, v = Ps(u), w; f; )
				(f instanceof ji
					? Op(f._targets, h) &&
						(v
							? (!Fs || (f._initted && f._ts)) &&
								f.globalTime(0) <= u &&
								f.globalTime(f.totalDuration()) > u
							: !u || f.isActive()) &&
						l.push(f)
					: (w = f.getTweensOf(h, u)).length && l.push.apply(l, w),
					(f = f._next));
			return l;
		}),
		(n.tweenTo = function (s, u) {
			u = u || {};
			var l = this,
				h = Or(l, s),
				f = u,
				v = f.startAt,
				w = f.onStart,
				A = f.onStartParams,
				D = f.immediateRender,
				C,
				O = ji.to(
					l,
					Rr(
						{
							ease: u.ease || "none",
							lazy: !1,
							immediateRender: !1,
							time: h,
							overwrite: "auto",
							duration:
								u.duration ||
								Math.abs(
									(h - (v && "time" in v ? v.time : l._time)) / l.timeScale(),
								) ||
								ai,
							onStart: function () {
								if ((l.pause(), !C)) {
									var F =
										u.duration ||
										Math.abs(
											(h - (v && "time" in v ? v.time : l._time)) /
												l.timeScale(),
										);
									(O._dur !== F && ha(O, F, 0, 1).render(O._time, !0, !0),
										(C = 1));
								}
								w && w.apply(O, A || []);
							},
						},
						u,
					),
				);
			return D ? O.render(0) : O;
		}),
		(n.tweenFromTo = function (s, u, l) {
			return this.tweenTo(u, Rr({ startAt: { time: Or(this, s) } }, l));
		}),
		(n.recent = function () {
			return this._recent;
		}),
		(n.nextLabel = function (s) {
			return (s === void 0 && (s = this._time), bh(this, Or(this, s)));
		}),
		(n.previousLabel = function (s) {
			return (s === void 0 && (s = this._time), bh(this, Or(this, s), 1));
		}),
		(n.currentLabel = function (s) {
			return arguments.length
				? this.seek(s, !0)
				: this.previousLabel(this._time + ai);
		}),
		(n.shiftChildren = function (s, u, l) {
			l === void 0 && (l = 0);
			for (var h = this._first, f = this.labels, v; h; )
				(h._start >= l && ((h._start += s), (h._end += s)), (h = h._next));
			if (u) for (v in f) f[v] >= l && (f[v] += s);
			return xo(this);
		}),
		(n.invalidate = function (s) {
			var u = this._first;
			for (this._lock = 0; u; ) (u.invalidate(s), (u = u._next));
			return p.prototype.invalidate.call(this, s);
		}),
		(n.clear = function (s) {
			s === void 0 && (s = !0);
			for (var u = this._first, l; u; )
				((l = u._next), this.remove(u), (u = l));
			return (
				this._dp && (this._time = this._tTime = this._pTime = 0),
				s && (this.labels = {}),
				xo(this)
			);
		}),
		(n.totalDuration = function (s) {
			var u = 0,
				l = this,
				h = l._last,
				f = Br,
				v,
				w,
				A;
			if (arguments.length)
				return l.timeScale(
					(l._repeat < 0 ? l.duration() : l.totalDuration()) /
						(l.reversed() ? -s : s),
				);
			if (l._dirty) {
				for (A = l.parent; h; )
					((v = h._prev),
						h._dirty && h.totalDuration(),
						(w = h._start),
						w > f && l._sort && h._ts && !l._lock
							? ((l._lock = 1), (rs(l, h, w - h._delay, 1)._lock = 0))
							: (f = w),
						w < 0 &&
							h._ts &&
							((u -= w),
							((!A && !l._dp) || (A && A.smoothChildTiming)) &&
								((l._start += w / l._ts), (l._time -= w), (l._tTime -= w)),
							l.shiftChildren(-w, !1, -1 / 0),
							(f = 0)),
						h._end > u && h._ts && (u = h._end),
						(h = v));
				(ha(l, l === Ei && l._time > u ? l._time : u, 1, 1), (l._dirty = 0));
			}
			return l._tDur;
		}),
		(e.updateRoot = function (s) {
			if ((Ei._ts && (Af(Ei, Uu(s, Ei)), (Lf = br.frame)), br.frame >= gh)) {
				gh += Sr.autoSleep || 120;
				var u = Ei._first;
				if ((!u || !u._ts) && Sr.autoSleep && br._listeners.length < 2) {
					for (; u && !u._ts; ) u = u._next;
					u || br.sleep();
				}
			}
		}),
		e
	);
})(tu);
Rr(jn.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
var em = function (e, n, r, s, u, l, h) {
		var f = new ur(this._pt, e, n, 0, 1, rd, null, u),
			v = 0,
			w = 0,
			A,
			D,
			C,
			O,
			P,
			F,
			G,
			B;
		for (
			f.b = r,
				f.e = s,
				r += "",
				s += "",
				(G = ~s.indexOf("random(")) && (s = Ja(s)),
				l && ((B = [r, s]), l(B, e, n), (r = B[0]), (s = B[1])),
				D = r.match(Sl) || [];
			(A = Sl.exec(s));
		)
			((O = A[0]),
				(P = s.substring(v, A.index)),
				C ? (C = (C + 1) % 5) : P.substr(-5) === "rgba(" && (C = 1),
				O !== D[w++] &&
					((F = parseFloat(D[w - 1]) || 0),
					(f._pt = {
						_next: f._pt,
						p: P || w === 1 ? P : ",",
						s: F,
						c: O.charAt(1) === "=" ? ia(F, O) - F : parseFloat(O) - F,
						m: C && C < 4 ? Math.round : 0,
					}),
					(v = Sl.lastIndex)));
		return (
			(f.c = v < s.length ? s.substring(v, s.length) : ""),
			(f.fp = h),
			(Sf.test(s) || G) && (f.e = 0),
			(this._pt = f),
			f
		);
	},
	Fc = function (e, n, r, s, u, l, h, f, v, w) {
		Oi(s) && (s = s(u || 0, e, l));
		var A = e[n],
			D =
				r !== "get"
					? r
					: Oi(A)
						? v
							? e[
									n.indexOf("set") || !Oi(e["get" + n.substr(3)])
										? n
										: "get" + n.substr(3)
								](v)
							: e[n]()
						: A,
			C = Oi(A) ? (v ? om : id) : qc,
			O;
		if (
			(sn(s) &&
				(~s.indexOf("random(") && (s = Ja(s)),
				s.charAt(1) === "=" &&
					((O = ia(D, s) + (wn(D) || 0)), (O || O === 0) && (s = O))),
			!w || D !== s || dc)
		)
			return !isNaN(D * s) && s !== ""
				? ((O = new ur(
						this._pt,
						e,
						n,
						+D || 0,
						s - (D || 0),
						typeof A == "boolean" ? um : nd,
						0,
						C,
					)),
					v && (O.fp = v),
					h && O.modifier(h, this, e),
					(this._pt = O))
				: (!A && !(n in e) && Bc(n, s),
					em.call(this, e, n, D, s, C, f || Sr.stringFilter, v));
	},
	im = function (e, n, r, s, u) {
		if (
			(Oi(e) && (e = Fa(e, u, n, r, s)),
			!ls(e) || (e.style && e.nodeType) || Tn(e) || xf(e))
		)
			return sn(e) ? Fa(e, u, n, r, s) : e;
		var l = {},
			h;
		for (h in e) l[h] = Fa(e[h], u, n, r, s);
		return l;
	},
	Qf = function (e, n, r, s, u, l) {
		var h, f, v, w;
		if (
			yr[e] &&
			(h = new yr[e]()).init(
				u,
				h.rawVars ? n[e] : im(n[e], s, u, l, r),
				r,
				s,
				l,
			) !== !1 &&
			((r._pt = f = new ur(r._pt, u, e, 0, 1, h.render, h, 0, h.priority)),
			r !== ta)
		)
			for (v = r._ptLookup[r._targets.indexOf(u)], w = h._props.length; w--; )
				v[h._props[w]] = f;
		return h;
	},
	Fs,
	dc,
	Hc = function p(e, n, r) {
		var s = e.vars,
			u = s.ease,
			l = s.startAt,
			h = s.immediateRender,
			f = s.lazy,
			v = s.onUpdate,
			w = s.runBackwards,
			A = s.yoyoEase,
			D = s.keyframes,
			C = s.autoRevert,
			O = e._dur,
			P = e._startAt,
			F = e._targets,
			G = e.parent,
			B = G && G.data === "nested" ? G.vars.targets : F,
			j = e._overwrite === "auto" && !Mc,
			V = e.timeline,
			Q,
			it,
			g,
			ct,
			ot,
			ft,
			Dt,
			pt,
			Et,
			K,
			Nt,
			St,
			Ct;
		if (
			(V && (!D || !u) && (u = "none"),
			(e._ease = wo(u, la.ease)),
			(e._yEase = A ? Xf(wo(A === !0 ? u : A, la.ease)) : 0),
			A &&
				e._yoyo &&
				!e._repeat &&
				((A = e._yEase), (e._yEase = e._ease), (e._ease = A)),
			(e._from = !V && !!s.runBackwards),
			!V || (D && !s.stagger))
		) {
			if (
				((pt = F[0] ? bo(F[0]).harness : 0),
				(St = pt && s[pt.prop]),
				(Q = ju(s, zc)),
				P &&
					(P._zTime < 0 && P.progress(1),
					n < 0 && w && h && !C ? P.render(-1, !0) : P.revert(w && O ? Du : Ap),
					(P._lazy = 0)),
				l)
			) {
				if (
					(Vs(
						(e._startAt = ji.set(
							F,
							Rr(
								{
									data: "isStart",
									overwrite: !1,
									parent: G,
									immediateRender: !0,
									lazy: !P && or(f),
									startAt: null,
									delay: 0,
									onUpdate:
										v &&
										function () {
											return wr(e, "onUpdate");
										},
									stagger: 0,
								},
								l,
							),
						)),
					),
					(e._startAt._dp = 0),
					(e._startAt._sat = e),
					n < 0 && (Sn || (!h && !C)) && e._startAt.revert(Du),
					h && O && n <= 0 && r <= 0)
				) {
					n && (e._zTime = n);
					return;
				}
			} else if (w && O && !P) {
				if (
					(n && (h = !1),
					(g = Rr(
						{
							overwrite: !1,
							data: "isFromStart",
							lazy: h && !P && or(f),
							immediateRender: h,
							stagger: 0,
							parent: G,
						},
						Q,
					)),
					St && (g[pt.prop] = St),
					Vs((e._startAt = ji.set(F, g))),
					(e._startAt._dp = 0),
					(e._startAt._sat = e),
					n < 0 && (Sn ? e._startAt.revert(Du) : e._startAt.render(-1, !0)),
					(e._zTime = n),
					!h)
				)
					p(e._startAt, ai, ai);
				else if (!n) return;
			}
			for (
				e._pt = e._ptCache = 0, f = (O && or(f)) || (f && !O), it = 0;
				it < F.length;
				it++
			) {
				if (
					((ot = F[it]),
					(Dt = ot._gsap || Rc(F)[it]._gsap),
					(e._ptLookup[it] = K = {}),
					ac[Dt.id] && js.length && Zu(),
					(Nt = B === F ? it : B.indexOf(ot)),
					pt &&
						(Et = new pt()).init(ot, St || Q, e, Nt, B) !== !1 &&
						((e._pt = ct =
							new ur(e._pt, ot, Et.name, 0, 1, Et.render, Et, 0, Et.priority)),
						Et._props.forEach(function (_t) {
							K[_t] = ct;
						}),
						Et.priority && (ft = 1)),
					!pt || St)
				)
					for (g in Q)
						yr[g] && (Et = Qf(g, Q, e, Nt, ot, B))
							? Et.priority && (ft = 1)
							: (K[g] = ct =
									Fc.call(e, ot, g, "get", Q[g], Nt, B, 0, s.stringFilter));
				(e._op && e._op[it] && e.kill(ot, e._op[it]),
					j &&
						e._pt &&
						((Fs = e),
						Ei.killTweensOf(ot, K, e.globalTime(n)),
						(Ct = !e.parent),
						(Fs = 0)),
					e._pt && f && (ac[Dt.id] = 1));
			}
			(ft && sd(e), e._onInit && e._onInit(e));
		}
		((e._onUpdate = v),
			(e._initted = (!e._op || e._pt) && !Ct),
			D && n <= 0 && V.render(Br, !0, !0));
	},
	nm = function (e, n, r, s, u, l, h, f) {
		var v = ((e._pt && e._ptCache) || (e._ptCache = {}))[n],
			w,
			A,
			D,
			C;
		if (!v)
			for (
				v = e._ptCache[n] = [], D = e._ptLookup, C = e._targets.length;
				C--;
			) {
				if (((w = D[C][n]), w && w.d && w.d._pt))
					for (w = w.d._pt; w && w.p !== n && w.fp !== n; ) w = w._next;
				if (!w)
					return (
						(dc = 1),
						(e.vars[n] = "+=0"),
						Hc(e, h),
						(dc = 0),
						f ? Ya(n + " not eligible for reset") : 1
					);
				v.push(w);
			}
		for (C = v.length; C--; )
			((A = v[C]),
				(w = A._pt || A),
				(w.s = (s || s === 0) && !u ? s : w.s + (s || 0) + l * w.c),
				(w.c = r - w.s),
				A.e && (A.e = Ni(r) + wn(A.e)),
				A.b && (A.b = w.s + wn(A.b)));
	},
	rm = function (e, n) {
		var r = e[0] ? bo(e[0]).harness : 0,
			s = r && r.aliases,
			u,
			l,
			h,
			f;
		if (!s) return n;
		u = Po({}, n);
		for (l in s)
			if (l in u) for (f = s[l].split(","), h = f.length; h--; ) u[f[h]] = u[l];
		return u;
	},
	sm = function (e, n, r, s) {
		var u = n.ease || s || "power1.inOut",
			l,
			h;
		if (Tn(n))
			((h = r[e] || (r[e] = [])),
				n.forEach(function (f, v) {
					return h.push({ t: (v / (n.length - 1)) * 100, v: f, e: u });
				}));
		else
			for (l in n)
				((h = r[l] || (r[l] = [])),
					l === "ease" || h.push({ t: parseFloat(e), v: n[l], e: u }));
	},
	Fa = function (e, n, r, s, u) {
		return Oi(e)
			? e.call(n, r, s, u)
			: sn(e) && ~e.indexOf("random(")
				? Ja(e)
				: e;
	},
	td = Nc + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
	ed = {};
ar(td + ",id,stagger,delay,duration,paused,scrollTrigger", function (p) {
	return (ed[p] = 1);
});
var ji = (function (p) {
	yf(e, p);
	function e(r, s, u, l) {
		var h;
		(typeof s == "number" && ((u.duration = s), (s = u), (u = null)),
			(h = p.call(this, l ? s : Na(s)) || this));
		var f = h.vars,
			v = f.duration,
			w = f.delay,
			A = f.immediateRender,
			D = f.stagger,
			C = f.overwrite,
			O = f.keyframes,
			P = f.defaults,
			F = f.scrollTrigger,
			G = f.yoyoEase,
			B = s.parent || Ei,
			j = (Tn(r) || xf(r) ? Ps(r[0]) : "length" in s) ? [r] : zr(r),
			V,
			Q,
			it,
			g,
			ct,
			ot,
			ft,
			Dt;
		if (
			((h._targets = j.length
				? Rc(j)
				: Ya(
						"GSAP target " + r + " not found. https://gsap.com",
						!Sr.nullTargetWarn,
					) || []),
			(h._ptLookup = []),
			(h._overwrite = C),
			O || D || yu(v) || yu(w))
		) {
			if (
				((s = h.vars),
				(V = h.timeline =
					new jn({
						data: "nested",
						defaults: P || {},
						targets: B && B.data === "nested" ? B.vars.targets : j,
					})),
				V.kill(),
				(V.parent = V._dp = xs(h)),
				(V._start = 0),
				D || yu(v) || yu(w))
			) {
				if (((g = j.length), (ft = D && Ff(D)), ls(D)))
					for (ct in D) ~td.indexOf(ct) && (Dt || (Dt = {}), (Dt[ct] = D[ct]));
				for (Q = 0; Q < g; Q++)
					((it = ju(s, ed)),
						(it.stagger = 0),
						G && (it.yoyoEase = G),
						Dt && Po(it, Dt),
						(ot = j[Q]),
						(it.duration = +Fa(v, xs(h), Q, ot, j)),
						(it.delay = (+Fa(w, xs(h), Q, ot, j) || 0) - h._delay),
						!D &&
							g === 1 &&
							it.delay &&
							((h._delay = w = it.delay), (h._start += w), (it.delay = 0)),
						V.to(ot, it, ft ? ft(Q, ot, j) : 0),
						(V._ease = De.none));
				V.duration() ? (v = w = 0) : (h.timeline = 0);
			} else if (O) {
				(Na(Rr(V.vars.defaults, { ease: "none" })),
					(V._ease = wo(O.ease || s.ease || "none")));
				var pt = 0,
					Et,
					K,
					Nt;
				if (Tn(O))
					(O.forEach(function (St) {
						return V.to(j, St, ">");
					}),
						V.duration());
				else {
					it = {};
					for (ct in O)
						ct === "ease" || ct === "easeEach" || sm(ct, O[ct], it, O.easeEach);
					for (ct in it)
						for (
							Et = it[ct].sort(function (St, Ct) {
								return St.t - Ct.t;
							}),
								pt = 0,
								Q = 0;
							Q < Et.length;
							Q++
						)
							((K = Et[Q]),
								(Nt = {
									ease: K.e,
									duration: ((K.t - (Q ? Et[Q - 1].t : 0)) / 100) * v,
								}),
								(Nt[ct] = K.v),
								V.to(j, Nt, pt),
								(pt += Nt.duration));
					V.duration() < v && V.to({}, { duration: v - V.duration() });
				}
			}
			v || h.duration((v = V.duration()));
		} else h.timeline = 0;
		return (
			C === !0 && !Mc && ((Fs = xs(h)), Ei.killTweensOf(j), (Fs = 0)),
			rs(B, xs(h), u),
			s.reversed && h.reverse(),
			s.paused && h.paused(!0),
			(A ||
				(!v &&
					!O &&
					h._start === rn(B._time) &&
					or(A) &&
					zp(xs(h)) &&
					B.data !== "nested")) &&
				((h._tTime = -ai), h.render(Math.max(0, -w) || 0)),
			F && Bf(xs(h), F),
			h
		);
	}
	var n = e.prototype;
	return (
		(n.render = function (s, u, l) {
			var h = this._time,
				f = this._tDur,
				v = this._dur,
				w = s < 0,
				A = s > f - ai && !w ? f : s < ai ? 0 : s,
				D,
				C,
				O,
				P,
				F,
				G,
				B,
				j,
				V;
			if (!v) Rp(this, s, u, l);
			else if (
				A !== this._tTime ||
				!s ||
				l ||
				(!this._initted && this._tTime) ||
				(this._startAt && this._zTime < 0 !== w)
			) {
				if (((D = A), (j = this.timeline), this._repeat)) {
					if (((P = v + this._rDelay), this._repeat < -1 && w))
						return this.totalTime(P * 100 + s, u, l);
					if (
						((D = rn(A % P)),
						A === f
							? ((O = this._repeat), (D = v))
							: ((O = ~~(A / P)),
								O && O === rn(A / P) && ((D = v), O--),
								D > v && (D = v)),
						(G = this._yoyo && O & 1),
						G && ((V = this._yEase), (D = v - D)),
						(F = ca(this._tTime, P)),
						D === h && !l && this._initted && O === F)
					)
						return ((this._tTime = A), this);
					O !== F &&
						(j && this._yEase && Yf(j, G),
						this.vars.repeatRefresh &&
							!G &&
							!this._lock &&
							this._time !== P &&
							this._initted &&
							((this._lock = l = 1),
							(this.render(rn(P * O), !0).invalidate()._lock = 0)));
				}
				if (!this._initted) {
					if (zf(this, w ? s : D, l, u, A)) return ((this._tTime = 0), this);
					if (h !== this._time && !(l && this.vars.repeatRefresh && O !== F))
						return this;
					if (v !== this._dur) return this.render(s, u, l);
				}
				if (
					((this._tTime = A),
					(this._time = D),
					!this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
					(this.ratio = B = (V || this._ease)(D / v)),
					this._from && (this.ratio = B = 1 - B),
					D && !h && !u && !O && (wr(this, "onStart"), this._tTime !== A))
				)
					return this;
				for (C = this._pt; C; ) (C.r(B, C.d), (C = C._next));
				((j && j.render(s < 0 ? s : j._dur * j._ease(D / this._dur), u, l)) ||
					(this._startAt && (this._zTime = s)),
					this._onUpdate &&
						!u &&
						(w && uc(this, s, u, l), wr(this, "onUpdate")),
					this._repeat &&
						O !== F &&
						this.vars.onRepeat &&
						!u &&
						this.parent &&
						wr(this, "onRepeat"),
					(A === this._tDur || !A) &&
						this._tTime === A &&
						(w && !this._onUpdate && uc(this, s, !0, !0),
						(s || !v) &&
							((A === this._tDur && this._ts > 0) || (!A && this._ts < 0)) &&
							Vs(this, 1),
						!u &&
							!(w && !h) &&
							(A || h || G) &&
							(wr(this, A === f ? "onComplete" : "onReverseComplete", !0),
							this._prom && !(A < f && this.timeScale() > 0) && this._prom())));
			}
			return this;
		}),
		(n.targets = function () {
			return this._targets;
		}),
		(n.invalidate = function (s) {
			return (
				(!s || !this.vars.runBackwards) && (this._startAt = 0),
				(this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0),
				(this._ptLookup = []),
				this.timeline && this.timeline.invalidate(s),
				p.prototype.invalidate.call(this, s)
			);
		}),
		(n.resetTo = function (s, u, l, h, f) {
			(Qa || br.wake(), this._ts || this.play());
			var v = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
				w;
			return (
				this._initted || Hc(this, v),
				(w = this._ease(v / this._dur)),
				nm(this, s, u, l, h, w, v, f)
					? this.resetTo(s, u, l, h, 1)
					: (nl(this, 0),
						this.parent ||
							Df(
								this._dp,
								this,
								"_first",
								"_last",
								this._dp._sort ? "_start" : 0,
							),
						this.render(0))
			);
		}),
		(n.kill = function (s, u) {
			if ((u === void 0 && (u = "all"), !s && (!u || u === "all")))
				return ((this._lazy = this._pt = 0), this.parent ? Aa(this) : this);
			if (this.timeline) {
				var l = this.timeline.totalDuration();
				return (
					this.timeline.killTweensOf(s, u, Fs && Fs.vars.overwrite !== !0)
						._first || Aa(this),
					this.parent &&
						l !== this.timeline.totalDuration() &&
						ha(this, (this._dur * this.timeline._tDur) / l, 0, 1),
					this
				);
			}
			var h = this._targets,
				f = s ? zr(s) : h,
				v = this._ptLookup,
				w = this._pt,
				A,
				D,
				C,
				O,
				P,
				F,
				G;
			if ((!u || u === "all") && Ip(h, f))
				return (u === "all" && (this._pt = 0), Aa(this));
			for (
				A = this._op = this._op || [],
					u !== "all" &&
						(sn(u) &&
							((P = {}),
							ar(u, function (B) {
								return (P[B] = 1);
							}),
							(u = P)),
						(u = rm(h, u))),
					G = h.length;
				G--;
			)
				if (~f.indexOf(h[G])) {
					((D = v[G]),
						u === "all"
							? ((A[G] = u), (O = D), (C = {}))
							: ((C = A[G] = A[G] || {}), (O = u)));
					for (P in O)
						((F = D && D[P]),
							F &&
								((!("kill" in F.d) || F.d.kill(P) === !0) && el(this, F, "_pt"),
								delete D[P]),
							C !== "all" && (C[P] = 1));
				}
			return (this._initted && !this._pt && w && Aa(this), this);
		}),
		(e.to = function (s, u) {
			return new e(s, u, arguments[2]);
		}),
		(e.from = function (s, u) {
			return Ra(1, arguments);
		}),
		(e.delayedCall = function (s, u, l, h) {
			return new e(u, 0, {
				immediateRender: !1,
				lazy: !1,
				overwrite: !1,
				delay: s,
				onComplete: u,
				onReverseComplete: u,
				onCompleteParams: l,
				onReverseCompleteParams: l,
				callbackScope: h,
			});
		}),
		(e.fromTo = function (s, u, l) {
			return Ra(2, arguments);
		}),
		(e.set = function (s, u) {
			return ((u.duration = 0), u.repeatDelay || (u.repeat = 0), new e(s, u));
		}),
		(e.killTweensOf = function (s, u, l) {
			return Ei.killTweensOf(s, u, l);
		}),
		e
	);
})(tu);
Rr(ji.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 });
ar("staggerTo,staggerFrom,staggerFromTo", function (p) {
	ji[p] = function () {
		var e = new jn(),
			n = cc.call(arguments, 0);
		return (n.splice(p === "staggerFromTo" ? 5 : 4, 0, 0), e[p].apply(e, n));
	};
});
var qc = function (e, n, r) {
		return (e[n] = r);
	},
	id = function (e, n, r) {
		return e[n](r);
	},
	om = function (e, n, r, s) {
		return e[n](s.fp, r);
	},
	am = function (e, n, r) {
		return e.setAttribute(n, r);
	},
	Wc = function (e, n) {
		return Oi(e[n]) ? id : Oc(e[n]) && e.setAttribute ? am : qc;
	},
	nd = function (e, n) {
		return n.set(n.t, n.p, Math.round((n.s + n.c * e) * 1e6) / 1e6, n);
	},
	um = function (e, n) {
		return n.set(n.t, n.p, !!(n.s + n.c * e), n);
	},
	rd = function (e, n) {
		var r = n._pt,
			s = "";
		if (!e && n.b) s = n.b;
		else if (e === 1 && n.e) s = n.e;
		else {
			for (; r; )
				((s =
					r.p +
					(r.m ? r.m(r.s + r.c * e) : Math.round((r.s + r.c * e) * 1e4) / 1e4) +
					s),
					(r = r._next));
			s += n.c;
		}
		n.set(n.t, n.p, s, n);
	},
	Zc = function (e, n) {
		for (var r = n._pt; r; ) (r.r(e, r.d), (r = r._next));
	},
	lm = function (e, n, r, s) {
		for (var u = this._pt, l; u; )
			((l = u._next), u.p === s && u.modifier(e, n, r), (u = l));
	},
	cm = function (e) {
		for (var n = this._pt, r, s; n; )
			((s = n._next),
				(n.p === e && !n.op) || n.op === e
					? el(this, n, "_pt")
					: n.dep || (r = 1),
				(n = s));
		return !r;
	},
	hm = function (e, n, r, s) {
		s.mSet(e, n, s.m.call(s.tween, r, s.mt), s);
	},
	sd = function (e) {
		for (var n = e._pt, r, s, u, l; n; ) {
			for (r = n._next, s = u; s && s.pr > n.pr; ) s = s._next;
			((n._prev = s ? s._prev : l) ? (n._prev._next = n) : (u = n),
				(n._next = s) ? (s._prev = n) : (l = n),
				(n = r));
		}
		e._pt = u;
	},
	ur = (function () {
		function p(n, r, s, u, l, h, f, v, w) {
			((this.t = r),
				(this.s = u),
				(this.c = l),
				(this.p = s),
				(this.r = h || nd),
				(this.d = f || this),
				(this.set = v || qc),
				(this.pr = w || 0),
				(this._next = n),
				n && (n._prev = this));
		}
		var e = p.prototype;
		return (
			(e.modifier = function (r, s, u) {
				((this.mSet = this.mSet || this.set),
					(this.set = hm),
					(this.m = r),
					(this.mt = u),
					(this.tween = s));
			}),
			p
		);
	})();
ar(
	Nc +
		"parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
	function (p) {
		return (zc[p] = 1);
	},
);
Tr.TweenMax = Tr.TweenLite = ji;
Tr.TimelineLite = Tr.TimelineMax = jn;
Ei = new jn({
	sortChildren: !1,
	defaults: la,
	autoRemoveChildren: !0,
	id: "root",
	smoothChildTiming: !0,
});
Sr.stringFilter = Gf;
var So = [],
	Bu = {},
	fm = [],
	wh = 0,
	dm = 0,
	Ll = function (e) {
		return (Bu[e] || fm).map(function (n) {
			return n();
		});
	},
	pc = function () {
		var e = Date.now(),
			n = [];
		e - wh > 2 &&
			(Ll("matchMediaInit"),
			So.forEach(function (r) {
				var s = r.queries,
					u = r.conditions,
					l,
					h,
					f,
					v;
				for (h in s)
					((l = is.matchMedia(s[h]).matches),
						l && (f = 1),
						l !== u[h] && ((u[h] = l), (v = 1)));
				v && (r.revert(), f && n.push(r));
			}),
			Ll("matchMediaRevert"),
			n.forEach(function (r) {
				return r.onMatch(r, function (s) {
					return r.add(null, s);
				});
			}),
			(wh = e),
			Ll("matchMedia"));
	},
	od = (function () {
		function p(n, r) {
			((this.selector = r && hc(r)),
				(this.data = []),
				(this._r = []),
				(this.isReverted = !1),
				(this.id = dm++),
				n && this.add(n));
		}
		var e = p.prototype;
		return (
			(e.add = function (r, s, u) {
				Oi(r) && ((u = s), (s = r), (r = Oi));
				var l = this,
					h = function () {
						var v = _i,
							w = l.selector,
							A;
						return (
							v && v !== l && v.data.push(l),
							u && (l.selector = hc(u)),
							(_i = l),
							(A = s.apply(l, arguments)),
							Oi(A) && l._r.push(A),
							(_i = v),
							(l.selector = w),
							(l.isReverted = !1),
							A
						);
					};
				return (
					(l.last = h),
					r === Oi
						? h(l, function (f) {
								return l.add(null, f);
							})
						: r
							? (l[r] = h)
							: h
				);
			}),
			(e.ignore = function (r) {
				var s = _i;
				((_i = null), r(this), (_i = s));
			}),
			(e.getTweens = function () {
				var r = [];
				return (
					this.data.forEach(function (s) {
						return s instanceof p
							? r.push.apply(r, s.getTweens())
							: s instanceof ji &&
									!(s.parent && s.parent.data === "nested") &&
									r.push(s);
					}),
					r
				);
			}),
			(e.clear = function () {
				this._r.length = this.data.length = 0;
			}),
			(e.kill = function (r, s) {
				var u = this;
				if (
					(r
						? (function () {
								for (var h = u.getTweens(), f = u.data.length, v; f--; )
									((v = u.data[f]),
										v.data === "isFlip" &&
											(v.revert(),
											v.getChildren(!0, !0, !1).forEach(function (w) {
												return h.splice(h.indexOf(w), 1);
											})));
								for (
									h
										.map(function (w) {
											return {
												g:
													w._dur ||
													w._delay ||
													(w._sat && !w._sat.vars.immediateRender)
														? w.globalTime(0)
														: -1 / 0,
												t: w,
											};
										})
										.sort(function (w, A) {
											return A.g - w.g || -1 / 0;
										})
										.forEach(function (w) {
											return w.t.revert(r);
										}),
										f = u.data.length;
									f--;
								)
									((v = u.data[f]),
										v instanceof jn
											? v.data !== "nested" &&
												(v.scrollTrigger && v.scrollTrigger.revert(), v.kill())
											: !(v instanceof ji) && v.revert && v.revert(r));
								(u._r.forEach(function (w) {
									return w(r, u);
								}),
									(u.isReverted = !0));
							})()
						: this.data.forEach(function (h) {
								return h.kill && h.kill();
							}),
					this.clear(),
					s)
				)
					for (var l = So.length; l--; )
						So[l].id === this.id && So.splice(l, 1);
			}),
			(e.revert = function (r) {
				this.kill(r || {});
			}),
			p
		);
	})(),
	pm = (function () {
		function p(n) {
			((this.contexts = []), (this.scope = n), _i && _i.data.push(this));
		}
		var e = p.prototype;
		return (
			(e.add = function (r, s, u) {
				ls(r) || (r = { matches: r });
				var l = new od(0, u || this.scope),
					h = (l.conditions = {}),
					f,
					v,
					w;
				(_i && !l.selector && (l.selector = _i.selector),
					this.contexts.push(l),
					(s = l.add("onMatch", s)),
					(l.queries = r));
				for (v in r)
					v === "all"
						? (w = 1)
						: ((f = is.matchMedia(r[v])),
							f &&
								(So.indexOf(l) < 0 && So.push(l),
								(h[v] = f.matches) && (w = 1),
								f.addListener
									? f.addListener(pc)
									: f.addEventListener("change", pc)));
				return (
					w &&
						s(l, function (A) {
							return l.add(null, A);
						}),
					this
				);
			}),
			(e.revert = function (r) {
				this.kill(r || {});
			}),
			(e.kill = function (r) {
				this.contexts.forEach(function (s) {
					return s.kill(r, !0);
				});
			}),
			p
		);
	})(),
	$u = {
		registerPlugin: function () {
			for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
				n[r] = arguments[r];
			n.forEach(function (s) {
				return Uf(s);
			});
		},
		timeline: function (e) {
			return new jn(e);
		},
		getTweensOf: function (e, n) {
			return Ei.getTweensOf(e, n);
		},
		getProperty: function (e, n, r, s) {
			sn(e) && (e = zr(e)[0]);
			var u = bo(e || {}).get,
				l = r ? Of : Mf;
			return (
				r === "native" && (r = ""),
				e &&
					(n
						? l(((yr[n] && yr[n].get) || u)(e, n, r, s))
						: function (h, f, v) {
								return l(((yr[h] && yr[h].get) || u)(e, h, f, v));
							})
			);
		},
		quickSetter: function (e, n, r) {
			if (((e = zr(e)), e.length > 1)) {
				var s = e.map(function (w) {
						return cr.quickSetter(w, n, r);
					}),
					u = s.length;
				return function (w) {
					for (var A = u; A--; ) s[A](w);
				};
			}
			e = e[0] || {};
			var l = yr[n],
				h = bo(e),
				f = (h.harness && (h.harness.aliases || {})[n]) || n,
				v = l
					? function (w) {
							var A = new l();
							((ta._pt = 0),
								A.init(e, r ? w + r : w, ta, 0, [e]),
								A.render(1, A),
								ta._pt && Zc(1, ta));
						}
					: h.set(e, f);
			return l
				? v
				: function (w) {
						return v(e, f, r ? w + r : w, h, 1);
					};
		},
		quickTo: function (e, n, r) {
			var s,
				u = cr.to(
					e,
					Po(((s = {}), (s[n] = "+=0.1"), (s.paused = !0), s), r || {}),
				),
				l = function (f, v, w) {
					return u.resetTo(n, f, v, w);
				};
			return ((l.tween = u), l);
		},
		isTweening: function (e) {
			return Ei.getTweensOf(e, !0).length > 0;
		},
		defaults: function (e) {
			return (e && e.ease && (e.ease = wo(e.ease, la.ease)), _h(la, e || {}));
		},
		config: function (e) {
			return _h(Sr, e || {});
		},
		registerEffect: function (e) {
			var n = e.name,
				r = e.effect,
				s = e.plugins,
				u = e.defaults,
				l = e.extendTimeline;
			((s || "").split(",").forEach(function (h) {
				return (
					h && !yr[h] && !Tr[h] && Ya(n + " effect requires " + h + " plugin.")
				);
			}),
				(Tl[n] = function (h, f, v) {
					return r(zr(h), Rr(f || {}, u), v);
				}),
				l &&
					(jn.prototype[n] = function (h, f, v) {
						return this.add(Tl[n](h, ls(f) ? f : (v = f) && {}, this), v);
					}));
		},
		registerEase: function (e, n) {
			De[e] = wo(n);
		},
		parseEase: function (e, n) {
			return arguments.length ? wo(e, n) : De;
		},
		getById: function (e) {
			return Ei.getById(e);
		},
		exportRoot: function (e, n) {
			e === void 0 && (e = {});
			var r = new jn(e),
				s,
				u;
			for (
				r.smoothChildTiming = or(e.smoothChildTiming),
					Ei.remove(r),
					r._dp = 0,
					r._time = r._tTime = Ei._time,
					s = Ei._first;
				s;
			)
				((u = s._next),
					(n ||
						!(
							!s._dur &&
							s instanceof ji &&
							s.vars.onComplete === s._targets[0]
						)) &&
						rs(r, s, s._start - s._delay),
					(s = u));
			return (rs(Ei, r, 0), r);
		},
		context: function (e, n) {
			return e ? new od(e, n) : _i;
		},
		matchMedia: function (e) {
			return new pm(e);
		},
		matchMediaRefresh: function () {
			return (
				So.forEach(function (e) {
					var n = e.conditions,
						r,
						s;
					for (s in n) n[s] && ((n[s] = !1), (r = 1));
					r && e.revert();
				}) || pc()
			);
		},
		addEventListener: function (e, n) {
			var r = Bu[e] || (Bu[e] = []);
			~r.indexOf(n) || r.push(n);
		},
		removeEventListener: function (e, n) {
			var r = Bu[e],
				s = r && r.indexOf(n);
			s >= 0 && r.splice(s, 1);
		},
		utils: {
			wrap: $p,
			wrapYoyo: Vp,
			distribute: Ff,
			random: qf,
			snap: Hf,
			normalize: Up,
			getUnit: wn,
			clamp: qp,
			splitColor: $f,
			toArray: zr,
			selector: hc,
			mapRange: Zf,
			pipe: Zp,
			unitize: jp,
			interpolate: Gp,
			shuffle: Rf,
		},
		install: Cf,
		effects: Tl,
		ticker: br,
		updateRoot: jn.updateRoot,
		plugins: yr,
		globalTimeline: Ei,
		core: {
			PropTween: ur,
			globals: Pf,
			Tween: ji,
			Timeline: jn,
			Animation: tu,
			getCache: bo,
			_removeLinkedListItem: el,
			reverting: function () {
				return Sn;
			},
			context: function (e) {
				return (e && _i && (_i.data.push(e), (e._ctx = _i)), _i);
			},
			suppressOverwrites: function (e) {
				return (Mc = e);
			},
		},
	};
ar("to,from,fromTo,delayedCall,set,killTweensOf", function (p) {
	return ($u[p] = ji[p]);
});
br.add(jn.updateRoot);
ta = $u.to({}, { duration: 0 });
var mm = function (e, n) {
		for (var r = e._pt; r && r.p !== n && r.op !== n && r.fp !== n; )
			r = r._next;
		return r;
	},
	gm = function (e, n) {
		var r = e._targets,
			s,
			u,
			l;
		for (s in n)
			for (u = r.length; u--; )
				((l = e._ptLookup[u][s]),
					l &&
						(l = l.d) &&
						(l._pt && (l = mm(l, s)),
						l && l.modifier && l.modifier(n[s], e, r[u], s)));
	},
	kl = function (e, n) {
		return {
			name: e,
			rawVars: 1,
			init: function (s, u, l) {
				l._onInit = function (h) {
					var f, v;
					if (
						(sn(u) &&
							((f = {}),
							ar(u, function (w) {
								return (f[w] = 1);
							}),
							(u = f)),
						n)
					) {
						f = {};
						for (v in u) f[v] = n(u[v]);
						u = f;
					}
					gm(h, u);
				};
			},
		};
	},
	cr =
		$u.registerPlugin(
			{
				name: "attr",
				init: function (e, n, r, s, u) {
					var l, h, f;
					this.tween = r;
					for (l in n)
						((f = e.getAttribute(l) || ""),
							(h = this.add(
								e,
								"setAttribute",
								(f || 0) + "",
								n[l],
								s,
								u,
								0,
								0,
								l,
							)),
							(h.op = l),
							(h.b = f),
							this._props.push(l));
				},
				render: function (e, n) {
					for (var r = n._pt; r; )
						(Sn ? r.set(r.t, r.p, r.b, r) : r.r(e, r.d), (r = r._next));
				},
			},
			{
				name: "endArray",
				init: function (e, n) {
					for (var r = n.length; r--; )
						this.add(e, r, e[r] || 0, n[r], 0, 0, 0, 0, 0, 1);
				},
			},
			kl("roundProps", fc),
			kl("modifiers"),
			kl("snap", Hf),
		) || $u;
ji.version = jn.version = cr.version = "3.12.5";
Ef = 1;
Dc() && fa();
De.Power0;
De.Power1;
De.Power2;
De.Power3;
De.Power4;
De.Linear;
De.Quad;
De.Cubic;
De.Quart;
De.Quint;
De.Strong;
De.Elastic;
De.Back;
De.SteppedEase;
De.Bounce;
De.Sine;
De.Expo;
De.Circ;
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */ var Sh,
	Hs,
	na,
	jc,
	vo,
	Th,
	Uc,
	_m = function () {
		return typeof window < "u";
	},
	Ls = {},
	mo = 180 / Math.PI,
	ra = Math.PI / 180,
	Go = Math.atan2,
	Eh = 1e8,
	$c = /([A-Z])/g,
	vm = /(left|right|width|margin|padding|x)/i,
	ym = /[\s,\(]\S/,
	ss = {
		autoAlpha: "opacity,visibility",
		scale: "scaleX,scaleY",
		alpha: "opacity",
	},
	mc = function (e, n) {
		return n.set(n.t, n.p, Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u, n);
	},
	bm = function (e, n) {
		return n.set(
			n.t,
			n.p,
			e === 1 ? n.e : Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u,
			n,
		);
	},
	xm = function (e, n) {
		return n.set(
			n.t,
			n.p,
			e ? Math.round((n.s + n.c * e) * 1e4) / 1e4 + n.u : n.b,
			n,
		);
	},
	wm = function (e, n) {
		var r = n.s + n.c * e;
		n.set(n.t, n.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + n.u, n);
	},
	ad = function (e, n) {
		return n.set(n.t, n.p, e ? n.e : n.b, n);
	},
	ud = function (e, n) {
		return n.set(n.t, n.p, e !== 1 ? n.b : n.e, n);
	},
	Sm = function (e, n, r) {
		return (e.style[n] = r);
	},
	Tm = function (e, n, r) {
		return e.style.setProperty(n, r);
	},
	Em = function (e, n, r) {
		return (e._gsap[n] = r);
	},
	Cm = function (e, n, r) {
		return (e._gsap.scaleX = e._gsap.scaleY = r);
	},
	Pm = function (e, n, r, s, u) {
		var l = e._gsap;
		((l.scaleX = l.scaleY = r), l.renderTransform(u, l));
	},
	Lm = function (e, n, r, s, u) {
		var l = e._gsap;
		((l[n] = r), l.renderTransform(u, l));
	},
	Ci = "transform",
	lr = Ci + "Origin",
	km = function p(e, n) {
		var r = this,
			s = this.target,
			u = s.style,
			l = s._gsap;
		if (e in Ls && u) {
			if (((this.tfm = this.tfm || {}), e !== "transform"))
				((e = ss[e] || e),
					~e.indexOf(",")
						? e.split(",").forEach(function (h) {
								return (r.tfm[h] = Ss(s, h));
							})
						: (this.tfm[e] = l.x ? l[e] : Ss(s, e)),
					e === lr && (this.tfm.zOrigin = l.zOrigin));
			else
				return ss.transform.split(",").forEach(function (h) {
					return p.call(r, h, n);
				});
			if (this.props.indexOf(Ci) >= 0) return;
			(l.svg &&
				((this.svgo = s.getAttribute("data-svg-origin")),
				this.props.push(lr, n, "")),
				(e = Ci));
		}
		(u || n) && this.props.push(e, n, u[e]);
	},
	ld = function (e) {
		e.translate &&
			(e.removeProperty("translate"),
			e.removeProperty("scale"),
			e.removeProperty("rotate"));
	},
	Am = function () {
		var e = this.props,
			n = this.target,
			r = n.style,
			s = n._gsap,
			u,
			l;
		for (u = 0; u < e.length; u += 3)
			e[u + 1]
				? (n[e[u]] = e[u + 2])
				: e[u + 2]
					? (r[e[u]] = e[u + 2])
					: r.removeProperty(
							e[u].substr(0, 2) === "--"
								? e[u]
								: e[u].replace($c, "-$1").toLowerCase(),
						);
		if (this.tfm) {
			for (l in this.tfm) s[l] = this.tfm[l];
			(s.svg &&
				(s.renderTransform(),
				n.setAttribute("data-svg-origin", this.svgo || "")),
				(u = Uc()),
				(!u || !u.isStart) &&
					!r[Ci] &&
					(ld(r),
					s.zOrigin &&
						r[lr] &&
						((r[lr] += " " + s.zOrigin + "px"),
						(s.zOrigin = 0),
						s.renderTransform()),
					(s.uncache = 1)));
		}
	},
	cd = function (e, n) {
		var r = { target: e, props: [], revert: Am, save: km };
		return (
			e._gsap || cr.core.getCache(e),
			n &&
				n.split(",").forEach(function (s) {
					return r.save(s);
				}),
			r
		);
	},
	hd,
	gc = function (e, n) {
		var r = Hs.createElementNS
			? Hs.createElementNS(
					(n || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"),
					e,
				)
			: Hs.createElement(e);
		return r && r.style ? r : Hs.createElement(e);
	},
	as = function p(e, n, r) {
		var s = getComputedStyle(e);
		return (
			s[n] ||
			s.getPropertyValue(n.replace($c, "-$1").toLowerCase()) ||
			s.getPropertyValue(n) ||
			(!r && p(e, da(n) || n, 1)) ||
			""
		);
	},
	Ch = "O,Moz,ms,Ms,Webkit".split(","),
	da = function (e, n, r) {
		var s = n || vo,
			u = s.style,
			l = 5;
		if (e in u && !r) return e;
		for (
			e = e.charAt(0).toUpperCase() + e.substr(1);
			l-- && !(Ch[l] + e in u);
		);
		return l < 0 ? null : (l === 3 ? "ms" : l >= 0 ? Ch[l] : "") + e;
	},
	_c = function () {
		_m() &&
			window.document &&
			((Sh = window),
			(Hs = Sh.document),
			(na = Hs.documentElement),
			(vo = gc("div") || { style: {} }),
			gc("div"),
			(Ci = da(Ci)),
			(lr = Ci + "Origin"),
			(vo.style.cssText =
				"border-width:0;line-height:0;position:absolute;padding:0"),
			(hd = !!da("perspective")),
			(Uc = cr.core.reverting),
			(jc = 1));
	},
	Al = function p(e) {
		var n = gc(
				"svg",
				(this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) ||
					"http://www.w3.org/2000/svg",
			),
			r = this.parentNode,
			s = this.nextSibling,
			u = this.style.cssText,
			l;
		if (
			(na.appendChild(n),
			n.appendChild(this),
			(this.style.display = "block"),
			e)
		)
			try {
				((l = this.getBBox()),
					(this._gsapBBox = this.getBBox),
					(this.getBBox = p));
			} catch {}
		else this._gsapBBox && (l = this._gsapBBox());
		return (
			r && (s ? r.insertBefore(this, s) : r.appendChild(this)),
			na.removeChild(n),
			(this.style.cssText = u),
			l
		);
	},
	Ph = function (e, n) {
		for (var r = n.length; r--; )
			if (e.hasAttribute(n[r])) return e.getAttribute(n[r]);
	},
	fd = function (e) {
		var n;
		try {
			n = e.getBBox();
		} catch {
			n = Al.call(e, !0);
		}
		return (
			(n && (n.width || n.height)) || e.getBBox === Al || (n = Al.call(e, !0)),
			n && !n.width && !n.x && !n.y
				? {
						x: +Ph(e, ["x", "cx", "x1"]) || 0,
						y: +Ph(e, ["y", "cy", "y1"]) || 0,
						width: 0,
						height: 0,
					}
				: n
		);
	},
	dd = function (e) {
		return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && fd(e));
	},
	Lo = function (e, n) {
		if (n) {
			var r = e.style,
				s;
			(n in Ls && n !== lr && (n = Ci),
				r.removeProperty
					? ((s = n.substr(0, 2)),
						(s === "ms" || n.substr(0, 6) === "webkit") && (n = "-" + n),
						r.removeProperty(
							s === "--" ? n : n.replace($c, "-$1").toLowerCase(),
						))
					: r.removeAttribute(n));
		}
	},
	qs = function (e, n, r, s, u, l) {
		var h = new ur(e._pt, n, r, 0, 1, l ? ud : ad);
		return ((e._pt = h), (h.b = s), (h.e = u), e._props.push(r), h);
	},
	Lh = { deg: 1, rad: 1, turn: 1 },
	Mm = { grid: 1, flex: 1 },
	Gs = function p(e, n, r, s) {
		var u = parseFloat(r) || 0,
			l = (r + "").trim().substr((u + "").length) || "px",
			h = vo.style,
			f = vm.test(n),
			v = e.tagName.toLowerCase() === "svg",
			w = (v ? "client" : "offset") + (f ? "Width" : "Height"),
			A = 100,
			D = s === "px",
			C = s === "%",
			O,
			P,
			F,
			G;
		if (s === l || !u || Lh[s] || Lh[l]) return u;
		if (
			(l !== "px" && !D && (u = p(e, n, r, "px")),
			(G = e.getCTM && dd(e)),
			(C || l === "%") && (Ls[n] || ~n.indexOf("adius")))
		)
			return (
				(O = G ? e.getBBox()[f ? "width" : "height"] : e[w]),
				Ni(C ? (u / O) * A : (u / 100) * O)
			);
		if (
			((h[f ? "width" : "height"] = A + (D ? l : s)),
			(P =
				~n.indexOf("adius") || (s === "em" && e.appendChild && !v)
					? e
					: e.parentNode),
			G && (P = (e.ownerSVGElement || {}).parentNode),
			(!P || P === Hs || !P.appendChild) && (P = Hs.body),
			(F = P._gsap),
			F && C && F.width && f && F.time === br.time && !F.uncache)
		)
			return Ni((u / F.width) * A);
		if (C && (n === "height" || n === "width")) {
			var B = e.style[n];
			((e.style[n] = A + s), (O = e[w]), B ? (e.style[n] = B) : Lo(e, n));
		} else
			((C || l === "%") &&
				!Mm[as(P, "display")] &&
				(h.position = as(e, "position")),
				P === e && (h.position = "static"),
				P.appendChild(vo),
				(O = vo[w]),
				P.removeChild(vo),
				(h.position = "absolute"));
		return (
			f && C && ((F = bo(P)), (F.time = br.time), (F.width = P[w])),
			Ni(D ? (O * u) / A : O && u ? (A / O) * u : 0)
		);
	},
	Ss = function (e, n, r, s) {
		var u;
		return (
			jc || _c(),
			n in ss &&
				n !== "transform" &&
				((n = ss[n]), ~n.indexOf(",") && (n = n.split(",")[0])),
			Ls[n] && n !== "transform"
				? ((u = iu(e, s)),
					(u =
						n !== "transformOrigin"
							? u[n]
							: u.svg
								? u.origin
								: Gu(as(e, lr)) + " " + u.zOrigin + "px"))
				: ((u = e.style[n]),
					(!u || u === "auto" || s || ~(u + "").indexOf("calc(")) &&
						(u =
							(Vu[n] && Vu[n](e, n, r)) ||
							as(e, n) ||
							kf(e, n) ||
							(n === "opacity" ? 1 : 0))),
			r && !~(u + "").trim().indexOf(" ") ? Gs(e, n, u, r) + r : u
		);
	},
	Om = function (e, n, r, s) {
		if (!r || r === "none") {
			var u = da(n, e, 1),
				l = u && as(e, u, 1);
			l && l !== r
				? ((n = u), (r = l))
				: n === "borderColor" && (r = as(e, "borderTopColor"));
		}
		var h = new ur(this._pt, e.style, n, 0, 1, rd),
			f = 0,
			v = 0,
			w,
			A,
			D,
			C,
			O,
			P,
			F,
			G,
			B,
			j,
			V,
			Q;
		if (
			((h.b = r),
			(h.e = s),
			(r += ""),
			(s += ""),
			s === "auto" &&
				((P = e.style[n]),
				(e.style[n] = s),
				(s = as(e, n) || s),
				P ? (e.style[n] = P) : Lo(e, n)),
			(w = [r, s]),
			Gf(w),
			(r = w[0]),
			(s = w[1]),
			(D = r.match(Qo) || []),
			(Q = s.match(Qo) || []),
			Q.length)
		) {
			for (; (A = Qo.exec(s)); )
				((F = A[0]),
					(B = s.substring(f, A.index)),
					O
						? (O = (O + 1) % 5)
						: (B.substr(-5) === "rgba(" || B.substr(-5) === "hsla(") && (O = 1),
					F !== (P = D[v++] || "") &&
						((C = parseFloat(P) || 0),
						(V = P.substr((C + "").length)),
						F.charAt(1) === "=" && (F = ia(C, F) + V),
						(G = parseFloat(F)),
						(j = F.substr((G + "").length)),
						(f = Qo.lastIndex - j.length),
						j ||
							((j = j || Sr.units[n] || V),
							f === s.length && ((s += j), (h.e += j))),
						V !== j && (C = Gs(e, n, P, j) || 0),
						(h._pt = {
							_next: h._pt,
							p: B || v === 1 ? B : ",",
							s: C,
							c: G - C,
							m: (O && O < 4) || n === "zIndex" ? Math.round : 0,
						})));
			h.c = f < s.length ? s.substring(f, s.length) : "";
		} else h.r = n === "display" && s === "none" ? ud : ad;
		return (Sf.test(s) && (h.e = 0), (this._pt = h), h);
	},
	kh = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" },
	Dm = function (e) {
		var n = e.split(" "),
			r = n[0],
			s = n[1] || "50%";
		return (
			(r === "top" || r === "bottom" || s === "left" || s === "right") &&
				((e = r), (r = s), (s = e)),
			(n[0] = kh[r] || r),
			(n[1] = kh[s] || s),
			n.join(" ")
		);
	},
	Im = function (e, n) {
		if (n.tween && n.tween._time === n.tween._dur) {
			var r = n.t,
				s = r.style,
				u = n.u,
				l = r._gsap,
				h,
				f,
				v;
			if (u === "all" || u === !0) ((s.cssText = ""), (f = 1));
			else
				for (u = u.split(","), v = u.length; --v > -1; )
					((h = u[v]),
						Ls[h] && ((f = 1), (h = h === "transformOrigin" ? lr : Ci)),
						Lo(r, h));
			f &&
				(Lo(r, Ci),
				l &&
					(l.svg && r.removeAttribute("transform"),
					iu(r, 1),
					(l.uncache = 1),
					ld(s)));
		}
	},
	Vu = {
		clearProps: function (e, n, r, s, u) {
			if (u.data !== "isFromStart") {
				var l = (e._pt = new ur(e._pt, n, r, 0, 0, Im));
				return ((l.u = s), (l.pr = -10), (l.tween = u), e._props.push(r), 1);
			}
		},
	},
	eu = [1, 0, 0, 1, 0, 0],
	pd = {},
	md = function (e) {
		return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
	},
	Ah = function (e) {
		var n = as(e, Ci);
		return md(n) ? eu : n.substr(7).match(wf).map(Ni);
	},
	Vc = function (e, n) {
		var r = e._gsap || bo(e),
			s = e.style,
			u = Ah(e),
			l,
			h,
			f,
			v;
		return r.svg && e.getAttribute("transform")
			? ((f = e.transform.baseVal.consolidate().matrix),
				(u = [f.a, f.b, f.c, f.d, f.e, f.f]),
				u.join(",") === "1,0,0,1,0,0" ? eu : u)
			: (u === eu &&
					!e.offsetParent &&
					e !== na &&
					!r.svg &&
					((f = s.display),
					(s.display = "block"),
					(l = e.parentNode),
					(!l || !e.offsetParent) &&
						((v = 1), (h = e.nextElementSibling), na.appendChild(e)),
					(u = Ah(e)),
					f ? (s.display = f) : Lo(e, "display"),
					v &&
						(h
							? l.insertBefore(e, h)
							: l
								? l.appendChild(e)
								: na.removeChild(e))),
				n && u.length > 6 ? [u[0], u[1], u[4], u[5], u[12], u[13]] : u);
	},
	vc = function (e, n, r, s, u, l) {
		var h = e._gsap,
			f = u || Vc(e, !0),
			v = h.xOrigin || 0,
			w = h.yOrigin || 0,
			A = h.xOffset || 0,
			D = h.yOffset || 0,
			C = f[0],
			O = f[1],
			P = f[2],
			F = f[3],
			G = f[4],
			B = f[5],
			j = n.split(" "),
			V = parseFloat(j[0]) || 0,
			Q = parseFloat(j[1]) || 0,
			it,
			g,
			ct,
			ot;
		(r
			? f !== eu &&
				(g = C * F - O * P) &&
				((ct = V * (F / g) + Q * (-P / g) + (P * B - F * G) / g),
				(ot = V * (-O / g) + Q * (C / g) - (C * B - O * G) / g),
				(V = ct),
				(Q = ot))
			: ((it = fd(e)),
				(V = it.x + (~j[0].indexOf("%") ? (V / 100) * it.width : V)),
				(Q =
					it.y + (~(j[1] || j[0]).indexOf("%") ? (Q / 100) * it.height : Q))),
			s || (s !== !1 && h.smooth)
				? ((G = V - v),
					(B = Q - w),
					(h.xOffset = A + (G * C + B * P) - G),
					(h.yOffset = D + (G * O + B * F) - B))
				: (h.xOffset = h.yOffset = 0),
			(h.xOrigin = V),
			(h.yOrigin = Q),
			(h.smooth = !!s),
			(h.origin = n),
			(h.originIsAbsolute = !!r),
			(e.style[lr] = "0px 0px"),
			l &&
				(qs(l, h, "xOrigin", v, V),
				qs(l, h, "yOrigin", w, Q),
				qs(l, h, "xOffset", A, h.xOffset),
				qs(l, h, "yOffset", D, h.yOffset)),
			e.setAttribute("data-svg-origin", V + " " + Q));
	},
	iu = function (e, n) {
		var r = e._gsap || new Jf(e);
		if ("x" in r && !n && !r.uncache) return r;
		var s = e.style,
			u = r.scaleX < 0,
			l = "px",
			h = "deg",
			f = getComputedStyle(e),
			v = as(e, lr) || "0",
			w,
			A,
			D,
			C,
			O,
			P,
			F,
			G,
			B,
			j,
			V,
			Q,
			it,
			g,
			ct,
			ot,
			ft,
			Dt,
			pt,
			Et,
			K,
			Nt,
			St,
			Ct,
			_t,
			de,
			W,
			Wt,
			Zt,
			oe,
			jt,
			Vt;
		return (
			(w = A = D = P = F = G = B = j = V = 0),
			(C = O = 1),
			(r.svg = !!(e.getCTM && dd(e))),
			f.translate &&
				((f.translate !== "none" ||
					f.scale !== "none" ||
					f.rotate !== "none") &&
					(s[Ci] =
						(f.translate !== "none"
							? "translate3d(" +
								(f.translate + " 0 0").split(" ").slice(0, 3).join(", ") +
								") "
							: "") +
						(f.rotate !== "none" ? "rotate(" + f.rotate + ") " : "") +
						(f.scale !== "none"
							? "scale(" + f.scale.split(" ").join(",") + ") "
							: "") +
						(f[Ci] !== "none" ? f[Ci] : "")),
				(s.scale = s.rotate = s.translate = "none")),
			(g = Vc(e, r.svg)),
			r.svg &&
				(r.uncache
					? ((_t = e.getBBox()),
						(v = r.xOrigin - _t.x + "px " + (r.yOrigin - _t.y) + "px"),
						(Ct = ""))
					: (Ct = !n && e.getAttribute("data-svg-origin")),
				vc(e, Ct || v, !!Ct || r.originIsAbsolute, r.smooth !== !1, g)),
			(Q = r.xOrigin || 0),
			(it = r.yOrigin || 0),
			g !== eu &&
				((Dt = g[0]),
				(pt = g[1]),
				(Et = g[2]),
				(K = g[3]),
				(w = Nt = g[4]),
				(A = St = g[5]),
				g.length === 6
					? ((C = Math.sqrt(Dt * Dt + pt * pt)),
						(O = Math.sqrt(K * K + Et * Et)),
						(P = Dt || pt ? Go(pt, Dt) * mo : 0),
						(B = Et || K ? Go(Et, K) * mo + P : 0),
						B && (O *= Math.abs(Math.cos(B * ra))),
						r.svg &&
							((w -= Q - (Q * Dt + it * Et)), (A -= it - (Q * pt + it * K))))
					: ((Vt = g[6]),
						(oe = g[7]),
						(W = g[8]),
						(Wt = g[9]),
						(Zt = g[10]),
						(jt = g[11]),
						(w = g[12]),
						(A = g[13]),
						(D = g[14]),
						(ct = Go(Vt, Zt)),
						(F = ct * mo),
						ct &&
							((ot = Math.cos(-ct)),
							(ft = Math.sin(-ct)),
							(Ct = Nt * ot + W * ft),
							(_t = St * ot + Wt * ft),
							(de = Vt * ot + Zt * ft),
							(W = Nt * -ft + W * ot),
							(Wt = St * -ft + Wt * ot),
							(Zt = Vt * -ft + Zt * ot),
							(jt = oe * -ft + jt * ot),
							(Nt = Ct),
							(St = _t),
							(Vt = de)),
						(ct = Go(-Et, Zt)),
						(G = ct * mo),
						ct &&
							((ot = Math.cos(-ct)),
							(ft = Math.sin(-ct)),
							(Ct = Dt * ot - W * ft),
							(_t = pt * ot - Wt * ft),
							(de = Et * ot - Zt * ft),
							(jt = K * ft + jt * ot),
							(Dt = Ct),
							(pt = _t),
							(Et = de)),
						(ct = Go(pt, Dt)),
						(P = ct * mo),
						ct &&
							((ot = Math.cos(ct)),
							(ft = Math.sin(ct)),
							(Ct = Dt * ot + pt * ft),
							(_t = Nt * ot + St * ft),
							(pt = pt * ot - Dt * ft),
							(St = St * ot - Nt * ft),
							(Dt = Ct),
							(Nt = _t)),
						F &&
							Math.abs(F) + Math.abs(P) > 359.9 &&
							((F = P = 0), (G = 180 - G)),
						(C = Ni(Math.sqrt(Dt * Dt + pt * pt + Et * Et))),
						(O = Ni(Math.sqrt(St * St + Vt * Vt))),
						(ct = Go(Nt, St)),
						(B = Math.abs(ct) > 2e-4 ? ct * mo : 0),
						(V = jt ? 1 / (jt < 0 ? -jt : jt) : 0)),
				r.svg &&
					((Ct = e.getAttribute("transform")),
					(r.forceCSS = e.setAttribute("transform", "") || !md(as(e, Ci))),
					Ct && e.setAttribute("transform", Ct))),
			Math.abs(B) > 90 &&
				Math.abs(B) < 270 &&
				(u
					? ((C *= -1), (B += P <= 0 ? 180 : -180), (P += P <= 0 ? 180 : -180))
					: ((O *= -1), (B += B <= 0 ? 180 : -180))),
			(n = n || r.uncache),
			(r.x =
				w -
				((r.xPercent =
					w &&
					((!n && r.xPercent) ||
						(Math.round(e.offsetWidth / 2) === Math.round(-w) ? -50 : 0)))
					? (e.offsetWidth * r.xPercent) / 100
					: 0) +
				l),
			(r.y =
				A -
				((r.yPercent =
					A &&
					((!n && r.yPercent) ||
						(Math.round(e.offsetHeight / 2) === Math.round(-A) ? -50 : 0)))
					? (e.offsetHeight * r.yPercent) / 100
					: 0) +
				l),
			(r.z = D + l),
			(r.scaleX = Ni(C)),
			(r.scaleY = Ni(O)),
			(r.rotation = Ni(P) + h),
			(r.rotationX = Ni(F) + h),
			(r.rotationY = Ni(G) + h),
			(r.skewX = B + h),
			(r.skewY = j + h),
			(r.transformPerspective = V + l),
			(r.zOrigin = parseFloat(v.split(" ")[2]) || (!n && r.zOrigin) || 0) &&
				(s[lr] = Gu(v)),
			(r.xOffset = r.yOffset = 0),
			(r.force3D = Sr.force3D),
			(r.renderTransform = r.svg ? zm : hd ? gd : Bm),
			(r.uncache = 0),
			r
		);
	},
	Gu = function (e) {
		return (e = e.split(" "))[0] + " " + e[1];
	},
	Ml = function (e, n, r) {
		var s = wn(n);
		return Ni(parseFloat(n) + parseFloat(Gs(e, "x", r + "px", s))) + s;
	},
	Bm = function (e, n) {
		((n.z = "0px"),
			(n.rotationY = n.rotationX = "0deg"),
			(n.force3D = 0),
			gd(e, n));
	},
	co = "0deg",
	Pa = "0px",
	ho = ") ",
	gd = function (e, n) {
		var r = n || this,
			s = r.xPercent,
			u = r.yPercent,
			l = r.x,
			h = r.y,
			f = r.z,
			v = r.rotation,
			w = r.rotationY,
			A = r.rotationX,
			D = r.skewX,
			C = r.skewY,
			O = r.scaleX,
			P = r.scaleY,
			F = r.transformPerspective,
			G = r.force3D,
			B = r.target,
			j = r.zOrigin,
			V = "",
			Q = (G === "auto" && e && e !== 1) || G === !0;
		if (j && (A !== co || w !== co)) {
			var it = parseFloat(w) * ra,
				g = Math.sin(it),
				ct = Math.cos(it),
				ot;
			((it = parseFloat(A) * ra),
				(ot = Math.cos(it)),
				(l = Ml(B, l, g * ot * -j)),
				(h = Ml(B, h, -Math.sin(it) * -j)),
				(f = Ml(B, f, ct * ot * -j + j)));
		}
		(F !== Pa && (V += "perspective(" + F + ho),
			(s || u) && (V += "translate(" + s + "%, " + u + "%) "),
			(Q || l !== Pa || h !== Pa || f !== Pa) &&
				(V +=
					f !== Pa || Q
						? "translate3d(" + l + ", " + h + ", " + f + ") "
						: "translate(" + l + ", " + h + ho),
			v !== co && (V += "rotate(" + v + ho),
			w !== co && (V += "rotateY(" + w + ho),
			A !== co && (V += "rotateX(" + A + ho),
			(D !== co || C !== co) && (V += "skew(" + D + ", " + C + ho),
			(O !== 1 || P !== 1) && (V += "scale(" + O + ", " + P + ho),
			(B.style[Ci] = V || "translate(0, 0)"));
	},
	zm = function (e, n) {
		var r = n || this,
			s = r.xPercent,
			u = r.yPercent,
			l = r.x,
			h = r.y,
			f = r.rotation,
			v = r.skewX,
			w = r.skewY,
			A = r.scaleX,
			D = r.scaleY,
			C = r.target,
			O = r.xOrigin,
			P = r.yOrigin,
			F = r.xOffset,
			G = r.yOffset,
			B = r.forceCSS,
			j = parseFloat(l),
			V = parseFloat(h),
			Q,
			it,
			g,
			ct,
			ot;
		((f = parseFloat(f)),
			(v = parseFloat(v)),
			(w = parseFloat(w)),
			w && ((w = parseFloat(w)), (v += w), (f += w)),
			f || v
				? ((f *= ra),
					(v *= ra),
					(Q = Math.cos(f) * A),
					(it = Math.sin(f) * A),
					(g = Math.sin(f - v) * -D),
					(ct = Math.cos(f - v) * D),
					v &&
						((w *= ra),
						(ot = Math.tan(v - w)),
						(ot = Math.sqrt(1 + ot * ot)),
						(g *= ot),
						(ct *= ot),
						w &&
							((ot = Math.tan(w)),
							(ot = Math.sqrt(1 + ot * ot)),
							(Q *= ot),
							(it *= ot))),
					(Q = Ni(Q)),
					(it = Ni(it)),
					(g = Ni(g)),
					(ct = Ni(ct)))
				: ((Q = A), (ct = D), (it = g = 0)),
			((j && !~(l + "").indexOf("px")) || (V && !~(h + "").indexOf("px"))) &&
				((j = Gs(C, "x", l, "px")), (V = Gs(C, "y", h, "px"))),
			(O || P || F || G) &&
				((j = Ni(j + O - (O * Q + P * g) + F)),
				(V = Ni(V + P - (O * it + P * ct) + G))),
			(s || u) &&
				((ot = C.getBBox()),
				(j = Ni(j + (s / 100) * ot.width)),
				(V = Ni(V + (u / 100) * ot.height))),
			(ot =
				"matrix(" +
				Q +
				"," +
				it +
				"," +
				g +
				"," +
				ct +
				"," +
				j +
				"," +
				V +
				")"),
			C.setAttribute("transform", ot),
			B && (C.style[Ci] = ot));
	},
	Nm = function (e, n, r, s, u) {
		var l = 360,
			h = sn(u),
			f = parseFloat(u) * (h && ~u.indexOf("rad") ? mo : 1),
			v = f - s,
			w = s + v + "deg",
			A,
			D;
		return (
			h &&
				((A = u.split("_")[1]),
				A === "short" && ((v %= l), v !== v % (l / 2) && (v += v < 0 ? l : -l)),
				A === "cw" && v < 0
					? (v = ((v + l * Eh) % l) - ~~(v / l) * l)
					: A === "ccw" && v > 0 && (v = ((v - l * Eh) % l) - ~~(v / l) * l)),
			(e._pt = D = new ur(e._pt, n, r, s, v, bm)),
			(D.e = w),
			(D.u = "deg"),
			e._props.push(r),
			D
		);
	},
	Mh = function (e, n) {
		for (var r in n) e[r] = n[r];
		return e;
	},
	Rm = function (e, n, r) {
		var s = Mh({}, r._gsap),
			u = "perspective,force3D,transformOrigin,svgOrigin",
			l = r.style,
			h,
			f,
			v,
			w,
			A,
			D,
			C,
			O;
		s.svg
			? ((v = r.getAttribute("transform")),
				r.setAttribute("transform", ""),
				(l[Ci] = n),
				(h = iu(r, 1)),
				Lo(r, Ci),
				r.setAttribute("transform", v))
			: ((v = getComputedStyle(r)[Ci]),
				(l[Ci] = n),
				(h = iu(r, 1)),
				(l[Ci] = v));
		for (f in Ls)
			((v = s[f]),
				(w = h[f]),
				v !== w &&
					u.indexOf(f) < 0 &&
					((C = wn(v)),
					(O = wn(w)),
					(A = C !== O ? Gs(r, f, v, O) : parseFloat(v)),
					(D = parseFloat(w)),
					(e._pt = new ur(e._pt, h, f, A, D - A, mc)),
					(e._pt.u = O || 0),
					e._props.push(f)));
		Mh(h, s);
	};
ar("padding,margin,Width,Radius", function (p, e) {
	var n = "Top",
		r = "Right",
		s = "Bottom",
		u = "Left",
		l = (e < 3 ? [n, r, s, u] : [n + u, n + r, s + r, s + u]).map(function (h) {
			return e < 2 ? p + h : "border" + h + p;
		});
	Vu[e > 1 ? "border" + p : p] = function (h, f, v, w, A) {
		var D, C;
		if (arguments.length < 4)
			return (
				(D = l.map(function (O) {
					return Ss(h, O, v);
				})),
				(C = D.join(" ")),
				C.split(D[0]).length === 5 ? D[0] : C
			);
		((D = (w + "").split(" ")),
			(C = {}),
			l.forEach(function (O, P) {
				return (C[O] = D[P] = D[P] || D[((P - 1) / 2) | 0]);
			}),
			h.init(f, C, A));
	};
});
var _d = {
	name: "css",
	register: _c,
	targetTest: function (e) {
		return e.style && e.nodeType;
	},
	init: function (e, n, r, s, u) {
		var l = this._props,
			h = e.style,
			f = r.vars.startAt,
			v,
			w,
			A,
			D,
			C,
			O,
			P,
			F,
			G,
			B,
			j,
			V,
			Q,
			it,
			g,
			ct;
		(jc || _c(),
			(this.styles = this.styles || cd(e)),
			(ct = this.styles.props),
			(this.tween = r));
		for (P in n)
			if (P !== "autoRound" && ((w = n[P]), !(yr[P] && Qf(P, n, r, s, e, u)))) {
				if (
					((C = typeof w),
					(O = Vu[P]),
					C === "function" && ((w = w.call(r, s, e, u)), (C = typeof w)),
					C === "string" && ~w.indexOf("random(") && (w = Ja(w)),
					O)
				)
					O(this, e, P, w, r) && (g = 1);
				else if (P.substr(0, 2) === "--")
					((v = (getComputedStyle(e).getPropertyValue(P) + "").trim()),
						(w += ""),
						(Us.lastIndex = 0),
						Us.test(v) || ((F = wn(v)), (G = wn(w))),
						G ? F !== G && (v = Gs(e, P, v, G) + G) : F && (w += F),
						this.add(h, "setProperty", v, w, s, u, 0, 0, P),
						l.push(P),
						ct.push(P, 0, h[P]));
				else if (C !== "undefined") {
					if (
						(f && P in f
							? ((v = typeof f[P] == "function" ? f[P].call(r, s, e, u) : f[P]),
								sn(v) && ~v.indexOf("random(") && (v = Ja(v)),
								wn(v + "") ||
									v === "auto" ||
									(v += Sr.units[P] || wn(Ss(e, P)) || ""),
								(v + "").charAt(1) === "=" && (v = Ss(e, P)))
							: (v = Ss(e, P)),
						(D = parseFloat(v)),
						(B = C === "string" && w.charAt(1) === "=" && w.substr(0, 2)),
						B && (w = w.substr(2)),
						(A = parseFloat(w)),
						P in ss &&
							(P === "autoAlpha" &&
								(D === 1 && Ss(e, "visibility") === "hidden" && A && (D = 0),
								ct.push("visibility", 0, h.visibility),
								qs(
									this,
									h,
									"visibility",
									D ? "inherit" : "hidden",
									A ? "inherit" : "hidden",
									!A,
								)),
							P !== "scale" &&
								P !== "transform" &&
								((P = ss[P]), ~P.indexOf(",") && (P = P.split(",")[0]))),
						(j = P in Ls),
						j)
					) {
						if (
							(this.styles.save(P),
							V ||
								((Q = e._gsap),
								(Q.renderTransform && !n.parseTransform) ||
									iu(e, n.parseTransform),
								(it = n.smoothOrigin !== !1 && Q.smooth),
								(V = this._pt =
									new ur(this._pt, h, Ci, 0, 1, Q.renderTransform, Q, 0, -1)),
								(V.dep = 1)),
							P === "scale")
						)
							((this._pt = new ur(
								this._pt,
								Q,
								"scaleY",
								Q.scaleY,
								(B ? ia(Q.scaleY, B + A) : A) - Q.scaleY || 0,
								mc,
							)),
								(this._pt.u = 0),
								l.push("scaleY", P),
								(P += "X"));
						else if (P === "transformOrigin") {
							(ct.push(lr, 0, h[lr]),
								(w = Dm(w)),
								Q.svg
									? vc(e, w, 0, it, 0, this)
									: ((G = parseFloat(w.split(" ")[2]) || 0),
										G !== Q.zOrigin && qs(this, Q, "zOrigin", Q.zOrigin, G),
										qs(this, h, P, Gu(v), Gu(w))));
							continue;
						} else if (P === "svgOrigin") {
							vc(e, w, 1, it, 0, this);
							continue;
						} else if (P in pd) {
							Nm(this, Q, P, D, B ? ia(D, B + w) : w);
							continue;
						} else if (P === "smoothOrigin") {
							qs(this, Q, "smooth", Q.smooth, w);
							continue;
						} else if (P === "force3D") {
							Q[P] = w;
							continue;
						} else if (P === "transform") {
							Rm(this, w, e);
							continue;
						}
					} else P in h || (P = da(P) || P);
					if (j || ((A || A === 0) && (D || D === 0) && !ym.test(w) && P in h))
						((F = (v + "").substr((D + "").length)),
							A || (A = 0),
							(G = wn(w) || (P in Sr.units ? Sr.units[P] : F)),
							F !== G && (D = Gs(e, P, v, G)),
							(this._pt = new ur(
								this._pt,
								j ? Q : h,
								P,
								D,
								(B ? ia(D, B + A) : A) - D,
								!j && (G === "px" || P === "zIndex") && n.autoRound !== !1
									? wm
									: mc,
							)),
							(this._pt.u = G || 0),
							F !== G && G !== "%" && ((this._pt.b = v), (this._pt.r = xm)));
					else if (P in h) Om.call(this, e, P, v, B ? B + w : w);
					else if (P in e) this.add(e, P, v || e[P], B ? B + w : w, s, u);
					else if (P !== "parseTransform") {
						Bc(P, w);
						continue;
					}
					(j || (P in h ? ct.push(P, 0, h[P]) : ct.push(P, 1, v || e[P])),
						l.push(P));
				}
			}
		g && sd(this);
	},
	render: function (e, n) {
		if (n.tween._time || !Uc())
			for (var r = n._pt; r; ) (r.r(e, r.d), (r = r._next));
		else n.styles.revert();
	},
	get: Ss,
	aliases: ss,
	getSetter: function (e, n, r) {
		var s = ss[n];
		return (
			s && s.indexOf(",") < 0 && (n = s),
			n in Ls && n !== lr && (e._gsap.x || Ss(e, "x"))
				? r && Th === r
					? n === "scale"
						? Cm
						: Em
					: (Th = r || {}) && (n === "scale" ? Pm : Lm)
				: e.style && !Oc(e.style[n])
					? Sm
					: ~n.indexOf("-")
						? Tm
						: Wc(e, n)
		);
	},
	core: { _removeProperty: Lo, _getMatrix: Vc },
};
cr.utils.checkPrefix = da;
cr.core.getStyleSaver = cd;
(function (p, e, n, r) {
	var s = ar(p + "," + e + "," + n, function (u) {
		Ls[u] = 1;
	});
	(ar(e, function (u) {
		((Sr.units[u] = "deg"), (pd[u] = 1));
	}),
		(ss[s[13]] = p + "," + e),
		ar(r, function (u) {
			var l = u.split(":");
			ss[l[1]] = s[l[0]];
		}));
})(
	"x,y,z,scale,scaleX,scaleY,xPercent,yPercent",
	"rotation,rotationX,rotationY,skewX,skewY",
	"transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
	"0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",
);
ar(
	"x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",
	function (p) {
		Sr.units[p] = "px";
	},
);
cr.registerPlugin(_d);
var es = cr.registerPlugin(_d) || cr;
es.core.Tween;
function Oh(p, e) {
	for (var n = 0; n < e.length; n++) {
		var r = e[n];
		((r.enumerable = r.enumerable || !1),
			(r.configurable = !0),
			"value" in r && (r.writable = !0),
			Object.defineProperty(p, r.key, r));
	}
}
function Fm(p, e, n) {
	return (e && Oh(p.prototype, e), n && Oh(p, n), p);
}
/*!
 * Observer 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */ var dn,
	zu,
	xr,
	Ws,
	Zs,
	sa,
	vd,
	go,
	Ha,
	yd,
	Es,
	$r,
	bd,
	xd = function () {
		return (
			dn ||
			(typeof window < "u" && (dn = window.gsap) && dn.registerPlugin && dn)
		);
	},
	wd = 1,
	ea = [],
	Ce = [],
	us = [],
	qa = Date.now,
	yc = function (e, n) {
		return n;
	},
	Hm = function () {
		var e = Ha.core,
			n = e.bridge || {},
			r = e._scrollers,
			s = e._proxies;
		(r.push.apply(r, Ce),
			s.push.apply(s, us),
			(Ce = r),
			(us = s),
			(yc = function (l, h) {
				return n[l](h);
			}));
	},
	$s = function (e, n) {
		return ~us.indexOf(e) && us[us.indexOf(e) + 1][n];
	},
	Wa = function (e) {
		return !!~yd.indexOf(e);
	},
	Hn = function (e, n, r, s, u) {
		return e.addEventListener(n, r, { passive: s !== !1, capture: !!u });
	},
	Fn = function (e, n, r, s) {
		return e.removeEventListener(n, r, !!s);
	},
	bu = "scrollLeft",
	xu = "scrollTop",
	bc = function () {
		return (Es && Es.isPressed) || Ce.cache++;
	},
	Xu = function (e, n) {
		var r = function s(u) {
			if (u || u === 0) {
				wd && (xr.history.scrollRestoration = "manual");
				var l = Es && Es.isPressed;
				((u = s.v = Math.round(u) || (Es && Es.iOS ? 1 : 0)),
					e(u),
					(s.cacheID = Ce.cache),
					l && yc("ss", u));
			} else
				(n || Ce.cache !== s.cacheID || yc("ref")) &&
					((s.cacheID = Ce.cache), (s.v = e()));
			return s.v + s.offset;
		};
		return ((r.offset = 0), e && r);
	},
	Un = {
		s: bu,
		p: "left",
		p2: "Left",
		os: "right",
		os2: "Right",
		d: "width",
		d2: "Width",
		a: "x",
		sc: Xu(function (p) {
			return arguments.length
				? xr.scrollTo(p, Ki.sc())
				: xr.pageXOffset || Ws[bu] || Zs[bu] || sa[bu] || 0;
		}),
	},
	Ki = {
		s: xu,
		p: "top",
		p2: "Top",
		os: "bottom",
		os2: "Bottom",
		d: "height",
		d2: "Height",
		a: "y",
		op: Un,
		sc: Xu(function (p) {
			return arguments.length
				? xr.scrollTo(Un.sc(), p)
				: xr.pageYOffset || Ws[xu] || Zs[xu] || sa[xu] || 0;
		}),
	},
	sr = function (e, n) {
		return (
			((n && n._ctx && n._ctx.selector) || dn.utils.toArray)(e)[0] ||
			(typeof e == "string" && dn.config().nullTargetWarn !== !1
				? console.warn("Element not found:", e)
				: null)
		);
	},
	Xs = function (e, n) {
		var r = n.s,
			s = n.sc;
		Wa(e) && (e = Ws.scrollingElement || Zs);
		var u = Ce.indexOf(e),
			l = s === Ki.sc ? 1 : 2;
		(!~u && (u = Ce.push(e) - 1), Ce[u + l] || Hn(e, "scroll", bc));
		var h = Ce[u + l],
			f =
				h ||
				(Ce[u + l] =
					Xu($s(e, r), !0) ||
					(Wa(e)
						? s
						: Xu(function (v) {
								return arguments.length ? (e[r] = v) : e[r];
							})));
		return (
			(f.target = e),
			h || (f.smooth = dn.getProperty(e, "scrollBehavior") === "smooth"),
			f
		);
	},
	xc = function (e, n, r) {
		var s = e,
			u = e,
			l = qa(),
			h = l,
			f = n || 50,
			v = Math.max(500, f * 3),
			w = function (O, P) {
				var F = qa();
				P || F - l > f
					? ((u = s), (s = O), (h = l), (l = F))
					: r
						? (s += O)
						: (s = u + ((O - u) / (F - h)) * (l - h));
			},
			A = function () {
				((u = s = r ? 0 : s), (h = l = 0));
			},
			D = function (O) {
				var P = h,
					F = u,
					G = qa();
				return (
					(O || O === 0) && O !== s && w(O),
					l === h || G - h > v
						? 0
						: ((s + (r ? F : -F)) / ((r ? G : l) - P)) * 1e3
				);
			};
		return { update: w, reset: A, getVelocity: D };
	},
	La = function (e, n) {
		return (
			n && !e._gsapAllow && e.preventDefault(),
			e.changedTouches ? e.changedTouches[0] : e
		);
	},
	Dh = function (e) {
		var n = Math.max.apply(Math, e),
			r = Math.min.apply(Math, e);
		return Math.abs(n) >= Math.abs(r) ? n : r;
	},
	Sd = function () {
		((Ha = dn.core.globals().ScrollTrigger), Ha && Ha.core && Hm());
	},
	Td = function (e) {
		return (
			(dn = e || xd()),
			!zu &&
				dn &&
				typeof document < "u" &&
				document.body &&
				((xr = window),
				(Ws = document),
				(Zs = Ws.documentElement),
				(sa = Ws.body),
				(yd = [xr, Ws, Zs, sa]),
				dn.utils.clamp,
				(bd = dn.core.context || function () {}),
				(go = "onpointerenter" in sa ? "pointer" : "mouse"),
				(vd = Ri.isTouch =
					xr.matchMedia &&
					xr.matchMedia("(hover: none), (pointer: coarse)").matches
						? 1
						: "ontouchstart" in xr ||
							  navigator.maxTouchPoints > 0 ||
							  navigator.msMaxTouchPoints > 0
							? 2
							: 0),
				($r = Ri.eventTypes =
					(
						"ontouchstart" in Zs
							? "touchstart,touchmove,touchcancel,touchend"
							: "onpointerdown" in Zs
								? "pointerdown,pointermove,pointercancel,pointerup"
								: "mousedown,mousemove,mouseup,mouseup"
					).split(",")),
				setTimeout(function () {
					return (wd = 0);
				}, 500),
				Sd(),
				(zu = 1)),
			zu
		);
	};
Un.op = Ki;
Ce.cache = 0;
var Ri = (function () {
	function p(n) {
		this.init(n);
	}
	var e = p.prototype;
	return (
		(e.init = function (r) {
			(zu || Td(dn) || console.warn("Please gsap.registerPlugin(Observer)"),
				Ha || Sd());
			var s = r.tolerance,
				u = r.dragMinimum,
				l = r.type,
				h = r.target,
				f = r.lineHeight,
				v = r.debounce,
				w = r.preventDefault,
				A = r.onStop,
				D = r.onStopDelay,
				C = r.ignore,
				O = r.wheelSpeed,
				P = r.event,
				F = r.onDragStart,
				G = r.onDragEnd,
				B = r.onDrag,
				j = r.onPress,
				V = r.onRelease,
				Q = r.onRight,
				it = r.onLeft,
				g = r.onUp,
				ct = r.onDown,
				ot = r.onChangeX,
				ft = r.onChangeY,
				Dt = r.onChange,
				pt = r.onToggleX,
				Et = r.onToggleY,
				K = r.onHover,
				Nt = r.onHoverEnd,
				St = r.onMove,
				Ct = r.ignoreCheck,
				_t = r.isNormalizer,
				de = r.onGestureStart,
				W = r.onGestureEnd,
				Wt = r.onWheel,
				Zt = r.onEnable,
				oe = r.onDisable,
				jt = r.onClick,
				Vt = r.scrollSpeed,
				U = r.capture,
				xe = r.allowClicks,
				qe = r.lockAxis,
				Ze = r.onLockAxis;
			((this.target = h = sr(h) || Zs),
				(this.vars = r),
				C && (C = dn.utils.toArray(C)),
				(s = s || 1e-9),
				(u = u || 0),
				(O = O || 1),
				(Vt = Vt || 1),
				(l = l || "wheel,touch,pointer"),
				(v = v !== !1),
				f || (f = parseFloat(xr.getComputedStyle(sa).lineHeight) || 22));
			var je,
				Ge,
				Ue,
				ne,
				We,
				He,
				di,
				st = this,
				ze = 0,
				Ji = 0,
				pi = r.passive || !w,
				Ie = Xs(h, Un),
				$e = Xs(h, Ki),
				re = Ie(),
				Di = $e(),
				gt =
					~l.indexOf("touch") &&
					!~l.indexOf("pointer") &&
					$r[0] === "pointerdown",
				Lt = Wa(h),
				Ft = h.ownerDocument || Ws,
				vt = [0, 0, 0],
				Kt = [0, 0, 0],
				Ne = 0,
				bt = function () {
					return (Ne = qa());
				},
				se = function (qt, we) {
					return (
						((st.event = qt) && C && ~C.indexOf(qt.target)) ||
						(we && gt && qt.pointerType !== "touch") ||
						(Ct && Ct(qt, we))
					);
				},
				ke = function () {
					(st._vx.reset(), st._vy.reset(), Ge.pause(), A && A(st));
				},
				ie = function () {
					var qt = (st.deltaX = Dh(vt)),
						we = (st.deltaY = Dh(Kt)),
						yt = Math.abs(qt) >= s,
						Ut = Math.abs(we) >= s;
					(Dt && (yt || Ut) && Dt(st, qt, we, vt, Kt),
						yt &&
							(Q && st.deltaX > 0 && Q(st),
							it && st.deltaX < 0 && it(st),
							ot && ot(st),
							pt && st.deltaX < 0 != ze < 0 && pt(st),
							(ze = st.deltaX),
							(vt[0] = vt[1] = vt[2] = 0)),
						Ut &&
							(ct && st.deltaY > 0 && ct(st),
							g && st.deltaY < 0 && g(st),
							ft && ft(st),
							Et && st.deltaY < 0 != Ji < 0 && Et(st),
							(Ji = st.deltaY),
							(Kt[0] = Kt[1] = Kt[2] = 0)),
						(ne || Ue) && (St && St(st), Ue && (B(st), (Ue = !1)), (ne = !1)),
						He && !(He = !1) && Ze && Ze(st),
						We && (Wt(st), (We = !1)),
						(je = 0));
				},
				Jt = function (qt, we, yt) {
					((vt[yt] += qt),
						(Kt[yt] += we),
						st._vx.update(qt),
						st._vy.update(we),
						v ? je || (je = requestAnimationFrame(ie)) : ie());
				},
				vi = function (qt, we) {
					(qe &&
						!di &&
						((st.axis = di = Math.abs(qt) > Math.abs(we) ? "x" : "y"),
						(He = !0)),
						di !== "y" && ((vt[2] += qt), st._vx.update(qt, !0)),
						di !== "x" && ((Kt[2] += we), st._vy.update(we, !0)),
						v ? je || (je = requestAnimationFrame(ie)) : ie());
				},
				Ii = function (qt) {
					if (!se(qt, 1)) {
						qt = La(qt, w);
						var we = qt.clientX,
							yt = qt.clientY,
							Ut = we - st.x,
							Rt = yt - st.y,
							zt = st.isDragging;
						((st.x = we),
							(st.y = yt),
							(zt ||
								Math.abs(st.startX - we) >= u ||
								Math.abs(st.startY - yt) >= u) &&
								(B && (Ue = !0),
								zt || (st.isDragging = !0),
								vi(Ut, Rt),
								zt || (F && F(st))));
					}
				},
				En = (st.onPress = function (te) {
					se(te, 1) ||
						(te && te.button) ||
						((st.axis = di = null),
						Ge.pause(),
						(st.isPressed = !0),
						(te = La(te)),
						(ze = Ji = 0),
						(st.startX = st.x = te.clientX),
						(st.startY = st.y = te.clientY),
						st._vx.reset(),
						st._vy.reset(),
						Hn(_t ? h : Ft, $r[1], Ii, pi, !0),
						(st.deltaX = st.deltaY = 0),
						j && j(st));
				}),
				Qt = (st.onRelease = function (te) {
					if (!se(te, 1)) {
						Fn(_t ? h : Ft, $r[1], Ii, !0);
						var qt = !isNaN(st.y - st.startY),
							we = st.isDragging,
							yt =
								we &&
								(Math.abs(st.x - st.startX) > 3 ||
									Math.abs(st.y - st.startY) > 3),
							Ut = La(te);
						(!yt &&
							qt &&
							(st._vx.reset(),
							st._vy.reset(),
							w &&
								xe &&
								dn.delayedCall(0.08, function () {
									if (qa() - Ne > 300 && !te.defaultPrevented) {
										if (te.target.click) te.target.click();
										else if (Ft.createEvent) {
											var Rt = Ft.createEvent("MouseEvents");
											(Rt.initMouseEvent(
												"click",
												!0,
												!0,
												xr,
												1,
												Ut.screenX,
												Ut.screenY,
												Ut.clientX,
												Ut.clientY,
												!1,
												!1,
												!1,
												!1,
												0,
												null,
											),
												te.target.dispatchEvent(Rt));
										}
									}
								})),
							(st.isDragging = st.isGesturing = st.isPressed = !1),
							A && we && !_t && Ge.restart(!0),
							G && we && G(st),
							V && V(st, yt));
					}
				}),
				Vn = function (qt) {
					return (
						qt.touches &&
						qt.touches.length > 1 &&
						(st.isGesturing = !0) &&
						de(qt, st.isDragging)
					);
				},
				ii = function () {
					return (st.isGesturing = !1) || W(st);
				},
				Pi = function (qt) {
					if (!se(qt)) {
						var we = Ie(),
							yt = $e();
						(Jt((we - re) * Vt, (yt - Di) * Vt, 1),
							(re = we),
							(Di = yt),
							A && Ge.restart(!0));
					}
				},
				Ui = function (qt) {
					if (!se(qt)) {
						((qt = La(qt, w)), Wt && (We = !0));
						var we =
							(qt.deltaMode === 1
								? f
								: qt.deltaMode === 2
									? xr.innerHeight
									: 1) * O;
						(Jt(qt.deltaX * we, qt.deltaY * we, 0), A && !_t && Ge.restart(!0));
					}
				},
				Cn = function (qt) {
					if (!se(qt)) {
						var we = qt.clientX,
							yt = qt.clientY,
							Ut = we - st.x,
							Rt = yt - st.y;
						((st.x = we),
							(st.y = yt),
							(ne = !0),
							A && Ge.restart(!0),
							(Ut || Rt) && vi(Ut, Rt));
					}
				},
				yi = function (qt) {
					((st.event = qt), K(st));
				},
				Xe = function (qt) {
					((st.event = qt), Nt(st));
				},
				Gn = function (qt) {
					return se(qt) || (La(qt, w) && jt(st));
				};
			((Ge = st._dc = dn.delayedCall(D || 0.25, ke).pause()),
				(st.deltaX = st.deltaY = 0),
				(st._vx = xc(0, 50, !0)),
				(st._vy = xc(0, 50, !0)),
				(st.scrollX = Ie),
				(st.scrollY = $e),
				(st.isDragging = st.isGesturing = st.isPressed = !1),
				bd(this),
				(st.enable = function (te) {
					return (
						st.isEnabled ||
							(Hn(Lt ? Ft : h, "scroll", bc),
							l.indexOf("scroll") >= 0 && Hn(Lt ? Ft : h, "scroll", Pi, pi, U),
							l.indexOf("wheel") >= 0 && Hn(h, "wheel", Ui, pi, U),
							((l.indexOf("touch") >= 0 && vd) || l.indexOf("pointer") >= 0) &&
								(Hn(h, $r[0], En, pi, U),
								Hn(Ft, $r[2], Qt),
								Hn(Ft, $r[3], Qt),
								xe && Hn(h, "click", bt, !0, !0),
								jt && Hn(h, "click", Gn),
								de && Hn(Ft, "gesturestart", Vn),
								W && Hn(Ft, "gestureend", ii),
								K && Hn(h, go + "enter", yi),
								Nt && Hn(h, go + "leave", Xe),
								St && Hn(h, go + "move", Cn)),
							(st.isEnabled = !0),
							te && te.type && En(te),
							Zt && Zt(st)),
						st
					);
				}),
				(st.disable = function () {
					st.isEnabled &&
						(ea.filter(function (te) {
							return te !== st && Wa(te.target);
						}).length || Fn(Lt ? Ft : h, "scroll", bc),
						st.isPressed &&
							(st._vx.reset(), st._vy.reset(), Fn(_t ? h : Ft, $r[1], Ii, !0)),
						Fn(Lt ? Ft : h, "scroll", Pi, U),
						Fn(h, "wheel", Ui, U),
						Fn(h, $r[0], En, U),
						Fn(Ft, $r[2], Qt),
						Fn(Ft, $r[3], Qt),
						Fn(h, "click", bt, !0),
						Fn(h, "click", Gn),
						Fn(Ft, "gesturestart", Vn),
						Fn(Ft, "gestureend", ii),
						Fn(h, go + "enter", yi),
						Fn(h, go + "leave", Xe),
						Fn(h, go + "move", Cn),
						(st.isEnabled = st.isPressed = st.isDragging = !1),
						oe && oe(st));
				}),
				(st.kill = st.revert =
					function () {
						st.disable();
						var te = ea.indexOf(st);
						(te >= 0 && ea.splice(te, 1), Es === st && (Es = 0));
					}),
				ea.push(st),
				_t && Wa(h) && (Es = st),
				st.enable(P));
		}),
		Fm(p, [
			{
				key: "velocityX",
				get: function () {
					return this._vx.getVelocity();
				},
			},
			{
				key: "velocityY",
				get: function () {
					return this._vy.getVelocity();
				},
			},
		]),
		p
	);
})();
Ri.version = "3.12.5";
Ri.create = function (p) {
	return new Ri(p);
};
Ri.register = Td;
Ri.getAll = function () {
	return ea.slice();
};
Ri.getById = function (p) {
	return ea.filter(function (e) {
		return e.vars.id === p;
	})[0];
};
xd() && dn.registerPlugin(Ri);
/*!
 * ScrollTrigger 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */ var Bt,
	Ko,
	Oe,
	Ti,
	Vr,
	fi,
	Ed,
	Yu,
	nu,
	Za,
	Oa,
	wu,
	bn,
	rl,
	wc,
	Wn,
	Ih,
	Bh,
	Jo,
	Cd,
	Ol,
	Pd,
	qn,
	Sc,
	Ld,
	kd,
	Ns,
	Tc,
	Gc,
	oa,
	Xc,
	Ku,
	Ec,
	Dl,
	Su = 1,
	xn = Date.now,
	Il = xn(),
	Nr = 0,
	Da = 0,
	zh = function (e, n, r) {
		var s = vr(e) && (e.substr(0, 6) === "clamp(" || e.indexOf("max") > -1);
		return ((r["_" + n + "Clamp"] = s), s ? e.substr(6, e.length - 7) : e);
	},
	Nh = function (e, n) {
		return n && (!vr(e) || e.substr(0, 6) !== "clamp(")
			? "clamp(" + e + ")"
			: e;
	},
	qm = function p() {
		return Da && requestAnimationFrame(p);
	},
	Rh = function () {
		return (rl = 1);
	},
	Fh = function () {
		return (rl = 0);
	},
	ns = function (e) {
		return e;
	},
	Ia = function (e) {
		return Math.round(e * 1e5) / 1e5 || 0;
	},
	Ad = function () {
		return typeof window < "u";
	},
	Md = function () {
		return Bt || (Ad() && (Bt = window.gsap) && Bt.registerPlugin && Bt);
	},
	ko = function (e) {
		return !!~Ed.indexOf(e);
	},
	Od = function (e) {
		return (
			(e === "Height" ? Xc : Oe["inner" + e]) ||
			Vr["client" + e] ||
			fi["client" + e]
		);
	},
	Dd = function (e) {
		return (
			$s(e, "getBoundingClientRect") ||
			(ko(e)
				? function () {
						return ((qu.width = Oe.innerWidth), (qu.height = Xc), qu);
					}
				: function () {
						return Ts(e);
					})
		);
	},
	Wm = function (e, n, r) {
		var s = r.d,
			u = r.d2,
			l = r.a;
		return (l = $s(e, "getBoundingClientRect"))
			? function () {
					return l()[s];
				}
			: function () {
					return (n ? Od(u) : e["client" + u]) || 0;
				};
	},
	Zm = function (e, n) {
		return !n || ~us.indexOf(e)
			? Dd(e)
			: function () {
					return qu;
				};
	},
	os = function (e, n) {
		var r = n.s,
			s = n.d2,
			u = n.d,
			l = n.a;
		return Math.max(
			0,
			(r = "scroll" + s) && (l = $s(e, r))
				? l() - Dd(e)()[u]
				: ko(e)
					? (Vr[r] || fi[r]) - Od(s)
					: e[r] - e["offset" + s],
		);
	},
	Tu = function (e, n) {
		for (var r = 0; r < Jo.length; r += 3)
			(!n || ~n.indexOf(Jo[r + 1])) && e(Jo[r], Jo[r + 1], Jo[r + 2]);
	},
	vr = function (e) {
		return typeof e == "string";
	},
	$n = function (e) {
		return typeof e == "function";
	},
	Ba = function (e) {
		return typeof e == "number";
	},
	_o = function (e) {
		return typeof e == "object";
	},
	ka = function (e, n, r) {
		return e && e.progress(n ? 0 : 1) && r && e.pause();
	},
	Bl = function (e, n) {
		if (e.enabled) {
			var r = e._ctx
				? e._ctx.add(function () {
						return n(e);
					})
				: n(e);
			r && r.totalTime && (e.callbackAnimation = r);
		}
	},
	Xo = Math.abs,
	Id = "left",
	Bd = "top",
	Yc = "right",
	Kc = "bottom",
	To = "width",
	Eo = "height",
	ja = "Right",
	Ua = "Left",
	$a = "Top",
	Va = "Bottom",
	Zi = "padding",
	Dr = "margin",
	pa = "Width",
	Jc = "Height",
	Yi = "px",
	Ir = function (e) {
		return Oe.getComputedStyle(e);
	},
	jm = function (e) {
		var n = Ir(e).position;
		e.style.position = n === "absolute" || n === "fixed" ? n : "relative";
	},
	Hh = function (e, n) {
		for (var r in n) r in e || (e[r] = n[r]);
		return e;
	},
	Ts = function (e, n) {
		var r =
				n &&
				Ir(e)[wc] !== "matrix(1, 0, 0, 1, 0, 0)" &&
				Bt.to(e, {
					x: 0,
					y: 0,
					xPercent: 0,
					yPercent: 0,
					rotation: 0,
					rotationX: 0,
					rotationY: 0,
					scale: 1,
					skewX: 0,
					skewY: 0,
				}).progress(1),
			s = e.getBoundingClientRect();
		return (r && r.progress(0).kill(), s);
	},
	Ju = function (e, n) {
		var r = n.d2;
		return e["offset" + r] || e["client" + r] || 0;
	},
	zd = function (e) {
		var n = [],
			r = e.labels,
			s = e.duration(),
			u;
		for (u in r) n.push(r[u] / s);
		return n;
	},
	Um = function (e) {
		return function (n) {
			return Bt.utils.snap(zd(e), n);
		};
	},
	Qc = function (e) {
		var n = Bt.utils.snap(e),
			r =
				Array.isArray(e) &&
				e.slice(0).sort(function (s, u) {
					return s - u;
				});
		return r
			? function (s, u, l) {
					l === void 0 && (l = 0.001);
					var h;
					if (!u) return n(s);
					if (u > 0) {
						for (s -= l, h = 0; h < r.length; h++) if (r[h] >= s) return r[h];
						return r[h - 1];
					} else for (h = r.length, s += l; h--; ) if (r[h] <= s) return r[h];
					return r[0];
				}
			: function (s, u, l) {
					l === void 0 && (l = 0.001);
					var h = n(s);
					return !u || Math.abs(h - s) < l || h - s < 0 == u < 0
						? h
						: n(u < 0 ? s - e : s + e);
				};
	},
	$m = function (e) {
		return function (n, r) {
			return Qc(zd(e))(n, r.direction);
		};
	},
	Eu = function (e, n, r, s) {
		return r.split(",").forEach(function (u) {
			return e(n, u, s);
		});
	},
	nn = function (e, n, r, s, u) {
		return e.addEventListener(n, r, { passive: !s, capture: !!u });
	},
	en = function (e, n, r, s) {
		return e.removeEventListener(n, r, !!s);
	},
	Cu = function (e, n, r) {
		((r = r && r.wheelHandler), r && (e(n, "wheel", r), e(n, "touchmove", r)));
	},
	qh = {
		startColor: "green",
		endColor: "red",
		indent: 0,
		fontSize: "16px",
		fontWeight: "normal",
	},
	Pu = { toggleActions: "play", anticipatePin: 0 },
	Qu = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
	Nu = function (e, n) {
		if (vr(e)) {
			var r = e.indexOf("="),
				s = ~r ? +(e.charAt(r - 1) + 1) * parseFloat(e.substr(r + 1)) : 0;
			(~r && (e.indexOf("%") > r && (s *= n / 100), (e = e.substr(0, r - 1))),
				(e =
					s +
					(e in Qu
						? Qu[e] * n
						: ~e.indexOf("%")
							? (parseFloat(e) * n) / 100
							: parseFloat(e) || 0)));
		}
		return e;
	},
	Lu = function (e, n, r, s, u, l, h, f) {
		var v = u.startColor,
			w = u.endColor,
			A = u.fontSize,
			D = u.indent,
			C = u.fontWeight,
			O = Ti.createElement("div"),
			P = ko(r) || $s(r, "pinType") === "fixed",
			F = e.indexOf("scroller") !== -1,
			G = P ? fi : r,
			B = e.indexOf("start") !== -1,
			j = B ? v : w,
			V =
				"border-color:" +
				j +
				";font-size:" +
				A +
				";color:" +
				j +
				";font-weight:" +
				C +
				";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
		return (
			(V += "position:" + ((F || f) && P ? "fixed;" : "absolute;")),
			(F || f || !P) &&
				(V += (s === Ki ? Yc : Kc) + ":" + (l + parseFloat(D)) + "px;"),
			h &&
				(V +=
					"box-sizing:border-box;text-align:left;width:" +
					h.offsetWidth +
					"px;"),
			(O._isStart = B),
			O.setAttribute("class", "gsap-marker-" + e + (n ? " marker-" + n : "")),
			(O.style.cssText = V),
			(O.innerText = n || n === 0 ? e + "-" + n : e),
			G.children[0] ? G.insertBefore(O, G.children[0]) : G.appendChild(O),
			(O._offset = O["offset" + s.op.d2]),
			Ru(O, 0, s, B),
			O
		);
	},
	Ru = function (e, n, r, s) {
		var u = { display: "block" },
			l = r[s ? "os2" : "p2"],
			h = r[s ? "p2" : "os2"];
		((e._isFlipped = s),
			(u[r.a + "Percent"] = s ? -100 : 0),
			(u[r.a] = s ? "1px" : 0),
			(u["border" + l + pa] = 1),
			(u["border" + h + pa] = 0),
			(u[r.p] = n + "px"),
			Bt.set(e, u));
	},
	Te = [],
	Cc = {},
	ru,
	Wh = function () {
		return xn() - Nr > 34 && (ru || (ru = requestAnimationFrame(Cs)));
	},
	Yo = function () {
		(!qn || !qn.isPressed || qn.startX > fi.clientWidth) &&
			(Ce.cache++,
			qn ? ru || (ru = requestAnimationFrame(Cs)) : Cs(),
			Nr || Mo("scrollStart"),
			(Nr = xn()));
	},
	zl = function () {
		((kd = Oe.innerWidth), (Ld = Oe.innerHeight));
	},
	za = function () {
		(Ce.cache++,
			!bn &&
				!Pd &&
				!Ti.fullscreenElement &&
				!Ti.webkitFullscreenElement &&
				(!Sc ||
					kd !== Oe.innerWidth ||
					Math.abs(Oe.innerHeight - Ld) > Oe.innerHeight * 0.25) &&
				Yu.restart(!0));
	},
	Ao = {},
	Vm = [],
	Nd = function p() {
		return en(Pe, "scrollEnd", p) || yo(!0);
	},
	Mo = function (e) {
		return (
			(Ao[e] &&
				Ao[e].map(function (n) {
					return n();
				})) ||
			Vm
		);
	},
	_r = [],
	Rd = function (e) {
		for (var n = 0; n < _r.length; n += 5)
			(!e || (_r[n + 4] && _r[n + 4].query === e)) &&
				((_r[n].style.cssText = _r[n + 1]),
				_r[n].getBBox && _r[n].setAttribute("transform", _r[n + 2] || ""),
				(_r[n + 3].uncache = 1));
	},
	th = function (e, n) {
		var r;
		for (Wn = 0; Wn < Te.length; Wn++)
			((r = Te[Wn]),
				r && (!n || r._ctx === n) && (e ? r.kill(1) : r.revert(!0, !0)));
		((Ku = !0), n && Rd(n), n || Mo("revert"));
	},
	Fd = function (e, n) {
		(Ce.cache++,
			(n || !Zn) &&
				Ce.forEach(function (r) {
					return $n(r) && r.cacheID++ && (r.rec = 0);
				}),
			vr(e) && (Oe.history.scrollRestoration = Gc = e));
	},
	Zn,
	Co = 0,
	Zh,
	Gm = function () {
		if (Zh !== Co) {
			var e = (Zh = Co);
			requestAnimationFrame(function () {
				return e === Co && yo(!0);
			});
		}
	},
	Hd = function () {
		(fi.appendChild(oa),
			(Xc = (!qn && oa.offsetHeight) || Oe.innerHeight),
			fi.removeChild(oa));
	},
	jh = function (e) {
		return nu(
			".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end",
		).forEach(function (n) {
			return (n.style.display = e ? "none" : "block");
		});
	},
	yo = function (e, n) {
		if (Nr && !e && !Ku) {
			nn(Pe, "scrollEnd", Nd);
			return;
		}
		(Hd(),
			(Zn = Pe.isRefreshing = !0),
			Ce.forEach(function (s) {
				return $n(s) && ++s.cacheID && (s.rec = s());
			}));
		var r = Mo("refreshInit");
		(Cd && Pe.sort(),
			n || th(),
			Ce.forEach(function (s) {
				$n(s) && (s.smooth && (s.target.style.scrollBehavior = "auto"), s(0));
			}),
			Te.slice(0).forEach(function (s) {
				return s.refresh();
			}),
			(Ku = !1),
			Te.forEach(function (s) {
				if (s._subPinOffset && s.pin) {
					var u = s.vars.horizontal ? "offsetWidth" : "offsetHeight",
						l = s.pin[u];
					(s.revert(!0, 1), s.adjustPinSpacing(s.pin[u] - l), s.refresh());
				}
			}),
			(Ec = 1),
			jh(!0),
			Te.forEach(function (s) {
				var u = os(s.scroller, s._dir),
					l = s.vars.end === "max" || (s._endClamp && s.end > u),
					h = s._startClamp && s.start >= u;
				(l || h) &&
					s.setPositions(
						h ? u - 1 : s.start,
						l ? Math.max(h ? u : s.start + 1, u) : s.end,
						!0,
					);
			}),
			jh(!1),
			(Ec = 0),
			r.forEach(function (s) {
				return s && s.render && s.render(-1);
			}),
			Ce.forEach(function (s) {
				$n(s) &&
					(s.smooth &&
						requestAnimationFrame(function () {
							return (s.target.style.scrollBehavior = "smooth");
						}),
					s.rec && s(s.rec));
			}),
			Fd(Gc, 1),
			Yu.pause(),
			Co++,
			(Zn = 2),
			Cs(2),
			Te.forEach(function (s) {
				return $n(s.vars.onRefresh) && s.vars.onRefresh(s);
			}),
			(Zn = Pe.isRefreshing = !1),
			Mo("refresh"));
	},
	Pc = 0,
	Fu = 1,
	Ga,
	Cs = function (e) {
		if (e === 2 || (!Zn && !Ku)) {
			((Pe.isUpdating = !0), Ga && Ga.update(0));
			var n = Te.length,
				r = xn(),
				s = r - Il >= 50,
				u = n && Te[0].scroll();
			if (
				((Fu = Pc > u ? -1 : 1),
				Zn || (Pc = u),
				s &&
					(Nr && !rl && r - Nr > 200 && ((Nr = 0), Mo("scrollEnd")),
					(Oa = Il),
					(Il = r)),
				Fu < 0)
			) {
				for (Wn = n; Wn-- > 0; ) Te[Wn] && Te[Wn].update(0, s);
				Fu = 1;
			} else for (Wn = 0; Wn < n; Wn++) Te[Wn] && Te[Wn].update(0, s);
			Pe.isUpdating = !1;
		}
		ru = 0;
	},
	Lc = [
		Id,
		Bd,
		Kc,
		Yc,
		Dr + Va,
		Dr + ja,
		Dr + $a,
		Dr + Ua,
		"display",
		"flexShrink",
		"float",
		"zIndex",
		"gridColumnStart",
		"gridColumnEnd",
		"gridRowStart",
		"gridRowEnd",
		"gridArea",
		"justifySelf",
		"alignSelf",
		"placeSelf",
		"order",
	],
	Hu = Lc.concat([
		To,
		Eo,
		"boxSizing",
		"max" + pa,
		"max" + Jc,
		"position",
		Dr,
		Zi,
		Zi + $a,
		Zi + ja,
		Zi + Va,
		Zi + Ua,
	]),
	Xm = function (e, n, r) {
		aa(r);
		var s = e._gsap;
		if (s.spacerIsNative) aa(s.spacerState);
		else if (e._gsap.swappedIn) {
			var u = n.parentNode;
			u && (u.insertBefore(e, n), u.removeChild(n));
		}
		e._gsap.swappedIn = !1;
	},
	Nl = function (e, n, r, s) {
		if (!e._gsap.swappedIn) {
			for (var u = Lc.length, l = n.style, h = e.style, f; u--; )
				((f = Lc[u]), (l[f] = r[f]));
			((l.position = r.position === "absolute" ? "absolute" : "relative"),
				r.display === "inline" && (l.display = "inline-block"),
				(h[Kc] = h[Yc] = "auto"),
				(l.flexBasis = r.flexBasis || "auto"),
				(l.overflow = "visible"),
				(l.boxSizing = "border-box"),
				(l[To] = Ju(e, Un) + Yi),
				(l[Eo] = Ju(e, Ki) + Yi),
				(l[Zi] = h[Dr] = h[Bd] = h[Id] = "0"),
				aa(s),
				(h[To] = h["max" + pa] = r[To]),
				(h[Eo] = h["max" + Jc] = r[Eo]),
				(h[Zi] = r[Zi]),
				e.parentNode !== n &&
					(e.parentNode.insertBefore(n, e), n.appendChild(e)),
				(e._gsap.swappedIn = !0));
		}
	},
	Ym = /([A-Z])/g,
	aa = function (e) {
		if (e) {
			var n = e.t.style,
				r = e.length,
				s = 0,
				u,
				l;
			for ((e.t._gsap || Bt.core.getCache(e.t)).uncache = 1; s < r; s += 2)
				((l = e[s + 1]),
					(u = e[s]),
					l
						? (n[u] = l)
						: n[u] && n.removeProperty(u.replace(Ym, "-$1").toLowerCase()));
		}
	},
	ku = function (e) {
		for (var n = Hu.length, r = e.style, s = [], u = 0; u < n; u++)
			s.push(Hu[u], r[Hu[u]]);
		return ((s.t = e), s);
	},
	Km = function (e, n, r) {
		for (var s = [], u = e.length, l = r ? 8 : 0, h; l < u; l += 2)
			((h = e[l]), s.push(h, h in n ? n[h] : e[l + 1]));
		return ((s.t = e.t), s);
	},
	qu = { left: 0, top: 0 },
	Uh = function (e, n, r, s, u, l, h, f, v, w, A, D, C, O) {
		($n(e) && (e = e(f)),
			vr(e) &&
				e.substr(0, 3) === "max" &&
				(e = D + (e.charAt(4) === "=" ? Nu("0" + e.substr(3), r) : 0)));
		var P = C ? C.time() : 0,
			F,
			G,
			B;
		if ((C && C.seek(0), isNaN(e) || (e = +e), Ba(e)))
			(C &&
				(e = Bt.utils.mapRange(
					C.scrollTrigger.start,
					C.scrollTrigger.end,
					0,
					D,
					e,
				)),
				h && Ru(h, r, s, !0));
		else {
			$n(n) && (n = n(f));
			var j = (e || "0").split(" "),
				V,
				Q,
				it,
				g;
			((B = sr(n, f) || fi),
				(V = Ts(B) || {}),
				(!V || (!V.left && !V.top)) &&
					Ir(B).display === "none" &&
					((g = B.style.display),
					(B.style.display = "block"),
					(V = Ts(B)),
					g ? (B.style.display = g) : B.style.removeProperty("display")),
				(Q = Nu(j[0], V[s.d])),
				(it = Nu(j[1] || "0", r)),
				(e = V[s.p] - v[s.p] - w + Q + u - it),
				h && Ru(h, it, s, r - it < 20 || (h._isStart && it > 20)),
				(r -= r - it));
		}
		if ((O && ((f[O] = e || -0.001), e < 0 && (e = 0)), l)) {
			var ct = e + r,
				ot = l._isStart;
			((F = "scroll" + s.d2),
				Ru(
					l,
					ct,
					s,
					(ot && ct > 20) ||
						(!ot && (A ? Math.max(fi[F], Vr[F]) : l.parentNode[F]) <= ct + 1),
				),
				A &&
					((v = Ts(h)),
					A && (l.style[s.op.p] = v[s.op.p] - s.op.m - l._offset + Yi)));
		}
		return (
			C &&
				B &&
				((F = Ts(B)),
				C.seek(D),
				(G = Ts(B)),
				(C._caScrollDist = F[s.p] - G[s.p]),
				(e = (e / C._caScrollDist) * D)),
			C && C.seek(P),
			C ? e : Math.round(e)
		);
	},
	Jm = /(webkit|moz|length|cssText|inset)/i,
	$h = function (e, n, r, s) {
		if (e.parentNode !== n) {
			var u = e.style,
				l,
				h;
			if (n === fi) {
				((e._stOrig = u.cssText), (h = Ir(e)));
				for (l in h)
					!+l &&
						!Jm.test(l) &&
						h[l] &&
						typeof u[l] == "string" &&
						l !== "0" &&
						(u[l] = h[l]);
				((u.top = r), (u.left = s));
			} else u.cssText = e._stOrig;
			((Bt.core.getCache(e).uncache = 1), n.appendChild(e));
		}
	},
	qd = function (e, n, r) {
		var s = n,
			u = s;
		return function (l) {
			var h = Math.round(e());
			return (
				h !== s &&
					h !== u &&
					Math.abs(h - s) > 3 &&
					Math.abs(h - u) > 3 &&
					((l = h), r && r()),
				(u = s),
				(s = l),
				l
			);
		};
	},
	Au = function (e, n, r) {
		var s = {};
		((s[n.p] = "+=" + r), Bt.set(e, s));
	},
	Vh = function (e, n) {
		var r = Xs(e, n),
			s = "_scroll" + n.p2,
			u = function l(h, f, v, w, A) {
				var D = l.tween,
					C = f.onComplete,
					O = {};
				v = v || r();
				var P = qd(r, v, function () {
					(D.kill(), (l.tween = 0));
				});
				return (
					(A = (w && A) || 0),
					(w = w || h - v),
					D && D.kill(),
					(f[s] = h),
					(f.inherit = !1),
					(f.modifiers = O),
					(O[s] = function () {
						return P(v + w * D.ratio + A * D.ratio * D.ratio);
					}),
					(f.onUpdate = function () {
						(Ce.cache++, l.tween && Cs());
					}),
					(f.onComplete = function () {
						((l.tween = 0), C && C.call(D));
					}),
					(D = l.tween = Bt.to(e, f)),
					D
				);
			};
		return (
			(e[s] = r),
			(r.wheelHandler = function () {
				return u.tween && u.tween.kill() && (u.tween = 0);
			}),
			nn(e, "wheel", r.wheelHandler),
			Pe.isTouch && nn(e, "touchmove", r.wheelHandler),
			u
		);
	},
	Pe = (function () {
		function p(n, r) {
			(Ko ||
				p.register(Bt) ||
				console.warn("Please gsap.registerPlugin(ScrollTrigger)"),
				Tc(this),
				this.init(n, r));
		}
		var e = p.prototype;
		return (
			(e.init = function (r, s) {
				if (
					((this.progress = this.start = 0),
					this.vars && this.kill(!0, !0),
					!Da)
				) {
					this.update = this.refresh = this.kill = ns;
					return;
				}
				r = Hh(vr(r) || Ba(r) || r.nodeType ? { trigger: r } : r, Pu);
				var u = r,
					l = u.onUpdate,
					h = u.toggleClass,
					f = u.id,
					v = u.onToggle,
					w = u.onRefresh,
					A = u.scrub,
					D = u.trigger,
					C = u.pin,
					O = u.pinSpacing,
					P = u.invalidateOnRefresh,
					F = u.anticipatePin,
					G = u.onScrubComplete,
					B = u.onSnapComplete,
					j = u.once,
					V = u.snap,
					Q = u.pinReparent,
					it = u.pinSpacer,
					g = u.containerAnimation,
					ct = u.fastScrollEnd,
					ot = u.preventOverlaps,
					ft =
						r.horizontal || (r.containerAnimation && r.horizontal !== !1)
							? Un
							: Ki,
					Dt = !A && A !== 0,
					pt = sr(r.scroller || Oe),
					Et = Bt.core.getCache(pt),
					K = ko(pt),
					Nt =
						("pinType" in r
							? r.pinType
							: $s(pt, "pinType") || (K && "fixed")) === "fixed",
					St = [r.onEnter, r.onLeave, r.onEnterBack, r.onLeaveBack],
					Ct = Dt && r.toggleActions.split(" "),
					_t = "markers" in r ? r.markers : Pu.markers,
					de = K ? 0 : parseFloat(Ir(pt)["border" + ft.p2 + pa]) || 0,
					W = this,
					Wt =
						r.onRefreshInit &&
						function () {
							return r.onRefreshInit(W);
						},
					Zt = Wm(pt, K, ft),
					oe = Zm(pt, K),
					jt = 0,
					Vt = 0,
					U = 0,
					xe = Xs(pt, ft),
					qe,
					Ze,
					je,
					Ge,
					Ue,
					ne,
					We,
					He,
					di,
					st,
					ze,
					Ji,
					pi,
					Ie,
					$e,
					re,
					Di,
					gt,
					Lt,
					Ft,
					vt,
					Kt,
					Ne,
					bt,
					se,
					ke,
					ie,
					Jt,
					vi,
					Ii,
					En,
					Qt,
					Vn,
					ii,
					Pi,
					Ui,
					Cn,
					yi,
					Xe;
				if (
					((W._startClamp = W._endClamp = !1),
					(W._dir = ft),
					(F *= 45),
					(W.scroller = pt),
					(W.scroll = g ? g.time.bind(g) : xe),
					(Ge = xe()),
					(W.vars = r),
					(s = s || r.animation),
					"refreshPriority" in r &&
						((Cd = 1), r.refreshPriority === -9999 && (Ga = W)),
					(Et.tweenScroll = Et.tweenScroll || {
						top: Vh(pt, Ki),
						left: Vh(pt, Un),
					}),
					(W.tweenTo = qe = Et.tweenScroll[ft.p]),
					(W.scrubDuration = function (yt) {
						((Vn = Ba(yt) && yt),
							Vn
								? Qt
									? Qt.duration(yt)
									: (Qt = Bt.to(s, {
											ease: "expo",
											totalProgress: "+=0",
											inherit: !1,
											duration: Vn,
											paused: !0,
											onComplete: function () {
												return G && G(W);
											},
										}))
								: (Qt && Qt.progress(1).kill(), (Qt = 0)));
					}),
					s &&
						((s.vars.lazy = !1),
						(s._initted && !W.isReverted) ||
							(s.vars.immediateRender !== !1 &&
								r.immediateRender !== !1 &&
								s.duration() &&
								s.render(0, !0, !0)),
						(W.animation = s.pause()),
						(s.scrollTrigger = W),
						W.scrubDuration(A),
						(Ii = 0),
						f || (f = s.vars.id)),
					V &&
						((!_o(V) || V.push) && (V = { snapTo: V }),
						"scrollBehavior" in fi.style &&
							Bt.set(K ? [fi, Vr] : pt, { scrollBehavior: "auto" }),
						Ce.forEach(function (yt) {
							return (
								$n(yt) &&
								yt.target === (K ? Ti.scrollingElement || Vr : pt) &&
								(yt.smooth = !1)
							);
						}),
						(je = $n(V.snapTo)
							? V.snapTo
							: V.snapTo === "labels"
								? Um(s)
								: V.snapTo === "labelsDirectional"
									? $m(s)
									: V.directional !== !1
										? function (yt, Ut) {
												return Qc(V.snapTo)(
													yt,
													xn() - Vt < 500 ? 0 : Ut.direction,
												);
											}
										: Bt.utils.snap(V.snapTo)),
						(ii = V.duration || { min: 0.1, max: 2 }),
						(ii = _o(ii) ? Za(ii.min, ii.max) : Za(ii, ii)),
						(Pi = Bt.delayedCall(V.delay || Vn / 2 || 0.1, function () {
							var yt = xe(),
								Ut = xn() - Vt < 500,
								Rt = qe.tween;
							if (
								(Ut || Math.abs(W.getVelocity()) < 10) &&
								!Rt &&
								!rl &&
								jt !== yt
							) {
								var zt = (yt - ne) / Ie,
									xt = s && !Dt ? s.totalProgress() : zt,
									he = Ut ? 0 : ((xt - En) / (xn() - Oa)) * 1e3 || 0,
									Ye = Bt.utils.clamp(-zt, 1 - zt, (Xo(he / 2) * he) / 0.185),
									mi = zt + (V.inertia === !1 ? 0 : Ye),
									Ve,
									Re,
									Ae = V,
									Li = Ae.onStart,
									Le = Ae.onInterrupt,
									ki = Ae.onComplete;
								if (
									((Ve = je(mi, W)),
									Ba(Ve) || (Ve = mi),
									(Re = Math.round(ne + Ve * Ie)),
									yt <= We && yt >= ne && Re !== yt)
								) {
									if (Rt && !Rt._initted && Rt.data <= Xo(Re - yt)) return;
									(V.inertia === !1 && (Ye = Ve - zt),
										qe(
											Re,
											{
												duration: ii(
													Xo(
														(Math.max(Xo(mi - xt), Xo(Ve - xt)) * 0.185) /
															he /
															0.05 || 0,
													),
												),
												ease: V.ease || "power3",
												data: Xo(Re - yt),
												onInterrupt: function () {
													return Pi.restart(!0) && Le && Le(W);
												},
												onComplete: function () {
													(W.update(),
														(jt = xe()),
														s &&
															(Qt
																? Qt.resetTo(
																		"totalProgress",
																		Ve,
																		s._tTime / s._tDur,
																	)
																: s.progress(Ve)),
														(Ii = En =
															s && !Dt ? s.totalProgress() : W.progress),
														B && B(W),
														ki && ki(W));
												},
											},
											yt,
											Ye * Ie,
											Re - yt - Ye * Ie,
										),
										Li && Li(W, qe.tween));
								}
							} else W.isActive && jt !== yt && Pi.restart(!0);
						}).pause())),
					f && (Cc[f] = W),
					(D = W.trigger = sr(D || (C !== !0 && C))),
					(Xe = D && D._gsap && D._gsap.stRevert),
					Xe && (Xe = Xe(W)),
					(C = C === !0 ? D : sr(C)),
					vr(h) && (h = { targets: D, className: h }),
					C &&
						(O === !1 ||
							O === Dr ||
							(O =
								!O &&
								C.parentNode &&
								C.parentNode.style &&
								Ir(C.parentNode).display === "flex"
									? !1
									: Zi),
						(W.pin = C),
						(Ze = Bt.core.getCache(C)),
						Ze.spacer
							? ($e = Ze.pinState)
							: (it &&
									((it = sr(it)),
									it && !it.nodeType && (it = it.current || it.nativeElement),
									(Ze.spacerIsNative = !!it),
									it && (Ze.spacerState = ku(it))),
								(Ze.spacer = gt = it || Ti.createElement("div")),
								gt.classList.add("pin-spacer"),
								f && gt.classList.add("pin-spacer-" + f),
								(Ze.pinState = $e = ku(C))),
						r.force3D !== !1 && Bt.set(C, { force3D: !0 }),
						(W.spacer = gt = Ze.spacer),
						(vi = Ir(C)),
						(bt = vi[O + ft.os2]),
						(Ft = Bt.getProperty(C)),
						(vt = Bt.quickSetter(C, ft.a, Yi)),
						Nl(C, gt, vi),
						(Di = ku(C))),
					_t)
				) {
					((Ji = _o(_t) ? Hh(_t, qh) : qh),
						(st = Lu("scroller-start", f, pt, ft, Ji, 0)),
						(ze = Lu("scroller-end", f, pt, ft, Ji, 0, st)),
						(Lt = st["offset" + ft.op.d2]));
					var Gn = sr($s(pt, "content") || pt);
					((He = this.markerStart = Lu("start", f, Gn, ft, Ji, Lt, 0, g)),
						(di = this.markerEnd = Lu("end", f, Gn, ft, Ji, Lt, 0, g)),
						g && (yi = Bt.quickSetter([He, di], ft.a, Yi)),
						!Nt &&
							!(us.length && $s(pt, "fixedMarkers") === !0) &&
							(jm(K ? fi : pt),
							Bt.set([st, ze], { force3D: !0 }),
							(ke = Bt.quickSetter(st, ft.a, Yi)),
							(Jt = Bt.quickSetter(ze, ft.a, Yi))));
				}
				if (g) {
					var te = g.vars.onUpdate,
						qt = g.vars.onUpdateParams;
					g.eventCallback("onUpdate", function () {
						(W.update(0, 0, 1), te && te.apply(g, qt || []));
					});
				}
				if (
					((W.previous = function () {
						return Te[Te.indexOf(W) - 1];
					}),
					(W.next = function () {
						return Te[Te.indexOf(W) + 1];
					}),
					(W.revert = function (yt, Ut) {
						if (!Ut) return W.kill(!0);
						var Rt = yt !== !1 || !W.enabled,
							zt = bn;
						Rt !== W.isReverted &&
							(Rt &&
								((Ui = Math.max(xe(), W.scroll.rec || 0)),
								(U = W.progress),
								(Cn = s && s.progress())),
							He &&
								[He, di, st, ze].forEach(function (xt) {
									return (xt.style.display = Rt ? "none" : "block");
								}),
							Rt && ((bn = W), W.update(Rt)),
							C &&
								(!Q || !W.isActive) &&
								(Rt ? Xm(C, gt, $e) : Nl(C, gt, Ir(C), se)),
							Rt || W.update(Rt),
							(bn = zt),
							(W.isReverted = Rt));
					}),
					(W.refresh = function (yt, Ut, Rt, zt) {
						if (!((bn || !W.enabled) && !Ut)) {
							if (C && yt && Nr) {
								nn(p, "scrollEnd", Nd);
								return;
							}
							(!Zn && Wt && Wt(W),
								(bn = W),
								qe.tween && !Rt && (qe.tween.kill(), (qe.tween = 0)),
								Qt && Qt.pause(),
								P && s && s.revert({ kill: !1 }).invalidate(),
								W.isReverted || W.revert(!0, !0),
								(W._subPinOffset = !1));
							var xt = Zt(),
								he = oe(),
								Ye = g ? g.duration() : os(pt, ft),
								mi = Ie <= 0.01,
								Ve = 0,
								Re = zt || 0,
								Ae = _o(Rt) ? Rt.end : r.end,
								Li = r.endTrigger || D,
								Le = _o(Rt)
									? Rt.start
									: r.start || (r.start === 0 || !D ? 0 : C ? "0 0" : "0 100%"),
								ki = (W.pinnedContainer =
									r.pinnedContainer && sr(r.pinnedContainer, W)),
								$i = (D && Math.max(0, Te.indexOf(W))) || 0,
								Fe = $i,
								ni,
								gi,
								hr,
								on,
								bi,
								ri,
								Fi,
								Fr,
								cs,
								pn,
								Hi,
								Er,
								Xn;
							for (
								_t &&
								_o(Rt) &&
								((Er = Bt.getProperty(st, ft.p)),
								(Xn = Bt.getProperty(ze, ft.p)));
								Fe--;
							)
								((ri = Te[Fe]),
									ri.end || ri.refresh(0, 1) || (bn = W),
									(Fi = ri.pin),
									Fi &&
										(Fi === D || Fi === C || Fi === ki) &&
										!ri.isReverted &&
										(pn || (pn = []), pn.unshift(ri), ri.revert(!0, !0)),
									ri !== Te[Fe] && ($i--, Fe--));
							for (
								$n(Le) && (Le = Le(W)),
									Le = zh(Le, "start", W),
									ne =
										Uh(
											Le,
											D,
											xt,
											ft,
											xe(),
											He,
											st,
											W,
											he,
											de,
											Nt,
											Ye,
											g,
											W._startClamp && "_startClamp",
										) || (C ? -0.001 : 0),
									$n(Ae) && (Ae = Ae(W)),
									vr(Ae) &&
										!Ae.indexOf("+=") &&
										(~Ae.indexOf(" ")
											? (Ae = (vr(Le) ? Le.split(" ")[0] : "") + Ae)
											: ((Ve = Nu(Ae.substr(2), xt)),
												(Ae = vr(Le)
													? Le
													: (g
															? Bt.utils.mapRange(
																	0,
																	g.duration(),
																	g.scrollTrigger.start,
																	g.scrollTrigger.end,
																	ne,
																)
															: ne) + Ve),
												(Li = D))),
									Ae = zh(Ae, "end", W),
									We =
										Math.max(
											ne,
											Uh(
												Ae || (Li ? "100% 0" : Ye),
												Li,
												xt,
												ft,
												xe() + Ve,
												di,
												ze,
												W,
												he,
												de,
												Nt,
												Ye,
												g,
												W._endClamp && "_endClamp",
											),
										) || -0.001,
									Ve = 0,
									Fe = $i;
								Fe--;
							)
								((ri = Te[Fe]),
									(Fi = ri.pin),
									Fi &&
										ri.start - ri._pinPush <= ne &&
										!g &&
										ri.end > 0 &&
										((ni =
											ri.end -
											(W._startClamp ? Math.max(0, ri.start) : ri.start)),
										((Fi === D && ri.start - ri._pinPush < ne) || Fi === ki) &&
											isNaN(Le) &&
											(Ve += ni * (1 - ri.progress)),
										Fi === C && (Re += ni)));
							if (
								((ne += Ve),
								(We += Ve),
								W._startClamp && (W._startClamp += Ve),
								W._endClamp &&
									!Zn &&
									((W._endClamp = We || -0.001),
									(We = Math.min(We, os(pt, ft)))),
								(Ie = We - ne || ((ne -= 0.01) && 0.001)),
								mi &&
									(U = Bt.utils.clamp(0, 1, Bt.utils.normalize(ne, We, Ui))),
								(W._pinPush = Re),
								He &&
									Ve &&
									((ni = {}),
									(ni[ft.a] = "+=" + Ve),
									ki && (ni[ft.p] = "-=" + xe()),
									Bt.set([He, di], ni)),
								C && !(Ec && W.end >= os(pt, ft)))
							)
								((ni = Ir(C)),
									(on = ft === Ki),
									(hr = xe()),
									(Kt = parseFloat(Ft(ft.a)) + Re),
									!Ye &&
										We > 1 &&
										((Hi = (K ? Ti.scrollingElement || Vr : pt).style),
										(Hi = {
											style: Hi,
											value: Hi["overflow" + ft.a.toUpperCase()],
										}),
										K &&
											Ir(fi)["overflow" + ft.a.toUpperCase()] !== "scroll" &&
											(Hi.style["overflow" + ft.a.toUpperCase()] = "scroll")),
									Nl(C, gt, ni),
									(Di = ku(C)),
									(gi = Ts(C, !0)),
									(Fr = Nt && Xs(pt, on ? Un : Ki)()),
									O
										? ((se = [O + ft.os2, Ie + Re + Yi]),
											(se.t = gt),
											(Fe = O === Zi ? Ju(C, ft) + Ie + Re : 0),
											Fe &&
												(se.push(ft.d, Fe + Yi),
												gt.style.flexBasis !== "auto" &&
													(gt.style.flexBasis = Fe + Yi)),
											aa(se),
											ki &&
												Te.forEach(function (mn) {
													mn.pin === ki &&
														mn.vars.pinSpacing !== !1 &&
														(mn._subPinOffset = !0);
												}),
											Nt && xe(Ui))
										: ((Fe = Ju(C, ft)),
											Fe &&
												gt.style.flexBasis !== "auto" &&
												(gt.style.flexBasis = Fe + Yi)),
									Nt &&
										((bi = {
											top: gi.top + (on ? hr - ne : Fr) + Yi,
											left: gi.left + (on ? Fr : hr - ne) + Yi,
											boxSizing: "border-box",
											position: "fixed",
										}),
										(bi[To] = bi["max" + pa] = Math.ceil(gi.width) + Yi),
										(bi[Eo] = bi["max" + Jc] = Math.ceil(gi.height) + Yi),
										(bi[Dr] =
											bi[Dr + $a] =
											bi[Dr + ja] =
											bi[Dr + Va] =
											bi[Dr + Ua] =
												"0"),
										(bi[Zi] = ni[Zi]),
										(bi[Zi + $a] = ni[Zi + $a]),
										(bi[Zi + ja] = ni[Zi + ja]),
										(bi[Zi + Va] = ni[Zi + Va]),
										(bi[Zi + Ua] = ni[Zi + Ua]),
										(re = Km($e, bi, Q)),
										Zn && xe(0)),
									s
										? ((cs = s._initted),
											Ol(1),
											s.render(s.duration(), !0, !0),
											(Ne = Ft(ft.a) - Kt + Ie + Re),
											(ie = Math.abs(Ie - Ne) > 1),
											Nt && ie && re.splice(re.length - 2, 2),
											s.render(0, !0, !0),
											cs || s.invalidate(!0),
											s.parent || s.totalTime(s.totalTime()),
											Ol(0))
										: (Ne = Ie),
									Hi &&
										(Hi.value
											? (Hi.style["overflow" + ft.a.toUpperCase()] = Hi.value)
											: Hi.style.removeProperty("overflow-" + ft.a)));
							else if (D && xe() && !g)
								for (gi = D.parentNode; gi && gi !== fi; )
									(gi._pinOffset &&
										((ne -= gi._pinOffset), (We -= gi._pinOffset)),
										(gi = gi.parentNode));
							(pn &&
								pn.forEach(function (mn) {
									return mn.revert(!1, !0);
								}),
								(W.start = ne),
								(W.end = We),
								(Ge = Ue = Zn ? Ui : xe()),
								!g && !Zn && (Ge < Ui && xe(Ui), (W.scroll.rec = 0)),
								W.revert(!1, !0),
								(Vt = xn()),
								Pi && ((jt = -1), Pi.restart(!0)),
								(bn = 0),
								s &&
									Dt &&
									(s._initted || Cn) &&
									s.progress() !== Cn &&
									s.progress(Cn || 0, !0).render(s.time(), !0, !0),
								(mi || U !== W.progress || g || P) &&
									(s &&
										!Dt &&
										s.totalProgress(
											g && ne < -0.001 && !U
												? Bt.utils.normalize(ne, We, 0)
												: U,
											!0,
										),
									(W.progress = mi || (Ge - ne) / Ie === U ? 0 : U)),
								C && O && (gt._pinOffset = Math.round(W.progress * Ne)),
								Qt && Qt.invalidate(),
								isNaN(Er) ||
									((Er -= Bt.getProperty(st, ft.p)),
									(Xn -= Bt.getProperty(ze, ft.p)),
									Au(st, ft, Er),
									Au(He, ft, Er - (zt || 0)),
									Au(ze, ft, Xn),
									Au(di, ft, Xn - (zt || 0))),
								mi && !Zn && W.update(),
								w && !Zn && !pi && ((pi = !0), w(W), (pi = !1)));
						}
					}),
					(W.getVelocity = function () {
						return ((xe() - Ue) / (xn() - Oa)) * 1e3 || 0;
					}),
					(W.endAnimation = function () {
						(ka(W.callbackAnimation),
							s &&
								(Qt
									? Qt.progress(1)
									: s.paused()
										? Dt || ka(s, W.direction < 0, 1)
										: ka(s, s.reversed())));
					}),
					(W.labelToScroll = function (yt) {
						return (
							(s &&
								s.labels &&
								(ne || W.refresh() || ne) +
									(s.labels[yt] / s.duration()) * Ie) ||
							0
						);
					}),
					(W.getTrailing = function (yt) {
						var Ut = Te.indexOf(W),
							Rt =
								W.direction > 0 ? Te.slice(0, Ut).reverse() : Te.slice(Ut + 1);
						return (
							vr(yt)
								? Rt.filter(function (zt) {
										return zt.vars.preventOverlaps === yt;
									})
								: Rt
						).filter(function (zt) {
							return W.direction > 0 ? zt.end <= ne : zt.start >= We;
						});
					}),
					(W.update = function (yt, Ut, Rt) {
						if (!(g && !Rt && !yt)) {
							var zt = Zn === !0 ? Ui : W.scroll(),
								xt = yt ? 0 : (zt - ne) / Ie,
								he = xt < 0 ? 0 : xt > 1 ? 1 : xt || 0,
								Ye = W.progress,
								mi,
								Ve,
								Re,
								Ae,
								Li,
								Le,
								ki,
								$i;
							if (
								(Ut &&
									((Ue = Ge),
									(Ge = g ? xe() : zt),
									V && ((En = Ii), (Ii = s && !Dt ? s.totalProgress() : he))),
								F &&
									C &&
									!bn &&
									!Su &&
									Nr &&
									(!he && ne < zt + ((zt - Ue) / (xn() - Oa)) * F
										? (he = 1e-4)
										: he === 1 &&
											We > zt + ((zt - Ue) / (xn() - Oa)) * F &&
											(he = 0.9999)),
								he !== Ye && W.enabled)
							) {
								if (
									((mi = W.isActive = !!he && he < 1),
									(Ve = !!Ye && Ye < 1),
									(Le = mi !== Ve),
									(Li = Le || !!he != !!Ye),
									(W.direction = he > Ye ? 1 : -1),
									(W.progress = he),
									Li &&
										!bn &&
										((Re = he && !Ye ? 0 : he === 1 ? 1 : Ye === 1 ? 2 : 3),
										Dt &&
											((Ae =
												(!Le && Ct[Re + 1] !== "none" && Ct[Re + 1]) || Ct[Re]),
											($i =
												s &&
												(Ae === "complete" || Ae === "reset" || Ae in s)))),
									ot &&
										(Le || $i) &&
										($i || A || !s) &&
										($n(ot)
											? ot(W)
											: W.getTrailing(ot).forEach(function (hr) {
													return hr.endAnimation();
												})),
									Dt ||
										(Qt && !bn && !Su
											? (Qt._dp._time - Qt._start !== Qt._time &&
													Qt.render(Qt._dp._time - Qt._start),
												Qt.resetTo
													? Qt.resetTo("totalProgress", he, s._tTime / s._tDur)
													: ((Qt.vars.totalProgress = he),
														Qt.invalidate().restart()))
											: s && s.totalProgress(he, !!(bn && (Vt || yt)))),
									C)
								) {
									if ((yt && O && (gt.style[O + ft.os2] = bt), !Nt))
										vt(Ia(Kt + Ne * he));
									else if (Li) {
										if (
											((ki =
												!yt && he > Ye && We + 1 > zt && zt + 1 >= os(pt, ft)),
											Q)
										)
											if (!yt && (mi || ki)) {
												var Fe = Ts(C, !0),
													ni = zt - ne;
												$h(
													C,
													fi,
													Fe.top + (ft === Ki ? ni : 0) + Yi,
													Fe.left + (ft === Ki ? 0 : ni) + Yi,
												);
											} else $h(C, gt);
										(aa(mi || ki ? re : Di),
											(ie && he < 1 && mi) ||
												vt(Kt + (he === 1 && !ki ? Ne : 0)));
									}
								}
								(V && !qe.tween && !bn && !Su && Pi.restart(!0),
									h &&
										(Le || (j && he && (he < 1 || !Dl))) &&
										nu(h.targets).forEach(function (hr) {
											return hr.classList[mi || j ? "add" : "remove"](
												h.className,
											);
										}),
									l && !Dt && !yt && l(W),
									Li && !bn
										? (Dt &&
												($i &&
													(Ae === "complete"
														? s.pause().totalProgress(1)
														: Ae === "reset"
															? s.restart(!0).pause()
															: Ae === "restart"
																? s.restart(!0)
																: s[Ae]()),
												l && l(W)),
											(Le || !Dl) &&
												(v && Le && Bl(W, v),
												St[Re] && Bl(W, St[Re]),
												j && (he === 1 ? W.kill(!1, 1) : (St[Re] = 0)),
												Le ||
													((Re = he === 1 ? 1 : 3), St[Re] && Bl(W, St[Re]))),
											ct &&
												!mi &&
												Math.abs(W.getVelocity()) > (Ba(ct) ? ct : 2500) &&
												(ka(W.callbackAnimation),
												Qt
													? Qt.progress(1)
													: ka(s, Ae === "reverse" ? 1 : !he, 1)))
										: Dt && l && !bn && l(W));
							}
							if (Jt) {
								var gi = g ? (zt / g.duration()) * (g._caScrollDist || 0) : zt;
								(ke(gi + (st._isFlipped ? 1 : 0)), Jt(gi));
							}
							yi && yi((-zt / g.duration()) * (g._caScrollDist || 0));
						}
					}),
					(W.enable = function (yt, Ut) {
						W.enabled ||
							((W.enabled = !0),
							nn(pt, "resize", za),
							K || nn(pt, "scroll", Yo),
							Wt && nn(p, "refreshInit", Wt),
							yt !== !1 && ((W.progress = U = 0), (Ge = Ue = jt = xe())),
							Ut !== !1 && W.refresh());
					}),
					(W.getTween = function (yt) {
						return yt && qe ? qe.tween : Qt;
					}),
					(W.setPositions = function (yt, Ut, Rt, zt) {
						if (g) {
							var xt = g.scrollTrigger,
								he = g.duration(),
								Ye = xt.end - xt.start;
							((yt = xt.start + (Ye * yt) / he),
								(Ut = xt.start + (Ye * Ut) / he));
						}
						(W.refresh(
							!1,
							!1,
							{
								start: Nh(yt, Rt && !!W._startClamp),
								end: Nh(Ut, Rt && !!W._endClamp),
							},
							zt,
						),
							W.update());
					}),
					(W.adjustPinSpacing = function (yt) {
						if (se && yt) {
							var Ut = se.indexOf(ft.d) + 1;
							((se[Ut] = parseFloat(se[Ut]) + yt + Yi),
								(se[1] = parseFloat(se[1]) + yt + Yi),
								aa(se));
						}
					}),
					(W.disable = function (yt, Ut) {
						if (
							W.enabled &&
							(yt !== !1 && W.revert(!0, !0),
							(W.enabled = W.isActive = !1),
							Ut || (Qt && Qt.pause()),
							(Ui = 0),
							Ze && (Ze.uncache = 1),
							Wt && en(p, "refreshInit", Wt),
							Pi && (Pi.pause(), qe.tween && qe.tween.kill() && (qe.tween = 0)),
							!K)
						) {
							for (var Rt = Te.length; Rt--; )
								if (Te[Rt].scroller === pt && Te[Rt] !== W) return;
							(en(pt, "resize", za), K || en(pt, "scroll", Yo));
						}
					}),
					(W.kill = function (yt, Ut) {
						(W.disable(yt, Ut), Qt && !Ut && Qt.kill(), f && delete Cc[f]);
						var Rt = Te.indexOf(W);
						(Rt >= 0 && Te.splice(Rt, 1),
							Rt === Wn && Fu > 0 && Wn--,
							(Rt = 0),
							Te.forEach(function (zt) {
								return zt.scroller === W.scroller && (Rt = 1);
							}),
							Rt || Zn || (W.scroll.rec = 0),
							s &&
								((s.scrollTrigger = null),
								yt && s.revert({ kill: !1 }),
								Ut || s.kill()),
							He &&
								[He, di, st, ze].forEach(function (zt) {
									return zt.parentNode && zt.parentNode.removeChild(zt);
								}),
							Ga === W && (Ga = 0),
							C &&
								(Ze && (Ze.uncache = 1),
								(Rt = 0),
								Te.forEach(function (zt) {
									return zt.pin === C && Rt++;
								}),
								Rt || (Ze.spacer = 0)),
							r.onKill && r.onKill(W));
					}),
					Te.push(W),
					W.enable(!1, !1),
					Xe && Xe(W),
					s && s.add && !Ie)
				) {
					var we = W.update;
					((W.update = function () {
						((W.update = we), ne || We || W.refresh());
					}),
						Bt.delayedCall(0.01, W.update),
						(Ie = 0.01),
						(ne = We = 0));
				} else W.refresh();
				C && Gm();
			}),
			(p.register = function (r) {
				return (
					Ko ||
						((Bt = r || Md()),
						Ad() && window.document && p.enable(),
						(Ko = Da)),
					Ko
				);
			}),
			(p.defaults = function (r) {
				if (r) for (var s in r) Pu[s] = r[s];
				return Pu;
			}),
			(p.disable = function (r, s) {
				((Da = 0),
					Te.forEach(function (l) {
						return l[s ? "kill" : "disable"](r);
					}),
					en(Oe, "wheel", Yo),
					en(Ti, "scroll", Yo),
					clearInterval(wu),
					en(Ti, "touchcancel", ns),
					en(fi, "touchstart", ns),
					Eu(en, Ti, "pointerdown,touchstart,mousedown", Rh),
					Eu(en, Ti, "pointerup,touchend,mouseup", Fh),
					Yu.kill(),
					Tu(en));
				for (var u = 0; u < Ce.length; u += 3)
					(Cu(en, Ce[u], Ce[u + 1]), Cu(en, Ce[u], Ce[u + 2]));
			}),
			(p.enable = function () {
				if (
					((Oe = window),
					(Ti = document),
					(Vr = Ti.documentElement),
					(fi = Ti.body),
					Bt &&
						((nu = Bt.utils.toArray),
						(Za = Bt.utils.clamp),
						(Tc = Bt.core.context || ns),
						(Ol = Bt.core.suppressOverwrites || ns),
						(Gc = Oe.history.scrollRestoration || "auto"),
						(Pc = Oe.pageYOffset),
						Bt.core.globals("ScrollTrigger", p),
						fi))
				) {
					((Da = 1),
						(oa = document.createElement("div")),
						(oa.style.height = "100vh"),
						(oa.style.position = "absolute"),
						Hd(),
						qm(),
						Ri.register(Bt),
						(p.isTouch = Ri.isTouch),
						(Ns =
							Ri.isTouch &&
							/(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
						(Sc = Ri.isTouch === 1),
						nn(Oe, "wheel", Yo),
						(Ed = [Oe, Ti, Vr, fi]),
						Bt.matchMedia
							? ((p.matchMedia = function (f) {
									var v = Bt.matchMedia(),
										w;
									for (w in f) v.add(w, f[w]);
									return v;
								}),
								Bt.addEventListener("matchMediaInit", function () {
									return th();
								}),
								Bt.addEventListener("matchMediaRevert", function () {
									return Rd();
								}),
								Bt.addEventListener("matchMedia", function () {
									(yo(0, 1), Mo("matchMedia"));
								}),
								Bt.matchMedia("(orientation: portrait)", function () {
									return (zl(), zl);
								}))
							: console.warn("Requires GSAP 3.11.0 or later"),
						zl(),
						nn(Ti, "scroll", Yo));
					var r = fi.style,
						s = r.borderTopStyle,
						u = Bt.core.Animation.prototype,
						l,
						h;
					for (
						u.revert ||
							Object.defineProperty(u, "revert", {
								value: function () {
									return this.time(-0.01, !0);
								},
							}),
							r.borderTopStyle = "solid",
							l = Ts(fi),
							Ki.m = Math.round(l.top + Ki.sc()) || 0,
							Un.m = Math.round(l.left + Un.sc()) || 0,
							s ? (r.borderTopStyle = s) : r.removeProperty("border-top-style"),
							wu = setInterval(Wh, 250),
							Bt.delayedCall(0.5, function () {
								return (Su = 0);
							}),
							nn(Ti, "touchcancel", ns),
							nn(fi, "touchstart", ns),
							Eu(nn, Ti, "pointerdown,touchstart,mousedown", Rh),
							Eu(nn, Ti, "pointerup,touchend,mouseup", Fh),
							wc = Bt.utils.checkPrefix("transform"),
							Hu.push(wc),
							Ko = xn(),
							Yu = Bt.delayedCall(0.2, yo).pause(),
							Jo = [
								Ti,
								"visibilitychange",
								function () {
									var f = Oe.innerWidth,
										v = Oe.innerHeight;
									Ti.hidden
										? ((Ih = f), (Bh = v))
										: (Ih !== f || Bh !== v) && za();
								},
								Ti,
								"DOMContentLoaded",
								yo,
								Oe,
								"load",
								yo,
								Oe,
								"resize",
								za,
							],
							Tu(nn),
							Te.forEach(function (f) {
								return f.enable(0, 1);
							}),
							h = 0;
						h < Ce.length;
						h += 3
					)
						(Cu(en, Ce[h], Ce[h + 1]), Cu(en, Ce[h], Ce[h + 2]));
				}
			}),
			(p.config = function (r) {
				"limitCallbacks" in r && (Dl = !!r.limitCallbacks);
				var s = r.syncInterval;
				((s && clearInterval(wu)) || ((wu = s) && setInterval(Wh, s)),
					"ignoreMobileResize" in r &&
						(Sc = p.isTouch === 1 && r.ignoreMobileResize),
					"autoRefreshEvents" in r &&
						(Tu(en) || Tu(nn, r.autoRefreshEvents || "none"),
						(Pd = (r.autoRefreshEvents + "").indexOf("resize") === -1)));
			}),
			(p.scrollerProxy = function (r, s) {
				var u = sr(r),
					l = Ce.indexOf(u),
					h = ko(u);
				(~l && Ce.splice(l, h ? 6 : 2),
					s && (h ? us.unshift(Oe, s, fi, s, Vr, s) : us.unshift(u, s)));
			}),
			(p.clearMatchMedia = function (r) {
				Te.forEach(function (s) {
					return s._ctx && s._ctx.query === r && s._ctx.kill(!0, !0);
				});
			}),
			(p.isInViewport = function (r, s, u) {
				var l = (vr(r) ? sr(r) : r).getBoundingClientRect(),
					h = l[u ? To : Eo] * s || 0;
				return u
					? l.right - h > 0 && l.left + h < Oe.innerWidth
					: l.bottom - h > 0 && l.top + h < Oe.innerHeight;
			}),
			(p.positionInViewport = function (r, s, u) {
				vr(r) && (r = sr(r));
				var l = r.getBoundingClientRect(),
					h = l[u ? To : Eo],
					f =
						s == null
							? h / 2
							: s in Qu
								? Qu[s] * h
								: ~s.indexOf("%")
									? (parseFloat(s) * h) / 100
									: parseFloat(s) || 0;
				return u ? (l.left + f) / Oe.innerWidth : (l.top + f) / Oe.innerHeight;
			}),
			(p.killAll = function (r) {
				if (
					(Te.slice(0).forEach(function (u) {
						return u.vars.id !== "ScrollSmoother" && u.kill();
					}),
					r !== !0)
				) {
					var s = Ao.killAll || [];
					((Ao = {}),
						s.forEach(function (u) {
							return u();
						}));
				}
			}),
			p
		);
	})();
Pe.version = "3.12.5";
Pe.saveStyles = function (p) {
	return p
		? nu(p).forEach(function (e) {
				if (e && e.style) {
					var n = _r.indexOf(e);
					(n >= 0 && _r.splice(n, 5),
						_r.push(
							e,
							e.style.cssText,
							e.getBBox && e.getAttribute("transform"),
							Bt.core.getCache(e),
							Tc(),
						));
				}
			})
		: _r;
};
Pe.revert = function (p, e) {
	return th(!p, e);
};
Pe.create = function (p, e) {
	return new Pe(p, e);
};
Pe.refresh = function (p) {
	return p ? za() : (Ko || Pe.register()) && yo(!0);
};
Pe.update = function (p) {
	return ++Ce.cache && Cs(p === !0 ? 2 : 0);
};
Pe.clearScrollMemory = Fd;
Pe.maxScroll = function (p, e) {
	return os(p, e ? Un : Ki);
};
Pe.getScrollFunc = function (p, e) {
	return Xs(sr(p), e ? Un : Ki);
};
Pe.getById = function (p) {
	return Cc[p];
};
Pe.getAll = function () {
	return Te.filter(function (p) {
		return p.vars.id !== "ScrollSmoother";
	});
};
Pe.isScrolling = function () {
	return !!Nr;
};
Pe.snapDirectional = Qc;
Pe.addEventListener = function (p, e) {
	var n = Ao[p] || (Ao[p] = []);
	~n.indexOf(e) || n.push(e);
};
Pe.removeEventListener = function (p, e) {
	var n = Ao[p],
		r = n && n.indexOf(e);
	r >= 0 && n.splice(r, 1);
};
Pe.batch = function (p, e) {
	var n = [],
		r = {},
		s = e.interval || 0.016,
		u = e.batchMax || 1e9,
		l = function (v, w) {
			var A = [],
				D = [],
				C = Bt.delayedCall(s, function () {
					(w(A, D), (A = []), (D = []));
				}).pause();
			return function (O) {
				(A.length || C.restart(!0),
					A.push(O.trigger),
					D.push(O),
					u <= A.length && C.progress(1));
			};
		},
		h;
	for (h in e)
		r[h] =
			h.substr(0, 2) === "on" && $n(e[h]) && h !== "onRefreshInit"
				? l(h, e[h])
				: e[h];
	return (
		$n(u) &&
			((u = u()),
			nn(Pe, "refresh", function () {
				return (u = e.batchMax());
			})),
		nu(p).forEach(function (f) {
			var v = {};
			for (h in r) v[h] = r[h];
			((v.trigger = f), n.push(Pe.create(v)));
		}),
		n
	);
};
var Gh = function (e, n, r, s) {
		return (
			n > s ? e(s) : n < 0 && e(0),
			r > s ? (s - n) / (r - n) : r < 0 ? n / (n - r) : 1
		);
	},
	Rl = function p(e, n) {
		(n === !0
			? e.style.removeProperty("touch-action")
			: (e.style.touchAction =
					n === !0
						? "auto"
						: n
							? "pan-" + n + (Ri.isTouch ? " pinch-zoom" : "")
							: "none"),
			e === Vr && p(fi, n));
	},
	Mu = { auto: 1, scroll: 1 },
	Qm = function (e) {
		var n = e.event,
			r = e.target,
			s = e.axis,
			u = (n.changedTouches ? n.changedTouches[0] : n).target,
			l = u._gsap || Bt.core.getCache(u),
			h = xn(),
			f;
		if (!l._isScrollT || h - l._isScrollT > 2e3) {
			for (
				;
				u &&
				u !== fi &&
				((u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) ||
					!(Mu[(f = Ir(u)).overflowY] || Mu[f.overflowX]));
			)
				u = u.parentNode;
			((l._isScroll =
				u &&
				u !== r &&
				!ko(u) &&
				(Mu[(f = Ir(u)).overflowY] || Mu[f.overflowX])),
				(l._isScrollT = h));
		}
		(l._isScroll || s === "x") && (n.stopPropagation(), (n._gsapAllow = !0));
	},
	Wd = function (e, n, r, s) {
		return Ri.create({
			target: e,
			capture: !0,
			debounce: !1,
			lockAxis: !0,
			type: n,
			onWheel: (s = s && Qm),
			onPress: s,
			onDrag: s,
			onScroll: s,
			onEnable: function () {
				return r && nn(Ti, Ri.eventTypes[0], Yh, !1, !0);
			},
			onDisable: function () {
				return en(Ti, Ri.eventTypes[0], Yh, !0);
			},
		});
	},
	tg = /(input|label|select|textarea)/i,
	Xh,
	Yh = function (e) {
		var n = tg.test(e.target.tagName);
		(n || Xh) && ((e._gsapAllow = !0), (Xh = n));
	},
	eg = function (e) {
		(_o(e) || (e = {}),
			(e.preventDefault = e.isNormalizer = e.allowClicks = !0),
			e.type || (e.type = "wheel,touch"),
			(e.debounce = !!e.debounce),
			(e.id = e.id || "normalizer"));
		var n = e,
			r = n.normalizeScrollX,
			s = n.momentum,
			u = n.allowNestedScroll,
			l = n.onRelease,
			h,
			f,
			v = sr(e.target) || Vr,
			w = Bt.core.globals().ScrollSmoother,
			A = w && w.get(),
			D =
				Ns &&
				((e.content && sr(e.content)) ||
					(A && e.content !== !1 && !A.smooth() && A.content())),
			C = Xs(v, Ki),
			O = Xs(v, Un),
			P = 1,
			F =
				(Ri.isTouch && Oe.visualViewport
					? Oe.visualViewport.scale * Oe.visualViewport.width
					: Oe.outerWidth) / Oe.innerWidth,
			G = 0,
			B = $n(s)
				? function () {
						return s(h);
					}
				: function () {
						return s || 2.8;
					},
			j,
			V,
			Q = Wd(v, e.type, !0, u),
			it = function () {
				return (V = !1);
			},
			g = ns,
			ct = ns,
			ot = function () {
				((f = os(v, Ki)),
					(ct = Za(Ns ? 1 : 0, f)),
					r && (g = Za(0, os(v, Un))),
					(j = Co));
			},
			ft = function () {
				((D._gsap.y = Ia(parseFloat(D._gsap.y) + C.offset) + "px"),
					(D.style.transform =
						"matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " +
						parseFloat(D._gsap.y) +
						", 0, 1)"),
					(C.offset = C.cacheID = 0));
			},
			Dt = function () {
				if (V) {
					requestAnimationFrame(it);
					var _t = Ia(h.deltaY / 2),
						de = ct(C.v - _t);
					if (D && de !== C.v + C.offset) {
						C.offset = de - C.v;
						var W = Ia((parseFloat(D && D._gsap.y) || 0) - C.offset);
						((D.style.transform =
							"matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " +
							W +
							", 0, 1)"),
							(D._gsap.y = W + "px"),
							(C.cacheID = Ce.cache),
							Cs());
					}
					return !0;
				}
				(C.offset && ft(), (V = !0));
			},
			pt,
			Et,
			K,
			Nt,
			St = function () {
				(ot(),
					pt.isActive() &&
						pt.vars.scrollY > f &&
						(C() > f ? pt.progress(1) && C(f) : pt.resetTo("scrollY", f)));
			};
		return (
			D && Bt.set(D, { y: "+=0" }),
			(e.ignoreCheck = function (Ct) {
				return (
					(Ns && Ct.type === "touchmove" && Dt()) ||
					(P > 1.05 && Ct.type !== "touchstart") ||
					h.isGesturing ||
					(Ct.touches && Ct.touches.length > 1)
				);
			}),
			(e.onPress = function () {
				V = !1;
				var Ct = P;
				((P = Ia(((Oe.visualViewport && Oe.visualViewport.scale) || 1) / F)),
					pt.pause(),
					Ct !== P && Rl(v, P > 1.01 ? !0 : r ? !1 : "x"),
					(Et = O()),
					(K = C()),
					ot(),
					(j = Co));
			}),
			(e.onRelease = e.onGestureStart =
				function (Ct, _t) {
					if ((C.offset && ft(), !_t)) Nt.restart(!0);
					else {
						Ce.cache++;
						var de = B(),
							W,
							Wt;
						(r &&
							((W = O()),
							(Wt = W + (de * 0.05 * -Ct.velocityX) / 0.227),
							(de *= Gh(O, W, Wt, os(v, Un))),
							(pt.vars.scrollX = g(Wt))),
							(W = C()),
							(Wt = W + (de * 0.05 * -Ct.velocityY) / 0.227),
							(de *= Gh(C, W, Wt, os(v, Ki))),
							(pt.vars.scrollY = ct(Wt)),
							pt.invalidate().duration(de).play(0.01),
							((Ns && pt.vars.scrollY >= f) || W >= f - 1) &&
								Bt.to({}, { onUpdate: St, duration: de }));
					}
					l && l(Ct);
				}),
			(e.onWheel = function () {
				(pt._ts && pt.pause(), xn() - G > 1e3 && ((j = 0), (G = xn())));
			}),
			(e.onChange = function (Ct, _t, de, W, Wt) {
				if (
					(Co !== j && ot(),
					_t &&
						r &&
						O(g(W[2] === _t ? Et + (Ct.startX - Ct.x) : O() + _t - W[1])),
					de)
				) {
					C.offset && ft();
					var Zt = Wt[2] === de,
						oe = Zt ? K + Ct.startY - Ct.y : C() + de - Wt[1],
						jt = ct(oe);
					(Zt && oe !== jt && (K += jt - oe), C(jt));
				}
				(de || _t) && Cs();
			}),
			(e.onEnable = function () {
				(Rl(v, r ? !1 : "x"),
					Pe.addEventListener("refresh", St),
					nn(Oe, "resize", St),
					C.smooth &&
						((C.target.style.scrollBehavior = "auto"),
						(C.smooth = O.smooth = !1)),
					Q.enable());
			}),
			(e.onDisable = function () {
				(Rl(v, !0),
					en(Oe, "resize", St),
					Pe.removeEventListener("refresh", St),
					Q.kill());
			}),
			(e.lockAxis = e.lockAxis !== !1),
			(h = new Ri(e)),
			(h.iOS = Ns),
			Ns && !C() && C(1),
			Ns && Bt.ticker.add(ns),
			(Nt = h._dc),
			(pt = Bt.to(h, {
				ease: "power4",
				paused: !0,
				inherit: !1,
				scrollX: r ? "+=0.1" : "+=0",
				scrollY: "+=0.1",
				modifiers: {
					scrollY: qd(C, C(), function () {
						return pt.pause();
					}),
				},
				onUpdate: Cs,
				onComplete: Nt.vars.onComplete,
			})),
			h
		);
	};
Pe.sort = function (p) {
	return Te.sort(
		p ||
			function (e, n) {
				return (
					(e.vars.refreshPriority || 0) * -1e6 +
					e.start -
					(n.start + (n.vars.refreshPriority || 0) * -1e6)
				);
			},
	);
};
Pe.observe = function (p) {
	return new Ri(p);
};
Pe.normalizeScroll = function (p) {
	if (typeof p > "u") return qn;
	if (p === !0 && qn) return qn.enable();
	if (p === !1) {
		(qn && qn.kill(), (qn = p));
		return;
	}
	var e = p instanceof Ri ? p : eg(p);
	return (
		qn && qn.target === e.target && qn.kill(),
		ko(e.target) && (qn = e),
		e
	);
};
Pe.core = {
	_getVelocityProp: xc,
	_inputObserver: Wd,
	_scrollers: Ce,
	_proxies: us,
	bridge: {
		ss: function () {
			(Nr || Mo("scrollStart"), (Nr = xn()));
		},
		ref: function () {
			return bn;
		},
	},
};
Md() && Bt.registerPlugin(Pe);
const ig = () =>
	Ht(function () {
		es.registerPlugin(Pe);
		let p = document.querySelectorAll("[data-animation]"),
			e = 0.75,
			n = "top 80%",
			r = "play none none reverse",
			s = "power3.out";
		(p.forEach((u) => {
			let l = u.dataset.animation,
				h = es.matchMedia();
			if (
				(l === "fade-in" &&
					es.to(u, {
						duration: e,
						opacity: 1,
						ease: s,
						scrollTrigger: { trigger: u, start: n, toggleActions: r },
					}),
				(l === "fade-up" || l === "fade-down") &&
					es.to(u, {
						duration: e,
						y: 0,
						opacity: 1,
						ease: s,
						scrollTrigger: { trigger: u, start: n, toggleActions: r },
					}),
				(l === "fade-left" || l === "fade-right") &&
					es.to(u, {
						duration: e,
						x: 0,
						opacity: 1,
						ease: s,
						scrollTrigger: { trigger: u, start: n, toggleActions: r },
					}),
				l === "stagger-fade-up" || l === "stagger-fade-down")
			) {
				let f = u.querySelectorAll(":scope > *");
				es.to(f, {
					duration: e,
					y: 0,
					opacity: 1,
					ease: s,
					stagger: 0.15,
					scrollTrigger: { trigger: u, start: n, toggleActions: r },
				});
			}
			if (l === "stagger-fade-in") {
				let f = u.querySelectorAll(":scope > *");
				es.to(f, {
					duration: e,
					opacity: 1,
					ease: s,
					stagger: 0.15,
					scrollTrigger: { trigger: u, start: n, toggleActions: r },
				});
			}
			h.add("(prefers-reduced-motion: no-preference)", () => {
				l === "parallax-hero" &&
					es.to(u, {
						yPercent: 10,
						ease: "power0.none",
						scrollTrigger: { trigger: u, start: "top top", scrub: !0 },
					});
			});
		}),
			Ht(".js-scroll-top").each(function () {
				es.to(Ht(this), {
					scrollTrigger: {
						trigger: "body",
						start: "top -5%",
						end: "top -5%",
						toggleActions: "play none reverse none",
					},
					duration: 0.25,
					autoAlpha: 1,
					y: "0%",
					ease: "power0.none",
				});
			}));
	});
setTimeout(ig, 500);
const ws = class ws {
	constructor(e, n = {}) {
		tn(this, "drawerElement", document.querySelector(".js-drawer"));
		tn(this, "config", {
			openButtons: document.querySelectorAll(".js-open-drawer"),
			closeButtons: document.querySelectorAll(".js-close-drawer"),
			closeByClickOutside: !0,
		});
		if (((this.drawerElement = e ?? this.drawerElement), !this.drawerElement)) {
			console.warn("Drawer Element does not exist!");
			return;
		}
		((this.config = { ...this.config, ...n }),
			(this.config.openButtons = [...this.config.openButtons].filter((r) => {
				var s;
				return (
					r.getAttribute("aria-controls") ===
					((s = this.drawerElement) == null ? void 0 : s.id)
				);
			})),
			(this.config.closeButtons = [...this.config.closeButtons].filter((r) => {
				var s;
				return (
					r.getAttribute("aria-controls") ===
					((s = this.drawerElement) == null ? void 0 : s.id)
				);
			})),
			(this.ally = po),
			(this.focusTrapHandle = null),
			(this.lastActiveElement = null),
			this.bindEvents());
	}
	bindEvents() {
		(this.config.openButtons.forEach((e) => {
			e.addEventListener("click", this.open.bind(this));
		}),
			this.config.closeButtons.forEach((e) => {
				e.addEventListener("click", this.close.bind(this));
			}),
			this.config.closeByClickOutside &&
				this.drawerElement.addEventListener("click", (e) => {
					e.target === this.drawerElement && this.close();
				}),
			document.addEventListener("keydown", (e) => {
				e.key === "Escape" && this.close();
			}));
	}
	open() {
		this.drawerElement.hidden &&
			(ws.instance && ws.instance.close(),
			(ws.instance = this),
			(this.drawerElement.hidden = !1),
			this.config.openButtons.forEach((e) => {
				e.setAttribute("aria-expanded", !0);
			}),
			document.body.style.setProperty("overflow", "hidden"),
			this.focus(),
			this.emitEvent("open"));
	}
	close() {
		this.drawerElement.hidden ||
			(ws.instance === this && (ws.instance = null),
			(this.drawerElement.hidden = !0),
			this.config.openButtons.forEach((e) => {
				e.setAttribute("aria-expanded", !1);
			}),
			document.body.style.removeProperty("overflow"),
			this.blur(),
			this.emitEvent("close"));
	}
	focus() {
		if (
			((this.lastActiveElement = document.activeElement),
			this.config.closeButtons.length <= 0)
		) {
			console.warn(
				`Drawer '${this.drawerElement.id}' has no close button inside.`,
			);
			return;
		}
		const e = this.ally.when.focusable({
			context: this.config.closeButtons,
			callback: function () {
				const n = ws.instance,
					r = n.drawerElement;
				n.focusTrapHandle = n.ally.maintain.tabFocus({ context: r });
				const s = n.ally.query.firstTabbable({
					context: r,
					defaultToContext: !0,
					includeOnlyTabbable: !0,
					strategy: "quick",
				});
				(s && n.ally.element.focus(s), e.disengage());
			},
		});
	}
	blur() {
		(this.focusTrapHandle !== null &&
			(this.focusTrapHandle.disengage(), (this.focusTrapHandle = null)),
			this.lastActiveElement &&
				this.ally.element.focus(this.lastActiveElement));
	}
	emitEvent(e) {
		const n = new CustomEvent(`drawer:${e}`, {
			detail: { drawerId: this.drawerElement.id },
		});
		window.dispatchEvent(n);
	}
};
tn(ws, "instance", null);
let kc = ws;
document.querySelectorAll(".js-drawer").forEach((p) => {
	new kc(p);
});
var Zd = { exports: {} },
	Fl = { exports: {} },
	Hl = { exports: {} },
	Kh;
function sl() {
	return (
		Kh ||
			((Kh = 1),
			(function (p) {
				(function (e, n) {
					p.exports ? (p.exports = n()) : (e.EvEmitter = n());
				})(typeof window < "u" ? window : Rs, function () {
					function e() {}
					var n = e.prototype;
					return (
						(n.on = function (r, s) {
							if (!(!r || !s)) {
								var u = (this._events = this._events || {}),
									l = (u[r] = u[r] || []);
								return (l.indexOf(s) == -1 && l.push(s), this);
							}
						}),
						(n.once = function (r, s) {
							if (!(!r || !s)) {
								this.on(r, s);
								var u = (this._onceEvents = this._onceEvents || {}),
									l = (u[r] = u[r] || {});
								return ((l[s] = !0), this);
							}
						}),
						(n.off = function (r, s) {
							var u = this._events && this._events[r];
							if (!(!u || !u.length)) {
								var l = u.indexOf(s);
								return (l != -1 && u.splice(l, 1), this);
							}
						}),
						(n.emitEvent = function (r, s) {
							var u = this._events && this._events[r];
							if (!(!u || !u.length)) {
								((u = u.slice(0)), (s = s || []));
								for (
									var l = this._onceEvents && this._onceEvents[r], h = 0;
									h < u.length;
									h++
								) {
									var f = u[h],
										v = l && l[f];
									(v && (this.off(r, f), delete l[f]), f.apply(this, s));
								}
								return this;
							}
						}),
						(n.allOff = function () {
							(delete this._events, delete this._onceEvents);
						}),
						e
					);
				});
			})(Hl)),
		Hl.exports
	);
}
var ql = { exports: {} };
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ var Jh;
function jd() {
	return (
		Jh ||
			((Jh = 1),
			(function (p) {
				(function (e, n) {
					p.exports ? (p.exports = n()) : (e.getSize = n());
				})(window, function () {
					function n(C) {
						var O = parseFloat(C),
							P = C.indexOf("%") == -1 && !isNaN(O);
						return P && O;
					}
					function r() {}
					var s =
							typeof console > "u"
								? r
								: function (C) {
										console.error(C);
									},
						u = [
							"paddingLeft",
							"paddingRight",
							"paddingTop",
							"paddingBottom",
							"marginLeft",
							"marginRight",
							"marginTop",
							"marginBottom",
							"borderLeftWidth",
							"borderRightWidth",
							"borderTopWidth",
							"borderBottomWidth",
						],
						l = u.length;
					function h() {
						for (
							var C = {
									width: 0,
									height: 0,
									innerWidth: 0,
									innerHeight: 0,
									outerWidth: 0,
									outerHeight: 0,
								},
								O = 0;
							O < l;
							O++
						) {
							var P = u[O];
							C[P] = 0;
						}
						return C;
					}
					function f(C) {
						var O = getComputedStyle(C);
						return (
							O ||
								s(
									"Style returned " +
										O +
										". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1",
								),
							O
						);
					}
					var v = !1,
						w;
					function A() {
						if (!v) {
							v = !0;
							var C = document.createElement("div");
							((C.style.width = "200px"),
								(C.style.padding = "1px 2px 3px 4px"),
								(C.style.borderStyle = "solid"),
								(C.style.borderWidth = "1px 2px 3px 4px"),
								(C.style.boxSizing = "border-box"));
							var O = document.body || document.documentElement;
							O.appendChild(C);
							var P = f(C);
							((w = Math.round(n(P.width)) == 200),
								(D.isBoxSizeOuter = w),
								O.removeChild(C));
						}
					}
					function D(C) {
						if (
							(A(),
							typeof C == "string" && (C = document.querySelector(C)),
							!(!C || typeof C != "object" || !C.nodeType))
						) {
							var O = f(C);
							if (O.display == "none") return h();
							var P = {};
							((P.width = C.offsetWidth), (P.height = C.offsetHeight));
							for (
								var F = (P.isBorderBox = O.boxSizing == "border-box"), G = 0;
								G < l;
								G++
							) {
								var B = u[G],
									j = O[B],
									V = parseFloat(j);
								P[B] = isNaN(V) ? 0 : V;
							}
							var Q = P.paddingLeft + P.paddingRight,
								it = P.paddingTop + P.paddingBottom,
								g = P.marginLeft + P.marginRight,
								ct = P.marginTop + P.marginBottom,
								ot = P.borderLeftWidth + P.borderRightWidth,
								ft = P.borderTopWidth + P.borderBottomWidth,
								Dt = F && w,
								pt = n(O.width);
							pt !== !1 && (P.width = pt + (Dt ? 0 : Q + ot));
							var Et = n(O.height);
							return (
								Et !== !1 && (P.height = Et + (Dt ? 0 : it + ft)),
								(P.innerWidth = P.width - (Q + ot)),
								(P.innerHeight = P.height - (it + ft)),
								(P.outerWidth = P.width + g),
								(P.outerHeight = P.height + ct),
								P
							);
						}
					}
					return D;
				});
			})(ql)),
		ql.exports
	);
}
var Wl = { exports: {} },
	Zl = { exports: {} },
	Qh;
function ng() {
	return (
		Qh ||
			((Qh = 1),
			(function (p) {
				(function (e, n) {
					p.exports ? (p.exports = n()) : (e.matchesSelector = n());
				})(window, function () {
					var n = (function () {
						var r = window.Element.prototype;
						if (r.matches) return "matches";
						if (r.matchesSelector) return "matchesSelector";
						for (
							var s = ["webkit", "moz", "ms", "o"], u = 0;
							u < s.length;
							u++
						) {
							var l = s[u],
								h = l + "MatchesSelector";
							if (r[h]) return h;
						}
					})();
					return function (s, u) {
						return s[n](u);
					};
				});
			})(Zl)),
		Zl.exports
	);
}
var tf;
function Ks() {
	return (
		tf ||
			((tf = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, ng()))
						: (e.fizzyUIUtils = n(e, e.matchesSelector));
				})(window, function (n, r) {
					var s = {};
					((s.extend = function (h, f) {
						for (var v in f) h[v] = f[v];
						return h;
					}),
						(s.modulo = function (h, f) {
							return ((h % f) + f) % f;
						}));
					var u = Array.prototype.slice;
					((s.makeArray = function (h) {
						if (Array.isArray(h)) return h;
						if (h == null) return [];
						var f = typeof h == "object" && typeof h.length == "number";
						return f ? u.call(h) : [h];
					}),
						(s.removeFrom = function (h, f) {
							var v = h.indexOf(f);
							v != -1 && h.splice(v, 1);
						}),
						(s.getParent = function (h, f) {
							for (; h.parentNode && h != document.body; )
								if (((h = h.parentNode), r(h, f))) return h;
						}),
						(s.getQueryElement = function (h) {
							return typeof h == "string" ? document.querySelector(h) : h;
						}),
						(s.handleEvent = function (h) {
							var f = "on" + h.type;
							this[f] && this[f](h);
						}),
						(s.filterFindElements = function (h, f) {
							h = s.makeArray(h);
							var v = [];
							return (
								h.forEach(function (w) {
									if (w instanceof HTMLElement) {
										if (!f) {
											v.push(w);
											return;
										}
										r(w, f) && v.push(w);
										for (
											var A = w.querySelectorAll(f), D = 0;
											D < A.length;
											D++
										)
											v.push(A[D]);
									}
								}),
								v
							);
						}),
						(s.debounceMethod = function (h, f, v) {
							v = v || 100;
							var w = h.prototype[f],
								A = f + "Timeout";
							h.prototype[f] = function () {
								var D = this[A];
								clearTimeout(D);
								var C = arguments,
									O = this;
								this[A] = setTimeout(function () {
									(w.apply(O, C), delete O[A]);
								}, v);
							};
						}),
						(s.docReady = function (h) {
							var f = document.readyState;
							f == "complete" || f == "interactive"
								? setTimeout(h)
								: document.addEventListener("DOMContentLoaded", h);
						}),
						(s.toDashed = function (h) {
							return h
								.replace(/(.)([A-Z])/g, function (f, v, w) {
									return v + "-" + w;
								})
								.toLowerCase();
						}));
					var l = n.console;
					return (
						(s.htmlInit = function (h, f) {
							s.docReady(function () {
								var v = s.toDashed(f),
									w = "data-" + v,
									A = document.querySelectorAll("[" + w + "]"),
									D = document.querySelectorAll(".js-" + v),
									C = s.makeArray(A).concat(s.makeArray(D)),
									O = w + "-options",
									P = n.jQuery;
								C.forEach(function (F) {
									var G = F.getAttribute(w) || F.getAttribute(O),
										B;
									try {
										B = G && JSON.parse(G);
									} catch (V) {
										l &&
											l.error(
												"Error parsing " + w + " on " + F.className + ": " + V,
											);
										return;
									}
									var j = new h(F, B);
									P && P.data(F, f, j);
								});
							});
						}),
						s
					);
				});
			})(Wl)),
		Wl.exports
	);
}
var jl = { exports: {} },
	ef;
function rg() {
	return (
		ef ||
			((ef = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, jd()))
						: ((e.Flickity = e.Flickity || {}),
							(e.Flickity.Cell = n(e, e.getSize)));
				})(window, function (n, r) {
					function s(l, h) {
						((this.element = l), (this.parent = h), this.create());
					}
					var u = s.prototype;
					return (
						(u.create = function () {
							((this.element.style.position = "absolute"),
								this.element.setAttribute("aria-hidden", "true"),
								(this.x = 0),
								(this.shift = 0),
								(this.element.style[this.parent.originSide] = 0));
						}),
						(u.destroy = function () {
							(this.unselect(), (this.element.style.position = ""));
							var l = this.parent.originSide;
							((this.element.style[l] = ""),
								(this.element.style.transform = ""),
								this.element.removeAttribute("aria-hidden"));
						}),
						(u.getSize = function () {
							this.size = r(this.element);
						}),
						(u.setPosition = function (l) {
							((this.x = l), this.updateTarget(), this.renderPosition(l));
						}),
						(u.updateTarget = u.setDefaultTarget =
							function () {
								var l =
									this.parent.originSide == "left"
										? "marginLeft"
										: "marginRight";
								this.target =
									this.x +
									this.size[l] +
									this.size.width * this.parent.cellAlign;
							}),
						(u.renderPosition = function (l) {
							var h = this.parent.originSide === "left" ? 1 : -1,
								f = this.parent.options.percentPosition
									? l * h * (this.parent.size.innerWidth / this.size.width)
									: l * h;
							this.element.style.transform =
								"translateX(" + this.parent.getPositionValue(f) + ")";
						}),
						(u.select = function () {
							(this.element.classList.add("is-selected"),
								this.element.removeAttribute("aria-hidden"));
						}),
						(u.unselect = function () {
							(this.element.classList.remove("is-selected"),
								this.element.setAttribute("aria-hidden", "true"));
						}),
						(u.wrapShift = function (l) {
							((this.shift = l),
								this.renderPosition(this.x + this.parent.slideableWidth * l));
						}),
						(u.remove = function () {
							this.element.parentNode.removeChild(this.element);
						}),
						s
					);
				});
			})(jl)),
		jl.exports
	);
}
var Ul = { exports: {} },
	nf;
function sg() {
	return (
		nf ||
			((nf = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n())
						: ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = n()));
				})(window, function () {
					function n(s) {
						((this.parent = s),
							(this.isOriginLeft = s.originSide == "left"),
							(this.cells = []),
							(this.outerWidth = 0),
							(this.height = 0));
					}
					var r = n.prototype;
					return (
						(r.addCell = function (s) {
							if (
								(this.cells.push(s),
								(this.outerWidth += s.size.outerWidth),
								(this.height = Math.max(s.size.outerHeight, this.height)),
								this.cells.length == 1)
							) {
								this.x = s.x;
								var u = this.isOriginLeft ? "marginLeft" : "marginRight";
								this.firstMargin = s.size[u];
							}
						}),
						(r.updateTarget = function () {
							var s = this.isOriginLeft ? "marginRight" : "marginLeft",
								u = this.getLastCell(),
								l = u ? u.size[s] : 0,
								h = this.outerWidth - (this.firstMargin + l);
							this.target =
								this.x + this.firstMargin + h * this.parent.cellAlign;
						}),
						(r.getLastCell = function () {
							return this.cells[this.cells.length - 1];
						}),
						(r.select = function () {
							this.cells.forEach(function (s) {
								s.select();
							});
						}),
						(r.unselect = function () {
							this.cells.forEach(function (s) {
								s.unselect();
							});
						}),
						(r.getCellElements = function () {
							return this.cells.map(function (s) {
								return s.element;
							});
						}),
						n
					);
				});
			})(Ul)),
		Ul.exports
	);
}
var $l = { exports: {} },
	rf;
function og() {
	return (
		rf ||
			((rf = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, Ks()))
						: ((e.Flickity = e.Flickity || {}),
							(e.Flickity.animatePrototype = n(e, e.fizzyUIUtils)));
				})(window, function (n, r) {
					var s = {};
					return (
						(s.startAnimation = function () {
							this.isAnimating ||
								((this.isAnimating = !0),
								(this.restingFrames = 0),
								this.animate());
						}),
						(s.animate = function () {
							(this.applyDragForce(), this.applySelectedAttraction());
							var u = this.x;
							if (
								(this.integratePhysics(),
								this.positionSlider(),
								this.settle(u),
								this.isAnimating)
							) {
								var l = this;
								requestAnimationFrame(function () {
									l.animate();
								});
							}
						}),
						(s.positionSlider = function () {
							var u = this.x;
							(this.options.wrapAround &&
								this.cells.length > 1 &&
								((u = r.modulo(u, this.slideableWidth)),
								(u -= this.slideableWidth),
								this.shiftWrapCells(u)),
								this.setTranslateX(u, this.isAnimating),
								this.dispatchScrollEvent());
						}),
						(s.setTranslateX = function (u, l) {
							((u += this.cursorPosition),
								(u = this.options.rightToLeft ? -u : u));
							var h = this.getPositionValue(u);
							this.slider.style.transform = l
								? "translate3d(" + h + ",0,0)"
								: "translateX(" + h + ")";
						}),
						(s.dispatchScrollEvent = function () {
							var u = this.slides[0];
							if (u) {
								var l = -this.x - u.target,
									h = l / this.slidesWidth;
								this.dispatchEvent("scroll", null, [h, l]);
							}
						}),
						(s.positionSliderAtSelected = function () {
							this.cells.length &&
								((this.x = -this.selectedSlide.target),
								(this.velocity = 0),
								this.positionSlider());
						}),
						(s.getPositionValue = function (u) {
							return this.options.percentPosition
								? Math.round((u / this.size.innerWidth) * 1e4) * 0.01 + "%"
								: Math.round(u) + "px";
						}),
						(s.settle = function (u) {
							var l =
								!this.isPointerDown &&
								Math.round(this.x * 100) == Math.round(u * 100);
							(l && this.restingFrames++,
								this.restingFrames > 2 &&
									((this.isAnimating = !1),
									delete this.isFreeScrolling,
									this.positionSlider(),
									this.dispatchEvent("settle", null, [this.selectedIndex])));
						}),
						(s.shiftWrapCells = function (u) {
							var l = this.cursorPosition + u;
							this._shiftCells(this.beforeShiftCells, l, -1);
							var h =
								this.size.innerWidth -
								(u + this.slideableWidth + this.cursorPosition);
							this._shiftCells(this.afterShiftCells, h, 1);
						}),
						(s._shiftCells = function (u, l, h) {
							for (var f = 0; f < u.length; f++) {
								var v = u[f],
									w = l > 0 ? h : 0;
								(v.wrapShift(w), (l -= v.size.outerWidth));
							}
						}),
						(s._unshiftCells = function (u) {
							if (!(!u || !u.length))
								for (var l = 0; l < u.length; l++) u[l].wrapShift(0);
						}),
						(s.integratePhysics = function () {
							((this.x += this.velocity),
								(this.velocity *= this.getFrictionFactor()));
						}),
						(s.applyForce = function (u) {
							this.velocity += u;
						}),
						(s.getFrictionFactor = function () {
							return (
								1 -
								this.options[
									this.isFreeScrolling ? "freeScrollFriction" : "friction"
								]
							);
						}),
						(s.getRestingPosition = function () {
							return this.x + this.velocity / (1 - this.getFrictionFactor());
						}),
						(s.applyDragForce = function () {
							if (!(!this.isDraggable || !this.isPointerDown)) {
								var u = this.dragX - this.x,
									l = u - this.velocity;
								this.applyForce(l);
							}
						}),
						(s.applySelectedAttraction = function () {
							var u = this.isDraggable && this.isPointerDown;
							if (!(u || this.isFreeScrolling || !this.slides.length)) {
								var l = this.selectedSlide.target * -1 - this.x,
									h = l * this.options.selectedAttraction;
								this.applyForce(h);
							}
						}),
						s
					);
				});
			})($l)),
		$l.exports
	);
}
var sf;
function Do() {
	return (
		sf ||
			((sf = 1),
			(function (p) {
				(function (e, n) {
					if (p.exports) p.exports = n(e, sl(), jd(), Ks(), rg(), sg(), og());
					else {
						var r = e.Flickity;
						e.Flickity = n(
							e,
							e.EvEmitter,
							e.getSize,
							e.fizzyUIUtils,
							r.Cell,
							r.Slide,
							r.animatePrototype,
						);
					}
				})(window, function (n, r, s, u, l, h, f) {
					var v = n.jQuery,
						w = n.getComputedStyle,
						A = n.console;
					function D(B, j) {
						for (B = u.makeArray(B); B.length; ) j.appendChild(B.shift());
					}
					var C = 0,
						O = {};
					function P(B, j) {
						var V = u.getQueryElement(B);
						if (!V) {
							A && A.error("Bad element for Flickity: " + (V || B));
							return;
						}
						if (((this.element = V), this.element.flickityGUID)) {
							var Q = O[this.element.flickityGUID];
							return (Q && Q.option(j), Q);
						}
						(v && (this.$element = v(this.element)),
							(this.options = u.extend({}, this.constructor.defaults)),
							this.option(j),
							this._create());
					}
					((P.defaults = {
						accessibility: !0,
						cellAlign: "center",
						freeScrollFriction: 0.075,
						friction: 0.28,
						namespaceJQueryEvents: !0,
						percentPosition: !0,
						resize: !0,
						selectedAttraction: 0.025,
						setGallerySize: !0,
					}),
						(P.createMethods = []));
					var F = P.prototype;
					(u.extend(F, r.prototype),
						(F._create = function () {
							var B = (this.guid = ++C);
							((this.element.flickityGUID = B),
								(O[B] = this),
								(this.selectedIndex = 0),
								(this.restingFrames = 0),
								(this.x = 0),
								(this.velocity = 0),
								(this.originSide = this.options.rightToLeft ? "right" : "left"),
								(this.viewport = document.createElement("div")),
								(this.viewport.className = "flickity-viewport"),
								this._createSlider(),
								(this.options.resize || this.options.watchCSS) &&
									n.addEventListener("resize", this));
							for (var j in this.options.on) {
								var V = this.options.on[j];
								this.on(j, V);
							}
							(P.createMethods.forEach(function (Q) {
								this[Q]();
							}, this),
								this.options.watchCSS ? this.watchCSS() : this.activate());
						}),
						(F.option = function (B) {
							u.extend(this.options, B);
						}),
						(F.activate = function () {
							if (!this.isActive) {
								((this.isActive = !0),
									this.element.classList.add("flickity-enabled"),
									this.options.rightToLeft &&
										this.element.classList.add("flickity-rtl"),
									this.getSize());
								var B = this._filterFindCellElements(this.element.children);
								(D(B, this.slider),
									this.viewport.appendChild(this.slider),
									this.element.appendChild(this.viewport),
									this.reloadCells(),
									this.options.accessibility &&
										((this.element.tabIndex = 0),
										this.element.addEventListener("keydown", this)),
									this.emitEvent("activate"),
									this.selectInitialIndex(),
									(this.isInitActivated = !0),
									this.dispatchEvent("ready"));
							}
						}),
						(F._createSlider = function () {
							var B = document.createElement("div");
							((B.className = "flickity-slider"),
								(B.style[this.originSide] = 0),
								(this.slider = B));
						}),
						(F._filterFindCellElements = function (B) {
							return u.filterFindElements(B, this.options.cellSelector);
						}),
						(F.reloadCells = function () {
							((this.cells = this._makeCells(this.slider.children)),
								this.positionCells(),
								this._getWrapShiftCells(),
								this.setGallerySize());
						}),
						(F._makeCells = function (B) {
							var j = this._filterFindCellElements(B),
								V = j.map(function (Q) {
									return new l(Q, this);
								}, this);
							return V;
						}),
						(F.getLastCell = function () {
							return this.cells[this.cells.length - 1];
						}),
						(F.getLastSlide = function () {
							return this.slides[this.slides.length - 1];
						}),
						(F.positionCells = function () {
							(this._sizeCells(this.cells), this._positionCells(0));
						}),
						(F._positionCells = function (B) {
							((B = B || 0),
								(this.maxCellHeight = (B && this.maxCellHeight) || 0));
							var j = 0;
							if (B > 0) {
								var V = this.cells[B - 1];
								j = V.x + V.size.outerWidth;
							}
							for (var Q = this.cells.length, it = B; it < Q; it++) {
								var g = this.cells[it];
								(g.setPosition(j),
									(j += g.size.outerWidth),
									(this.maxCellHeight = Math.max(
										g.size.outerHeight,
										this.maxCellHeight,
									)));
							}
							((this.slideableWidth = j),
								this.updateSlides(),
								this._containSlides(),
								(this.slidesWidth = Q
									? this.getLastSlide().target - this.slides[0].target
									: 0));
						}),
						(F._sizeCells = function (B) {
							B.forEach(function (j) {
								j.getSize();
							});
						}),
						(F.updateSlides = function () {
							if (((this.slides = []), !!this.cells.length)) {
								var B = new h(this);
								this.slides.push(B);
								var j = this.originSide == "left",
									V = j ? "marginRight" : "marginLeft",
									Q = this._getCanCellFit();
								(this.cells.forEach(function (it, g) {
									if (!B.cells.length) {
										B.addCell(it);
										return;
									}
									var ct =
										B.outerWidth -
										B.firstMargin +
										(it.size.outerWidth - it.size[V]);
									(Q.call(this, g, ct) ||
										(B.updateTarget(), (B = new h(this)), this.slides.push(B)),
										B.addCell(it));
								}, this),
									B.updateTarget(),
									this.updateSelectedSlide());
							}
						}),
						(F._getCanCellFit = function () {
							var B = this.options.groupCells;
							if (B) {
								if (typeof B == "number") {
									var j = parseInt(B, 10);
									return function (it) {
										return it % j !== 0;
									};
								}
							} else
								return function () {
									return !1;
								};
							var V = typeof B == "string" && B.match(/^(\d+)%$/),
								Q = V ? parseInt(V[1], 10) / 100 : 1;
							return function (it, g) {
								return g <= (this.size.innerWidth + 1) * Q;
							};
						}),
						(F._init = F.reposition =
							function () {
								(this.positionCells(), this.positionSliderAtSelected());
							}),
						(F.getSize = function () {
							((this.size = s(this.element)),
								this.setCellAlign(),
								(this.cursorPosition = this.size.innerWidth * this.cellAlign));
						}));
					var G = {
						center: { left: 0.5, right: 0.5 },
						left: { left: 0, right: 1 },
						right: { right: 0, left: 1 },
					};
					return (
						(F.setCellAlign = function () {
							var B = G[this.options.cellAlign];
							this.cellAlign = B ? B[this.originSide] : this.options.cellAlign;
						}),
						(F.setGallerySize = function () {
							if (this.options.setGallerySize) {
								var B =
									this.options.adaptiveHeight && this.selectedSlide
										? this.selectedSlide.height
										: this.maxCellHeight;
								this.viewport.style.height = B + "px";
							}
						}),
						(F._getWrapShiftCells = function () {
							if (this.options.wrapAround) {
								(this._unshiftCells(this.beforeShiftCells),
									this._unshiftCells(this.afterShiftCells));
								var B = this.cursorPosition,
									j = this.cells.length - 1;
								((this.beforeShiftCells = this._getGapCells(B, j, -1)),
									(B = this.size.innerWidth - this.cursorPosition),
									(this.afterShiftCells = this._getGapCells(B, 0, 1)));
							}
						}),
						(F._getGapCells = function (B, j, V) {
							for (var Q = []; B > 0; ) {
								var it = this.cells[j];
								if (!it) break;
								(Q.push(it), (j += V), (B -= it.size.outerWidth));
							}
							return Q;
						}),
						(F._containSlides = function () {
							if (
								!(
									!this.options.contain ||
									this.options.wrapAround ||
									!this.cells.length
								)
							) {
								var B = this.options.rightToLeft,
									j = B ? "marginRight" : "marginLeft",
									V = B ? "marginLeft" : "marginRight",
									Q = this.slideableWidth - this.getLastCell().size[V],
									it = Q < this.size.innerWidth,
									g = this.cursorPosition + this.cells[0].size[j],
									ct = Q - this.size.innerWidth * (1 - this.cellAlign);
								this.slides.forEach(function (ot) {
									it
										? (ot.target = Q * this.cellAlign)
										: ((ot.target = Math.max(ot.target, g)),
											(ot.target = Math.min(ot.target, ct)));
								}, this);
							}
						}),
						(F.dispatchEvent = function (B, j, V) {
							var Q = j ? [j].concat(V) : V;
							if ((this.emitEvent(B, Q), v && this.$element)) {
								B += this.options.namespaceJQueryEvents ? ".flickity" : "";
								var it = B;
								if (j) {
									var g = new v.Event(j);
									((g.type = B), (it = g));
								}
								this.$element.trigger(it, V);
							}
						}),
						(F.select = function (B, j, V) {
							if (
								this.isActive &&
								((B = parseInt(B, 10)),
								this._wrapSelect(B),
								(this.options.wrapAround || j) &&
									(B = u.modulo(B, this.slides.length)),
								!!this.slides[B])
							) {
								var Q = this.selectedIndex;
								((this.selectedIndex = B),
									this.updateSelectedSlide(),
									V ? this.positionSliderAtSelected() : this.startAnimation(),
									this.options.adaptiveHeight && this.setGallerySize(),
									this.dispatchEvent("select", null, [B]),
									B != Q && this.dispatchEvent("change", null, [B]),
									this.dispatchEvent("cellSelect"));
							}
						}),
						(F._wrapSelect = function (B) {
							var j = this.slides.length,
								V = this.options.wrapAround && j > 1;
							if (!V) return B;
							var Q = u.modulo(B, j),
								it = Math.abs(Q - this.selectedIndex),
								g = Math.abs(Q + j - this.selectedIndex),
								ct = Math.abs(Q - j - this.selectedIndex);
							(!this.isDragSelect && g < it
								? (B += j)
								: !this.isDragSelect && ct < it && (B -= j),
								B < 0
									? (this.x -= this.slideableWidth)
									: B >= j && (this.x += this.slideableWidth));
						}),
						(F.previous = function (B, j) {
							this.select(this.selectedIndex - 1, B, j);
						}),
						(F.next = function (B, j) {
							this.select(this.selectedIndex + 1, B, j);
						}),
						(F.updateSelectedSlide = function () {
							var B = this.slides[this.selectedIndex];
							B &&
								(this.unselectSelectedSlide(),
								(this.selectedSlide = B),
								B.select(),
								(this.selectedCells = B.cells),
								(this.selectedElements = B.getCellElements()),
								(this.selectedCell = B.cells[0]),
								(this.selectedElement = this.selectedElements[0]));
						}),
						(F.unselectSelectedSlide = function () {
							this.selectedSlide && this.selectedSlide.unselect();
						}),
						(F.selectInitialIndex = function () {
							var B = this.options.initialIndex;
							if (this.isInitActivated) {
								this.select(this.selectedIndex, !1, !0);
								return;
							}
							if (B && typeof B == "string") {
								var j = this.queryCell(B);
								if (j) {
									this.selectCell(B, !1, !0);
									return;
								}
							}
							var V = 0;
							(B && this.slides[B] && (V = B), this.select(V, !1, !0));
						}),
						(F.selectCell = function (B, j, V) {
							var Q = this.queryCell(B);
							if (Q) {
								var it = this.getCellSlideIndex(Q);
								this.select(it, j, V);
							}
						}),
						(F.getCellSlideIndex = function (B) {
							for (var j = 0; j < this.slides.length; j++) {
								var V = this.slides[j],
									Q = V.cells.indexOf(B);
								if (Q != -1) return j;
							}
						}),
						(F.getCell = function (B) {
							for (var j = 0; j < this.cells.length; j++) {
								var V = this.cells[j];
								if (V.element == B) return V;
							}
						}),
						(F.getCells = function (B) {
							B = u.makeArray(B);
							var j = [];
							return (
								B.forEach(function (V) {
									var Q = this.getCell(V);
									Q && j.push(Q);
								}, this),
								j
							);
						}),
						(F.getCellElements = function () {
							return this.cells.map(function (B) {
								return B.element;
							});
						}),
						(F.getParentCell = function (B) {
							var j = this.getCell(B);
							return (
								j ||
								((B = u.getParent(B, ".flickity-slider > *")), this.getCell(B))
							);
						}),
						(F.getAdjacentCellElements = function (B, j) {
							if (!B) return this.selectedSlide.getCellElements();
							j = j === void 0 ? this.selectedIndex : j;
							var V = this.slides.length;
							if (1 + B * 2 >= V) return this.getCellElements();
							for (var Q = [], it = j - B; it <= j + B; it++) {
								var g = this.options.wrapAround ? u.modulo(it, V) : it,
									ct = this.slides[g];
								ct && (Q = Q.concat(ct.getCellElements()));
							}
							return Q;
						}),
						(F.queryCell = function (B) {
							if (typeof B == "number") return this.cells[B];
							if (typeof B == "string") {
								if (B.match(/^[#.]?[\d/]/)) return;
								B = this.element.querySelector(B);
							}
							return this.getCell(B);
						}),
						(F.uiChange = function () {
							this.emitEvent("uiChange");
						}),
						(F.childUIPointerDown = function (B) {
							(B.type != "touchstart" && B.preventDefault(), this.focus());
						}),
						(F.onresize = function () {
							(this.watchCSS(), this.resize());
						}),
						u.debounceMethod(P, "onresize", 150),
						(F.resize = function () {
							if (!(!this.isActive || this.isAnimating || this.isDragging)) {
								(this.getSize(),
									this.options.wrapAround &&
										(this.x = u.modulo(this.x, this.slideableWidth)),
									this.positionCells(),
									this._getWrapShiftCells(),
									this.setGallerySize(),
									this.emitEvent("resize"));
								var B = this.selectedElements && this.selectedElements[0];
								this.selectCell(B, !1, !0);
							}
						}),
						(F.watchCSS = function () {
							var B = this.options.watchCSS;
							if (B) {
								var j = w(this.element, ":after").content;
								j.indexOf("flickity") != -1
									? this.activate()
									: this.deactivate();
							}
						}),
						(F.onkeydown = function (B) {
							var j =
								document.activeElement &&
								document.activeElement != this.element;
							if (!(!this.options.accessibility || j)) {
								var V = P.keyboardHandlers[B.keyCode];
								V && V.call(this);
							}
						}),
						(P.keyboardHandlers = {
							37: function () {
								var B = this.options.rightToLeft ? "next" : "previous";
								(this.uiChange(), this[B]());
							},
							39: function () {
								var B = this.options.rightToLeft ? "previous" : "next";
								(this.uiChange(), this[B]());
							},
						}),
						(F.focus = function () {
							var B = n.pageYOffset;
							(this.element.focus({ preventScroll: !0 }),
								n.pageYOffset != B && n.scrollTo(n.pageXOffset, B));
						}),
						(F.deactivate = function () {
							this.isActive &&
								(this.element.classList.remove("flickity-enabled"),
								this.element.classList.remove("flickity-rtl"),
								this.unselectSelectedSlide(),
								this.cells.forEach(function (B) {
									B.destroy();
								}),
								this.element.removeChild(this.viewport),
								D(this.slider.children, this.element),
								this.options.accessibility &&
									(this.element.removeAttribute("tabIndex"),
									this.element.removeEventListener("keydown", this)),
								(this.isActive = !1),
								this.emitEvent("deactivate"));
						}),
						(F.destroy = function () {
							(this.deactivate(),
								n.removeEventListener("resize", this),
								this.allOff(),
								this.emitEvent("destroy"),
								v && this.$element && v.removeData(this.element, "flickity"),
								delete this.element.flickityGUID,
								delete O[this.guid]);
						}),
						u.extend(F, f),
						(P.data = function (B) {
							B = u.getQueryElement(B);
							var j = B && B.flickityGUID;
							return j && O[j];
						}),
						u.htmlInit(P, "flickity"),
						v && v.bridget && v.bridget("flickity", P),
						(P.setJQuery = function (B) {
							v = B;
						}),
						(P.Cell = l),
						(P.Slide = h),
						P
					);
				});
			})(Fl)),
		Fl.exports
	);
}
var Vl = { exports: {} },
	Gl = { exports: {} },
	Xl = { exports: {} };
/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */ var of;
function eh() {
	return (
		of ||
			((of = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, sl()))
						: (e.Unipointer = n(e, e.EvEmitter));
				})(window, function (n, r) {
					function s() {}
					function u() {}
					var l = (u.prototype = Object.create(r.prototype));
					((l.bindStartEvent = function (f) {
						this._bindStartEvent(f, !0);
					}),
						(l.unbindStartEvent = function (f) {
							this._bindStartEvent(f, !1);
						}),
						(l._bindStartEvent = function (f, v) {
							v = v === void 0 ? !0 : v;
							var w = v ? "addEventListener" : "removeEventListener",
								A = "mousedown";
							("ontouchstart" in n
								? (A = "touchstart")
								: n.PointerEvent && (A = "pointerdown"),
								f[w](A, this));
						}),
						(l.handleEvent = function (f) {
							var v = "on" + f.type;
							this[v] && this[v](f);
						}),
						(l.getTouch = function (f) {
							for (var v = 0; v < f.length; v++) {
								var w = f[v];
								if (w.identifier == this.pointerIdentifier) return w;
							}
						}),
						(l.onmousedown = function (f) {
							var v = f.button;
							(v && v !== 0 && v !== 1) || this._pointerDown(f, f);
						}),
						(l.ontouchstart = function (f) {
							this._pointerDown(f, f.changedTouches[0]);
						}),
						(l.onpointerdown = function (f) {
							this._pointerDown(f, f);
						}),
						(l._pointerDown = function (f, v) {
							f.button ||
								this.isPointerDown ||
								((this.isPointerDown = !0),
								(this.pointerIdentifier =
									v.pointerId !== void 0 ? v.pointerId : v.identifier),
								this.pointerDown(f, v));
						}),
						(l.pointerDown = function (f, v) {
							(this._bindPostStartEvents(f),
								this.emitEvent("pointerDown", [f, v]));
						}));
					var h = {
						mousedown: ["mousemove", "mouseup"],
						touchstart: ["touchmove", "touchend", "touchcancel"],
						pointerdown: ["pointermove", "pointerup", "pointercancel"],
					};
					return (
						(l._bindPostStartEvents = function (f) {
							if (f) {
								var v = h[f.type];
								(v.forEach(function (w) {
									n.addEventListener(w, this);
								}, this),
									(this._boundPointerEvents = v));
							}
						}),
						(l._unbindPostStartEvents = function () {
							this._boundPointerEvents &&
								(this._boundPointerEvents.forEach(function (f) {
									n.removeEventListener(f, this);
								}, this),
								delete this._boundPointerEvents);
						}),
						(l.onmousemove = function (f) {
							this._pointerMove(f, f);
						}),
						(l.onpointermove = function (f) {
							f.pointerId == this.pointerIdentifier && this._pointerMove(f, f);
						}),
						(l.ontouchmove = function (f) {
							var v = this.getTouch(f.changedTouches);
							v && this._pointerMove(f, v);
						}),
						(l._pointerMove = function (f, v) {
							this.pointerMove(f, v);
						}),
						(l.pointerMove = function (f, v) {
							this.emitEvent("pointerMove", [f, v]);
						}),
						(l.onmouseup = function (f) {
							this._pointerUp(f, f);
						}),
						(l.onpointerup = function (f) {
							f.pointerId == this.pointerIdentifier && this._pointerUp(f, f);
						}),
						(l.ontouchend = function (f) {
							var v = this.getTouch(f.changedTouches);
							v && this._pointerUp(f, v);
						}),
						(l._pointerUp = function (f, v) {
							(this._pointerDone(), this.pointerUp(f, v));
						}),
						(l.pointerUp = function (f, v) {
							this.emitEvent("pointerUp", [f, v]);
						}),
						(l._pointerDone = function () {
							(this._pointerReset(),
								this._unbindPostStartEvents(),
								this.pointerDone());
						}),
						(l._pointerReset = function () {
							((this.isPointerDown = !1), delete this.pointerIdentifier);
						}),
						(l.pointerDone = s),
						(l.onpointercancel = function (f) {
							f.pointerId == this.pointerIdentifier &&
								this._pointerCancel(f, f);
						}),
						(l.ontouchcancel = function (f) {
							var v = this.getTouch(f.changedTouches);
							v && this._pointerCancel(f, v);
						}),
						(l._pointerCancel = function (f, v) {
							(this._pointerDone(), this.pointerCancel(f, v));
						}),
						(l.pointerCancel = function (f, v) {
							this.emitEvent("pointerCancel", [f, v]);
						}),
						(u.getPointerPoint = function (f) {
							return { x: f.pageX, y: f.pageY };
						}),
						u
					);
				});
			})(Xl)),
		Xl.exports
	);
}
/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */ var af;
function ag() {
	return (
		af ||
			((af = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, eh()))
						: (e.Unidragger = n(e, e.Unipointer));
				})(window, function (n, r) {
					function s() {}
					var u = (s.prototype = Object.create(r.prototype));
					((u.bindHandles = function () {
						this._bindHandles(!0);
					}),
						(u.unbindHandles = function () {
							this._bindHandles(!1);
						}),
						(u._bindHandles = function (f) {
							f = f === void 0 ? !0 : f;
							for (
								var v = f ? "addEventListener" : "removeEventListener",
									w = f ? this._touchActionValue : "",
									A = 0;
								A < this.handles.length;
								A++
							) {
								var D = this.handles[A];
								(this._bindStartEvent(D, f),
									D[v]("click", this),
									n.PointerEvent && (D.style.touchAction = w));
							}
						}),
						(u._touchActionValue = "none"),
						(u.pointerDown = function (f, v) {
							var w = this.okayPointerDown(f);
							w &&
								((this.pointerDownPointer = { pageX: v.pageX, pageY: v.pageY }),
								f.preventDefault(),
								this.pointerDownBlur(),
								this._bindPostStartEvents(f),
								this.emitEvent("pointerDown", [f, v]));
						}));
					var l = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
						h = {
							radio: !0,
							checkbox: !0,
							button: !0,
							submit: !0,
							image: !0,
							file: !0,
						};
					return (
						(u.okayPointerDown = function (f) {
							var v = l[f.target.nodeName],
								w = h[f.target.type],
								A = !v || w;
							return (A || this._pointerReset(), A);
						}),
						(u.pointerDownBlur = function () {
							var f = document.activeElement,
								v = f && f.blur && f != document.body;
							v && f.blur();
						}),
						(u.pointerMove = function (f, v) {
							var w = this._dragPointerMove(f, v);
							(this.emitEvent("pointerMove", [f, v, w]),
								this._dragMove(f, v, w));
						}),
						(u._dragPointerMove = function (f, v) {
							var w = {
								x: v.pageX - this.pointerDownPointer.pageX,
								y: v.pageY - this.pointerDownPointer.pageY,
							};
							return (
								!this.isDragging &&
									this.hasDragStarted(w) &&
									this._dragStart(f, v),
								w
							);
						}),
						(u.hasDragStarted = function (f) {
							return Math.abs(f.x) > 3 || Math.abs(f.y) > 3;
						}),
						(u.pointerUp = function (f, v) {
							(this.emitEvent("pointerUp", [f, v]), this._dragPointerUp(f, v));
						}),
						(u._dragPointerUp = function (f, v) {
							this.isDragging ? this._dragEnd(f, v) : this._staticClick(f, v);
						}),
						(u._dragStart = function (f, v) {
							((this.isDragging = !0),
								(this.isPreventingClicks = !0),
								this.dragStart(f, v));
						}),
						(u.dragStart = function (f, v) {
							this.emitEvent("dragStart", [f, v]);
						}),
						(u._dragMove = function (f, v, w) {
							this.isDragging && this.dragMove(f, v, w);
						}),
						(u.dragMove = function (f, v, w) {
							(f.preventDefault(), this.emitEvent("dragMove", [f, v, w]));
						}),
						(u._dragEnd = function (f, v) {
							((this.isDragging = !1),
								setTimeout(
									function () {
										delete this.isPreventingClicks;
									}.bind(this),
								),
								this.dragEnd(f, v));
						}),
						(u.dragEnd = function (f, v) {
							this.emitEvent("dragEnd", [f, v]);
						}),
						(u.onclick = function (f) {
							this.isPreventingClicks && f.preventDefault();
						}),
						(u._staticClick = function (f, v) {
							(this.isIgnoringMouseUp && f.type == "mouseup") ||
								(this.staticClick(f, v),
								f.type != "mouseup" &&
									((this.isIgnoringMouseUp = !0),
									setTimeout(
										function () {
											delete this.isIgnoringMouseUp;
										}.bind(this),
										400,
									)));
						}),
						(u.staticClick = function (f, v) {
							this.emitEvent("staticClick", [f, v]);
						}),
						(s.getPointerPoint = r.getPointerPoint),
						s
					);
				});
			})(Gl)),
		Gl.exports
	);
}
var uf;
function ug() {
	return (
		uf ||
			((uf = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, Do(), ag(), Ks()))
						: (e.Flickity = n(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
				})(window, function (n, r, s, u) {
					(u.extend(r.defaults, { draggable: ">1", dragThreshold: 3 }),
						r.createMethods.push("_createDrag"));
					var l = r.prototype;
					(u.extend(l, s.prototype),
						(l._touchActionValue = "pan-y"),
						(l._createDrag = function () {
							(this.on("activate", this.onActivateDrag),
								this.on("uiChange", this._uiChangeDrag),
								this.on("deactivate", this.onDeactivateDrag),
								this.on("cellChange", this.updateDraggable));
						}),
						(l.onActivateDrag = function () {
							((this.handles = [this.viewport]),
								this.bindHandles(),
								this.updateDraggable());
						}),
						(l.onDeactivateDrag = function () {
							(this.unbindHandles(),
								this.element.classList.remove("is-draggable"));
						}),
						(l.updateDraggable = function () {
							(this.options.draggable == ">1"
								? (this.isDraggable = this.slides.length > 1)
								: (this.isDraggable = this.options.draggable),
								this.isDraggable
									? this.element.classList.add("is-draggable")
									: this.element.classList.remove("is-draggable"));
						}),
						(l.bindDrag = function () {
							((this.options.draggable = !0), this.updateDraggable());
						}),
						(l.unbindDrag = function () {
							((this.options.draggable = !1), this.updateDraggable());
						}),
						(l._uiChangeDrag = function () {
							delete this.isFreeScrolling;
						}),
						(l.pointerDown = function (v, w) {
							if (!this.isDraggable) {
								this._pointerDownDefault(v, w);
								return;
							}
							var A = this.okayPointerDown(v);
							A &&
								(this._pointerDownPreventDefault(v),
								this.pointerDownFocus(v),
								document.activeElement != this.element &&
									this.pointerDownBlur(),
								(this.dragX = this.x),
								this.viewport.classList.add("is-pointer-down"),
								(this.pointerDownScroll = f()),
								n.addEventListener("scroll", this),
								this._pointerDownDefault(v, w));
						}),
						(l._pointerDownDefault = function (v, w) {
							((this.pointerDownPointer = { pageX: w.pageX, pageY: w.pageY }),
								this._bindPostStartEvents(v),
								this.dispatchEvent("pointerDown", v, [w]));
						}));
					var h = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
					((l.pointerDownFocus = function (v) {
						var w = h[v.target.nodeName];
						w || this.focus();
					}),
						(l._pointerDownPreventDefault = function (v) {
							var w = v.type == "touchstart",
								A = v.pointerType == "touch",
								D = h[v.target.nodeName];
							!w && !A && !D && v.preventDefault();
						}),
						(l.hasDragStarted = function (v) {
							return Math.abs(v.x) > this.options.dragThreshold;
						}),
						(l.pointerUp = function (v, w) {
							(delete this.isTouchScrolling,
								this.viewport.classList.remove("is-pointer-down"),
								this.dispatchEvent("pointerUp", v, [w]),
								this._dragPointerUp(v, w));
						}),
						(l.pointerDone = function () {
							(n.removeEventListener("scroll", this),
								delete this.pointerDownScroll);
						}),
						(l.dragStart = function (v, w) {
							this.isDraggable &&
								((this.dragStartPosition = this.x),
								this.startAnimation(),
								n.removeEventListener("scroll", this),
								this.dispatchEvent("dragStart", v, [w]));
						}),
						(l.pointerMove = function (v, w) {
							var A = this._dragPointerMove(v, w);
							(this.dispatchEvent("pointerMove", v, [w, A]),
								this._dragMove(v, w, A));
						}),
						(l.dragMove = function (v, w, A) {
							if (this.isDraggable) {
								(v.preventDefault(), (this.previousDragX = this.dragX));
								var D = this.options.rightToLeft ? -1 : 1;
								this.options.wrapAround && (A.x %= this.slideableWidth);
								var C = this.dragStartPosition + A.x * D;
								if (!this.options.wrapAround && this.slides.length) {
									var O = Math.max(
										-this.slides[0].target,
										this.dragStartPosition,
									);
									C = C > O ? (C + O) * 0.5 : C;
									var P = Math.min(
										-this.getLastSlide().target,
										this.dragStartPosition,
									);
									C = C < P ? (C + P) * 0.5 : C;
								}
								((this.dragX = C),
									(this.dragMoveTime = new Date()),
									this.dispatchEvent("dragMove", v, [w, A]));
							}
						}),
						(l.dragEnd = function (v, w) {
							if (this.isDraggable) {
								this.options.freeScroll && (this.isFreeScrolling = !0);
								var A = this.dragEndRestingSelect();
								if (this.options.freeScroll && !this.options.wrapAround) {
									var D = this.getRestingPosition();
									this.isFreeScrolling =
										-D > this.slides[0].target &&
										-D < this.getLastSlide().target;
								} else
									!this.options.freeScroll &&
										A == this.selectedIndex &&
										(A += this.dragEndBoostSelect());
								(delete this.previousDragX,
									(this.isDragSelect = this.options.wrapAround),
									this.select(A),
									delete this.isDragSelect,
									this.dispatchEvent("dragEnd", v, [w]));
							}
						}),
						(l.dragEndRestingSelect = function () {
							var v = this.getRestingPosition(),
								w = Math.abs(this.getSlideDistance(-v, this.selectedIndex)),
								A = this._getClosestResting(v, w, 1),
								D = this._getClosestResting(v, w, -1),
								C = A.distance < D.distance ? A.index : D.index;
							return C;
						}),
						(l._getClosestResting = function (v, w, A) {
							for (
								var D = this.selectedIndex,
									C = 1 / 0,
									O =
										this.options.contain && !this.options.wrapAround
											? function (P, F) {
													return P <= F;
												}
											: function (P, F) {
													return P < F;
												};
								O(w, C) &&
								((D += A),
								(C = w),
								(w = this.getSlideDistance(-v, D)),
								w !== null);
							)
								w = Math.abs(w);
							return { distance: C, index: D - A };
						}),
						(l.getSlideDistance = function (v, w) {
							var A = this.slides.length,
								D = this.options.wrapAround && A > 1,
								C = D ? u.modulo(w, A) : w,
								O = this.slides[C];
							if (!O) return null;
							var P = D ? this.slideableWidth * Math.floor(w / A) : 0;
							return v - (O.target + P);
						}),
						(l.dragEndBoostSelect = function () {
							if (
								this.previousDragX === void 0 ||
								!this.dragMoveTime ||
								new Date() - this.dragMoveTime > 100
							)
								return 0;
							var v = this.getSlideDistance(-this.dragX, this.selectedIndex),
								w = this.previousDragX - this.dragX;
							return v > 0 && w > 0 ? 1 : v < 0 && w < 0 ? -1 : 0;
						}),
						(l.staticClick = function (v, w) {
							var A = this.getParentCell(v.target),
								D = A && A.element,
								C = A && this.cells.indexOf(A);
							this.dispatchEvent("staticClick", v, [w, D, C]);
						}),
						(l.onscroll = function () {
							var v = f(),
								w = this.pointerDownScroll.x - v.x,
								A = this.pointerDownScroll.y - v.y;
							(Math.abs(w) > 3 || Math.abs(A) > 3) && this._pointerDone();
						}));
					function f() {
						return { x: n.pageXOffset, y: n.pageYOffset };
					}
					return r;
				});
			})(Vl)),
		Vl.exports
	);
}
var Yl = { exports: {} },
	lf;
function lg() {
	return (
		lf ||
			((lf = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, Do(), eh(), Ks()))
						: n(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
				})(window, function (n, r, s, u) {
					var l = "http://www.w3.org/2000/svg";
					function h(w, A) {
						((this.direction = w), (this.parent = A), this._create());
					}
					((h.prototype = Object.create(s.prototype)),
						(h.prototype._create = function () {
							((this.isEnabled = !0), (this.isPrevious = this.direction == -1));
							var w = this.parent.options.rightToLeft ? 1 : -1;
							this.isLeft = this.direction == w;
							var A = (this.element = document.createElement("button"));
							((A.className = "flickity-button flickity-prev-next-button"),
								(A.className += this.isPrevious ? " previous" : " next"),
								A.setAttribute("type", "button"),
								this.disable(),
								A.setAttribute(
									"aria-label",
									this.isPrevious ? "Previous" : "Next",
								));
							var D = this.createSVG();
							(A.appendChild(D),
								this.parent.on("select", this.update.bind(this)),
								this.on(
									"pointerDown",
									this.parent.childUIPointerDown.bind(this.parent),
								));
						}),
						(h.prototype.activate = function () {
							(this.bindStartEvent(this.element),
								this.element.addEventListener("click", this),
								this.parent.element.appendChild(this.element));
						}),
						(h.prototype.deactivate = function () {
							(this.parent.element.removeChild(this.element),
								this.unbindStartEvent(this.element),
								this.element.removeEventListener("click", this));
						}),
						(h.prototype.createSVG = function () {
							var w = document.createElementNS(l, "svg");
							(w.setAttribute("class", "flickity-button-icon"),
								w.setAttribute("viewBox", "0 0 100 100"));
							var A = document.createElementNS(l, "path"),
								D = f(this.parent.options.arrowShape);
							return (
								A.setAttribute("d", D),
								A.setAttribute("class", "arrow"),
								this.isLeft ||
									A.setAttribute(
										"transform",
										"translate(100, 100) rotate(180) ",
									),
								w.appendChild(A),
								w
							);
						}));
					function f(w) {
						return typeof w == "string"
							? w
							: "M " +
									w.x0 +
									",50 L " +
									w.x1 +
									"," +
									(w.y1 + 50) +
									" L " +
									w.x2 +
									"," +
									(w.y2 + 50) +
									" L " +
									w.x3 +
									",50  L " +
									w.x2 +
									"," +
									(50 - w.y2) +
									" L " +
									w.x1 +
									"," +
									(50 - w.y1) +
									" Z";
					}
					((h.prototype.handleEvent = u.handleEvent),
						(h.prototype.onclick = function () {
							if (this.isEnabled) {
								this.parent.uiChange();
								var w = this.isPrevious ? "previous" : "next";
								this.parent[w]();
							}
						}),
						(h.prototype.enable = function () {
							this.isEnabled ||
								((this.element.disabled = !1), (this.isEnabled = !0));
						}),
						(h.prototype.disable = function () {
							this.isEnabled &&
								((this.element.disabled = !0), (this.isEnabled = !1));
						}),
						(h.prototype.update = function () {
							var w = this.parent.slides;
							if (this.parent.options.wrapAround && w.length > 1) {
								this.enable();
								return;
							}
							var A = w.length ? w.length - 1 : 0,
								D = this.isPrevious ? 0 : A,
								C = this.parent.selectedIndex == D ? "disable" : "enable";
							this[C]();
						}),
						(h.prototype.destroy = function () {
							(this.deactivate(), this.allOff());
						}),
						u.extend(r.defaults, {
							prevNextButtons: !0,
							arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
						}),
						r.createMethods.push("_createPrevNextButtons"));
					var v = r.prototype;
					return (
						(v._createPrevNextButtons = function () {
							this.options.prevNextButtons &&
								((this.prevButton = new h(-1, this)),
								(this.nextButton = new h(1, this)),
								this.on("activate", this.activatePrevNextButtons));
						}),
						(v.activatePrevNextButtons = function () {
							(this.prevButton.activate(),
								this.nextButton.activate(),
								this.on("deactivate", this.deactivatePrevNextButtons));
						}),
						(v.deactivatePrevNextButtons = function () {
							(this.prevButton.deactivate(),
								this.nextButton.deactivate(),
								this.off("deactivate", this.deactivatePrevNextButtons));
						}),
						(r.PrevNextButton = h),
						r
					);
				});
			})(Yl)),
		Yl.exports
	);
}
var Kl = { exports: {} },
	cf;
function cg() {
	return (
		cf ||
			((cf = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, Do(), eh(), Ks()))
						: n(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
				})(window, function (n, r, s, u) {
					function l(f) {
						((this.parent = f), this._create());
					}
					((l.prototype = Object.create(s.prototype)),
						(l.prototype._create = function () {
							((this.holder = document.createElement("ol")),
								(this.holder.className = "flickity-page-dots"),
								(this.dots = []),
								(this.handleClick = this.onClick.bind(this)),
								this.on(
									"pointerDown",
									this.parent.childUIPointerDown.bind(this.parent),
								));
						}),
						(l.prototype.activate = function () {
							(this.setDots(),
								this.holder.addEventListener("click", this.handleClick),
								this.bindStartEvent(this.holder),
								this.parent.element.appendChild(this.holder));
						}),
						(l.prototype.deactivate = function () {
							(this.holder.removeEventListener("click", this.handleClick),
								this.unbindStartEvent(this.holder),
								this.parent.element.removeChild(this.holder));
						}),
						(l.prototype.setDots = function () {
							var f = this.parent.slides.length - this.dots.length;
							f > 0 ? this.addDots(f) : f < 0 && this.removeDots(-f);
						}),
						(l.prototype.addDots = function (f) {
							for (
								var v = document.createDocumentFragment(),
									w = [],
									A = this.dots.length,
									D = A + f,
									C = A;
								C < D;
								C++
							) {
								var O = document.createElement("li");
								((O.className = "dot"),
									O.setAttribute("aria-label", "Page dot " + (C + 1)),
									v.appendChild(O),
									w.push(O));
							}
							(this.holder.appendChild(v), (this.dots = this.dots.concat(w)));
						}),
						(l.prototype.removeDots = function (f) {
							var v = this.dots.splice(this.dots.length - f, f);
							v.forEach(function (w) {
								this.holder.removeChild(w);
							}, this);
						}),
						(l.prototype.updateSelected = function () {
							(this.selectedDot &&
								((this.selectedDot.className = "dot"),
								this.selectedDot.removeAttribute("aria-current")),
								this.dots.length &&
									((this.selectedDot = this.dots[this.parent.selectedIndex]),
									(this.selectedDot.className = "dot is-selected"),
									this.selectedDot.setAttribute("aria-current", "step")));
						}),
						(l.prototype.onTap = l.prototype.onClick =
							function (f) {
								var v = f.target;
								if (v.nodeName == "LI") {
									this.parent.uiChange();
									var w = this.dots.indexOf(v);
									this.parent.select(w);
								}
							}),
						(l.prototype.destroy = function () {
							(this.deactivate(), this.allOff());
						}),
						(r.PageDots = l),
						u.extend(r.defaults, { pageDots: !0 }),
						r.createMethods.push("_createPageDots"));
					var h = r.prototype;
					return (
						(h._createPageDots = function () {
							this.options.pageDots &&
								((this.pageDots = new l(this)),
								this.on("activate", this.activatePageDots),
								this.on("select", this.updateSelectedPageDots),
								this.on("cellChange", this.updatePageDots),
								this.on("resize", this.updatePageDots),
								this.on("deactivate", this.deactivatePageDots));
						}),
						(h.activatePageDots = function () {
							this.pageDots.activate();
						}),
						(h.updateSelectedPageDots = function () {
							this.pageDots.updateSelected();
						}),
						(h.updatePageDots = function () {
							this.pageDots.setDots();
						}),
						(h.deactivatePageDots = function () {
							this.pageDots.deactivate();
						}),
						(r.PageDots = l),
						r
					);
				});
			})(Kl)),
		Kl.exports
	);
}
var Jl = { exports: {} },
	hf;
function hg() {
	return (
		hf ||
			((hf = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(sl(), Ks(), Do()))
						: n(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
				})(window, function (n, r, s) {
					function u(h) {
						((this.parent = h),
							(this.state = "stopped"),
							(this.onVisibilityChange = this.visibilityChange.bind(this)),
							(this.onVisibilityPlay = this.visibilityPlay.bind(this)));
					}
					((u.prototype = Object.create(n.prototype)),
						(u.prototype.play = function () {
							if (this.state != "playing") {
								var h = document.hidden;
								if (h) {
									document.addEventListener(
										"visibilitychange",
										this.onVisibilityPlay,
									);
									return;
								}
								((this.state = "playing"),
									document.addEventListener(
										"visibilitychange",
										this.onVisibilityChange,
									),
									this.tick());
							}
						}),
						(u.prototype.tick = function () {
							if (this.state == "playing") {
								var h = this.parent.options.autoPlay;
								h = typeof h == "number" ? h : 3e3;
								var f = this;
								(this.clear(),
									(this.timeout = setTimeout(function () {
										(f.parent.next(!0), f.tick());
									}, h)));
							}
						}),
						(u.prototype.stop = function () {
							((this.state = "stopped"),
								this.clear(),
								document.removeEventListener(
									"visibilitychange",
									this.onVisibilityChange,
								));
						}),
						(u.prototype.clear = function () {
							clearTimeout(this.timeout);
						}),
						(u.prototype.pause = function () {
							this.state == "playing" &&
								((this.state = "paused"), this.clear());
						}),
						(u.prototype.unpause = function () {
							this.state == "paused" && this.play();
						}),
						(u.prototype.visibilityChange = function () {
							var h = document.hidden;
							this[h ? "pause" : "unpause"]();
						}),
						(u.prototype.visibilityPlay = function () {
							(this.play(),
								document.removeEventListener(
									"visibilitychange",
									this.onVisibilityPlay,
								));
						}),
						r.extend(s.defaults, { pauseAutoPlayOnHover: !0 }),
						s.createMethods.push("_createPlayer"));
					var l = s.prototype;
					return (
						(l._createPlayer = function () {
							((this.player = new u(this)),
								this.on("activate", this.activatePlayer),
								this.on("uiChange", this.stopPlayer),
								this.on("pointerDown", this.stopPlayer),
								this.on("deactivate", this.deactivatePlayer));
						}),
						(l.activatePlayer = function () {
							this.options.autoPlay &&
								(this.player.play(),
								this.element.addEventListener("mouseenter", this));
						}),
						(l.playPlayer = function () {
							this.player.play();
						}),
						(l.stopPlayer = function () {
							this.player.stop();
						}),
						(l.pausePlayer = function () {
							this.player.pause();
						}),
						(l.unpausePlayer = function () {
							this.player.unpause();
						}),
						(l.deactivatePlayer = function () {
							(this.player.stop(),
								this.element.removeEventListener("mouseenter", this));
						}),
						(l.onmouseenter = function () {
							this.options.pauseAutoPlayOnHover &&
								(this.player.pause(),
								this.element.addEventListener("mouseleave", this));
						}),
						(l.onmouseleave = function () {
							(this.player.unpause(),
								this.element.removeEventListener("mouseleave", this));
						}),
						(s.Player = u),
						s
					);
				});
			})(Jl)),
		Jl.exports
	);
}
var Ql = { exports: {} },
	ff;
function fg() {
	return (
		ff ||
			((ff = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, Do(), Ks()))
						: n(e, e.Flickity, e.fizzyUIUtils);
				})(window, function (n, r, s) {
					function u(h) {
						var f = document.createDocumentFragment();
						return (
							h.forEach(function (v) {
								f.appendChild(v.element);
							}),
							f
						);
					}
					var l = r.prototype;
					return (
						(l.insert = function (h, f) {
							var v = this._makeCells(h);
							if (!(!v || !v.length)) {
								var w = this.cells.length;
								f = f === void 0 ? w : f;
								var A = u(v),
									D = f == w;
								if (D) this.slider.appendChild(A);
								else {
									var C = this.cells[f].element;
									this.slider.insertBefore(A, C);
								}
								if (f === 0) this.cells = v.concat(this.cells);
								else if (D) this.cells = this.cells.concat(v);
								else {
									var O = this.cells.splice(f, w - f);
									this.cells = this.cells.concat(v).concat(O);
								}
								(this._sizeCells(v), this.cellChange(f, !0));
							}
						}),
						(l.append = function (h) {
							this.insert(h, this.cells.length);
						}),
						(l.prepend = function (h) {
							this.insert(h, 0);
						}),
						(l.remove = function (h) {
							var f = this.getCells(h);
							if (!(!f || !f.length)) {
								var v = this.cells.length - 1;
								(f.forEach(function (w) {
									w.remove();
									var A = this.cells.indexOf(w);
									((v = Math.min(A, v)), s.removeFrom(this.cells, w));
								}, this),
									this.cellChange(v, !0));
							}
						}),
						(l.cellSizeChange = function (h) {
							var f = this.getCell(h);
							if (f) {
								f.getSize();
								var v = this.cells.indexOf(f);
								this.cellChange(v);
							}
						}),
						(l.cellChange = function (h, f) {
							var v = this.selectedElement;
							(this._positionCells(h),
								this._getWrapShiftCells(),
								this.setGallerySize());
							var w = this.getCell(v);
							(w && (this.selectedIndex = this.getCellSlideIndex(w)),
								(this.selectedIndex = Math.min(
									this.slides.length - 1,
									this.selectedIndex,
								)),
								this.emitEvent("cellChange", [h]),
								this.select(this.selectedIndex),
								f && this.positionSliderAtSelected());
						}),
						r
					);
				});
			})(Ql)),
		Ql.exports
	);
}
var tc = { exports: {} },
	df;
function dg() {
	return (
		df ||
			((df = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, Do(), Ks()))
						: n(e, e.Flickity, e.fizzyUIUtils);
				})(window, function (n, r, s) {
					r.createMethods.push("_createLazyload");
					var u = r.prototype;
					((u._createLazyload = function () {
						this.on("select", this.lazyLoad);
					}),
						(u.lazyLoad = function () {
							var f = this.options.lazyLoad;
							if (f) {
								var v = typeof f == "number" ? f : 0,
									w = this.getAdjacentCellElements(v),
									A = [];
								(w.forEach(function (D) {
									var C = l(D);
									A = A.concat(C);
								}),
									A.forEach(function (D) {
										new h(D, this);
									}, this));
							}
						}));
					function l(f) {
						if (f.nodeName == "IMG") {
							var v = f.getAttribute("data-flickity-lazyload"),
								w = f.getAttribute("data-flickity-lazyload-src"),
								A = f.getAttribute("data-flickity-lazyload-srcset");
							if (v || w || A) return [f];
						}
						var D =
								"img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
							C = f.querySelectorAll(D);
						return s.makeArray(C);
					}
					function h(f, v) {
						((this.img = f), (this.flickity = v), this.load());
					}
					return (
						(h.prototype.handleEvent = s.handleEvent),
						(h.prototype.load = function () {
							(this.img.addEventListener("load", this),
								this.img.addEventListener("error", this));
							var f =
									this.img.getAttribute("data-flickity-lazyload") ||
									this.img.getAttribute("data-flickity-lazyload-src"),
								v = this.img.getAttribute("data-flickity-lazyload-srcset");
							((this.img.src = f),
								v && this.img.setAttribute("srcset", v),
								this.img.removeAttribute("data-flickity-lazyload"),
								this.img.removeAttribute("data-flickity-lazyload-src"),
								this.img.removeAttribute("data-flickity-lazyload-srcset"));
						}),
						(h.prototype.onload = function (f) {
							this.complete(f, "flickity-lazyloaded");
						}),
						(h.prototype.onerror = function (f) {
							this.complete(f, "flickity-lazyerror");
						}),
						(h.prototype.complete = function (f, v) {
							(this.img.removeEventListener("load", this),
								this.img.removeEventListener("error", this));
							var w = this.flickity.getParentCell(this.img),
								A = w && w.element;
							(this.flickity.cellSizeChange(A),
								this.img.classList.add(v),
								this.flickity.dispatchEvent("lazyLoad", f, A));
						}),
						(r.LazyLoader = h),
						r
					);
				});
			})(tc)),
		tc.exports
	);
}
/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */ (function (p) {
	(function (e, n) {
		p.exports && (p.exports = n(Do(), ug(), lg(), cg(), hg(), fg(), dg()));
	})(window, function (n) {
		return n;
	});
})(Zd);
var Ud = Zd.exports;
const pf = tl(Ud);
var pg = { exports: {} },
	ec = { exports: {} };
/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ var mf;
function mg() {
	return (
		mf ||
			((mf = 1),
			(function (p) {
				(function (e, n) {
					p.exports
						? (p.exports = n(e, sl()))
						: (e.imagesLoaded = n(e, e.EvEmitter));
				})(typeof window < "u" ? window : Rs, function (n, r) {
					var s = n.jQuery,
						u = n.console;
					function l(C, O) {
						for (var P in O) C[P] = O[P];
						return C;
					}
					var h = Array.prototype.slice;
					function f(C) {
						if (Array.isArray(C)) return C;
						var O = typeof C == "object" && typeof C.length == "number";
						return O ? h.call(C) : [C];
					}
					function v(C, O, P) {
						if (!(this instanceof v)) return new v(C, O, P);
						var F = C;
						if (
							(typeof C == "string" && (F = document.querySelectorAll(C)), !F)
						) {
							u.error("Bad element for imagesLoaded " + (F || C));
							return;
						}
						((this.elements = f(F)),
							(this.options = l({}, this.options)),
							typeof O == "function" ? (P = O) : l(this.options, O),
							P && this.on("always", P),
							this.getImages(),
							s && (this.jqDeferred = new s.Deferred()),
							setTimeout(this.check.bind(this)));
					}
					((v.prototype = Object.create(r.prototype)),
						(v.prototype.options = {}),
						(v.prototype.getImages = function () {
							((this.images = []),
								this.elements.forEach(this.addElementImages, this));
						}),
						(v.prototype.addElementImages = function (C) {
							(C.nodeName == "IMG" && this.addImage(C),
								this.options.background === !0 &&
									this.addElementBackgroundImages(C));
							var O = C.nodeType;
							if (!(!O || !w[O])) {
								for (
									var P = C.querySelectorAll("img"), F = 0;
									F < P.length;
									F++
								) {
									var G = P[F];
									this.addImage(G);
								}
								if (typeof this.options.background == "string") {
									var B = C.querySelectorAll(this.options.background);
									for (F = 0; F < B.length; F++) {
										var j = B[F];
										this.addElementBackgroundImages(j);
									}
								}
							}
						}));
					var w = { 1: !0, 9: !0, 11: !0 };
					((v.prototype.addElementBackgroundImages = function (C) {
						var O = getComputedStyle(C);
						if (O)
							for (
								var P = /url\((['"])?(.*?)\1\)/gi,
									F = P.exec(O.backgroundImage);
								F !== null;
							) {
								var G = F && F[2];
								(G && this.addBackground(G, C),
									(F = P.exec(O.backgroundImage)));
							}
					}),
						(v.prototype.addImage = function (C) {
							var O = new A(C);
							this.images.push(O);
						}),
						(v.prototype.addBackground = function (C, O) {
							var P = new D(C, O);
							this.images.push(P);
						}),
						(v.prototype.check = function () {
							var C = this;
							if (
								((this.progressedCount = 0),
								(this.hasAnyBroken = !1),
								!this.images.length)
							) {
								this.complete();
								return;
							}
							function O(P, F, G) {
								setTimeout(function () {
									C.progress(P, F, G);
								});
							}
							this.images.forEach(function (P) {
								(P.once("progress", O), P.check());
							});
						}),
						(v.prototype.progress = function (C, O, P) {
							(this.progressedCount++,
								(this.hasAnyBroken = this.hasAnyBroken || !C.isLoaded),
								this.emitEvent("progress", [this, C, O]),
								this.jqDeferred &&
									this.jqDeferred.notify &&
									this.jqDeferred.notify(this, C),
								this.progressedCount == this.images.length && this.complete(),
								this.options.debug && u && u.log("progress: " + P, C, O));
						}),
						(v.prototype.complete = function () {
							var C = this.hasAnyBroken ? "fail" : "done";
							if (
								((this.isComplete = !0),
								this.emitEvent(C, [this]),
								this.emitEvent("always", [this]),
								this.jqDeferred)
							) {
								var O = this.hasAnyBroken ? "reject" : "resolve";
								this.jqDeferred[O](this);
							}
						}));
					function A(C) {
						this.img = C;
					}
					((A.prototype = Object.create(r.prototype)),
						(A.prototype.check = function () {
							var C = this.getIsImageComplete();
							if (C) {
								this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
								return;
							}
							((this.proxyImage = new Image()),
								this.proxyImage.addEventListener("load", this),
								this.proxyImage.addEventListener("error", this),
								this.img.addEventListener("load", this),
								this.img.addEventListener("error", this),
								(this.proxyImage.src = this.img.src));
						}),
						(A.prototype.getIsImageComplete = function () {
							return this.img.complete && this.img.naturalWidth;
						}),
						(A.prototype.confirm = function (C, O) {
							((this.isLoaded = C),
								this.emitEvent("progress", [this, this.img, O]));
						}),
						(A.prototype.handleEvent = function (C) {
							var O = "on" + C.type;
							this[O] && this[O](C);
						}),
						(A.prototype.onload = function () {
							(this.confirm(!0, "onload"), this.unbindEvents());
						}),
						(A.prototype.onerror = function () {
							(this.confirm(!1, "onerror"), this.unbindEvents());
						}),
						(A.prototype.unbindEvents = function () {
							(this.proxyImage.removeEventListener("load", this),
								this.proxyImage.removeEventListener("error", this),
								this.img.removeEventListener("load", this),
								this.img.removeEventListener("error", this));
						}));
					function D(C, O) {
						((this.url = C), (this.element = O), (this.img = new Image()));
					}
					return (
						(D.prototype = Object.create(A.prototype)),
						(D.prototype.check = function () {
							(this.img.addEventListener("load", this),
								this.img.addEventListener("error", this),
								(this.img.src = this.url));
							var C = this.getIsImageComplete();
							C &&
								(this.confirm(this.img.naturalWidth !== 0, "naturalWidth"),
								this.unbindEvents());
						}),
						(D.prototype.unbindEvents = function () {
							(this.img.removeEventListener("load", this),
								this.img.removeEventListener("error", this));
						}),
						(D.prototype.confirm = function (C, O) {
							((this.isLoaded = C),
								this.emitEvent("progress", [this, this.element, O]));
						}),
						(v.makeJQueryPlugin = function (C) {
							((C = C || n.jQuery),
								C &&
									((s = C),
									(s.fn.imagesLoaded = function (O, P) {
										var F = new v(this, O, P);
										return F.jqDeferred.promise(s(this));
									})));
						}),
						v.makeJQueryPlugin(),
						v
					);
				});
			})(ec)),
		ec.exports
	);
}
/*!
 * Flickity imagesLoaded v2.0.0
 * enables imagesLoaded option for Flickity
 */ (function (p) {
	(function (e, n) {
		p.exports
			? (p.exports = n(e, Ud, mg()))
			: (e.Flickity = n(e, e.Flickity, e.imagesLoaded));
	})(window, function (n, r, s) {
		r.createMethods.push("_createImagesLoaded");
		var u = r.prototype;
		return (
			(u._createImagesLoaded = function () {
				this.on("activate", this.imagesLoaded);
			}),
			(u.imagesLoaded = function () {
				if (!this.options.imagesLoaded) return;
				var l = this;
				function h(f, v) {
					var w = l.getParentCell(v.img);
					(l.cellSizeChange(w && w.element),
						l.options.freeScroll || l.positionSliderAtSelected());
				}
				s(this.slider).on("progress", h);
			}),
			r
		);
	});
})(pg);
var Ac = { exports: {} };
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function (p, e) {
	(function (n, r) {
		r(e);
	})(Rs, function (n) {
		var r = "1.9.4";
		function s(t) {
			var i, a, d, x;
			for (a = 1, d = arguments.length; a < d; a++) {
				x = arguments[a];
				for (i in x) t[i] = x[i];
			}
			return t;
		}
		var u =
			Object.create ||
			(function () {
				function t() {}
				return function (i) {
					return ((t.prototype = i), new t());
				};
			})();
		function l(t, i) {
			var a = Array.prototype.slice;
			if (t.bind) return t.bind.apply(t, a.call(arguments, 1));
			var d = a.call(arguments, 2);
			return function () {
				return t.apply(i, d.length ? d.concat(a.call(arguments)) : arguments);
			};
		}
		var h = 0;
		function f(t) {
			return ("_leaflet_id" in t || (t._leaflet_id = ++h), t._leaflet_id);
		}
		function v(t, i, a) {
			var d, x, M, q;
			return (
				(q = function () {
					((d = !1), x && (M.apply(a, x), (x = !1)));
				}),
				(M = function () {
					d
						? (x = arguments)
						: (t.apply(a, arguments), setTimeout(q, i), (d = !0));
				}),
				M
			);
		}
		function w(t, i, a) {
			var d = i[1],
				x = i[0],
				M = d - x;
			return t === d && a ? t : ((((t - x) % M) + M) % M) + x;
		}
		function A() {
			return !1;
		}
		function D(t, i) {
			if (i === !1) return t;
			var a = Math.pow(10, i === void 0 ? 6 : i);
			return Math.round(t * a) / a;
		}
		function C(t) {
			return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
		}
		function O(t) {
			return C(t).split(/\s+/);
		}
		function P(t, i) {
			Object.prototype.hasOwnProperty.call(t, "options") ||
				(t.options = t.options ? u(t.options) : {});
			for (var a in i) t.options[a] = i[a];
			return t.options;
		}
		function F(t, i, a) {
			var d = [];
			for (var x in t)
				d.push(
					encodeURIComponent(a ? x.toUpperCase() : x) +
						"=" +
						encodeURIComponent(t[x]),
				);
			return (!i || i.indexOf("?") === -1 ? "?" : "&") + d.join("&");
		}
		var G = /\{ *([\w_ -]+) *\}/g;
		function B(t, i) {
			return t.replace(G, function (a, d) {
				var x = i[d];
				if (x === void 0)
					throw new Error("No value provided for variable " + a);
				return (typeof x == "function" && (x = x(i)), x);
			});
		}
		var j =
			Array.isArray ||
			function (t) {
				return Object.prototype.toString.call(t) === "[object Array]";
			};
		function V(t, i) {
			for (var a = 0; a < t.length; a++) if (t[a] === i) return a;
			return -1;
		}
		var Q = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
		function it(t) {
			return window["webkit" + t] || window["moz" + t] || window["ms" + t];
		}
		var g = 0;
		function ct(t) {
			var i = +new Date(),
				a = Math.max(0, 16 - (i - g));
			return ((g = i + a), window.setTimeout(t, a));
		}
		var ot = window.requestAnimationFrame || it("RequestAnimationFrame") || ct,
			ft =
				window.cancelAnimationFrame ||
				it("CancelAnimationFrame") ||
				it("CancelRequestAnimationFrame") ||
				function (t) {
					window.clearTimeout(t);
				};
		function Dt(t, i, a) {
			if (a && ot === ct) t.call(i);
			else return ot.call(window, l(t, i));
		}
		function pt(t) {
			t && ft.call(window, t);
		}
		var Et = {
			__proto__: null,
			extend: s,
			create: u,
			bind: l,
			get lastId() {
				return h;
			},
			stamp: f,
			throttle: v,
			wrapNum: w,
			falseFn: A,
			formatNum: D,
			trim: C,
			splitWords: O,
			setOptions: P,
			getParamString: F,
			template: B,
			isArray: j,
			indexOf: V,
			emptyImageUrl: Q,
			requestFn: ot,
			cancelFn: ft,
			requestAnimFrame: Dt,
			cancelAnimFrame: pt,
		};
		function K() {}
		((K.extend = function (t) {
			var i = function () {
					(P(this),
						this.initialize && this.initialize.apply(this, arguments),
						this.callInitHooks());
				},
				a = (i.__super__ = this.prototype),
				d = u(a);
			((d.constructor = i), (i.prototype = d));
			for (var x in this)
				Object.prototype.hasOwnProperty.call(this, x) &&
					x !== "prototype" &&
					x !== "__super__" &&
					(i[x] = this[x]);
			return (
				t.statics && s(i, t.statics),
				t.includes && (Nt(t.includes), s.apply(null, [d].concat(t.includes))),
				s(d, t),
				delete d.statics,
				delete d.includes,
				d.options &&
					((d.options = a.options ? u(a.options) : {}),
					s(d.options, t.options)),
				(d._initHooks = []),
				(d.callInitHooks = function () {
					if (!this._initHooksCalled) {
						(a.callInitHooks && a.callInitHooks.call(this),
							(this._initHooksCalled = !0));
						for (var M = 0, q = d._initHooks.length; M < q; M++)
							d._initHooks[M].call(this);
					}
				}),
				i
			);
		}),
			(K.include = function (t) {
				var i = this.prototype.options;
				return (
					s(this.prototype, t),
					t.options &&
						((this.prototype.options = i), this.mergeOptions(t.options)),
					this
				);
			}),
			(K.mergeOptions = function (t) {
				return (s(this.prototype.options, t), this);
			}),
			(K.addInitHook = function (t) {
				var i = Array.prototype.slice.call(arguments, 1),
					a =
						typeof t == "function"
							? t
							: function () {
									this[t].apply(this, i);
								};
				return (
					(this.prototype._initHooks = this.prototype._initHooks || []),
					this.prototype._initHooks.push(a),
					this
				);
			}));
		function Nt(t) {
			if (!(typeof L > "u" || !L || !L.Mixin)) {
				t = j(t) ? t : [t];
				for (var i = 0; i < t.length; i++)
					t[i] === L.Mixin.Events &&
						console.warn(
							"Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.",
							new Error().stack,
						);
			}
		}
		var St = {
			on: function (t, i, a) {
				if (typeof t == "object") for (var d in t) this._on(d, t[d], i);
				else {
					t = O(t);
					for (var x = 0, M = t.length; x < M; x++) this._on(t[x], i, a);
				}
				return this;
			},
			off: function (t, i, a) {
				if (!arguments.length) delete this._events;
				else if (typeof t == "object") for (var d in t) this._off(d, t[d], i);
				else {
					t = O(t);
					for (var x = arguments.length === 1, M = 0, q = t.length; M < q; M++)
						x ? this._off(t[M]) : this._off(t[M], i, a);
				}
				return this;
			},
			_on: function (t, i, a, d) {
				if (typeof i != "function") {
					console.warn("wrong listener type: " + typeof i);
					return;
				}
				if (this._listens(t, i, a) === !1) {
					a === this && (a = void 0);
					var x = { fn: i, ctx: a };
					(d && (x.once = !0),
						(this._events = this._events || {}),
						(this._events[t] = this._events[t] || []),
						this._events[t].push(x));
				}
			},
			_off: function (t, i, a) {
				var d, x, M;
				if (this._events && ((d = this._events[t]), !!d)) {
					if (arguments.length === 1) {
						if (this._firingCount)
							for (x = 0, M = d.length; x < M; x++) d[x].fn = A;
						delete this._events[t];
						return;
					}
					if (typeof i != "function") {
						console.warn("wrong listener type: " + typeof i);
						return;
					}
					var q = this._listens(t, i, a);
					if (q !== !1) {
						var J = d[q];
						(this._firingCount &&
							((J.fn = A), (this._events[t] = d = d.slice())),
							d.splice(q, 1));
					}
				}
			},
			fire: function (t, i, a) {
				if (!this.listens(t, a)) return this;
				var d = s({}, i, {
					type: t,
					target: this,
					sourceTarget: (i && i.sourceTarget) || this,
				});
				if (this._events) {
					var x = this._events[t];
					if (x) {
						this._firingCount = this._firingCount + 1 || 1;
						for (var M = 0, q = x.length; M < q; M++) {
							var J = x[M],
								nt = J.fn;
							(J.once && this.off(t, nt, J.ctx), nt.call(J.ctx || this, d));
						}
						this._firingCount--;
					}
				}
				return (a && this._propagateEvent(d), this);
			},
			listens: function (t, i, a, d) {
				typeof t != "string" && console.warn('"string" type argument expected');
				var x = i;
				typeof i != "function" && ((d = !!i), (x = void 0), (a = void 0));
				var M = this._events && this._events[t];
				if (M && M.length && this._listens(t, x, a) !== !1) return !0;
				if (d) {
					for (var q in this._eventParents)
						if (this._eventParents[q].listens(t, i, a, d)) return !0;
				}
				return !1;
			},
			_listens: function (t, i, a) {
				if (!this._events) return !1;
				var d = this._events[t] || [];
				if (!i) return !!d.length;
				a === this && (a = void 0);
				for (var x = 0, M = d.length; x < M; x++)
					if (d[x].fn === i && d[x].ctx === a) return x;
				return !1;
			},
			once: function (t, i, a) {
				if (typeof t == "object") for (var d in t) this._on(d, t[d], i, !0);
				else {
					t = O(t);
					for (var x = 0, M = t.length; x < M; x++) this._on(t[x], i, a, !0);
				}
				return this;
			},
			addEventParent: function (t) {
				return (
					(this._eventParents = this._eventParents || {}),
					(this._eventParents[f(t)] = t),
					this
				);
			},
			removeEventParent: function (t) {
				return (this._eventParents && delete this._eventParents[f(t)], this);
			},
			_propagateEvent: function (t) {
				for (var i in this._eventParents)
					this._eventParents[i].fire(
						t.type,
						s({ layer: t.target, propagatedFrom: t.target }, t),
						!0,
					);
			},
		};
		((St.addEventListener = St.on),
			(St.removeEventListener = St.clearAllEventListeners = St.off),
			(St.addOneTimeEventListener = St.once),
			(St.fireEvent = St.fire),
			(St.hasEventListeners = St.listens));
		var Ct = K.extend(St);
		function _t(t, i, a) {
			((this.x = a ? Math.round(t) : t), (this.y = a ? Math.round(i) : i));
		}
		var de =
			Math.trunc ||
			function (t) {
				return t > 0 ? Math.floor(t) : Math.ceil(t);
			};
		_t.prototype = {
			clone: function () {
				return new _t(this.x, this.y);
			},
			add: function (t) {
				return this.clone()._add(W(t));
			},
			_add: function (t) {
				return ((this.x += t.x), (this.y += t.y), this);
			},
			subtract: function (t) {
				return this.clone()._subtract(W(t));
			},
			_subtract: function (t) {
				return ((this.x -= t.x), (this.y -= t.y), this);
			},
			divideBy: function (t) {
				return this.clone()._divideBy(t);
			},
			_divideBy: function (t) {
				return ((this.x /= t), (this.y /= t), this);
			},
			multiplyBy: function (t) {
				return this.clone()._multiplyBy(t);
			},
			_multiplyBy: function (t) {
				return ((this.x *= t), (this.y *= t), this);
			},
			scaleBy: function (t) {
				return new _t(this.x * t.x, this.y * t.y);
			},
			unscaleBy: function (t) {
				return new _t(this.x / t.x, this.y / t.y);
			},
			round: function () {
				return this.clone()._round();
			},
			_round: function () {
				return (
					(this.x = Math.round(this.x)),
					(this.y = Math.round(this.y)),
					this
				);
			},
			floor: function () {
				return this.clone()._floor();
			},
			_floor: function () {
				return (
					(this.x = Math.floor(this.x)),
					(this.y = Math.floor(this.y)),
					this
				);
			},
			ceil: function () {
				return this.clone()._ceil();
			},
			_ceil: function () {
				return (
					(this.x = Math.ceil(this.x)),
					(this.y = Math.ceil(this.y)),
					this
				);
			},
			trunc: function () {
				return this.clone()._trunc();
			},
			_trunc: function () {
				return ((this.x = de(this.x)), (this.y = de(this.y)), this);
			},
			distanceTo: function (t) {
				t = W(t);
				var i = t.x - this.x,
					a = t.y - this.y;
				return Math.sqrt(i * i + a * a);
			},
			equals: function (t) {
				return ((t = W(t)), t.x === this.x && t.y === this.y);
			},
			contains: function (t) {
				return (
					(t = W(t)),
					Math.abs(t.x) <= Math.abs(this.x) && Math.abs(t.y) <= Math.abs(this.y)
				);
			},
			toString: function () {
				return "Point(" + D(this.x) + ", " + D(this.y) + ")";
			},
		};
		function W(t, i, a) {
			return t instanceof _t
				? t
				: j(t)
					? new _t(t[0], t[1])
					: t == null
						? t
						: typeof t == "object" && "x" in t && "y" in t
							? new _t(t.x, t.y)
							: new _t(t, i, a);
		}
		function Wt(t, i) {
			if (t)
				for (var a = i ? [t, i] : t, d = 0, x = a.length; d < x; d++)
					this.extend(a[d]);
		}
		Wt.prototype = {
			extend: function (t) {
				var i, a;
				if (!t) return this;
				if (t instanceof _t || typeof t[0] == "number" || "x" in t)
					i = a = W(t);
				else if (((t = Zt(t)), (i = t.min), (a = t.max), !i || !a)) return this;
				return (
					!this.min && !this.max
						? ((this.min = i.clone()), (this.max = a.clone()))
						: ((this.min.x = Math.min(i.x, this.min.x)),
							(this.max.x = Math.max(a.x, this.max.x)),
							(this.min.y = Math.min(i.y, this.min.y)),
							(this.max.y = Math.max(a.y, this.max.y))),
					this
				);
			},
			getCenter: function (t) {
				return W(
					(this.min.x + this.max.x) / 2,
					(this.min.y + this.max.y) / 2,
					t,
				);
			},
			getBottomLeft: function () {
				return W(this.min.x, this.max.y);
			},
			getTopRight: function () {
				return W(this.max.x, this.min.y);
			},
			getTopLeft: function () {
				return this.min;
			},
			getBottomRight: function () {
				return this.max;
			},
			getSize: function () {
				return this.max.subtract(this.min);
			},
			contains: function (t) {
				var i, a;
				return (
					typeof t[0] == "number" || t instanceof _t ? (t = W(t)) : (t = Zt(t)),
					t instanceof Wt ? ((i = t.min), (a = t.max)) : (i = a = t),
					i.x >= this.min.x &&
						a.x <= this.max.x &&
						i.y >= this.min.y &&
						a.y <= this.max.y
				);
			},
			intersects: function (t) {
				t = Zt(t);
				var i = this.min,
					a = this.max,
					d = t.min,
					x = t.max,
					M = x.x >= i.x && d.x <= a.x,
					q = x.y >= i.y && d.y <= a.y;
				return M && q;
			},
			overlaps: function (t) {
				t = Zt(t);
				var i = this.min,
					a = this.max,
					d = t.min,
					x = t.max,
					M = x.x > i.x && d.x < a.x,
					q = x.y > i.y && d.y < a.y;
				return M && q;
			},
			isValid: function () {
				return !!(this.min && this.max);
			},
			pad: function (t) {
				var i = this.min,
					a = this.max,
					d = Math.abs(i.x - a.x) * t,
					x = Math.abs(i.y - a.y) * t;
				return Zt(W(i.x - d, i.y - x), W(a.x + d, a.y + x));
			},
			equals: function (t) {
				return t
					? ((t = Zt(t)),
						this.min.equals(t.getTopLeft()) &&
							this.max.equals(t.getBottomRight()))
					: !1;
			},
		};
		function Zt(t, i) {
			return !t || t instanceof Wt ? t : new Wt(t, i);
		}
		function oe(t, i) {
			if (t)
				for (var a = i ? [t, i] : t, d = 0, x = a.length; d < x; d++)
					this.extend(a[d]);
		}
		oe.prototype = {
			extend: function (t) {
				var i = this._southWest,
					a = this._northEast,
					d,
					x;
				if (t instanceof Vt) ((d = t), (x = t));
				else if (t instanceof oe) {
					if (((d = t._southWest), (x = t._northEast), !d || !x)) return this;
				} else return t ? this.extend(U(t) || jt(t)) : this;
				return (
					!i && !a
						? ((this._southWest = new Vt(d.lat, d.lng)),
							(this._northEast = new Vt(x.lat, x.lng)))
						: ((i.lat = Math.min(d.lat, i.lat)),
							(i.lng = Math.min(d.lng, i.lng)),
							(a.lat = Math.max(x.lat, a.lat)),
							(a.lng = Math.max(x.lng, a.lng))),
					this
				);
			},
			pad: function (t) {
				var i = this._southWest,
					a = this._northEast,
					d = Math.abs(i.lat - a.lat) * t,
					x = Math.abs(i.lng - a.lng) * t;
				return new oe(
					new Vt(i.lat - d, i.lng - x),
					new Vt(a.lat + d, a.lng + x),
				);
			},
			getCenter: function () {
				return new Vt(
					(this._southWest.lat + this._northEast.lat) / 2,
					(this._southWest.lng + this._northEast.lng) / 2,
				);
			},
			getSouthWest: function () {
				return this._southWest;
			},
			getNorthEast: function () {
				return this._northEast;
			},
			getNorthWest: function () {
				return new Vt(this.getNorth(), this.getWest());
			},
			getSouthEast: function () {
				return new Vt(this.getSouth(), this.getEast());
			},
			getWest: function () {
				return this._southWest.lng;
			},
			getSouth: function () {
				return this._southWest.lat;
			},
			getEast: function () {
				return this._northEast.lng;
			},
			getNorth: function () {
				return this._northEast.lat;
			},
			contains: function (t) {
				typeof t[0] == "number" || t instanceof Vt || "lat" in t
					? (t = U(t))
					: (t = jt(t));
				var i = this._southWest,
					a = this._northEast,
					d,
					x;
				return (
					t instanceof oe
						? ((d = t.getSouthWest()), (x = t.getNorthEast()))
						: (d = x = t),
					d.lat >= i.lat && x.lat <= a.lat && d.lng >= i.lng && x.lng <= a.lng
				);
			},
			intersects: function (t) {
				t = jt(t);
				var i = this._southWest,
					a = this._northEast,
					d = t.getSouthWest(),
					x = t.getNorthEast(),
					M = x.lat >= i.lat && d.lat <= a.lat,
					q = x.lng >= i.lng && d.lng <= a.lng;
				return M && q;
			},
			overlaps: function (t) {
				t = jt(t);
				var i = this._southWest,
					a = this._northEast,
					d = t.getSouthWest(),
					x = t.getNorthEast(),
					M = x.lat > i.lat && d.lat < a.lat,
					q = x.lng > i.lng && d.lng < a.lng;
				return M && q;
			},
			toBBoxString: function () {
				return [
					this.getWest(),
					this.getSouth(),
					this.getEast(),
					this.getNorth(),
				].join(",");
			},
			equals: function (t, i) {
				return t
					? ((t = jt(t)),
						this._southWest.equals(t.getSouthWest(), i) &&
							this._northEast.equals(t.getNorthEast(), i))
					: !1;
			},
			isValid: function () {
				return !!(this._southWest && this._northEast);
			},
		};
		function jt(t, i) {
			return t instanceof oe ? t : new oe(t, i);
		}
		function Vt(t, i, a) {
			if (isNaN(t) || isNaN(i))
				throw new Error("Invalid LatLng object: (" + t + ", " + i + ")");
			((this.lat = +t), (this.lng = +i), a !== void 0 && (this.alt = +a));
		}
		Vt.prototype = {
			equals: function (t, i) {
				if (!t) return !1;
				t = U(t);
				var a = Math.max(
					Math.abs(this.lat - t.lat),
					Math.abs(this.lng - t.lng),
				);
				return a <= (i === void 0 ? 1e-9 : i);
			},
			toString: function (t) {
				return "LatLng(" + D(this.lat, t) + ", " + D(this.lng, t) + ")";
			},
			distanceTo: function (t) {
				return qe.distance(this, U(t));
			},
			wrap: function () {
				return qe.wrapLatLng(this);
			},
			toBounds: function (t) {
				var i = (180 * t) / 40075017,
					a = i / Math.cos((Math.PI / 180) * this.lat);
				return jt([this.lat - i, this.lng - a], [this.lat + i, this.lng + a]);
			},
			clone: function () {
				return new Vt(this.lat, this.lng, this.alt);
			},
		};
		function U(t, i, a) {
			return t instanceof Vt
				? t
				: j(t) && typeof t[0] != "object"
					? t.length === 3
						? new Vt(t[0], t[1], t[2])
						: t.length === 2
							? new Vt(t[0], t[1])
							: null
					: t == null
						? t
						: typeof t == "object" && "lat" in t
							? new Vt(t.lat, "lng" in t ? t.lng : t.lon, t.alt)
							: i === void 0
								? null
								: new Vt(t, i, a);
		}
		var xe = {
				latLngToPoint: function (t, i) {
					var a = this.projection.project(t),
						d = this.scale(i);
					return this.transformation._transform(a, d);
				},
				pointToLatLng: function (t, i) {
					var a = this.scale(i),
						d = this.transformation.untransform(t, a);
					return this.projection.unproject(d);
				},
				project: function (t) {
					return this.projection.project(t);
				},
				unproject: function (t) {
					return this.projection.unproject(t);
				},
				scale: function (t) {
					return 256 * Math.pow(2, t);
				},
				zoom: function (t) {
					return Math.log(t / 256) / Math.LN2;
				},
				getProjectedBounds: function (t) {
					if (this.infinite) return null;
					var i = this.projection.bounds,
						a = this.scale(t),
						d = this.transformation.transform(i.min, a),
						x = this.transformation.transform(i.max, a);
					return new Wt(d, x);
				},
				infinite: !1,
				wrapLatLng: function (t) {
					var i = this.wrapLng ? w(t.lng, this.wrapLng, !0) : t.lng,
						a = this.wrapLat ? w(t.lat, this.wrapLat, !0) : t.lat,
						d = t.alt;
					return new Vt(a, i, d);
				},
				wrapLatLngBounds: function (t) {
					var i = t.getCenter(),
						a = this.wrapLatLng(i),
						d = i.lat - a.lat,
						x = i.lng - a.lng;
					if (d === 0 && x === 0) return t;
					var M = t.getSouthWest(),
						q = t.getNorthEast(),
						J = new Vt(M.lat - d, M.lng - x),
						nt = new Vt(q.lat - d, q.lng - x);
					return new oe(J, nt);
				},
			},
			qe = s({}, xe, {
				wrapLng: [-180, 180],
				R: 6371e3,
				distance: function (t, i) {
					var a = Math.PI / 180,
						d = t.lat * a,
						x = i.lat * a,
						M = Math.sin(((i.lat - t.lat) * a) / 2),
						q = Math.sin(((i.lng - t.lng) * a) / 2),
						J = M * M + Math.cos(d) * Math.cos(x) * q * q,
						nt = 2 * Math.atan2(Math.sqrt(J), Math.sqrt(1 - J));
					return this.R * nt;
				},
			}),
			Ze = 6378137,
			je = {
				R: Ze,
				MAX_LATITUDE: 85.0511287798,
				project: function (t) {
					var i = Math.PI / 180,
						a = this.MAX_LATITUDE,
						d = Math.max(Math.min(a, t.lat), -a),
						x = Math.sin(d * i);
					return new _t(
						this.R * t.lng * i,
						(this.R * Math.log((1 + x) / (1 - x))) / 2,
					);
				},
				unproject: function (t) {
					var i = 180 / Math.PI;
					return new Vt(
						(2 * Math.atan(Math.exp(t.y / this.R)) - Math.PI / 2) * i,
						(t.x * i) / this.R,
					);
				},
				bounds: (function () {
					var t = Ze * Math.PI;
					return new Wt([-t, -t], [t, t]);
				})(),
			};
		function Ge(t, i, a, d) {
			if (j(t)) {
				((this._a = t[0]),
					(this._b = t[1]),
					(this._c = t[2]),
					(this._d = t[3]));
				return;
			}
			((this._a = t), (this._b = i), (this._c = a), (this._d = d));
		}
		Ge.prototype = {
			transform: function (t, i) {
				return this._transform(t.clone(), i);
			},
			_transform: function (t, i) {
				return (
					(i = i || 1),
					(t.x = i * (this._a * t.x + this._b)),
					(t.y = i * (this._c * t.y + this._d)),
					t
				);
			},
			untransform: function (t, i) {
				return (
					(i = i || 1),
					new _t((t.x / i - this._b) / this._a, (t.y / i - this._d) / this._c)
				);
			},
		};
		function Ue(t, i, a, d) {
			return new Ge(t, i, a, d);
		}
		var ne = s({}, qe, {
				code: "EPSG:3857",
				projection: je,
				transformation: (function () {
					var t = 0.5 / (Math.PI * je.R);
					return Ue(t, 0.5, -t, 0.5);
				})(),
			}),
			We = s({}, ne, { code: "EPSG:900913" });
		function He(t) {
			return document.createElementNS("http://www.w3.org/2000/svg", t);
		}
		function di(t, i) {
			var a = "",
				d,
				x,
				M,
				q,
				J,
				nt;
			for (d = 0, M = t.length; d < M; d++) {
				for (J = t[d], x = 0, q = J.length; x < q; x++)
					((nt = J[x]), (a += (x ? "L" : "M") + nt.x + " " + nt.y));
				a += i ? (xt.svg ? "z" : "x") : "";
			}
			return a || "M0 0";
		}
		var st = document.documentElement.style,
			ze = "ActiveXObject" in window,
			Ji = ze && !document.addEventListener,
			pi = "msLaunchUri" in navigator && !("documentMode" in document),
			Ie = zt("webkit"),
			$e = zt("android"),
			re = zt("android 2") || zt("android 3"),
			Di = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10),
			gt = $e && zt("Google") && Di < 537 && !("AudioNode" in window),
			Lt = !!window.opera,
			Ft = !pi && zt("chrome"),
			vt = zt("gecko") && !Ie && !Lt && !ze,
			Kt = !Ft && zt("safari"),
			Ne = zt("phantom"),
			bt = "OTransition" in st,
			se = navigator.platform.indexOf("Win") === 0,
			ke = ze && "transition" in st,
			ie =
				"WebKitCSSMatrix" in window &&
				"m11" in new window.WebKitCSSMatrix() &&
				!re,
			Jt = "MozPerspective" in st,
			vi = !window.L_DISABLE_3D && (ke || ie || Jt) && !bt && !Ne,
			Ii = typeof orientation < "u" || zt("mobile"),
			En = Ii && Ie,
			Qt = Ii && ie,
			Vn = !window.PointerEvent && window.MSPointerEvent,
			ii = !!(window.PointerEvent || Vn),
			Pi = "ontouchstart" in window || !!window.TouchEvent,
			Ui = !window.L_NO_TOUCH && (Pi || ii),
			Cn = Ii && Lt,
			yi = Ii && vt,
			Xe =
				(window.devicePixelRatio ||
					window.screen.deviceXDPI / window.screen.logicalXDPI) > 1,
			Gn = (function () {
				var t = !1;
				try {
					var i = Object.defineProperty({}, "passive", {
						get: function () {
							t = !0;
						},
					});
					(window.addEventListener("testPassiveEventSupport", A, i),
						window.removeEventListener("testPassiveEventSupport", A, i));
				} catch {}
				return t;
			})(),
			te = (function () {
				return !!document.createElement("canvas").getContext;
			})(),
			qt = !!(document.createElementNS && He("svg").createSVGRect),
			we =
				!!qt &&
				(function () {
					var t = document.createElement("div");
					return (
						(t.innerHTML = "<svg/>"),
						(t.firstChild && t.firstChild.namespaceURI) ===
							"http://www.w3.org/2000/svg"
					);
				})(),
			yt =
				!qt &&
				(function () {
					try {
						var t = document.createElement("div");
						t.innerHTML = '<v:shape adj="1"/>';
						var i = t.firstChild;
						return (
							(i.style.behavior = "url(#default#VML)"),
							i && typeof i.adj == "object"
						);
					} catch {
						return !1;
					}
				})(),
			Ut = navigator.platform.indexOf("Mac") === 0,
			Rt = navigator.platform.indexOf("Linux") === 0;
		function zt(t) {
			return navigator.userAgent.toLowerCase().indexOf(t) >= 0;
		}
		var xt = {
				ie: ze,
				ielt9: Ji,
				edge: pi,
				webkit: Ie,
				android: $e,
				android23: re,
				androidStock: gt,
				opera: Lt,
				chrome: Ft,
				gecko: vt,
				safari: Kt,
				phantom: Ne,
				opera12: bt,
				win: se,
				ie3d: ke,
				webkit3d: ie,
				gecko3d: Jt,
				any3d: vi,
				mobile: Ii,
				mobileWebkit: En,
				mobileWebkit3d: Qt,
				msPointer: Vn,
				pointer: ii,
				touch: Ui,
				touchNative: Pi,
				mobileOpera: Cn,
				mobileGecko: yi,
				retina: Xe,
				passiveEvents: Gn,
				canvas: te,
				svg: qt,
				vml: yt,
				inlineSvg: we,
				mac: Ut,
				linux: Rt,
			},
			he = xt.msPointer ? "MSPointerDown" : "pointerdown",
			Ye = xt.msPointer ? "MSPointerMove" : "pointermove",
			mi = xt.msPointer ? "MSPointerUp" : "pointerup",
			Ve = xt.msPointer ? "MSPointerCancel" : "pointercancel",
			Re = { touchstart: he, touchmove: Ye, touchend: mi, touchcancel: Ve },
			Ae = { touchstart: bi, touchmove: on, touchend: on, touchcancel: on },
			Li = {},
			Le = !1;
		function ki(t, i, a) {
			return (
				i === "touchstart" && hr(),
				Ae[i]
					? ((a = Ae[i].bind(this, a)), t.addEventListener(Re[i], a, !1), a)
					: (console.warn("wrong event specified:", i), A)
			);
		}
		function $i(t, i, a) {
			if (!Re[i]) {
				console.warn("wrong event specified:", i);
				return;
			}
			t.removeEventListener(Re[i], a, !1);
		}
		function Fe(t) {
			Li[t.pointerId] = t;
		}
		function ni(t) {
			Li[t.pointerId] && (Li[t.pointerId] = t);
		}
		function gi(t) {
			delete Li[t.pointerId];
		}
		function hr() {
			Le ||
				(document.addEventListener(he, Fe, !0),
				document.addEventListener(Ye, ni, !0),
				document.addEventListener(mi, gi, !0),
				document.addEventListener(Ve, gi, !0),
				(Le = !0));
		}
		function on(t, i) {
			if (i.pointerType !== (i.MSPOINTER_TYPE_MOUSE || "mouse")) {
				i.touches = [];
				for (var a in Li) i.touches.push(Li[a]);
				((i.changedTouches = [i]), t(i));
			}
		}
		function bi(t, i) {
			(i.MSPOINTER_TYPE_TOUCH &&
				i.pointerType === i.MSPOINTER_TYPE_TOUCH &&
				Mi(i),
				on(t, i));
		}
		function ri(t) {
			var i = {},
				a,
				d;
			for (d in t) ((a = t[d]), (i[d] = a && a.bind ? a.bind(t) : a));
			return (
				(t = i),
				(i.type = "dblclick"),
				(i.detail = 2),
				(i.isTrusted = !1),
				(i._simulated = !0),
				i
			);
		}
		var Fi = 200;
		function Fr(t, i) {
			t.addEventListener("dblclick", i);
			var a = 0,
				d;
			function x(M) {
				if (M.detail !== 1) {
					d = M.detail;
					return;
				}
				if (
					!(
						M.pointerType === "mouse" ||
						(M.sourceCapabilities && !M.sourceCapabilities.firesTouchEvents)
					)
				) {
					var q = eo(M);
					if (
						!(
							q.some(function (nt) {
								return nt instanceof HTMLLabelElement && nt.attributes.for;
							}) &&
							!q.some(function (nt) {
								return (
									nt instanceof HTMLInputElement ||
									nt instanceof HTMLSelectElement
								);
							})
						)
					) {
						var J = Date.now();
						(J - a <= Fi ? (d++, d === 2 && i(ri(M))) : (d = 1), (a = J));
					}
				}
			}
			return (t.addEventListener("click", x), { dblclick: i, simDblclick: x });
		}
		function cs(t, i) {
			(t.removeEventListener("dblclick", i.dblclick),
				t.removeEventListener("click", i.simDblclick));
		}
		var pn = kn([
				"transform",
				"webkitTransform",
				"OTransform",
				"MozTransform",
				"msTransform",
			]),
			Hi = kn([
				"webkitTransition",
				"transition",
				"OTransition",
				"MozTransition",
				"msTransition",
			]),
			Er =
				Hi === "webkitTransition" || Hi === "OTransition"
					? Hi + "End"
					: "transitionend";
		function Xn(t) {
			return typeof t == "string" ? document.getElementById(t) : t;
		}
		function mn(t, i) {
			var a = t.style[i] || (t.currentStyle && t.currentStyle[i]);
			if ((!a || a === "auto") && document.defaultView) {
				var d = document.defaultView.getComputedStyle(t, null);
				a = d ? d[i] : null;
			}
			return a === "auto" ? null : a;
		}
		function ve(t, i, a) {
			var d = document.createElement(t);
			return ((d.className = i || ""), a && a.appendChild(d), d);
		}
		function Ke(t) {
			var i = t.parentNode;
			i && i.removeChild(t);
		}
		function Bi(t) {
			for (; t.firstChild; ) t.removeChild(t.firstChild);
		}
		function Pn(t) {
			var i = t.parentNode;
			i && i.lastChild !== t && i.appendChild(t);
		}
		function an(t) {
			var i = t.parentNode;
			i && i.firstChild !== t && i.insertBefore(t, i.firstChild);
		}
		function ks(t, i) {
			if (t.classList !== void 0) return t.classList.contains(i);
			var a = Me(t);
			return a.length > 0 && new RegExp("(^|\\s)" + i + "(\\s|$)").test(a);
		}
		function ue(t, i) {
			if (t.classList !== void 0)
				for (var a = O(i), d = 0, x = a.length; d < x; d++)
					t.classList.add(a[d]);
			else if (!ks(t, i)) {
				var M = Me(t);
				xi(t, (M ? M + " " : "") + i);
			}
		}
		function Je(t, i) {
			t.classList !== void 0
				? t.classList.remove(i)
				: xi(t, C((" " + Me(t) + " ").replace(" " + i + " ", " ")));
		}
		function xi(t, i) {
			t.className.baseVal === void 0
				? (t.className = i)
				: (t.className.baseVal = i);
		}
		function Me(t) {
			return (
				t.correspondingElement && (t = t.correspondingElement),
				t.className.baseVal === void 0 ? t.className : t.className.baseVal
			);
		}
		function Ai(t, i) {
			"opacity" in t.style
				? (t.style.opacity = i)
				: "filter" in t.style && Ln(t, i);
		}
		function Ln(t, i) {
			var a = !1,
				d = "DXImageTransform.Microsoft.Alpha";
			try {
				a = t.filters.item(d);
			} catch {
				if (i === 1) return;
			}
			((i = Math.round(i * 100)),
				a
					? ((a.Enabled = i !== 100), (a.Opacity = i))
					: (t.style.filter += " progid:" + d + "(opacity=" + i + ")"));
		}
		function kn(t) {
			for (var i = document.documentElement.style, a = 0; a < t.length; a++)
				if (t[a] in i) return t[a];
			return !1;
		}
		function wi(t, i, a) {
			var d = i || new _t(0, 0);
			t.style[pn] =
				(xt.ie3d
					? "translate(" + d.x + "px," + d.y + "px)"
					: "translate3d(" + d.x + "px," + d.y + "px,0)") +
				(a ? " scale(" + a + ")" : "");
		}
		function ui(t, i) {
			((t._leaflet_pos = i),
				xt.any3d
					? wi(t, i)
					: ((t.style.left = i.x + "px"), (t.style.top = i.y + "px")));
		}
		function Tt(t) {
			return t._leaflet_pos || new _t(0, 0);
		}
		var Cr, hs, fr;
		if ("onselectstart" in document)
			((Cr = function () {
				ee(window, "selectstart", Mi);
			}),
				(hs = function () {
					Be(window, "selectstart", Mi);
				}));
		else {
			var An = kn([
				"userSelect",
				"WebkitUserSelect",
				"OUserSelect",
				"MozUserSelect",
				"msUserSelect",
			]);
			((Cr = function () {
				if (An) {
					var t = document.documentElement.style;
					((fr = t[An]), (t[An] = "none"));
				}
			}),
				(hs = function () {
					An && ((document.documentElement.style[An] = fr), (fr = void 0));
				}));
		}
		function fs() {
			ee(window, "dragstart", Mi);
		}
		function Js() {
			Be(window, "dragstart", Mi);
		}
		var Pr, Hr;
		function ds(t) {
			for (; t.tabIndex === -1; ) t = t.parentNode;
			t.style &&
				(ps(),
				(Pr = t),
				(Hr = t.style.outlineStyle),
				(t.style.outlineStyle = "none"),
				ee(window, "keydown", ps));
		}
		function ps() {
			Pr &&
				((Pr.style.outlineStyle = Hr),
				(Pr = void 0),
				(Hr = void 0),
				Be(window, "keydown", ps));
		}
		function Qs(t) {
			do t = t.parentNode;
			while ((!t.offsetWidth || !t.offsetHeight) && t !== document.body);
			return t;
		}
		function Gr(t) {
			var i = t.getBoundingClientRect();
			return {
				x: i.width / t.offsetWidth || 1,
				y: i.height / t.offsetHeight || 1,
				boundingClientRect: i,
			};
		}
		var Io = {
			__proto__: null,
			TRANSFORM: pn,
			TRANSITION: Hi,
			TRANSITION_END: Er,
			get: Xn,
			getStyle: mn,
			create: ve,
			remove: Ke,
			empty: Bi,
			toFront: Pn,
			toBack: an,
			hasClass: ks,
			addClass: ue,
			removeClass: Je,
			setClass: xi,
			getClass: Me,
			setOpacity: Ai,
			testProp: kn,
			setTransform: wi,
			setPosition: ui,
			getPosition: Tt,
			get disableTextSelection() {
				return Cr;
			},
			get enableTextSelection() {
				return hs;
			},
			disableImageDrag: fs,
			enableImageDrag: Js,
			preventOutline: ds,
			restoreOutline: ps,
			getSizedParentNode: Qs,
			getScale: Gr,
		};
		function ee(t, i, a, d) {
			if (i && typeof i == "object") for (var x in i) As(t, x, i[x], a);
			else {
				i = O(i);
				for (var M = 0, q = i.length; M < q; M++) As(t, i[M], a, d);
			}
			return this;
		}
		var Mn = "_leaflet_events";
		function Be(t, i, a, d) {
			if (arguments.length === 1) (Yn(t), delete t[Mn]);
			else if (i && typeof i == "object") for (var x in i) Kn(t, x, i[x], a);
			else if (((i = O(i)), arguments.length === 2))
				Yn(t, function (J) {
					return V(i, J) !== -1;
				});
			else for (var M = 0, q = i.length; M < q; M++) Kn(t, i[M], a, d);
			return this;
		}
		function Yn(t, i) {
			for (var a in t[Mn]) {
				var d = a.split(/\d/)[0];
				(!i || i(d)) && Kn(t, d, null, null, a);
			}
		}
		var ms = {
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			wheel: !("onwheel" in window) && "mousewheel",
		};
		function As(t, i, a, d) {
			var x = i + f(a) + (d ? "_" + f(d) : "");
			if (t[Mn] && t[Mn][x]) return this;
			var M = function (J) {
					return a.call(d || t, J || window.event);
				},
				q = M;
			(!xt.touchNative && xt.pointer && i.indexOf("touch") === 0
				? (M = ki(t, i, M))
				: xt.touch && i === "dblclick"
					? (M = Fr(t, M))
					: "addEventListener" in t
						? i === "touchstart" ||
							i === "touchmove" ||
							i === "wheel" ||
							i === "mousewheel"
							? t.addEventListener(
									ms[i] || i,
									M,
									xt.passiveEvents ? { passive: !1 } : !1,
								)
							: i === "mouseenter" || i === "mouseleave"
								? ((M = function (J) {
										((J = J || window.event), _s(t, J) && q(J));
									}),
									t.addEventListener(ms[i], M, !1))
								: t.addEventListener(i, q, !1)
						: t.attachEvent("on" + i, M),
				(t[Mn] = t[Mn] || {}),
				(t[Mn][x] = M));
		}
		function Kn(t, i, a, d, x) {
			x = x || i + f(a) + (d ? "_" + f(d) : "");
			var M = t[Mn] && t[Mn][x];
			if (!M) return this;
			(!xt.touchNative && xt.pointer && i.indexOf("touch") === 0
				? $i(t, i, M)
				: xt.touch && i === "dblclick"
					? cs(t, M)
					: "removeEventListener" in t
						? t.removeEventListener(ms[i] || i, M, !1)
						: t.detachEvent("on" + i, M),
				(t[Mn][x] = null));
		}
		function qr(t) {
			return (
				t.stopPropagation
					? t.stopPropagation()
					: t.originalEvent
						? (t.originalEvent._stopped = !0)
						: (t.cancelBubble = !0),
				this
			);
		}
		function to(t) {
			return (As(t, "wheel", qr), this);
		}
		function gs(t) {
			return (
				ee(t, "mousedown touchstart dblclick contextmenu", qr),
				(t._leaflet_disable_click = !0),
				this
			);
		}
		function Mi(t) {
			return (
				t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
				this
			);
		}
		function dr(t) {
			return (Mi(t), qr(t), this);
		}
		function eo(t) {
			if (t.composedPath) return t.composedPath();
			for (var i = [], a = t.target; a; ) (i.push(a), (a = a.parentNode));
			return i;
		}
		function Ms(t, i) {
			if (!i) return new _t(t.clientX, t.clientY);
			var a = Gr(i),
				d = a.boundingClientRect;
			return new _t(
				(t.clientX - d.left) / a.x - i.clientLeft,
				(t.clientY - d.top) / a.y - i.clientTop,
			);
		}
		var Bo =
			xt.linux && xt.chrome
				? window.devicePixelRatio
				: xt.mac
					? window.devicePixelRatio * 3
					: window.devicePixelRatio > 0
						? 2 * window.devicePixelRatio
						: 1;
		function io(t) {
			return xt.edge
				? t.wheelDeltaY / 2
				: t.deltaY && t.deltaMode === 0
					? -t.deltaY / Bo
					: t.deltaY && t.deltaMode === 1
						? -t.deltaY * 20
						: t.deltaY && t.deltaMode === 2
							? -t.deltaY * 60
							: t.deltaX || t.deltaZ
								? 0
								: t.wheelDelta
									? (t.wheelDeltaY || t.wheelDelta) / 2
									: t.detail && Math.abs(t.detail) < 32765
										? -t.detail * 20
										: t.detail
											? (t.detail / -32765) * 60
											: 0;
		}
		function _s(t, i) {
			var a = i.relatedTarget;
			if (!a) return !0;
			try {
				for (; a && a !== t; ) a = a.parentNode;
			} catch {
				return !1;
			}
			return a !== t;
		}
		var ma = {
				__proto__: null,
				on: ee,
				off: Be,
				stopPropagation: qr,
				disableScrollPropagation: to,
				disableClickPropagation: gs,
				preventDefault: Mi,
				stop: dr,
				getPropagationPath: eo,
				getMousePosition: Ms,
				getWheelDelta: io,
				isExternalTarget: _s,
				addListener: ee,
				removeListener: Be,
			},
			zo = Ct.extend({
				run: function (t, i, a, d) {
					(this.stop(),
						(this._el = t),
						(this._inProgress = !0),
						(this._duration = a || 0.25),
						(this._easeOutPower = 1 / Math.max(d || 0.5, 0.2)),
						(this._startPos = Tt(t)),
						(this._offset = i.subtract(this._startPos)),
						(this._startTime = +new Date()),
						this.fire("start"),
						this._animate());
				},
				stop: function () {
					this._inProgress && (this._step(!0), this._complete());
				},
				_animate: function () {
					((this._animId = Dt(this._animate, this)), this._step());
				},
				_step: function (t) {
					var i = +new Date() - this._startTime,
						a = this._duration * 1e3;
					i < a
						? this._runFrame(this._easeOut(i / a), t)
						: (this._runFrame(1), this._complete());
				},
				_runFrame: function (t, i) {
					var a = this._startPos.add(this._offset.multiplyBy(t));
					(i && a._round(), ui(this._el, a), this.fire("step"));
				},
				_complete: function () {
					(pt(this._animId), (this._inProgress = !1), this.fire("end"));
				},
				_easeOut: function (t) {
					return 1 - Math.pow(1 - t, this._easeOutPower);
				},
			}),
			Se = Ct.extend({
				options: {
					crs: ne,
					center: void 0,
					zoom: void 0,
					minZoom: void 0,
					maxZoom: void 0,
					layers: [],
					maxBounds: void 0,
					renderer: void 0,
					zoomAnimation: !0,
					zoomAnimationThreshold: 4,
					fadeAnimation: !0,
					markerZoomAnimation: !0,
					transform3DLimit: 8388608,
					zoomSnap: 1,
					zoomDelta: 1,
					trackResize: !0,
				},
				initialize: function (t, i) {
					((i = P(this, i)),
						(this._handlers = []),
						(this._layers = {}),
						(this._zoomBoundLayers = {}),
						(this._sizeChanged = !0),
						this._initContainer(t),
						this._initLayout(),
						(this._onResize = l(this._onResize, this)),
						this._initEvents(),
						i.maxBounds && this.setMaxBounds(i.maxBounds),
						i.zoom !== void 0 && (this._zoom = this._limitZoom(i.zoom)),
						i.center &&
							i.zoom !== void 0 &&
							this.setView(U(i.center), i.zoom, { reset: !0 }),
						this.callInitHooks(),
						(this._zoomAnimated =
							Hi && xt.any3d && !xt.mobileOpera && this.options.zoomAnimation),
						this._zoomAnimated &&
							(this._createAnimProxy(),
							ee(this._proxy, Er, this._catchTransitionEnd, this)),
						this._addLayers(this.options.layers));
				},
				setView: function (t, i, a) {
					if (
						((i = i === void 0 ? this._zoom : this._limitZoom(i)),
						(t = this._limitCenter(U(t), i, this.options.maxBounds)),
						(a = a || {}),
						this._stop(),
						this._loaded && !a.reset && a !== !0)
					) {
						a.animate !== void 0 &&
							((a.zoom = s({ animate: a.animate }, a.zoom)),
							(a.pan = s({ animate: a.animate, duration: a.duration }, a.pan)));
						var d =
							this._zoom !== i
								? this._tryAnimatedZoom && this._tryAnimatedZoom(t, i, a.zoom)
								: this._tryAnimatedPan(t, a.pan);
						if (d) return (clearTimeout(this._sizeTimer), this);
					}
					return (this._resetView(t, i, a.pan && a.pan.noMoveStart), this);
				},
				setZoom: function (t, i) {
					return this._loaded
						? this.setView(this.getCenter(), t, { zoom: i })
						: ((this._zoom = t), this);
				},
				zoomIn: function (t, i) {
					return (
						(t = t || (xt.any3d ? this.options.zoomDelta : 1)),
						this.setZoom(this._zoom + t, i)
					);
				},
				zoomOut: function (t, i) {
					return (
						(t = t || (xt.any3d ? this.options.zoomDelta : 1)),
						this.setZoom(this._zoom - t, i)
					);
				},
				setZoomAround: function (t, i, a) {
					var d = this.getZoomScale(i),
						x = this.getSize().divideBy(2),
						M = t instanceof _t ? t : this.latLngToContainerPoint(t),
						q = M.subtract(x).multiplyBy(1 - 1 / d),
						J = this.containerPointToLatLng(x.add(q));
					return this.setView(J, i, { zoom: a });
				},
				_getBoundsCenterZoom: function (t, i) {
					((i = i || {}), (t = t.getBounds ? t.getBounds() : jt(t)));
					var a = W(i.paddingTopLeft || i.padding || [0, 0]),
						d = W(i.paddingBottomRight || i.padding || [0, 0]),
						x = this.getBoundsZoom(t, !1, a.add(d));
					if (
						((x = typeof i.maxZoom == "number" ? Math.min(i.maxZoom, x) : x),
						x === 1 / 0)
					)
						return { center: t.getCenter(), zoom: x };
					var M = d.subtract(a).divideBy(2),
						q = this.project(t.getSouthWest(), x),
						J = this.project(t.getNorthEast(), x),
						nt = this.unproject(q.add(J).divideBy(2).add(M), x);
					return { center: nt, zoom: x };
				},
				fitBounds: function (t, i) {
					if (((t = jt(t)), !t.isValid()))
						throw new Error("Bounds are not valid.");
					var a = this._getBoundsCenterZoom(t, i);
					return this.setView(a.center, a.zoom, i);
				},
				fitWorld: function (t) {
					return this.fitBounds(
						[
							[-90, -180],
							[90, 180],
						],
						t,
					);
				},
				panTo: function (t, i) {
					return this.setView(t, this._zoom, { pan: i });
				},
				panBy: function (t, i) {
					if (((t = W(t).round()), (i = i || {}), !t.x && !t.y))
						return this.fire("moveend");
					if (i.animate !== !0 && !this.getSize().contains(t))
						return (
							this._resetView(
								this.unproject(this.project(this.getCenter()).add(t)),
								this.getZoom(),
							),
							this
						);
					if (
						(this._panAnim ||
							((this._panAnim = new zo()),
							this._panAnim.on(
								{
									step: this._onPanTransitionStep,
									end: this._onPanTransitionEnd,
								},
								this,
							)),
						i.noMoveStart || this.fire("movestart"),
						i.animate !== !1)
					) {
						ue(this._mapPane, "leaflet-pan-anim");
						var a = this._getMapPanePos().subtract(t).round();
						this._panAnim.run(
							this._mapPane,
							a,
							i.duration || 0.25,
							i.easeLinearity,
						);
					} else (this._rawPanBy(t), this.fire("move").fire("moveend"));
					return this;
				},
				flyTo: function (t, i, a) {
					if (((a = a || {}), a.animate === !1 || !xt.any3d))
						return this.setView(t, i, a);
					this._stop();
					var d = this.project(this.getCenter()),
						x = this.project(t),
						M = this.getSize(),
						q = this._zoom;
					((t = U(t)), (i = i === void 0 ? q : i));
					var J = Math.max(M.x, M.y),
						nt = J * this.getZoomScale(q, i),
						ht = x.distanceTo(d) || 1,
						At = 1.42,
						Yt = At * At;
					function _e(hi) {
						var Ur = hi ? -1 : 1,
							cu = hi ? nt : J,
							hu = nt * nt - J * J + Ur * Yt * Yt * ht * ht,
							wa = 2 * cu * Yt * ht,
							Uo = hu / wa,
							fu = Math.sqrt(Uo * Uo + 1) - Uo,
							Sa = fu < 1e-9 ? -18 : Math.log(fu);
						return Sa;
					}
					function hn(hi) {
						return (Math.exp(hi) - Math.exp(-hi)) / 2;
					}
					function Wi(hi) {
						return (Math.exp(hi) + Math.exp(-hi)) / 2;
					}
					function rr(hi) {
						return hn(hi) / Wi(hi);
					}
					var yn = _e(0);
					function zs(hi) {
						return J * (Wi(yn) / Wi(yn + At * hi));
					}
					function cl(hi) {
						return (J * (Wi(yn) * rr(yn + At * hi) - hn(yn))) / Yt;
					}
					function hl(hi) {
						return 1 - Math.pow(1 - hi, 1.5);
					}
					var fl = Date.now(),
						jo = (_e(1) - yn) / At,
						xa = a.duration ? 1e3 * a.duration : 1e3 * jo * 0.8;
					function jr() {
						var hi = (Date.now() - fl) / xa,
							Ur = hl(hi) * jo;
						hi <= 1
							? ((this._flyToFrame = Dt(jr, this)),
								this._move(
									this.unproject(
										d.add(x.subtract(d).multiplyBy(cl(Ur) / ht)),
										q,
									),
									this.getScaleZoom(J / zs(Ur), q),
									{ flyTo: !0 },
								))
							: this._move(t, i)._moveEnd(!0);
					}
					return (this._moveStart(!0, a.noMoveStart), jr.call(this), this);
				},
				flyToBounds: function (t, i) {
					var a = this._getBoundsCenterZoom(t, i);
					return this.flyTo(a.center, a.zoom, i);
				},
				setMaxBounds: function (t) {
					return (
						(t = jt(t)),
						this.listens("moveend", this._panInsideMaxBounds) &&
							this.off("moveend", this._panInsideMaxBounds),
						t.isValid()
							? ((this.options.maxBounds = t),
								this._loaded && this._panInsideMaxBounds(),
								this.on("moveend", this._panInsideMaxBounds))
							: ((this.options.maxBounds = null), this)
					);
				},
				setMinZoom: function (t) {
					var i = this.options.minZoom;
					return (
						(this.options.minZoom = t),
						this._loaded &&
						i !== t &&
						(this.fire("zoomlevelschange"),
						this.getZoom() < this.options.minZoom)
							? this.setZoom(t)
							: this
					);
				},
				setMaxZoom: function (t) {
					var i = this.options.maxZoom;
					return (
						(this.options.maxZoom = t),
						this._loaded &&
						i !== t &&
						(this.fire("zoomlevelschange"),
						this.getZoom() > this.options.maxZoom)
							? this.setZoom(t)
							: this
					);
				},
				panInsideBounds: function (t, i) {
					this._enforcingBounds = !0;
					var a = this.getCenter(),
						d = this._limitCenter(a, this._zoom, jt(t));
					return (
						a.equals(d) || this.panTo(d, i),
						(this._enforcingBounds = !1),
						this
					);
				},
				panInside: function (t, i) {
					i = i || {};
					var a = W(i.paddingTopLeft || i.padding || [0, 0]),
						d = W(i.paddingBottomRight || i.padding || [0, 0]),
						x = this.project(this.getCenter()),
						M = this.project(t),
						q = this.getPixelBounds(),
						J = Zt([q.min.add(a), q.max.subtract(d)]),
						nt = J.getSize();
					if (!J.contains(M)) {
						this._enforcingBounds = !0;
						var ht = M.subtract(J.getCenter()),
							At = J.extend(M).getSize().subtract(nt);
						((x.x += ht.x < 0 ? -At.x : At.x),
							(x.y += ht.y < 0 ? -At.y : At.y),
							this.panTo(this.unproject(x), i),
							(this._enforcingBounds = !1));
					}
					return this;
				},
				invalidateSize: function (t) {
					if (!this._loaded) return this;
					t = s({ animate: !1, pan: !0 }, t === !0 ? { animate: !0 } : t);
					var i = this.getSize();
					((this._sizeChanged = !0), (this._lastCenter = null));
					var a = this.getSize(),
						d = i.divideBy(2).round(),
						x = a.divideBy(2).round(),
						M = d.subtract(x);
					return !M.x && !M.y
						? this
						: (t.animate && t.pan
								? this.panBy(M)
								: (t.pan && this._rawPanBy(M),
									this.fire("move"),
									t.debounceMoveend
										? (clearTimeout(this._sizeTimer),
											(this._sizeTimer = setTimeout(
												l(this.fire, this, "moveend"),
												200,
											)))
										: this.fire("moveend")),
							this.fire("resize", { oldSize: i, newSize: a }));
				},
				stop: function () {
					return (
						this.setZoom(this._limitZoom(this._zoom)),
						this.options.zoomSnap || this.fire("viewreset"),
						this._stop()
					);
				},
				locate: function (t) {
					if (
						((t = this._locateOptions = s({ timeout: 1e4, watch: !1 }, t)),
						!("geolocation" in navigator))
					)
						return (
							this._handleGeolocationError({
								code: 0,
								message: "Geolocation not supported.",
							}),
							this
						);
					var i = l(this._handleGeolocationResponse, this),
						a = l(this._handleGeolocationError, this);
					return (
						t.watch
							? (this._locationWatchId = navigator.geolocation.watchPosition(
									i,
									a,
									t,
								))
							: navigator.geolocation.getCurrentPosition(i, a, t),
						this
					);
				},
				stopLocate: function () {
					return (
						navigator.geolocation &&
							navigator.geolocation.clearWatch &&
							navigator.geolocation.clearWatch(this._locationWatchId),
						this._locateOptions && (this._locateOptions.setView = !1),
						this
					);
				},
				_handleGeolocationError: function (t) {
					if (this._container._leaflet_id) {
						var i = t.code,
							a =
								t.message ||
								(i === 1
									? "permission denied"
									: i === 2
										? "position unavailable"
										: "timeout");
						(this._locateOptions.setView && !this._loaded && this.fitWorld(),
							this.fire("locationerror", {
								code: i,
								message: "Geolocation error: " + a + ".",
							}));
					}
				},
				_handleGeolocationResponse: function (t) {
					if (this._container._leaflet_id) {
						var i = t.coords.latitude,
							a = t.coords.longitude,
							d = new Vt(i, a),
							x = d.toBounds(t.coords.accuracy * 2),
							M = this._locateOptions;
						if (M.setView) {
							var q = this.getBoundsZoom(x);
							this.setView(d, M.maxZoom ? Math.min(q, M.maxZoom) : q);
						}
						var J = { latlng: d, bounds: x, timestamp: t.timestamp };
						for (var nt in t.coords)
							typeof t.coords[nt] == "number" && (J[nt] = t.coords[nt]);
						this.fire("locationfound", J);
					}
				},
				addHandler: function (t, i) {
					if (!i) return this;
					var a = (this[t] = new i(this));
					return (this._handlers.push(a), this.options[t] && a.enable(), this);
				},
				remove: function () {
					if (
						(this._initEvents(!0),
						this.options.maxBounds &&
							this.off("moveend", this._panInsideMaxBounds),
						this._containerId !== this._container._leaflet_id)
					)
						throw new Error(
							"Map container is being reused by another instance",
						);
					try {
						(delete this._container._leaflet_id, delete this._containerId);
					} catch {
						((this._container._leaflet_id = void 0),
							(this._containerId = void 0));
					}
					(this._locationWatchId !== void 0 && this.stopLocate(),
						this._stop(),
						Ke(this._mapPane),
						this._clearControlPos && this._clearControlPos(),
						this._resizeRequest &&
							(pt(this._resizeRequest), (this._resizeRequest = null)),
						this._clearHandlers(),
						this._loaded && this.fire("unload"));
					var t;
					for (t in this._layers) this._layers[t].remove();
					for (t in this._panes) Ke(this._panes[t]);
					return (
						(this._layers = []),
						(this._panes = []),
						delete this._mapPane,
						delete this._renderer,
						this
					);
				},
				createPane: function (t, i) {
					var a =
							"leaflet-pane" +
							(t ? " leaflet-" + t.replace("Pane", "") + "-pane" : ""),
						d = ve("div", a, i || this._mapPane);
					return (t && (this._panes[t] = d), d);
				},
				getCenter: function () {
					return (
						this._checkIfLoaded(),
						this._lastCenter && !this._moved()
							? this._lastCenter.clone()
							: this.layerPointToLatLng(this._getCenterLayerPoint())
					);
				},
				getZoom: function () {
					return this._zoom;
				},
				getBounds: function () {
					var t = this.getPixelBounds(),
						i = this.unproject(t.getBottomLeft()),
						a = this.unproject(t.getTopRight());
					return new oe(i, a);
				},
				getMinZoom: function () {
					return this.options.minZoom === void 0
						? this._layersMinZoom || 0
						: this.options.minZoom;
				},
				getMaxZoom: function () {
					return this.options.maxZoom === void 0
						? this._layersMaxZoom === void 0
							? 1 / 0
							: this._layersMaxZoom
						: this.options.maxZoom;
				},
				getBoundsZoom: function (t, i, a) {
					((t = jt(t)), (a = W(a || [0, 0])));
					var d = this.getZoom() || 0,
						x = this.getMinZoom(),
						M = this.getMaxZoom(),
						q = t.getNorthWest(),
						J = t.getSouthEast(),
						nt = this.getSize().subtract(a),
						ht = Zt(this.project(J, d), this.project(q, d)).getSize(),
						At = xt.any3d ? this.options.zoomSnap : 1,
						Yt = nt.x / ht.x,
						_e = nt.y / ht.y,
						hn = i ? Math.max(Yt, _e) : Math.min(Yt, _e);
					return (
						(d = this.getScaleZoom(hn, d)),
						At &&
							((d = Math.round(d / (At / 100)) * (At / 100)),
							(d = i ? Math.ceil(d / At) * At : Math.floor(d / At) * At)),
						Math.max(x, Math.min(M, d))
					);
				},
				getSize: function () {
					return (
						(!this._size || this._sizeChanged) &&
							((this._size = new _t(
								this._container.clientWidth || 0,
								this._container.clientHeight || 0,
							)),
							(this._sizeChanged = !1)),
						this._size.clone()
					);
				},
				getPixelBounds: function (t, i) {
					var a = this._getTopLeftPoint(t, i);
					return new Wt(a, a.add(this.getSize()));
				},
				getPixelOrigin: function () {
					return (this._checkIfLoaded(), this._pixelOrigin);
				},
				getPixelWorldBounds: function (t) {
					return this.options.crs.getProjectedBounds(
						t === void 0 ? this.getZoom() : t,
					);
				},
				getPane: function (t) {
					return typeof t == "string" ? this._panes[t] : t;
				},
				getPanes: function () {
					return this._panes;
				},
				getContainer: function () {
					return this._container;
				},
				getZoomScale: function (t, i) {
					var a = this.options.crs;
					return ((i = i === void 0 ? this._zoom : i), a.scale(t) / a.scale(i));
				},
				getScaleZoom: function (t, i) {
					var a = this.options.crs;
					i = i === void 0 ? this._zoom : i;
					var d = a.zoom(t * a.scale(i));
					return isNaN(d) ? 1 / 0 : d;
				},
				project: function (t, i) {
					return (
						(i = i === void 0 ? this._zoom : i),
						this.options.crs.latLngToPoint(U(t), i)
					);
				},
				unproject: function (t, i) {
					return (
						(i = i === void 0 ? this._zoom : i),
						this.options.crs.pointToLatLng(W(t), i)
					);
				},
				layerPointToLatLng: function (t) {
					var i = W(t).add(this.getPixelOrigin());
					return this.unproject(i);
				},
				latLngToLayerPoint: function (t) {
					var i = this.project(U(t))._round();
					return i._subtract(this.getPixelOrigin());
				},
				wrapLatLng: function (t) {
					return this.options.crs.wrapLatLng(U(t));
				},
				wrapLatLngBounds: function (t) {
					return this.options.crs.wrapLatLngBounds(jt(t));
				},
				distance: function (t, i) {
					return this.options.crs.distance(U(t), U(i));
				},
				containerPointToLayerPoint: function (t) {
					return W(t).subtract(this._getMapPanePos());
				},
				layerPointToContainerPoint: function (t) {
					return W(t).add(this._getMapPanePos());
				},
				containerPointToLatLng: function (t) {
					var i = this.containerPointToLayerPoint(W(t));
					return this.layerPointToLatLng(i);
				},
				latLngToContainerPoint: function (t) {
					return this.layerPointToContainerPoint(this.latLngToLayerPoint(U(t)));
				},
				mouseEventToContainerPoint: function (t) {
					return Ms(t, this._container);
				},
				mouseEventToLayerPoint: function (t) {
					return this.containerPointToLayerPoint(
						this.mouseEventToContainerPoint(t),
					);
				},
				mouseEventToLatLng: function (t) {
					return this.layerPointToLatLng(this.mouseEventToLayerPoint(t));
				},
				_initContainer: function (t) {
					var i = (this._container = Xn(t));
					if (i) {
						if (i._leaflet_id)
							throw new Error("Map container is already initialized.");
					} else throw new Error("Map container not found.");
					(ee(i, "scroll", this._onScroll, this), (this._containerId = f(i)));
				},
				_initLayout: function () {
					var t = this._container;
					((this._fadeAnimated = this.options.fadeAnimation && xt.any3d),
						ue(
							t,
							"leaflet-container" +
								(xt.touch ? " leaflet-touch" : "") +
								(xt.retina ? " leaflet-retina" : "") +
								(xt.ielt9 ? " leaflet-oldie" : "") +
								(xt.safari ? " leaflet-safari" : "") +
								(this._fadeAnimated ? " leaflet-fade-anim" : ""),
						));
					var i = mn(t, "position");
					(i !== "absolute" &&
						i !== "relative" &&
						i !== "fixed" &&
						i !== "sticky" &&
						(t.style.position = "relative"),
						this._initPanes(),
						this._initControlPos && this._initControlPos());
				},
				_initPanes: function () {
					var t = (this._panes = {});
					((this._paneRenderers = {}),
						(this._mapPane = this.createPane("mapPane", this._container)),
						ui(this._mapPane, new _t(0, 0)),
						this.createPane("tilePane"),
						this.createPane("overlayPane"),
						this.createPane("shadowPane"),
						this.createPane("markerPane"),
						this.createPane("tooltipPane"),
						this.createPane("popupPane"),
						this.options.markerZoomAnimation ||
							(ue(t.markerPane, "leaflet-zoom-hide"),
							ue(t.shadowPane, "leaflet-zoom-hide")));
				},
				_resetView: function (t, i, a) {
					ui(this._mapPane, new _t(0, 0));
					var d = !this._loaded;
					((this._loaded = !0),
						(i = this._limitZoom(i)),
						this.fire("viewprereset"));
					var x = this._zoom !== i;
					(this._moveStart(x, a)._move(t, i)._moveEnd(x),
						this.fire("viewreset"),
						d && this.fire("load"));
				},
				_moveStart: function (t, i) {
					return (
						t && this.fire("zoomstart"),
						i || this.fire("movestart"),
						this
					);
				},
				_move: function (t, i, a, d) {
					i === void 0 && (i = this._zoom);
					var x = this._zoom !== i;
					return (
						(this._zoom = i),
						(this._lastCenter = t),
						(this._pixelOrigin = this._getNewPixelOrigin(t)),
						d
							? a && a.pinch && this.fire("zoom", a)
							: ((x || (a && a.pinch)) && this.fire("zoom", a),
								this.fire("move", a)),
						this
					);
				},
				_moveEnd: function (t) {
					return (t && this.fire("zoomend"), this.fire("moveend"));
				},
				_stop: function () {
					return (
						pt(this._flyToFrame),
						this._panAnim && this._panAnim.stop(),
						this
					);
				},
				_rawPanBy: function (t) {
					ui(this._mapPane, this._getMapPanePos().subtract(t));
				},
				_getZoomSpan: function () {
					return this.getMaxZoom() - this.getMinZoom();
				},
				_panInsideMaxBounds: function () {
					this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
				},
				_checkIfLoaded: function () {
					if (!this._loaded) throw new Error("Set map center and zoom first.");
				},
				_initEvents: function (t) {
					((this._targets = {}), (this._targets[f(this._container)] = this));
					var i = t ? Be : ee;
					(i(
						this._container,
						"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup",
						this._handleDOMEvent,
						this,
					),
						this.options.trackResize &&
							i(window, "resize", this._onResize, this),
						xt.any3d &&
							this.options.transform3DLimit &&
							(t ? this.off : this.on).call(this, "moveend", this._onMoveEnd));
				},
				_onResize: function () {
					(pt(this._resizeRequest),
						(this._resizeRequest = Dt(function () {
							this.invalidateSize({ debounceMoveend: !0 });
						}, this)));
				},
				_onScroll: function () {
					((this._container.scrollTop = 0), (this._container.scrollLeft = 0));
				},
				_onMoveEnd: function () {
					var t = this._getMapPanePos();
					Math.max(Math.abs(t.x), Math.abs(t.y)) >=
						this.options.transform3DLimit &&
						this._resetView(this.getCenter(), this.getZoom());
				},
				_findEventTargets: function (t, i) {
					for (
						var a = [],
							d,
							x = i === "mouseout" || i === "mouseover",
							M = t.target || t.srcElement,
							q = !1;
						M;
					) {
						if (
							((d = this._targets[f(M)]),
							d &&
								(i === "click" || i === "preclick") &&
								this._draggableMoved(d))
						) {
							q = !0;
							break;
						}
						if (
							(d && d.listens(i, !0) && ((x && !_s(M, t)) || (a.push(d), x))) ||
							M === this._container
						)
							break;
						M = M.parentNode;
					}
					return (
						!a.length && !q && !x && this.listens(i, !0) && (a = [this]),
						a
					);
				},
				_isClickDisabled: function (t) {
					for (; t && t !== this._container; ) {
						if (t._leaflet_disable_click) return !0;
						t = t.parentNode;
					}
				},
				_handleDOMEvent: function (t) {
					var i = t.target || t.srcElement;
					if (
						!(
							!this._loaded ||
							i._leaflet_disable_events ||
							(t.type === "click" && this._isClickDisabled(i))
						)
					) {
						var a = t.type;
						(a === "mousedown" && ds(i), this._fireDOMEvent(t, a));
					}
				},
				_mouseEvents: [
					"click",
					"dblclick",
					"mouseover",
					"mouseout",
					"contextmenu",
				],
				_fireDOMEvent: function (t, i, a) {
					if (t.type === "click") {
						var d = s({}, t);
						((d.type = "preclick"), this._fireDOMEvent(d, d.type, a));
					}
					var x = this._findEventTargets(t, i);
					if (a) {
						for (var M = [], q = 0; q < a.length; q++)
							a[q].listens(i, !0) && M.push(a[q]);
						x = M.concat(x);
					}
					if (x.length) {
						i === "contextmenu" && Mi(t);
						var J = x[0],
							nt = { originalEvent: t };
						if (
							t.type !== "keypress" &&
							t.type !== "keydown" &&
							t.type !== "keyup"
						) {
							var ht = J.getLatLng && (!J._radius || J._radius <= 10);
							((nt.containerPoint = ht
								? this.latLngToContainerPoint(J.getLatLng())
								: this.mouseEventToContainerPoint(t)),
								(nt.layerPoint = this.containerPointToLayerPoint(
									nt.containerPoint,
								)),
								(nt.latlng = ht
									? J.getLatLng()
									: this.layerPointToLatLng(nt.layerPoint)));
						}
						for (q = 0; q < x.length; q++)
							if (
								(x[q].fire(i, nt, !0),
								nt.originalEvent._stopped ||
									(x[q].options.bubblingMouseEvents === !1 &&
										V(this._mouseEvents, i) !== -1))
							)
								return;
					}
				},
				_draggableMoved: function (t) {
					return (
						(t = t.dragging && t.dragging.enabled() ? t : this),
						(t.dragging && t.dragging.moved()) ||
							(this.boxZoom && this.boxZoom.moved())
					);
				},
				_clearHandlers: function () {
					for (var t = 0, i = this._handlers.length; t < i; t++)
						this._handlers[t].disable();
				},
				whenReady: function (t, i) {
					return (
						this._loaded
							? t.call(i || this, { target: this })
							: this.on("load", t, i),
						this
					);
				},
				_getMapPanePos: function () {
					return Tt(this._mapPane) || new _t(0, 0);
				},
				_moved: function () {
					var t = this._getMapPanePos();
					return t && !t.equals([0, 0]);
				},
				_getTopLeftPoint: function (t, i) {
					var a =
						t && i !== void 0
							? this._getNewPixelOrigin(t, i)
							: this.getPixelOrigin();
					return a.subtract(this._getMapPanePos());
				},
				_getNewPixelOrigin: function (t, i) {
					var a = this.getSize()._divideBy(2);
					return this.project(t, i)
						._subtract(a)
						._add(this._getMapPanePos())
						._round();
				},
				_latLngToNewLayerPoint: function (t, i, a) {
					var d = this._getNewPixelOrigin(a, i);
					return this.project(t, i)._subtract(d);
				},
				_latLngBoundsToNewLayerBounds: function (t, i, a) {
					var d = this._getNewPixelOrigin(a, i);
					return Zt([
						this.project(t.getSouthWest(), i)._subtract(d),
						this.project(t.getNorthWest(), i)._subtract(d),
						this.project(t.getSouthEast(), i)._subtract(d),
						this.project(t.getNorthEast(), i)._subtract(d),
					]);
				},
				_getCenterLayerPoint: function () {
					return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
				},
				_getCenterOffset: function (t) {
					return this.latLngToLayerPoint(t).subtract(
						this._getCenterLayerPoint(),
					);
				},
				_limitCenter: function (t, i, a) {
					if (!a) return t;
					var d = this.project(t, i),
						x = this.getSize().divideBy(2),
						M = new Wt(d.subtract(x), d.add(x)),
						q = this._getBoundsOffset(M, a, i);
					return Math.abs(q.x) <= 1 && Math.abs(q.y) <= 1
						? t
						: this.unproject(d.add(q), i);
				},
				_limitOffset: function (t, i) {
					if (!i) return t;
					var a = this.getPixelBounds(),
						d = new Wt(a.min.add(t), a.max.add(t));
					return t.add(this._getBoundsOffset(d, i));
				},
				_getBoundsOffset: function (t, i, a) {
					var d = Zt(
							this.project(i.getNorthEast(), a),
							this.project(i.getSouthWest(), a),
						),
						x = d.min.subtract(t.min),
						M = d.max.subtract(t.max),
						q = this._rebound(x.x, -M.x),
						J = this._rebound(x.y, -M.y);
					return new _t(q, J);
				},
				_rebound: function (t, i) {
					return t + i > 0
						? Math.round(t - i) / 2
						: Math.max(0, Math.ceil(t)) - Math.max(0, Math.floor(i));
				},
				_limitZoom: function (t) {
					var i = this.getMinZoom(),
						a = this.getMaxZoom(),
						d = xt.any3d ? this.options.zoomSnap : 1;
					return (
						d && (t = Math.round(t / d) * d),
						Math.max(i, Math.min(a, t))
					);
				},
				_onPanTransitionStep: function () {
					this.fire("move");
				},
				_onPanTransitionEnd: function () {
					(Je(this._mapPane, "leaflet-pan-anim"), this.fire("moveend"));
				},
				_tryAnimatedPan: function (t, i) {
					var a = this._getCenterOffset(t)._trunc();
					return (i && i.animate) !== !0 && !this.getSize().contains(a)
						? !1
						: (this.panBy(a, i), !0);
				},
				_createAnimProxy: function () {
					var t = (this._proxy = ve(
						"div",
						"leaflet-proxy leaflet-zoom-animated",
					));
					(this._panes.mapPane.appendChild(t),
						this.on(
							"zoomanim",
							function (i) {
								var a = pn,
									d = this._proxy.style[a];
								(wi(
									this._proxy,
									this.project(i.center, i.zoom),
									this.getZoomScale(i.zoom, 1),
								),
									d === this._proxy.style[a] &&
										this._animatingZoom &&
										this._onZoomTransitionEnd());
							},
							this,
						),
						this.on("load moveend", this._animMoveEnd, this),
						this._on("unload", this._destroyAnimProxy, this));
				},
				_destroyAnimProxy: function () {
					(Ke(this._proxy),
						this.off("load moveend", this._animMoveEnd, this),
						delete this._proxy);
				},
				_animMoveEnd: function () {
					var t = this.getCenter(),
						i = this.getZoom();
					wi(this._proxy, this.project(t, i), this.getZoomScale(i, 1));
				},
				_catchTransitionEnd: function (t) {
					this._animatingZoom &&
						t.propertyName.indexOf("transform") >= 0 &&
						this._onZoomTransitionEnd();
				},
				_nothingToAnimate: function () {
					return !this._container.getElementsByClassName(
						"leaflet-zoom-animated",
					).length;
				},
				_tryAnimatedZoom: function (t, i, a) {
					if (this._animatingZoom) return !0;
					if (
						((a = a || {}),
						!this._zoomAnimated ||
							a.animate === !1 ||
							this._nothingToAnimate() ||
							Math.abs(i - this._zoom) > this.options.zoomAnimationThreshold)
					)
						return !1;
					var d = this.getZoomScale(i),
						x = this._getCenterOffset(t)._divideBy(1 - 1 / d);
					return a.animate !== !0 && !this.getSize().contains(x)
						? !1
						: (Dt(function () {
								this._moveStart(!0, a.noMoveStart || !1)._animateZoom(t, i, !0);
							}, this),
							!0);
				},
				_animateZoom: function (t, i, a, d) {
					this._mapPane &&
						(a &&
							((this._animatingZoom = !0),
							(this._animateToCenter = t),
							(this._animateToZoom = i),
							ue(this._mapPane, "leaflet-zoom-anim")),
						this.fire("zoomanim", { center: t, zoom: i, noUpdate: d }),
						this._tempFireZoomEvent ||
							(this._tempFireZoomEvent = this._zoom !== this._animateToZoom),
						this._move(this._animateToCenter, this._animateToZoom, void 0, !0),
						setTimeout(l(this._onZoomTransitionEnd, this), 250));
				},
				_onZoomTransitionEnd: function () {
					this._animatingZoom &&
						(this._mapPane && Je(this._mapPane, "leaflet-zoom-anim"),
						(this._animatingZoom = !1),
						this._move(this._animateToCenter, this._animateToZoom, void 0, !0),
						this._tempFireZoomEvent && this.fire("zoom"),
						delete this._tempFireZoomEvent,
						this.fire("move"),
						this._moveEnd(!0));
				},
			});
		function vs(t, i) {
			return new Se(t, i);
		}
		var gn = K.extend({
				options: { position: "topright" },
				initialize: function (t) {
					P(this, t);
				},
				getPosition: function () {
					return this.options.position;
				},
				setPosition: function (t) {
					var i = this._map;
					return (
						i && i.removeControl(this),
						(this.options.position = t),
						i && i.addControl(this),
						this
					);
				},
				getContainer: function () {
					return this._container;
				},
				addTo: function (t) {
					(this.remove(), (this._map = t));
					var i = (this._container = this.onAdd(t)),
						a = this.getPosition(),
						d = t._controlCorners[a];
					return (
						ue(i, "leaflet-control"),
						a.indexOf("bottom") !== -1
							? d.insertBefore(i, d.firstChild)
							: d.appendChild(i),
						this._map.on("unload", this.remove, this),
						this
					);
				},
				remove: function () {
					return this._map
						? (Ke(this._container),
							this.onRemove && this.onRemove(this._map),
							this._map.off("unload", this.remove, this),
							(this._map = null),
							this)
						: this;
				},
				_refocusOnMap: function (t) {
					this._map &&
						t &&
						t.screenX > 0 &&
						t.screenY > 0 &&
						this._map.getContainer().focus();
				},
			}),
			Wr = function (t) {
				return new gn(t);
			};
		Se.include({
			addControl: function (t) {
				return (t.addTo(this), this);
			},
			removeControl: function (t) {
				return (t.remove(), this);
			},
			_initControlPos: function () {
				var t = (this._controlCorners = {}),
					i = "leaflet-",
					a = (this._controlContainer = ve(
						"div",
						i + "control-container",
						this._container,
					));
				function d(x, M) {
					var q = i + x + " " + i + M;
					t[x + M] = ve("div", q, a);
				}
				(d("top", "left"),
					d("top", "right"),
					d("bottom", "left"),
					d("bottom", "right"));
			},
			_clearControlPos: function () {
				for (var t in this._controlCorners) Ke(this._controlCorners[t]);
				(Ke(this._controlContainer),
					delete this._controlCorners,
					delete this._controlContainer);
			},
		});
		var No = gn.extend({
				options: {
					collapsed: !0,
					position: "topright",
					autoZIndex: !0,
					hideSingleBase: !1,
					sortLayers: !1,
					sortFunction: function (t, i, a, d) {
						return a < d ? -1 : d < a ? 1 : 0;
					},
				},
				initialize: function (t, i, a) {
					(P(this, a),
						(this._layerControlInputs = []),
						(this._layers = []),
						(this._lastZIndex = 0),
						(this._handlingClick = !1),
						(this._preventClick = !1));
					for (var d in t) this._addLayer(t[d], d);
					for (d in i) this._addLayer(i[d], d, !0);
				},
				onAdd: function (t) {
					(this._initLayout(),
						this._update(),
						(this._map = t),
						t.on("zoomend", this._checkDisabledLayers, this));
					for (var i = 0; i < this._layers.length; i++)
						this._layers[i].layer.on("add remove", this._onLayerChange, this);
					return this._container;
				},
				addTo: function (t) {
					return (
						gn.prototype.addTo.call(this, t),
						this._expandIfNotCollapsed()
					);
				},
				onRemove: function () {
					this._map.off("zoomend", this._checkDisabledLayers, this);
					for (var t = 0; t < this._layers.length; t++)
						this._layers[t].layer.off("add remove", this._onLayerChange, this);
				},
				addBaseLayer: function (t, i) {
					return (this._addLayer(t, i), this._map ? this._update() : this);
				},
				addOverlay: function (t, i) {
					return (this._addLayer(t, i, !0), this._map ? this._update() : this);
				},
				removeLayer: function (t) {
					t.off("add remove", this._onLayerChange, this);
					var i = this._getLayer(f(t));
					return (
						i && this._layers.splice(this._layers.indexOf(i), 1),
						this._map ? this._update() : this
					);
				},
				expand: function () {
					(ue(this._container, "leaflet-control-layers-expanded"),
						(this._section.style.height = null));
					var t = this._map.getSize().y - (this._container.offsetTop + 50);
					return (
						t < this._section.clientHeight
							? (ue(this._section, "leaflet-control-layers-scrollbar"),
								(this._section.style.height = t + "px"))
							: Je(this._section, "leaflet-control-layers-scrollbar"),
						this._checkDisabledLayers(),
						this
					);
				},
				collapse: function () {
					return (Je(this._container, "leaflet-control-layers-expanded"), this);
				},
				_initLayout: function () {
					var t = "leaflet-control-layers",
						i = (this._container = ve("div", t)),
						a = this.options.collapsed;
					(i.setAttribute("aria-haspopup", !0), gs(i), to(i));
					var d = (this._section = ve("section", t + "-list"));
					a &&
						(this._map.on("click", this.collapse, this),
						ee(
							i,
							{ mouseenter: this._expandSafely, mouseleave: this.collapse },
							this,
						));
					var x = (this._layersLink = ve("a", t + "-toggle", i));
					((x.href = "#"),
						(x.title = "Layers"),
						x.setAttribute("role", "button"),
						ee(
							x,
							{
								keydown: function (M) {
									M.keyCode === 13 && this._expandSafely();
								},
								click: function (M) {
									(Mi(M), this._expandSafely());
								},
							},
							this,
						),
						a || this.expand(),
						(this._baseLayersList = ve("div", t + "-base", d)),
						(this._separator = ve("div", t + "-separator", d)),
						(this._overlaysList = ve("div", t + "-overlays", d)),
						i.appendChild(d));
				},
				_getLayer: function (t) {
					for (var i = 0; i < this._layers.length; i++)
						if (this._layers[i] && f(this._layers[i].layer) === t)
							return this._layers[i];
				},
				_addLayer: function (t, i, a) {
					(this._map && t.on("add remove", this._onLayerChange, this),
						this._layers.push({ layer: t, name: i, overlay: a }),
						this.options.sortLayers &&
							this._layers.sort(
								l(function (d, x) {
									return this.options.sortFunction(
										d.layer,
										x.layer,
										d.name,
										x.name,
									);
								}, this),
							),
						this.options.autoZIndex &&
							t.setZIndex &&
							(this._lastZIndex++, t.setZIndex(this._lastZIndex)),
						this._expandIfNotCollapsed());
				},
				_update: function () {
					if (!this._container) return this;
					(Bi(this._baseLayersList),
						Bi(this._overlaysList),
						(this._layerControlInputs = []));
					var t,
						i,
						a,
						d,
						x = 0;
					for (a = 0; a < this._layers.length; a++)
						((d = this._layers[a]),
							this._addItem(d),
							(i = i || d.overlay),
							(t = t || !d.overlay),
							(x += d.overlay ? 0 : 1));
					return (
						this.options.hideSingleBase &&
							((t = t && x > 1),
							(this._baseLayersList.style.display = t ? "" : "none")),
						(this._separator.style.display = i && t ? "" : "none"),
						this
					);
				},
				_onLayerChange: function (t) {
					this._handlingClick || this._update();
					var i = this._getLayer(f(t.target)),
						a = i.overlay
							? t.type === "add"
								? "overlayadd"
								: "overlayremove"
							: t.type === "add"
								? "baselayerchange"
								: null;
					a && this._map.fire(a, i);
				},
				_createRadioElement: function (t, i) {
					var a =
							'<input type="radio" class="leaflet-control-layers-selector" name="' +
							t +
							'"' +
							(i ? ' checked="checked"' : "") +
							"/>",
						d = document.createElement("div");
					return ((d.innerHTML = a), d.firstChild);
				},
				_addItem: function (t) {
					var i = document.createElement("label"),
						a = this._map.hasLayer(t.layer),
						d;
					(t.overlay
						? ((d = document.createElement("input")),
							(d.type = "checkbox"),
							(d.className = "leaflet-control-layers-selector"),
							(d.defaultChecked = a))
						: (d = this._createRadioElement(
								"leaflet-base-layers_" + f(this),
								a,
							)),
						this._layerControlInputs.push(d),
						(d.layerId = f(t.layer)),
						ee(d, "click", this._onInputClick, this));
					var x = document.createElement("span");
					x.innerHTML = " " + t.name;
					var M = document.createElement("span");
					(i.appendChild(M), M.appendChild(d), M.appendChild(x));
					var q = t.overlay ? this._overlaysList : this._baseLayersList;
					return (q.appendChild(i), this._checkDisabledLayers(), i);
				},
				_onInputClick: function () {
					if (!this._preventClick) {
						var t = this._layerControlInputs,
							i,
							a,
							d = [],
							x = [];
						this._handlingClick = !0;
						for (var M = t.length - 1; M >= 0; M--)
							((i = t[M]),
								(a = this._getLayer(i.layerId).layer),
								i.checked ? d.push(a) : i.checked || x.push(a));
						for (M = 0; M < x.length; M++)
							this._map.hasLayer(x[M]) && this._map.removeLayer(x[M]);
						for (M = 0; M < d.length; M++)
							this._map.hasLayer(d[M]) || this._map.addLayer(d[M]);
						((this._handlingClick = !1), this._refocusOnMap());
					}
				},
				_checkDisabledLayers: function () {
					for (
						var t = this._layerControlInputs,
							i,
							a,
							d = this._map.getZoom(),
							x = t.length - 1;
						x >= 0;
						x--
					)
						((i = t[x]),
							(a = this._getLayer(i.layerId).layer),
							(i.disabled =
								(a.options.minZoom !== void 0 && d < a.options.minZoom) ||
								(a.options.maxZoom !== void 0 && d > a.options.maxZoom)));
				},
				_expandIfNotCollapsed: function () {
					return (this._map && !this.options.collapsed && this.expand(), this);
				},
				_expandSafely: function () {
					var t = this._section;
					((this._preventClick = !0), ee(t, "click", Mi), this.expand());
					var i = this;
					setTimeout(function () {
						(Be(t, "click", Mi), (i._preventClick = !1));
					});
				},
			}),
			ga = function (t, i, a) {
				return new No(t, i, a);
			},
			Os = gn.extend({
				options: {
					position: "topleft",
					zoomInText: '<span aria-hidden="true">+</span>',
					zoomInTitle: "Zoom in",
					zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
					zoomOutTitle: "Zoom out",
				},
				onAdd: function (t) {
					var i = "leaflet-control-zoom",
						a = ve("div", i + " leaflet-bar"),
						d = this.options;
					return (
						(this._zoomInButton = this._createButton(
							d.zoomInText,
							d.zoomInTitle,
							i + "-in",
							a,
							this._zoomIn,
						)),
						(this._zoomOutButton = this._createButton(
							d.zoomOutText,
							d.zoomOutTitle,
							i + "-out",
							a,
							this._zoomOut,
						)),
						this._updateDisabled(),
						t.on("zoomend zoomlevelschange", this._updateDisabled, this),
						a
					);
				},
				onRemove: function (t) {
					t.off("zoomend zoomlevelschange", this._updateDisabled, this);
				},
				disable: function () {
					return ((this._disabled = !0), this._updateDisabled(), this);
				},
				enable: function () {
					return ((this._disabled = !1), this._updateDisabled(), this);
				},
				_zoomIn: function (t) {
					!this._disabled &&
						this._map._zoom < this._map.getMaxZoom() &&
						this._map.zoomIn(
							this._map.options.zoomDelta * (t.shiftKey ? 3 : 1),
						);
				},
				_zoomOut: function (t) {
					!this._disabled &&
						this._map._zoom > this._map.getMinZoom() &&
						this._map.zoomOut(
							this._map.options.zoomDelta * (t.shiftKey ? 3 : 1),
						);
				},
				_createButton: function (t, i, a, d, x) {
					var M = ve("a", a, d);
					return (
						(M.innerHTML = t),
						(M.href = "#"),
						(M.title = i),
						M.setAttribute("role", "button"),
						M.setAttribute("aria-label", i),
						gs(M),
						ee(M, "click", dr),
						ee(M, "click", x, this),
						ee(M, "click", this._refocusOnMap, this),
						M
					);
				},
				_updateDisabled: function () {
					var t = this._map,
						i = "leaflet-disabled";
					(Je(this._zoomInButton, i),
						Je(this._zoomOutButton, i),
						this._zoomInButton.setAttribute("aria-disabled", "false"),
						this._zoomOutButton.setAttribute("aria-disabled", "false"),
						(this._disabled || t._zoom === t.getMinZoom()) &&
							(ue(this._zoomOutButton, i),
							this._zoomOutButton.setAttribute("aria-disabled", "true")),
						(this._disabled || t._zoom === t.getMaxZoom()) &&
							(ue(this._zoomInButton, i),
							this._zoomInButton.setAttribute("aria-disabled", "true")));
				},
			});
		(Se.mergeOptions({ zoomControl: !0 }),
			Se.addInitHook(function () {
				this.options.zoomControl &&
					((this.zoomControl = new Os()), this.addControl(this.zoomControl));
			}));
		var o = function (t) {
				return new Os(t);
			},
			c = gn.extend({
				options: {
					position: "bottomleft",
					maxWidth: 100,
					metric: !0,
					imperial: !0,
				},
				onAdd: function (t) {
					var i = "leaflet-control-scale",
						a = ve("div", i),
						d = this.options;
					return (
						this._addScales(d, i + "-line", a),
						t.on(d.updateWhenIdle ? "moveend" : "move", this._update, this),
						t.whenReady(this._update, this),
						a
					);
				},
				onRemove: function (t) {
					t.off(
						this.options.updateWhenIdle ? "moveend" : "move",
						this._update,
						this,
					);
				},
				_addScales: function (t, i, a) {
					(t.metric && (this._mScale = ve("div", i, a)),
						t.imperial && (this._iScale = ve("div", i, a)));
				},
				_update: function () {
					var t = this._map,
						i = t.getSize().y / 2,
						a = t.distance(
							t.containerPointToLatLng([0, i]),
							t.containerPointToLatLng([this.options.maxWidth, i]),
						);
					this._updateScales(a);
				},
				_updateScales: function (t) {
					(this.options.metric && t && this._updateMetric(t),
						this.options.imperial && t && this._updateImperial(t));
				},
				_updateMetric: function (t) {
					var i = this._getRoundNum(t),
						a = i < 1e3 ? i + " m" : i / 1e3 + " km";
					this._updateScale(this._mScale, a, i / t);
				},
				_updateImperial: function (t) {
					var i = t * 3.2808399,
						a,
						d,
						x;
					i > 5280
						? ((a = i / 5280),
							(d = this._getRoundNum(a)),
							this._updateScale(this._iScale, d + " mi", d / a))
						: ((x = this._getRoundNum(i)),
							this._updateScale(this._iScale, x + " ft", x / i));
				},
				_updateScale: function (t, i, a) {
					((t.style.width = Math.round(this.options.maxWidth * a) + "px"),
						(t.innerHTML = i));
				},
				_getRoundNum: function (t) {
					var i = Math.pow(10, (Math.floor(t) + "").length - 1),
						a = t / i;
					return (
						(a = a >= 10 ? 10 : a >= 5 ? 5 : a >= 3 ? 3 : a >= 2 ? 2 : 1),
						i * a
					);
				},
			}),
			_ = function (t) {
				return new c(t);
			},
			y =
				'<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>',
			S = gn.extend({
				options: {
					position: "bottomright",
					prefix:
						'<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' +
						(xt.inlineSvg ? y + " " : "") +
						"Leaflet</a>",
				},
				initialize: function (t) {
					(P(this, t), (this._attributions = {}));
				},
				onAdd: function (t) {
					((t.attributionControl = this),
						(this._container = ve("div", "leaflet-control-attribution")),
						gs(this._container));
					for (var i in t._layers)
						t._layers[i].getAttribution &&
							this.addAttribution(t._layers[i].getAttribution());
					return (
						this._update(),
						t.on("layeradd", this._addAttribution, this),
						this._container
					);
				},
				onRemove: function (t) {
					t.off("layeradd", this._addAttribution, this);
				},
				_addAttribution: function (t) {
					t.layer.getAttribution &&
						(this.addAttribution(t.layer.getAttribution()),
						t.layer.once(
							"remove",
							function () {
								this.removeAttribution(t.layer.getAttribution());
							},
							this,
						));
				},
				setPrefix: function (t) {
					return ((this.options.prefix = t), this._update(), this);
				},
				addAttribution: function (t) {
					return t
						? (this._attributions[t] || (this._attributions[t] = 0),
							this._attributions[t]++,
							this._update(),
							this)
						: this;
				},
				removeAttribution: function (t) {
					return t
						? (this._attributions[t] &&
								(this._attributions[t]--, this._update()),
							this)
						: this;
				},
				_update: function () {
					if (this._map) {
						var t = [];
						for (var i in this._attributions)
							this._attributions[i] && t.push(i);
						var a = [];
						(this.options.prefix && a.push(this.options.prefix),
							t.length && a.push(t.join(", ")),
							(this._container.innerHTML = a.join(
								' <span aria-hidden="true">|</span> ',
							)));
					}
				},
			});
		(Se.mergeOptions({ attributionControl: !0 }),
			Se.addInitHook(function () {
				this.options.attributionControl && new S().addTo(this);
			}));
		var T = function (t) {
			return new S(t);
		};
		((gn.Layers = No),
			(gn.Zoom = Os),
			(gn.Scale = c),
			(gn.Attribution = S),
			(Wr.layers = ga),
			(Wr.zoom = o),
			(Wr.scale = _),
			(Wr.attribution = T));
		var k = K.extend({
			initialize: function (t) {
				this._map = t;
			},
			enable: function () {
				return this._enabled
					? this
					: ((this._enabled = !0), this.addHooks(), this);
			},
			disable: function () {
				return this._enabled
					? ((this._enabled = !1), this.removeHooks(), this)
					: this;
			},
			enabled: function () {
				return !!this._enabled;
			},
		});
		k.addTo = function (t, i) {
			return (t.addHandler(i, this), this);
		};
		var H = { Events: St },
			R = xt.touch ? "touchstart mousedown" : "mousedown",
			$ = Ct.extend({
				options: { clickTolerance: 3 },
				initialize: function (t, i, a, d) {
					(P(this, d),
						(this._element = t),
						(this._dragStartTarget = i || t),
						(this._preventOutline = a));
				},
				enable: function () {
					this._enabled ||
						(ee(this._dragStartTarget, R, this._onDown, this),
						(this._enabled = !0));
				},
				disable: function () {
					this._enabled &&
						($._dragging === this && this.finishDrag(!0),
						Be(this._dragStartTarget, R, this._onDown, this),
						(this._enabled = !1),
						(this._moved = !1));
				},
				_onDown: function (t) {
					if (
						this._enabled &&
						((this._moved = !1), !ks(this._element, "leaflet-zoom-anim"))
					) {
						if (t.touches && t.touches.length !== 1) {
							$._dragging === this && this.finishDrag();
							return;
						}
						if (
							!(
								$._dragging ||
								t.shiftKey ||
								(t.which !== 1 && t.button !== 1 && !t.touches)
							) &&
							(($._dragging = this),
							this._preventOutline && ds(this._element),
							fs(),
							Cr(),
							!this._moving)
						) {
							this.fire("down");
							var i = t.touches ? t.touches[0] : t,
								a = Qs(this._element);
							((this._startPoint = new _t(i.clientX, i.clientY)),
								(this._startPos = Tt(this._element)),
								(this._parentScale = Gr(a)));
							var d = t.type === "mousedown";
							(ee(document, d ? "mousemove" : "touchmove", this._onMove, this),
								ee(
									document,
									d ? "mouseup" : "touchend touchcancel",
									this._onUp,
									this,
								));
						}
					}
				},
				_onMove: function (t) {
					if (this._enabled) {
						if (t.touches && t.touches.length > 1) {
							this._moved = !0;
							return;
						}
						var i = t.touches && t.touches.length === 1 ? t.touches[0] : t,
							a = new _t(i.clientX, i.clientY)._subtract(this._startPoint);
						(!a.x && !a.y) ||
							Math.abs(a.x) + Math.abs(a.y) < this.options.clickTolerance ||
							((a.x /= this._parentScale.x),
							(a.y /= this._parentScale.y),
							Mi(t),
							this._moved ||
								(this.fire("dragstart"),
								(this._moved = !0),
								ue(document.body, "leaflet-dragging"),
								(this._lastTarget = t.target || t.srcElement),
								window.SVGElementInstance &&
									this._lastTarget instanceof window.SVGElementInstance &&
									(this._lastTarget = this._lastTarget.correspondingUseElement),
								ue(this._lastTarget, "leaflet-drag-target")),
							(this._newPos = this._startPos.add(a)),
							(this._moving = !0),
							(this._lastEvent = t),
							this._updatePosition());
					}
				},
				_updatePosition: function () {
					var t = { originalEvent: this._lastEvent };
					(this.fire("predrag", t),
						ui(this._element, this._newPos),
						this.fire("drag", t));
				},
				_onUp: function () {
					this._enabled && this.finishDrag();
				},
				finishDrag: function (t) {
					(Je(document.body, "leaflet-dragging"),
						this._lastTarget &&
							(Je(this._lastTarget, "leaflet-drag-target"),
							(this._lastTarget = null)),
						Be(document, "mousemove touchmove", this._onMove, this),
						Be(document, "mouseup touchend touchcancel", this._onUp, this),
						Js(),
						hs());
					var i = this._moved && this._moving;
					((this._moving = !1),
						($._dragging = !1),
						i &&
							this.fire("dragend", {
								noInertia: t,
								distance: this._newPos.distanceTo(this._startPos),
							}));
				},
			});
		function rt(t, i, a) {
			var d,
				x = [1, 4, 2, 8],
				M,
				q,
				J,
				nt,
				ht,
				At,
				Yt,
				_e;
			for (M = 0, At = t.length; M < At; M++) t[M]._code = fe(t[M], i);
			for (J = 0; J < 4; J++) {
				for (
					Yt = x[J], d = [], M = 0, At = t.length, q = At - 1;
					M < At;
					q = M++
				)
					((nt = t[M]),
						(ht = t[q]),
						nt._code & Yt
							? ht._code & Yt ||
								((_e = Qn(ht, nt, Yt, i, a)),
								(_e._code = fe(_e, i)),
								d.push(_e))
							: (ht._code & Yt &&
									((_e = Qn(ht, nt, Yt, i, a)),
									(_e._code = fe(_e, i)),
									d.push(_e)),
								d.push(nt)));
				t = d;
			}
			return t;
		}
		function ut(t, i) {
			var a, d, x, M, q, J, nt, ht, At;
			if (!t || t.length === 0) throw new Error("latlngs not passed");
			Si(t) ||
				(console.warn("latlngs are not flat! Only the first ring will be used"),
				(t = t[0]));
			var Yt = U([0, 0]),
				_e = jt(t),
				hn =
					_e.getNorthWest().distanceTo(_e.getSouthWest()) *
					_e.getNorthEast().distanceTo(_e.getNorthWest());
			hn < 1700 && (Yt = tt(t));
			var Wi = t.length,
				rr = [];
			for (a = 0; a < Wi; a++) {
				var yn = U(t[a]);
				rr.push(i.project(U([yn.lat - Yt.lat, yn.lng - Yt.lng])));
			}
			for (J = nt = ht = 0, a = 0, d = Wi - 1; a < Wi; d = a++)
				((x = rr[a]),
					(M = rr[d]),
					(q = x.y * M.x - M.y * x.x),
					(nt += (x.x + M.x) * q),
					(ht += (x.y + M.y) * q),
					(J += q * 3));
			J === 0 ? (At = rr[0]) : (At = [nt / J, ht / J]);
			var zs = i.unproject(W(At));
			return U([zs.lat + Yt.lat, zs.lng + Yt.lng]);
		}
		function tt(t) {
			for (var i = 0, a = 0, d = 0, x = 0; x < t.length; x++) {
				var M = U(t[x]);
				((i += M.lat), (a += M.lng), d++);
			}
			return U([i / d, a / d]);
		}
		var dt = {
			__proto__: null,
			clipPolygon: rt,
			polygonCenter: ut,
			centroid: tt,
		};
		function Xt(t, i) {
			if (!i || !t.length) return t.slice();
			var a = i * i;
			return ((t = Jn(t, a)), (t = zi(t, a)), t);
		}
		function ye(t, i, a) {
			return Math.sqrt(pr(t, i, a, !0));
		}
		function le(t, i, a) {
			return pr(t, i, a);
		}
		function zi(t, i) {
			var a = t.length,
				d = typeof Uint8Array != void 0 + "" ? Uint8Array : Array,
				x = new d(a);
			((x[0] = x[a - 1] = 1), li(t, x, i, 0, a - 1));
			var M,
				q = [];
			for (M = 0; M < a; M++) x[M] && q.push(t[M]);
			return q;
		}
		function li(t, i, a, d, x) {
			var M = 0,
				q,
				J,
				nt;
			for (J = d + 1; J <= x - 1; J++)
				((nt = pr(t[J], t[d], t[x], !0)), nt > M && ((q = J), (M = nt)));
			M > a && ((i[q] = 1), li(t, i, a, d, q), li(t, i, a, q, x));
		}
		function Jn(t, i) {
			for (var a = [t[0]], d = 1, x = 0, M = t.length; d < M; d++)
				ti(t[d], t[x]) > i && (a.push(t[d]), (x = d));
			return (x < M - 1 && a.push(t[M - 1]), a);
		}
		var On;
		function me(t, i, a, d, x) {
			var M = d ? On : fe(t, a),
				q = fe(i, a),
				J,
				nt,
				ht;
			for (On = q; ; ) {
				if (!(M | q)) return [t, i];
				if (M & q) return !1;
				((J = M || q),
					(nt = Qn(t, i, J, a, x)),
					(ht = fe(nt, a)),
					J === M ? ((t = nt), (M = ht)) : ((i = nt), (q = ht)));
			}
		}
		function Qn(t, i, a, d, x) {
			var M = i.x - t.x,
				q = i.y - t.y,
				J = d.min,
				nt = d.max,
				ht,
				At;
			return (
				a & 8
					? ((ht = t.x + (M * (nt.y - t.y)) / q), (At = nt.y))
					: a & 4
						? ((ht = t.x + (M * (J.y - t.y)) / q), (At = J.y))
						: a & 2
							? ((ht = nt.x), (At = t.y + (q * (nt.x - t.x)) / M))
							: a & 1 && ((ht = J.x), (At = t.y + (q * (J.x - t.x)) / M)),
				new _t(ht, At, x)
			);
		}
		function fe(t, i) {
			var a = 0;
			return (
				t.x < i.min.x ? (a |= 1) : t.x > i.max.x && (a |= 2),
				t.y < i.min.y ? (a |= 4) : t.y > i.max.y && (a |= 8),
				a
			);
		}
		function ti(t, i) {
			var a = i.x - t.x,
				d = i.y - t.y;
			return a * a + d * d;
		}
		function pr(t, i, a, d) {
			var x = i.x,
				M = i.y,
				q = a.x - x,
				J = a.y - M,
				nt = q * q + J * J,
				ht;
			return (
				nt > 0 &&
					((ht = ((t.x - x) * q + (t.y - M) * J) / nt),
					ht > 1
						? ((x = a.x), (M = a.y))
						: ht > 0 && ((x += q * ht), (M += J * ht))),
				(q = t.x - x),
				(J = t.y - M),
				d ? q * q + J * J : new _t(x, M)
			);
		}
		function Si(t) {
			return !j(t[0]) || (typeof t[0][0] != "object" && typeof t[0][0] < "u");
		}
		function si(t) {
			return (
				console.warn(
					"Deprecated use of _flat, please use L.LineUtil.isFlat instead.",
				),
				Si(t)
			);
		}
		function tr(t, i) {
			var a, d, x, M, q, J, nt, ht;
			if (!t || t.length === 0) throw new Error("latlngs not passed");
			Si(t) ||
				(console.warn("latlngs are not flat! Only the first ring will be used"),
				(t = t[0]));
			var At = U([0, 0]),
				Yt = jt(t),
				_e =
					Yt.getNorthWest().distanceTo(Yt.getSouthWest()) *
					Yt.getNorthEast().distanceTo(Yt.getNorthWest());
			_e < 1700 && (At = tt(t));
			var hn = t.length,
				Wi = [];
			for (a = 0; a < hn; a++) {
				var rr = U(t[a]);
				Wi.push(i.project(U([rr.lat - At.lat, rr.lng - At.lng])));
			}
			for (a = 0, d = 0; a < hn - 1; a++) d += Wi[a].distanceTo(Wi[a + 1]) / 2;
			if (d === 0) ht = Wi[0];
			else
				for (a = 0, M = 0; a < hn - 1; a++)
					if (
						((q = Wi[a]),
						(J = Wi[a + 1]),
						(x = q.distanceTo(J)),
						(M += x),
						M > d)
					) {
						((nt = (M - d) / x),
							(ht = [J.x - nt * (J.x - q.x), J.y - nt * (J.y - q.y)]));
						break;
					}
			var yn = i.unproject(W(ht));
			return U([yn.lat + At.lat, yn.lng + At.lng]);
		}
		var er = {
				__proto__: null,
				simplify: Xt,
				pointToSegmentDistance: ye,
				closestPointOnSegment: le,
				clipSegment: me,
				_getEdgeIntersection: Qn,
				_getBitCode: fe,
				_sqClosestPointOnSegment: pr,
				isFlat: Si,
				_flat: si,
				polylineCenter: tr,
			},
			ir = {
				project: function (t) {
					return new _t(t.lng, t.lat);
				},
				unproject: function (t) {
					return new Vt(t.y, t.x);
				},
				bounds: new Wt([-180, -90], [180, 90]),
			},
			un = {
				R: 6378137,
				R_MINOR: 6356752314245179e-9,
				bounds: new Wt(
					[-2003750834279e-5, -1549657073972e-5],
					[2003750834279e-5, 1876465623138e-5],
				),
				project: function (t) {
					var i = Math.PI / 180,
						a = this.R,
						d = t.lat * i,
						x = this.R_MINOR / a,
						M = Math.sqrt(1 - x * x),
						q = M * Math.sin(d),
						J =
							Math.tan(Math.PI / 4 - d / 2) /
							Math.pow((1 - q) / (1 + q), M / 2);
					return (
						(d = -a * Math.log(Math.max(J, 1e-10))),
						new _t(t.lng * i * a, d)
					);
				},
				unproject: function (t) {
					for (
						var i = 180 / Math.PI,
							a = this.R,
							d = this.R_MINOR / a,
							x = Math.sqrt(1 - d * d),
							M = Math.exp(-t.y / a),
							q = Math.PI / 2 - 2 * Math.atan(M),
							J = 0,
							nt = 0.1,
							ht;
						J < 15 && Math.abs(nt) > 1e-7;
						J++
					)
						((ht = x * Math.sin(q)),
							(ht = Math.pow((1 - ht) / (1 + ht), x / 2)),
							(nt = Math.PI / 2 - 2 * Math.atan(M * ht) - q),
							(q += nt));
					return new Vt(q * i, (t.x * i) / a);
				},
			},
			ci = { __proto__: null, LonLat: ir, Mercator: un, SphericalMercator: je },
			Xr = s({}, qe, {
				code: "EPSG:3395",
				projection: un,
				transformation: (function () {
					var t = 0.5 / (Math.PI * un.R);
					return Ue(t, 0.5, -t, 0.5);
				})(),
			}),
			Dn = s({}, qe, {
				code: "EPSG:4326",
				projection: ir,
				transformation: Ue(1 / 180, 1, -1 / 180, 0.5),
			}),
			In = s({}, xe, {
				projection: ir,
				transformation: Ue(1, 0, -1, 0),
				scale: function (t) {
					return Math.pow(2, t);
				},
				zoom: function (t) {
					return Math.log(t) / Math.LN2;
				},
				distance: function (t, i) {
					var a = i.lng - t.lng,
						d = i.lat - t.lat;
					return Math.sqrt(a * a + d * d);
				},
				infinite: !0,
			});
		((xe.Earth = qe),
			(xe.EPSG3395 = Xr),
			(xe.EPSG3857 = ne),
			(xe.EPSG900913 = We),
			(xe.EPSG4326 = Dn),
			(xe.Simple = In));
		var _n = Ct.extend({
			options: {
				pane: "overlayPane",
				attribution: null,
				bubblingMouseEvents: !0,
			},
			addTo: function (t) {
				return (t.addLayer(this), this);
			},
			remove: function () {
				return this.removeFrom(this._map || this._mapToAdd);
			},
			removeFrom: function (t) {
				return (t && t.removeLayer(this), this);
			},
			getPane: function (t) {
				return this._map.getPane(t ? this.options[t] || t : this.options.pane);
			},
			addInteractiveTarget: function (t) {
				return ((this._map._targets[f(t)] = this), this);
			},
			removeInteractiveTarget: function (t) {
				return (delete this._map._targets[f(t)], this);
			},
			getAttribution: function () {
				return this.options.attribution;
			},
			_layerAdd: function (t) {
				var i = t.target;
				if (i.hasLayer(this)) {
					if (
						((this._map = i),
						(this._zoomAnimated = i._zoomAnimated),
						this.getEvents)
					) {
						var a = this.getEvents();
						(i.on(a, this),
							this.once(
								"remove",
								function () {
									i.off(a, this);
								},
								this,
							));
					}
					(this.onAdd(i),
						this.fire("add"),
						i.fire("layeradd", { layer: this }));
				}
			},
		});
		Se.include({
			addLayer: function (t) {
				if (!t._layerAdd)
					throw new Error("The provided object is not a Layer.");
				var i = f(t);
				return this._layers[i]
					? this
					: ((this._layers[i] = t),
						(t._mapToAdd = this),
						t.beforeAdd && t.beforeAdd(this),
						this.whenReady(t._layerAdd, t),
						this);
			},
			removeLayer: function (t) {
				var i = f(t);
				return this._layers[i]
					? (this._loaded && t.onRemove(this),
						delete this._layers[i],
						this._loaded &&
							(this.fire("layerremove", { layer: t }), t.fire("remove")),
						(t._map = t._mapToAdd = null),
						this)
					: this;
			},
			hasLayer: function (t) {
				return f(t) in this._layers;
			},
			eachLayer: function (t, i) {
				for (var a in this._layers) t.call(i, this._layers[a]);
				return this;
			},
			_addLayers: function (t) {
				t = t ? (j(t) ? t : [t]) : [];
				for (var i = 0, a = t.length; i < a; i++) this.addLayer(t[i]);
			},
			_addZoomLimit: function (t) {
				(!isNaN(t.options.maxZoom) || !isNaN(t.options.minZoom)) &&
					((this._zoomBoundLayers[f(t)] = t), this._updateZoomLevels());
			},
			_removeZoomLimit: function (t) {
				var i = f(t);
				this._zoomBoundLayers[i] &&
					(delete this._zoomBoundLayers[i], this._updateZoomLevels());
			},
			_updateZoomLevels: function () {
				var t = 1 / 0,
					i = -1 / 0,
					a = this._getZoomSpan();
				for (var d in this._zoomBoundLayers) {
					var x = this._zoomBoundLayers[d].options;
					((t = x.minZoom === void 0 ? t : Math.min(t, x.minZoom)),
						(i = x.maxZoom === void 0 ? i : Math.max(i, x.maxZoom)));
				}
				((this._layersMaxZoom = i === -1 / 0 ? void 0 : i),
					(this._layersMinZoom = t === 1 / 0 ? void 0 : t),
					a !== this._getZoomSpan() && this.fire("zoomlevelschange"),
					this.options.maxZoom === void 0 &&
						this._layersMaxZoom &&
						this.getZoom() > this._layersMaxZoom &&
						this.setZoom(this._layersMaxZoom),
					this.options.minZoom === void 0 &&
						this._layersMinZoom &&
						this.getZoom() < this._layersMinZoom &&
						this.setZoom(this._layersMinZoom));
			},
		});
		var Zr = _n.extend({
				initialize: function (t, i) {
					(P(this, i), (this._layers = {}));
					var a, d;
					if (t) for (a = 0, d = t.length; a < d; a++) this.addLayer(t[a]);
				},
				addLayer: function (t) {
					var i = this.getLayerId(t);
					return (
						(this._layers[i] = t),
						this._map && this._map.addLayer(t),
						this
					);
				},
				removeLayer: function (t) {
					var i = t in this._layers ? t : this.getLayerId(t);
					return (
						this._map &&
							this._layers[i] &&
							this._map.removeLayer(this._layers[i]),
						delete this._layers[i],
						this
					);
				},
				hasLayer: function (t) {
					var i = typeof t == "number" ? t : this.getLayerId(t);
					return i in this._layers;
				},
				clearLayers: function () {
					return this.eachLayer(this.removeLayer, this);
				},
				invoke: function (t) {
					var i = Array.prototype.slice.call(arguments, 1),
						a,
						d;
					for (a in this._layers)
						((d = this._layers[a]), d[t] && d[t].apply(d, i));
					return this;
				},
				onAdd: function (t) {
					this.eachLayer(t.addLayer, t);
				},
				onRemove: function (t) {
					this.eachLayer(t.removeLayer, t);
				},
				eachLayer: function (t, i) {
					for (var a in this._layers) t.call(i, this._layers[a]);
					return this;
				},
				getLayer: function (t) {
					return this._layers[t];
				},
				getLayers: function () {
					var t = [];
					return (this.eachLayer(t.push, t), t);
				},
				setZIndex: function (t) {
					return this.invoke("setZIndex", t);
				},
				getLayerId: function (t) {
					return f(t);
				},
			}),
			Yr = function (t, i) {
				return new Zr(t, i);
			},
			ae = Zr.extend({
				addLayer: function (t) {
					return this.hasLayer(t)
						? this
						: (t.addEventParent(this),
							Zr.prototype.addLayer.call(this, t),
							this.fire("layeradd", { layer: t }));
				},
				removeLayer: function (t) {
					return this.hasLayer(t)
						? (t in this._layers && (t = this._layers[t]),
							t.removeEventParent(this),
							Zr.prototype.removeLayer.call(this, t),
							this.fire("layerremove", { layer: t }))
						: this;
				},
				setStyle: function (t) {
					return this.invoke("setStyle", t);
				},
				bringToFront: function () {
					return this.invoke("bringToFront");
				},
				bringToBack: function () {
					return this.invoke("bringToBack");
				},
				getBounds: function () {
					var t = new oe();
					for (var i in this._layers) {
						var a = this._layers[i];
						t.extend(a.getBounds ? a.getBounds() : a.getLatLng());
					}
					return t;
				},
			}),
			Ds = function (t, i) {
				return new ae(t, i);
			},
			qi = K.extend({
				options: {
					popupAnchor: [0, 0],
					tooltipAnchor: [0, 0],
					crossOrigin: !1,
				},
				initialize: function (t) {
					P(this, t);
				},
				createIcon: function (t) {
					return this._createIcon("icon", t);
				},
				createShadow: function (t) {
					return this._createIcon("shadow", t);
				},
				_createIcon: function (t, i) {
					var a = this._getIconUrl(t);
					if (!a) {
						if (t === "icon")
							throw new Error(
								"iconUrl not set in Icon options (see the docs).",
							);
						return null;
					}
					var d = this._createImg(a, i && i.tagName === "IMG" ? i : null);
					return (
						this._setIconStyles(d, t),
						(this.options.crossOrigin || this.options.crossOrigin === "") &&
							(d.crossOrigin =
								this.options.crossOrigin === !0
									? ""
									: this.options.crossOrigin),
						d
					);
				},
				_setIconStyles: function (t, i) {
					var a = this.options,
						d = a[i + "Size"];
					typeof d == "number" && (d = [d, d]);
					var x = W(d),
						M = W(
							(i === "shadow" && a.shadowAnchor) ||
								a.iconAnchor ||
								(x && x.divideBy(2, !0)),
						);
					((t.className = "leaflet-marker-" + i + " " + (a.className || "")),
						M &&
							((t.style.marginLeft = -M.x + "px"),
							(t.style.marginTop = -M.y + "px")),
						x && ((t.style.width = x.x + "px"), (t.style.height = x.y + "px")));
				},
				_createImg: function (t, i) {
					return ((i = i || document.createElement("img")), (i.src = t), i);
				},
				_getIconUrl: function (t) {
					return (
						(xt.retina && this.options[t + "RetinaUrl"]) ||
						this.options[t + "Url"]
					);
				},
			});
		function mr(t) {
			return new qi(t);
		}
		var Lr = qi.extend({
				options: {
					iconUrl: "marker-icon.png",
					iconRetinaUrl: "marker-icon-2x.png",
					shadowUrl: "marker-shadow.png",
					iconSize: [25, 41],
					iconAnchor: [12, 41],
					popupAnchor: [1, -34],
					tooltipAnchor: [16, -28],
					shadowSize: [41, 41],
				},
				_getIconUrl: function (t) {
					return (
						typeof Lr.imagePath != "string" &&
							(Lr.imagePath = this._detectIconPath()),
						(this.options.imagePath || Lr.imagePath) +
							qi.prototype._getIconUrl.call(this, t)
					);
				},
				_stripUrl: function (t) {
					var i = function (a, d, x) {
						var M = d.exec(a);
						return M && M[x];
					};
					return (
						(t = i(t, /^url\((['"])?(.+)\1\)$/, 2)),
						t && i(t, /^(.*)marker-icon\.png$/, 1)
					);
				},
				_detectIconPath: function () {
					var t = ve("div", "leaflet-default-icon-path", document.body),
						i = mn(t, "background-image") || mn(t, "backgroundImage");
					if ((document.body.removeChild(t), (i = this._stripUrl(i)), i))
						return i;
					var a = document.querySelector('link[href$="leaflet.css"]');
					return a ? a.href.substring(0, a.href.length - 11 - 1) : "";
				},
			}),
			Bn = k.extend({
				initialize: function (t) {
					this._marker = t;
				},
				addHooks: function () {
					var t = this._marker._icon;
					(this._draggable || (this._draggable = new $(t, t, !0)),
						this._draggable
							.on(
								{
									dragstart: this._onDragStart,
									predrag: this._onPreDrag,
									drag: this._onDrag,
									dragend: this._onDragEnd,
								},
								this,
							)
							.enable(),
						ue(t, "leaflet-marker-draggable"));
				},
				removeHooks: function () {
					(this._draggable
						.off(
							{
								dragstart: this._onDragStart,
								predrag: this._onPreDrag,
								drag: this._onDrag,
								dragend: this._onDragEnd,
							},
							this,
						)
						.disable(),
						this._marker._icon &&
							Je(this._marker._icon, "leaflet-marker-draggable"));
				},
				moved: function () {
					return this._draggable && this._draggable._moved;
				},
				_adjustPan: function (t) {
					var i = this._marker,
						a = i._map,
						d = this._marker.options.autoPanSpeed,
						x = this._marker.options.autoPanPadding,
						M = Tt(i._icon),
						q = a.getPixelBounds(),
						J = a.getPixelOrigin(),
						nt = Zt(q.min._subtract(J).add(x), q.max._subtract(J).subtract(x));
					if (!nt.contains(M)) {
						var ht = W(
							(Math.max(nt.max.x, M.x) - nt.max.x) / (q.max.x - nt.max.x) -
								(Math.min(nt.min.x, M.x) - nt.min.x) / (q.min.x - nt.min.x),
							(Math.max(nt.max.y, M.y) - nt.max.y) / (q.max.y - nt.max.y) -
								(Math.min(nt.min.y, M.y) - nt.min.y) / (q.min.y - nt.min.y),
						).multiplyBy(d);
						(a.panBy(ht, { animate: !1 }),
							this._draggable._newPos._add(ht),
							this._draggable._startPos._add(ht),
							ui(i._icon, this._draggable._newPos),
							this._onDrag(t),
							(this._panRequest = Dt(this._adjustPan.bind(this, t))));
					}
				},
				_onDragStart: function () {
					((this._oldLatLng = this._marker.getLatLng()),
						this._marker.closePopup && this._marker.closePopup(),
						this._marker.fire("movestart").fire("dragstart"));
				},
				_onPreDrag: function (t) {
					this._marker.options.autoPan &&
						(pt(this._panRequest),
						(this._panRequest = Dt(this._adjustPan.bind(this, t))));
				},
				_onDrag: function (t) {
					var i = this._marker,
						a = i._shadow,
						d = Tt(i._icon),
						x = i._map.layerPointToLatLng(d);
					(a && ui(a, d),
						(i._latlng = x),
						(t.latlng = x),
						(t.oldLatLng = this._oldLatLng),
						i.fire("move", t).fire("drag", t));
				},
				_onDragEnd: function (t) {
					(pt(this._panRequest),
						delete this._oldLatLng,
						this._marker.fire("moveend").fire("dragend", t));
				},
			}),
			ys = _n.extend({
				options: {
					icon: new Lr(),
					interactive: !0,
					keyboard: !0,
					title: "",
					alt: "Marker",
					zIndexOffset: 0,
					opacity: 1,
					riseOnHover: !1,
					riseOffset: 250,
					pane: "markerPane",
					shadowPane: "shadowPane",
					bubblingMouseEvents: !1,
					autoPanOnFocus: !0,
					draggable: !1,
					autoPan: !1,
					autoPanPadding: [50, 50],
					autoPanSpeed: 10,
				},
				initialize: function (t, i) {
					(P(this, i), (this._latlng = U(t)));
				},
				onAdd: function (t) {
					((this._zoomAnimated =
						this._zoomAnimated && t.options.markerZoomAnimation),
						this._zoomAnimated && t.on("zoomanim", this._animateZoom, this),
						this._initIcon(),
						this.update());
				},
				onRemove: function (t) {
					(this.dragging &&
						this.dragging.enabled() &&
						((this.options.draggable = !0), this.dragging.removeHooks()),
						delete this.dragging,
						this._zoomAnimated && t.off("zoomanim", this._animateZoom, this),
						this._removeIcon(),
						this._removeShadow());
				},
				getEvents: function () {
					return { zoom: this.update, viewreset: this.update };
				},
				getLatLng: function () {
					return this._latlng;
				},
				setLatLng: function (t) {
					var i = this._latlng;
					return (
						(this._latlng = U(t)),
						this.update(),
						this.fire("move", { oldLatLng: i, latlng: this._latlng })
					);
				},
				setZIndexOffset: function (t) {
					return ((this.options.zIndexOffset = t), this.update());
				},
				getIcon: function () {
					return this.options.icon;
				},
				setIcon: function (t) {
					return (
						(this.options.icon = t),
						this._map && (this._initIcon(), this.update()),
						this._popup && this.bindPopup(this._popup, this._popup.options),
						this
					);
				},
				getElement: function () {
					return this._icon;
				},
				update: function () {
					if (this._icon && this._map) {
						var t = this._map.latLngToLayerPoint(this._latlng).round();
						this._setPos(t);
					}
					return this;
				},
				_initIcon: function () {
					var t = this.options,
						i = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"),
						a = t.icon.createIcon(this._icon),
						d = !1;
					(a !== this._icon &&
						(this._icon && this._removeIcon(),
						(d = !0),
						t.title && (a.title = t.title),
						a.tagName === "IMG" && (a.alt = t.alt || "")),
						ue(a, i),
						t.keyboard &&
							((a.tabIndex = "0"), a.setAttribute("role", "button")),
						(this._icon = a),
						t.riseOnHover &&
							this.on({
								mouseover: this._bringToFront,
								mouseout: this._resetZIndex,
							}),
						this.options.autoPanOnFocus &&
							ee(a, "focus", this._panOnFocus, this));
					var x = t.icon.createShadow(this._shadow),
						M = !1;
					(x !== this._shadow && (this._removeShadow(), (M = !0)),
						x && (ue(x, i), (x.alt = "")),
						(this._shadow = x),
						t.opacity < 1 && this._updateOpacity(),
						d && this.getPane().appendChild(this._icon),
						this._initInteraction(),
						x && M && this.getPane(t.shadowPane).appendChild(this._shadow));
				},
				_removeIcon: function () {
					(this.options.riseOnHover &&
						this.off({
							mouseover: this._bringToFront,
							mouseout: this._resetZIndex,
						}),
						this.options.autoPanOnFocus &&
							Be(this._icon, "focus", this._panOnFocus, this),
						Ke(this._icon),
						this.removeInteractiveTarget(this._icon),
						(this._icon = null));
				},
				_removeShadow: function () {
					(this._shadow && Ke(this._shadow), (this._shadow = null));
				},
				_setPos: function (t) {
					(this._icon && ui(this._icon, t),
						this._shadow && ui(this._shadow, t),
						(this._zIndex = t.y + this.options.zIndexOffset),
						this._resetZIndex());
				},
				_updateZIndex: function (t) {
					this._icon && (this._icon.style.zIndex = this._zIndex + t);
				},
				_animateZoom: function (t) {
					var i = this._map
						._latLngToNewLayerPoint(this._latlng, t.zoom, t.center)
						.round();
					this._setPos(i);
				},
				_initInteraction: function () {
					if (
						this.options.interactive &&
						(ue(this._icon, "leaflet-interactive"),
						this.addInteractiveTarget(this._icon),
						Bn)
					) {
						var t = this.options.draggable;
						(this.dragging &&
							((t = this.dragging.enabled()), this.dragging.disable()),
							(this.dragging = new Bn(this)),
							t && this.dragging.enable());
					}
				},
				setOpacity: function (t) {
					return (
						(this.options.opacity = t),
						this._map && this._updateOpacity(),
						this
					);
				},
				_updateOpacity: function () {
					var t = this.options.opacity;
					(this._icon && Ai(this._icon, t),
						this._shadow && Ai(this._shadow, t));
				},
				_bringToFront: function () {
					this._updateZIndex(this.options.riseOffset);
				},
				_resetZIndex: function () {
					this._updateZIndex(0);
				},
				_panOnFocus: function () {
					var t = this._map;
					if (t) {
						var i = this.options.icon.options,
							a = i.iconSize ? W(i.iconSize) : W(0, 0),
							d = i.iconAnchor ? W(i.iconAnchor) : W(0, 0);
						t.panInside(this._latlng, {
							paddingTopLeft: d,
							paddingBottomRight: a.subtract(d),
						});
					}
				},
				_getPopupAnchor: function () {
					return this.options.icon.options.popupAnchor;
				},
				_getTooltipAnchor: function () {
					return this.options.icon.options.tooltipAnchor;
				},
			});
		function gr(t, i) {
			return new ys(t, i);
		}
		var be = _n.extend({
				options: {
					stroke: !0,
					color: "#3388ff",
					weight: 3,
					opacity: 1,
					lineCap: "round",
					lineJoin: "round",
					dashArray: null,
					dashOffset: null,
					fill: !1,
					fillColor: null,
					fillOpacity: 0.2,
					fillRule: "evenodd",
					interactive: !0,
					bubblingMouseEvents: !0,
				},
				beforeAdd: function (t) {
					this._renderer = t.getRenderer(this);
				},
				onAdd: function () {
					(this._renderer._initPath(this),
						this._reset(),
						this._renderer._addPath(this));
				},
				onRemove: function () {
					this._renderer._removePath(this);
				},
				redraw: function () {
					return (this._map && this._renderer._updatePath(this), this);
				},
				setStyle: function (t) {
					return (
						P(this, t),
						this._renderer &&
							(this._renderer._updateStyle(this),
							this.options.stroke &&
								t &&
								Object.prototype.hasOwnProperty.call(t, "weight") &&
								this._updateBounds()),
						this
					);
				},
				bringToFront: function () {
					return (this._renderer && this._renderer._bringToFront(this), this);
				},
				bringToBack: function () {
					return (this._renderer && this._renderer._bringToBack(this), this);
				},
				getElement: function () {
					return this._path;
				},
				_reset: function () {
					(this._project(), this._update());
				},
				_clickTolerance: function () {
					return (
						(this.options.stroke ? this.options.weight / 2 : 0) +
						(this._renderer.options.tolerance || 0)
					);
				},
			}),
			Vi = be.extend({
				options: { fill: !0, radius: 10 },
				initialize: function (t, i) {
					(P(this, i),
						(this._latlng = U(t)),
						(this._radius = this.options.radius));
				},
				setLatLng: function (t) {
					var i = this._latlng;
					return (
						(this._latlng = U(t)),
						this.redraw(),
						this.fire("move", { oldLatLng: i, latlng: this._latlng })
					);
				},
				getLatLng: function () {
					return this._latlng;
				},
				setRadius: function (t) {
					return ((this.options.radius = this._radius = t), this.redraw());
				},
				getRadius: function () {
					return this._radius;
				},
				setStyle: function (t) {
					var i = (t && t.radius) || this._radius;
					return (be.prototype.setStyle.call(this, t), this.setRadius(i), this);
				},
				_project: function () {
					((this._point = this._map.latLngToLayerPoint(this._latlng)),
						this._updateBounds());
				},
				_updateBounds: function () {
					var t = this._radius,
						i = this._radiusY || t,
						a = this._clickTolerance(),
						d = [t + a, i + a];
					this._pxBounds = new Wt(this._point.subtract(d), this._point.add(d));
				},
				_update: function () {
					this._map && this._updatePath();
				},
				_updatePath: function () {
					this._renderer._updateCircle(this);
				},
				_empty: function () {
					return (
						this._radius && !this._renderer._bounds.intersects(this._pxBounds)
					);
				},
				_containsPoint: function (t) {
					return (
						t.distanceTo(this._point) <= this._radius + this._clickTolerance()
					);
				},
			});
		function Ro(t, i) {
			return new Vi(t, i);
		}
		var zn = Vi.extend({
			initialize: function (t, i, a) {
				if (
					(typeof i == "number" && (i = s({}, a, { radius: i })),
					P(this, i),
					(this._latlng = U(t)),
					isNaN(this.options.radius))
				)
					throw new Error("Circle radius cannot be NaN");
				this._mRadius = this.options.radius;
			},
			setRadius: function (t) {
				return ((this._mRadius = t), this.redraw());
			},
			getRadius: function () {
				return this._mRadius;
			},
			getBounds: function () {
				var t = [this._radius, this._radiusY || this._radius];
				return new oe(
					this._map.layerPointToLatLng(this._point.subtract(t)),
					this._map.layerPointToLatLng(this._point.add(t)),
				);
			},
			setStyle: be.prototype.setStyle,
			_project: function () {
				var t = this._latlng.lng,
					i = this._latlng.lat,
					a = this._map,
					d = a.options.crs;
				if (d.distance === qe.distance) {
					var x = Math.PI / 180,
						M = this._mRadius / qe.R / x,
						q = a.project([i + M, t]),
						J = a.project([i - M, t]),
						nt = q.add(J).divideBy(2),
						ht = a.unproject(nt).lat,
						At =
							Math.acos(
								(Math.cos(M * x) - Math.sin(i * x) * Math.sin(ht * x)) /
									(Math.cos(i * x) * Math.cos(ht * x)),
							) / x;
					((isNaN(At) || At === 0) && (At = M / Math.cos((Math.PI / 180) * i)),
						(this._point = nt.subtract(a.getPixelOrigin())),
						(this._radius = isNaN(At) ? 0 : nt.x - a.project([ht, t - At]).x),
						(this._radiusY = nt.y - q.y));
				} else {
					var Yt = d.unproject(
						d.project(this._latlng).subtract([this._mRadius, 0]),
					);
					((this._point = a.latLngToLayerPoint(this._latlng)),
						(this._radius = this._point.x - a.latLngToLayerPoint(Yt).x));
				}
				this._updateBounds();
			},
		});
		function Kr(t, i, a) {
			return new zn(t, i, a);
		}
		var Qi = be.extend({
			options: { smoothFactor: 1, noClip: !1 },
			initialize: function (t, i) {
				(P(this, i), this._setLatLngs(t));
			},
			getLatLngs: function () {
				return this._latlngs;
			},
			setLatLngs: function (t) {
				return (this._setLatLngs(t), this.redraw());
			},
			isEmpty: function () {
				return !this._latlngs.length;
			},
			closestLayerPoint: function (t) {
				for (
					var i = 1 / 0, a = null, d = pr, x, M, q = 0, J = this._parts.length;
					q < J;
					q++
				)
					for (var nt = this._parts[q], ht = 1, At = nt.length; ht < At; ht++) {
						((x = nt[ht - 1]), (M = nt[ht]));
						var Yt = d(t, x, M, !0);
						Yt < i && ((i = Yt), (a = d(t, x, M)));
					}
				return (a && (a.distance = Math.sqrt(i)), a);
			},
			getCenter: function () {
				if (!this._map)
					throw new Error("Must add layer to map before using getCenter()");
				return tr(this._defaultShape(), this._map.options.crs);
			},
			getBounds: function () {
				return this._bounds;
			},
			addLatLng: function (t, i) {
				return (
					(i = i || this._defaultShape()),
					(t = U(t)),
					i.push(t),
					this._bounds.extend(t),
					this.redraw()
				);
			},
			_setLatLngs: function (t) {
				((this._bounds = new oe()), (this._latlngs = this._convertLatLngs(t)));
			},
			_defaultShape: function () {
				return Si(this._latlngs) ? this._latlngs : this._latlngs[0];
			},
			_convertLatLngs: function (t) {
				for (var i = [], a = Si(t), d = 0, x = t.length; d < x; d++)
					a
						? ((i[d] = U(t[d])), this._bounds.extend(i[d]))
						: (i[d] = this._convertLatLngs(t[d]));
				return i;
			},
			_project: function () {
				var t = new Wt();
				((this._rings = []),
					this._projectLatlngs(this._latlngs, this._rings, t),
					this._bounds.isValid() &&
						t.isValid() &&
						((this._rawPxBounds = t), this._updateBounds()));
			},
			_updateBounds: function () {
				var t = this._clickTolerance(),
					i = new _t(t, t);
				this._rawPxBounds &&
					(this._pxBounds = new Wt([
						this._rawPxBounds.min.subtract(i),
						this._rawPxBounds.max.add(i),
					]));
			},
			_projectLatlngs: function (t, i, a) {
				var d = t[0] instanceof Vt,
					x = t.length,
					M,
					q;
				if (d) {
					for (q = [], M = 0; M < x; M++)
						((q[M] = this._map.latLngToLayerPoint(t[M])), a.extend(q[M]));
					i.push(q);
				} else for (M = 0; M < x; M++) this._projectLatlngs(t[M], i, a);
			},
			_clipPoints: function () {
				var t = this._renderer._bounds;
				if (
					((this._parts = []),
					!(!this._pxBounds || !this._pxBounds.intersects(t)))
				) {
					if (this.options.noClip) {
						this._parts = this._rings;
						return;
					}
					var i = this._parts,
						a,
						d,
						x,
						M,
						q,
						J,
						nt;
					for (a = 0, x = 0, M = this._rings.length; a < M; a++)
						for (nt = this._rings[a], d = 0, q = nt.length; d < q - 1; d++)
							((J = me(nt[d], nt[d + 1], t, d, !0)),
								J &&
									((i[x] = i[x] || []),
									i[x].push(J[0]),
									(J[1] !== nt[d + 1] || d === q - 2) &&
										(i[x].push(J[1]), x++)));
				}
			},
			_simplifyPoints: function () {
				for (
					var t = this._parts,
						i = this.options.smoothFactor,
						a = 0,
						d = t.length;
					a < d;
					a++
				)
					t[a] = Xt(t[a], i);
			},
			_update: function () {
				this._map &&
					(this._clipPoints(), this._simplifyPoints(), this._updatePath());
			},
			_updatePath: function () {
				this._renderer._updatePoly(this);
			},
			_containsPoint: function (t, i) {
				var a,
					d,
					x,
					M,
					q,
					J,
					nt = this._clickTolerance();
				if (!this._pxBounds || !this._pxBounds.contains(t)) return !1;
				for (a = 0, M = this._parts.length; a < M; a++)
					for (
						J = this._parts[a], d = 0, q = J.length, x = q - 1;
						d < q;
						x = d++
					)
						if (!(!i && d === 0) && ye(t, J[x], J[d]) <= nt) return !0;
				return !1;
			},
		});
		function no(t, i) {
			return new Qi(t, i);
		}
		Qi._flat = si;
		var Nn = Qi.extend({
			options: { fill: !0 },
			isEmpty: function () {
				return !this._latlngs.length || !this._latlngs[0].length;
			},
			getCenter: function () {
				if (!this._map)
					throw new Error("Must add layer to map before using getCenter()");
				return ut(this._defaultShape(), this._map.options.crs);
			},
			_convertLatLngs: function (t) {
				var i = Qi.prototype._convertLatLngs.call(this, t),
					a = i.length;
				return (
					a >= 2 && i[0] instanceof Vt && i[0].equals(i[a - 1]) && i.pop(),
					i
				);
			},
			_setLatLngs: function (t) {
				(Qi.prototype._setLatLngs.call(this, t),
					Si(this._latlngs) && (this._latlngs = [this._latlngs]));
			},
			_defaultShape: function () {
				return Si(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
			},
			_clipPoints: function () {
				var t = this._renderer._bounds,
					i = this.options.weight,
					a = new _t(i, i);
				if (
					((t = new Wt(t.min.subtract(a), t.max.add(a))),
					(this._parts = []),
					!(!this._pxBounds || !this._pxBounds.intersects(t)))
				) {
					if (this.options.noClip) {
						this._parts = this._rings;
						return;
					}
					for (var d = 0, x = this._rings.length, M; d < x; d++)
						((M = rt(this._rings[d], t, !0)), M.length && this._parts.push(M));
				}
			},
			_updatePath: function () {
				this._renderer._updatePoly(this, !0);
			},
			_containsPoint: function (t) {
				var i = !1,
					a,
					d,
					x,
					M,
					q,
					J,
					nt,
					ht;
				if (!this._pxBounds || !this._pxBounds.contains(t)) return !1;
				for (M = 0, nt = this._parts.length; M < nt; M++)
					for (
						a = this._parts[M], q = 0, ht = a.length, J = ht - 1;
						q < ht;
						J = q++
					)
						((d = a[q]),
							(x = a[J]),
							d.y > t.y != x.y > t.y &&
								t.x < ((x.x - d.x) * (t.y - d.y)) / (x.y - d.y) + d.x &&
								(i = !i));
				return i || Qi.prototype._containsPoint.call(this, t, !0);
			},
		});
		function nr(t, i) {
			return new Nn(t, i);
		}
		var vn = ae.extend({
			initialize: function (t, i) {
				(P(this, i), (this._layers = {}), t && this.addData(t));
			},
			addData: function (t) {
				var i = j(t) ? t : t.features,
					a,
					d,
					x;
				if (i) {
					for (a = 0, d = i.length; a < d; a++)
						((x = i[a]),
							(x.geometries || x.geometry || x.features || x.coordinates) &&
								this.addData(x));
					return this;
				}
				var M = this.options;
				if (M.filter && !M.filter(t)) return this;
				var q = kr(t, M);
				return q
					? ((q.feature = et(t)),
						(q.defaultOptions = q.options),
						this.resetStyle(q),
						M.onEachFeature && M.onEachFeature(t, q),
						this.addLayer(q))
					: this;
			},
			resetStyle: function (t) {
				return t === void 0
					? this.eachLayer(this.resetStyle, this)
					: ((t.options = s({}, t.defaultOptions)),
						this._setLayerStyle(t, this.options.style),
						this);
			},
			setStyle: function (t) {
				return this.eachLayer(function (i) {
					this._setLayerStyle(i, t);
				}, this);
			},
			_setLayerStyle: function (t, i) {
				t.setStyle &&
					(typeof i == "function" && (i = i(t.feature)), t.setStyle(i));
			},
		});
		function kr(t, i) {
			var a = t.type === "Feature" ? t.geometry : t,
				d = a ? a.coordinates : null,
				x = [],
				M = i && i.pointToLayer,
				q = (i && i.coordsToLatLng) || Jr,
				J,
				nt,
				ht,
				At;
			if (!d && !a) return null;
			switch (a.type) {
				case "Point":
					return ((J = q(d)), ro(M, t, J, i));
				case "MultiPoint":
					for (ht = 0, At = d.length; ht < At; ht++)
						((J = q(d[ht])), x.push(ro(M, t, J, i)));
					return new ae(x);
				case "LineString":
				case "MultiLineString":
					return (
						(nt = ln(d, a.type === "LineString" ? 0 : 1, q)),
						new Qi(nt, i)
					);
				case "Polygon":
				case "MultiPolygon":
					return ((nt = ln(d, a.type === "Polygon" ? 1 : 2, q)), new Nn(nt, i));
				case "GeometryCollection":
					for (ht = 0, At = a.geometries.length; ht < At; ht++) {
						var Yt = kr(
							{
								geometry: a.geometries[ht],
								type: "Feature",
								properties: t.properties,
							},
							i,
						);
						Yt && x.push(Yt);
					}
					return new ae(x);
				case "FeatureCollection":
					for (ht = 0, At = a.features.length; ht < At; ht++) {
						var _e = kr(a.features[ht], i);
						_e && x.push(_e);
					}
					return new ae(x);
				default:
					throw new Error("Invalid GeoJSON object.");
			}
		}
		function ro(t, i, a, d) {
			return t ? t(i, a) : new ys(a, d && d.markersInheritOptions && d);
		}
		function Jr(t) {
			return new Vt(t[1], t[0], t[2]);
		}
		function ln(t, i, a) {
			for (var d = [], x = 0, M = t.length, q; x < M; x++)
				((q = i ? ln(t[x], i - 1, a) : (a || Jr)(t[x])), d.push(q));
			return d;
		}
		function z(t, i) {
			return (
				(t = U(t)),
				t.alt !== void 0
					? [D(t.lng, i), D(t.lat, i), D(t.alt, i)]
					: [D(t.lng, i), D(t.lat, i)]
			);
		}
		function Z(t, i, a, d) {
			for (var x = [], M = 0, q = t.length; M < q; M++)
				x.push(i ? Z(t[M], Si(t[M]) ? 0 : i - 1, a, d) : z(t[M], d));
			return (!i && a && x.length > 0 && x.push(x[0].slice()), x);
		}
		function X(t, i) {
			return t.feature ? s({}, t.feature, { geometry: i }) : et(i);
		}
		function et(t) {
			return t.type === "Feature" || t.type === "FeatureCollection"
				? t
				: { type: "Feature", properties: {}, geometry: t };
		}
		var at = {
			toGeoJSON: function (t) {
				return X(this, { type: "Point", coordinates: z(this.getLatLng(), t) });
			},
		};
		(ys.include(at),
			zn.include(at),
			Vi.include(at),
			Qi.include({
				toGeoJSON: function (t) {
					var i = !Si(this._latlngs),
						a = Z(this._latlngs, i ? 1 : 0, !1, t);
					return X(this, {
						type: (i ? "Multi" : "") + "LineString",
						coordinates: a,
					});
				},
			}),
			Nn.include({
				toGeoJSON: function (t) {
					var i = !Si(this._latlngs),
						a = i && !Si(this._latlngs[0]),
						d = Z(this._latlngs, a ? 2 : i ? 1 : 0, !0, t);
					return (
						i || (d = [d]),
						X(this, { type: (a ? "Multi" : "") + "Polygon", coordinates: d })
					);
				},
			}),
			Zr.include({
				toMultiPoint: function (t) {
					var i = [];
					return (
						this.eachLayer(function (a) {
							i.push(a.toGeoJSON(t).geometry.coordinates);
						}),
						X(this, { type: "MultiPoint", coordinates: i })
					);
				},
				toGeoJSON: function (t) {
					var i =
						this.feature && this.feature.geometry && this.feature.geometry.type;
					if (i === "MultiPoint") return this.toMultiPoint(t);
					var a = i === "GeometryCollection",
						d = [];
					return (
						this.eachLayer(function (x) {
							if (x.toGeoJSON) {
								var M = x.toGeoJSON(t);
								if (a) d.push(M.geometry);
								else {
									var q = et(M);
									q.type === "FeatureCollection"
										? d.push.apply(d, q.features)
										: d.push(q);
								}
							}
						}),
						a
							? X(this, { geometries: d, type: "GeometryCollection" })
							: { type: "FeatureCollection", features: d }
					);
				},
			}));
		function mt(t, i) {
			return new vn(t, i);
		}
		var wt = mt,
			It = _n.extend({
				options: {
					opacity: 1,
					alt: "",
					interactive: !1,
					crossOrigin: !1,
					errorOverlayUrl: "",
					zIndex: 1,
					className: "",
				},
				initialize: function (t, i, a) {
					((this._url = t), (this._bounds = jt(i)), P(this, a));
				},
				onAdd: function () {
					(this._image ||
						(this._initImage(),
						this.options.opacity < 1 && this._updateOpacity()),
						this.options.interactive &&
							(ue(this._image, "leaflet-interactive"),
							this.addInteractiveTarget(this._image)),
						this.getPane().appendChild(this._image),
						this._reset());
				},
				onRemove: function () {
					(Ke(this._image),
						this.options.interactive &&
							this.removeInteractiveTarget(this._image));
				},
				setOpacity: function (t) {
					return (
						(this.options.opacity = t),
						this._image && this._updateOpacity(),
						this
					);
				},
				setStyle: function (t) {
					return (t.opacity && this.setOpacity(t.opacity), this);
				},
				bringToFront: function () {
					return (this._map && Pn(this._image), this);
				},
				bringToBack: function () {
					return (this._map && an(this._image), this);
				},
				setUrl: function (t) {
					return ((this._url = t), this._image && (this._image.src = t), this);
				},
				setBounds: function (t) {
					return ((this._bounds = jt(t)), this._map && this._reset(), this);
				},
				getEvents: function () {
					var t = { zoom: this._reset, viewreset: this._reset };
					return (this._zoomAnimated && (t.zoomanim = this._animateZoom), t);
				},
				setZIndex: function (t) {
					return ((this.options.zIndex = t), this._updateZIndex(), this);
				},
				getBounds: function () {
					return this._bounds;
				},
				getElement: function () {
					return this._image;
				},
				_initImage: function () {
					var t = this._url.tagName === "IMG",
						i = (this._image = t ? this._url : ve("img"));
					if (
						(ue(i, "leaflet-image-layer"),
						this._zoomAnimated && ue(i, "leaflet-zoom-animated"),
						this.options.className && ue(i, this.options.className),
						(i.onselectstart = A),
						(i.onmousemove = A),
						(i.onload = l(this.fire, this, "load")),
						(i.onerror = l(this._overlayOnError, this, "error")),
						(this.options.crossOrigin || this.options.crossOrigin === "") &&
							(i.crossOrigin =
								this.options.crossOrigin === !0
									? ""
									: this.options.crossOrigin),
						this.options.zIndex && this._updateZIndex(),
						t)
					) {
						this._url = i.src;
						return;
					}
					((i.src = this._url), (i.alt = this.options.alt));
				},
				_animateZoom: function (t) {
					var i = this._map.getZoomScale(t.zoom),
						a = this._map._latLngBoundsToNewLayerBounds(
							this._bounds,
							t.zoom,
							t.center,
						).min;
					wi(this._image, a, i);
				},
				_reset: function () {
					var t = this._image,
						i = new Wt(
							this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
							this._map.latLngToLayerPoint(this._bounds.getSouthEast()),
						),
						a = i.getSize();
					(ui(t, i.min),
						(t.style.width = a.x + "px"),
						(t.style.height = a.y + "px"));
				},
				_updateOpacity: function () {
					Ai(this._image, this.options.opacity);
				},
				_updateZIndex: function () {
					this._image &&
						this.options.zIndex !== void 0 &&
						this.options.zIndex !== null &&
						(this._image.style.zIndex = this.options.zIndex);
				},
				_overlayOnError: function () {
					this.fire("error");
					var t = this.options.errorOverlayUrl;
					t && this._url !== t && ((this._url = t), (this._image.src = t));
				},
				getCenter: function () {
					return this._bounds.getCenter();
				},
			}),
			kt = function (t, i, a) {
				return new It(t, i, a);
			},
			pe = It.extend({
				options: {
					autoplay: !0,
					loop: !0,
					keepAspectRatio: !0,
					muted: !1,
					playsInline: !0,
				},
				_initImage: function () {
					var t = this._url.tagName === "VIDEO",
						i = (this._image = t ? this._url : ve("video"));
					if (
						(ue(i, "leaflet-image-layer"),
						this._zoomAnimated && ue(i, "leaflet-zoom-animated"),
						this.options.className && ue(i, this.options.className),
						(i.onselectstart = A),
						(i.onmousemove = A),
						(i.onloadeddata = l(this.fire, this, "load")),
						t)
					) {
						for (
							var a = i.getElementsByTagName("source"), d = [], x = 0;
							x < a.length;
							x++
						)
							d.push(a[x].src);
						this._url = a.length > 0 ? d : [i.src];
						return;
					}
					(j(this._url) || (this._url = [this._url]),
						!this.options.keepAspectRatio &&
							Object.prototype.hasOwnProperty.call(i.style, "objectFit") &&
							(i.style.objectFit = "fill"),
						(i.autoplay = !!this.options.autoplay),
						(i.loop = !!this.options.loop),
						(i.muted = !!this.options.muted),
						(i.playsInline = !!this.options.playsInline));
					for (var M = 0; M < this._url.length; M++) {
						var q = ve("source");
						((q.src = this._url[M]), i.appendChild(q));
					}
				},
			});
		function Gt(t, i, a) {
			return new pe(t, i, a);
		}
		var $t = It.extend({
			_initImage: function () {
				var t = (this._image = this._url);
				(ue(t, "leaflet-image-layer"),
					this._zoomAnimated && ue(t, "leaflet-zoom-animated"),
					this.options.className && ue(t, this.options.className),
					(t.onselectstart = A),
					(t.onmousemove = A));
			},
		});
		function ge(t, i, a) {
			return new $t(t, i, a);
		}
		var Ot = _n.extend({
			options: {
				interactive: !1,
				offset: [0, 0],
				className: "",
				pane: void 0,
				content: "",
			},
			initialize: function (t, i) {
				(t && (t instanceof Vt || j(t))
					? ((this._latlng = U(t)), P(this, i))
					: (P(this, t), (this._source = i)),
					this.options.content && (this._content = this.options.content));
			},
			openOn: function (t) {
				return (
					(t = arguments.length ? t : this._source._map),
					t.hasLayer(this) || t.addLayer(this),
					this
				);
			},
			close: function () {
				return (this._map && this._map.removeLayer(this), this);
			},
			toggle: function (t) {
				return (
					this._map
						? this.close()
						: (arguments.length ? (this._source = t) : (t = this._source),
							this._prepareOpen(),
							this.openOn(t._map)),
					this
				);
			},
			onAdd: function (t) {
				((this._zoomAnimated = t._zoomAnimated),
					this._container || this._initLayout(),
					t._fadeAnimated && Ai(this._container, 0),
					clearTimeout(this._removeTimeout),
					this.getPane().appendChild(this._container),
					this.update(),
					t._fadeAnimated && Ai(this._container, 1),
					this.bringToFront(),
					this.options.interactive &&
						(ue(this._container, "leaflet-interactive"),
						this.addInteractiveTarget(this._container)));
			},
			onRemove: function (t) {
				(t._fadeAnimated
					? (Ai(this._container, 0),
						(this._removeTimeout = setTimeout(
							l(Ke, void 0, this._container),
							200,
						)))
					: Ke(this._container),
					this.options.interactive &&
						(Je(this._container, "leaflet-interactive"),
						this.removeInteractiveTarget(this._container)));
			},
			getLatLng: function () {
				return this._latlng;
			},
			setLatLng: function (t) {
				return (
					(this._latlng = U(t)),
					this._map && (this._updatePosition(), this._adjustPan()),
					this
				);
			},
			getContent: function () {
				return this._content;
			},
			setContent: function (t) {
				return ((this._content = t), this.update(), this);
			},
			getElement: function () {
				return this._container;
			},
			update: function () {
				this._map &&
					((this._container.style.visibility = "hidden"),
					this._updateContent(),
					this._updateLayout(),
					this._updatePosition(),
					(this._container.style.visibility = ""),
					this._adjustPan());
			},
			getEvents: function () {
				var t = { zoom: this._updatePosition, viewreset: this._updatePosition };
				return (this._zoomAnimated && (t.zoomanim = this._animateZoom), t);
			},
			isOpen: function () {
				return !!this._map && this._map.hasLayer(this);
			},
			bringToFront: function () {
				return (this._map && Pn(this._container), this);
			},
			bringToBack: function () {
				return (this._map && an(this._container), this);
			},
			_prepareOpen: function (t) {
				var i = this._source;
				if (!i._map) return !1;
				if (i instanceof ae) {
					i = null;
					var a = this._source._layers;
					for (var d in a)
						if (a[d]._map) {
							i = a[d];
							break;
						}
					if (!i) return !1;
					this._source = i;
				}
				if (!t)
					if (i.getCenter) t = i.getCenter();
					else if (i.getLatLng) t = i.getLatLng();
					else if (i.getBounds) t = i.getBounds().getCenter();
					else throw new Error("Unable to get source layer LatLng.");
				return (this.setLatLng(t), this._map && this.update(), !0);
			},
			_updateContent: function () {
				if (this._content) {
					var t = this._contentNode,
						i =
							typeof this._content == "function"
								? this._content(this._source || this)
								: this._content;
					if (typeof i == "string") t.innerHTML = i;
					else {
						for (; t.hasChildNodes(); ) t.removeChild(t.firstChild);
						t.appendChild(i);
					}
					this.fire("contentupdate");
				}
			},
			_updatePosition: function () {
				if (this._map) {
					var t = this._map.latLngToLayerPoint(this._latlng),
						i = W(this.options.offset),
						a = this._getAnchor();
					this._zoomAnimated
						? ui(this._container, t.add(a))
						: (i = i.add(t).add(a));
					var d = (this._containerBottom = -i.y),
						x = (this._containerLeft =
							-Math.round(this._containerWidth / 2) + i.x);
					((this._container.style.bottom = d + "px"),
						(this._container.style.left = x + "px"));
				}
			},
			_getAnchor: function () {
				return [0, 0];
			},
		});
		(Se.include({
			_initOverlay: function (t, i, a, d) {
				var x = i;
				return (
					x instanceof t || (x = new t(d).setContent(i)),
					a && x.setLatLng(a),
					x
				);
			},
		}),
			_n.include({
				_initOverlay: function (t, i, a, d) {
					var x = a;
					return (
						x instanceof t
							? (P(x, d), (x._source = this))
							: ((x = i && !d ? i : new t(d, this)), x.setContent(a)),
						x
					);
				},
			}));
		var Ee = Ot.extend({
				options: {
					pane: "popupPane",
					offset: [0, 7],
					maxWidth: 300,
					minWidth: 50,
					maxHeight: null,
					autoPan: !0,
					autoPanPaddingTopLeft: null,
					autoPanPaddingBottomRight: null,
					autoPanPadding: [5, 5],
					keepInView: !1,
					closeButton: !0,
					autoClose: !0,
					closeOnEscapeKey: !0,
					className: "",
				},
				openOn: function (t) {
					return (
						(t = arguments.length ? t : this._source._map),
						!t.hasLayer(this) &&
							t._popup &&
							t._popup.options.autoClose &&
							t.removeLayer(t._popup),
						(t._popup = this),
						Ot.prototype.openOn.call(this, t)
					);
				},
				onAdd: function (t) {
					(Ot.prototype.onAdd.call(this, t),
						t.fire("popupopen", { popup: this }),
						this._source &&
							(this._source.fire("popupopen", { popup: this }, !0),
							this._source instanceof be || this._source.on("preclick", qr)));
				},
				onRemove: function (t) {
					(Ot.prototype.onRemove.call(this, t),
						t.fire("popupclose", { popup: this }),
						this._source &&
							(this._source.fire("popupclose", { popup: this }, !0),
							this._source instanceof be || this._source.off("preclick", qr)));
				},
				getEvents: function () {
					var t = Ot.prototype.getEvents.call(this);
					return (
						(this.options.closeOnClick !== void 0
							? this.options.closeOnClick
							: this._map.options.closePopupOnClick) &&
							(t.preclick = this.close),
						this.options.keepInView && (t.moveend = this._adjustPan),
						t
					);
				},
				_initLayout: function () {
					var t = "leaflet-popup",
						i = (this._container = ve(
							"div",
							t +
								" " +
								(this.options.className || "") +
								" leaflet-zoom-animated",
						)),
						a = (this._wrapper = ve("div", t + "-content-wrapper", i));
					if (
						((this._contentNode = ve("div", t + "-content", a)),
						gs(i),
						to(this._contentNode),
						ee(i, "contextmenu", qr),
						(this._tipContainer = ve("div", t + "-tip-container", i)),
						(this._tip = ve("div", t + "-tip", this._tipContainer)),
						this.options.closeButton)
					) {
						var d = (this._closeButton = ve("a", t + "-close-button", i));
						(d.setAttribute("role", "button"),
							d.setAttribute("aria-label", "Close popup"),
							(d.href = "#close"),
							(d.innerHTML = '<span aria-hidden="true">&#215;</span>'),
							ee(
								d,
								"click",
								function (x) {
									(Mi(x), this.close());
								},
								this,
							));
					}
				},
				_updateLayout: function () {
					var t = this._contentNode,
						i = t.style;
					((i.width = ""), (i.whiteSpace = "nowrap"));
					var a = t.offsetWidth;
					((a = Math.min(a, this.options.maxWidth)),
						(a = Math.max(a, this.options.minWidth)),
						(i.width = a + 1 + "px"),
						(i.whiteSpace = ""),
						(i.height = ""));
					var d = t.offsetHeight,
						x = this.options.maxHeight,
						M = "leaflet-popup-scrolled";
					(x && d > x ? ((i.height = x + "px"), ue(t, M)) : Je(t, M),
						(this._containerWidth = this._container.offsetWidth));
				},
				_animateZoom: function (t) {
					var i = this._map._latLngToNewLayerPoint(
							this._latlng,
							t.zoom,
							t.center,
						),
						a = this._getAnchor();
					ui(this._container, i.add(a));
				},
				_adjustPan: function () {
					if (this.options.autoPan) {
						if (
							(this._map._panAnim && this._map._panAnim.stop(),
							this._autopanning)
						) {
							this._autopanning = !1;
							return;
						}
						var t = this._map,
							i = parseInt(mn(this._container, "marginBottom"), 10) || 0,
							a = this._container.offsetHeight + i,
							d = this._containerWidth,
							x = new _t(this._containerLeft, -a - this._containerBottom);
						x._add(Tt(this._container));
						var M = t.layerPointToContainerPoint(x),
							q = W(this.options.autoPanPadding),
							J = W(this.options.autoPanPaddingTopLeft || q),
							nt = W(this.options.autoPanPaddingBottomRight || q),
							ht = t.getSize(),
							At = 0,
							Yt = 0;
						(M.x + d + nt.x > ht.x && (At = M.x + d - ht.x + nt.x),
							M.x - At - J.x < 0 && (At = M.x - J.x),
							M.y + a + nt.y > ht.y && (Yt = M.y + a - ht.y + nt.y),
							M.y - Yt - J.y < 0 && (Yt = M.y - J.y),
							(At || Yt) &&
								(this.options.keepInView && (this._autopanning = !0),
								t.fire("autopanstart").panBy([At, Yt])));
					}
				},
				_getAnchor: function () {
					return W(
						this._source && this._source._getPopupAnchor
							? this._source._getPopupAnchor()
							: [0, 0],
					);
				},
			}),
			Gi = function (t, i) {
				return new Ee(t, i);
			};
		(Se.mergeOptions({ closePopupOnClick: !0 }),
			Se.include({
				openPopup: function (t, i, a) {
					return (this._initOverlay(Ee, t, i, a).openOn(this), this);
				},
				closePopup: function (t) {
					return (
						(t = arguments.length ? t : this._popup),
						t && t.close(),
						this
					);
				},
			}),
			_n.include({
				bindPopup: function (t, i) {
					return (
						(this._popup = this._initOverlay(Ee, this._popup, t, i)),
						this._popupHandlersAdded ||
							(this.on({
								click: this._openPopup,
								keypress: this._onKeyPress,
								remove: this.closePopup,
								move: this._movePopup,
							}),
							(this._popupHandlersAdded = !0)),
						this
					);
				},
				unbindPopup: function () {
					return (
						this._popup &&
							(this.off({
								click: this._openPopup,
								keypress: this._onKeyPress,
								remove: this.closePopup,
								move: this._movePopup,
							}),
							(this._popupHandlersAdded = !1),
							(this._popup = null)),
						this
					);
				},
				openPopup: function (t) {
					return (
						this._popup &&
							(this instanceof ae || (this._popup._source = this),
							this._popup._prepareOpen(t || this._latlng) &&
								this._popup.openOn(this._map)),
						this
					);
				},
				closePopup: function () {
					return (this._popup && this._popup.close(), this);
				},
				togglePopup: function () {
					return (this._popup && this._popup.toggle(this), this);
				},
				isPopupOpen: function () {
					return this._popup ? this._popup.isOpen() : !1;
				},
				setPopupContent: function (t) {
					return (this._popup && this._popup.setContent(t), this);
				},
				getPopup: function () {
					return this._popup;
				},
				_openPopup: function (t) {
					if (!(!this._popup || !this._map)) {
						dr(t);
						var i = t.layer || t.target;
						if (this._popup._source === i && !(i instanceof be)) {
							this._map.hasLayer(this._popup)
								? this.closePopup()
								: this.openPopup(t.latlng);
							return;
						}
						((this._popup._source = i), this.openPopup(t.latlng));
					}
				},
				_movePopup: function (t) {
					this._popup.setLatLng(t.latlng);
				},
				_onKeyPress: function (t) {
					t.originalEvent.keyCode === 13 && this._openPopup(t);
				},
			}));
		var Qe = Ot.extend({
				options: {
					pane: "tooltipPane",
					offset: [0, 0],
					direction: "auto",
					permanent: !1,
					sticky: !1,
					opacity: 0.9,
				},
				onAdd: function (t) {
					(Ot.prototype.onAdd.call(this, t),
						this.setOpacity(this.options.opacity),
						t.fire("tooltipopen", { tooltip: this }),
						this._source &&
							(this.addEventParent(this._source),
							this._source.fire("tooltipopen", { tooltip: this }, !0)));
				},
				onRemove: function (t) {
					(Ot.prototype.onRemove.call(this, t),
						t.fire("tooltipclose", { tooltip: this }),
						this._source &&
							(this.removeEventParent(this._source),
							this._source.fire("tooltipclose", { tooltip: this }, !0)));
				},
				getEvents: function () {
					var t = Ot.prototype.getEvents.call(this);
					return (this.options.permanent || (t.preclick = this.close), t);
				},
				_initLayout: function () {
					var t = "leaflet-tooltip",
						i =
							t +
							" " +
							(this.options.className || "") +
							" leaflet-zoom-" +
							(this._zoomAnimated ? "animated" : "hide");
					((this._contentNode = this._container = ve("div", i)),
						this._container.setAttribute("role", "tooltip"),
						this._container.setAttribute("id", "leaflet-tooltip-" + f(this)));
				},
				_updateLayout: function () {},
				_adjustPan: function () {},
				_setPosition: function (t) {
					var i,
						a,
						d = this._map,
						x = this._container,
						M = d.latLngToContainerPoint(d.getCenter()),
						q = d.layerPointToContainerPoint(t),
						J = this.options.direction,
						nt = x.offsetWidth,
						ht = x.offsetHeight,
						At = W(this.options.offset),
						Yt = this._getAnchor();
					(J === "top"
						? ((i = nt / 2), (a = ht))
						: J === "bottom"
							? ((i = nt / 2), (a = 0))
							: J === "center"
								? ((i = nt / 2), (a = ht / 2))
								: J === "right"
									? ((i = 0), (a = ht / 2))
									: J === "left"
										? ((i = nt), (a = ht / 2))
										: q.x < M.x
											? ((J = "right"), (i = 0), (a = ht / 2))
											: ((J = "left"),
												(i = nt + (At.x + Yt.x) * 2),
												(a = ht / 2)),
						(t = t
							.subtract(W(i, a, !0))
							.add(At)
							.add(Yt)),
						Je(x, "leaflet-tooltip-right"),
						Je(x, "leaflet-tooltip-left"),
						Je(x, "leaflet-tooltip-top"),
						Je(x, "leaflet-tooltip-bottom"),
						ue(x, "leaflet-tooltip-" + J),
						ui(x, t));
				},
				_updatePosition: function () {
					var t = this._map.latLngToLayerPoint(this._latlng);
					this._setPosition(t);
				},
				setOpacity: function (t) {
					((this.options.opacity = t),
						this._container && Ai(this._container, t));
				},
				_animateZoom: function (t) {
					var i = this._map._latLngToNewLayerPoint(
						this._latlng,
						t.zoom,
						t.center,
					);
					this._setPosition(i);
				},
				_getAnchor: function () {
					return W(
						this._source &&
							this._source._getTooltipAnchor &&
							!this.options.sticky
							? this._source._getTooltipAnchor()
							: [0, 0],
					);
				},
			}),
			cn = function (t, i) {
				return new Qe(t, i);
			};
		(Se.include({
			openTooltip: function (t, i, a) {
				return (this._initOverlay(Qe, t, i, a).openOn(this), this);
			},
			closeTooltip: function (t) {
				return (t.close(), this);
			},
		}),
			_n.include({
				bindTooltip: function (t, i) {
					return (
						this._tooltip && this.isTooltipOpen() && this.unbindTooltip(),
						(this._tooltip = this._initOverlay(Qe, this._tooltip, t, i)),
						this._initTooltipInteractions(),
						this._tooltip.options.permanent &&
							this._map &&
							this._map.hasLayer(this) &&
							this.openTooltip(),
						this
					);
				},
				unbindTooltip: function () {
					return (
						this._tooltip &&
							(this._initTooltipInteractions(!0),
							this.closeTooltip(),
							(this._tooltip = null)),
						this
					);
				},
				_initTooltipInteractions: function (t) {
					if (!(!t && this._tooltipHandlersAdded)) {
						var i = t ? "off" : "on",
							a = { remove: this.closeTooltip, move: this._moveTooltip };
						(this._tooltip.options.permanent
							? (a.add = this._openTooltip)
							: ((a.mouseover = this._openTooltip),
								(a.mouseout = this.closeTooltip),
								(a.click = this._openTooltip),
								this._map
									? this._addFocusListeners()
									: (a.add = this._addFocusListeners)),
							this._tooltip.options.sticky && (a.mousemove = this._moveTooltip),
							this[i](a),
							(this._tooltipHandlersAdded = !t));
					}
				},
				openTooltip: function (t) {
					return (
						this._tooltip &&
							(this instanceof ae || (this._tooltip._source = this),
							this._tooltip._prepareOpen(t) &&
								(this._tooltip.openOn(this._map),
								this.getElement
									? this._setAriaDescribedByOnLayer(this)
									: this.eachLayer &&
										this.eachLayer(this._setAriaDescribedByOnLayer, this))),
						this
					);
				},
				closeTooltip: function () {
					if (this._tooltip) return this._tooltip.close();
				},
				toggleTooltip: function () {
					return (this._tooltip && this._tooltip.toggle(this), this);
				},
				isTooltipOpen: function () {
					return this._tooltip.isOpen();
				},
				setTooltipContent: function (t) {
					return (this._tooltip && this._tooltip.setContent(t), this);
				},
				getTooltip: function () {
					return this._tooltip;
				},
				_addFocusListeners: function () {
					this.getElement
						? this._addFocusListenersOnLayer(this)
						: this.eachLayer &&
							this.eachLayer(this._addFocusListenersOnLayer, this);
				},
				_addFocusListenersOnLayer: function (t) {
					var i = typeof t.getElement == "function" && t.getElement();
					i &&
						(ee(
							i,
							"focus",
							function () {
								((this._tooltip._source = t), this.openTooltip());
							},
							this,
						),
						ee(i, "blur", this.closeTooltip, this));
				},
				_setAriaDescribedByOnLayer: function (t) {
					var i = typeof t.getElement == "function" && t.getElement();
					i && i.setAttribute("aria-describedby", this._tooltip._container.id);
				},
				_openTooltip: function (t) {
					if (!(!this._tooltip || !this._map)) {
						if (
							this._map.dragging &&
							this._map.dragging.moving() &&
							!this._openOnceFlag
						) {
							this._openOnceFlag = !0;
							var i = this;
							this._map.once("moveend", function () {
								((i._openOnceFlag = !1), i._openTooltip(t));
							});
							return;
						}
						((this._tooltip._source = t.layer || t.target),
							this.openTooltip(
								this._tooltip.options.sticky ? t.latlng : void 0,
							));
					}
				},
				_moveTooltip: function (t) {
					var i = t.latlng,
						a,
						d;
					(this._tooltip.options.sticky &&
						t.originalEvent &&
						((a = this._map.mouseEventToContainerPoint(t.originalEvent)),
						(d = this._map.containerPointToLayerPoint(a)),
						(i = this._map.layerPointToLatLng(d))),
						this._tooltip.setLatLng(i));
				},
			}));
		var Rn = qi.extend({
			options: {
				iconSize: [12, 12],
				html: !1,
				bgPos: null,
				className: "leaflet-div-icon",
			},
			createIcon: function (t) {
				var i = t && t.tagName === "DIV" ? t : document.createElement("div"),
					a = this.options;
				if (
					(a.html instanceof Element
						? (Bi(i), i.appendChild(a.html))
						: (i.innerHTML = a.html !== !1 ? a.html : ""),
					a.bgPos)
				) {
					var d = W(a.bgPos);
					i.style.backgroundPosition = -d.x + "px " + -d.y + "px";
				}
				return (this._setIconStyles(i, "icon"), i);
			},
			createShadow: function () {
				return null;
			},
		});
		function Qr(t) {
			return new Rn(t);
		}
		qi.Default = Lr;
		var oi = _n.extend({
			options: {
				tileSize: 256,
				opacity: 1,
				updateWhenIdle: xt.mobile,
				updateWhenZooming: !0,
				updateInterval: 200,
				zIndex: 1,
				bounds: null,
				minZoom: 0,
				maxZoom: void 0,
				maxNativeZoom: void 0,
				minNativeZoom: void 0,
				noWrap: !1,
				pane: "tilePane",
				className: "",
				keepBuffer: 2,
			},
			initialize: function (t) {
				P(this, t);
			},
			onAdd: function () {
				(this._initContainer(),
					(this._levels = {}),
					(this._tiles = {}),
					this._resetView());
			},
			beforeAdd: function (t) {
				t._addZoomLimit(this);
			},
			onRemove: function (t) {
				(this._removeAllTiles(),
					Ke(this._container),
					t._removeZoomLimit(this),
					(this._container = null),
					(this._tileZoom = void 0));
			},
			bringToFront: function () {
				return (
					this._map && (Pn(this._container), this._setAutoZIndex(Math.max)),
					this
				);
			},
			bringToBack: function () {
				return (
					this._map && (an(this._container), this._setAutoZIndex(Math.min)),
					this
				);
			},
			getContainer: function () {
				return this._container;
			},
			setOpacity: function (t) {
				return ((this.options.opacity = t), this._updateOpacity(), this);
			},
			setZIndex: function (t) {
				return ((this.options.zIndex = t), this._updateZIndex(), this);
			},
			isLoading: function () {
				return this._loading;
			},
			redraw: function () {
				if (this._map) {
					this._removeAllTiles();
					var t = this._clampZoom(this._map.getZoom());
					(t !== this._tileZoom && ((this._tileZoom = t), this._updateLevels()),
						this._update());
				}
				return this;
			},
			getEvents: function () {
				var t = {
					viewprereset: this._invalidateAll,
					viewreset: this._resetView,
					zoom: this._resetView,
					moveend: this._onMoveEnd,
				};
				return (
					this.options.updateWhenIdle ||
						(this._onMove ||
							(this._onMove = v(
								this._onMoveEnd,
								this.options.updateInterval,
								this,
							)),
						(t.move = this._onMove)),
					this._zoomAnimated && (t.zoomanim = this._animateZoom),
					t
				);
			},
			createTile: function () {
				return document.createElement("div");
			},
			getTileSize: function () {
				var t = this.options.tileSize;
				return t instanceof _t ? t : new _t(t, t);
			},
			_updateZIndex: function () {
				this._container &&
					this.options.zIndex !== void 0 &&
					this.options.zIndex !== null &&
					(this._container.style.zIndex = this.options.zIndex);
			},
			_setAutoZIndex: function (t) {
				for (
					var i = this.getPane().children,
						a = -t(-1 / 0, 1 / 0),
						d = 0,
						x = i.length,
						M;
					d < x;
					d++
				)
					((M = i[d].style.zIndex),
						i[d] !== this._container && M && (a = t(a, +M)));
				isFinite(a) &&
					((this.options.zIndex = a + t(-1, 1)), this._updateZIndex());
			},
			_updateOpacity: function () {
				if (this._map && !xt.ielt9) {
					Ai(this._container, this.options.opacity);
					var t = +new Date(),
						i = !1,
						a = !1;
					for (var d in this._tiles) {
						var x = this._tiles[d];
						if (!(!x.current || !x.loaded)) {
							var M = Math.min(1, (t - x.loaded) / 200);
							(Ai(x.el, M),
								M < 1
									? (i = !0)
									: (x.active ? (a = !0) : this._onOpaqueTile(x),
										(x.active = !0)));
						}
					}
					(a && !this._noPrune && this._pruneTiles(),
						i &&
							(pt(this._fadeFrame),
							(this._fadeFrame = Dt(this._updateOpacity, this))));
				}
			},
			_onOpaqueTile: A,
			_initContainer: function () {
				this._container ||
					((this._container = ve(
						"div",
						"leaflet-layer " + (this.options.className || ""),
					)),
					this._updateZIndex(),
					this.options.opacity < 1 && this._updateOpacity(),
					this.getPane().appendChild(this._container));
			},
			_updateLevels: function () {
				var t = this._tileZoom,
					i = this.options.maxZoom;
				if (t !== void 0) {
					for (var a in this._levels)
						((a = Number(a)),
							this._levels[a].el.children.length || a === t
								? ((this._levels[a].el.style.zIndex = i - Math.abs(t - a)),
									this._onUpdateLevel(a))
								: (Ke(this._levels[a].el),
									this._removeTilesAtZoom(a),
									this._onRemoveLevel(a),
									delete this._levels[a]));
					var d = this._levels[t],
						x = this._map;
					return (
						d ||
							((d = this._levels[t] = {}),
							(d.el = ve(
								"div",
								"leaflet-tile-container leaflet-zoom-animated",
								this._container,
							)),
							(d.el.style.zIndex = i),
							(d.origin = x
								.project(x.unproject(x.getPixelOrigin()), t)
								.round()),
							(d.zoom = t),
							this._setZoomTransform(d, x.getCenter(), x.getZoom()),
							A(d.el.offsetWidth),
							this._onCreateLevel(d)),
						(this._level = d),
						d
					);
				}
			},
			_onUpdateLevel: A,
			_onRemoveLevel: A,
			_onCreateLevel: A,
			_pruneTiles: function () {
				if (this._map) {
					var t,
						i,
						a = this._map.getZoom();
					if (a > this.options.maxZoom || a < this.options.minZoom) {
						this._removeAllTiles();
						return;
					}
					for (t in this._tiles) ((i = this._tiles[t]), (i.retain = i.current));
					for (t in this._tiles)
						if (((i = this._tiles[t]), i.current && !i.active)) {
							var d = i.coords;
							this._retainParent(d.x, d.y, d.z, d.z - 5) ||
								this._retainChildren(d.x, d.y, d.z, d.z + 2);
						}
					for (t in this._tiles) this._tiles[t].retain || this._removeTile(t);
				}
			},
			_removeTilesAtZoom: function (t) {
				for (var i in this._tiles)
					this._tiles[i].coords.z === t && this._removeTile(i);
			},
			_removeAllTiles: function () {
				for (var t in this._tiles) this._removeTile(t);
			},
			_invalidateAll: function () {
				for (var t in this._levels)
					(Ke(this._levels[t].el),
						this._onRemoveLevel(Number(t)),
						delete this._levels[t]);
				(this._removeAllTiles(), (this._tileZoom = void 0));
			},
			_retainParent: function (t, i, a, d) {
				var x = Math.floor(t / 2),
					M = Math.floor(i / 2),
					q = a - 1,
					J = new _t(+x, +M);
				J.z = +q;
				var nt = this._tileCoordsToKey(J),
					ht = this._tiles[nt];
				return ht && ht.active
					? ((ht.retain = !0), !0)
					: (ht && ht.loaded && (ht.retain = !0),
						q > d ? this._retainParent(x, M, q, d) : !1);
			},
			_retainChildren: function (t, i, a, d) {
				for (var x = 2 * t; x < 2 * t + 2; x++)
					for (var M = 2 * i; M < 2 * i + 2; M++) {
						var q = new _t(x, M);
						q.z = a + 1;
						var J = this._tileCoordsToKey(q),
							nt = this._tiles[J];
						if (nt && nt.active) {
							nt.retain = !0;
							continue;
						} else nt && nt.loaded && (nt.retain = !0);
						a + 1 < d && this._retainChildren(x, M, a + 1, d);
					}
			},
			_resetView: function (t) {
				var i = t && (t.pinch || t.flyTo);
				this._setView(this._map.getCenter(), this._map.getZoom(), i, i);
			},
			_animateZoom: function (t) {
				this._setView(t.center, t.zoom, !0, t.noUpdate);
			},
			_clampZoom: function (t) {
				var i = this.options;
				return i.minNativeZoom !== void 0 && t < i.minNativeZoom
					? i.minNativeZoom
					: i.maxNativeZoom !== void 0 && i.maxNativeZoom < t
						? i.maxNativeZoom
						: t;
			},
			_setView: function (t, i, a, d) {
				var x = Math.round(i);
				(this.options.maxZoom !== void 0 && x > this.options.maxZoom) ||
				(this.options.minZoom !== void 0 && x < this.options.minZoom)
					? (x = void 0)
					: (x = this._clampZoom(x));
				var M = this.options.updateWhenZooming && x !== this._tileZoom;
				((!d || M) &&
					((this._tileZoom = x),
					this._abortLoading && this._abortLoading(),
					this._updateLevels(),
					this._resetGrid(),
					x !== void 0 && this._update(t),
					a || this._pruneTiles(),
					(this._noPrune = !!a)),
					this._setZoomTransforms(t, i));
			},
			_setZoomTransforms: function (t, i) {
				for (var a in this._levels)
					this._setZoomTransform(this._levels[a], t, i);
			},
			_setZoomTransform: function (t, i, a) {
				var d = this._map.getZoomScale(a, t.zoom),
					x = t.origin
						.multiplyBy(d)
						.subtract(this._map._getNewPixelOrigin(i, a))
						.round();
				xt.any3d ? wi(t.el, x, d) : ui(t.el, x);
			},
			_resetGrid: function () {
				var t = this._map,
					i = t.options.crs,
					a = (this._tileSize = this.getTileSize()),
					d = this._tileZoom,
					x = this._map.getPixelWorldBounds(this._tileZoom);
				(x && (this._globalTileRange = this._pxBoundsToTileRange(x)),
					(this._wrapX = i.wrapLng &&
						!this.options.noWrap && [
							Math.floor(t.project([0, i.wrapLng[0]], d).x / a.x),
							Math.ceil(t.project([0, i.wrapLng[1]], d).x / a.y),
						]),
					(this._wrapY = i.wrapLat &&
						!this.options.noWrap && [
							Math.floor(t.project([i.wrapLat[0], 0], d).y / a.x),
							Math.ceil(t.project([i.wrapLat[1], 0], d).y / a.y),
						]));
			},
			_onMoveEnd: function () {
				!this._map || this._map._animatingZoom || this._update();
			},
			_getTiledPixelBounds: function (t) {
				var i = this._map,
					a = i._animatingZoom
						? Math.max(i._animateToZoom, i.getZoom())
						: i.getZoom(),
					d = i.getZoomScale(a, this._tileZoom),
					x = i.project(t, this._tileZoom).floor(),
					M = i.getSize().divideBy(d * 2);
				return new Wt(x.subtract(M), x.add(M));
			},
			_update: function (t) {
				var i = this._map;
				if (i) {
					var a = this._clampZoom(i.getZoom());
					if (
						(t === void 0 && (t = i.getCenter()), this._tileZoom !== void 0)
					) {
						var d = this._getTiledPixelBounds(t),
							x = this._pxBoundsToTileRange(d),
							M = x.getCenter(),
							q = [],
							J = this.options.keepBuffer,
							nt = new Wt(
								x.getBottomLeft().subtract([J, -J]),
								x.getTopRight().add([J, -J]),
							);
						if (
							!(
								isFinite(x.min.x) &&
								isFinite(x.min.y) &&
								isFinite(x.max.x) &&
								isFinite(x.max.y)
							)
						)
							throw new Error("Attempted to load an infinite number of tiles");
						for (var ht in this._tiles) {
							var At = this._tiles[ht].coords;
							(At.z !== this._tileZoom || !nt.contains(new _t(At.x, At.y))) &&
								(this._tiles[ht].current = !1);
						}
						if (Math.abs(a - this._tileZoom) > 1) {
							this._setView(t, a);
							return;
						}
						for (var Yt = x.min.y; Yt <= x.max.y; Yt++)
							for (var _e = x.min.x; _e <= x.max.x; _e++) {
								var hn = new _t(_e, Yt);
								if (((hn.z = this._tileZoom), !!this._isValidTile(hn))) {
									var Wi = this._tiles[this._tileCoordsToKey(hn)];
									Wi ? (Wi.current = !0) : q.push(hn);
								}
							}
						if (
							(q.sort(function (yn, zs) {
								return yn.distanceTo(M) - zs.distanceTo(M);
							}),
							q.length !== 0)
						) {
							this._loading || ((this._loading = !0), this.fire("loading"));
							var rr = document.createDocumentFragment();
							for (_e = 0; _e < q.length; _e++) this._addTile(q[_e], rr);
							this._level.el.appendChild(rr);
						}
					}
				}
			},
			_isValidTile: function (t) {
				var i = this._map.options.crs;
				if (!i.infinite) {
					var a = this._globalTileRange;
					if (
						(!i.wrapLng && (t.x < a.min.x || t.x > a.max.x)) ||
						(!i.wrapLat && (t.y < a.min.y || t.y > a.max.y))
					)
						return !1;
				}
				if (!this.options.bounds) return !0;
				var d = this._tileCoordsToBounds(t);
				return jt(this.options.bounds).overlaps(d);
			},
			_keyToBounds: function (t) {
				return this._tileCoordsToBounds(this._keyToTileCoords(t));
			},
			_tileCoordsToNwSe: function (t) {
				var i = this._map,
					a = this.getTileSize(),
					d = t.scaleBy(a),
					x = d.add(a),
					M = i.unproject(d, t.z),
					q = i.unproject(x, t.z);
				return [M, q];
			},
			_tileCoordsToBounds: function (t) {
				var i = this._tileCoordsToNwSe(t),
					a = new oe(i[0], i[1]);
				return (this.options.noWrap || (a = this._map.wrapLatLngBounds(a)), a);
			},
			_tileCoordsToKey: function (t) {
				return t.x + ":" + t.y + ":" + t.z;
			},
			_keyToTileCoords: function (t) {
				var i = t.split(":"),
					a = new _t(+i[0], +i[1]);
				return ((a.z = +i[2]), a);
			},
			_removeTile: function (t) {
				var i = this._tiles[t];
				i &&
					(Ke(i.el),
					delete this._tiles[t],
					this.fire("tileunload", {
						tile: i.el,
						coords: this._keyToTileCoords(t),
					}));
			},
			_initTile: function (t) {
				ue(t, "leaflet-tile");
				var i = this.getTileSize();
				((t.style.width = i.x + "px"),
					(t.style.height = i.y + "px"),
					(t.onselectstart = A),
					(t.onmousemove = A),
					xt.ielt9 && this.options.opacity < 1 && Ai(t, this.options.opacity));
			},
			_addTile: function (t, i) {
				var a = this._getTilePos(t),
					d = this._tileCoordsToKey(t),
					x = this.createTile(this._wrapCoords(t), l(this._tileReady, this, t));
				(this._initTile(x),
					this.createTile.length < 2 &&
						Dt(l(this._tileReady, this, t, null, x)),
					ui(x, a),
					(this._tiles[d] = { el: x, coords: t, current: !0 }),
					i.appendChild(x),
					this.fire("tileloadstart", { tile: x, coords: t }));
			},
			_tileReady: function (t, i, a) {
				i && this.fire("tileerror", { error: i, tile: a, coords: t });
				var d = this._tileCoordsToKey(t);
				((a = this._tiles[d]),
					a &&
						((a.loaded = +new Date()),
						this._map._fadeAnimated
							? (Ai(a.el, 0),
								pt(this._fadeFrame),
								(this._fadeFrame = Dt(this._updateOpacity, this)))
							: ((a.active = !0), this._pruneTiles()),
						i ||
							(ue(a.el, "leaflet-tile-loaded"),
							this.fire("tileload", { tile: a.el, coords: t })),
						this._noTilesToLoad() &&
							((this._loading = !1),
							this.fire("load"),
							xt.ielt9 || !this._map._fadeAnimated
								? Dt(this._pruneTiles, this)
								: setTimeout(l(this._pruneTiles, this), 250))));
			},
			_getTilePos: function (t) {
				return t.scaleBy(this.getTileSize()).subtract(this._level.origin);
			},
			_wrapCoords: function (t) {
				var i = new _t(
					this._wrapX ? w(t.x, this._wrapX) : t.x,
					this._wrapY ? w(t.y, this._wrapY) : t.y,
				);
				return ((i.z = t.z), i);
			},
			_pxBoundsToTileRange: function (t) {
				var i = this.getTileSize();
				return new Wt(
					t.min.unscaleBy(i).floor(),
					t.max.unscaleBy(i).ceil().subtract([1, 1]),
				);
			},
			_noTilesToLoad: function () {
				for (var t in this._tiles) if (!this._tiles[t].loaded) return !1;
				return !0;
			},
		});
		function ol(t) {
			return new oi(t);
		}
		var Ar = oi.extend({
			options: {
				minZoom: 0,
				maxZoom: 18,
				subdomains: "abc",
				errorTileUrl: "",
				zoomOffset: 0,
				tms: !1,
				zoomReverse: !1,
				detectRetina: !1,
				crossOrigin: !1,
				referrerPolicy: !1,
			},
			initialize: function (t, i) {
				((this._url = t),
					(i = P(this, i)),
					i.detectRetina && xt.retina && i.maxZoom > 0
						? ((i.tileSize = Math.floor(i.tileSize / 2)),
							i.zoomReverse
								? (i.zoomOffset--,
									(i.minZoom = Math.min(i.maxZoom, i.minZoom + 1)))
								: (i.zoomOffset++,
									(i.maxZoom = Math.max(i.minZoom, i.maxZoom - 1))),
							(i.minZoom = Math.max(0, i.minZoom)))
						: i.zoomReverse
							? (i.minZoom = Math.min(i.maxZoom, i.minZoom))
							: (i.maxZoom = Math.max(i.minZoom, i.maxZoom)),
					typeof i.subdomains == "string" &&
						(i.subdomains = i.subdomains.split("")),
					this.on("tileunload", this._onTileRemove));
			},
			setUrl: function (t, i) {
				return (
					this._url === t && i === void 0 && (i = !0),
					(this._url = t),
					i || this.redraw(),
					this
				);
			},
			createTile: function (t, i) {
				var a = document.createElement("img");
				return (
					ee(a, "load", l(this._tileOnLoad, this, i, a)),
					ee(a, "error", l(this._tileOnError, this, i, a)),
					(this.options.crossOrigin || this.options.crossOrigin === "") &&
						(a.crossOrigin =
							this.options.crossOrigin === !0 ? "" : this.options.crossOrigin),
					typeof this.options.referrerPolicy == "string" &&
						(a.referrerPolicy = this.options.referrerPolicy),
					(a.alt = ""),
					(a.src = this.getTileUrl(t)),
					a
				);
			},
			getTileUrl: function (t) {
				var i = {
					r: xt.retina ? "@2x" : "",
					s: this._getSubdomain(t),
					x: t.x,
					y: t.y,
					z: this._getZoomForUrl(),
				};
				if (this._map && !this._map.options.crs.infinite) {
					var a = this._globalTileRange.max.y - t.y;
					(this.options.tms && (i.y = a), (i["-y"] = a));
				}
				return B(this._url, s(i, this.options));
			},
			_tileOnLoad: function (t, i) {
				xt.ielt9 ? setTimeout(l(t, this, null, i), 0) : t(null, i);
			},
			_tileOnError: function (t, i, a) {
				var d = this.options.errorTileUrl;
				(d && i.getAttribute("src") !== d && (i.src = d), t(a, i));
			},
			_onTileRemove: function (t) {
				t.tile.onload = null;
			},
			_getZoomForUrl: function () {
				var t = this._tileZoom,
					i = this.options.maxZoom,
					a = this.options.zoomReverse,
					d = this.options.zoomOffset;
				return (a && (t = i - t), t + d);
			},
			_getSubdomain: function (t) {
				var i = Math.abs(t.x + t.y) % this.options.subdomains.length;
				return this.options.subdomains[i];
			},
			_abortLoading: function () {
				var t, i;
				for (t in this._tiles)
					if (
						this._tiles[t].coords.z !== this._tileZoom &&
						((i = this._tiles[t].el),
						(i.onload = A),
						(i.onerror = A),
						!i.complete)
					) {
						i.src = Q;
						var a = this._tiles[t].coords;
						(Ke(i),
							delete this._tiles[t],
							this.fire("tileabort", { tile: i, coords: a }));
					}
			},
			_removeTile: function (t) {
				var i = this._tiles[t];
				if (i)
					return (
						i.el.setAttribute("src", Q),
						oi.prototype._removeTile.call(this, t)
					);
			},
			_tileReady: function (t, i, a) {
				if (!(!this._map || (a && a.getAttribute("src") === Q)))
					return oi.prototype._tileReady.call(this, t, i, a);
			},
		});
		function so(t, i) {
			return new Ar(t, i);
		}
		var Is = Ar.extend({
			defaultWmsParams: {
				service: "WMS",
				request: "GetMap",
				layers: "",
				styles: "",
				format: "image/jpeg",
				transparent: !1,
				version: "1.1.1",
			},
			options: { crs: null, uppercase: !1 },
			initialize: function (t, i) {
				this._url = t;
				var a = s({}, this.defaultWmsParams);
				for (var d in i) d in this.options || (a[d] = i[d]);
				i = P(this, i);
				var x = i.detectRetina && xt.retina ? 2 : 1,
					M = this.getTileSize();
				((a.width = M.x * x), (a.height = M.y * x), (this.wmsParams = a));
			},
			onAdd: function (t) {
				((this._crs = this.options.crs || t.options.crs),
					(this._wmsVersion = parseFloat(this.wmsParams.version)));
				var i = this._wmsVersion >= 1.3 ? "crs" : "srs";
				((this.wmsParams[i] = this._crs.code),
					Ar.prototype.onAdd.call(this, t));
			},
			getTileUrl: function (t) {
				var i = this._tileCoordsToNwSe(t),
					a = this._crs,
					d = Zt(a.project(i[0]), a.project(i[1])),
					x = d.min,
					M = d.max,
					q = (
						this._wmsVersion >= 1.3 && this._crs === Dn
							? [x.y, x.x, M.y, M.x]
							: [x.x, x.y, M.x, M.y]
					).join(","),
					J = Ar.prototype.getTileUrl.call(this, t);
				return (
					J +
					F(this.wmsParams, J, this.options.uppercase) +
					(this.options.uppercase ? "&BBOX=" : "&bbox=") +
					q
				);
			},
			setParams: function (t, i) {
				return (s(this.wmsParams, t), i || this.redraw(), this);
			},
		});
		function al(t, i) {
			return new Is(t, i);
		}
		((Ar.WMS = Is), (so.wms = al));
		var Mr = _n.extend({
				options: { padding: 0.1 },
				initialize: function (t) {
					(P(this, t), f(this), (this._layers = this._layers || {}));
				},
				onAdd: function () {
					(this._container ||
						(this._initContainer(),
						ue(this._container, "leaflet-zoom-animated")),
						this.getPane().appendChild(this._container),
						this._update(),
						this.on("update", this._updatePaths, this));
				},
				onRemove: function () {
					(this.off("update", this._updatePaths, this),
						this._destroyContainer());
				},
				getEvents: function () {
					var t = {
						viewreset: this._reset,
						zoom: this._onZoom,
						moveend: this._update,
						zoomend: this._onZoomEnd,
					};
					return (this._zoomAnimated && (t.zoomanim = this._onAnimZoom), t);
				},
				_onAnimZoom: function (t) {
					this._updateTransform(t.center, t.zoom);
				},
				_onZoom: function () {
					this._updateTransform(this._map.getCenter(), this._map.getZoom());
				},
				_updateTransform: function (t, i) {
					var a = this._map.getZoomScale(i, this._zoom),
						d = this._map.getSize().multiplyBy(0.5 + this.options.padding),
						x = this._map.project(this._center, i),
						M = d
							.multiplyBy(-a)
							.add(x)
							.subtract(this._map._getNewPixelOrigin(t, i));
					xt.any3d ? wi(this._container, M, a) : ui(this._container, M);
				},
				_reset: function () {
					(this._update(), this._updateTransform(this._center, this._zoom));
					for (var t in this._layers) this._layers[t]._reset();
				},
				_onZoomEnd: function () {
					for (var t in this._layers) this._layers[t]._project();
				},
				_updatePaths: function () {
					for (var t in this._layers) this._layers[t]._update();
				},
				_update: function () {
					var t = this.options.padding,
						i = this._map.getSize(),
						a = this._map.containerPointToLayerPoint(i.multiplyBy(-t)).round();
					((this._bounds = new Wt(a, a.add(i.multiplyBy(1 + t * 2)).round())),
						(this._center = this._map.getCenter()),
						(this._zoom = this._map.getZoom()));
				},
			}),
			_a = Mr.extend({
				options: { tolerance: 0 },
				getEvents: function () {
					var t = Mr.prototype.getEvents.call(this);
					return ((t.viewprereset = this._onViewPreReset), t);
				},
				_onViewPreReset: function () {
					this._postponeUpdatePaths = !0;
				},
				onAdd: function () {
					(Mr.prototype.onAdd.call(this), this._draw());
				},
				_initContainer: function () {
					var t = (this._container = document.createElement("canvas"));
					(ee(t, "mousemove", this._onMouseMove, this),
						ee(
							t,
							"click dblclick mousedown mouseup contextmenu",
							this._onClick,
							this,
						),
						ee(t, "mouseout", this._handleMouseOut, this),
						(t._leaflet_disable_events = !0),
						(this._ctx = t.getContext("2d")));
				},
				_destroyContainer: function () {
					(pt(this._redrawRequest),
						delete this._ctx,
						Ke(this._container),
						Be(this._container),
						delete this._container);
				},
				_updatePaths: function () {
					if (!this._postponeUpdatePaths) {
						var t;
						this._redrawBounds = null;
						for (var i in this._layers) ((t = this._layers[i]), t._update());
						this._redraw();
					}
				},
				_update: function () {
					if (!(this._map._animatingZoom && this._bounds)) {
						Mr.prototype._update.call(this);
						var t = this._bounds,
							i = this._container,
							a = t.getSize(),
							d = xt.retina ? 2 : 1;
						(ui(i, t.min),
							(i.width = d * a.x),
							(i.height = d * a.y),
							(i.style.width = a.x + "px"),
							(i.style.height = a.y + "px"),
							xt.retina && this._ctx.scale(2, 2),
							this._ctx.translate(-t.min.x, -t.min.y),
							this.fire("update"));
					}
				},
				_reset: function () {
					(Mr.prototype._reset.call(this),
						this._postponeUpdatePaths &&
							((this._postponeUpdatePaths = !1), this._updatePaths()));
				},
				_initPath: function (t) {
					(this._updateDashArray(t), (this._layers[f(t)] = t));
					var i = (t._order = { layer: t, prev: this._drawLast, next: null });
					(this._drawLast && (this._drawLast.next = i),
						(this._drawLast = i),
						(this._drawFirst = this._drawFirst || this._drawLast));
				},
				_addPath: function (t) {
					this._requestRedraw(t);
				},
				_removePath: function (t) {
					var i = t._order,
						a = i.next,
						d = i.prev;
					(a ? (a.prev = d) : (this._drawLast = d),
						d ? (d.next = a) : (this._drawFirst = a),
						delete t._order,
						delete this._layers[f(t)],
						this._requestRedraw(t));
				},
				_updatePath: function (t) {
					(this._extendRedrawBounds(t),
						t._project(),
						t._update(),
						this._requestRedraw(t));
				},
				_updateStyle: function (t) {
					(this._updateDashArray(t), this._requestRedraw(t));
				},
				_updateDashArray: function (t) {
					if (typeof t.options.dashArray == "string") {
						var i = t.options.dashArray.split(/[, ]+/),
							a = [],
							d,
							x;
						for (x = 0; x < i.length; x++) {
							if (((d = Number(i[x])), isNaN(d))) return;
							a.push(d);
						}
						t.options._dashArray = a;
					} else t.options._dashArray = t.options.dashArray;
				},
				_requestRedraw: function (t) {
					this._map &&
						(this._extendRedrawBounds(t),
						(this._redrawRequest =
							this._redrawRequest || Dt(this._redraw, this)));
				},
				_extendRedrawBounds: function (t) {
					if (t._pxBounds) {
						var i = (t.options.weight || 0) + 1;
						((this._redrawBounds = this._redrawBounds || new Wt()),
							this._redrawBounds.extend(t._pxBounds.min.subtract([i, i])),
							this._redrawBounds.extend(t._pxBounds.max.add([i, i])));
					}
				},
				_redraw: function () {
					((this._redrawRequest = null),
						this._redrawBounds &&
							(this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()),
						this._clear(),
						this._draw(),
						(this._redrawBounds = null));
				},
				_clear: function () {
					var t = this._redrawBounds;
					if (t) {
						var i = t.getSize();
						this._ctx.clearRect(t.min.x, t.min.y, i.x, i.y);
					} else
						(this._ctx.save(),
							this._ctx.setTransform(1, 0, 0, 1, 0, 0),
							this._ctx.clearRect(
								0,
								0,
								this._container.width,
								this._container.height,
							),
							this._ctx.restore());
				},
				_draw: function () {
					var t,
						i = this._redrawBounds;
					if ((this._ctx.save(), i)) {
						var a = i.getSize();
						(this._ctx.beginPath(),
							this._ctx.rect(i.min.x, i.min.y, a.x, a.y),
							this._ctx.clip());
					}
					this._drawing = !0;
					for (var d = this._drawFirst; d; d = d.next)
						((t = d.layer),
							(!i || (t._pxBounds && t._pxBounds.intersects(i))) &&
								t._updatePath());
					((this._drawing = !1), this._ctx.restore());
				},
				_updatePoly: function (t, i) {
					if (this._drawing) {
						var a,
							d,
							x,
							M,
							q = t._parts,
							J = q.length,
							nt = this._ctx;
						if (J) {
							for (nt.beginPath(), a = 0; a < J; a++) {
								for (d = 0, x = q[a].length; d < x; d++)
									((M = q[a][d]), nt[d ? "lineTo" : "moveTo"](M.x, M.y));
								i && nt.closePath();
							}
							this._fillStroke(nt, t);
						}
					}
				},
				_updateCircle: function (t) {
					if (!(!this._drawing || t._empty())) {
						var i = t._point,
							a = this._ctx,
							d = Math.max(Math.round(t._radius), 1),
							x = (Math.max(Math.round(t._radiusY), 1) || d) / d;
						(x !== 1 && (a.save(), a.scale(1, x)),
							a.beginPath(),
							a.arc(i.x, i.y / x, d, 0, Math.PI * 2, !1),
							x !== 1 && a.restore(),
							this._fillStroke(a, t));
					}
				},
				_fillStroke: function (t, i) {
					var a = i.options;
					(a.fill &&
						((t.globalAlpha = a.fillOpacity),
						(t.fillStyle = a.fillColor || a.color),
						t.fill(a.fillRule || "evenodd")),
						a.stroke &&
							a.weight !== 0 &&
							(t.setLineDash &&
								t.setLineDash((i.options && i.options._dashArray) || []),
							(t.globalAlpha = a.opacity),
							(t.lineWidth = a.weight),
							(t.strokeStyle = a.color),
							(t.lineCap = a.lineCap),
							(t.lineJoin = a.lineJoin),
							t.stroke()));
				},
				_onClick: function (t) {
					for (
						var i = this._map.mouseEventToLayerPoint(t),
							a,
							d,
							x = this._drawFirst;
						x;
						x = x.next
					)
						((a = x.layer),
							a.options.interactive &&
								a._containsPoint(i) &&
								(!(t.type === "click" || t.type === "preclick") ||
									!this._map._draggableMoved(a)) &&
								(d = a));
					this._fireEvent(d ? [d] : !1, t);
				},
				_onMouseMove: function (t) {
					if (
						!(
							!this._map ||
							this._map.dragging.moving() ||
							this._map._animatingZoom
						)
					) {
						var i = this._map.mouseEventToLayerPoint(t);
						this._handleMouseHover(t, i);
					}
				},
				_handleMouseOut: function (t) {
					var i = this._hoveredLayer;
					i &&
						(Je(this._container, "leaflet-interactive"),
						this._fireEvent([i], t, "mouseout"),
						(this._hoveredLayer = null),
						(this._mouseHoverThrottled = !1));
				},
				_handleMouseHover: function (t, i) {
					if (!this._mouseHoverThrottled) {
						for (var a, d, x = this._drawFirst; x; x = x.next)
							((a = x.layer),
								a.options.interactive && a._containsPoint(i) && (d = a));
						(d !== this._hoveredLayer &&
							(this._handleMouseOut(t),
							d &&
								(ue(this._container, "leaflet-interactive"),
								this._fireEvent([d], t, "mouseover"),
								(this._hoveredLayer = d))),
							this._fireEvent(
								this._hoveredLayer ? [this._hoveredLayer] : !1,
								t,
							),
							(this._mouseHoverThrottled = !0),
							setTimeout(
								l(function () {
									this._mouseHoverThrottled = !1;
								}, this),
								32,
							));
					}
				},
				_fireEvent: function (t, i, a) {
					this._map._fireDOMEvent(i, a || i.type, t);
				},
				_bringToFront: function (t) {
					var i = t._order;
					if (i) {
						var a = i.next,
							d = i.prev;
						if (a) a.prev = d;
						else return;
						(d ? (d.next = a) : a && (this._drawFirst = a),
							(i.prev = this._drawLast),
							(this._drawLast.next = i),
							(i.next = null),
							(this._drawLast = i),
							this._requestRedraw(t));
					}
				},
				_bringToBack: function (t) {
					var i = t._order;
					if (i) {
						var a = i.next,
							d = i.prev;
						if (d) d.next = a;
						else return;
						(a ? (a.prev = d) : d && (this._drawLast = d),
							(i.prev = null),
							(i.next = this._drawFirst),
							(this._drawFirst.prev = i),
							(this._drawFirst = i),
							this._requestRedraw(t));
					}
				},
			});
		function Fo(t) {
			return xt.canvas ? new _a(t) : null;
		}
		var bs = (function () {
				try {
					return (
						document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"),
						function (t) {
							return document.createElement("<lvml:" + t + ' class="lvml">');
						}
					);
				} catch {}
				return function (t) {
					return document.createElement(
						"<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">',
					);
				};
			})(),
			va = {
				_initContainer: function () {
					this._container = ve("div", "leaflet-vml-container");
				},
				_update: function () {
					this._map._animatingZoom ||
						(Mr.prototype._update.call(this), this.fire("update"));
				},
				_initPath: function (t) {
					var i = (t._container = bs("shape"));
					(ue(i, "leaflet-vml-shape " + (this.options.className || "")),
						(i.coordsize = "1 1"),
						(t._path = bs("path")),
						i.appendChild(t._path),
						this._updateStyle(t),
						(this._layers[f(t)] = t));
				},
				_addPath: function (t) {
					var i = t._container;
					(this._container.appendChild(i),
						t.options.interactive && t.addInteractiveTarget(i));
				},
				_removePath: function (t) {
					var i = t._container;
					(Ke(i), t.removeInteractiveTarget(i), delete this._layers[f(t)]);
				},
				_updateStyle: function (t) {
					var i = t._stroke,
						a = t._fill,
						d = t.options,
						x = t._container;
					((x.stroked = !!d.stroke),
						(x.filled = !!d.fill),
						d.stroke
							? (i || (i = t._stroke = bs("stroke")),
								x.appendChild(i),
								(i.weight = d.weight + "px"),
								(i.color = d.color),
								(i.opacity = d.opacity),
								d.dashArray
									? (i.dashStyle = j(d.dashArray)
											? d.dashArray.join(" ")
											: d.dashArray.replace(/( *, *)/g, " "))
									: (i.dashStyle = ""),
								(i.endcap = d.lineCap.replace("butt", "flat")),
								(i.joinstyle = d.lineJoin))
							: i && (x.removeChild(i), (t._stroke = null)),
						d.fill
							? (a || (a = t._fill = bs("fill")),
								x.appendChild(a),
								(a.color = d.fillColor || d.color),
								(a.opacity = d.fillOpacity))
							: a && (x.removeChild(a), (t._fill = null)));
				},
				_updateCircle: function (t) {
					var i = t._point.round(),
						a = Math.round(t._radius),
						d = Math.round(t._radiusY || a);
					this._setPath(
						t,
						t._empty()
							? "M0 0"
							: "AL " +
									i.x +
									"," +
									i.y +
									" " +
									a +
									"," +
									d +
									" 0," +
									65535 * 360,
					);
				},
				_setPath: function (t, i) {
					t._path.v = i;
				},
				_bringToFront: function (t) {
					Pn(t._container);
				},
				_bringToBack: function (t) {
					an(t._container);
				},
			},
			Bs = xt.vml ? bs : He,
			oo = Mr.extend({
				_initContainer: function () {
					((this._container = Bs("svg")),
						this._container.setAttribute("pointer-events", "none"),
						(this._rootGroup = Bs("g")),
						this._container.appendChild(this._rootGroup));
				},
				_destroyContainer: function () {
					(Ke(this._container),
						Be(this._container),
						delete this._container,
						delete this._rootGroup,
						delete this._svgSize);
				},
				_update: function () {
					if (!(this._map._animatingZoom && this._bounds)) {
						Mr.prototype._update.call(this);
						var t = this._bounds,
							i = t.getSize(),
							a = this._container;
						((!this._svgSize || !this._svgSize.equals(i)) &&
							((this._svgSize = i),
							a.setAttribute("width", i.x),
							a.setAttribute("height", i.y)),
							ui(a, t.min),
							a.setAttribute("viewBox", [t.min.x, t.min.y, i.x, i.y].join(" ")),
							this.fire("update"));
					}
				},
				_initPath: function (t) {
					var i = (t._path = Bs("path"));
					(t.options.className && ue(i, t.options.className),
						t.options.interactive && ue(i, "leaflet-interactive"),
						this._updateStyle(t),
						(this._layers[f(t)] = t));
				},
				_addPath: function (t) {
					(this._rootGroup || this._initContainer(),
						this._rootGroup.appendChild(t._path),
						t.addInteractiveTarget(t._path));
				},
				_removePath: function (t) {
					(Ke(t._path),
						t.removeInteractiveTarget(t._path),
						delete this._layers[f(t)]);
				},
				_updatePath: function (t) {
					(t._project(), t._update());
				},
				_updateStyle: function (t) {
					var i = t._path,
						a = t.options;
					i &&
						(a.stroke
							? (i.setAttribute("stroke", a.color),
								i.setAttribute("stroke-opacity", a.opacity),
								i.setAttribute("stroke-width", a.weight),
								i.setAttribute("stroke-linecap", a.lineCap),
								i.setAttribute("stroke-linejoin", a.lineJoin),
								a.dashArray
									? i.setAttribute("stroke-dasharray", a.dashArray)
									: i.removeAttribute("stroke-dasharray"),
								a.dashOffset
									? i.setAttribute("stroke-dashoffset", a.dashOffset)
									: i.removeAttribute("stroke-dashoffset"))
							: i.setAttribute("stroke", "none"),
						a.fill
							? (i.setAttribute("fill", a.fillColor || a.color),
								i.setAttribute("fill-opacity", a.fillOpacity),
								i.setAttribute("fill-rule", a.fillRule || "evenodd"))
							: i.setAttribute("fill", "none"));
				},
				_updatePoly: function (t, i) {
					this._setPath(t, di(t._parts, i));
				},
				_updateCircle: function (t) {
					var i = t._point,
						a = Math.max(Math.round(t._radius), 1),
						d = Math.max(Math.round(t._radiusY), 1) || a,
						x = "a" + a + "," + d + " 0 1,0 ",
						M = t._empty()
							? "M0 0"
							: "M" +
								(i.x - a) +
								"," +
								i.y +
								x +
								a * 2 +
								",0 " +
								x +
								-a * 2 +
								",0 ";
					this._setPath(t, M);
				},
				_setPath: function (t, i) {
					t._path.setAttribute("d", i);
				},
				_bringToFront: function (t) {
					Pn(t._path);
				},
				_bringToBack: function (t) {
					an(t._path);
				},
			});
		xt.vml && oo.include(va);
		function Ho(t) {
			return xt.svg || xt.vml ? new oo(t) : null;
		}
		Se.include({
			getRenderer: function (t) {
				var i =
					t.options.renderer ||
					this._getPaneRenderer(t.options.pane) ||
					this.options.renderer ||
					this._renderer;
				return (
					i || (i = this._renderer = this._createRenderer()),
					this.hasLayer(i) || this.addLayer(i),
					i
				);
			},
			_getPaneRenderer: function (t) {
				if (t === "overlayPane" || t === void 0) return !1;
				var i = this._paneRenderers[t];
				return (
					i === void 0 &&
						((i = this._createRenderer({ pane: t })),
						(this._paneRenderers[t] = i)),
					i
				);
			},
			_createRenderer: function (t) {
				return (this.options.preferCanvas && Fo(t)) || Ho(t);
			},
		});
		var qo = Nn.extend({
			initialize: function (t, i) {
				Nn.prototype.initialize.call(this, this._boundsToLatLngs(t), i);
			},
			setBounds: function (t) {
				return this.setLatLngs(this._boundsToLatLngs(t));
			},
			_boundsToLatLngs: function (t) {
				return (
					(t = jt(t)),
					[
						t.getSouthWest(),
						t.getNorthWest(),
						t.getNorthEast(),
						t.getSouthEast(),
					]
				);
			},
		});
		function ou(t, i) {
			return new qo(t, i);
		}
		((oo.create = Bs),
			(oo.pointsToPath = di),
			(vn.geometryToLayer = kr),
			(vn.coordsToLatLng = Jr),
			(vn.coordsToLatLngs = ln),
			(vn.latLngToCoords = z),
			(vn.latLngsToCoords = Z),
			(vn.getFeature = X),
			(vn.asFeature = et),
			Se.mergeOptions({ boxZoom: !0 }));
		var au = k.extend({
			initialize: function (t) {
				((this._map = t),
					(this._container = t._container),
					(this._pane = t._panes.overlayPane),
					(this._resetStateTimeout = 0),
					t.on("unload", this._destroy, this));
			},
			addHooks: function () {
				ee(this._container, "mousedown", this._onMouseDown, this);
			},
			removeHooks: function () {
				Be(this._container, "mousedown", this._onMouseDown, this);
			},
			moved: function () {
				return this._moved;
			},
			_destroy: function () {
				(Ke(this._pane), delete this._pane);
			},
			_resetState: function () {
				((this._resetStateTimeout = 0), (this._moved = !1));
			},
			_clearDeferredResetState: function () {
				this._resetStateTimeout !== 0 &&
					(clearTimeout(this._resetStateTimeout),
					(this._resetStateTimeout = 0));
			},
			_onMouseDown: function (t) {
				if (!t.shiftKey || (t.which !== 1 && t.button !== 1)) return !1;
				(this._clearDeferredResetState(),
					this._resetState(),
					Cr(),
					fs(),
					(this._startPoint = this._map.mouseEventToContainerPoint(t)),
					ee(
						document,
						{
							contextmenu: dr,
							mousemove: this._onMouseMove,
							mouseup: this._onMouseUp,
							keydown: this._onKeyDown,
						},
						this,
					));
			},
			_onMouseMove: function (t) {
				(this._moved ||
					((this._moved = !0),
					(this._box = ve("div", "leaflet-zoom-box", this._container)),
					ue(this._container, "leaflet-crosshair"),
					this._map.fire("boxzoomstart")),
					(this._point = this._map.mouseEventToContainerPoint(t)));
				var i = new Wt(this._point, this._startPoint),
					a = i.getSize();
				(ui(this._box, i.min),
					(this._box.style.width = a.x + "px"),
					(this._box.style.height = a.y + "px"));
			},
			_finish: function () {
				(this._moved &&
					(Ke(this._box), Je(this._container, "leaflet-crosshair")),
					hs(),
					Js(),
					Be(
						document,
						{
							contextmenu: dr,
							mousemove: this._onMouseMove,
							mouseup: this._onMouseUp,
							keydown: this._onKeyDown,
						},
						this,
					));
			},
			_onMouseUp: function (t) {
				if (
					!(t.which !== 1 && t.button !== 1) &&
					(this._finish(), !!this._moved)
				) {
					(this._clearDeferredResetState(),
						(this._resetStateTimeout = setTimeout(
							l(this._resetState, this),
							0,
						)));
					var i = new oe(
						this._map.containerPointToLatLng(this._startPoint),
						this._map.containerPointToLatLng(this._point),
					);
					this._map.fitBounds(i).fire("boxzoomend", { boxZoomBounds: i });
				}
			},
			_onKeyDown: function (t) {
				t.keyCode === 27 &&
					(this._finish(), this._clearDeferredResetState(), this._resetState());
			},
		});
		(Se.addInitHook("addHandler", "boxZoom", au),
			Se.mergeOptions({ doubleClickZoom: !0 }));
		var uu = k.extend({
			addHooks: function () {
				this._map.on("dblclick", this._onDoubleClick, this);
			},
			removeHooks: function () {
				this._map.off("dblclick", this._onDoubleClick, this);
			},
			_onDoubleClick: function (t) {
				var i = this._map,
					a = i.getZoom(),
					d = i.options.zoomDelta,
					x = t.originalEvent.shiftKey ? a - d : a + d;
				i.options.doubleClickZoom === "center"
					? i.setZoom(x)
					: i.setZoomAround(t.containerPoint, x);
			},
		});
		(Se.addInitHook("addHandler", "doubleClickZoom", uu),
			Se.mergeOptions({
				dragging: !0,
				inertia: !0,
				inertiaDeceleration: 3400,
				inertiaMaxSpeed: 1 / 0,
				easeLinearity: 0.2,
				worldCopyJump: !1,
				maxBoundsViscosity: 0,
			}));
		var Wo = k.extend({
			addHooks: function () {
				if (!this._draggable) {
					var t = this._map;
					((this._draggable = new $(t._mapPane, t._container)),
						this._draggable.on(
							{
								dragstart: this._onDragStart,
								drag: this._onDrag,
								dragend: this._onDragEnd,
							},
							this,
						),
						this._draggable.on("predrag", this._onPreDragLimit, this),
						t.options.worldCopyJump &&
							(this._draggable.on("predrag", this._onPreDragWrap, this),
							t.on("zoomend", this._onZoomEnd, this),
							t.whenReady(this._onZoomEnd, this)));
				}
				(ue(this._map._container, "leaflet-grab leaflet-touch-drag"),
					this._draggable.enable(),
					(this._positions = []),
					(this._times = []));
			},
			removeHooks: function () {
				(Je(this._map._container, "leaflet-grab"),
					Je(this._map._container, "leaflet-touch-drag"),
					this._draggable.disable());
			},
			moved: function () {
				return this._draggable && this._draggable._moved;
			},
			moving: function () {
				return this._draggable && this._draggable._moving;
			},
			_onDragStart: function () {
				var t = this._map;
				if (
					(t._stop(),
					this._map.options.maxBounds && this._map.options.maxBoundsViscosity)
				) {
					var i = jt(this._map.options.maxBounds);
					((this._offsetLimit = Zt(
						this._map.latLngToContainerPoint(i.getNorthWest()).multiplyBy(-1),
						this._map
							.latLngToContainerPoint(i.getSouthEast())
							.multiplyBy(-1)
							.add(this._map.getSize()),
					)),
						(this._viscosity = Math.min(
							1,
							Math.max(0, this._map.options.maxBoundsViscosity),
						)));
				} else this._offsetLimit = null;
				(t.fire("movestart").fire("dragstart"),
					t.options.inertia && ((this._positions = []), (this._times = [])));
			},
			_onDrag: function (t) {
				if (this._map.options.inertia) {
					var i = (this._lastTime = +new Date()),
						a = (this._lastPos =
							this._draggable._absPos || this._draggable._newPos);
					(this._positions.push(a),
						this._times.push(i),
						this._prunePositions(i));
				}
				this._map.fire("move", t).fire("drag", t);
			},
			_prunePositions: function (t) {
				for (; this._positions.length > 1 && t - this._times[0] > 50; )
					(this._positions.shift(), this._times.shift());
			},
			_onZoomEnd: function () {
				var t = this._map.getSize().divideBy(2),
					i = this._map.latLngToLayerPoint([0, 0]);
				((this._initialWorldOffset = i.subtract(t).x),
					(this._worldWidth = this._map.getPixelWorldBounds().getSize().x));
			},
			_viscousLimit: function (t, i) {
				return t - (t - i) * this._viscosity;
			},
			_onPreDragLimit: function () {
				if (!(!this._viscosity || !this._offsetLimit)) {
					var t = this._draggable._newPos.subtract(this._draggable._startPos),
						i = this._offsetLimit;
					(t.x < i.min.x && (t.x = this._viscousLimit(t.x, i.min.x)),
						t.y < i.min.y && (t.y = this._viscousLimit(t.y, i.min.y)),
						t.x > i.max.x && (t.x = this._viscousLimit(t.x, i.max.x)),
						t.y > i.max.y && (t.y = this._viscousLimit(t.y, i.max.y)),
						(this._draggable._newPos = this._draggable._startPos.add(t)));
				}
			},
			_onPreDragWrap: function () {
				var t = this._worldWidth,
					i = Math.round(t / 2),
					a = this._initialWorldOffset,
					d = this._draggable._newPos.x,
					x = ((d - i + a) % t) + i - a,
					M = ((d + i + a) % t) - i - a,
					q = Math.abs(x + a) < Math.abs(M + a) ? x : M;
				((this._draggable._absPos = this._draggable._newPos.clone()),
					(this._draggable._newPos.x = q));
			},
			_onDragEnd: function (t) {
				var i = this._map,
					a = i.options,
					d = !a.inertia || t.noInertia || this._times.length < 2;
				if ((i.fire("dragend", t), d)) i.fire("moveend");
				else {
					this._prunePositions(+new Date());
					var x = this._lastPos.subtract(this._positions[0]),
						M = (this._lastTime - this._times[0]) / 1e3,
						q = a.easeLinearity,
						J = x.multiplyBy(q / M),
						nt = J.distanceTo([0, 0]),
						ht = Math.min(a.inertiaMaxSpeed, nt),
						At = J.multiplyBy(ht / nt),
						Yt = ht / (a.inertiaDeceleration * q),
						_e = At.multiplyBy(-Yt / 2).round();
					!_e.x && !_e.y
						? i.fire("moveend")
						: ((_e = i._limitOffset(_e, i.options.maxBounds)),
							Dt(function () {
								i.panBy(_e, {
									duration: Yt,
									easeLinearity: q,
									noMoveStart: !0,
									animate: !0,
								});
							}));
				}
			},
		});
		(Se.addInitHook("addHandler", "dragging", Wo),
			Se.mergeOptions({ keyboard: !0, keyboardPanDelta: 80 }));
		var ya = k.extend({
			keyCodes: {
				left: [37],
				right: [39],
				down: [40],
				up: [38],
				zoomIn: [187, 107, 61, 171],
				zoomOut: [189, 109, 54, 173],
			},
			initialize: function (t) {
				((this._map = t),
					this._setPanDelta(t.options.keyboardPanDelta),
					this._setZoomDelta(t.options.zoomDelta));
			},
			addHooks: function () {
				var t = this._map._container;
				(t.tabIndex <= 0 && (t.tabIndex = "0"),
					ee(
						t,
						{
							focus: this._onFocus,
							blur: this._onBlur,
							mousedown: this._onMouseDown,
						},
						this,
					),
					this._map.on(
						{ focus: this._addHooks, blur: this._removeHooks },
						this,
					));
			},
			removeHooks: function () {
				(this._removeHooks(),
					Be(
						this._map._container,
						{
							focus: this._onFocus,
							blur: this._onBlur,
							mousedown: this._onMouseDown,
						},
						this,
					),
					this._map.off(
						{ focus: this._addHooks, blur: this._removeHooks },
						this,
					));
			},
			_onMouseDown: function () {
				if (!this._focused) {
					var t = document.body,
						i = document.documentElement,
						a = t.scrollTop || i.scrollTop,
						d = t.scrollLeft || i.scrollLeft;
					(this._map._container.focus(), window.scrollTo(d, a));
				}
			},
			_onFocus: function () {
				((this._focused = !0), this._map.fire("focus"));
			},
			_onBlur: function () {
				((this._focused = !1), this._map.fire("blur"));
			},
			_setPanDelta: function (t) {
				var i = (this._panKeys = {}),
					a = this.keyCodes,
					d,
					x;
				for (d = 0, x = a.left.length; d < x; d++) i[a.left[d]] = [-1 * t, 0];
				for (d = 0, x = a.right.length; d < x; d++) i[a.right[d]] = [t, 0];
				for (d = 0, x = a.down.length; d < x; d++) i[a.down[d]] = [0, t];
				for (d = 0, x = a.up.length; d < x; d++) i[a.up[d]] = [0, -1 * t];
			},
			_setZoomDelta: function (t) {
				var i = (this._zoomKeys = {}),
					a = this.keyCodes,
					d,
					x;
				for (d = 0, x = a.zoomIn.length; d < x; d++) i[a.zoomIn[d]] = t;
				for (d = 0, x = a.zoomOut.length; d < x; d++) i[a.zoomOut[d]] = -t;
			},
			_addHooks: function () {
				ee(document, "keydown", this._onKeyDown, this);
			},
			_removeHooks: function () {
				Be(document, "keydown", this._onKeyDown, this);
			},
			_onKeyDown: function (t) {
				if (!(t.altKey || t.ctrlKey || t.metaKey)) {
					var i = t.keyCode,
						a = this._map,
						d;
					if (i in this._panKeys) {
						if (!a._panAnim || !a._panAnim._inProgress)
							if (
								((d = this._panKeys[i]),
								t.shiftKey && (d = W(d).multiplyBy(3)),
								a.options.maxBounds &&
									(d = a._limitOffset(W(d), a.options.maxBounds)),
								a.options.worldCopyJump)
							) {
								var x = a.wrapLatLng(
									a.unproject(a.project(a.getCenter()).add(d)),
								);
								a.panTo(x);
							} else a.panBy(d);
					} else if (i in this._zoomKeys)
						a.setZoom(a.getZoom() + (t.shiftKey ? 3 : 1) * this._zoomKeys[i]);
					else if (i === 27 && a._popup && a._popup.options.closeOnEscapeKey)
						a.closePopup();
					else return;
					dr(t);
				}
			},
		});
		(Se.addInitHook("addHandler", "keyboard", ya),
			Se.mergeOptions({
				scrollWheelZoom: !0,
				wheelDebounceTime: 40,
				wheelPxPerZoomLevel: 60,
			}));
		var lu = k.extend({
			addHooks: function () {
				(ee(this._map._container, "wheel", this._onWheelScroll, this),
					(this._delta = 0));
			},
			removeHooks: function () {
				Be(this._map._container, "wheel", this._onWheelScroll, this);
			},
			_onWheelScroll: function (t) {
				var i = io(t),
					a = this._map.options.wheelDebounceTime;
				((this._delta += i),
					(this._lastMousePos = this._map.mouseEventToContainerPoint(t)),
					this._startTime || (this._startTime = +new Date()));
				var d = Math.max(a - (+new Date() - this._startTime), 0);
				(clearTimeout(this._timer),
					(this._timer = setTimeout(l(this._performZoom, this), d)),
					dr(t));
			},
			_performZoom: function () {
				var t = this._map,
					i = t.getZoom(),
					a = this._map.options.zoomSnap || 0;
				t._stop();
				var d = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
					x = (4 * Math.log(2 / (1 + Math.exp(-Math.abs(d))))) / Math.LN2,
					M = a ? Math.ceil(x / a) * a : x,
					q = t._limitZoom(i + (this._delta > 0 ? M : -M)) - i;
				((this._delta = 0),
					(this._startTime = null),
					q &&
						(t.options.scrollWheelZoom === "center"
							? t.setZoom(i + q)
							: t.setZoomAround(this._lastMousePos, i + q)));
			},
		});
		Se.addInitHook("addHandler", "scrollWheelZoom", lu);
		var ul = 600;
		Se.mergeOptions({
			tapHold: xt.touchNative && xt.safari && xt.mobile,
			tapTolerance: 15,
		});
		var Zo = k.extend({
			addHooks: function () {
				ee(this._map._container, "touchstart", this._onDown, this);
			},
			removeHooks: function () {
				Be(this._map._container, "touchstart", this._onDown, this);
			},
			_onDown: function (t) {
				if ((clearTimeout(this._holdTimeout), t.touches.length === 1)) {
					var i = t.touches[0];
					((this._startPos = this._newPos = new _t(i.clientX, i.clientY)),
						(this._holdTimeout = setTimeout(
							l(function () {
								(this._cancel(),
									this._isTapValid() &&
										(ee(document, "touchend", Mi),
										ee(
											document,
											"touchend touchcancel",
											this._cancelClickPrevent,
										),
										this._simulateEvent("contextmenu", i)));
							}, this),
							ul,
						)),
						ee(
							document,
							"touchend touchcancel contextmenu",
							this._cancel,
							this,
						),
						ee(document, "touchmove", this._onMove, this));
				}
			},
			_cancelClickPrevent: function t() {
				(Be(document, "touchend", Mi), Be(document, "touchend touchcancel", t));
			},
			_cancel: function () {
				(clearTimeout(this._holdTimeout),
					Be(document, "touchend touchcancel contextmenu", this._cancel, this),
					Be(document, "touchmove", this._onMove, this));
			},
			_onMove: function (t) {
				var i = t.touches[0];
				this._newPos = new _t(i.clientX, i.clientY);
			},
			_isTapValid: function () {
				return (
					this._newPos.distanceTo(this._startPos) <=
					this._map.options.tapTolerance
				);
			},
			_simulateEvent: function (t, i) {
				var a = new MouseEvent(t, {
					bubbles: !0,
					cancelable: !0,
					view: window,
					screenX: i.screenX,
					screenY: i.screenY,
					clientX: i.clientX,
					clientY: i.clientY,
				});
				((a._simulated = !0), i.target.dispatchEvent(a));
			},
		});
		(Se.addInitHook("addHandler", "tapHold", Zo),
			Se.mergeOptions({ touchZoom: xt.touch, bounceAtZoomLimits: !0 }));
		var ba = k.extend({
			addHooks: function () {
				(ue(this._map._container, "leaflet-touch-zoom"),
					ee(this._map._container, "touchstart", this._onTouchStart, this));
			},
			removeHooks: function () {
				(Je(this._map._container, "leaflet-touch-zoom"),
					Be(this._map._container, "touchstart", this._onTouchStart, this));
			},
			_onTouchStart: function (t) {
				var i = this._map;
				if (
					!(
						!t.touches ||
						t.touches.length !== 2 ||
						i._animatingZoom ||
						this._zooming
					)
				) {
					var a = i.mouseEventToContainerPoint(t.touches[0]),
						d = i.mouseEventToContainerPoint(t.touches[1]);
					((this._centerPoint = i.getSize()._divideBy(2)),
						(this._startLatLng = i.containerPointToLatLng(this._centerPoint)),
						i.options.touchZoom !== "center" &&
							(this._pinchStartLatLng = i.containerPointToLatLng(
								a.add(d)._divideBy(2),
							)),
						(this._startDist = a.distanceTo(d)),
						(this._startZoom = i.getZoom()),
						(this._moved = !1),
						(this._zooming = !0),
						i._stop(),
						ee(document, "touchmove", this._onTouchMove, this),
						ee(document, "touchend touchcancel", this._onTouchEnd, this),
						Mi(t));
				}
			},
			_onTouchMove: function (t) {
				if (!(!t.touches || t.touches.length !== 2 || !this._zooming)) {
					var i = this._map,
						a = i.mouseEventToContainerPoint(t.touches[0]),
						d = i.mouseEventToContainerPoint(t.touches[1]),
						x = a.distanceTo(d) / this._startDist;
					if (
						((this._zoom = i.getScaleZoom(x, this._startZoom)),
						!i.options.bounceAtZoomLimits &&
							((this._zoom < i.getMinZoom() && x < 1) ||
								(this._zoom > i.getMaxZoom() && x > 1)) &&
							(this._zoom = i._limitZoom(this._zoom)),
						i.options.touchZoom === "center")
					) {
						if (((this._center = this._startLatLng), x === 1)) return;
					} else {
						var M = a._add(d)._divideBy(2)._subtract(this._centerPoint);
						if (x === 1 && M.x === 0 && M.y === 0) return;
						this._center = i.unproject(
							i.project(this._pinchStartLatLng, this._zoom).subtract(M),
							this._zoom,
						);
					}
					(this._moved || (i._moveStart(!0, !1), (this._moved = !0)),
						pt(this._animRequest));
					var q = l(
						i._move,
						i,
						this._center,
						this._zoom,
						{ pinch: !0, round: !1 },
						void 0,
					);
					((this._animRequest = Dt(q, this, !0)), Mi(t));
				}
			},
			_onTouchEnd: function () {
				if (!this._moved || !this._zooming) {
					this._zooming = !1;
					return;
				}
				((this._zooming = !1),
					pt(this._animRequest),
					Be(document, "touchmove", this._onTouchMove, this),
					Be(document, "touchend touchcancel", this._onTouchEnd, this),
					this._map.options.zoomAnimation
						? this._map._animateZoom(
								this._center,
								this._map._limitZoom(this._zoom),
								!0,
								this._map.options.zoomSnap,
							)
						: this._map._resetView(
								this._center,
								this._map._limitZoom(this._zoom),
							));
			},
		});
		(Se.addInitHook("addHandler", "touchZoom", ba),
			(Se.BoxZoom = au),
			(Se.DoubleClickZoom = uu),
			(Se.Drag = Wo),
			(Se.Keyboard = ya),
			(Se.ScrollWheelZoom = lu),
			(Se.TapHold = Zo),
			(Se.TouchZoom = ba),
			(n.Bounds = Wt),
			(n.Browser = xt),
			(n.CRS = xe),
			(n.Canvas = _a),
			(n.Circle = zn),
			(n.CircleMarker = Vi),
			(n.Class = K),
			(n.Control = gn),
			(n.DivIcon = Rn),
			(n.DivOverlay = Ot),
			(n.DomEvent = ma),
			(n.DomUtil = Io),
			(n.Draggable = $),
			(n.Evented = Ct),
			(n.FeatureGroup = ae),
			(n.GeoJSON = vn),
			(n.GridLayer = oi),
			(n.Handler = k),
			(n.Icon = qi),
			(n.ImageOverlay = It),
			(n.LatLng = Vt),
			(n.LatLngBounds = oe),
			(n.Layer = _n),
			(n.LayerGroup = Zr),
			(n.LineUtil = er),
			(n.Map = Se),
			(n.Marker = ys),
			(n.Mixin = H),
			(n.Path = be),
			(n.Point = _t),
			(n.PolyUtil = dt),
			(n.Polygon = Nn),
			(n.Polyline = Qi),
			(n.Popup = Ee),
			(n.PosAnimation = zo),
			(n.Projection = ci),
			(n.Rectangle = qo),
			(n.Renderer = Mr),
			(n.SVG = oo),
			(n.SVGOverlay = $t),
			(n.TileLayer = Ar),
			(n.Tooltip = Qe),
			(n.Transformation = Ge),
			(n.Util = Et),
			(n.VideoOverlay = pe),
			(n.bind = l),
			(n.bounds = Zt),
			(n.canvas = Fo),
			(n.circle = Kr),
			(n.circleMarker = Ro),
			(n.control = Wr),
			(n.divIcon = Qr),
			(n.extend = s),
			(n.featureGroup = Ds),
			(n.geoJSON = mt),
			(n.geoJson = wt),
			(n.gridLayer = ol),
			(n.icon = mr),
			(n.imageOverlay = kt),
			(n.latLng = U),
			(n.latLngBounds = jt),
			(n.layerGroup = Yr),
			(n.map = vs),
			(n.marker = gr),
			(n.point = W),
			(n.polygon = nr),
			(n.polyline = no),
			(n.popup = Gi),
			(n.rectangle = ou),
			(n.setOptions = P),
			(n.stamp = f),
			(n.svg = Ho),
			(n.svgOverlay = ge),
			(n.tileLayer = so),
			(n.tooltip = cn),
			(n.transformation = Ue),
			(n.version = r),
			(n.videoOverlay = Gt));
		var ll = window.L;
		((n.noConflict = function () {
			return ((window.L = ll), this);
		}),
			(window.L = n));
	});
})(Ac, Ac.exports);
var gg = Ac.exports;
const fo = tl(gg);
class _g {
	constructor(e) {
		((this.container = e.container),
			(this.marker = e.marker || []),
			(this.boundary = e.boundary),
			(this.controls = e.controls || null),
			(this.minZoom = e.minZoom),
			(this.maxZoom = e.maxZoom),
			(this.maxBounds = e.maxBounds),
			(this.map = null),
			(this.boundaryLayer = null),
			(this.layerGroups = []),
			this.init());
	}
	async init() {
		(this.marker.length > 0 && this.initMap(),
			this.boundary && (await this.setBoundary(this.boundary)),
			this.marker.length > 0 && this.setMarker(this.marker),
			this.layerGroups.length > 0 &&
				this.setView(this.layerGroups[0].getBounds(), this.maxZoom),
			this.bindEvents());
	}
	initMap() {
		((this.map = fo.map(this.container, {
			zoomControl: this.controls === void 0,
			maxBounds: this.maxBounds,
		})),
			fo
				.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
					minZoom: this.minZoom,
					maxZoom: this.maxZoom,
					attribution:
						'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
				})
				.addTo(this.map));
	}
	bindEvents() {
		var e, n;
		this.controls &&
			((e = this.controls.zoomIn) == null ||
				e.addEventListener("click", () => {
					this.map.zoomIn();
				}),
			(n = this.controls.zoomOut) == null ||
				n.addEventListener("click", () => {
					this.map.zoomOut();
				}),
			this.map.on("zoomend", (r) => {
				const s = r.target;
				this.handleControlsState(s);
			}));
	}
	async setBoundary(e) {
		const n = this;
		if (e.q || e.geojson) {
			const r =
				e.geojson ??
				`https://nominatim.openstreetmap.org/search.php?q=${e.q}&polygon_geojson=1&format=jsonv2`;
			await fetch(r)
				.then(function (s) {
					return s.json();
				})
				.then(function (s) {
					var h, f;
					const u = (h = s[0]) == null ? void 0 : h.geojson,
						l = (f = s[0]) == null ? void 0 : f.licence;
					((n.boundaryLayer = fo.geoJSON(u, {
						style: e.style,
						interactive: !1,
						attribution: l,
					})),
						n.boundaryLayer.addTo(n.map));
				});
		}
	}
	setMarker(e) {
		const n = [];
		(e.forEach((r) => {
			r.lat !== 0 &&
				r.lng !== 0 &&
				n.indexOf(r.group) === -1 &&
				n.push(r.group);
		}),
			n.forEach((r) => {
				const s = [];
				(e.forEach((u) => {
					if (u.group === r) {
						const l = fo
							.marker([u.lat, u.lng], {
								id: u.id,
								icon: this.markerIcon(u.icon),
								title: u.title,
							})
							.bindPopup(u.popup.content, u.popup.options)
							.on("popupopen", (h) => {
								var f;
								(f = l._icon) == null || f.classList.add("is-active");
							})
							.on("popupclose", (h) => {
								var f;
								(f = l._icon) == null || f.classList.remove("is-active");
							});
						s.push(l);
					}
				}),
					this.layerGroups.push(fo.featureGroup(s, { id: r })));
			}),
			this.layerGroups.forEach((r) => {
				r.addTo(this.map);
			}));
	}
	setView(e, n) {
		(this.map.setView(e.getCenter(), n),
			this.map.fitBounds(e, { padding: [20, 20] }),
			this.handleControlsState(this.map));
	}
	markerIcon(e) {
		return new fo.DivIcon({
			className: e.class ?? "",
			iconSize: e.size ?? [24, 24],
			html: e.html ?? "",
		});
	}
	handleControlsState(e) {
		var n, r, s;
		!((n = this.controls) != null && n.zoomOut) ||
			!((r = this.controls) != null && r.zoomIn) ||
			!((s = this.controls) != null && s.zoomIn.parentElement) ||
			(fo.Browser.mobile &&
				(this.controls.zoomIn.parentElement.remove(),
				this.controls.zoomOut.remove(),
				this.controls.zoomIn.remove()),
			(this.controls.zoomOut.disabled = e.getZoom() === e.getMinZoom()),
			(this.controls.zoomIn.disabled = e.getZoom() === e.getMaxZoom()));
	}
}
class vg {
	constructor(e) {
		((this.mapContainer = e.map),
			(this.leafletMap = {}),
			(this.filterButtons = e.filterButtons),
			(this.flyToButtons = e.flyToButtons),
			(this.currentFilter = null),
			this.init());
	}
	async init() {
		(await this.initMap(), this.bindEvents());
	}
	bindEvents() {
		var e, n;
		((e = this.filterButtons) == null ||
			e.forEach((r) => {
				r.addEventListener("change", () => {
					this.filter(r.value);
				});
			}),
			(n = this.flyToButtons) == null ||
				n.forEach((r) => {
					r.addEventListener("click", () => {
						this.flyTo(r.dataset.mapFlyto);
					});
				}));
	}
	async initMap() {
		const e = JSON.parse(this.mapContainer.dataset.map),
			n = await this.getMapData(this.mapContainer.id, e);
		if (!(n != null && n.marker != null && n.marker.length > 0)) return;
		this.leafletMap = new _g({
			container: this.mapContainer,
			marker: n == null ? void 0 : n.marker,
			minZoom: 5,
			maxZoom: 18,
			maxBounds: [
				[70, -30],
				[30, 50],
			],
			controls: {
				zoomIn: this.mapContainer.querySelector('[data-control="zoom-in"]'),
				zoomOut: this.mapContainer.querySelector('[data-control="zoom-out"]'),
			},
			boundary: {
				geojson: hlKirbyUrl("/static/map/ahrenshoop-boundary.json"),
				style: {
					color: "#000000",
					dashArray: "2 5 2 5",
					opacity: 0.2,
					className: "map-boundary",
					fill: !0,
					fillColor: "#ffffff",
					fillOpacity: 0.3,
				},
			},
		});
		this.leafletMap.map.on("load", () => {
			this.leafletMap.layerGroups.forEach((r) => {
				r === this.leafletMap.layerGroups[0]
					? (this.leafletMap.map.addLayer(r),
						this.leafletMap.map.fitBounds(r.getBounds()))
					: this.leafletMap.map.removeLayer(r);
			});
		});
	}
	async getMapData(e, n = []) {
		try {
			const r = await fetch(hlKirbyUrl("/app/map/get-map-data"), {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					mapId: e,
					entries: n,
					language: document.documentElement.lang,
				}),
			});
			if (!r.ok) return {};
			return await r.json();
		} catch (r) {
			return (console.error(r), {});
		}
	}
	filter(e) {
		if (!this.leafletMap?.map || !this.leafletMap.layerGroups) return;
		this.leafletMap.layerGroups.forEach((n) => {
			n.options.id === e
				? (this.leafletMap.map.addLayer(n),
					this.leafletMap.map.fitBounds(n.getBounds()))
				: this.leafletMap.map.removeLayer(n);
		});
	}
	flyTo(e) {
		if (!this.leafletMap?.map || !this.leafletMap.layerGroups) return;
		this.leafletMap.layerGroups.forEach((n) => {
			for (const r of Object.values(n.getLayers()))
				r.options.id === e &&
					(this.leafletMap.map.flyTo(r.getLatLng(), 16), r.fire("click"));
		});
	}
}
class yg {
	constructor(e, n) {
		((this.endpoint = "app/data/discover"),
			(this.langCodes = { "de-DE": "de", "en-US": "en", "en-GB": "en" }),
			(this.langCode = this.langCodes[document.documentElement.lang] ?? "de"),
			(this.form = e),
			(this.resultsContainer =
				(n == null ? void 0 : n.resultsContainer) ?? null),
			this.bindEvents());
	}
	bindEvents() {
		return (
			this.form.addEventListener("submit", (e) => {
				e.preventDefault();
			}),
			this.form.addEventListener("change", (e) => {
				this.updateList();
			}),
			this
		);
	}
	async updateList() {
		this.resultsContainer.setAttribute("aria-busy", !0);
		try {
			const e = await this.fetchEntries();
			this.resultsContainer.innerHTML = e.html;
		} catch (e) {
			console.error(e.message);
		} finally {
			this.resultsContainer.removeAttribute("aria-busy");
		}
		return this;
	}
	async fetchEntries() {
		const e = {};
		[...this.form.elements].forEach((n) => {
			n.name && (e[n.name] = n.value);
		});
		try {
			const n = new URLSearchParams(e).toString(),
				r = `${this.getFetchUrl()}?${n}`,
				s = await fetch(r, { method: "GET", cache: "no-store" });
			if (!s.ok) throw new Error(`Response status: ${s.status}`);
			return await s.json();
		} catch (n) {
			console.error(n.message);
		}
	}
	getFetchUrl() {
		return hlKirbyUrl(
			`/${this.langCode === "de" ? "" : `${this.langCode}/`}${this.endpoint}`,
		);
	}
}
document.addEventListener("DOMContentLoaded", () => {});
Ht(function () {
	Ht(window).on("load", function () {
		(vp(), Xa("#" + Ht(":target").attr("id"), 125));
	});
	const p = (s) => {
		const u = s.selectedIndex,
			l = Ht(s.element).parent().find(".js-block-slider-dots button"),
			h = l.filter(`[data-index="${u}"]`).first();
		(l.attr("aria-current", !1),
			h.attr("aria-current", !0),
			s.resize(),
			Pe.refresh());
	};
	document.querySelectorAll(".js-slider").length > 0 &&
		n.forEach((s) => {
			const u = new pf($sliderSelector, {
				cellAlign: "left",
				contain: !0,
				wrapAround: !0,
				adaptiveHeight: !0,
				imagesLoaded: !0,
				prevNextButtons: !1,
				on: {
					ready() {
						p(this);
					},
					settle() {
						p(this);
					},
				},
			});
			(p(u),
				window.addEventListener("load", () => p(u)),
				Ht(s)
					.parent()
					.find(".js-slider-prev")
					.on("click", function () {
						u.previous(!0, wl.matches);
					}),
				Ht(s)
					.parent()
					.find(".js-slider-next")
					.on("click", function () {
						u.next(!0, wl.matches);
					}));
		});
	const n = document.querySelectorAll(".js-block-slider");
	(n.length > 0 &&
		n.forEach((s) => {
			const u = new pf(s, {
				cellAlign: "center",
				contain: !0,
				wrapAround: !0,
				adaptiveHeight: !0,
				imagesLoaded: !0,
				prevNextButtons: !1,
				pageDots: !1,
				on: {
					ready() {
						p(this);
					},
					settle() {
						p(this);
					},
					change() {
						p(this);
					},
				},
			});
			(p(u),
				window.addEventListener("load", () => p(u)),
				Ht(s)
					.parent()
					.find(".js-block-slider-dots")
					.on("click", "button", function () {
						const f = Ht(this).data("index");
						u.selectCell(f);
					}),
				Ht(s)
					.parent()
					.find(".js-block-slider-controls")
					.on("click", "button", function () {
						const f = Ht(this).data("control");
						u[f](!0, wl.matches);
					}));
		}),
		Ht('a[href^="#"], [data-target]').on("click", function (s) {
			let u = this.hash !== void 0 ? this.hash : Ht(this).data("target");
			typeof u < "u" && Xa(u, 125);
		}),
		Ht("select.js-reload").change(function () {
			let s = Ht(this).find(":selected").data("href");
			typeof s < "u" && (window.location.href = s);
		}),
		Ht(".dropdown-link").hover(
			function () {
				Ht(this).attr("aria-expanded", "true");
			},
			function () {
				Ht(this).attr("aria-expanded", "false");
			},
		));
	const r = document.querySelector(".js-sticky-header");
	(window.addEventListener("scroll", function () {
		window.scrollY > r.offsetTop
			? r.classList.add("is-scrolled")
			: r.classList.remove("is-scrolled");
	}),
		Ht(".js-tabs-container-pills").hellltabs({ tabIndex: 0 }),
		Ht(".js-tabs-container-select").hellltabs({ tabIndex: 0 }),
		Ht(".js-accordion").helllaccordion(),
		Ht(".js-form").ajaxForm(),
		document.querySelectorAll(".js-map-explorer").forEach((s) => {
			// Booting the map costs a POST for its markers, a 64 kB boundary
			// geojson and a screenful of tiles before anything is drawn. The
			// explorer is below the fold on every template that uses it, so
			// that whole chain used to hang off the initial page load for
			// nothing. The filter and flyTo buttons live inside this same
			// container, so anything that can drive the map has scrolled into
			// range by the time the observer fires.
			const boot = () =>
				new vg({
					map: s.querySelector("[data-map]"),
					filterButtons: s.querySelectorAll("[data-map-filter]"),
					flyToButtons: s.querySelectorAll("[data-map-flyto]"),
				});

			if (!("IntersectionObserver" in window)) {
				boot();
				return;
			}

			const io = new IntersectionObserver(
				(entries) => {
					if (entries.some((entry) => entry.isIntersecting)) {
						(io.disconnect(), boot());
					}
				},
				{ rootMargin: "400px" },
			);
			io.observe(s);
		}));
});
const Ou = document.querySelector("#js-events");
function bg(p, e) {
	const n = {
		mm: String(p.getMonth() + 1).padStart(2, "0"),
		dd: String(p.getDate()).padStart(2, "0"),
		yy: p.getFullYear().toString().slice(-2),
		yyyy: p.getFullYear().toString(),
	};
	return e.replace(/\b(mm|dd|yy|yyyy)\b/g, (r) => n[r]);
}
if (Ou) {
	const p = Ou.querySelectorAll("#date-from"),
		e = new Date();
	(p.forEach((n) => {
		n.value.length <= 0 && (n.value = bg(e, "yyyy-mm-dd"));
	}),
		Ht(window).on("load", function () {
			const n = new URL(window.location.href),
				r = new URLSearchParams(n.search);
			for (const u of [...r.keys()]) r.get(u).trim() || r.delete(u);
			const s = r.toString() ? `${n.pathname}?${r.toString()}` : n.pathname;
			(window.history.replaceState({}, "", s),
				(r == null ? void 0 : r.size) > 0 &&
					Ou &&
					setTimeout(() => {
						Xa(Ou, 0, 800, !1);
					}, 500));
		}));
}
const xg = document.querySelectorAll(".js-discover-select");
xg.forEach((p) => {
	new yg(p, {
		resultsContainer: p.querySelector('[data-discover="results-container"]'),
	});
});
const wg = document.querySelector("main");
wg.querySelectorAll('a[href^="http://"], a[href^="https://"]').forEach((p) => {
	typeof p.href == "string" &&
		!p.href.includes(window.location.hostname) &&
		(p.setAttribute("target", "_blank"),
		p.setAttribute("rel", "noopener noreferrer"));
});
Ht(window).on("load", function () {
	const p = [];
	document.querySelectorAll("script[data-src]").forEach((u) => {
		const l = new nc(u);
		(l.disable(), p.push(l));
	});
	let n = !1,
		r = !0;
	(window.addEventListener("cookieconsent:enableEmbed", () => {
		n ||
			((n = !0),
			(r = !1),
			console.log("cookieconsent:enableEmbed → manually enabling all embeds"),
			p.forEach((u) => u.enable()));
	}),
		window.addEventListener("cookieconsent:disableEmbed", () => {
			r ||
				((r = !0),
				(n = !1),
				console.log(
					"cookieconsent:disableEmbed → manually disabling all embeds",
				),
				p.forEach((u) => u.disable()));
		}),
		window.cookieconsent.getPreferences().checked.includes("embeds")
			? (p.forEach((u) => u.enable()), (n = !0), (r = !1))
			: (p.forEach((u) => u.disable()), (n = !1), (r = !0)));
});
window.$ = Ht;
